function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired62c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired62c"] = parcelRequire;
}
parcelRequire.register("ecd4d", function(module, exports) {

$parcel$export(module.exports, "compile", () => $a55c527d369bf9c1$export$ef7acd7185315e22);
parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};
$parcel$exportWildcard(module.exports, $eeJ70);

});
parcelRequire.register("eeJ70", function(module, exports) {

$parcel$export(module.exports, "defineCustomElement", () => $a5d55dc64ccb07cf$export$a00e2346eabbdbef);
$parcel$export(module.exports, "VueElement", () => $a5d55dc64ccb07cf$export$b337c1a55163dbe3);
$parcel$export(module.exports, "defineSSRCustomElement", () => $a5d55dc64ccb07cf$export$6debb2e68f212638);
$parcel$export(module.exports, "hydrate", () => $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "useCssModule", () => $a5d55dc64ccb07cf$export$9300d5b90d56e3d1);
$parcel$export(module.exports, "useCssVars", () => $a5d55dc64ccb07cf$export$ef28b76f07940108);
$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "createSSRApp", () => $a5d55dc64ccb07cf$export$35800275c0037383);
$parcel$export(module.exports, "initDirectivesForSSR", () => $a5d55dc64ccb07cf$export$800b28255aa678d9);
parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $8POXm.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
        }
        for(const key in next)$a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$nativeOnRE = /^on[a-z]/;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$nativeOnRE.test(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($a5d55dc64ccb07cf$var$nativeOnRE.test(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = (options)=>{
    return $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $8POXm.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.watchPostEffect)(setVars);
    (0, $TusQn.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $8POXm.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8POXm.isArray)(value)) el.checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el._assign($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $8POXm.isArray)(value) && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if ((0, $8POXm.isArray)(value)) option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $TusQn);

});
parcelRequire.register("TusQn", function(module, exports) {

$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "assertNumber", () => $0a6cc4ba868319ae$export$dfbcecb440255e4a);
$parcel$export(module.exports, "callWithErrorHandling", () => $0a6cc4ba868319ae$export$b22fcaf88446e9bf);
$parcel$export(module.exports, "handleError", () => $0a6cc4ba868319ae$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "devtools", () => $0a6cc4ba868319ae$export$6922d3b3a607469e);
$parcel$export(module.exports, "setDevtoolsHook", () => $0a6cc4ba868319ae$export$b0c258b32c26c785);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "pushScopeId", () => $0a6cc4ba868319ae$export$ac020265ca2cc4cd);
$parcel$export(module.exports, "popScopeId", () => $0a6cc4ba868319ae$export$f2dc6805dc11834e);
$parcel$export(module.exports, "withScopeId", () => $0a6cc4ba868319ae$export$15ba313e13f3dd04);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "setBlockTracking", () => $0a6cc4ba868319ae$export$c20bee82f26f1e27);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "isVNode", () => $0a6cc4ba868319ae$export$3868d13f8734ae81);
$parcel$export(module.exports, "Suspense", () => $0a6cc4ba868319ae$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watchSyncEffect", () => $0a6cc4ba868319ae$export$2035654f31b0e555);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useSSRContext", () => $0a6cc4ba868319ae$export$6b1c54dc4befcda);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "defineAsyncComponent", () => $0a6cc4ba868319ae$export$d75d499b4c16cf21);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "KeepAlive", () => $0a6cc4ba868319ae$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "onServerPrefetch", () => $0a6cc4ba868319ae$export$ebf0c601f267bceb);
$parcel$export(module.exports, "onRenderTriggered", () => $0a6cc4ba868319ae$export$898295a813d662eb);
$parcel$export(module.exports, "onRenderTracked", () => $0a6cc4ba868319ae$export$2b41f4235363e921);
$parcel$export(module.exports, "onErrorCaptured", () => $0a6cc4ba868319ae$export$6a3a15856e50ad19);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $0a6cc4ba868319ae$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0a6cc4ba868319ae$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $0a6cc4ba868319ae$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "defineProps", () => $0a6cc4ba868319ae$export$80b33eababae110e);
$parcel$export(module.exports, "defineEmits", () => $0a6cc4ba868319ae$export$51ecece22fc17ddc);
$parcel$export(module.exports, "defineExpose", () => $0a6cc4ba868319ae$export$da25b65ca24b518a);
$parcel$export(module.exports, "defineOptions", () => $0a6cc4ba868319ae$export$77e79129327f3d0d);
$parcel$export(module.exports, "defineSlots", () => $0a6cc4ba868319ae$export$1b3acd4bb805b712);
$parcel$export(module.exports, "defineModel", () => $0a6cc4ba868319ae$export$acd55aa037e791bb);
$parcel$export(module.exports, "withDefaults", () => $0a6cc4ba868319ae$export$4df9c0969a9e0160);
$parcel$export(module.exports, "useSlots", () => $0a6cc4ba868319ae$export$9203a8e84125433c);
$parcel$export(module.exports, "useAttrs", () => $0a6cc4ba868319ae$export$75e29435042cd2ea);
$parcel$export(module.exports, "useModel", () => $0a6cc4ba868319ae$export$fb78bd113157f1a1);
$parcel$export(module.exports, "mergeDefaults", () => $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f);
$parcel$export(module.exports, "mergeModels", () => $0a6cc4ba868319ae$export$ad4f724f587e6828);
$parcel$export(module.exports, "createPropsRestProxy", () => $0a6cc4ba868319ae$export$7c343e855c563faa);
$parcel$export(module.exports, "withAsyncContext", () => $0a6cc4ba868319ae$export$d6d6f7369f1fb104);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "version", () => $0a6cc4ba868319ae$export$83d89fbfd8236492);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "transformVNodeArgs", () => $0a6cc4ba868319ae$export$83beccd3afeeb809);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0a6cc4ba868319ae$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "ssrContextKey", () => $0a6cc4ba868319ae$export$f2549a27e18acf2d);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "withMemo", () => $0a6cc4ba868319ae$export$2a6d714a4d738ae);
$parcel$export(module.exports, "isMemoSame", () => $0a6cc4ba868319ae$export$bf525184d622787c);
$parcel$export(module.exports, "ssrUtils", () => $0a6cc4ba868319ae$export$a9679033567b336d);
$parcel$export(module.exports, "resolveFilter", () => $0a6cc4ba868319ae$export$83cf26e06ea620e1);
$parcel$export(module.exports, "compatUtils", () => $0a6cc4ba868319ae$export$dc678eddf276286e);
$parcel$export(module.exports, "EffectScope", () => (parcelRequire("01W3b")).EffectScope);
$parcel$export(module.exports, "ReactiveEffect", () => (parcelRequire("01W3b")).ReactiveEffect);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "effect", () => (parcelRequire("01W3b")).effect);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isShallow", () => (parcelRequire("01W3b")).isShallow);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "proxyRefs", () => (parcelRequire("01W3b")).proxyRefs);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "stop", () => (parcelRequire("01W3b")).stop);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("01W3b")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8POXm")).capitalize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8POXm")).toHandlerKey);

var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value1, raw) {
    if ((0, $8POXm.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $01W3b.isRef)(value1)) {
        value1 = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $01W3b.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $0a6cc4ba868319ae$var$getId($0a6cc4ba868319ae$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ];
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        $0a6cc4ba868319ae$var$activePostFlushCbs.sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$export$6922d3b3a607469e;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e) $0a6cc4ba868319ae$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$export$6922d3b3a607469e = hook;
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e) {
        $0a6cc4ba868319ae$export$6922d3b3a607469e.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$export$6922d3b3a607469e.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e && typeof $0a6cc4ba868319ae$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$export$6922d3b3a607469e.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8POXm.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container2, anchor2, 0);
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $8POXm.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $01W3b.getCurrentScope)() === ((_a = $0a6cc4ba868319ae$var$currentInstance) == null ? void 0 : _a.scope) ? $0a6cc4ba868319ae$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return $0a6cc4ba868319ae$var$traverse(s);
                else if ((0, $8POXm.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8POXm.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8POXm.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8POXm.hasChanged)(v1, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $8POXm.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $0a6cc4ba868319ae$var$setCurrentInstance(cur);
    else $0a6cc4ba868319ae$var$unsetCurrentInstance();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value1, seen) {
    if (!(0, $8POXm.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $01W3b.isRef)(value1)) $0a6cc4ba868319ae$var$traverse(value1.value, seen);
    else if ((0, $8POXm.isArray)(value1)) for(let i = 0; i < value1.length; i++)$0a6cc4ba868319ae$var$traverse(value1[i], seen);
    else if ((0, $8POXm.isSet)(value1) || (0, $8POXm.isMap)(value1)) value1.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value1)) for(const key in value1)$0a6cc4ba868319ae$var$traverse(value1[key], seen);
    return value1;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && (!$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el._leaveCb) el._leaveCb(true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    return $0a6cc4ba868319ae$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            $0a6cc4ba868319ae$var$unsetCurrentInstance();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8POXm.isArray)(source) || (0, $8POXm.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$0a6cc4ba868319ae$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyWhitelisted)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $01W3b.ref)(props[name]);
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value1) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $8POXm.def)(attrs, $0a6cc4ba868319ae$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance, "set", "$attrs");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $0a6cc4ba868319ae$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $8POXm.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8POXm.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8POXm.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, !(0, $8POXm.hasOwn)(rawProps, key) && !(0, $8POXm.hasOwn)(rawProps, (0, $8POXm.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$export$c106dd0671a0fc2d($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value1, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value1);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value1, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value1)=>(0, $8POXm.isArray)(value1) ? value1.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value1)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $8POXm.isFunction)(value1)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $01W3b.toRaw)(children);
            (0, $8POXm.def)(children, "_", type);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
    }
    (0, $8POXm.def)(instance.slots, $0a6cc4ba868319ae$var$InternalObjectKey, 1);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8POXm.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8POXm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8POXm.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), optimized);
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    if (nextNode && $0a6cc4ba868319ae$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs();
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $0a6cc4ba868319ae$var$flushPreFlushCbs();
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $0a6cc4ba868319ae$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $0a6cc4ba868319ae$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        if (doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value1) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value1;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$InternalObjectKey = `__vInternal`;
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$InternalObjectKey in props ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($0a6cc4ba868319ae$var$InternalObjectKey in children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$globalCurrentInstanceSetters;
let $0a6cc4ba868319ae$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($0a6cc4ba868319ae$var$globalCurrentInstanceSetters = (0, $8POXm.getGlobalThis)()[$0a6cc4ba868319ae$var$settersKey])) $0a6cc4ba868319ae$var$globalCurrentInstanceSetters = (0, $8POXm.getGlobalThis)()[$0a6cc4ba868319ae$var$settersKey] = [];
$0a6cc4ba868319ae$var$globalCurrentInstanceSetters.push((i)=>$0a6cc4ba868319ae$var$currentInstance = i);
$0a6cc4ba868319ae$var$internalSetCurrentInstance = (instance)=>{
    if ($0a6cc4ba868319ae$var$globalCurrentInstanceSetters.length > 1) $0a6cc4ba868319ae$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $0a6cc4ba868319ae$var$globalCurrentInstanceSetters[0](instance);
};
const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $8POXm.NO);
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || appIsNativeTag(name)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    $0a6cc4ba868319ae$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $01W3b.markRaw)(new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if ((0, $8POXm.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$applyOptions(instance);
        (0, $01W3b.resetTracking)();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
    }
}
function $0a6cc4ba868319ae$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $0a6cc4ba868319ae$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value1) {
    return (0, $8POXm.isFunction)(value1) && "__vccOpts" in value1;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($0a6cc4ba868319ae$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.3.4";
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;

});
parcelRequire.register("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "effect", () => $005d1fb7704e278c$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "stop", () => $005d1fb7704e278c$export$fa6813432f753b0d);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $005d1fb7704e278c$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);

var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
const $005d1fb7704e278c$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $005d1fb7704e278c$var$wasTracked = (dep)=>(dep.w & $005d1fb7704e278c$var$trackOpBit) > 0;
const $005d1fb7704e278c$var$newTracked = (dep)=>(dep.n & $005d1fb7704e278c$var$trackOpBit) > 0;
const $005d1fb7704e278c$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $005d1fb7704e278c$var$trackOpBit;
};
const $005d1fb7704e278c$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($005d1fb7704e278c$var$wasTracked(dep) && !$005d1fb7704e278c$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$005d1fb7704e278c$var$trackOpBit;
            dep.n &= ~$005d1fb7704e278c$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$effectTrackDepth = 0;
let $005d1fb7704e278c$var$trackOpBit = 1;
const $005d1fb7704e278c$var$maxMarkerBits = 30;
let $005d1fb7704e278c$var$activeEffect;
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $005d1fb7704e278c$var$activeEffect;
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $005d1fb7704e278c$var$activeEffect;
            $005d1fb7704e278c$var$activeEffect = this;
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$trackOpBit = 1 << ++$005d1fb7704e278c$var$effectTrackDepth;
            if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) $005d1fb7704e278c$var$initDepMarkers(this);
            else $005d1fb7704e278c$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) $005d1fb7704e278c$var$finalizeDepMarkers(this);
            $005d1fb7704e278c$var$trackOpBit = 1 << --$005d1fb7704e278c$var$effectTrackDepth;
            $005d1fb7704e278c$var$activeEffect = this.parent;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($005d1fb7704e278c$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $005d1fb7704e278c$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) {
        (0, $8POXm.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep());
        const eventInfo = void 0;
        $005d1fb7704e278c$var$trackEffects(dep, eventInfo);
    }
}
function $005d1fb7704e278c$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) {
        if (!$005d1fb7704e278c$var$newTracked(dep)) {
            dep.n |= $005d1fb7704e278c$var$trackOpBit;
            shouldTrack2 = !$005d1fb7704e278c$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($005d1fb7704e278c$var$activeEffect);
    if (shouldTrack2) {
        dep.add($005d1fb7704e278c$var$activeEffect);
        $005d1fb7704e278c$var$activeEffect.deps.push(dep);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $8POXm.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8POXm.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $005d1fb7704e278c$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $005d1fb7704e278c$var$triggerEffects($005d1fb7704e278c$var$createDep(effects));
    }
}
function $005d1fb7704e278c$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $8POXm.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $005d1fb7704e278c$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $005d1fb7704e278c$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $005d1fb7704e278c$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $005d1fb7704e278c$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $005d1fb7704e278c$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
const $005d1fb7704e278c$var$get$1 = /* @__PURE__ */ $005d1fb7704e278c$var$createGetter();
const $005d1fb7704e278c$var$shallowGet = /* @__PURE__ */ $005d1fb7704e278c$var$createGetter(false, true);
const $005d1fb7704e278c$var$readonlyGet = /* @__PURE__ */ $005d1fb7704e278c$var$createGetter(true);
const $005d1fb7704e278c$var$shallowReadonlyGet = /* @__PURE__ */ $005d1fb7704e278c$var$createGetter(true, true);
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
function $005d1fb7704e278c$var$createGetter(isReadonly2 = false, shallow = false) {
    return function get2(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : shallow ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $8POXm.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    };
}
const $005d1fb7704e278c$var$set$1 = /* @__PURE__ */ $005d1fb7704e278c$var$createSetter();
const $005d1fb7704e278c$var$shallowSet = /* @__PURE__ */ $005d1fb7704e278c$var$createSetter(true);
function $005d1fb7704e278c$var$createSetter(shallow = false) {
    return function set2(target, key, value, receiver) {
        let oldValue = target[key];
        if ($005d1fb7704e278c$export$92d09b48637741e7(oldValue) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $005d1fb7704e278c$var$deleteProperty(target, key) {
    const hadKey = (0, $8POXm.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$has$1(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
    return result;
}
function $005d1fb7704e278c$var$ownKeys(target) {
    $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $005d1fb7704e278c$var$mutableHandlers = {
    get: $005d1fb7704e278c$var$get$1,
    set: $005d1fb7704e278c$var$set$1,
    deleteProperty: $005d1fb7704e278c$var$deleteProperty,
    has: $005d1fb7704e278c$var$has$1,
    ownKeys: $005d1fb7704e278c$var$ownKeys
};
const $005d1fb7704e278c$var$readonlyHandlers = {
    get: $005d1fb7704e278c$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $005d1fb7704e278c$var$mutableHandlers, {
    get: $005d1fb7704e278c$var$shallowGet,
    set: $005d1fb7704e278c$var$shallowSet
});
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $005d1fb7704e278c$var$readonlyHandlers, {
    get: $005d1fb7704e278c$var$shallowReadonlyGet
});
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return $005d1fb7704e278c$export$352205f445242f02(value) || $005d1fb7704e278c$export$92d09b48637741e7(value);
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffects(ref2.dep || (ref2.dep = $005d1fb7704e278c$var$createDep()));
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $8POXm.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $005d1fb7704e278c$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8POXm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $8POXm.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$var$tick = /* @__PURE__ */ Promise.resolve();
const $005d1fb7704e278c$var$queue = [];
let $005d1fb7704e278c$var$queued = false;
const $005d1fb7704e278c$var$scheduler = (fn)=>{
    $005d1fb7704e278c$var$queue.push(fn);
    if (!$005d1fb7704e278c$var$queued) {
        $005d1fb7704e278c$var$queued = true;
        $005d1fb7704e278c$var$tick.then($005d1fb7704e278c$var$flush);
    }
};
const $005d1fb7704e278c$var$flush = ()=>{
    for(let i = 0; i < $005d1fb7704e278c$var$queue.length; i++)$005d1fb7704e278c$var$queue[i]();
    $005d1fb7704e278c$var$queue.length = 0;
    $005d1fb7704e278c$var$queued = false;
};
class $005d1fb7704e278c$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $005d1fb7704e278c$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $005d1fb7704e278c$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $005d1fb7704e278c$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return $005d1fb7704e278c$export$ab18938b9fc5f28e(this)._get();
    }
}
function $005d1fb7704e278c$export$483264c4ec4c46ce(getter) {
    return new $005d1fb7704e278c$var$DeferredComputedRefImpl(getter);
}

});
parcelRequire.register("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyWhitelisted", () => $66ea9d0aaa418c4d$export$d6571a1911e4f27e);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $66ea9d0aaa418c4d$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$var$onRE = /^on[^a-z]/;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>$66ea9d0aaa418c4d$var$onRE.test(key);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``);
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_WHITE_LISTED);
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) return value;
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});





parcelRequire.register("38qZG", function(module, exports) {

$parcel$export(module.exports, "render", () => $24870edb0ccb6a1f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
function $24870edb0ccb6a1f$export$b3890eb0ae9dca99(_ctx, _cache) {
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_router_view, {
        class: (0, $8POXm.normalizeClass)(_ctx.$style.body)
    }, null, 8, [
        "class"
    ]);
}

});

parcelRequire.register("eQYUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad052cc5d6d19fa2$export$2e2bcd8739ae039);
parcelRequire("38qZG");
let $ad052cc5d6d19fa2$var$cssModules = {
    "$style": {
        "body": "_body_x43jy_2"
    }
};
var $ad052cc5d6d19fa2$export$2e2bcd8739ae039 = $ad052cc5d6d19fa2$var$cssModules;

});

parcelRequire.register("6fKCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d84f0eb7c14bfe$export$2e2bcd8739ae039);
let $48d84f0eb7c14bfe$var$NOOP = ()=>{};
var $48d84f0eb7c14bfe$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("3gDlC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b5182fc7a10dc535$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $khdnb = parcelRequire("khdnb");
var $b5182fc7a10dc535$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "SurveyPage",
    setup (__props, { expose: __expose }) {
        __expose();
        /**
 * TODO
 * - Interface de création des questionnaires
 * - Export Excel
 * - Travailler sur le visuel
 * - Bonus: grouper les questions
 *  - Suivant/Précédent pour passer d'un groupe à l'autre
 *  - Barre de progression par groupe
 **/ const route = (0, $73mM4.useRoute)();
        const survey_id = route.query.id;
        const user_id = route.query.u;
        const done = (0, $01W3b.ref)(false);
        const survey = (0, $01W3b.ref)(null);
        const currentPageIndex = (0, $01W3b.ref)(0);
        const currentPage = (0, $TusQn.computed)(()=>{
            return survey.value?.pages[currentPageIndex.value];
        });
        const somePageQuestionsNotAnswered = (0, $TusQn.computed)(()=>{
            if (!survey.value || !currentPage.value) return false;
            const value = currentPage.value.data.questions.some((question)=>{
                if (currentPage.value?.type === "table") {
                    if (question.choice === null) return true;
                } else if (currentPage.value?.type === "questions") {
                    if (!shouldShowQuestion(question, currentPage.value.data.questions)) return false;
                    if (question.choice === null) return true;
                    if (question.type === "string" && question.choice.trim() === "") return true;
                    if (question.type === "number" && typeof question.choice !== "number") return true;
                } else throw new Error();
            });
            return value;
        });
        function shouldShowQuestion(question, pageQuestions) {
            if (!question.condition.questionID) return true;
            let targetQuestion = pageQuestions.filter((q)=>q.internalID === question.condition.questionID)[0];
            if (!targetQuestion) return true;
            if (question.condition.answers.includes(targetQuestion.choice)) return true;
            return false;
        }
        function selectAnswer(question, answer) {
            question.choice = answer.internalID;
        }
        function nextPage() {
            currentPageIndex.value += 1;
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        function previousPage() {
            currentPageIndex.value -= 1;
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        async function save() {
            (0, $khdnb.Loading).show();
            fetch(`/api/surveys/${survey_id}/u/${user_id}`, {
                method: "POST",
                body: JSON.stringify(survey.value),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(()=>done.value = true).finally(()=>(0, $khdnb.Loading).hide());
        }
        async function getSurvey() {
            (0, $khdnb.Loading).show();
            fetch(`/api/surveys/${survey_id}`, {
                method: "GET"
            }).then(async (response)=>{
                survey.value = await response.json();
            }).finally(()=>(0, $khdnb.Loading).hide());
        }
        (0, $TusQn.onMounted)(getSurvey);
        const __returned__ = {
            route: route,
            survey_id: survey_id,
            user_id: user_id,
            done: done,
            survey: survey,
            currentPageIndex: currentPageIndex,
            currentPage: currentPage,
            somePageQuestionsNotAnswered: somePageQuestionsNotAnswered,
            shouldShowQuestion: shouldShowQuestion,
            selectAnswer: selectAnswer,
            nextPage: nextPage,
            previousPage: previousPage,
            save: save,
            getSurvey: getSurvey,
            get QBtn () {
                return 0, $khdnb.QBtn;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRequire.register("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHashHistory", () => $a809ac530d32f081$export$542bc3a76486c94d);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
$parcel$export(module.exports, "useRouter", () => $a809ac530d32f081$export$9a302a45f65d0572);
$parcel$export(module.exports, "useRoute", () => $a809ac530d32f081$export$3f79f0b98112cf57);
/*!
  * vue-router v4.2.4
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $j6G8F = parcelRequire("j6G8F");
const $a809ac530d32f081$var$isBrowser = typeof window !== "undefined";
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: hash
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments// ensure we use at least the last element in the toSegments
    .slice(toPosition - (toPosition === toSegments.length ? 1 : 0)).join("/");
}
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, "#") + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.pageXOffset,
        top: window.pageYOffset
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, "");
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // console.log({ deltaFromCurrent })
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position === queue.length) // we are at the end, we can simply append a new entry
        queue.push(location1);
        else {
            // we are in the middle, we remove everything from here in the queue
            queue.splice(position);
            queue.push(location1);
        }
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error(), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if ("path" in to) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$a809ac530d32f081$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if ("path" in location1) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $a809ac530d32f081$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $a809ac530d32f081$var$isRecordChildOf(record, child));
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI("" + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, "|").replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, "[").replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, "%2B").replace($a809ac530d32f081$var$ENC_SPACE_RE, "+").replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$AMPERSAND_RE, "%26").replace($a809ac530d32f081$var$ENC_BACKTICK_RE, "`").replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? "" : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = guard.call(record && record.instances[name], to, from, next);
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    const route = (0, $TusQn.computed)(()=>router.resolve((0, $01W3b.unref)(props.to)));
    const activeRecordIndex = (0, $TusQn.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $TusQn.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $TusQn.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) return router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $TusQn.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $TusQn.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $TusQn.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $TusQn.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $TusQn.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $TusQn.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = "";
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("beforeEach"),
                from: $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $a809ac530d32f081$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("❌");
            } else data.status = $a809ac530d32f081$var$formatDisplay("✅");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if ("path" in rawLocation) matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
            path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: "path" in newTargetLocation ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $a809ac530d32f081$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorHandlers = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorHandlers added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorHandlers.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorHandlers.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}

});
parcelRequire.register("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRequire.register("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === "function";

});

parcelRequire.register("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = "plugin:settings:set";

});

parcelRequire.register("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRequire.register("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof $parcel$global !== "undefined" && ((_a = $parcel$global.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = $parcel$global.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});




parcelRequire.register("khdnb", function(module, exports) {

$parcel$export(module.exports, "QBtn", () => $ec2fc4c0d7a3c6c6$export$72abad9388e88b7);
$parcel$export(module.exports, "QCard", () => $ec2fc4c0d7a3c6c6$export$866037ffbc2a7c62);
$parcel$export(module.exports, "QCardSection", () => $ec2fc4c0d7a3c6c6$export$653482776a1a6c98);
$parcel$export(module.exports, "Dialog", () => $ec2fc4c0d7a3c6c6$export$3ddf2d174ce01153);
$parcel$export(module.exports, "Loading", () => $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf);
$parcel$export(module.exports, "Notify", () => $ec2fc4c0d7a3c6c6$export$dd80a68918412a62);
$parcel$export(module.exports, "Quasar", () => $ec2fc4c0d7a3c6c6$export$aa2891570c510a77);
/*!
 * Quasar Framework v2.12.5
 * (c) 2015-present Razvan Stoenescu
 * Released under the MIT License.
 */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $eeJ70 = parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");
function $ec2fc4c0d7a3c6c6$var$injectProp(e, t, o, n) {
    return Object.defineProperty(e, t, {
        get: o,
        set: n,
        enumerable: !0
    }), e;
}
function $ec2fc4c0d7a3c6c6$var$injectMultipleProps(e, t) {
    for(const o in t)$ec2fc4c0d7a3c6c6$var$injectProp(e, o, t[o]);
    return e;
}
const $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration = (0, $01W3b.ref)(!1);
let $ec2fc4c0d7a3c6c6$var$iosCorrection;
function $ec2fc4c0d7a3c6c6$var$getMatch(e, t) {
    const o = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(e) || /(opr)[\/]([\w.]+)/.exec(e) || /(vivaldi)[\/]([\w.]+)/.exec(e) || /(chrome|crios)[\/]([\w.]+)/.exec(e) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(firefox|fxios)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(e) || [];
    return {
        browser: o[5] || o[3] || o[1] || "",
        version: o[2] || o[4] || "0",
        versionNumber: o[4] || o[2] || "0",
        platform: t[0] || ""
    };
}
function $ec2fc4c0d7a3c6c6$var$getPlatformMatch(e) {
    return /(ipad)/.exec(e) || /(ipod)/.exec(e) || /(windows phone)/.exec(e) || /(iphone)/.exec(e) || /(kindle)/.exec(e) || /(silk)/.exec(e) || /(android)/.exec(e) || /(win)/.exec(e) || /(mac)/.exec(e) || /(linux)/.exec(e) || /(cros)/.exec(e) || /(playbook)/.exec(e) || /(bb)/.exec(e) || /(blackberry)/.exec(e) || [];
}
const $ec2fc4c0d7a3c6c6$var$hasTouch = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function $ec2fc4c0d7a3c6c6$var$applyIosCorrection(e) {
    $ec2fc4c0d7a3c6c6$var$iosCorrection = {
        is: {
            ...e
        }
    }, delete e.mac, delete e.desktop;
    const t = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
    Object.assign(e, {
        mobile: !0,
        ios: !0,
        platform: t,
        [t]: !0
    });
}
function $ec2fc4c0d7a3c6c6$var$getPlatform(e) {
    const t = e.toLowerCase(), o = $ec2fc4c0d7a3c6c6$var$getPlatformMatch(t), n = $ec2fc4c0d7a3c6c6$var$getMatch(t, o), a = {};
    n.browser && (a[n.browser] = !0, a.version = n.version, a.versionNumber = parseInt(n.versionNumber, 10)), n.platform && (a[n.platform] = !0);
    const l = a.android || a.ios || a.bb || a.blackberry || a.ipad || a.iphone || a.ipod || a.kindle || a.playbook || a.silk || a["windows phone"];
    return !0 === l || t.indexOf("mobile") > -1 ? (a.mobile = !0, a.edga || a.edgios ? (a.edge = !0, n.browser = "edge") : a.crios ? (a.chrome = !0, n.browser = "chrome") : a.fxios && (a.firefox = !0, n.browser = "firefox")) : a.desktop = !0, (a.ipod || a.ipad || a.iphone) && (a.ios = !0), a["windows phone"] && (a.winphone = !0, delete a["windows phone"]), (a.chrome || a.opr || a.safari || a.vivaldi || !0 === a.mobile && !0 !== a.ios && !0 !== l) && (a.webkit = !0), a.edg && (n.browser = "edgechromium", a.edgeChromium = !0), (a.safari && a.blackberry || a.bb) && (n.browser = "blackberry", a.blackberry = !0), a.safari && a.playbook && (n.browser = "playbook", a.playbook = !0), a.opr && (n.browser = "opera", a.opera = !0), a.safari && a.android && (n.browser = "android", a.android = !0), a.safari && a.kindle && (n.browser = "kindle", a.kindle = !0), a.safari && a.silk && (n.browser = "silk", a.silk = !0), a.vivaldi && (n.browser = "vivaldi", a.vivaldi = !0), a.name = n.browser, a.platform = n.platform, t.indexOf("electron") > -1 ? a.electron = !0 : document.location.href.indexOf("-extension://") > -1 ? a.bex = !0 : (void 0 !== window.Capacitor ? (a.capacitor = !0, a.nativeMobile = !0, a.nativeMobileWrapper = "capacitor") : void 0 === window._cordovaNative && void 0 === window.cordova || (a.cordova = !0, a.nativeMobile = !0, a.nativeMobileWrapper = "cordova"), !0 === $ec2fc4c0d7a3c6c6$var$hasTouch && !0 === a.mac && (!0 === a.desktop && !0 === a.safari || !0 === a.nativeMobile && !0 !== a.android && !0 !== a.ios && !0 !== a.ipad) && $ec2fc4c0d7a3c6c6$var$applyIosCorrection(a)), a;
}
const $ec2fc4c0d7a3c6c6$var$userAgent = navigator.userAgent || navigator.vendor || window.opera, $ec2fc4c0d7a3c6c6$var$ssrClient = {
    has: {
        touch: !1,
        webStorage: !1
    },
    within: {
        iframe: !1
    }
}, $ec2fc4c0d7a3c6c6$var$client = {
    userAgent: $ec2fc4c0d7a3c6c6$var$userAgent,
    is: $ec2fc4c0d7a3c6c6$var$getPlatform($ec2fc4c0d7a3c6c6$var$userAgent),
    has: {
        touch: $ec2fc4c0d7a3c6c6$var$hasTouch
    },
    within: {
        iframe: window.self !== window.top
    }
}, $ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389 = {
    install (e) {
        const { $q: t } = e;
        !0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value ? (e.onSSRHydrated.push(()=>{
            Object.assign(t.platform, $ec2fc4c0d7a3c6c6$var$client), $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value = !1, $ec2fc4c0d7a3c6c6$var$iosCorrection = void 0;
        }), t.platform = (0, $01W3b.reactive)(this)) : t.platform = this;
    }
};
{
    let e;
    $ec2fc4c0d7a3c6c6$var$injectProp($ec2fc4c0d7a3c6c6$var$client.has, "webStorage", ()=>{
        if (void 0 !== e) return e;
        try {
            if (window.localStorage) return e = !0, !0;
        } catch (e) {}
        return e = !1, !1;
    }), !0 === $ec2fc4c0d7a3c6c6$var$client.is.ios && window.navigator.vendor.toLowerCase().indexOf("apple"), !0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value ? Object.assign($ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389, $ec2fc4c0d7a3c6c6$var$client, $ec2fc4c0d7a3c6c6$var$iosCorrection, $ec2fc4c0d7a3c6c6$var$ssrClient) : Object.assign($ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389, $ec2fc4c0d7a3c6c6$var$client);
}var $ec2fc4c0d7a3c6c6$var$defineReactivePlugin = (e, t)=>{
    const o = (0, $01W3b.reactive)(e);
    for(const n in e)$ec2fc4c0d7a3c6c6$var$injectProp(t, n, ()=>o[n], (e)=>{
        o[n] = e;
    });
    return t;
};
const $ec2fc4c0d7a3c6c6$var$listenOpts = {
    hasPassive: !1,
    passiveCapture: !0,
    notPassiveCapture: !0
};
try {
    const e = Object.defineProperty({}, "passive", {
        get () {
            Object.assign($ec2fc4c0d7a3c6c6$var$listenOpts, {
                hasPassive: !0,
                passive: {
                    passive: !0
                },
                notPassive: {
                    passive: !1
                },
                passiveCapture: {
                    passive: !0,
                    capture: !0
                },
                notPassiveCapture: {
                    passive: !1,
                    capture: !0
                }
            });
        }
    });
    window.addEventListener("qtest", null, e), window.removeEventListener("qtest", null, e);
} catch (e) {}
function $ec2fc4c0d7a3c6c6$export$8793edee2d425525() {}
function $ec2fc4c0d7a3c6c6$var$leftClick(e) {
    return 0 === e.button;
}
function $ec2fc4c0d7a3c6c6$var$middleClick(e) {
    return 1 === e.button;
}
function $ec2fc4c0d7a3c6c6$var$rightClick(e) {
    return 2 === e.button;
}
function $ec2fc4c0d7a3c6c6$var$position(e) {
    return e.touches && e.touches[0] ? e = e.touches[0] : e.changedTouches && e.changedTouches[0] ? e = e.changedTouches[0] : e.targetTouches && e.targetTouches[0] && (e = e.targetTouches[0]), {
        top: e.clientY,
        left: e.clientX
    };
}
function $ec2fc4c0d7a3c6c6$var$getEventPath(e) {
    if (e.path) return e.path;
    if (e.composedPath) return e.composedPath();
    const t = [];
    let o = e.target;
    while(o){
        if (t.push(o), "HTML" === o.tagName) return t.push(document), t.push(window), t;
        o = o.parentElement;
    }
}
const $ec2fc4c0d7a3c6c6$var$LINE_HEIGHT = 40, $ec2fc4c0d7a3c6c6$var$PAGE_HEIGHT = 800;
function $ec2fc4c0d7a3c6c6$var$getMouseWheelDistance(e) {
    let t = e.deltaX, o = e.deltaY;
    if ((t || o) && e.deltaMode) {
        const n = 1 === e.deltaMode ? $ec2fc4c0d7a3c6c6$var$LINE_HEIGHT : $ec2fc4c0d7a3c6c6$var$PAGE_HEIGHT;
        t *= n, o *= n;
    }
    return e.shiftKey && !t && ([o, t] = [
        t,
        o
    ]), {
        x: t,
        y: o
    };
}
function $ec2fc4c0d7a3c6c6$var$stop(e) {
    e.stopPropagation();
}
function $ec2fc4c0d7a3c6c6$var$prevent(e) {
    !1 !== e.cancelable && e.preventDefault();
}
function $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e) {
    !1 !== e.cancelable && e.preventDefault(), e.stopPropagation();
}
function $ec2fc4c0d7a3c6c6$var$preventDraggable(e, t) {
    if (void 0 === e || !0 === t && !0 === e.__dragPrevented) return;
    const o = !0 === t ? (e)=>{
        e.__dragPrevented = !0, e.addEventListener("dragstart", $ec2fc4c0d7a3c6c6$var$prevent, $ec2fc4c0d7a3c6c6$var$listenOpts.notPassiveCapture);
    } : (e)=>{
        delete e.__dragPrevented, e.removeEventListener("dragstart", $ec2fc4c0d7a3c6c6$var$prevent, $ec2fc4c0d7a3c6c6$var$listenOpts.notPassiveCapture);
    };
    e.querySelectorAll("a, img").forEach(o);
}
function $ec2fc4c0d7a3c6c6$var$addEvt(e, t, o) {
    const n = `__q_${t}_evt`;
    e[n] = void 0 !== e[n] ? e[n].concat(o) : o, o.forEach((t)=>{
        t[0].addEventListener(t[1], e[t[2]], $ec2fc4c0d7a3c6c6$var$listenOpts[t[3]]);
    });
}
function $ec2fc4c0d7a3c6c6$var$cleanEvt(e, t) {
    const o = `__q_${t}_evt`;
    void 0 !== e[o] && (e[o].forEach((t)=>{
        t[0].removeEventListener(t[1], e[t[2]], $ec2fc4c0d7a3c6c6$var$listenOpts[t[3]]);
    }), e[o] = void 0);
}
var $ec2fc4c0d7a3c6c6$export$6cd530ed55e06764 = {
    listenOpts: $ec2fc4c0d7a3c6c6$var$listenOpts,
    leftClick: $ec2fc4c0d7a3c6c6$var$leftClick,
    middleClick: $ec2fc4c0d7a3c6c6$var$middleClick,
    rightClick: $ec2fc4c0d7a3c6c6$var$rightClick,
    position: $ec2fc4c0d7a3c6c6$var$position,
    getEventPath: $ec2fc4c0d7a3c6c6$var$getEventPath,
    getMouseWheelDistance: $ec2fc4c0d7a3c6c6$var$getMouseWheelDistance,
    stop: $ec2fc4c0d7a3c6c6$var$stop,
    prevent: $ec2fc4c0d7a3c6c6$var$prevent,
    stopAndPrevent: $ec2fc4c0d7a3c6c6$var$stopAndPrevent,
    preventDraggable: $ec2fc4c0d7a3c6c6$var$preventDraggable
};
function $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(e, t = 250, o) {
    let n = null;
    function a() {
        const a = arguments, l = ()=>{
            n = null, !0 !== o && e.apply(this, a);
        };
        null !== n ? clearTimeout(n) : !0 === o && e.apply(this, a), n = setTimeout(l, t);
    }
    return a.cancel = ()=>{
        null !== n && clearTimeout(n);
    }, a;
}
const $ec2fc4c0d7a3c6c6$var$SIZE_LIST = [
    "sm",
    "md",
    "lg",
    "xl"
], { passive: $ec2fc4c0d7a3c6c6$var$passive$4 } = $ec2fc4c0d7a3c6c6$var$listenOpts;
var $ec2fc4c0d7a3c6c6$export$a98515d67472a41f = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    width: 0,
    height: 0,
    name: "xs",
    sizes: {
        sm: 600,
        md: 1024,
        lg: 1440,
        xl: 1920
    },
    lt: {
        sm: !0,
        md: !0,
        lg: !0,
        xl: !0
    },
    gt: {
        xs: !1,
        sm: !1,
        md: !1,
        lg: !1
    },
    xs: !0,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1
}, {
    setSizes: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    setDebounce: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    install ({ $q: e, onSSRHydrated: t }) {
        if (e.screen = this, !0 === this.__installed) return void (void 0 !== e.config.screen && (!1 === e.config.screen.bodyClasses ? document.body.classList.remove(`screen--${this.name}`) : this.__update(!0)));
        const { visualViewport: o } = window, n = o || window, a = document.scrollingElement || document.documentElement, l = void 0 === o || !0 === $ec2fc4c0d7a3c6c6$var$client.is.mobile ? ()=>[
                Math.max(window.innerWidth, a.clientWidth),
                Math.max(window.innerHeight, a.clientHeight)
            ] : ()=>[
                o.width * o.scale + window.innerWidth - a.clientWidth,
                o.height * o.scale + window.innerHeight - a.clientHeight
            ], i = void 0 !== e.config.screen && !0 === e.config.screen.bodyClasses;
        this.__update = (e)=>{
            const [t, o] = l();
            if (o !== this.height && (this.height = o), t !== this.width) this.width = t;
            else if (!0 !== e) return;
            let n = this.sizes;
            this.gt.xs = t >= n.sm, this.gt.sm = t >= n.md, this.gt.md = t >= n.lg, this.gt.lg = t >= n.xl, this.lt.sm = t < n.sm, this.lt.md = t < n.md, this.lt.lg = t < n.lg, this.lt.xl = t < n.xl, this.xs = this.lt.sm, this.sm = !0 === this.gt.xs && !0 === this.lt.md, this.md = !0 === this.gt.sm && !0 === this.lt.lg, this.lg = !0 === this.gt.md && !0 === this.lt.xl, this.xl = this.gt.lg, n = (!0 === this.xs ? "xs" : !0 === this.sm && "sm") || !0 === this.md && "md" || !0 === this.lg && "lg" || "xl", n !== this.name && (!0 === i && (document.body.classList.remove(`screen--${this.name}`), document.body.classList.add(`screen--${n}`)), this.name = n);
        };
        let r, s = {}, u = 16;
        this.setSizes = (e)=>{
            $ec2fc4c0d7a3c6c6$var$SIZE_LIST.forEach((t)=>{
                void 0 !== e[t] && (s[t] = e[t]);
            });
        }, this.setDebounce = (e)=>{
            u = e;
        };
        const c = ()=>{
            const e = getComputedStyle(document.body);
            e.getPropertyValue("--q-size-sm") && $ec2fc4c0d7a3c6c6$var$SIZE_LIST.forEach((t)=>{
                this.sizes[t] = parseInt(e.getPropertyValue(`--q-size-${t}`), 10);
            }), this.setSizes = (e)=>{
                $ec2fc4c0d7a3c6c6$var$SIZE_LIST.forEach((t)=>{
                    e[t] && (this.sizes[t] = e[t]);
                }), this.__update(!0);
            }, this.setDebounce = (e)=>{
                void 0 !== r && n.removeEventListener("resize", r, $ec2fc4c0d7a3c6c6$var$passive$4), r = e > 0 ? $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(this.__update, e) : this.__update, n.addEventListener("resize", r, $ec2fc4c0d7a3c6c6$var$passive$4);
            }, this.setDebounce(u), 0 !== Object.keys(s).length ? (this.setSizes(s), s = void 0) : this.__update(), !0 === i && "xs" === this.name && document.body.classList.add("screen--xs");
        };
        !0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value ? t.push(c) : c();
    }
});
const $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    isActive: !1,
    mode: !1
}, {
    __media: void 0,
    set (e) {
        $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.mode = e, "auto" === e ? (void 0 === $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media && ($ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media = window.matchMedia("(prefers-color-scheme: dark)"), $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__updateMedia = ()=>{
            $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.set("auto");
        }, $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media.addListener($ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__updateMedia)), e = $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media.matches) : void 0 !== $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media && ($ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media.removeListener($ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__updateMedia), $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.__media = void 0), $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.isActive = !0 === e, document.body.classList.remove(`body--${!0 === e ? "light" : "dark"}`), document.body.classList.add(`body--${!0 === e ? "dark" : "light"}`);
    },
    toggle () {
        $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.set(!1 === $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f.isActive);
    },
    install ({ $q: e, onSSRHydrated: t, ssrContext: o }) {
        const { dark: n } = e.config;
        if (e.dark = this, !0 === this.__installed && void 0 === n) return;
        this.isActive = !0 === n;
        const a = void 0 !== n && n;
        if (!0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value) {
            const e = (e)=>{
                this.__fromSSR = e;
            }, o = this.set;
            this.set = e, e(a), t.push(()=>{
                this.set = o, this.set(this.__fromSSR);
            });
        } else this.set(a);
    }
}), $ec2fc4c0d7a3c6c6$var$getTrue = ()=>!0;
function $ec2fc4c0d7a3c6c6$var$filterInvalidPath(e) {
    return "string" === typeof e && "" !== e && "/" !== e && "#/" !== e;
}
function $ec2fc4c0d7a3c6c6$var$normalizeExitPath(e) {
    return !0 === e.startsWith("#") && (e = e.substring(1)), !1 === e.startsWith("/") && (e = "/" + e), !0 === e.endsWith("/") && (e = e.substring(0, e.length - 1)), "#" + e;
}
function $ec2fc4c0d7a3c6c6$var$getShouldExitFn(e) {
    if (!1 === e.backButtonExit) return ()=>!1;
    if ("*" === e.backButtonExit) return $ec2fc4c0d7a3c6c6$var$getTrue;
    const t = [
        "#/"
    ];
    return !0 === Array.isArray(e.backButtonExit) && t.push(...e.backButtonExit.filter($ec2fc4c0d7a3c6c6$var$filterInvalidPath).map($ec2fc4c0d7a3c6c6$var$normalizeExitPath)), ()=>t.includes(window.location.hash);
}
var $ec2fc4c0d7a3c6c6$var$History = {
    __history: [],
    add: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    remove: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    install ({ $q: e }) {
        if (!0 === this.__installed) return;
        const { cordova: t, capacitor: o } = $ec2fc4c0d7a3c6c6$var$client.is;
        if (!0 !== t && !0 !== o) return;
        const n = e.config[!0 === t ? "cordova" : "capacitor"];
        if (void 0 !== n && !1 === n.backButton) return;
        if (!0 === o && (void 0 === window.Capacitor || void 0 === window.Capacitor.Plugins.App)) return;
        this.add = (e)=>{
            void 0 === e.condition && (e.condition = $ec2fc4c0d7a3c6c6$var$getTrue), this.__history.push(e);
        }, this.remove = (e)=>{
            const t = this.__history.indexOf(e);
            t >= 0 && this.__history.splice(t, 1);
        };
        const a = $ec2fc4c0d7a3c6c6$var$getShouldExitFn(Object.assign({
            backButtonExit: !0
        }, n)), l = ()=>{
            if (this.__history.length) {
                const e = this.__history[this.__history.length - 1];
                !0 === e.condition() && (this.__history.pop(), e.handler());
            } else !0 === a() ? navigator.app.exitApp() : window.history.back();
        };
        !0 === t ? document.addEventListener("deviceready", ()=>{
            document.addEventListener("backbutton", l, !1);
        }) : window.Capacitor.Plugins.App.addListener("backButton", l);
    }
}, $ec2fc4c0d7a3c6c6$var$defaultLang = {
    isoName: "en-US",
    nativeName: "English (US)",
    label: {
        clear: "Clear",
        ok: "OK",
        cancel: "Cancel",
        close: "Close",
        set: "Set",
        select: "Select",
        reset: "Reset",
        remove: "Remove",
        update: "Update",
        create: "Create",
        search: "Search",
        filter: "Filter",
        refresh: "Refresh",
        expand: (e)=>e ? `Expand "${e}"` : "Expand",
        collapse: (e)=>e ? `Collapse "${e}"` : "Collapse"
    },
    date: {
        days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        firstDayOfWeek: 0,
        format24h: !1,
        pluralDay: "days"
    },
    table: {
        noData: "No data available",
        noResults: "No matching records found",
        loading: "Loading...",
        selectedRecords: (e)=>1 === e ? "1 record selected." : (0 === e ? "No" : e) + " records selected.",
        recordsPerPage: "Records per page:",
        allRows: "All",
        pagination: (e, t, o)=>e + "-" + t + " of " + o,
        columns: "Columns"
    },
    editor: {
        url: "URL",
        bold: "Bold",
        italic: "Italic",
        strikethrough: "Strikethrough",
        underline: "Underline",
        unorderedList: "Unordered List",
        orderedList: "Ordered List",
        subscript: "Subscript",
        superscript: "Superscript",
        hyperlink: "Hyperlink",
        toggleFullscreen: "Toggle Fullscreen",
        quote: "Quote",
        left: "Left align",
        center: "Center align",
        right: "Right align",
        justify: "Justify align",
        print: "Print",
        outdent: "Decrease indentation",
        indent: "Increase indentation",
        removeFormat: "Remove formatting",
        formatting: "Formatting",
        fontSize: "Font Size",
        align: "Align",
        hr: "Insert Horizontal Rule",
        undo: "Undo",
        redo: "Redo",
        heading1: "Heading 1",
        heading2: "Heading 2",
        heading3: "Heading 3",
        heading4: "Heading 4",
        heading5: "Heading 5",
        heading6: "Heading 6",
        paragraph: "Paragraph",
        code: "Code",
        size1: "Very small",
        size2: "A bit small",
        size3: "Normal",
        size4: "Medium-large",
        size5: "Big",
        size6: "Very big",
        size7: "Maximum",
        defaultFont: "Default Font",
        viewSource: "View Source"
    },
    tree: {
        noNodes: "No nodes available",
        noResults: "No matching nodes found"
    }
};
function $ec2fc4c0d7a3c6c6$var$getLocale() {
    const e = !0 === Array.isArray(navigator.languages) && 0 !== navigator.languages.length ? navigator.languages[0] : navigator.language;
    if ("string" === typeof e) return e.split(/[-_]/).map((e, t)=>0 === t ? e.toLowerCase() : t > 1 || e.length < 4 ? e.toUpperCase() : e[0].toUpperCase() + e.slice(1).toLowerCase()).join("-");
}
const $ec2fc4c0d7a3c6c6$var$Plugin$8 = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    __langPack: {}
}, {
    getLocale: $ec2fc4c0d7a3c6c6$var$getLocale,
    set (e = $ec2fc4c0d7a3c6c6$var$defaultLang, t) {
        const o = {
            ...e,
            rtl: !0 === e.rtl,
            getLocale: $ec2fc4c0d7a3c6c6$var$getLocale
        };
        if (o.set = $ec2fc4c0d7a3c6c6$var$Plugin$8.set, void 0 === $ec2fc4c0d7a3c6c6$var$Plugin$8.__langConfig || !0 !== $ec2fc4c0d7a3c6c6$var$Plugin$8.__langConfig.noHtmlAttrs) {
            const e = document.documentElement;
            e.setAttribute("dir", !0 === o.rtl ? "rtl" : "ltr"), e.setAttribute("lang", o.isoName);
        }
        Object.assign($ec2fc4c0d7a3c6c6$var$Plugin$8.__langPack, o), $ec2fc4c0d7a3c6c6$var$Plugin$8.props = o, $ec2fc4c0d7a3c6c6$var$Plugin$8.isoName = o.isoName, $ec2fc4c0d7a3c6c6$var$Plugin$8.nativeName = o.nativeName;
    },
    install ({ $q: e, lang: t, ssrContext: o }) {
        e.lang = $ec2fc4c0d7a3c6c6$var$Plugin$8.__langPack, $ec2fc4c0d7a3c6c6$var$Plugin$8.__langConfig = e.config.lang, !0 === this.__installed ? void 0 !== t && this.set(t) : this.set(t || $ec2fc4c0d7a3c6c6$var$defaultLang);
    }
});
function $ec2fc4c0d7a3c6c6$export$e1eed9727d6445a7(e, t, o = document.body) {
    if ("string" !== typeof e) throw new TypeError("Expected a string as propName");
    if ("string" !== typeof t) throw new TypeError("Expected a string as value");
    if (!(o instanceof Element)) throw new TypeError("Expected a DOM element");
    o.style.setProperty(`--q-${e}`, t);
}
let $ec2fc4c0d7a3c6c6$var$lastKeyCompositionStatus = !1;
function $ec2fc4c0d7a3c6c6$var$onKeyDownComposition(e) {
    $ec2fc4c0d7a3c6c6$var$lastKeyCompositionStatus = !0 === e.isComposing;
}
function $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(e) {
    return !0 === $ec2fc4c0d7a3c6c6$var$lastKeyCompositionStatus || e !== Object(e) || !0 === e.isComposing || !0 === e.qKeyEvent;
}
function $ec2fc4c0d7a3c6c6$var$isKeyCode(e, t) {
    return !0 !== $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(e) && [].concat(t).includes(e.keyCode);
}
function $ec2fc4c0d7a3c6c6$var$getMobilePlatform(e) {
    return !0 === e.ios ? "ios" : !0 === e.android ? "android" : void 0;
}
function $ec2fc4c0d7a3c6c6$var$getBodyClasses({ is: e, has: t, within: o }, n) {
    const a = [
        !0 === e.desktop ? "desktop" : "mobile",
        `${!1 === t.touch ? "no-" : ""}touch`
    ];
    if (!0 === e.mobile) {
        const t = $ec2fc4c0d7a3c6c6$var$getMobilePlatform(e);
        void 0 !== t && a.push("platform-" + t);
    }
    if (!0 === e.nativeMobile) {
        const t = e.nativeMobileWrapper;
        a.push(t), a.push("native-mobile"), !0 !== e.ios || void 0 !== n[t] && !1 === n[t].iosStatusBarPadding || a.push("q-ios-padding");
    } else !0 === e.electron ? a.push("electron") : !0 === e.bex && a.push("bex");
    return !0 === o.iframe && a.push("within-iframe"), a;
}
function $ec2fc4c0d7a3c6c6$var$applyClientSsrCorrections() {
    const { is: e } = $ec2fc4c0d7a3c6c6$var$client, t = document.body.className, o = new Set(t.replace(/ {2}/g, " ").split(" "));
    if (void 0 !== $ec2fc4c0d7a3c6c6$var$iosCorrection) o.delete("desktop"), o.add("platform-ios"), o.add("mobile");
    else if (!0 !== e.nativeMobile && !0 !== e.electron && !0 !== e.bex) {
        if (!0 === e.desktop) o.delete("mobile"), o.delete("platform-ios"), o.delete("platform-android"), o.add("desktop");
        else if (!0 === e.mobile) {
            o.delete("desktop"), o.add("mobile");
            const t = $ec2fc4c0d7a3c6c6$var$getMobilePlatform(e);
            void 0 !== t ? (o.add(`platform-${t}`), o.delete(`platform-${"ios" === t ? "android" : "ios"}`)) : (o.delete("platform-ios"), o.delete("platform-android"));
        }
    }
    !0 === $ec2fc4c0d7a3c6c6$var$client.has.touch && (o.delete("no-touch"), o.add("touch")), !0 === $ec2fc4c0d7a3c6c6$var$client.within.iframe && o.add("within-iframe");
    const n = Array.from(o).join(" ");
    t !== n && (document.body.className = n);
}
function $ec2fc4c0d7a3c6c6$var$setColors(e) {
    for(const t in e)$ec2fc4c0d7a3c6c6$export$e1eed9727d6445a7(t, e[t]);
}
var $ec2fc4c0d7a3c6c6$var$Body = {
    install (e) {
        if (!0 !== this.__installed) {
            if (!0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value) $ec2fc4c0d7a3c6c6$var$applyClientSsrCorrections();
            else {
                const { $q: t } = e;
                void 0 !== t.config.brand && $ec2fc4c0d7a3c6c6$var$setColors(t.config.brand);
                const o = $ec2fc4c0d7a3c6c6$var$getBodyClasses($ec2fc4c0d7a3c6c6$var$client, t.config);
                document.body.classList.add.apply(document.body.classList, o);
            }
            !0 === $ec2fc4c0d7a3c6c6$var$client.is.ios && document.body.addEventListener("touchstart", $ec2fc4c0d7a3c6c6$export$8793edee2d425525), window.addEventListener("keydown", $ec2fc4c0d7a3c6c6$var$onKeyDownComposition, !0);
        }
    }
}, $ec2fc4c0d7a3c6c6$var$materialIcons = {
    name: "material-icons",
    type: {
        positive: "check_circle",
        negative: "warning",
        info: "info",
        warning: "priority_high"
    },
    arrow: {
        up: "arrow_upward",
        right: "arrow_forward",
        down: "arrow_downward",
        left: "arrow_back",
        dropdown: "arrow_drop_down"
    },
    chevron: {
        left: "chevron_left",
        right: "chevron_right"
    },
    colorPicker: {
        spectrum: "gradient",
        tune: "tune",
        palette: "style"
    },
    pullToRefresh: {
        icon: "refresh"
    },
    carousel: {
        left: "chevron_left",
        right: "chevron_right",
        up: "keyboard_arrow_up",
        down: "keyboard_arrow_down",
        navigationIcon: "lens"
    },
    chip: {
        remove: "cancel",
        selected: "check"
    },
    datetime: {
        arrowLeft: "chevron_left",
        arrowRight: "chevron_right",
        now: "access_time",
        today: "today"
    },
    editor: {
        bold: "format_bold",
        italic: "format_italic",
        strikethrough: "strikethrough_s",
        underline: "format_underlined",
        unorderedList: "format_list_bulleted",
        orderedList: "format_list_numbered",
        subscript: "vertical_align_bottom",
        superscript: "vertical_align_top",
        hyperlink: "link",
        toggleFullscreen: "fullscreen",
        quote: "format_quote",
        left: "format_align_left",
        center: "format_align_center",
        right: "format_align_right",
        justify: "format_align_justify",
        print: "print",
        outdent: "format_indent_decrease",
        indent: "format_indent_increase",
        removeFormat: "format_clear",
        formatting: "text_format",
        fontSize: "format_size",
        align: "format_align_left",
        hr: "remove",
        undo: "undo",
        redo: "redo",
        heading: "format_size",
        code: "code",
        size: "format_size",
        font: "font_download",
        viewSource: "code"
    },
    expansionItem: {
        icon: "keyboard_arrow_down",
        denseIcon: "arrow_drop_down"
    },
    fab: {
        icon: "add",
        activeIcon: "close"
    },
    field: {
        clear: "cancel",
        error: "error"
    },
    pagination: {
        first: "first_page",
        prev: "keyboard_arrow_left",
        next: "keyboard_arrow_right",
        last: "last_page"
    },
    rating: {
        icon: "grade"
    },
    stepper: {
        done: "check",
        active: "edit",
        error: "warning"
    },
    tabs: {
        left: "chevron_left",
        right: "chevron_right",
        up: "keyboard_arrow_up",
        down: "keyboard_arrow_down"
    },
    table: {
        arrowUp: "arrow_upward",
        warning: "warning",
        firstPage: "first_page",
        prevPage: "chevron_left",
        nextPage: "chevron_right",
        lastPage: "last_page"
    },
    tree: {
        icon: "play_arrow"
    },
    uploader: {
        done: "done",
        clear: "clear",
        add: "add_box",
        upload: "cloud_upload",
        removeQueue: "clear_all",
        removeUploaded: "done_all"
    }
};
const $ec2fc4c0d7a3c6c6$var$Plugin$7 = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    iconMapFn: null,
    __icons: {}
}, {
    set (e, t) {
        const o = {
            ...e,
            rtl: !0 === e.rtl
        };
        o.set = $ec2fc4c0d7a3c6c6$var$Plugin$7.set, Object.assign($ec2fc4c0d7a3c6c6$var$Plugin$7.__icons, o);
    },
    install ({ $q: e, iconSet: t, ssrContext: o }) {
        void 0 !== e.config.iconMapFn && (this.iconMapFn = e.config.iconMapFn), e.iconSet = this.__icons, $ec2fc4c0d7a3c6c6$var$injectProp(e, "iconMapFn", ()=>this.iconMapFn, (e)=>{
            this.iconMapFn = e;
        }), !0 === this.__installed ? void 0 !== t && this.set(t) : this.set(t || $ec2fc4c0d7a3c6c6$var$materialIcons);
    }
}), $ec2fc4c0d7a3c6c6$var$quasarKey = "_q_", $ec2fc4c0d7a3c6c6$var$timelineKey = "_q_t_", $ec2fc4c0d7a3c6c6$var$stepperKey = "_q_s_", $ec2fc4c0d7a3c6c6$var$layoutKey = "_q_l_", $ec2fc4c0d7a3c6c6$var$pageContainerKey = "_q_pc_", $ec2fc4c0d7a3c6c6$var$fabKey = "_q_f_", $ec2fc4c0d7a3c6c6$var$formKey = "_q_fo_", $ec2fc4c0d7a3c6c6$var$tabsKey = "_q_tabs_", $ec2fc4c0d7a3c6c6$var$uploaderKey = "_q_u_", $ec2fc4c0d7a3c6c6$var$emptyRenderFn = ()=>{}, $ec2fc4c0d7a3c6c6$var$globalConfig = {};
let $ec2fc4c0d7a3c6c6$var$globalConfigIsFrozen = !1;
function $ec2fc4c0d7a3c6c6$var$freezeGlobalConfig() {
    $ec2fc4c0d7a3c6c6$var$globalConfigIsFrozen = !0;
}
function $ec2fc4c0d7a3c6c6$var$isDeepEqual(e, t) {
    if (e === t) return !0;
    if (null !== e && null !== t && "object" === typeof e && "object" === typeof t) {
        if (e.constructor !== t.constructor) return !1;
        let o, n;
        if (e.constructor === Array) {
            if (o = e.length, o !== t.length) return !1;
            for(n = o; 0 !== n--;)if (!0 !== $ec2fc4c0d7a3c6c6$var$isDeepEqual(e[n], t[n])) return !1;
            return !0;
        }
        if (e.constructor === Map) {
            if (e.size !== t.size) return !1;
            let o = e.entries();
            n = o.next();
            while(!0 !== n.done){
                if (!0 !== t.has(n.value[0])) return !1;
                n = o.next();
            }
            o = e.entries(), n = o.next();
            while(!0 !== n.done){
                if (!0 !== $ec2fc4c0d7a3c6c6$var$isDeepEqual(n.value[1], t.get(n.value[0]))) return !1;
                n = o.next();
            }
            return !0;
        }
        if (e.constructor === Set) {
            if (e.size !== t.size) return !1;
            const o = e.entries();
            n = o.next();
            while(!0 !== n.done){
                if (!0 !== t.has(n.value[0])) return !1;
                n = o.next();
            }
            return !0;
        }
        if (null != e.buffer && e.buffer.constructor === ArrayBuffer) {
            if (o = e.length, o !== t.length) return !1;
            for(n = o; 0 !== n--;)if (e[n] !== t[n]) return !1;
            return !0;
        }
        if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
        if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
        const a = Object.keys(e).filter((t)=>void 0 !== e[t]);
        if (o = a.length, o !== Object.keys(t).filter((e)=>void 0 !== t[e]).length) return !1;
        for(n = o; 0 !== n--;){
            const o = a[n];
            if (!0 !== $ec2fc4c0d7a3c6c6$var$isDeepEqual(e[o], t[o])) return !1;
        }
        return !0;
    }
    return e !== e && t !== t;
}
function $ec2fc4c0d7a3c6c6$var$isObject(e) {
    return null !== e && "object" === typeof e && !0 !== Array.isArray(e);
}
function $ec2fc4c0d7a3c6c6$var$isDate(e) {
    return "[object Date]" === Object.prototype.toString.call(e);
}
function $ec2fc4c0d7a3c6c6$var$isRegexp(e) {
    return "[object RegExp]" === Object.prototype.toString.call(e);
}
function $ec2fc4c0d7a3c6c6$var$isNumber(e) {
    return "number" === typeof e && isFinite(e);
}
var $ec2fc4c0d7a3c6c6$export$226b3eccf92c9ed9 = {
    deepEqual: $ec2fc4c0d7a3c6c6$var$isDeepEqual,
    object: $ec2fc4c0d7a3c6c6$var$isObject,
    date: $ec2fc4c0d7a3c6c6$var$isDate,
    regexp: $ec2fc4c0d7a3c6c6$var$isRegexp,
    number: $ec2fc4c0d7a3c6c6$var$isNumber
};
const $ec2fc4c0d7a3c6c6$var$autoInstalledPlugins = [
    $ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389,
    $ec2fc4c0d7a3c6c6$var$Body,
    $ec2fc4c0d7a3c6c6$export$ef445a9602a9971f,
    $ec2fc4c0d7a3c6c6$export$a98515d67472a41f,
    $ec2fc4c0d7a3c6c6$var$History,
    $ec2fc4c0d7a3c6c6$var$Plugin$8,
    $ec2fc4c0d7a3c6c6$var$Plugin$7
];
function $ec2fc4c0d7a3c6c6$var$createChildApp(e, t) {
    const o = (0, $eeJ70.createApp)(e);
    o.config.globalProperties = t.config.globalProperties;
    const { reload: n, ...a } = t._context;
    return Object.assign(o._context, a), o;
}
function $ec2fc4c0d7a3c6c6$var$installPlugins(e, t) {
    t.forEach((t)=>{
        t.install(e), t.__installed = !0;
    });
}
function $ec2fc4c0d7a3c6c6$var$prepareApp(e, t, o) {
    e.config.globalProperties.$q = o.$q, e.provide($ec2fc4c0d7a3c6c6$var$quasarKey, o.$q), $ec2fc4c0d7a3c6c6$var$installPlugins(o, $ec2fc4c0d7a3c6c6$var$autoInstalledPlugins), void 0 !== t.components && Object.values(t.components).forEach((t)=>{
        !0 === $ec2fc4c0d7a3c6c6$var$isObject(t) && void 0 !== t.name && e.component(t.name, t);
    }), void 0 !== t.directives && Object.values(t.directives).forEach((t)=>{
        !0 === $ec2fc4c0d7a3c6c6$var$isObject(t) && void 0 !== t.name && e.directive(t.name, t);
    }), void 0 !== t.plugins && $ec2fc4c0d7a3c6c6$var$installPlugins(o, Object.values(t.plugins).filter((e)=>"function" === typeof e.install && !1 === $ec2fc4c0d7a3c6c6$var$autoInstalledPlugins.includes(e))), !0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value && (o.$q.onSSRHydrated = ()=>{
        o.onSSRHydrated.forEach((e)=>{
            e();
        }), o.$q.onSSRHydrated = ()=>{};
    });
}
var $ec2fc4c0d7a3c6c6$var$installQuasar = function(e, t = {}) {
    const o = {
        version: "2.12.5"
    };
    !1 === $ec2fc4c0d7a3c6c6$var$globalConfigIsFrozen ? (void 0 !== t.config && Object.assign($ec2fc4c0d7a3c6c6$var$globalConfig, t.config), o.config = {
        ...$ec2fc4c0d7a3c6c6$var$globalConfig
    }, $ec2fc4c0d7a3c6c6$var$freezeGlobalConfig()) : o.config = t.config || {}, $ec2fc4c0d7a3c6c6$var$prepareApp(e, t, {
        parentApp: e,
        $q: o,
        lang: t.lang,
        iconSet: t.iconSet,
        onSSRHydrated: []
    });
};
const $ec2fc4c0d7a3c6c6$var$createComponent = (e)=>(0, $01W3b.markRaw)((0, $TusQn.defineComponent)(e)), $ec2fc4c0d7a3c6c6$var$createDirective = (e)=>(0, $01W3b.markRaw)(e), $ec2fc4c0d7a3c6c6$var$units = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB"
];
function $ec2fc4c0d7a3c6c6$var$humanStorageSize(e) {
    let t = 0;
    while(parseInt(e, 10) >= 1024 && t < $ec2fc4c0d7a3c6c6$var$units.length - 1)e /= 1024, ++t;
    return `${e.toFixed(1)}${$ec2fc4c0d7a3c6c6$var$units[t]}`;
}
function $ec2fc4c0d7a3c6c6$var$capitalize(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
}
function $ec2fc4c0d7a3c6c6$var$between(e, t, o) {
    return o <= t ? t : Math.min(o, Math.max(t, e));
}
function $ec2fc4c0d7a3c6c6$var$normalizeToInterval(e, t, o) {
    if (o <= t) return t;
    const n = o - t + 1;
    let a = t + (e - t) % n;
    return a < t && (a = n + a), 0 === a ? 0 : a;
}
function $ec2fc4c0d7a3c6c6$var$pad(e, t = 2, o = "0") {
    if (void 0 === e || null === e) return e;
    const n = "" + e;
    return n.length >= t ? n : new Array(t - n.length + 1).join(o) + n;
}
var $ec2fc4c0d7a3c6c6$export$d9468344d3651243 = {
    humanStorageSize: $ec2fc4c0d7a3c6c6$var$humanStorageSize,
    capitalize: $ec2fc4c0d7a3c6c6$var$capitalize,
    between: $ec2fc4c0d7a3c6c6$var$between,
    normalizeToInterval: $ec2fc4c0d7a3c6c6$var$normalizeToInterval,
    pad: $ec2fc4c0d7a3c6c6$var$pad
};
const $ec2fc4c0d7a3c6c6$var$xhr = XMLHttpRequest, $ec2fc4c0d7a3c6c6$var$open = $ec2fc4c0d7a3c6c6$var$xhr.prototype.open, $ec2fc4c0d7a3c6c6$var$positionValues = [
    "top",
    "right",
    "bottom",
    "left"
];
let $ec2fc4c0d7a3c6c6$var$stack = [], $ec2fc4c0d7a3c6c6$var$highjackCount = 0;
function $ec2fc4c0d7a3c6c6$var$translate({ p: e, pos: t, active: o, horiz: n, reverse: a, dir: l }) {
    let i = 1, r = 1;
    return !0 === n ? (!0 === a && (i = -1), "bottom" === t && (r = -1), {
        transform: `translate3d(${i * (e - 100)}%,${o ? 0 : -200 * r}%,0)`
    }) : (!0 === a && (r = -1), "right" === t && (i = -1), {
        transform: `translate3d(${o ? 0 : l * i * -200}%,${r * (e - 100)}%,0)`
    });
}
function $ec2fc4c0d7a3c6c6$var$inc(e, t) {
    return "number" !== typeof t && (t = e < 25 ? 3 * Math.random() + 3 : e < 65 ? 3 * Math.random() : e < 85 ? 2 * Math.random() : e < 99 ? .6 : 0), $ec2fc4c0d7a3c6c6$var$between(e + t, 0, 100);
}
function $ec2fc4c0d7a3c6c6$var$highjackAjax(e) {
    $ec2fc4c0d7a3c6c6$var$highjackCount++, $ec2fc4c0d7a3c6c6$var$stack.push(e), $ec2fc4c0d7a3c6c6$var$highjackCount > 1 || ($ec2fc4c0d7a3c6c6$var$xhr.prototype.open = function(e, t) {
        const o = [], n = ()=>{
            $ec2fc4c0d7a3c6c6$var$stack.forEach((e)=>{
                null !== e.hijackFilter.value && !0 !== e.hijackFilter.value(t) || (e.start(), o.push(e.stop));
            });
        }, a = ()=>{
            o.forEach((e)=>{
                e();
            });
        };
        this.addEventListener("loadstart", n, {
            once: !0
        }), this.addEventListener("loadend", a, {
            once: !0
        }), $ec2fc4c0d7a3c6c6$var$open.apply(this, arguments);
    });
}
function $ec2fc4c0d7a3c6c6$var$restoreAjax(e) {
    $ec2fc4c0d7a3c6c6$var$stack = $ec2fc4c0d7a3c6c6$var$stack.filter((t)=>t.start !== e), $ec2fc4c0d7a3c6c6$var$highjackCount = Math.max(0, $ec2fc4c0d7a3c6c6$var$highjackCount - 1), 0 === $ec2fc4c0d7a3c6c6$var$highjackCount && ($ec2fc4c0d7a3c6c6$var$xhr.prototype.open = $ec2fc4c0d7a3c6c6$var$open);
}
var $ec2fc4c0d7a3c6c6$export$b18d87171d171ca9 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QAjaxBar",
    props: {
        position: {
            type: String,
            default: "top",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$positionValues.includes(e)
        },
        size: {
            type: String,
            default: "2px"
        },
        color: String,
        skipHijack: Boolean,
        reverse: Boolean,
        hijackFilter: Function
    },
    emits: [
        "start",
        "stop"
    ],
    setup (e, { emit: t }) {
        const { proxy: o } = (0, $TusQn.getCurrentInstance)(), n = (0, $01W3b.ref)(0), a = (0, $01W3b.ref)(!1), l = (0, $01W3b.ref)(!0);
        let i, r = 0, s = null;
        const u = (0, $TusQn.computed)(()=>`q-loading-bar q-loading-bar--${e.position}` + (void 0 !== e.color ? ` bg-${e.color}` : "") + (!0 === l.value ? "" : " no-transition")), c = (0, $TusQn.computed)(()=>"top" === e.position || "bottom" === e.position), d = (0, $TusQn.computed)(()=>!0 === c.value ? "height" : "width"), p = (0, $TusQn.computed)(()=>{
            const t = a.value, l = $ec2fc4c0d7a3c6c6$var$translate({
                p: n.value,
                pos: e.position,
                active: t,
                horiz: c.value,
                reverse: !0 === o.$q.lang.rtl && [
                    "top",
                    "bottom"
                ].includes(e.position) ? !1 === e.reverse : e.reverse,
                dir: !0 === o.$q.lang.rtl ? -1 : 1
            });
            return l[d.value] = e.size, l.opacity = t ? 1 : 0, l;
        }), v = (0, $TusQn.computed)(()=>!0 === a.value ? {
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": n.value
            } : {
                "aria-hidden": "true"
            });
        function m(e = 300) {
            const o = i;
            return i = Math.max(0, e) || 0, r++, r > 1 ? (0 === o && e > 0 ? b() : null !== s && o > 0 && e <= 0 && (clearTimeout(s), s = null), r) : (null !== s && clearTimeout(s), t("start"), n.value = 0, s = setTimeout(()=>{
                s = null, l.value = !0, e > 0 && b();
            }, !0 === a.value ? 500 : 1), !0 !== a.value && (a.value = !0, l.value = !1), r);
        }
        function f(e) {
            return r > 0 && (n.value = $ec2fc4c0d7a3c6c6$var$inc(n.value, e)), r;
        }
        function g() {
            if (r = Math.max(0, r - 1), r > 0) return r;
            null !== s && (clearTimeout(s), s = null), t("stop");
            const e = ()=>{
                l.value = !0, n.value = 100, s = setTimeout(()=>{
                    s = null, a.value = !1;
                }, 1e3);
            };
            return 0 === n.value ? s = setTimeout(e, 1) : e(), r;
        }
        function b() {
            n.value < 100 && (s = setTimeout(()=>{
                s = null, f(), b();
            }, i));
        }
        let y;
        return (0, $TusQn.onMounted)(()=>{
            !0 !== e.skipHijack && (y = !0, $ec2fc4c0d7a3c6c6$var$highjackAjax({
                start: m,
                stop: g,
                hijackFilter: (0, $TusQn.computed)(()=>e.hijackFilter || null)
            }));
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            null !== s && clearTimeout(s), !0 === y && $ec2fc4c0d7a3c6c6$var$restoreAjax(m);
        }), Object.assign(o, {
            start: m,
            stop: g,
            increment: f
        }), ()=>(0, $TusQn.h)("div", {
                class: u.value,
                style: p.value,
                ...v.value
            });
    }
});
const $ec2fc4c0d7a3c6c6$var$useSizeDefaults = {
    xs: 18,
    sm: 24,
    md: 32,
    lg: 38,
    xl: 46
}, $ec2fc4c0d7a3c6c6$var$useSizeProps = {
    size: String
};
function $ec2fc4c0d7a3c6c6$var$useSize(e, t = $ec2fc4c0d7a3c6c6$var$useSizeDefaults) {
    return (0, $TusQn.computed)(()=>void 0 !== e.size ? {
            fontSize: e.size in t ? `${t[e.size]}px` : e.size
        } : null);
}
function $ec2fc4c0d7a3c6c6$var$hSlot(e, t) {
    return void 0 !== e && e() || t;
}
function $ec2fc4c0d7a3c6c6$var$hUniqueSlot(e, t) {
    if (void 0 !== e) {
        const t = e();
        if (void 0 !== t && null !== t) return t.slice();
    }
    return t;
}
function $ec2fc4c0d7a3c6c6$var$hMergeSlot(e, t) {
    return void 0 !== e ? t.concat(e()) : t;
}
function $ec2fc4c0d7a3c6c6$var$hMergeSlotSafely(e, t) {
    return void 0 === e ? t : void 0 !== t ? t.concat(e()) : e();
}
function $ec2fc4c0d7a3c6c6$var$hDir(e, t, o, n, a, l) {
    t.key = n + a;
    const i = (0, $TusQn.h)(e, t, o);
    return !0 === a ? (0, $TusQn.withDirectives)(i, l()) : i;
}
const $ec2fc4c0d7a3c6c6$var$defaultViewBox = "0 0 24 24", $ec2fc4c0d7a3c6c6$var$sameFn = (e)=>e, $ec2fc4c0d7a3c6c6$var$ionFn = (e)=>`ionicons ${e}`, $ec2fc4c0d7a3c6c6$var$libMap = {
    "mdi-": (e)=>`mdi ${e}`,
    "icon-": $ec2fc4c0d7a3c6c6$var$sameFn,
    "bt-": (e)=>`bt ${e}`,
    "eva-": (e)=>`eva ${e}`,
    "ion-md": $ec2fc4c0d7a3c6c6$var$ionFn,
    "ion-ios": $ec2fc4c0d7a3c6c6$var$ionFn,
    "ion-logo": $ec2fc4c0d7a3c6c6$var$ionFn,
    "iconfont ": $ec2fc4c0d7a3c6c6$var$sameFn,
    "ti-": (e)=>`themify-icon ${e}`,
    "bi-": (e)=>`bootstrap-icons ${e}`
}, $ec2fc4c0d7a3c6c6$var$matMap = {
    o_: "-outlined",
    r_: "-round",
    s_: "-sharp"
}, $ec2fc4c0d7a3c6c6$var$symMap = {
    sym_o_: "-outlined",
    sym_r_: "-rounded",
    sym_s_: "-sharp"
}, $ec2fc4c0d7a3c6c6$var$libRE = new RegExp("^(" + Object.keys($ec2fc4c0d7a3c6c6$var$libMap).join("|") + ")"), $ec2fc4c0d7a3c6c6$var$matRE = new RegExp("^(" + Object.keys($ec2fc4c0d7a3c6c6$var$matMap).join("|") + ")"), $ec2fc4c0d7a3c6c6$var$symRE = new RegExp("^(" + Object.keys($ec2fc4c0d7a3c6c6$var$symMap).join("|") + ")"), $ec2fc4c0d7a3c6c6$var$mRE = /^[Mm]\s?[-+]?\.?\d/, $ec2fc4c0d7a3c6c6$var$imgRE = /^img:/, $ec2fc4c0d7a3c6c6$var$svgUseRE = /^svguse:/, $ec2fc4c0d7a3c6c6$var$ionRE = /^ion-/, $ec2fc4c0d7a3c6c6$var$faRE = /^(fa-(sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
var $ec2fc4c0d7a3c6c6$export$d56d6691b226e237 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QIcon",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
        tag: {
            type: String,
            default: "i"
        },
        name: String,
        color: String,
        left: Boolean,
        right: Boolean
    },
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useSize(e), a = (0, $TusQn.computed)(()=>"q-icon" + (!0 === e.left ? " on-left" : "") + (!0 === e.right ? " on-right" : "") + (void 0 !== e.color ? ` text-${e.color}` : "")), l = (0, $TusQn.computed)(()=>{
            let t, n = e.name;
            if ("none" === n || !n) return {
                none: !0
            };
            if (null !== o.iconMapFn) {
                const e = o.iconMapFn(n);
                if (void 0 !== e) {
                    if (void 0 === e.icon) return {
                        cls: e.cls,
                        content: void 0 !== e.content ? e.content : " "
                    };
                    if (n = e.icon, "none" === n || !n) return {
                        none: !0
                    };
                }
            }
            if (!0 === $ec2fc4c0d7a3c6c6$var$mRE.test(n)) {
                const [e, t = $ec2fc4c0d7a3c6c6$var$defaultViewBox] = n.split("|");
                return {
                    svg: !0,
                    viewBox: t,
                    nodes: e.split("&&").map((e)=>{
                        const [t, o, n] = e.split("@@");
                        return (0, $TusQn.h)("path", {
                            style: o,
                            d: t,
                            transform: n
                        });
                    })
                };
            }
            if (!0 === $ec2fc4c0d7a3c6c6$var$imgRE.test(n)) return {
                img: !0,
                src: n.substring(4)
            };
            if (!0 === $ec2fc4c0d7a3c6c6$var$svgUseRE.test(n)) {
                const [e, t = $ec2fc4c0d7a3c6c6$var$defaultViewBox] = n.split("|");
                return {
                    svguse: !0,
                    src: e.substring(7),
                    viewBox: t
                };
            }
            let a = " ";
            const l = n.match($ec2fc4c0d7a3c6c6$var$libRE);
            if (null !== l) t = $ec2fc4c0d7a3c6c6$var$libMap[l[1]](n);
            else if (!0 === $ec2fc4c0d7a3c6c6$var$faRE.test(n)) t = n;
            else if (!0 === $ec2fc4c0d7a3c6c6$var$ionRE.test(n)) t = `ionicons ion-${!0 === o.platform.is.ios ? "ios" : "md"}${n.substring(3)}`;
            else if (!0 === $ec2fc4c0d7a3c6c6$var$symRE.test(n)) {
                t = "notranslate material-symbols";
                const e = n.match($ec2fc4c0d7a3c6c6$var$symRE);
                null !== e && (n = n.substring(6), t += $ec2fc4c0d7a3c6c6$var$symMap[e[1]]), a = n;
            } else {
                t = "notranslate material-icons";
                const e = n.match($ec2fc4c0d7a3c6c6$var$matRE);
                null !== e && (n = n.substring(2), t += $ec2fc4c0d7a3c6c6$var$matMap[e[1]]), a = n;
            }
            return {
                cls: t,
                content: a
            };
        });
        return ()=>{
            const o = {
                class: a.value,
                style: n.value,
                "aria-hidden": "true",
                role: "presentation"
            };
            return !0 === l.value.none ? (0, $TusQn.h)(e.tag, o, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)) : !0 === l.value.img ? (0, $TusQn.h)("span", o, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                (0, $TusQn.h)("img", {
                    src: l.value.src
                })
            ])) : !0 === l.value.svg ? (0, $TusQn.h)("span", o, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                (0, $TusQn.h)("svg", {
                    viewBox: l.value.viewBox || "0 0 24 24"
                }, l.value.nodes)
            ])) : !0 === l.value.svguse ? (0, $TusQn.h)("span", o, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                (0, $TusQn.h)("svg", {
                    viewBox: l.value.viewBox
                }, [
                    (0, $TusQn.h)("use", {
                        "xlink:href": l.value.src
                    })
                ])
            ])) : (void 0 !== l.value.cls && (o.class += " " + l.value.cls), (0, $TusQn.h)(e.tag, o, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                l.value.content
            ])));
        };
    }
}), $ec2fc4c0d7a3c6c6$export$f3774053158ba051 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QAvatar",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
        fontSize: String,
        color: String,
        textColor: String,
        icon: String,
        square: Boolean,
        rounded: Boolean
    },
    setup (e, { slots: t }) {
        const o = $ec2fc4c0d7a3c6c6$var$useSize(e), n = (0, $TusQn.computed)(()=>"q-avatar" + (e.color ? ` bg-${e.color}` : "") + (e.textColor ? ` text-${e.textColor} q-chip--colored` : "") + (!0 === e.square ? " q-avatar--square" : !0 === e.rounded ? " rounded-borders" : "")), a = (0, $TusQn.computed)(()=>e.fontSize ? {
                fontSize: e.fontSize
            } : null);
        return ()=>{
            const l = void 0 !== e.icon ? [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    name: e.icon
                })
            ] : void 0;
            return (0, $TusQn.h)("div", {
                class: n.value,
                style: o.value
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-avatar__content row flex-center overflow-hidden",
                    style: a.value
                }, $ec2fc4c0d7a3c6c6$var$hMergeSlotSafely(t.default, l))
            ]);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$alignValues$3 = [
    "top",
    "middle",
    "bottom"
];
var $ec2fc4c0d7a3c6c6$export$73f24ecabf561a88 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBadge",
    props: {
        color: String,
        textColor: String,
        floating: Boolean,
        transparent: Boolean,
        multiLine: Boolean,
        outline: Boolean,
        rounded: Boolean,
        label: [
            Number,
            String
        ],
        align: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$alignValues$3.includes(e)
        }
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>{
            return void 0 !== e.align ? {
                verticalAlign: e.align
            } : null;
        }), n = (0, $TusQn.computed)(()=>{
            const t = !0 === e.outline && e.color || e.textColor;
            return "q-badge flex inline items-center no-wrap" + ` q-badge--${!0 === e.multiLine ? "multi" : "single"}-line` + (!0 === e.outline ? " q-badge--outline" : void 0 !== e.color ? ` bg-${e.color}` : "") + (void 0 !== t ? ` text-${t}` : "") + (!0 === e.floating ? " q-badge--floating" : "") + (!0 === e.rounded ? " q-badge--rounded" : "") + (!0 === e.transparent ? " q-badge--transparent" : "");
        });
        return ()=>(0, $TusQn.h)("div", {
                class: n.value,
                style: o.value,
                role: "status",
                "aria-label": e.label
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, void 0 !== e.label ? [
                e.label
            ] : []));
    }
});
const $ec2fc4c0d7a3c6c6$var$useDarkProps = {
    dark: {
        type: Boolean,
        default: null
    }
};
function $ec2fc4c0d7a3c6c6$var$useDark(e, t) {
    return (0, $TusQn.computed)(()=>null === e.dark ? t.dark.isActive : e.dark);
}
var $ec2fc4c0d7a3c6c6$export$388879c71c3c10cf = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBanner",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        inlineActions: Boolean,
        dense: Boolean,
        rounded: Boolean
    },
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o), a = (0, $TusQn.computed)(()=>"q-banner row items-center" + (!0 === e.dense ? " q-banner--dense" : "") + (!0 === n.value ? " q-banner--dark q-dark" : "") + (!0 === e.rounded ? " rounded-borders" : "")), l = (0, $TusQn.computed)(()=>"q-banner__actions row items-center justify-end" + ` col-${!0 === e.inlineActions ? "auto" : "all"}`);
        return ()=>{
            const o = [
                (0, $TusQn.h)("div", {
                    class: "q-banner__avatar col-auto row items-center self-start"
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.avatar)),
                (0, $TusQn.h)("div", {
                    class: "q-banner__content col text-body2"
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ], n = $ec2fc4c0d7a3c6c6$var$hSlot(t.action);
            return void 0 !== n && o.push((0, $TusQn.h)("div", {
                class: l.value
            }, n)), (0, $TusQn.h)("div", {
                class: a.value + (!1 === e.inlineActions && void 0 !== n ? " q-banner--top-padding" : ""),
                role: "alert"
            }, o);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$31ac01ac4236208c = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBar",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        dense: Boolean
    },
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o), a = (0, $TusQn.computed)(()=>"q-bar row no-wrap items-center" + ` q-bar--${!0 === e.dense ? "dense" : "standard"} ` + ` q-bar--${!0 === n.value ? "dark" : "light"}`);
        return ()=>(0, $TusQn.h)("div", {
                class: a.value,
                role: "toolbar"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$alignMap = {
    left: "start",
    center: "center",
    right: "end",
    between: "between",
    around: "around",
    evenly: "evenly",
    stretch: "stretch"
}, $ec2fc4c0d7a3c6c6$var$alignValues$2 = Object.keys($ec2fc4c0d7a3c6c6$var$alignMap), $ec2fc4c0d7a3c6c6$var$useAlignProps = {
    align: {
        type: String,
        validator: (e)=>$ec2fc4c0d7a3c6c6$var$alignValues$2.includes(e)
    }
};
function $ec2fc4c0d7a3c6c6$var$useAlign(e) {
    return (0, $TusQn.computed)(()=>{
        const t = void 0 === e.align ? !0 === e.vertical ? "stretch" : "left" : e.align;
        return `${!0 === e.vertical ? "items" : "justify"}-${$ec2fc4c0d7a3c6c6$var$alignMap[t]}`;
    });
}
function $ec2fc4c0d7a3c6c6$var$getParentProxy(e) {
    if (Object(e.$parent) === e.$parent) return e.$parent;
    let { parent: t } = e.$;
    while(Object(t) === t){
        if (Object(t.proxy) === t.proxy) return t.proxy;
        t = t.parent;
    }
}
function $ec2fc4c0d7a3c6c6$var$fillNormalizedVNodes(e, t) {
    "symbol" === typeof t.type ? !0 === Array.isArray(t.children) && t.children.forEach((t)=>{
        $ec2fc4c0d7a3c6c6$var$fillNormalizedVNodes(e, t);
    }) : e.add(t);
}
function $ec2fc4c0d7a3c6c6$var$getNormalizedVNodes(e) {
    const t = new Set;
    return e.forEach((e)=>{
        $ec2fc4c0d7a3c6c6$var$fillNormalizedVNodes(t, e);
    }), Array.from(t);
}
function $ec2fc4c0d7a3c6c6$var$vmHasRouter(e) {
    return void 0 !== e.appContext.config.globalProperties.$router;
}
function $ec2fc4c0d7a3c6c6$var$vmIsDestroyed(e) {
    return !0 === e.isUnmounted || !0 === e.isDeactivated;
}
const $ec2fc4c0d7a3c6c6$var$disabledValues = [
    "",
    !0
];
var $ec2fc4c0d7a3c6c6$export$88a7ba48108b3d90 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBreadcrumbs",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useAlignProps,
        separator: {
            type: String,
            default: "/"
        },
        separatorColor: String,
        activeColor: {
            type: String,
            default: "primary"
        },
        gutter: {
            type: String,
            validator: (e)=>[
                    "none",
                    "xs",
                    "sm",
                    "md",
                    "lg",
                    "xl"
                ].includes(e),
            default: "sm"
        }
    },
    setup (e, { slots: t }) {
        const o = $ec2fc4c0d7a3c6c6$var$useAlign(e), n = (0, $TusQn.computed)(()=>`flex items-center ${o.value}${"none" === e.gutter ? "" : ` q-gutter-${e.gutter}`}`), a = (0, $TusQn.computed)(()=>e.separatorColor ? ` text-${e.separatorColor}` : ""), l = (0, $TusQn.computed)(()=>` text-${e.activeColor}`);
        return ()=>{
            const o = $ec2fc4c0d7a3c6c6$var$getNormalizedVNodes($ec2fc4c0d7a3c6c6$var$hSlot(t.default));
            if (0 === o.length) return;
            let i = 1;
            const r = [], s = o.filter((e)=>void 0 !== e.type && "QBreadcrumbsEl" === e.type.name).length, u = void 0 !== t.separator ? t.separator : ()=>e.separator;
            return o.forEach((e)=>{
                if (void 0 !== e.type && "QBreadcrumbsEl" === e.type.name) {
                    const t = i < s, o = null !== e.props && $ec2fc4c0d7a3c6c6$var$disabledValues.includes(e.props.disable), n = (!0 === t ? "" : " q-breadcrumbs--last") + (!0 !== o && !0 === t ? l.value : "");
                    i++, r.push((0, $TusQn.h)("div", {
                        class: `flex items-center${n}`
                    }, [
                        e
                    ])), !0 === t && r.push((0, $TusQn.h)("div", {
                        class: "q-breadcrumbs__separator" + a.value
                    }, u()));
                } else r.push(e);
            }), (0, $TusQn.h)("div", {
                class: "q-breadcrumbs"
            }, [
                (0, $TusQn.h)("div", {
                    class: n.value
                }, r)
            ]);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$getOriginalPath(e) {
    return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
function $ec2fc4c0d7a3c6c6$var$isSameRouteRecord(e, t) {
    return (e.aliasOf || e) === (t.aliasOf || t);
}
function $ec2fc4c0d7a3c6c6$var$includesParams(e, t) {
    for(const o in t){
        const n = t[o], a = e[o];
        if ("string" === typeof n) {
            if (n !== a) return !1;
        } else if (!1 === Array.isArray(a) || a.length !== n.length || n.some((e, t)=>e !== a[t])) return !1;
    }
    return !0;
}
function $ec2fc4c0d7a3c6c6$var$isEquivalentArray(e, t) {
    return !0 === Array.isArray(t) ? e.length === t.length && e.every((e, o)=>e === t[o]) : 1 === e.length && e[0] === t;
}
function $ec2fc4c0d7a3c6c6$var$isSameRouteLocationParamsValue(e, t) {
    return !0 === Array.isArray(e) ? $ec2fc4c0d7a3c6c6$var$isEquivalentArray(e, t) : !0 === Array.isArray(t) ? $ec2fc4c0d7a3c6c6$var$isEquivalentArray(t, e) : e === t;
}
function $ec2fc4c0d7a3c6c6$var$isSameRouteLocationParams(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for(const o in e)if (!1 === $ec2fc4c0d7a3c6c6$var$isSameRouteLocationParamsValue(e[o], t[o])) return !1;
    return !0;
}
const $ec2fc4c0d7a3c6c6$var$useRouterLinkProps = {
    to: [
        String,
        Object
    ],
    replace: Boolean,
    exact: Boolean,
    activeClass: {
        type: String,
        default: "q-router-link--active"
    },
    exactActiveClass: {
        type: String,
        default: "q-router-link--exact-active"
    },
    href: String,
    target: String,
    disable: Boolean
};
function $ec2fc4c0d7a3c6c6$var$useRouterLink({ fallbackTag: e, useDisableForRouterLinkProps: t = !0 } = {}) {
    const o = (0, $TusQn.getCurrentInstance)(), { props: n, proxy: a, emit: l } = o, i = $ec2fc4c0d7a3c6c6$var$vmHasRouter(o), r = (0, $TusQn.computed)(()=>!0 !== n.disable && void 0 !== n.href), s = (0, $TusQn.computed)(!0 === t ? ()=>!0 === i && !0 !== n.disable && !0 !== r.value && void 0 !== n.to && null !== n.to && "" !== n.to : ()=>!0 === i && !0 !== r.value && void 0 !== n.to && null !== n.to && "" !== n.to), u = (0, $TusQn.computed)(()=>!0 === s.value ? b(n.to) : null), c = (0, $TusQn.computed)(()=>null !== u.value), d = (0, $TusQn.computed)(()=>!0 === r.value || !0 === c.value), p = (0, $TusQn.computed)(()=>"a" === n.type || !0 === d.value ? "a" : n.tag || e || "div"), v = (0, $TusQn.computed)(()=>!0 === r.value ? {
            href: n.href,
            target: n.target
        } : !0 === c.value ? {
            href: u.value.href,
            target: n.target
        } : {}), m = (0, $TusQn.computed)(()=>{
        if (!1 === c.value) return -1;
        const { matched: e } = u.value, { length: t } = e, o = e[t - 1];
        if (void 0 === o) return -1;
        const n = a.$route.matched;
        if (0 === n.length) return -1;
        const l = n.findIndex($ec2fc4c0d7a3c6c6$var$isSameRouteRecord.bind(null, o));
        if (l > -1) return l;
        const i = $ec2fc4c0d7a3c6c6$var$getOriginalPath(e[t - 2]);
        return t > 1 && $ec2fc4c0d7a3c6c6$var$getOriginalPath(o) === i && n[n.length - 1].path !== i ? n.findIndex($ec2fc4c0d7a3c6c6$var$isSameRouteRecord.bind(null, e[t - 2])) : l;
    }), f = (0, $TusQn.computed)(()=>!0 === c.value && -1 !== m.value && $ec2fc4c0d7a3c6c6$var$includesParams(a.$route.params, u.value.params)), h = (0, $TusQn.computed)(()=>!0 === f.value && m.value === a.$route.matched.length - 1 && $ec2fc4c0d7a3c6c6$var$isSameRouteLocationParams(a.$route.params, u.value.params)), g = (0, $TusQn.computed)(()=>!0 === c.value ? !0 === h.value ? ` ${n.exactActiveClass} ${n.activeClass}` : !0 === n.exact ? "" : !0 === f.value ? ` ${n.activeClass}` : "" : "");
    function b(e) {
        try {
            return a.$router.resolve(e);
        } catch (e) {}
        return null;
    }
    function y(e, { returnRouterError: t, to: o = n.to, replace: l = n.replace } = {}) {
        if (!0 === n.disable) return e.preventDefault(), Promise.resolve(!1);
        if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || void 0 !== e.button && 0 !== e.button || "_blank" === n.target) return Promise.resolve(!1);
        e.preventDefault();
        const i = a.$router[!0 === l ? "replace" : "push"](o);
        return !0 === t ? i : i.then(()=>{}).catch(()=>{});
    }
    function S(e) {
        if (!0 === c.value) {
            const t = (t)=>y(e, t);
            l("click", e, t), !0 !== e.defaultPrevented && t();
        } else l("click", e);
    }
    return {
        hasRouterLink: c,
        hasHrefLink: r,
        hasLink: d,
        linkTag: p,
        resolvedLink: u,
        linkIsActive: f,
        linkIsExactActive: h,
        linkClass: g,
        linkAttrs: v,
        getLink: b,
        navigateToRouterLink: y,
        navigateOnClick: S
    };
}
var $ec2fc4c0d7a3c6c6$export$488745943e252354 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBreadcrumbsEl",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useRouterLinkProps,
        label: String,
        icon: String,
        tag: {
            type: String,
            default: "span"
        }
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t }) {
        const { linkTag: o, linkAttrs: n, linkClass: a, navigateOnClick: l } = $ec2fc4c0d7a3c6c6$var$useRouterLink(), i = (0, $TusQn.computed)(()=>{
            return {
                class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (!0 !== e.disable ? "q-link--focusable" + a.value : "q-breadcrumbs__el--disable"),
                ...n.value,
                onClick: l
            };
        }), r = (0, $TusQn.computed)(()=>"q-breadcrumbs__el-icon" + (void 0 !== e.label ? " q-breadcrumbs__el-icon--with-label" : ""));
        return ()=>{
            const n = [];
            return void 0 !== e.icon && n.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: r.value,
                name: e.icon
            })), void 0 !== e.label && n.push(e.label), (0, $TusQn.h)(o.value, {
                ...i.value
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, n));
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$useSpinnerProps = {
    size: {
        type: [
            Number,
            String
        ],
        default: "1em"
    },
    color: String
};
function $ec2fc4c0d7a3c6c6$var$useSpinner(e) {
    return {
        cSize: (0, $TusQn.computed)(()=>e.size in $ec2fc4c0d7a3c6c6$var$useSizeDefaults ? `${$ec2fc4c0d7a3c6c6$var$useSizeDefaults[e.size]}px` : e.size),
        classes: (0, $TusQn.computed)(()=>"q-spinner" + (e.color ? ` text-${e.color}` : ""))
    };
}
var $ec2fc4c0d7a3c6c6$export$7418ab329b11fed0 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinner",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useSpinnerProps,
        thickness: {
            type: Number,
            default: 5
        }
    },
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value + " q-spinner-mat",
                width: t.value,
                height: t.value,
                viewBox: "25 25 50 50"
            }, [
                (0, $TusQn.h)("circle", {
                    class: "path",
                    cx: "50",
                    cy: "50",
                    r: "20",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": e.thickness,
                    "stroke-miterlimit": "10"
                })
            ]);
    }
});
function $ec2fc4c0d7a3c6c6$var$offset(e) {
    if (e === window) return {
        top: 0,
        left: 0
    };
    const { top: t, left: o } = e.getBoundingClientRect();
    return {
        top: t,
        left: o
    };
}
function $ec2fc4c0d7a3c6c6$var$style(e, t) {
    return window.getComputedStyle(e).getPropertyValue(t);
}
function $ec2fc4c0d7a3c6c6$var$height(e) {
    return e === window ? window.innerHeight : e.getBoundingClientRect().height;
}
function $ec2fc4c0d7a3c6c6$var$width$1(e) {
    return e === window ? window.innerWidth : e.getBoundingClientRect().width;
}
function $ec2fc4c0d7a3c6c6$var$css(e, t) {
    const o = e.style;
    for(const n in t)o[n] = t[n];
}
function $ec2fc4c0d7a3c6c6$var$cssBatch(e, t) {
    e.forEach((e)=>$ec2fc4c0d7a3c6c6$var$css(e, t));
}
function $ec2fc4c0d7a3c6c6$var$ready(e) {
    if ("function" === typeof e) return "loading" !== document.readyState ? e() : void document.addEventListener("DOMContentLoaded", e, !1);
}
function $ec2fc4c0d7a3c6c6$var$getElement$1(e) {
    if (void 0 === e || null === e) return;
    if ("string" === typeof e) try {
        return document.querySelector(e) || void 0;
    } catch (e) {
        return;
    }
    const t = (0, $01W3b.unref)(e);
    return t ? t.$el || t : void 0;
}
function $ec2fc4c0d7a3c6c6$var$childHasFocus(e, t) {
    if (void 0 === e || null === e || !0 === e.contains(t)) return !0;
    for(let o = e.nextElementSibling; null !== o; o = o.nextElementSibling)if (o.contains(t)) return !0;
    return !1;
}
var $ec2fc4c0d7a3c6c6$export$df3a06d6289f983e = {
    offset: $ec2fc4c0d7a3c6c6$var$offset,
    style: $ec2fc4c0d7a3c6c6$var$style,
    height: $ec2fc4c0d7a3c6c6$var$height,
    width: $ec2fc4c0d7a3c6c6$var$width$1,
    css: $ec2fc4c0d7a3c6c6$var$css,
    cssBatch: $ec2fc4c0d7a3c6c6$var$cssBatch,
    ready: $ec2fc4c0d7a3c6c6$var$ready
};
function $ec2fc4c0d7a3c6c6$export$de363e709c412c8a(e, t = 250) {
    let o, n = !1;
    return function() {
        return !1 === n && (n = !0, setTimeout(()=>{
            n = !1;
        }, t), o = e.apply(this, arguments)), o;
    };
}
function $ec2fc4c0d7a3c6c6$var$showRipple(e, t, o, n) {
    !0 === o.modifiers.stop && $ec2fc4c0d7a3c6c6$var$stop(e);
    const a = o.modifiers.color;
    let l = o.modifiers.center;
    l = !0 === l || !0 === n;
    const i = document.createElement("span"), r = document.createElement("span"), s = $ec2fc4c0d7a3c6c6$var$position(e), { left: u, top: c, width: d, height: p } = t.getBoundingClientRect(), v = Math.sqrt(d * d + p * p), m = v / 2, f = `${(d - v) / 2}px`, h = l ? f : `${s.left - u - m}px`, g = `${(p - v) / 2}px`, b = l ? g : `${s.top - c - m}px`;
    r.className = "q-ripple__inner", $ec2fc4c0d7a3c6c6$var$css(r, {
        height: `${v}px`,
        width: `${v}px`,
        transform: `translate3d(${h},${b},0) scale3d(.2,.2,1)`,
        opacity: 0
    }), i.className = `q-ripple${a ? " text-" + a : ""}`, i.setAttribute("dir", "ltr"), i.appendChild(r), t.appendChild(i);
    const y = ()=>{
        i.remove(), clearTimeout(S);
    };
    o.abort.push(y);
    let S = setTimeout(()=>{
        r.classList.add("q-ripple__inner--enter"), r.style.transform = `translate3d(${f},${g},0) scale3d(1,1,1)`, r.style.opacity = .2, S = setTimeout(()=>{
            r.classList.remove("q-ripple__inner--enter"), r.classList.add("q-ripple__inner--leave"), r.style.opacity = 0, S = setTimeout(()=>{
                i.remove(), o.abort.splice(o.abort.indexOf(y), 1);
            }, 275);
        }, 250);
    }, 50);
}
function $ec2fc4c0d7a3c6c6$var$updateModifiers$1(e, { modifiers: t, value: o, arg: n }) {
    const a = Object.assign({}, e.cfg.ripple, t, o);
    e.modifiers = {
        early: !0 === a.early,
        stop: !0 === a.stop,
        center: !0 === a.center,
        color: a.color || n,
        keyCodes: [].concat(a.keyCodes || 13)
    };
}
var $ec2fc4c0d7a3c6c6$export$9e9146f7e027fdaa = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "ripple",
    beforeMount (e, t) {
        const o = t.instance.$.appContext.config.globalProperties.$q.config || {};
        if (!1 === o.ripple) return;
        const n = {
            cfg: o,
            enabled: !1 !== t.value,
            modifiers: {},
            abort: [],
            start (t) {
                !0 === n.enabled && !0 !== t.qSkipRipple && t.type === (!0 === n.modifiers.early ? "pointerdown" : "click") && $ec2fc4c0d7a3c6c6$var$showRipple(t, e, n, !0 === t.qKeyEvent);
            },
            keystart: $ec2fc4c0d7a3c6c6$export$de363e709c412c8a((t)=>{
                !0 === n.enabled && !0 !== t.qSkipRipple && !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(t, n.modifiers.keyCodes) && t.type === `key${!0 === n.modifiers.early ? "down" : "up"}` && $ec2fc4c0d7a3c6c6$var$showRipple(t, e, n, !0);
            }, 300)
        };
        $ec2fc4c0d7a3c6c6$var$updateModifiers$1(n, t), e.__qripple = n, $ec2fc4c0d7a3c6c6$var$addEvt(n, "main", [
            [
                e,
                "pointerdown",
                "start",
                "passive"
            ],
            [
                e,
                "click",
                "start",
                "passive"
            ],
            [
                e,
                "keydown",
                "keystart",
                "passive"
            ],
            [
                e,
                "keyup",
                "keystart",
                "passive"
            ]
        ]);
    },
    updated (e, t) {
        if (t.oldValue !== t.value) {
            const o = e.__qripple;
            void 0 !== o && (o.enabled = !1 !== t.value, !0 === o.enabled && Object(t.value) === t.value && $ec2fc4c0d7a3c6c6$var$updateModifiers$1(o, t));
        }
    },
    beforeUnmount (e) {
        const t = e.__qripple;
        void 0 !== t && (t.abort.forEach((e)=>{
            e();
        }), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "main"), delete e._qripple);
    }
});
const $ec2fc4c0d7a3c6c6$var$btnPadding = {
    none: 0,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
}, $ec2fc4c0d7a3c6c6$var$defaultSizes$2 = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
}, $ec2fc4c0d7a3c6c6$var$formTypes = [
    "button",
    "submit",
    "reset"
], $ec2fc4c0d7a3c6c6$var$mediaTypeRE = /[^\s]\/[^\s]/, $ec2fc4c0d7a3c6c6$var$btnDesignOptions = [
    "flat",
    "outline",
    "push",
    "unelevated"
], $ec2fc4c0d7a3c6c6$var$getBtnDesign = (e, t)=>{
    return !0 === e.flat ? "flat" : !0 === e.outline ? "outline" : !0 === e.push ? "push" : !0 === e.unelevated ? "unelevated" : t;
}, $ec2fc4c0d7a3c6c6$var$getBtnDesignAttr = (e)=>{
    const t = $ec2fc4c0d7a3c6c6$var$getBtnDesign(e);
    return void 0 !== t ? {
        [t]: !0
    } : {};
}, $ec2fc4c0d7a3c6c6$var$useBtnProps = {
    ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
    ...$ec2fc4c0d7a3c6c6$var$useRouterLinkProps,
    type: {
        type: String,
        default: "button"
    },
    label: [
        Number,
        String
    ],
    icon: String,
    iconRight: String,
    ...$ec2fc4c0d7a3c6c6$var$btnDesignOptions.reduce((e, t)=>(e[t] = Boolean) && e, {}),
    square: Boolean,
    round: Boolean,
    rounded: Boolean,
    glossy: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    padding: String,
    color: String,
    textColor: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    tabindex: [
        Number,
        String
    ],
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    },
    align: {
        ...$ec2fc4c0d7a3c6c6$var$useAlignProps.align,
        default: "center"
    },
    stack: Boolean,
    stretch: Boolean,
    loading: {
        type: Boolean,
        default: null
    },
    disable: Boolean
};
function $ec2fc4c0d7a3c6c6$var$useBtn(e) {
    const t = $ec2fc4c0d7a3c6c6$var$useSize(e, $ec2fc4c0d7a3c6c6$var$defaultSizes$2), o = $ec2fc4c0d7a3c6c6$var$useAlign(e), { hasRouterLink: n, hasLink: a, linkTag: l, linkAttrs: i, navigateOnClick: r } = $ec2fc4c0d7a3c6c6$var$useRouterLink({
        fallbackTag: "button"
    }), s = (0, $TusQn.computed)(()=>{
        const o = !1 === e.fab && !1 === e.fabMini ? t.value : {};
        return void 0 !== e.padding ? Object.assign({}, o, {
            padding: e.padding.split(/\s+/).map((e)=>e in $ec2fc4c0d7a3c6c6$var$btnPadding ? $ec2fc4c0d7a3c6c6$var$btnPadding[e] + "px" : e).join(" "),
            minWidth: "0",
            minHeight: "0"
        }) : o;
    }), u = (0, $TusQn.computed)(()=>!0 === e.rounded || !0 === e.fab || !0 === e.fabMini), c = (0, $TusQn.computed)(()=>!0 !== e.disable && !0 !== e.loading), d = (0, $TusQn.computed)(()=>!0 === c.value ? e.tabindex || 0 : -1), p = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBtnDesign(e, "standard")), v = (0, $TusQn.computed)(()=>{
        const t = {
            tabindex: d.value
        };
        return !0 === a.value ? Object.assign(t, i.value) : !0 === $ec2fc4c0d7a3c6c6$var$formTypes.includes(e.type) && (t.type = e.type), "a" === l.value ? (!0 === e.disable ? t["aria-disabled"] = "true" : void 0 === t.href && (t.role = "button"), !0 !== n.value && !0 === $ec2fc4c0d7a3c6c6$var$mediaTypeRE.test(e.type) && (t.type = e.type)) : !0 === e.disable && (t.disabled = "", t["aria-disabled"] = "true"), !0 === e.loading && void 0 !== e.percentage && Object.assign(t, {
            role: "progressbar",
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.percentage
        }), t;
    }), m = (0, $TusQn.computed)(()=>{
        let t;
        void 0 !== e.color ? t = !0 === e.flat || !0 === e.outline ? `text-${e.textColor || e.color}` : `bg-${e.color} text-${e.textColor || "white"}` : e.textColor && (t = `text-${e.textColor}`);
        const o = !0 === e.round ? "round" : `rectangle${!0 === u.value ? " q-btn--rounded" : !0 === e.square ? " q-btn--square" : ""}`;
        return `q-btn--${p.value} q-btn--${o}` + (void 0 !== t ? " " + t : "") + (!0 === c.value ? " q-btn--actionable q-focusable q-hoverable" : !0 === e.disable ? " disabled" : "") + (!0 === e.fab ? " q-btn--fab" : !0 === e.fabMini ? " q-btn--fab-mini" : "") + (!0 === e.noCaps ? " q-btn--no-uppercase" : "") + (!0 === e.dense ? " q-btn--dense" : "") + (!0 === e.stretch ? " no-border-radius self-stretch" : "") + (!0 === e.glossy ? " glossy" : "") + (e.square ? " q-btn--square" : "");
    }), f = (0, $TusQn.computed)(()=>o.value + (!0 === e.stack ? " column" : " row") + (!0 === e.noWrap ? " no-wrap text-no-wrap" : "") + (!0 === e.loading ? " q-btn__content--hidden" : ""));
    return {
        classes: m,
        style: s,
        innerClasses: f,
        attributes: v,
        hasLink: a,
        linkTag: l,
        navigateOnClick: r,
        isActionable: c
    };
}
const { passiveCapture: $ec2fc4c0d7a3c6c6$var$passiveCapture } = $ec2fc4c0d7a3c6c6$var$listenOpts;
let $ec2fc4c0d7a3c6c6$var$touchTarget = null, $ec2fc4c0d7a3c6c6$var$keyboardTarget = null, $ec2fc4c0d7a3c6c6$var$mouseTarget = null;
var $ec2fc4c0d7a3c6c6$export$72abad9388e88b7 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBtn",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useBtnProps,
        percentage: Number,
        darkPercentage: Boolean,
        onTouchstart: [
            Function,
            Array
        ]
    },
    emits: [
        "click",
        "keydown",
        "mousedown",
        "keyup"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { classes: a, style: l, innerClasses: i, attributes: r, hasLink: s, linkTag: u, navigateOnClick: c, isActionable: d } = $ec2fc4c0d7a3c6c6$var$useBtn(e), p = (0, $01W3b.ref)(null), v = (0, $01W3b.ref)(null);
        let m, f = null, g = null;
        const b = (0, $TusQn.computed)(()=>void 0 !== e.label && null !== e.label && "" !== e.label), y = (0, $TusQn.computed)(()=>!0 !== e.disable && !1 !== e.ripple && {
                keyCodes: !0 === s.value ? [
                    13,
                    32
                ] : [
                    13
                ],
                ...!0 === e.ripple ? {} : e.ripple
            }), S = (0, $TusQn.computed)(()=>({
                center: e.round
            })), w = (0, $TusQn.computed)(()=>{
            const t = Math.max(0, Math.min(100, e.percentage));
            return t > 0 ? {
                transition: "transform 0.6s",
                transform: `translateX(${t - 100}%)`
            } : {};
        }), C = (0, $TusQn.computed)(()=>{
            if (!0 === e.loading) return {
                onMousedown: M,
                onTouchstart: M,
                onClick: M,
                onKeydown: M,
                onKeyup: M
            };
            if (!0 === d.value) {
                const t = {
                    onClick: k,
                    onKeydown: _,
                    onMousedown: T
                };
                if (!0 === n.$q.platform.has.touch) {
                    const o = void 0 !== e.onTouchstart ? "" : "Passive";
                    t[`onTouchstart${o}`] = q;
                }
                return t;
            }
            return {
                onClick: $ec2fc4c0d7a3c6c6$var$stopAndPrevent
            };
        }), x = (0, $TusQn.computed)(()=>({
                ref: p,
                class: "q-btn q-btn-item non-selectable no-outline " + a.value,
                style: l.value,
                ...r.value,
                ...C.value
            }));
        function k(t) {
            if (null !== p.value) {
                if (void 0 !== t) {
                    if (!0 === t.defaultPrevented) return;
                    const o = document.activeElement;
                    if ("submit" === e.type && o !== document.body && !1 === p.value.contains(o) && !1 === o.contains(p.value)) {
                        p.value.focus();
                        const e = ()=>{
                            document.removeEventListener("keydown", $ec2fc4c0d7a3c6c6$var$stopAndPrevent, !0), document.removeEventListener("keyup", e, $ec2fc4c0d7a3c6c6$var$passiveCapture), null !== p.value && p.value.removeEventListener("blur", e, $ec2fc4c0d7a3c6c6$var$passiveCapture);
                        };
                        document.addEventListener("keydown", $ec2fc4c0d7a3c6c6$var$stopAndPrevent, !0), document.addEventListener("keyup", e, $ec2fc4c0d7a3c6c6$var$passiveCapture), p.value.addEventListener("blur", e, $ec2fc4c0d7a3c6c6$var$passiveCapture);
                    }
                }
                c(t);
            }
        }
        function _(e) {
            null !== p.value && (o("keydown", e), !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, [
                13,
                32
            ]) && $ec2fc4c0d7a3c6c6$var$keyboardTarget !== p.value && (null !== $ec2fc4c0d7a3c6c6$var$keyboardTarget && $(), !0 !== e.defaultPrevented && (p.value.focus(), $ec2fc4c0d7a3c6c6$var$keyboardTarget = p.value, p.value.classList.add("q-btn--active"), document.addEventListener("keyup", P, !0), p.value.addEventListener("blur", P, $ec2fc4c0d7a3c6c6$var$passiveCapture)), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e)));
        }
        function q(e) {
            null !== p.value && (o("touchstart", e), !0 !== e.defaultPrevented && ($ec2fc4c0d7a3c6c6$var$touchTarget !== p.value && (null !== $ec2fc4c0d7a3c6c6$var$touchTarget && $(), $ec2fc4c0d7a3c6c6$var$touchTarget = p.value, f = e.target, f.addEventListener("touchcancel", P, $ec2fc4c0d7a3c6c6$var$passiveCapture), f.addEventListener("touchend", P, $ec2fc4c0d7a3c6c6$var$passiveCapture)), m = !0, null !== g && clearTimeout(g), g = setTimeout(()=>{
                g = null, m = !1;
            }, 200)));
        }
        function T(e) {
            null !== p.value && (e.qSkipRipple = !0 === m, o("mousedown", e), !0 !== e.defaultPrevented && $ec2fc4c0d7a3c6c6$var$mouseTarget !== p.value && (null !== $ec2fc4c0d7a3c6c6$var$mouseTarget && $(), $ec2fc4c0d7a3c6c6$var$mouseTarget = p.value, p.value.classList.add("q-btn--active"), document.addEventListener("mouseup", P, $ec2fc4c0d7a3c6c6$var$passiveCapture)));
        }
        function P(e) {
            if (null !== p.value && (void 0 === e || "blur" !== e.type || document.activeElement !== p.value)) {
                if (void 0 !== e && "keyup" === e.type) {
                    if ($ec2fc4c0d7a3c6c6$var$keyboardTarget === p.value && !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, [
                        13,
                        32
                    ])) {
                        const t = new MouseEvent("click", e);
                        t.qKeyEvent = !0, !0 === e.defaultPrevented && $ec2fc4c0d7a3c6c6$var$prevent(t), !0 === e.cancelBubble && $ec2fc4c0d7a3c6c6$var$stop(t), p.value.dispatchEvent(t), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), e.qKeyEvent = !0;
                    }
                    o("keyup", e);
                }
                $();
            }
        }
        function $(e) {
            const t = v.value;
            !0 === e || $ec2fc4c0d7a3c6c6$var$touchTarget !== p.value && $ec2fc4c0d7a3c6c6$var$mouseTarget !== p.value || null === t || t === document.activeElement || (t.setAttribute("tabindex", -1), t.focus()), $ec2fc4c0d7a3c6c6$var$touchTarget === p.value && (null !== f && (f.removeEventListener("touchcancel", P, $ec2fc4c0d7a3c6c6$var$passiveCapture), f.removeEventListener("touchend", P, $ec2fc4c0d7a3c6c6$var$passiveCapture)), $ec2fc4c0d7a3c6c6$var$touchTarget = f = null), $ec2fc4c0d7a3c6c6$var$mouseTarget === p.value && (document.removeEventListener("mouseup", P, $ec2fc4c0d7a3c6c6$var$passiveCapture), $ec2fc4c0d7a3c6c6$var$mouseTarget = null), $ec2fc4c0d7a3c6c6$var$keyboardTarget === p.value && (document.removeEventListener("keyup", P, !0), null !== p.value && p.value.removeEventListener("blur", P, $ec2fc4c0d7a3c6c6$var$passiveCapture), $ec2fc4c0d7a3c6c6$var$keyboardTarget = null), null !== p.value && p.value.classList.remove("q-btn--active");
        }
        function M(e) {
            $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), e.qSkipRipple = !0;
        }
        return (0, $TusQn.onBeforeUnmount)(()=>{
            $(!0);
        }), Object.assign(n, {
            click: k
        }), ()=>{
            let o = [];
            void 0 !== e.icon && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                name: e.icon,
                left: !1 === e.stack && !0 === b.value,
                role: "img",
                "aria-hidden": "true"
            })), !0 === b.value && o.push((0, $TusQn.h)("span", {
                class: "block"
            }, [
                e.label
            ])), o = $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, o), void 0 !== e.iconRight && !1 === e.round && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                name: e.iconRight,
                right: !1 === e.stack && !0 === b.value,
                role: "img",
                "aria-hidden": "true"
            }));
            const n = [
                (0, $TusQn.h)("span", {
                    class: "q-focus-helper",
                    ref: v
                })
            ];
            return !0 === e.loading && void 0 !== e.percentage && n.push((0, $TusQn.h)("span", {
                class: "q-btn__progress absolute-full overflow-hidden" + (!0 === e.darkPercentage ? " q-btn__progress--dark" : "")
            }, [
                (0, $TusQn.h)("span", {
                    class: "q-btn__progress-indicator fit block",
                    style: w.value
                })
            ])), n.push((0, $TusQn.h)("span", {
                class: "q-btn__content text-center col items-center q-anchor--skip " + i.value
            }, o)), null !== e.loading && n.push((0, $TusQn.h)((0, $eeJ70.Transition), {
                name: "q-transition--fade"
            }, ()=>!0 === e.loading ? [
                    (0, $TusQn.h)("span", {
                        key: "loading",
                        class: "absolute-full flex flex-center"
                    }, void 0 !== t.loading ? t.loading() : [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0)
                    ])
                ] : null)), (0, $TusQn.withDirectives)((0, $TusQn.h)(u.value, x.value, n), [
                [
                    $ec2fc4c0d7a3c6c6$export$9e9146f7e027fdaa,
                    y.value,
                    void 0,
                    S.value
                ]
            ]);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$ec40a025a653c83b = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBtnGroup",
    props: {
        unelevated: Boolean,
        outline: Boolean,
        flat: Boolean,
        rounded: Boolean,
        square: Boolean,
        push: Boolean,
        stretch: Boolean,
        glossy: Boolean,
        spread: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>{
            const t = [
                "unelevated",
                "outline",
                "flat",
                "rounded",
                "square",
                "push",
                "stretch",
                "glossy"
            ].filter((t)=>!0 === e[t]).map((e)=>`q-btn-group--${e}`).join(" ");
            return `q-btn-group row no-wrap${0 !== t.length ? " " + t : ""}` + (!0 === e.spread ? " q-btn-group--spread" : " inline");
        });
        return ()=>(0, $TusQn.h)("div", {
                class: o.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
function $ec2fc4c0d7a3c6c6$var$clearSelection() {
    if (void 0 !== window.getSelection) {
        const e = window.getSelection();
        void 0 !== e.empty ? e.empty() : void 0 !== e.removeAllRanges && (e.removeAllRanges(), !0 !== $ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389.is.mobile && e.addRange(document.createRange()));
    } else void 0 !== document.selection && document.selection.empty();
}
const $ec2fc4c0d7a3c6c6$var$useAnchorProps = {
    target: {
        default: !0
    },
    noParentEvent: Boolean,
    contextMenu: Boolean
};
function $ec2fc4c0d7a3c6c6$var$useAnchor({ showing: e, avoidEmit: t, configureAnchorEl: o }) {
    const { props: n, proxy: a, emit: l } = (0, $TusQn.getCurrentInstance)(), i = (0, $01W3b.ref)(null);
    let r = null;
    function s(e) {
        return null !== i.value && (void 0 === e || void 0 === e.touches || e.touches.length <= 1);
    }
    const u = {};
    function c() {
        $ec2fc4c0d7a3c6c6$var$cleanEvt(u, "anchor");
    }
    function d(e) {
        i.value = e;
        while(i.value.classList.contains("q-anchor--skip"))i.value = i.value.parentNode;
        o();
    }
    function p() {
        if (!1 === n.target || "" === n.target || null === a.$el.parentNode) i.value = null;
        else if (!0 === n.target) d(a.$el.parentNode);
        else {
            let e = n.target;
            if ("string" === typeof n.target) try {
                e = document.querySelector(n.target);
            } catch (t) {
                e = void 0;
            }
            void 0 !== e && null !== e ? (i.value = e.$el || e, o()) : (i.value = null, console.error(`Anchor: target "${n.target}" not found`));
        }
    }
    return void 0 === o && (Object.assign(u, {
        hide (e) {
            a.hide(e);
        },
        toggle (e) {
            a.toggle(e), e.qAnchorHandled = !0;
        },
        toggleKey (e) {
            !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, 13) && u.toggle(e);
        },
        contextClick (e) {
            a.hide(e), $ec2fc4c0d7a3c6c6$var$prevent(e), (0, $TusQn.nextTick)(()=>{
                a.show(e), e.qAnchorHandled = !0;
            });
        },
        prevent: $ec2fc4c0d7a3c6c6$var$prevent,
        mobileTouch (e) {
            if (u.mobileCleanup(e), !0 !== s(e)) return;
            a.hide(e), i.value.classList.add("non-selectable");
            const t = e.target;
            $ec2fc4c0d7a3c6c6$var$addEvt(u, "anchor", [
                [
                    t,
                    "touchmove",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    t,
                    "touchend",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    t,
                    "touchcancel",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    i.value,
                    "contextmenu",
                    "prevent",
                    "notPassive"
                ]
            ]), r = setTimeout(()=>{
                r = null, a.show(e), e.qAnchorHandled = !0;
            }, 300);
        },
        mobileCleanup (t) {
            i.value.classList.remove("non-selectable"), null !== r && (clearTimeout(r), r = null), !0 === e.value && void 0 !== t && $ec2fc4c0d7a3c6c6$var$clearSelection();
        }
    }), o = function(e = n.contextMenu) {
        if (!0 === n.noParentEvent || null === i.value) return;
        let t;
        t = !0 === e ? !0 === a.$q.platform.is.mobile ? [
            [
                i.value,
                "touchstart",
                "mobileTouch",
                "passive"
            ]
        ] : [
            [
                i.value,
                "mousedown",
                "hide",
                "passive"
            ],
            [
                i.value,
                "contextmenu",
                "contextClick",
                "notPassive"
            ]
        ] : [
            [
                i.value,
                "click",
                "toggle",
                "passive"
            ],
            [
                i.value,
                "keyup",
                "toggleKey",
                "passive"
            ]
        ], $ec2fc4c0d7a3c6c6$var$addEvt(u, "anchor", t);
    }), (0, $TusQn.watch)(()=>n.contextMenu, (e)=>{
        null !== i.value && (c(), o(e));
    }), (0, $TusQn.watch)(()=>n.target, ()=>{
        null !== i.value && c(), p();
    }), (0, $TusQn.watch)(()=>n.noParentEvent, (e)=>{
        null !== i.value && (!0 === e ? c() : o());
    }), (0, $TusQn.onMounted)(()=>{
        p(), !0 !== t && !0 === n.modelValue && null === i.value && l("update:modelValue", !1);
    }), (0, $TusQn.onBeforeUnmount)(()=>{
        null !== r && clearTimeout(r), c();
    }), {
        anchorEl: i,
        canShow: s,
        anchorEvents: u
    };
}
function $ec2fc4c0d7a3c6c6$var$useScrollTarget(e, t) {
    const o = (0, $01W3b.ref)(null);
    let n;
    function a(e, t) {
        const o = `${void 0 !== t ? "add" : "remove"}EventListener`, a = void 0 !== t ? t : n;
        e !== window && e[o]("scroll", a, $ec2fc4c0d7a3c6c6$var$listenOpts.passive), window[o]("scroll", a, $ec2fc4c0d7a3c6c6$var$listenOpts.passive), n = t;
    }
    function l() {
        null !== o.value && (a(o.value), o.value = null);
    }
    const i = (0, $TusQn.watch)(()=>e.noParentEvent, ()=>{
        null !== o.value && (l(), t());
    });
    return (0, $TusQn.onBeforeUnmount)(i), {
        localScrollTarget: o,
        unconfigureScrollTarget: l,
        changeScrollEvent: a
    };
}
const $ec2fc4c0d7a3c6c6$var$useModelToggleProps = {
    modelValue: {
        type: Boolean,
        default: null
    },
    "onUpdate:modelValue": [
        Function,
        Array
    ]
}, $ec2fc4c0d7a3c6c6$var$useModelToggleEmits = [
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
];
function $ec2fc4c0d7a3c6c6$var$useModelToggle({ showing: e, canShow: t, hideOnRouteChange: o, handleShow: n, handleHide: a, processOnMount: l }) {
    const i = (0, $TusQn.getCurrentInstance)(), { props: r, emit: s, proxy: u } = i;
    let c;
    function d(t) {
        !0 === e.value ? m(t) : p(t);
    }
    function p(e) {
        if (!0 === r.disable || void 0 !== e && !0 === e.qAnchorHandled || void 0 !== t && !0 !== t(e)) return;
        const o = void 0 !== r["onUpdate:modelValue"];
        !0 === o && (s("update:modelValue", !0), c = e, (0, $TusQn.nextTick)(()=>{
            c === e && (c = void 0);
        })), null !== r.modelValue && !1 !== o || v(e);
    }
    function v(t) {
        !0 !== e.value && (e.value = !0, s("beforeShow", t), void 0 !== n ? n(t) : s("show", t));
    }
    function m(e) {
        if (!0 === r.disable) return;
        const t = void 0 !== r["onUpdate:modelValue"];
        !0 === t && (s("update:modelValue", !1), c = e, (0, $TusQn.nextTick)(()=>{
            c === e && (c = void 0);
        })), null !== r.modelValue && !1 !== t || f(e);
    }
    function f(t) {
        !1 !== e.value && (e.value = !1, s("beforeHide", t), void 0 !== a ? a(t) : s("hide", t));
    }
    function h(t) {
        if (!0 === r.disable && !0 === t) void 0 !== r["onUpdate:modelValue"] && s("update:modelValue", !1);
        else if (!0 === t !== e.value) {
            const e = !0 === t ? v : f;
            e(c);
        }
    }
    (0, $TusQn.watch)(()=>r.modelValue, h), void 0 !== o && !0 === $ec2fc4c0d7a3c6c6$var$vmHasRouter(i) && (0, $TusQn.watch)(()=>u.$route.fullPath, ()=>{
        !0 === o.value && !0 === e.value && m();
    }), !0 === l && (0, $TusQn.onMounted)(()=>{
        h(r.modelValue);
    });
    const g = {
        show: p,
        hide: m,
        toggle: d
    };
    return Object.assign(u, g), g;
}
let $ec2fc4c0d7a3c6c6$var$queue = [], $ec2fc4c0d7a3c6c6$var$waitFlags = [];
function $ec2fc4c0d7a3c6c6$var$clearFlag(e) {
    $ec2fc4c0d7a3c6c6$var$waitFlags = $ec2fc4c0d7a3c6c6$var$waitFlags.filter((t)=>t !== e);
}
function $ec2fc4c0d7a3c6c6$var$addFocusWaitFlag(e) {
    $ec2fc4c0d7a3c6c6$var$clearFlag(e), $ec2fc4c0d7a3c6c6$var$waitFlags.push(e);
}
function $ec2fc4c0d7a3c6c6$var$removeFocusWaitFlag(e) {
    $ec2fc4c0d7a3c6c6$var$clearFlag(e), 0 === $ec2fc4c0d7a3c6c6$var$waitFlags.length && 0 !== $ec2fc4c0d7a3c6c6$var$queue.length && ($ec2fc4c0d7a3c6c6$var$queue[$ec2fc4c0d7a3c6c6$var$queue.length - 1](), $ec2fc4c0d7a3c6c6$var$queue = []);
}
function $ec2fc4c0d7a3c6c6$var$addFocusFn(e) {
    0 === $ec2fc4c0d7a3c6c6$var$waitFlags.length ? e() : $ec2fc4c0d7a3c6c6$var$queue.push(e);
}
function $ec2fc4c0d7a3c6c6$var$removeFocusFn(e) {
    $ec2fc4c0d7a3c6c6$var$queue = $ec2fc4c0d7a3c6c6$var$queue.filter((t)=>t !== e);
}
const $ec2fc4c0d7a3c6c6$var$nodesList = [], $ec2fc4c0d7a3c6c6$var$portalTypeList = [];
let $ec2fc4c0d7a3c6c6$var$portalIndex = 1, $ec2fc4c0d7a3c6c6$var$target = document.body;
function $ec2fc4c0d7a3c6c6$var$createGlobalNode(e, t) {
    const o = document.createElement("div");
    if (o.id = void 0 !== t ? `q-portal--${t}--${$ec2fc4c0d7a3c6c6$var$portalIndex++}` : e, void 0 !== $ec2fc4c0d7a3c6c6$var$globalConfig.globalNodes) {
        const e = $ec2fc4c0d7a3c6c6$var$globalConfig.globalNodes.class;
        void 0 !== e && (o.className = e);
    }
    return $ec2fc4c0d7a3c6c6$var$target.appendChild(o), $ec2fc4c0d7a3c6c6$var$nodesList.push(o), $ec2fc4c0d7a3c6c6$var$portalTypeList.push(t), o;
}
function $ec2fc4c0d7a3c6c6$var$removeGlobalNode(e) {
    const t = $ec2fc4c0d7a3c6c6$var$nodesList.indexOf(e);
    $ec2fc4c0d7a3c6c6$var$nodesList.splice(t, 1), $ec2fc4c0d7a3c6c6$var$portalTypeList.splice(t, 1), e.remove();
}
function $ec2fc4c0d7a3c6c6$var$changeGlobalNodesTarget(e) {
    if (e === $ec2fc4c0d7a3c6c6$var$target) return;
    if ($ec2fc4c0d7a3c6c6$var$target = e, $ec2fc4c0d7a3c6c6$var$target === document.body || $ec2fc4c0d7a3c6c6$var$portalTypeList.reduce((e, t)=>"dialog" === t ? e + 1 : e, 0) < 2) return void $ec2fc4c0d7a3c6c6$var$nodesList.forEach((e)=>{
        !1 === e.contains($ec2fc4c0d7a3c6c6$var$target) && $ec2fc4c0d7a3c6c6$var$target.appendChild(e);
    });
    const t = $ec2fc4c0d7a3c6c6$var$portalTypeList.lastIndexOf("dialog");
    for(let o = 0; o < $ec2fc4c0d7a3c6c6$var$nodesList.length; o++){
        const e = $ec2fc4c0d7a3c6c6$var$nodesList[o];
        o !== t && "dialog" === $ec2fc4c0d7a3c6c6$var$portalTypeList[o] || !1 !== e.contains($ec2fc4c0d7a3c6c6$var$target) || $ec2fc4c0d7a3c6c6$var$target.appendChild(e);
    }
}
const $ec2fc4c0d7a3c6c6$var$portalProxyList = [];
function $ec2fc4c0d7a3c6c6$var$getPortalProxy(e) {
    return $ec2fc4c0d7a3c6c6$var$portalProxyList.find((t)=>null !== t.contentEl && t.contentEl.contains(e));
}
function $ec2fc4c0d7a3c6c6$var$closePortalMenus(e, t) {
    do {
        if ("QMenu" === e.$options.name) {
            if (e.hide(t), !0 === e.$props.separateClosePopup) return $ec2fc4c0d7a3c6c6$var$getParentProxy(e);
        } else if (!0 === e.__qPortal) {
            const o = $ec2fc4c0d7a3c6c6$var$getParentProxy(e);
            return void 0 !== o && "QPopupProxy" === o.$options.name ? (e.hide(t), o) : e;
        }
        e = $ec2fc4c0d7a3c6c6$var$getParentProxy(e);
    }while (void 0 !== e && null !== e);
}
function $ec2fc4c0d7a3c6c6$var$closePortals(e, t, o) {
    while(0 !== o && void 0 !== e && null !== e){
        if (!0 === e.__qPortal) {
            if (o--, "QMenu" === e.$options.name) {
                e = $ec2fc4c0d7a3c6c6$var$closePortalMenus(e, t);
                continue;
            }
            e.hide(t);
        }
        e = $ec2fc4c0d7a3c6c6$var$getParentProxy(e);
    }
}
function $ec2fc4c0d7a3c6c6$var$isOnGlobalDialog(e) {
    e = e.parent;
    while(void 0 !== e && null !== e){
        if ("QGlobalDialog" === e.type.name) return !0;
        if ("QDialog" === e.type.name || "QMenu" === e.type.name) return !1;
        e = e.parent;
    }
    return !1;
}
function $ec2fc4c0d7a3c6c6$var$usePortal(e, t, o, n) {
    const a = (0, $01W3b.ref)(!1), l = (0, $01W3b.ref)(!1);
    let i = null;
    const r = {}, s = "dialog" === n && $ec2fc4c0d7a3c6c6$var$isOnGlobalDialog(e);
    function u(t) {
        if (!0 === t) return $ec2fc4c0d7a3c6c6$var$removeFocusWaitFlag(r), void (l.value = !0);
        l.value = !1, !1 === a.value && (!1 === s && null === i && (i = $ec2fc4c0d7a3c6c6$var$createGlobalNode(!1, n)), a.value = !0, $ec2fc4c0d7a3c6c6$var$portalProxyList.push(e.proxy), $ec2fc4c0d7a3c6c6$var$addFocusWaitFlag(r));
    }
    function c(t) {
        if (l.value = !1, !0 !== t) return;
        $ec2fc4c0d7a3c6c6$var$removeFocusWaitFlag(r), a.value = !1;
        const o = $ec2fc4c0d7a3c6c6$var$portalProxyList.indexOf(e.proxy);
        -1 !== o && $ec2fc4c0d7a3c6c6$var$portalProxyList.splice(o, 1), null !== i && ($ec2fc4c0d7a3c6c6$var$removeGlobalNode(i), i = null);
    }
    return (0, $TusQn.onUnmounted)(()=>{
        c(!0);
    }), e.proxy.__qPortal = !0, $ec2fc4c0d7a3c6c6$var$injectProp(e.proxy, "contentEl", ()=>t.value), {
        showPortal: u,
        hidePortal: c,
        portalIsActive: a,
        portalIsAccessible: l,
        renderPortal: ()=>!0 === s ? o() : !0 === a.value ? [
                (0, $TusQn.h)((0, $TusQn.Teleport), {
                    to: i
                }, o())
            ] : void 0
    };
}
const $ec2fc4c0d7a3c6c6$var$useTransitionProps = {
    transitionShow: {
        type: String,
        default: "fade"
    },
    transitionHide: {
        type: String,
        default: "fade"
    },
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    }
};
function $ec2fc4c0d7a3c6c6$var$useTransition(e, t = ()=>{}, o = ()=>{}) {
    return {
        transitionProps: (0, $TusQn.computed)(()=>{
            const n = `q-transition--${e.transitionShow || t()}`, a = `q-transition--${e.transitionHide || o()}`;
            return {
                appear: !0,
                enterFromClass: `${n}-enter-from`,
                enterActiveClass: `${n}-enter-active`,
                enterToClass: `${n}-enter-to`,
                leaveFromClass: `${a}-leave-from`,
                leaveActiveClass: `${a}-leave-active`,
                leaveToClass: `${a}-leave-to`
            };
        }),
        transitionStyle: (0, $TusQn.computed)(()=>`--q-transition-duration: ${e.transitionDuration}ms`)
    };
}
function $ec2fc4c0d7a3c6c6$var$useTick() {
    let e;
    const t = (0, $TusQn.getCurrentInstance)();
    function o() {
        e = void 0;
    }
    return (0, $TusQn.onDeactivated)(o), (0, $TusQn.onBeforeUnmount)(o), {
        removeTick: o,
        registerTick (o) {
            e = o, (0, $TusQn.nextTick)(()=>{
                e === o && (!1 === $ec2fc4c0d7a3c6c6$var$vmIsDestroyed(t) && e(), e = void 0);
            });
        }
    };
}
function $ec2fc4c0d7a3c6c6$var$useTimeout() {
    let e = null;
    const t = (0, $TusQn.getCurrentInstance)();
    function o() {
        null !== e && (clearTimeout(e), e = null);
    }
    return (0, $TusQn.onDeactivated)(o), (0, $TusQn.onBeforeUnmount)(o), {
        removeTimeout: o,
        registerTimeout (n, a) {
            o(), !1 === $ec2fc4c0d7a3c6c6$var$vmIsDestroyed(t) && (e = setTimeout(n, a));
        }
    };
}
const $ec2fc4c0d7a3c6c6$var$scrollTargets = [
    null,
    document,
    document.body,
    document.scrollingElement,
    document.documentElement
];
function $ec2fc4c0d7a3c6c6$var$getScrollTarget(e, t) {
    let o = $ec2fc4c0d7a3c6c6$var$getElement$1(t);
    if (void 0 === o) {
        if (void 0 === e || null === e) return window;
        o = e.closest(".scroll,.scroll-y,.overflow-auto");
    }
    return $ec2fc4c0d7a3c6c6$var$scrollTargets.includes(o) ? window : o;
}
function $ec2fc4c0d7a3c6c6$var$getScrollHeight(e) {
    return (e === window ? document.body : e).scrollHeight;
}
function $ec2fc4c0d7a3c6c6$var$getScrollWidth(e) {
    return (e === window ? document.body : e).scrollWidth;
}
function $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(e) {
    return e === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : e.scrollTop;
}
function $ec2fc4c0d7a3c6c6$var$getHorizontalScrollPosition(e) {
    return e === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : e.scrollLeft;
}
function $ec2fc4c0d7a3c6c6$var$animVerticalScrollTo(e, t, o = 0) {
    const n = void 0 === arguments[3] ? performance.now() : arguments[3], a = $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(e);
    o <= 0 ? a !== t && $ec2fc4c0d7a3c6c6$var$setScroll$1(e, t) : requestAnimationFrame((l)=>{
        const i = l - n, r = a + (t - a) / Math.max(i, o) * i;
        $ec2fc4c0d7a3c6c6$var$setScroll$1(e, r), r !== t && $ec2fc4c0d7a3c6c6$var$animVerticalScrollTo(e, t, o - i, l);
    });
}
function $ec2fc4c0d7a3c6c6$var$animHorizontalScrollTo(e, t, o = 0) {
    const n = void 0 === arguments[3] ? performance.now() : arguments[3], a = $ec2fc4c0d7a3c6c6$var$getHorizontalScrollPosition(e);
    o <= 0 ? a !== t && $ec2fc4c0d7a3c6c6$var$setHorizontalScroll(e, t) : requestAnimationFrame((l)=>{
        const i = l - n, r = a + (t - a) / Math.max(i, o) * i;
        $ec2fc4c0d7a3c6c6$var$setHorizontalScroll(e, r), r !== t && $ec2fc4c0d7a3c6c6$var$animHorizontalScrollTo(e, t, o - i, l);
    });
}
function $ec2fc4c0d7a3c6c6$var$setScroll$1(e, t) {
    e !== window ? e.scrollTop = t : window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t);
}
function $ec2fc4c0d7a3c6c6$var$setHorizontalScroll(e, t) {
    e !== window ? e.scrollLeft = t : window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
}
function $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition(e, t, o) {
    o ? $ec2fc4c0d7a3c6c6$var$animVerticalScrollTo(e, t, o) : $ec2fc4c0d7a3c6c6$var$setScroll$1(e, t);
}
function $ec2fc4c0d7a3c6c6$var$setHorizontalScrollPosition(e, t, o) {
    o ? $ec2fc4c0d7a3c6c6$var$animHorizontalScrollTo(e, t, o) : $ec2fc4c0d7a3c6c6$var$setHorizontalScroll(e, t);
}
let $ec2fc4c0d7a3c6c6$var$size;
function $ec2fc4c0d7a3c6c6$var$getScrollbarWidth() {
    if (void 0 !== $ec2fc4c0d7a3c6c6$var$size) return $ec2fc4c0d7a3c6c6$var$size;
    const e = document.createElement("p"), t = document.createElement("div");
    $ec2fc4c0d7a3c6c6$var$css(e, {
        width: "100%",
        height: "200px"
    }), $ec2fc4c0d7a3c6c6$var$css(t, {
        position: "absolute",
        top: "0px",
        left: "0px",
        visibility: "hidden",
        width: "200px",
        height: "150px",
        overflow: "hidden"
    }), t.appendChild(e), document.body.appendChild(t);
    const o = e.offsetWidth;
    t.style.overflow = "scroll";
    let n = e.offsetWidth;
    return o === n && (n = t.clientWidth), t.remove(), $ec2fc4c0d7a3c6c6$var$size = o - n, $ec2fc4c0d7a3c6c6$var$size;
}
function $ec2fc4c0d7a3c6c6$var$hasScrollbar(e, t = !0) {
    return !(!e || e.nodeType !== Node.ELEMENT_NODE) && (t ? e.scrollHeight > e.clientHeight && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(e)["overflow-y"])) : e.scrollWidth > e.clientWidth && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(e)["overflow-x"])));
}
var $ec2fc4c0d7a3c6c6$export$209876d7b1ac8f3 = {
    getScrollTarget: $ec2fc4c0d7a3c6c6$var$getScrollTarget,
    getScrollHeight: $ec2fc4c0d7a3c6c6$var$getScrollHeight,
    getScrollWidth: $ec2fc4c0d7a3c6c6$var$getScrollWidth,
    getVerticalScrollPosition: $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition,
    getHorizontalScrollPosition: $ec2fc4c0d7a3c6c6$var$getHorizontalScrollPosition,
    animVerticalScrollTo: $ec2fc4c0d7a3c6c6$var$animVerticalScrollTo,
    animHorizontalScrollTo: $ec2fc4c0d7a3c6c6$var$animHorizontalScrollTo,
    setVerticalScrollPosition: $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition,
    setHorizontalScrollPosition: $ec2fc4c0d7a3c6c6$var$setHorizontalScrollPosition,
    getScrollbarWidth: $ec2fc4c0d7a3c6c6$var$getScrollbarWidth,
    hasScrollbar: $ec2fc4c0d7a3c6c6$var$hasScrollbar
};
const $ec2fc4c0d7a3c6c6$var$handlers$1 = [];
let $ec2fc4c0d7a3c6c6$var$escDown;
function $ec2fc4c0d7a3c6c6$var$onKeydown(e) {
    $ec2fc4c0d7a3c6c6$var$escDown = 27 === e.keyCode;
}
function $ec2fc4c0d7a3c6c6$var$onBlur() {
    !0 === $ec2fc4c0d7a3c6c6$var$escDown && ($ec2fc4c0d7a3c6c6$var$escDown = !1);
}
function $ec2fc4c0d7a3c6c6$var$onKeyup(e) {
    !0 === $ec2fc4c0d7a3c6c6$var$escDown && ($ec2fc4c0d7a3c6c6$var$escDown = !1, !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, 27) && $ec2fc4c0d7a3c6c6$var$handlers$1[$ec2fc4c0d7a3c6c6$var$handlers$1.length - 1](e));
}
function $ec2fc4c0d7a3c6c6$var$update$4(e) {
    window[e]("keydown", $ec2fc4c0d7a3c6c6$var$onKeydown), window[e]("blur", $ec2fc4c0d7a3c6c6$var$onBlur), window[e]("keyup", $ec2fc4c0d7a3c6c6$var$onKeyup), $ec2fc4c0d7a3c6c6$var$escDown = !1;
}
function $ec2fc4c0d7a3c6c6$var$addEscapeKey(e) {
    !0 === $ec2fc4c0d7a3c6c6$var$client.is.desktop && ($ec2fc4c0d7a3c6c6$var$handlers$1.push(e), 1 === $ec2fc4c0d7a3c6c6$var$handlers$1.length && $ec2fc4c0d7a3c6c6$var$update$4("addEventListener"));
}
function $ec2fc4c0d7a3c6c6$var$removeEscapeKey(e) {
    const t = $ec2fc4c0d7a3c6c6$var$handlers$1.indexOf(e);
    t > -1 && ($ec2fc4c0d7a3c6c6$var$handlers$1.splice(t, 1), 0 === $ec2fc4c0d7a3c6c6$var$handlers$1.length && $ec2fc4c0d7a3c6c6$var$update$4("removeEventListener"));
}
const $ec2fc4c0d7a3c6c6$var$handlers = [];
function $ec2fc4c0d7a3c6c6$var$trigger$1(e) {
    $ec2fc4c0d7a3c6c6$var$handlers[$ec2fc4c0d7a3c6c6$var$handlers.length - 1](e);
}
function $ec2fc4c0d7a3c6c6$var$addFocusout(e) {
    !0 === $ec2fc4c0d7a3c6c6$var$client.is.desktop && ($ec2fc4c0d7a3c6c6$var$handlers.push(e), 1 === $ec2fc4c0d7a3c6c6$var$handlers.length && document.body.addEventListener("focusin", $ec2fc4c0d7a3c6c6$var$trigger$1));
}
function $ec2fc4c0d7a3c6c6$var$removeFocusout(e) {
    const t = $ec2fc4c0d7a3c6c6$var$handlers.indexOf(e);
    t > -1 && ($ec2fc4c0d7a3c6c6$var$handlers.splice(t, 1), 0 === $ec2fc4c0d7a3c6c6$var$handlers.length && document.body.removeEventListener("focusin", $ec2fc4c0d7a3c6c6$var$trigger$1));
}
const { notPassiveCapture: $ec2fc4c0d7a3c6c6$var$notPassiveCapture } = $ec2fc4c0d7a3c6c6$var$listenOpts, $ec2fc4c0d7a3c6c6$var$registeredList = [];
function $ec2fc4c0d7a3c6c6$var$globalHandler(e) {
    const t = e.target;
    if (void 0 === t || 8 === t.nodeType || !0 === t.classList.contains("no-pointer-events")) return;
    let o = $ec2fc4c0d7a3c6c6$var$portalProxyList.length - 1;
    while(o >= 0){
        const e = $ec2fc4c0d7a3c6c6$var$portalProxyList[o].$;
        if ("QTooltip" !== e.type.name) {
            if ("QDialog" !== e.type.name) break;
            if (!0 !== e.props.seamless) return;
            o--;
        } else o--;
    }
    for(let n = $ec2fc4c0d7a3c6c6$var$registeredList.length - 1; n >= 0; n--){
        const o = $ec2fc4c0d7a3c6c6$var$registeredList[n];
        if (null !== o.anchorEl.value && !1 !== o.anchorEl.value.contains(t) || t !== document.body && (null === o.innerRef.value || !1 !== o.innerRef.value.contains(t))) return;
        e.qClickOutside = !0, o.onClickOutside(e);
    }
}
function $ec2fc4c0d7a3c6c6$var$addClickOutside(e) {
    $ec2fc4c0d7a3c6c6$var$registeredList.push(e), 1 === $ec2fc4c0d7a3c6c6$var$registeredList.length && (document.addEventListener("mousedown", $ec2fc4c0d7a3c6c6$var$globalHandler, $ec2fc4c0d7a3c6c6$var$notPassiveCapture), document.addEventListener("touchstart", $ec2fc4c0d7a3c6c6$var$globalHandler, $ec2fc4c0d7a3c6c6$var$notPassiveCapture));
}
function $ec2fc4c0d7a3c6c6$var$removeClickOutside(e) {
    const t = $ec2fc4c0d7a3c6c6$var$registeredList.findIndex((t)=>t === e);
    t > -1 && ($ec2fc4c0d7a3c6c6$var$registeredList.splice(t, 1), 0 === $ec2fc4c0d7a3c6c6$var$registeredList.length && (document.removeEventListener("mousedown", $ec2fc4c0d7a3c6c6$var$globalHandler, $ec2fc4c0d7a3c6c6$var$notPassiveCapture), document.removeEventListener("touchstart", $ec2fc4c0d7a3c6c6$var$globalHandler, $ec2fc4c0d7a3c6c6$var$notPassiveCapture)));
}
let $ec2fc4c0d7a3c6c6$var$vpLeft, $ec2fc4c0d7a3c6c6$var$vpTop;
function $ec2fc4c0d7a3c6c6$var$validatePosition(e) {
    const t = e.split(" ");
    return 2 === t.length && (!0 !== [
        "top",
        "center",
        "bottom"
    ].includes(t[0]) ? (console.error("Anchor/Self position must start with one of top/center/bottom"), !1) : !0 === [
        "left",
        "middle",
        "right",
        "start",
        "end"
    ].includes(t[1]) || (console.error("Anchor/Self position must end with one of left/middle/right/start/end"), !1));
}
function $ec2fc4c0d7a3c6c6$var$validateOffset(e) {
    return !e || 2 === e.length && "number" === typeof e[0] && "number" === typeof e[1];
}
const $ec2fc4c0d7a3c6c6$var$horizontalPos = {
    "start#ltr": "left",
    "start#rtl": "right",
    "end#ltr": "right",
    "end#rtl": "left"
};
function $ec2fc4c0d7a3c6c6$var$parsePosition(e, t) {
    const o = e.split(" ");
    return {
        vertical: o[0],
        horizontal: $ec2fc4c0d7a3c6c6$var$horizontalPos[`${o[1]}#${!0 === t ? "rtl" : "ltr"}`]
    };
}
function $ec2fc4c0d7a3c6c6$var$getAnchorProps(e, t) {
    let { top: o, left: n, right: a, bottom: l, width: i, height: r } = e.getBoundingClientRect();
    return void 0 !== t && (o -= t[1], n -= t[0], l += t[1], a += t[0], i += t[0], r += t[1]), {
        top: o,
        bottom: l,
        height: r,
        left: n,
        right: a,
        width: i,
        middle: n + (a - n) / 2,
        center: o + (l - o) / 2
    };
}
function $ec2fc4c0d7a3c6c6$var$getAbsoluteAnchorProps(e, t, o) {
    let { top: n, left: a } = e.getBoundingClientRect();
    return n += t.top, a += t.left, void 0 !== o && (n += o[1], a += o[0]), {
        top: n,
        bottom: n + 1,
        height: 1,
        left: a,
        right: a + 1,
        width: 1,
        middle: a,
        center: n
    };
}
function $ec2fc4c0d7a3c6c6$var$getTargetProps(e, t) {
    return {
        top: 0,
        center: t / 2,
        bottom: t,
        left: 0,
        middle: e / 2,
        right: e
    };
}
function $ec2fc4c0d7a3c6c6$var$getTopLeftProps(e, t, o, n) {
    return {
        top: e[o.vertical] - t[n.vertical],
        left: e[o.horizontal] - t[n.horizontal]
    };
}
function $ec2fc4c0d7a3c6c6$var$setPosition(e, t = 0) {
    if (null === e.targetEl || null === e.anchorEl || t > 5) return;
    if (0 === e.targetEl.offsetHeight || 0 === e.targetEl.offsetWidth) return void setTimeout(()=>{
        $ec2fc4c0d7a3c6c6$var$setPosition(e, t + 1);
    }, 10);
    const { targetEl: o, offset: n, anchorEl: a, anchorOrigin: l, selfOrigin: i, absoluteOffset: r, fit: s, cover: u, maxHeight: c, maxWidth: d } = e;
    if (!0 === $ec2fc4c0d7a3c6c6$var$client.is.ios && void 0 !== window.visualViewport) {
        const e = document.body.style, { offsetLeft: t, offsetTop: o } = window.visualViewport;
        t !== $ec2fc4c0d7a3c6c6$var$vpLeft && (e.setProperty("--q-pe-left", t + "px"), $ec2fc4c0d7a3c6c6$var$vpLeft = t), o !== $ec2fc4c0d7a3c6c6$var$vpTop && (e.setProperty("--q-pe-top", o + "px"), $ec2fc4c0d7a3c6c6$var$vpTop = o);
    }
    const { scrollLeft: p, scrollTop: v } = o, m = void 0 === r ? $ec2fc4c0d7a3c6c6$var$getAnchorProps(a, !0 === u ? [
        0,
        0
    ] : n) : $ec2fc4c0d7a3c6c6$var$getAbsoluteAnchorProps(a, r, n);
    Object.assign(o.style, {
        top: 0,
        left: 0,
        minWidth: null,
        minHeight: null,
        maxWidth: d || "100vw",
        maxHeight: c || "100vh",
        visibility: "visible"
    });
    const { offsetWidth: f, offsetHeight: h } = o, { elWidth: g, elHeight: b } = !0 === s || !0 === u ? {
        elWidth: Math.max(m.width, f),
        elHeight: !0 === u ? Math.max(m.height, h) : h
    } : {
        elWidth: f,
        elHeight: h
    };
    let y = {
        maxWidth: d,
        maxHeight: c
    };
    !0 !== s && !0 !== u || (y.minWidth = m.width + "px", !0 === u && (y.minHeight = m.height + "px")), Object.assign(o.style, y);
    const S = $ec2fc4c0d7a3c6c6$var$getTargetProps(g, b);
    let w = $ec2fc4c0d7a3c6c6$var$getTopLeftProps(m, S, l, i);
    if (void 0 === r || void 0 === n) $ec2fc4c0d7a3c6c6$var$applyBoundaries(w, m, S, l, i);
    else {
        const { top: e, left: t } = w;
        $ec2fc4c0d7a3c6c6$var$applyBoundaries(w, m, S, l, i);
        let o = !1;
        if (w.top !== e) {
            o = !0;
            const e = 2 * n[1];
            m.center = m.top -= e, m.bottom -= e + 2;
        }
        if (w.left !== t) {
            o = !0;
            const e = 2 * n[0];
            m.middle = m.left -= e, m.right -= e + 2;
        }
        !0 === o && (w = $ec2fc4c0d7a3c6c6$var$getTopLeftProps(m, S, l, i), $ec2fc4c0d7a3c6c6$var$applyBoundaries(w, m, S, l, i));
    }
    y = {
        top: w.top + "px",
        left: w.left + "px"
    }, void 0 !== w.maxHeight && (y.maxHeight = w.maxHeight + "px", m.height > w.maxHeight && (y.minHeight = y.maxHeight)), void 0 !== w.maxWidth && (y.maxWidth = w.maxWidth + "px", m.width > w.maxWidth && (y.minWidth = y.maxWidth)), Object.assign(o.style, y), o.scrollTop !== v && (o.scrollTop = v), o.scrollLeft !== p && (o.scrollLeft = p);
}
function $ec2fc4c0d7a3c6c6$var$applyBoundaries(e, t, o, n, a) {
    const l = o.bottom, i = o.right, r = $ec2fc4c0d7a3c6c6$var$getScrollbarWidth(), s = window.innerHeight - r, u = document.body.clientWidth;
    if (e.top < 0 || e.top + l > s) {
        if ("center" === a.vertical) e.top = t[n.vertical] > s / 2 ? Math.max(0, s - l) : 0, e.maxHeight = Math.min(l, s);
        else if (t[n.vertical] > s / 2) {
            const o = Math.min(s, "center" === n.vertical ? t.center : n.vertical === a.vertical ? t.bottom : t.top);
            e.maxHeight = Math.min(l, o), e.top = Math.max(0, o - l);
        } else e.top = Math.max(0, "center" === n.vertical ? t.center : n.vertical === a.vertical ? t.top : t.bottom), e.maxHeight = Math.min(l, s - e.top);
    }
    if (e.left < 0 || e.left + i > u) {
        if (e.maxWidth = Math.min(i, u), "middle" === a.horizontal) e.left = t[n.horizontal] > u / 2 ? Math.max(0, u - i) : 0;
        else if (t[n.horizontal] > u / 2) {
            const o = Math.min(u, "middle" === n.horizontal ? t.middle : n.horizontal === a.horizontal ? t.right : t.left);
            e.maxWidth = Math.min(i, o), e.left = Math.max(0, o - e.maxWidth);
        } else e.left = Math.max(0, "middle" === n.horizontal ? t.middle : n.horizontal === a.horizontal ? t.left : t.right), e.maxWidth = Math.min(i, u - e.left);
    }
}
[
    "left",
    "middle",
    "right"
].forEach((e)=>{
    $ec2fc4c0d7a3c6c6$var$horizontalPos[`${e}#ltr`] = e, $ec2fc4c0d7a3c6c6$var$horizontalPos[`${e}#rtl`] = e;
});
var $ec2fc4c0d7a3c6c6$export$73537802004a2118 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QMenu",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useAnchorProps,
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleProps,
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useTransitionProps,
        persistent: Boolean,
        autoClose: Boolean,
        separateClosePopup: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        fit: Boolean,
        cover: Boolean,
        square: Boolean,
        anchor: {
            type: String,
            validator: $ec2fc4c0d7a3c6c6$var$validatePosition
        },
        self: {
            type: String,
            validator: $ec2fc4c0d7a3c6c6$var$validatePosition
        },
        offset: {
            type: Array,
            validator: $ec2fc4c0d7a3c6c6$var$validateOffset
        },
        scrollTarget: {
            default: void 0
        },
        touchPosition: Boolean,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        }
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleEmits,
        "click",
        "escapeKey"
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        let a, l, i, r = null;
        const s = (0, $TusQn.getCurrentInstance)(), { proxy: u } = s, { $q: c } = u, d = (0, $01W3b.ref)(null), p = (0, $01W3b.ref)(!1), v = (0, $TusQn.computed)(()=>!0 !== e.persistent && !0 !== e.noRouteDismiss), m = $ec2fc4c0d7a3c6c6$var$useDark(e, c), { registerTick: f, removeTick: g } = $ec2fc4c0d7a3c6c6$var$useTick(), { registerTimeout: b } = $ec2fc4c0d7a3c6c6$var$useTimeout(), { transitionProps: y, transitionStyle: S } = $ec2fc4c0d7a3c6c6$var$useTransition(e), { localScrollTarget: w, changeScrollEvent: C, unconfigureScrollTarget: x } = $ec2fc4c0d7a3c6c6$var$useScrollTarget(e, z), { anchorEl: k, canShow: _ } = $ec2fc4c0d7a3c6c6$var$useAnchor({
            showing: p
        }), { hide: q } = $ec2fc4c0d7a3c6c6$var$useModelToggle({
            showing: p,
            canShow: _,
            handleShow: F,
            handleHide: R,
            hideOnRouteChange: v,
            processOnMount: !0
        }), { showPortal: T, hidePortal: P, renderPortal: $ } = $ec2fc4c0d7a3c6c6$var$usePortal(s, d, j, "menu"), M = {
            anchorEl: k,
            innerRef: d,
            onClickOutside (t) {
                if (!0 !== e.persistent && !0 === p.value) return q(t), ("touchstart" === t.type || t.target.classList.contains("q-dialog__backdrop")) && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), !0;
            }
        }, B = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$parsePosition(e.anchor || (!0 === e.cover ? "center middle" : "bottom start"), c.lang.rtl)), E = (0, $TusQn.computed)(()=>!0 === e.cover ? B.value : $ec2fc4c0d7a3c6c6$var$parsePosition(e.self || "top start", c.lang.rtl)), Q = (0, $TusQn.computed)(()=>(!0 === e.square ? " q-menu--square" : "") + (!0 === m.value ? " q-menu--dark q-dark" : "")), A = (0, $TusQn.computed)(()=>!0 === e.autoClose ? {
                onClick: I
            } : {}), L = (0, $TusQn.computed)(()=>!0 === p.value && !0 !== e.persistent);
        function O() {
            $ec2fc4c0d7a3c6c6$var$addFocusFn(()=>{
                let e = d.value;
                e && !0 !== e.contains(document.activeElement) && (e = e.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || e.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || e.querySelector("[autofocus], [data-autofocus]") || e, e.focus({
                    preventScroll: !0
                }));
            });
        }
        function F(t) {
            if (r = !1 === e.noRefocus ? document.activeElement : null, $ec2fc4c0d7a3c6c6$var$addFocusout(V), T(), z(), a = void 0, void 0 !== t && (e.touchPosition || e.contextMenu)) {
                const e = $ec2fc4c0d7a3c6c6$var$position(t);
                if (void 0 !== e.left) {
                    const { top: t, left: o } = k.value.getBoundingClientRect();
                    a = {
                        left: e.left - o,
                        top: e.top - t
                    };
                }
            }
            void 0 === l && (l = (0, $TusQn.watch)(()=>c.screen.width + "|" + c.screen.height + "|" + e.self + "|" + e.anchor + "|" + c.lang.rtl, N)), !0 !== e.noFocus && document.activeElement.blur(), f(()=>{
                N(), !0 !== e.noFocus && O();
            }), b(()=>{
                !0 === c.platform.is.ios && (i = e.autoClose, d.value.click()), N(), T(!0), o("show", t);
            }, e.transitionDuration);
        }
        function R(t) {
            g(), P(), D(!0), null === r || void 0 !== t && !0 === t.qClickOutside || (((t && 0 === t.type.indexOf("key") ? r.closest('[tabindex]:not([tabindex^="-"])') : void 0) || r).focus(), r = null), b(()=>{
                P(!0), o("hide", t);
            }, e.transitionDuration);
        }
        function D(e) {
            a = void 0, void 0 !== l && (l(), l = void 0), !0 !== e && !0 !== p.value || ($ec2fc4c0d7a3c6c6$var$removeFocusout(V), x(), $ec2fc4c0d7a3c6c6$var$removeClickOutside(M), $ec2fc4c0d7a3c6c6$var$removeEscapeKey(H)), !0 !== e && (r = null);
        }
        function z() {
            null === k.value && void 0 === e.scrollTarget || (w.value = $ec2fc4c0d7a3c6c6$var$getScrollTarget(k.value, e.scrollTarget), C(w.value, N));
        }
        function I(e) {
            !0 !== i ? ($ec2fc4c0d7a3c6c6$var$closePortalMenus(u, e), o("click", e)) : i = !1;
        }
        function V(t) {
            !0 === L.value && !0 !== e.noFocus && !0 !== $ec2fc4c0d7a3c6c6$var$childHasFocus(d.value, t.target) && O();
        }
        function H(e) {
            o("escapeKey"), q(e);
        }
        function N() {
            $ec2fc4c0d7a3c6c6$var$setPosition({
                targetEl: d.value,
                offset: e.offset,
                anchorEl: k.value,
                anchorOrigin: B.value,
                selfOrigin: E.value,
                absoluteOffset: a,
                fit: e.fit,
                cover: e.cover,
                maxHeight: e.maxHeight,
                maxWidth: e.maxWidth
            });
        }
        function j() {
            return (0, $TusQn.h)((0, $eeJ70.Transition), y.value, ()=>!0 === p.value ? (0, $TusQn.h)("div", {
                    role: "menu",
                    ...n,
                    ref: d,
                    tabindex: -1,
                    class: [
                        "q-menu q-position-engine scroll" + Q.value,
                        n.class
                    ],
                    style: [
                        n.style,
                        S.value
                    ],
                    ...A.value
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)) : null);
        }
        return (0, $TusQn.watch)(L, (e)=>{
            !0 === e ? ($ec2fc4c0d7a3c6c6$var$addEscapeKey(H), $ec2fc4c0d7a3c6c6$var$addClickOutside(M)) : ($ec2fc4c0d7a3c6c6$var$removeEscapeKey(H), $ec2fc4c0d7a3c6c6$var$removeClickOutside(M));
        }), (0, $TusQn.onBeforeUnmount)(D), Object.assign(u, {
            focus: O,
            updatePosition: N
        }), $;
    }
});
let $ec2fc4c0d7a3c6c6$var$buf, $ec2fc4c0d7a3c6c6$var$bufIdx = 0;
const $ec2fc4c0d7a3c6c6$var$hexBytes = new Array(256);
for(let e = 0; e < 256; e++)$ec2fc4c0d7a3c6c6$var$hexBytes[e] = (e + 256).toString(16).substring(1);
const $ec2fc4c0d7a3c6c6$var$randomBytes = (()=>{
    const e = "undefined" !== typeof crypto ? crypto : "undefined" !== typeof window ? window.crypto || window.msCrypto : void 0;
    if (void 0 !== e) {
        if (void 0 !== e.randomBytes) return e.randomBytes;
        if (void 0 !== e.getRandomValues) return (t)=>{
            const o = new Uint8Array(t);
            return e.getRandomValues(o), o;
        };
    }
    return (e)=>{
        const t = [];
        for(let o = e; o > 0; o--)t.push(Math.floor(256 * Math.random()));
        return t;
    };
})(), $ec2fc4c0d7a3c6c6$var$BUFFER_SIZE = 4096;
function $ec2fc4c0d7a3c6c6$export$e2a22331486dcca0() {
    (void 0 === $ec2fc4c0d7a3c6c6$var$buf || $ec2fc4c0d7a3c6c6$var$bufIdx + 16 > $ec2fc4c0d7a3c6c6$var$BUFFER_SIZE) && ($ec2fc4c0d7a3c6c6$var$bufIdx = 0, $ec2fc4c0d7a3c6c6$var$buf = $ec2fc4c0d7a3c6c6$var$randomBytes($ec2fc4c0d7a3c6c6$var$BUFFER_SIZE));
    const e = Array.prototype.slice.call($ec2fc4c0d7a3c6c6$var$buf, $ec2fc4c0d7a3c6c6$var$bufIdx, $ec2fc4c0d7a3c6c6$var$bufIdx += 16);
    return e[6] = 15 & e[6] | 64, e[8] = 63 & e[8] | 128, $ec2fc4c0d7a3c6c6$var$hexBytes[e[0]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[1]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[2]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[3]] + "-" + $ec2fc4c0d7a3c6c6$var$hexBytes[e[4]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[5]] + "-" + $ec2fc4c0d7a3c6c6$var$hexBytes[e[6]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[7]] + "-" + $ec2fc4c0d7a3c6c6$var$hexBytes[e[8]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[9]] + "-" + $ec2fc4c0d7a3c6c6$var$hexBytes[e[10]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[11]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[12]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[13]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[14]] + $ec2fc4c0d7a3c6c6$var$hexBytes[e[15]];
}
const $ec2fc4c0d7a3c6c6$var$btnPropsList = Object.keys($ec2fc4c0d7a3c6c6$var$useBtnProps), $ec2fc4c0d7a3c6c6$var$passBtnProps = (e)=>$ec2fc4c0d7a3c6c6$var$btnPropsList.reduce((t, o)=>{
        const n = e[o];
        return void 0 !== n && (t[o] = n), t;
    }, {});
var $ec2fc4c0d7a3c6c6$export$ed13f95342ac4309 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBtnDropdown",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useBtnProps,
        ...$ec2fc4c0d7a3c6c6$var$useTransitionProps,
        modelValue: Boolean,
        split: Boolean,
        dropdownIcon: String,
        contentClass: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        cover: Boolean,
        persistent: Boolean,
        noRouteDismiss: Boolean,
        autoClose: Boolean,
        menuAnchor: {
            type: String,
            default: "bottom end"
        },
        menuSelf: {
            type: String,
            default: "top end"
        },
        menuOffset: Array,
        disableMainBtn: Boolean,
        disableDropdown: Boolean,
        noIconAnimation: Boolean,
        toggleAriaLabel: String
    },
    emits: [
        "update:modelValue",
        "click",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), a = (0, $01W3b.ref)(e.modelValue), l = (0, $01W3b.ref)(null), i = $ec2fc4c0d7a3c6c6$export$e2a22331486dcca0(), r = (0, $TusQn.computed)(()=>{
            const t = {
                "aria-expanded": !0 === a.value ? "true" : "false",
                "aria-haspopup": "true",
                "aria-controls": i,
                "aria-label": e.toggleAriaLabel || n.$q.lang.label[!0 === a.value ? "collapse" : "expand"](e.label)
            };
            return (!0 === e.disable || !1 === e.split && !0 === e.disableMainBtn || !0 === e.disableDropdown) && (t["aria-disabled"] = "true"), t;
        }), s = (0, $TusQn.computed)(()=>"q-btn-dropdown__arrow" + (!0 === a.value && !1 === e.noIconAnimation ? " rotate-180" : "") + (!1 === e.split ? " q-btn-dropdown__arrow-container" : "")), u = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBtnDesignAttr(e)), c = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$passBtnProps(e));
        function d(e) {
            a.value = !0, o("beforeShow", e);
        }
        function p(e) {
            o("show", e), o("update:modelValue", !0);
        }
        function v(e) {
            a.value = !1, o("beforeHide", e);
        }
        function m(e) {
            o("hide", e), o("update:modelValue", !1);
        }
        function f(e) {
            o("click", e);
        }
        function g(e) {
            $ec2fc4c0d7a3c6c6$var$stop(e), S(), o("click", e);
        }
        function b(e) {
            null !== l.value && l.value.toggle(e);
        }
        function y(e) {
            null !== l.value && l.value.show(e);
        }
        function S(e) {
            null !== l.value && l.value.hide(e);
        }
        return (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            null !== l.value && l.value[e ? "show" : "hide"]();
        }), (0, $TusQn.watch)(()=>e.split, S), Object.assign(n, {
            show: y,
            hide: S,
            toggle: b
        }), (0, $TusQn.onMounted)(()=>{
            !0 === e.modelValue && y();
        }), ()=>{
            const o = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    class: s.value,
                    name: e.dropdownIcon || n.$q.iconSet.arrow.dropdown
                })
            ];
            return !0 !== e.disableDropdown && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$73537802004a2118, {
                ref: l,
                id: i,
                class: e.contentClass,
                style: e.contentStyle,
                cover: e.cover,
                fit: !0,
                persistent: e.persistent,
                noRouteDismiss: e.noRouteDismiss,
                autoClose: e.autoClose,
                anchor: e.menuAnchor,
                self: e.menuSelf,
                offset: e.menuOffset,
                separateClosePopup: !0,
                transitionShow: e.transitionShow,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                onBeforeShow: d,
                onShow: p,
                onBeforeHide: v,
                onHide: m
            }, t.default)), !1 === e.split ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                class: "q-btn-dropdown q-btn-dropdown--simple",
                ...c.value,
                ...r.value,
                disable: !0 === e.disable || !0 === e.disableMainBtn,
                noWrap: !0,
                round: !1,
                onClick: f
            }, {
                default: ()=>$ec2fc4c0d7a3c6c6$var$hSlot(t.label, []).concat(o),
                loading: t.loading
            }) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$ec40a025a653c83b, {
                class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
                rounded: e.rounded,
                square: e.square,
                ...u.value,
                glossy: e.glossy,
                stretch: e.stretch
            }, ()=>[
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        class: "q-btn-dropdown--current",
                        ...c.value,
                        disable: !0 === e.disable || !0 === e.disableMainBtn,
                        noWrap: !0,
                        round: !1,
                        onClick: g
                    }, {
                        default: t.label,
                        loading: t.loading
                    }),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        class: "q-btn-dropdown__arrow-container q-anchor--skip",
                        ...r.value,
                        ...u.value,
                        disable: !0 === e.disable || !0 === e.disableDropdown,
                        rounded: e.rounded,
                        color: e.color,
                        textColor: e.textColor,
                        dense: e.dense,
                        size: e.size,
                        padding: e.padding,
                        ripple: e.ripple
                    }, ()=>o)
                ]);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$useFormProps = {
    name: String
};
function $ec2fc4c0d7a3c6c6$var$useFormAttrs(e) {
    return (0, $TusQn.computed)(()=>({
            type: "hidden",
            name: e.name,
            value: e.modelValue
        }));
}
function $ec2fc4c0d7a3c6c6$var$useFormInject(e = {}) {
    return (t, o, n)=>{
        t[o]((0, $TusQn.h)("input", {
            class: "hidden" + (n || ""),
            ...e.value
        }));
    };
}
function $ec2fc4c0d7a3c6c6$var$useFormInputNameAttr(e) {
    return (0, $TusQn.computed)(()=>e.name || e.for);
}
var $ec2fc4c0d7a3c6c6$export$1e5c1ca50ee4d96c = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QBtnToggle",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        modelValue: {
            required: !0
        },
        options: {
            type: Array,
            required: !0,
            validator: (e)=>e.every((e)=>("label" in e || "icon" in e || "slot" in e) && "value" in e)
        },
        color: String,
        textColor: String,
        toggleColor: {
            type: String,
            default: "primary"
        },
        toggleTextColor: String,
        outline: Boolean,
        flat: Boolean,
        unelevated: Boolean,
        rounded: Boolean,
        push: Boolean,
        glossy: Boolean,
        size: String,
        padding: String,
        noCaps: Boolean,
        noWrap: Boolean,
        dense: Boolean,
        readonly: Boolean,
        disable: Boolean,
        stack: Boolean,
        stretch: Boolean,
        spread: Boolean,
        clearable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: !0
        }
    },
    emits: [
        "update:modelValue",
        "clear",
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $TusQn.computed)(()=>void 0 !== e.options.find((t)=>t.value === e.modelValue)), a = (0, $TusQn.computed)(()=>({
                type: "hidden",
                name: e.name,
                value: e.modelValue
            })), l = $ec2fc4c0d7a3c6c6$var$useFormInject(a), i = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBtnDesignAttr(e)), r = (0, $TusQn.computed)(()=>({
                rounded: e.rounded,
                dense: e.dense,
                ...i.value
            })), s = (0, $TusQn.computed)(()=>e.options.map((t, o)=>{
                const { attrs: n, value: a, slot: l, ...i } = t;
                return {
                    slot: l,
                    props: {
                        key: o,
                        "aria-pressed": a === e.modelValue ? "true" : "false",
                        ...n,
                        ...i,
                        ...r.value,
                        disable: !0 === e.disable || !0 === i.disable,
                        color: a === e.modelValue ? c(i, "toggleColor") : c(i, "color"),
                        textColor: a === e.modelValue ? c(i, "toggleTextColor") : c(i, "textColor"),
                        noCaps: !0 === c(i, "noCaps"),
                        noWrap: !0 === c(i, "noWrap"),
                        size: c(i, "size"),
                        padding: c(i, "padding"),
                        ripple: c(i, "ripple"),
                        stack: !0 === c(i, "stack"),
                        stretch: !0 === c(i, "stretch"),
                        onClick (e) {
                            u(a, t, e);
                        }
                    }
                };
            }));
        function u(t, n, a) {
            !0 !== e.readonly && (e.modelValue === t ? !0 === e.clearable && (o("update:modelValue", null, null), o("clear")) : o("update:modelValue", t, n), o("click", a));
        }
        function c(t, o) {
            return void 0 === t[o] ? e[o] : t[o];
        }
        function d() {
            const o = s.value.map((e)=>{
                return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, e.props, void 0 !== e.slot ? t[e.slot] : void 0);
            });
            return void 0 !== e.name && !0 !== e.disable && !0 === n.value && l(o, "push"), $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, o);
        }
        return ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$ec40a025a653c83b, {
                class: "q-btn-toggle",
                ...i.value,
                rounded: e.rounded,
                stretch: e.stretch,
                glossy: e.glossy,
                spread: e.spread
            }, d);
    }
}), $ec2fc4c0d7a3c6c6$export$866037ffbc2a7c62 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCard",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        tag: {
            type: String,
            default: "div"
        },
        square: Boolean,
        flat: Boolean,
        bordered: Boolean
    },
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o), a = (0, $TusQn.computed)(()=>"q-card" + (!0 === n.value ? " q-card--dark q-dark" : "") + (!0 === e.bordered ? " q-card--bordered" : "") + (!0 === e.square ? " q-card--square no-border-radius" : "") + (!0 === e.flat ? " q-card--flat no-shadow" : ""));
        return ()=>(0, $TusQn.h)(e.tag, {
                class: a.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$653482776a1a6c98 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCardSection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        horizontal: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>"q-card__section" + ` q-card__section--${!0 === e.horizontal ? "horiz row no-wrap" : "vert"}`);
        return ()=>(0, $TusQn.h)(e.tag, {
                class: o.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$8c05ea70037eac6a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCardActions",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useAlignProps,
        vertical: Boolean
    },
    setup (e, { slots: t }) {
        const o = $ec2fc4c0d7a3c6c6$var$useAlign(e), n = (0, $TusQn.computed)(()=>`q-card__actions ${o.value}` + ` q-card__actions--${!0 === e.vertical ? "vert column" : "horiz row"}`);
        return ()=>(0, $TusQn.h)("div", {
                class: n.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$modifiersAll = {
    left: !0,
    right: !0,
    up: !0,
    down: !0,
    horizontal: !0,
    vertical: !0
}, $ec2fc4c0d7a3c6c6$var$directionList = Object.keys($ec2fc4c0d7a3c6c6$var$modifiersAll);
function $ec2fc4c0d7a3c6c6$var$getModifierDirections(e) {
    const t = {};
    for (const o of $ec2fc4c0d7a3c6c6$var$directionList)!0 === e[o] && (t[o] = !0);
    return 0 === Object.keys(t).length ? $ec2fc4c0d7a3c6c6$var$modifiersAll : (!0 === t.horizontal ? t.left = t.right = !0 : !0 === t.left && !0 === t.right && (t.horizontal = !0), !0 === t.vertical ? t.up = t.down = !0 : !0 === t.up && !0 === t.down && (t.vertical = !0), !0 === t.horizontal && !0 === t.vertical && (t.all = !0), t);
}
$ec2fc4c0d7a3c6c6$var$modifiersAll.all = !0;
const $ec2fc4c0d7a3c6c6$var$avoidNodeNamesList = [
    "INPUT",
    "TEXTAREA"
];
function $ec2fc4c0d7a3c6c6$var$shouldStart(e, t) {
    return void 0 === t.event && void 0 !== e.target && !0 !== e.target.draggable && "function" === typeof t.handler && !1 === $ec2fc4c0d7a3c6c6$var$avoidNodeNamesList.includes(e.target.nodeName.toUpperCase()) && (void 0 === e.qClonedBy || -1 === e.qClonedBy.indexOf(t.uid));
}
function $ec2fc4c0d7a3c6c6$var$parseArg(e) {
    const t = [
        .06,
        6,
        50
    ];
    return "string" === typeof e && e.length && e.split(":").forEach((e, o)=>{
        const n = parseFloat(e);
        n && (t[o] = n);
    }), t;
}
var $ec2fc4c0d7a3c6c6$export$945da4db66eba3a1 = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "touch-swipe",
    beforeMount (e, { value: t, arg: o, modifiers: n }) {
        if (!0 !== n.mouse && !0 !== $ec2fc4c0d7a3c6c6$var$client.has.touch) return;
        const a = !0 === n.mouseCapture ? "Capture" : "", l = {
            handler: t,
            sensitivity: $ec2fc4c0d7a3c6c6$var$parseArg(o),
            direction: $ec2fc4c0d7a3c6c6$var$getModifierDirections(n),
            noop: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
            mouseStart (e) {
                $ec2fc4c0d7a3c6c6$var$shouldStart(e, l) && $ec2fc4c0d7a3c6c6$var$leftClick(e) && ($ec2fc4c0d7a3c6c6$var$addEvt(l, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        `notPassive${a}`
                    ],
                    [
                        document,
                        "mouseup",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), l.start(e, !0));
            },
            touchStart (e) {
                if ($ec2fc4c0d7a3c6c6$var$shouldStart(e, l)) {
                    const t = e.target;
                    $ec2fc4c0d7a3c6c6$var$addEvt(l, "temp", [
                        [
                            t,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            t,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            t,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), l.start(e);
                }
            },
            start (t, o) {
                !0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox && $ec2fc4c0d7a3c6c6$var$preventDraggable(e, !0);
                const n = $ec2fc4c0d7a3c6c6$var$position(t);
                l.event = {
                    x: n.left,
                    y: n.top,
                    time: Date.now(),
                    mouse: !0 === o,
                    dir: !1
                };
            },
            move (e) {
                if (void 0 === l.event) return;
                if (!1 !== l.event.dir) return void $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
                const t = Date.now() - l.event.time;
                if (0 === t) return;
                const o = $ec2fc4c0d7a3c6c6$var$position(e), n = o.left - l.event.x, a = Math.abs(n), i = o.top - l.event.y, r = Math.abs(i);
                if (!0 !== l.event.mouse) {
                    if (a < l.sensitivity[1] && r < l.sensitivity[1]) return void l.end(e);
                } else {
                    if ("" !== window.getSelection().toString()) return void l.end(e);
                    if (a < l.sensitivity[2] && r < l.sensitivity[2]) return;
                }
                const s = a / t, u = r / t;
                !0 === l.direction.vertical && a < r && a < 100 && u > l.sensitivity[0] && (l.event.dir = i < 0 ? "up" : "down"), !0 === l.direction.horizontal && a > r && r < 100 && s > l.sensitivity[0] && (l.event.dir = n < 0 ? "left" : "right"), !0 === l.direction.up && a < r && i < 0 && a < 100 && u > l.sensitivity[0] && (l.event.dir = "up"), !0 === l.direction.down && a < r && i > 0 && a < 100 && u > l.sensitivity[0] && (l.event.dir = "down"), !0 === l.direction.left && a > r && n < 0 && r < 100 && s > l.sensitivity[0] && (l.event.dir = "left"), !0 === l.direction.right && a > r && n > 0 && r < 100 && s > l.sensitivity[0] && (l.event.dir = "right"), !1 !== l.event.dir ? ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), !0 === l.event.mouse && (document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), $ec2fc4c0d7a3c6c6$var$clearSelection(), l.styleCleanup = (e)=>{
                    l.styleCleanup = void 0, document.body.classList.remove("non-selectable");
                    const t = ()=>{
                        document.body.classList.remove("no-pointer-events--children");
                    };
                    !0 === e ? setTimeout(t, 50) : t();
                }), l.handler({
                    evt: e,
                    touch: !0 !== l.event.mouse,
                    mouse: l.event.mouse,
                    direction: l.event.dir,
                    duration: t,
                    distance: {
                        x: a,
                        y: r
                    }
                })) : l.end(e);
            },
            end (t) {
                void 0 !== l.event && ($ec2fc4c0d7a3c6c6$var$cleanEvt(l, "temp"), !0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox && $ec2fc4c0d7a3c6c6$var$preventDraggable(e, !1), void 0 !== l.styleCleanup && l.styleCleanup(!0), void 0 !== t && !1 !== l.event.dir && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), l.event = void 0);
            }
        };
        if (e.__qtouchswipe = l, !0 === n.mouse) {
            const t = !0 === n.mouseCapture || !0 === n.mousecapture ? "Capture" : "";
            $ec2fc4c0d7a3c6c6$var$addEvt(l, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${t}`
                ]
            ]);
        }
        !0 === $ec2fc4c0d7a3c6c6$var$client.has.touch && $ec2fc4c0d7a3c6c6$var$addEvt(l, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${!0 === n.capture ? "Capture" : ""}`
            ],
            [
                e,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (e, t) {
        const o = e.__qtouchswipe;
        void 0 !== o && (t.oldValue !== t.value && ("function" !== typeof t.value && o.end(), o.handler = t.value), o.direction = $ec2fc4c0d7a3c6c6$var$getModifierDirections(t.modifiers));
    },
    beforeUnmount (e) {
        const t = e.__qtouchswipe;
        void 0 !== t && ($ec2fc4c0d7a3c6c6$var$cleanEvt(t, "main"), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "temp"), !0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox && $ec2fc4c0d7a3c6c6$var$preventDraggable(e, !1), void 0 !== t.styleCleanup && t.styleCleanup(), delete e.__qtouchswipe);
    }
});
function $ec2fc4c0d7a3c6c6$var$useCache() {
    const e = new Map;
    return {
        getCache: function(t, o) {
            return void 0 === e[t] ? e[t] = o : e[t];
        },
        getCacheWithFn: function(t, o) {
            return void 0 === e[t] ? e[t] = o() : e[t];
        }
    };
}
const $ec2fc4c0d7a3c6c6$var$usePanelChildProps = {
    name: {
        required: !0
    },
    disable: Boolean
}, $ec2fc4c0d7a3c6c6$var$PanelWrapper$1 = {
    setup (e, { slots: t }) {
        return ()=>(0, $TusQn.h)("div", {
                class: "q-panel scroll",
                role: "tabpanel"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}, $ec2fc4c0d7a3c6c6$var$usePanelProps = {
    modelValue: {
        required: !0
    },
    animated: Boolean,
    infinite: Boolean,
    swipeable: Boolean,
    vertical: Boolean,
    transitionPrev: String,
    transitionNext: String,
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    },
    keepAlive: Boolean,
    keepAliveInclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveExclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveMax: Number
}, $ec2fc4c0d7a3c6c6$var$usePanelEmits = [
    "update:modelValue",
    "beforeTransition",
    "transition"
];
function $ec2fc4c0d7a3c6c6$var$usePanel() {
    const { props: e, emit: t, proxy: o } = (0, $TusQn.getCurrentInstance)(), { getCacheWithFn: n } = $ec2fc4c0d7a3c6c6$var$useCache();
    let a, l;
    const i = (0, $01W3b.ref)(null), r = (0, $01W3b.ref)(null);
    function s(t) {
        const n = !0 === e.vertical ? "up" : "left";
        k((!0 === o.$q.lang.rtl ? -1 : 1) * (t.direction === n ? 1 : -1));
    }
    const u = (0, $TusQn.computed)(()=>{
        return [
            [
                $ec2fc4c0d7a3c6c6$export$945da4db66eba3a1,
                s,
                void 0,
                {
                    horizontal: !0 !== e.vertical,
                    vertical: e.vertical,
                    mouse: !0
                }
            ]
        ];
    }), c = (0, $TusQn.computed)(()=>e.transitionPrev || `slide-${!0 === e.vertical ? "down" : "right"}`), d = (0, $TusQn.computed)(()=>e.transitionNext || `slide-${!0 === e.vertical ? "up" : "left"}`), p = (0, $TusQn.computed)(()=>`--q-transition-duration: ${e.transitionDuration}ms`), v = (0, $TusQn.computed)(()=>"string" === typeof e.modelValue || "number" === typeof e.modelValue ? e.modelValue : String(e.modelValue)), m = (0, $TusQn.computed)(()=>({
            include: e.keepAliveInclude,
            exclude: e.keepAliveExclude,
            max: e.keepAliveMax
        })), f = (0, $TusQn.computed)(()=>void 0 !== e.keepAliveInclude || void 0 !== e.keepAliveExclude);
    function g() {
        k(1);
    }
    function b() {
        k(-1);
    }
    function y(e) {
        t("update:modelValue", e);
    }
    function S(e) {
        return void 0 !== e && null !== e && "" !== e;
    }
    function w(e) {
        return a.findIndex((t)=>{
            return t.props.name === e && "" !== t.props.disable && !0 !== t.props.disable;
        });
    }
    function C() {
        return a.filter((e)=>{
            return "" !== e.props.disable && !0 !== e.props.disable;
        });
    }
    function x(t) {
        const o = 0 !== t && !0 === e.animated && -1 !== i.value ? "q-transition--" + (-1 === t ? c.value : d.value) : null;
        r.value !== o && (r.value = o);
    }
    function k(o, n = i.value) {
        let r = n + o;
        while(r > -1 && r < a.length){
            const e = a[r];
            if (void 0 !== e && "" !== e.props.disable && !0 !== e.props.disable) return x(o), l = !0, t("update:modelValue", e.props.name), void setTimeout(()=>{
                l = !1;
            });
            r += o;
        }
        !0 === e.infinite && 0 !== a.length && -1 !== n && n !== a.length && k(o, -1 === o ? a.length : -1);
    }
    function _() {
        const t = w(e.modelValue);
        return i.value !== t && (i.value = t), !0;
    }
    function q() {
        const t = !0 === S(e.modelValue) && _() && a[i.value];
        return !0 === e.keepAlive ? [
            (0, $TusQn.h)((0, $TusQn.KeepAlive), m.value, [
                (0, $TusQn.h)(!0 === f.value ? n(v.value, ()=>({
                        ...$ec2fc4c0d7a3c6c6$var$PanelWrapper$1,
                        name: v.value
                    })) : $ec2fc4c0d7a3c6c6$var$PanelWrapper$1, {
                    key: v.value,
                    style: p.value
                }, ()=>t)
            ])
        ] : [
            (0, $TusQn.h)("div", {
                class: "q-panel scroll",
                style: p.value,
                key: v.value,
                role: "tabpanel"
            }, [
                t
            ])
        ];
    }
    function T() {
        if (0 !== a.length) return !0 === e.animated ? [
            (0, $TusQn.h)((0, $eeJ70.Transition), {
                name: r.value
            }, q)
        ] : q();
    }
    function P(e) {
        return a = $ec2fc4c0d7a3c6c6$var$getNormalizedVNodes($ec2fc4c0d7a3c6c6$var$hSlot(e.default, [])).filter((e)=>null !== e.props && void 0 === e.props.slot && !0 === S(e.props.name)), a.length;
    }
    function $() {
        return a;
    }
    return (0, $TusQn.watch)(()=>e.modelValue, (e, o)=>{
        const n = !0 === S(e) ? w(e) : -1;
        !0 !== l && x(-1 === n ? 0 : n < w(o) ? -1 : 1), i.value !== n && (i.value = n, t("beforeTransition", e, o), (0, $TusQn.nextTick)(()=>{
            t("transition", e, o);
        }));
    }), Object.assign(o, {
        next: g,
        previous: b,
        goTo: y
    }), {
        panelIndex: i,
        panelDirectives: u,
        updatePanelsList: P,
        updatePanelIndex: _,
        getPanelContent: T,
        getEnabledPanels: C,
        getPanels: $,
        isValidPanelName: S,
        keepAliveProps: m,
        needsUniqueKeepAliveWrapper: f,
        goToPanelByOffset: k,
        goToPanel: y,
        nextPanel: g,
        previousPanel: b
    };
}
let $ec2fc4c0d7a3c6c6$var$counter = 0;
const $ec2fc4c0d7a3c6c6$var$useFullscreenProps = {
    fullscreen: Boolean,
    noRouteFullscreenExit: Boolean
}, $ec2fc4c0d7a3c6c6$var$useFullscreenEmits = [
    "update:fullscreen",
    "fullscreen"
];
function $ec2fc4c0d7a3c6c6$var$useFullscreen() {
    const e = (0, $TusQn.getCurrentInstance)(), { props: t, emit: o, proxy: n } = e;
    let a, l, i;
    const r = (0, $01W3b.ref)(!1);
    function s() {
        !0 === r.value ? c() : u();
    }
    function u() {
        !0 !== r.value && (r.value = !0, i = n.$el.parentNode, i.replaceChild(l, n.$el), document.body.appendChild(n.$el), $ec2fc4c0d7a3c6c6$var$counter++, 1 === $ec2fc4c0d7a3c6c6$var$counter && document.body.classList.add("q-body--fullscreen-mixin"), a = {
            handler: c
        }, $ec2fc4c0d7a3c6c6$var$History.add(a));
    }
    function c() {
        !0 === r.value && (void 0 !== a && ($ec2fc4c0d7a3c6c6$var$History.remove(a), a = void 0), i.replaceChild(n.$el, l), r.value = !1, $ec2fc4c0d7a3c6c6$var$counter = Math.max(0, $ec2fc4c0d7a3c6c6$var$counter - 1), 0 === $ec2fc4c0d7a3c6c6$var$counter && (document.body.classList.remove("q-body--fullscreen-mixin"), void 0 !== n.$el.scrollIntoView && setTimeout(()=>{
            n.$el.scrollIntoView();
        })));
    }
    return !0 === $ec2fc4c0d7a3c6c6$var$vmHasRouter(e) && (0, $TusQn.watch)(()=>n.$route.fullPath, ()=>{
        !0 !== t.noRouteFullscreenExit && c();
    }), (0, $TusQn.watch)(()=>t.fullscreen, (e)=>{
        r.value !== e && s();
    }), (0, $TusQn.watch)(r, (e)=>{
        o("update:fullscreen", e), o("fullscreen", e);
    }), (0, $TusQn.onBeforeMount)(()=>{
        l = document.createElement("span");
    }), (0, $TusQn.onMounted)(()=>{
        !0 === t.fullscreen && u();
    }), (0, $TusQn.onBeforeUnmount)(c), Object.assign(n, {
        toggleFullscreen: s,
        setFullscreen: u,
        exitFullscreen: c
    }), {
        inFullscreen: r,
        toggleFullscreen: s
    };
}
const $ec2fc4c0d7a3c6c6$var$navigationPositionOptions = [
    "top",
    "right",
    "bottom",
    "left"
], $ec2fc4c0d7a3c6c6$var$controlTypeOptions = [
    "regular",
    "flat",
    "outline",
    "push",
    "unelevated"
];
var $ec2fc4c0d7a3c6c6$export$ceb1843391966906 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCarousel",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$usePanelProps,
        ...$ec2fc4c0d7a3c6c6$var$useFullscreenProps,
        transitionPrev: {
            type: String,
            default: "fade"
        },
        transitionNext: {
            type: String,
            default: "fade"
        },
        height: String,
        padding: Boolean,
        controlColor: String,
        controlTextColor: String,
        controlType: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$controlTypeOptions.includes(e),
            default: "flat"
        },
        autoplay: [
            Number,
            Boolean
        ],
        arrows: Boolean,
        prevIcon: String,
        nextIcon: String,
        navigation: Boolean,
        navigationPosition: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$navigationPositionOptions.includes(e)
        },
        navigationIcon: String,
        navigationActiveIcon: String,
        thumbnails: Boolean
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useFullscreenEmits,
        ...$ec2fc4c0d7a3c6c6$var$usePanelEmits
    ],
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o);
        let a, l = null;
        const { updatePanelsList: i, getPanelContent: r, panelDirectives: s, goToPanel: u, previousPanel: c, nextPanel: d, getEnabledPanels: p, panelIndex: v } = $ec2fc4c0d7a3c6c6$var$usePanel(), { inFullscreen: m } = $ec2fc4c0d7a3c6c6$var$useFullscreen(), f = (0, $TusQn.computed)(()=>!0 !== m.value && void 0 !== e.height ? {
                height: e.height
            } : {}), g = (0, $TusQn.computed)(()=>!0 === e.vertical ? "vertical" : "horizontal"), b = (0, $TusQn.computed)(()=>`q-carousel q-panel-parent q-carousel--with${!0 === e.padding ? "" : "out"}-padding` + (!0 === m.value ? " fullscreen" : "") + (!0 === n.value ? " q-carousel--dark q-dark" : "") + (!0 === e.arrows ? ` q-carousel--arrows-${g.value}` : "") + (!0 === e.navigation ? ` q-carousel--navigation-${C.value}` : "")), y = (0, $TusQn.computed)(()=>{
            const t = [
                e.prevIcon || o.iconSet.carousel[!0 === e.vertical ? "up" : "left"],
                e.nextIcon || o.iconSet.carousel[!0 === e.vertical ? "down" : "right"]
            ];
            return !1 === e.vertical && !0 === o.lang.rtl ? t.reverse() : t;
        }), S = (0, $TusQn.computed)(()=>e.navigationIcon || o.iconSet.carousel.navigationIcon), w = (0, $TusQn.computed)(()=>e.navigationActiveIcon || S.value), C = (0, $TusQn.computed)(()=>e.navigationPosition || (!0 === e.vertical ? "right" : "bottom")), x = (0, $TusQn.computed)(()=>({
                color: e.controlColor,
                textColor: e.controlTextColor,
                round: !0,
                [e.controlType]: !0,
                dense: !0
            }));
        function k() {
            const t = !0 === $ec2fc4c0d7a3c6c6$var$isNumber(e.autoplay) ? Math.abs(e.autoplay) : 5e3;
            null !== l && clearTimeout(l), l = setTimeout(()=>{
                l = null, t >= 0 ? d() : c();
            }, t);
        }
        function _(t, o) {
            return (0, $TusQn.h)("div", {
                class: "q-carousel__control q-carousel__navigation no-wrap absolute flex" + ` q-carousel__navigation--${t} q-carousel__navigation--${C.value}` + (void 0 !== e.controlColor ? ` text-${e.controlColor}` : "")
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-carousel__navigation-inner flex flex-center no-wrap"
                }, p().map(o))
            ]);
        }
        function q() {
            const o = [];
            if (!0 === e.navigation) {
                const e = void 0 !== t["navigation-icon"] ? t["navigation-icon"] : (e)=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        key: "nav" + e.name,
                        class: `q-carousel__navigation-icon q-carousel__navigation-icon--${!0 === e.active ? "" : "in"}active`,
                        ...e.btnProps,
                        onClick: e.onClick
                    }), n = a - 1;
                o.push(_("buttons", (t, o)=>{
                    const a = t.props.name, l = v.value === o;
                    return e({
                        index: o,
                        maxIndex: n,
                        name: a,
                        active: l,
                        btnProps: {
                            icon: !0 === l ? w.value : S.value,
                            size: "sm",
                            ...x.value
                        },
                        onClick: ()=>{
                            u(a);
                        }
                    });
                }));
            } else if (!0 === e.thumbnails) {
                const t = void 0 !== e.controlColor ? ` text-${e.controlColor}` : "";
                o.push(_("thumbnails", (o)=>{
                    const n = o.props;
                    return (0, $TusQn.h)("img", {
                        key: "tmb#" + n.name,
                        class: `q-carousel__thumbnail q-carousel__thumbnail--${n.name === e.modelValue ? "" : "in"}active` + t,
                        src: n.imgSrc || n["img-src"],
                        onClick: ()=>{
                            u(n.name);
                        }
                    });
                }));
            }
            return !0 === e.arrows && v.value >= 0 && ((!0 === e.infinite || v.value > 0) && o.push((0, $TusQn.h)("div", {
                key: "prev",
                class: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${g.value} absolute flex flex-center`
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    icon: y.value[0],
                    ...x.value,
                    onClick: c
                })
            ])), (!0 === e.infinite || v.value < a - 1) && o.push((0, $TusQn.h)("div", {
                key: "next",
                class: "q-carousel__control q-carousel__arrow q-carousel__next-arrow" + ` q-carousel__next-arrow--${g.value} absolute flex flex-center`
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    icon: y.value[1],
                    ...x.value,
                    onClick: d
                })
            ]))), $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.control, o);
        }
        return (0, $TusQn.watch)(()=>e.modelValue, ()=>{
            e.autoplay && k();
        }), (0, $TusQn.watch)(()=>e.autoplay, (e)=>{
            e ? k() : null !== l && (clearTimeout(l), l = null);
        }), (0, $TusQn.onMounted)(()=>{
            e.autoplay && k();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            null !== l && clearTimeout(l);
        }), ()=>{
            return a = i(t), (0, $TusQn.h)("div", {
                class: b.value,
                style: f.value
            }, [
                $ec2fc4c0d7a3c6c6$var$hDir("div", {
                    class: "q-carousel__slides-container"
                }, r(), "sl-cont", e.swipeable, ()=>s.value)
            ].concat(q()));
        };
    }
}), $ec2fc4c0d7a3c6c6$export$18e00ae665ca0ca8 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCarouselSlide",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$usePanelChildProps,
        imgSrc: String
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>e.imgSrc ? {
                backgroundImage: `url("${e.imgSrc}")`
            } : {});
        return ()=>(0, $TusQn.h)("div", {
                class: "q-carousel__slide",
                style: o.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$99b8110ff6b4a7c0 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCarouselControl",
    props: {
        position: {
            type: String,
            default: "bottom-right",
            validator: (e)=>[
                    "top-right",
                    "top-left",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "right",
                    "bottom",
                    "left"
                ].includes(e)
        },
        offset: {
            type: Array,
            default: ()=>[
                    18,
                    18
                ],
            validator: (e)=>2 === e.length
        }
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>`q-carousel__control absolute absolute-${e.position}`), n = (0, $TusQn.computed)(()=>({
                margin: `${e.offset[1]}px ${e.offset[0]}px`
            }));
        return ()=>(0, $TusQn.h)("div", {
                class: o.value,
                style: n.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$f38b603ba263988 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QChatMessage",
    props: {
        sent: Boolean,
        label: String,
        bgColor: String,
        textColor: String,
        name: String,
        avatar: String,
        text: Array,
        stamp: String,
        size: String,
        labelHtml: Boolean,
        nameHtml: Boolean,
        textHtml: Boolean,
        stampHtml: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>!0 === e.sent ? "sent" : "received"), n = (0, $TusQn.computed)(()=>`q-message-text-content q-message-text-content--${o.value}` + (void 0 !== e.textColor ? ` text-${e.textColor}` : "")), a = (0, $TusQn.computed)(()=>`q-message-text q-message-text--${o.value}` + (void 0 !== e.bgColor ? ` text-${e.bgColor}` : "")), l = (0, $TusQn.computed)(()=>"q-message-container row items-end no-wrap" + (!0 === e.sent ? " reverse" : "")), i = (0, $TusQn.computed)(()=>void 0 !== e.size ? `col-${e.size}` : ""), r = (0, $TusQn.computed)(()=>({
                msg: !0 === e.textHtml ? "innerHTML" : "textContent",
                stamp: !0 === e.stampHtml ? "innerHTML" : "textContent",
                name: !0 === e.nameHtml ? "innerHTML" : "textContent",
                label: !0 === e.labelHtml ? "innerHTML" : "textContent"
            }));
        function s(o) {
            return void 0 !== t.stamp ? [
                o,
                (0, $TusQn.h)("div", {
                    class: "q-message-stamp"
                }, t.stamp())
            ] : e.stamp ? [
                o,
                (0, $TusQn.h)("div", {
                    class: "q-message-stamp",
                    [r.value.stamp]: e.stamp
                })
            ] : [
                o
            ];
        }
        function u(e, t) {
            const o = !0 === t ? e.length > 1 ? (e)=>e : (e)=>(0, $TusQn.h)("div", [
                    e
                ]) : (e)=>(0, $TusQn.h)("div", {
                    [r.value.msg]: e
                });
            return e.map((e, t)=>(0, $TusQn.h)("div", {
                    key: t,
                    class: a.value
                }, [
                    (0, $TusQn.h)("div", {
                        class: n.value
                    }, s(o(e)))
                ]));
        }
        return ()=>{
            const n = [];
            void 0 !== t.avatar ? n.push(t.avatar()) : void 0 !== e.avatar && n.push((0, $TusQn.h)("img", {
                class: `q-message-avatar q-message-avatar--${o.value}`,
                src: e.avatar,
                "aria-hidden": "true"
            }));
            const a = [];
            void 0 !== t.name ? a.push((0, $TusQn.h)("div", {
                class: `q-message-name q-message-name--${o.value}`
            }, t.name())) : void 0 !== e.name && a.push((0, $TusQn.h)("div", {
                class: `q-message-name q-message-name--${o.value}`,
                [r.value.name]: e.name
            })), void 0 !== t.default ? a.push(u($ec2fc4c0d7a3c6c6$var$getNormalizedVNodes(t.default()), !0)) : void 0 !== e.text && a.push(u(e.text)), n.push((0, $TusQn.h)("div", {
                class: i.value
            }, a));
            const s = [];
            return void 0 !== t.label ? s.push((0, $TusQn.h)("div", {
                class: "q-message-label"
            }, t.label())) : void 0 !== e.label && s.push((0, $TusQn.h)("div", {
                class: "q-message-label",
                [r.value.label]: e.label
            })), s.push((0, $TusQn.h)("div", {
                class: l.value
            }, n)), (0, $TusQn.h)("div", {
                class: `q-message q-message-${o.value}`
            }, s);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$useRefocusTarget(e, t) {
    const o = (0, $01W3b.ref)(null), n = (0, $TusQn.computed)(()=>{
        return !0 === e.disable ? null : (0, $TusQn.h)("span", {
            ref: o,
            class: "no-outline",
            tabindex: -1
        });
    });
    function a(e) {
        const n = t.value;
        void 0 !== e && 0 === e.type.indexOf("key") ? null !== n && document.activeElement !== n && !0 === n.contains(document.activeElement) && n.focus() : null !== o.value && (void 0 === e || null !== n && !0 === n.contains(e.target)) && o.value.focus();
    }
    return {
        refocusTargetEl: n,
        refocusTarget: a
    };
}
var $ec2fc4c0d7a3c6c6$var$optionSizes = {
    xs: 30,
    sm: 35,
    md: 40,
    lg: 50,
    xl: 60
};
const $ec2fc4c0d7a3c6c6$var$useCheckboxProps = {
    ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
    ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
    ...$ec2fc4c0d7a3c6c6$var$useFormProps,
    modelValue: {
        required: !0,
        default: null
    },
    val: {},
    trueValue: {
        default: !0
    },
    falseValue: {
        default: !1
    },
    indeterminateValue: {
        default: null
    },
    checkedIcon: String,
    uncheckedIcon: String,
    indeterminateIcon: String,
    toggleOrder: {
        type: String,
        validator: (e)=>"tf" === e || "ft" === e
    },
    toggleIndeterminate: Boolean,
    label: String,
    leftLabel: Boolean,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [
        String,
        Number
    ]
}, $ec2fc4c0d7a3c6c6$var$useCheckboxEmits = [
    "update:modelValue"
];
function $ec2fc4c0d7a3c6c6$var$useCheckbox(e, t) {
    const { props: o, slots: n, emit: a, proxy: l } = (0, $TusQn.getCurrentInstance)(), { $q: i } = l, r = $ec2fc4c0d7a3c6c6$var$useDark(o, i), s = (0, $01W3b.ref)(null), { refocusTargetEl: u, refocusTarget: c } = $ec2fc4c0d7a3c6c6$var$useRefocusTarget(o, s), d = $ec2fc4c0d7a3c6c6$var$useSize(o, $ec2fc4c0d7a3c6c6$var$optionSizes), p = (0, $TusQn.computed)(()=>void 0 !== o.val && Array.isArray(o.modelValue)), v = (0, $TusQn.computed)(()=>{
        const e = (0, $01W3b.toRaw)(o.val);
        return !0 === p.value ? o.modelValue.findIndex((t)=>(0, $01W3b.toRaw)(t) === e) : -1;
    }), m = (0, $TusQn.computed)(()=>!0 === p.value ? v.value > -1 : (0, $01W3b.toRaw)(o.modelValue) === (0, $01W3b.toRaw)(o.trueValue)), f = (0, $TusQn.computed)(()=>!0 === p.value ? -1 === v.value : (0, $01W3b.toRaw)(o.modelValue) === (0, $01W3b.toRaw)(o.falseValue)), g = (0, $TusQn.computed)(()=>!1 === m.value && !1 === f.value), b = (0, $TusQn.computed)(()=>!0 === o.disable ? -1 : o.tabindex || 0), y = (0, $TusQn.computed)(()=>`q-${e} cursor-pointer no-outline row inline no-wrap items-center` + (!0 === o.disable ? " disabled" : "") + (!0 === r.value ? ` q-${e}--dark` : "") + (!0 === o.dense ? ` q-${e}--dense` : "") + (!0 === o.leftLabel ? " reverse" : "")), S = (0, $TusQn.computed)(()=>{
        const t = !0 === m.value ? "truthy" : !0 === f.value ? "falsy" : "indet", n = void 0 === o.color || !0 !== o.keepColor && ("toggle" === e ? !0 !== m.value : !0 === f.value) ? "" : ` text-${o.color}`;
        return `q-${e}__inner relative-position non-selectable q-${e}__inner--${t}${n}`;
    }), w = (0, $TusQn.computed)(()=>{
        const e = {
            type: "checkbox"
        };
        return void 0 !== o.name && Object.assign(e, {
            ".checked": m.value,
            "^checked": !0 === m.value ? "checked" : void 0,
            name: o.name,
            value: !0 === p.value ? o.val : o.trueValue
        }), e;
    }), C = $ec2fc4c0d7a3c6c6$var$useFormInject(w), x = (0, $TusQn.computed)(()=>{
        const t = {
            tabindex: b.value,
            role: "toggle" === e ? "switch" : "checkbox",
            "aria-label": o.label,
            "aria-checked": !0 === g.value ? "mixed" : !0 === m.value ? "true" : "false"
        };
        return !0 === o.disable && (t["aria-disabled"] = "true"), t;
    });
    function k(e) {
        void 0 !== e && ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), c(e)), !0 !== o.disable && a("update:modelValue", _(), e);
    }
    function _() {
        if (!0 === p.value) {
            if (!0 === m.value) {
                const e = o.modelValue.slice();
                return e.splice(v.value, 1), e;
            }
            return o.modelValue.concat([
                o.val
            ]);
        }
        if (!0 === m.value) {
            if ("ft" !== o.toggleOrder || !1 === o.toggleIndeterminate) return o.falseValue;
        } else {
            if (!0 !== f.value) return "ft" !== o.toggleOrder ? o.trueValue : o.falseValue;
            if ("ft" === o.toggleOrder || !1 === o.toggleIndeterminate) return o.trueValue;
        }
        return o.indeterminateValue;
    }
    function q(e) {
        13 !== e.keyCode && 32 !== e.keyCode || $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
    }
    function T(e) {
        13 !== e.keyCode && 32 !== e.keyCode || k(e);
    }
    const P = t(m, g);
    return Object.assign(l, {
        toggle: k
    }), ()=>{
        const t = P();
        !0 !== o.disable && C(t, "unshift", ` q-${e}__native absolute q-ma-none q-pa-none`);
        const a = [
            (0, $TusQn.h)("div", {
                class: S.value,
                style: d.value,
                "aria-hidden": "true"
            }, t)
        ];
        null !== u.value && a.push(u.value);
        const l = void 0 !== o.label ? $ec2fc4c0d7a3c6c6$var$hMergeSlot(n.default, [
            o.label
        ]) : $ec2fc4c0d7a3c6c6$var$hSlot(n.default);
        return void 0 !== l && a.push((0, $TusQn.h)("div", {
            class: `q-${e}__label q-anchor--skip`
        }, l)), (0, $TusQn.h)("div", {
            ref: s,
            class: y.value,
            ...x.value,
            onClick: k,
            onKeydown: q,
            onKeyup: T
        }, a);
    };
}
const $ec2fc4c0d7a3c6c6$var$bgNode = (0, $TusQn.h)("div", {
    key: "svg",
    class: "q-checkbox__bg absolute"
}, [
    (0, $TusQn.h)("svg", {
        class: "q-checkbox__svg fit absolute-full",
        viewBox: "0 0 24 24"
    }, [
        (0, $TusQn.h)("path", {
            class: "q-checkbox__truthy",
            fill: "none",
            d: "M1.73,12.91 8.1,19.28 22.79,4.59"
        }),
        (0, $TusQn.h)("path", {
            class: "q-checkbox__indet",
            d: "M4,14H20V10H4"
        })
    ])
]);
var $ec2fc4c0d7a3c6c6$export$a3430661ad019cfb = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCheckbox",
    props: $ec2fc4c0d7a3c6c6$var$useCheckboxProps,
    emits: $ec2fc4c0d7a3c6c6$var$useCheckboxEmits,
    setup (e) {
        function t(t, o) {
            const n = (0, $TusQn.computed)(()=>(!0 === t.value ? e.checkedIcon : !0 === o.value ? e.indeterminateIcon : e.uncheckedIcon) || null);
            return ()=>null !== n.value ? [
                    (0, $TusQn.h)("div", {
                        key: "icon",
                        class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
                    }, [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                            class: "q-checkbox__icon",
                            name: n.value
                        })
                    ])
                ] : [
                    $ec2fc4c0d7a3c6c6$var$bgNode
                ];
        }
        return $ec2fc4c0d7a3c6c6$var$useCheckbox("checkbox", t);
    }
});
const $ec2fc4c0d7a3c6c6$var$defaultSizes$1 = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
};
var $ec2fc4c0d7a3c6c6$export$fe8abce8a0a972d6 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QChip",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
        dense: Boolean,
        icon: String,
        iconRight: String,
        iconRemove: String,
        iconSelected: String,
        label: [
            String,
            Number
        ],
        color: String,
        textColor: String,
        modelValue: {
            type: Boolean,
            default: !0
        },
        selected: {
            type: Boolean,
            default: null
        },
        square: Boolean,
        outline: Boolean,
        clickable: Boolean,
        removable: Boolean,
        removeAriaLabel: String,
        tabindex: [
            String,
            Number
        ],
        disable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: !0
        }
    },
    emits: [
        "update:modelValue",
        "update:selected",
        "remove",
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), l = $ec2fc4c0d7a3c6c6$var$useSize(e, $ec2fc4c0d7a3c6c6$var$defaultSizes$1), i = (0, $TusQn.computed)(()=>!0 === e.selected || void 0 !== e.icon), r = (0, $TusQn.computed)(()=>!0 === e.selected ? e.iconSelected || n.iconSet.chip.selected : e.icon), s = (0, $TusQn.computed)(()=>e.iconRemove || n.iconSet.chip.remove), u = (0, $TusQn.computed)(()=>!1 === e.disable && (!0 === e.clickable || null !== e.selected)), c = (0, $TusQn.computed)(()=>{
            const t = !0 === e.outline && e.color || e.textColor;
            return "q-chip row inline no-wrap items-center" + (!1 === e.outline && void 0 !== e.color ? ` bg-${e.color}` : "") + (t ? ` text-${t} q-chip--colored` : "") + (!0 === e.disable ? " disabled" : "") + (!0 === e.dense ? " q-chip--dense" : "") + (!0 === e.outline ? " q-chip--outline" : "") + (!0 === e.selected ? " q-chip--selected" : "") + (!0 === u.value ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (!0 === e.square ? " q-chip--square" : "") + (!0 === a.value ? " q-chip--dark q-dark" : "");
        }), d = (0, $TusQn.computed)(()=>{
            const t = !0 === e.disable ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: e.tabindex || 0
            }, o = {
                ...t,
                role: "button",
                "aria-hidden": "false",
                "aria-label": e.removeAriaLabel || n.lang.label.remove
            };
            return {
                chip: t,
                remove: o
            };
        });
        function p(e) {
            13 === e.keyCode && v(e);
        }
        function v(t) {
            e.disable || (o("update:selected", !e.selected), o("click", t));
        }
        function m(t) {
            void 0 !== t.keyCode && 13 !== t.keyCode || ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), !1 === e.disable && (o("update:modelValue", !1), o("remove")));
        }
        function f() {
            const o = [];
            !0 === u.value && o.push((0, $TusQn.h)("div", {
                class: "q-focus-helper"
            })), !0 === i.value && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: "q-chip__icon q-chip__icon--left",
                name: r.value
            }));
            const n = void 0 !== e.label ? [
                (0, $TusQn.h)("div", {
                    class: "ellipsis"
                }, [
                    e.label
                ])
            ] : void 0;
            return o.push((0, $TusQn.h)("div", {
                class: "q-chip__content col row no-wrap items-center q-anchor--skip"
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlotSafely(t.default, n))), e.iconRight && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: "q-chip__icon q-chip__icon--right",
                name: e.iconRight
            })), !0 === e.removable && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: "q-chip__icon q-chip__icon--remove cursor-pointer",
                name: s.value,
                ...d.value.remove,
                onClick: m,
                onKeyup: m
            })), o;
        }
        return ()=>{
            if (!1 === e.modelValue) return;
            const t = {
                class: c.value,
                style: l.value
            };
            return !0 === u.value && Object.assign(t, d.value.chip, {
                onClick: v,
                onKeyup: p
            }), $ec2fc4c0d7a3c6c6$var$hDir("div", t, f(), "ripple", !1 !== e.ripple && !0 !== e.disable, ()=>[
                    [
                        $ec2fc4c0d7a3c6c6$export$9e9146f7e027fdaa,
                        e.ripple
                    ]
                ]);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$useCircularCommonProps = {
    ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    color: String,
    centerColor: String,
    trackColor: String,
    fontSize: String,
    rounded: Boolean,
    thickness: {
        type: Number,
        default: .2,
        validator: (e)=>e >= 0 && e <= 1
    },
    angle: {
        type: Number,
        default: 0
    },
    showValue: Boolean,
    reverse: Boolean,
    instantFeedback: Boolean
}, $ec2fc4c0d7a3c6c6$var$radius = 50, $ec2fc4c0d7a3c6c6$var$diameter = 2 * $ec2fc4c0d7a3c6c6$var$radius, $ec2fc4c0d7a3c6c6$var$circumference = $ec2fc4c0d7a3c6c6$var$diameter * Math.PI, $ec2fc4c0d7a3c6c6$var$strokeDashArray = Math.round(1e3 * $ec2fc4c0d7a3c6c6$var$circumference) / 1e3;
var $ec2fc4c0d7a3c6c6$export$3bbfcedf93eff7f7 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QCircularProgress",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useCircularCommonProps,
        value: {
            type: Number,
            default: 0
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        indeterminate: Boolean
    },
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useSize(e), a = (0, $TusQn.computed)(()=>{
            const t = (!0 === o.lang.rtl ? -1 : 1) * e.angle;
            return {
                transform: e.reverse !== (!0 === o.lang.rtl) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - t}deg)` : `rotate3d(0, 0, 1, ${t - 90}deg)`
            };
        }), l = (0, $TusQn.computed)(()=>!0 !== e.instantFeedback && !0 !== e.indeterminate ? {
                transition: `stroke-dashoffset ${e.animationSpeed}ms ease 0s, stroke ${e.animationSpeed}ms ease`
            } : ""), i = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$diameter / (1 - e.thickness / 2)), r = (0, $TusQn.computed)(()=>`${i.value / 2} ${i.value / 2} ${i.value} ${i.value}`), s = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$between(e.value, e.min, e.max)), u = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$circumference * (1 - (s.value - e.min) / (e.max - e.min))), c = (0, $TusQn.computed)(()=>e.thickness / 2 * i.value);
        function d({ thickness: e, offset: t, color: o, cls: n, rounded: a }) {
            return (0, $TusQn.h)("circle", {
                class: "q-circular-progress__" + n + (void 0 !== o ? ` text-${o}` : ""),
                style: l.value,
                fill: "transparent",
                stroke: "currentColor",
                "stroke-width": e,
                "stroke-dasharray": $ec2fc4c0d7a3c6c6$var$strokeDashArray,
                "stroke-dashoffset": t,
                "stroke-linecap": a,
                cx: i.value,
                cy: i.value,
                r: $ec2fc4c0d7a3c6c6$var$radius
            });
        }
        return ()=>{
            const o = [];
            void 0 !== e.centerColor && "transparent" !== e.centerColor && o.push((0, $TusQn.h)("circle", {
                class: `q-circular-progress__center text-${e.centerColor}`,
                fill: "currentColor",
                r: $ec2fc4c0d7a3c6c6$var$radius - c.value / 2,
                cx: i.value,
                cy: i.value
            })), void 0 !== e.trackColor && "transparent" !== e.trackColor && o.push(d({
                cls: "track",
                thickness: c.value,
                offset: 0,
                color: e.trackColor
            })), o.push(d({
                cls: "circle",
                thickness: c.value,
                offset: u.value,
                color: e.color,
                rounded: !0 === e.rounded ? "round" : void 0
            }));
            const l = [
                (0, $TusQn.h)("svg", {
                    class: "q-circular-progress__svg",
                    style: a.value,
                    viewBox: r.value,
                    "aria-hidden": "true"
                }, o)
            ];
            return !0 === e.showValue && l.push((0, $TusQn.h)("div", {
                class: "q-circular-progress__text absolute-full row flex-center content-center",
                style: {
                    fontSize: e.fontSize
                }
            }, void 0 !== t.default ? t.default() : [
                (0, $TusQn.h)("div", s.value)
            ])), (0, $TusQn.h)("div", {
                class: `q-circular-progress q-circular-progress--${!0 === e.indeterminate ? "in" : ""}determinate`,
                style: n.value,
                role: "progressbar",
                "aria-valuemin": e.min,
                "aria-valuemax": e.max,
                "aria-valuenow": !0 === e.indeterminate ? void 0 : s.value
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlotSafely(t.internal, l));
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$getChanges(e, t, o) {
    const n = $ec2fc4c0d7a3c6c6$var$position(e);
    let a, l = n.left - t.event.x, i = n.top - t.event.y, r = Math.abs(l), s = Math.abs(i);
    const u = t.direction;
    !0 === u.horizontal && !0 !== u.vertical ? a = l < 0 ? "left" : "right" : !0 !== u.horizontal && !0 === u.vertical ? a = i < 0 ? "up" : "down" : !0 === u.up && i < 0 ? (a = "up", r > s && (!0 === u.left && l < 0 ? a = "left" : !0 === u.right && l > 0 && (a = "right"))) : !0 === u.down && i > 0 ? (a = "down", r > s && (!0 === u.left && l < 0 ? a = "left" : !0 === u.right && l > 0 && (a = "right"))) : !0 === u.left && l < 0 ? (a = "left", r < s && (!0 === u.up && i < 0 ? a = "up" : !0 === u.down && i > 0 && (a = "down"))) : !0 === u.right && l > 0 && (a = "right", r < s && (!0 === u.up && i < 0 ? a = "up" : !0 === u.down && i > 0 && (a = "down")));
    let c = !1;
    if (void 0 === a && !1 === o) {
        if (!0 === t.event.isFirst || void 0 === t.event.lastDir) return {};
        a = t.event.lastDir, c = !0, "left" === a || "right" === a ? (n.left -= l, r = 0, l = 0) : (n.top -= i, s = 0, i = 0);
    }
    return {
        synthetic: c,
        payload: {
            evt: e,
            touch: !0 !== t.event.mouse,
            mouse: !0 === t.event.mouse,
            position: n,
            direction: a,
            isFirst: t.event.isFirst,
            isFinal: !0 === o,
            duration: Date.now() - t.event.time,
            distance: {
                x: r,
                y: s
            },
            offset: {
                x: l,
                y: i
            },
            delta: {
                x: n.left - t.event.lastX,
                y: n.top - t.event.lastY
            }
        }
    };
}
let $ec2fc4c0d7a3c6c6$var$uid$2 = 0;
var $ec2fc4c0d7a3c6c6$export$718797250d1e376 = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "touch-pan",
    beforeMount (e, { value: t, modifiers: o }) {
        if (!0 !== o.mouse && !0 !== $ec2fc4c0d7a3c6c6$var$client.has.touch) return;
        function n(e, t) {
            !0 === o.mouse && !0 === t ? $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e) : (!0 === o.stop && $ec2fc4c0d7a3c6c6$var$stop(e), !0 === o.prevent && $ec2fc4c0d7a3c6c6$var$prevent(e));
        }
        const a = {
            uid: "qvtp_" + $ec2fc4c0d7a3c6c6$var$uid$2++,
            handler: t,
            modifiers: o,
            direction: $ec2fc4c0d7a3c6c6$var$getModifierDirections(o),
            noop: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
            mouseStart (e) {
                $ec2fc4c0d7a3c6c6$var$shouldStart(e, a) && $ec2fc4c0d7a3c6c6$var$leftClick(e) && ($ec2fc4c0d7a3c6c6$var$addEvt(a, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "notPassiveCapture"
                    ],
                    [
                        document,
                        "mouseup",
                        "end",
                        "passiveCapture"
                    ]
                ]), a.start(e, !0));
            },
            touchStart (e) {
                if ($ec2fc4c0d7a3c6c6$var$shouldStart(e, a)) {
                    const t = e.target;
                    $ec2fc4c0d7a3c6c6$var$addEvt(a, "temp", [
                        [
                            t,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            t,
                            "touchcancel",
                            "end",
                            "passiveCapture"
                        ],
                        [
                            t,
                            "touchend",
                            "end",
                            "passiveCapture"
                        ]
                    ]), a.start(e);
                }
            },
            start (t, n) {
                if (!0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox && $ec2fc4c0d7a3c6c6$var$preventDraggable(e, !0), a.lastEvt = t, !0 === n || !0 === o.stop) {
                    if (!0 !== a.direction.all && (!0 !== n || !0 !== a.modifiers.mouseAllDir && !0 !== a.modifiers.mousealldir)) {
                        const e = t.type.indexOf("mouse") > -1 ? new MouseEvent(t.type, t) : new TouchEvent(t.type, t);
                        !0 === t.defaultPrevented && $ec2fc4c0d7a3c6c6$var$prevent(e), !0 === t.cancelBubble && $ec2fc4c0d7a3c6c6$var$stop(e), Object.assign(e, {
                            qKeyEvent: t.qKeyEvent,
                            qClickOutside: t.qClickOutside,
                            qAnchorHandled: t.qAnchorHandled,
                            qClonedBy: void 0 === t.qClonedBy ? [
                                a.uid
                            ] : t.qClonedBy.concat(a.uid)
                        }), a.initialEvent = {
                            target: t.target,
                            event: e
                        };
                    }
                    $ec2fc4c0d7a3c6c6$var$stop(t);
                }
                const { left: l, top: i } = $ec2fc4c0d7a3c6c6$var$position(t);
                a.event = {
                    x: l,
                    y: i,
                    time: Date.now(),
                    mouse: !0 === n,
                    detected: !1,
                    isFirst: !0,
                    isFinal: !1,
                    lastX: l,
                    lastY: i
                };
            },
            move (e) {
                if (void 0 === a.event) return;
                const t = $ec2fc4c0d7a3c6c6$var$position(e), l = t.left - a.event.x, i = t.top - a.event.y;
                if (0 === l && 0 === i) return;
                a.lastEvt = e;
                const r = !0 === a.event.mouse, s = ()=>{
                    let t;
                    n(e, r), !0 !== o.preserveCursor && !0 !== o.preservecursor && (t = document.documentElement.style.cursor || "", document.documentElement.style.cursor = "grabbing"), !0 === r && document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), $ec2fc4c0d7a3c6c6$var$clearSelection(), a.styleCleanup = (e)=>{
                        if (a.styleCleanup = void 0, void 0 !== t && (document.documentElement.style.cursor = t), document.body.classList.remove("non-selectable"), !0 === r) {
                            const t = ()=>{
                                document.body.classList.remove("no-pointer-events--children");
                            };
                            void 0 !== e ? setTimeout(()=>{
                                t(), e();
                            }, 50) : t();
                        } else void 0 !== e && e();
                    };
                };
                if (!0 === a.event.detected) {
                    !0 !== a.event.isFirst && n(e, a.event.mouse);
                    const { payload: t, synthetic: o } = $ec2fc4c0d7a3c6c6$var$getChanges(e, a, !1);
                    return void (void 0 !== t && (!1 === a.handler(t) ? a.end(e) : (void 0 === a.styleCleanup && !0 === a.event.isFirst && s(), a.event.lastX = t.position.left, a.event.lastY = t.position.top, a.event.lastDir = !0 === o ? void 0 : t.direction, a.event.isFirst = !1)));
                }
                if (!0 === a.direction.all || !0 === r && (!0 === a.modifiers.mouseAllDir || !0 === a.modifiers.mousealldir)) return s(), a.event.detected = !0, void a.move(e);
                const u = Math.abs(l), c = Math.abs(i);
                u !== c && (!0 === a.direction.horizontal && u > c || !0 === a.direction.vertical && u < c || !0 === a.direction.up && u < c && i < 0 || !0 === a.direction.down && u < c && i > 0 || !0 === a.direction.left && u > c && l < 0 || !0 === a.direction.right && u > c && l > 0 ? (a.event.detected = !0, a.move(e)) : a.end(e, !0));
            },
            end (t, o) {
                if (void 0 !== a.event) {
                    if ($ec2fc4c0d7a3c6c6$var$cleanEvt(a, "temp"), !0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox && $ec2fc4c0d7a3c6c6$var$preventDraggable(e, !1), !0 === o) void 0 !== a.styleCleanup && a.styleCleanup(), !0 !== a.event.detected && void 0 !== a.initialEvent && a.initialEvent.target.dispatchEvent(a.initialEvent.event);
                    else if (!0 === a.event.detected) {
                        !0 === a.event.isFirst && a.handler($ec2fc4c0d7a3c6c6$var$getChanges(void 0 === t ? a.lastEvt : t, a).payload);
                        const { payload: e } = $ec2fc4c0d7a3c6c6$var$getChanges(void 0 === t ? a.lastEvt : t, a, !0), o = ()=>{
                            a.handler(e);
                        };
                        void 0 !== a.styleCleanup ? a.styleCleanup(o) : o();
                    }
                    a.event = void 0, a.initialEvent = void 0, a.lastEvt = void 0;
                }
            }
        };
        if (e.__qtouchpan = a, !0 === o.mouse) {
            const t = !0 === o.mouseCapture || !0 === o.mousecapture ? "Capture" : "";
            $ec2fc4c0d7a3c6c6$var$addEvt(a, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${t}`
                ]
            ]);
        }
        !0 === $ec2fc4c0d7a3c6c6$var$client.has.touch && $ec2fc4c0d7a3c6c6$var$addEvt(a, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${!0 === o.capture ? "Capture" : ""}`
            ],
            [
                e,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (e, t) {
        const o = e.__qtouchpan;
        void 0 !== o && (t.oldValue !== t.value && ("function" !== typeof value && o.end(), o.handler = t.value), o.direction = $ec2fc4c0d7a3c6c6$var$getModifierDirections(t.modifiers));
    },
    beforeUnmount (e) {
        const t = e.__qtouchpan;
        void 0 !== t && (void 0 !== t.event && t.end(), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "main"), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "temp"), !0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox && $ec2fc4c0d7a3c6c6$var$preventDraggable(e, !1), void 0 !== t.styleCleanup && t.styleCleanup(), delete e.__qtouchpan);
    }
});
const $ec2fc4c0d7a3c6c6$var$markerPrefixClass = "q-slider__marker-labels", $ec2fc4c0d7a3c6c6$var$defaultMarkerConvertFn = (e)=>({
        value: e
    }), $ec2fc4c0d7a3c6c6$var$defaultMarkerLabelRenderFn = ({ marker: e })=>(0, $TusQn.h)("div", {
        key: e.value,
        style: e.style,
        class: e.classes
    }, e.label), $ec2fc4c0d7a3c6c6$var$keyCodes$2 = [
    34,
    37,
    40,
    33,
    39,
    38
], $ec2fc4c0d7a3c6c6$var$useSliderProps = {
    ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
    ...$ec2fc4c0d7a3c6c6$var$useFormProps,
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    innerMin: Number,
    innerMax: Number,
    step: {
        type: Number,
        default: 1,
        validator: (e)=>e >= 0
    },
    snap: Boolean,
    vertical: Boolean,
    reverse: Boolean,
    hideSelection: Boolean,
    color: String,
    markerLabelsClass: String,
    label: Boolean,
    labelColor: String,
    labelTextColor: String,
    labelAlways: Boolean,
    switchLabelSide: Boolean,
    markers: [
        Boolean,
        Number
    ],
    markerLabels: [
        Boolean,
        Array,
        Object,
        Function
    ],
    switchMarkerLabelsSide: Boolean,
    trackImg: String,
    trackColor: String,
    innerTrackImg: String,
    innerTrackColor: String,
    selectionColor: String,
    selectionImg: String,
    thumbSize: {
        type: String,
        default: "20px"
    },
    trackSize: {
        type: String,
        default: "4px"
    },
    disable: Boolean,
    readonly: Boolean,
    dense: Boolean,
    tabindex: [
        String,
        Number
    ],
    thumbColor: String,
    thumbPath: {
        type: String,
        default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
    }
}, $ec2fc4c0d7a3c6c6$var$useSliderEmits = [
    "pan",
    "update:modelValue",
    "change"
];
function $ec2fc4c0d7a3c6c6$var$useSlider({ updateValue: e, updatePosition: t, getDragging: o, formAttrs: n }) {
    const { props: a, emit: l, slots: i, proxy: { $q: r } } = (0, $TusQn.getCurrentInstance)(), s = $ec2fc4c0d7a3c6c6$var$useDark(a, r), u = $ec2fc4c0d7a3c6c6$var$useFormInject(n), c = (0, $01W3b.ref)(!1), d = (0, $01W3b.ref)(!1), p = (0, $01W3b.ref)(!1), v = (0, $01W3b.ref)(!1), m = (0, $TusQn.computed)(()=>!0 === a.vertical ? "--v" : "--h"), f = (0, $TusQn.computed)(()=>"-" + (!0 === a.switchLabelSide ? "switched" : "standard")), g = (0, $TusQn.computed)(()=>!0 === a.vertical ? !0 === a.reverse : a.reverse !== (!0 === r.lang.rtl)), b = (0, $TusQn.computed)(()=>!0 === isNaN(a.innerMin) || a.innerMin < a.min ? a.min : a.innerMin), y = (0, $TusQn.computed)(()=>!0 === isNaN(a.innerMax) || a.innerMax > a.max ? a.max : a.innerMax), S = (0, $TusQn.computed)(()=>!0 !== a.disable && !0 !== a.readonly && b.value < y.value), w = (0, $TusQn.computed)(()=>(String(a.step).trim().split(".")[1] || "").length), C = (0, $TusQn.computed)(()=>0 === a.step ? 1 : a.step), x = (0, $TusQn.computed)(()=>!0 === S.value ? a.tabindex || 0 : -1), k = (0, $TusQn.computed)(()=>a.max - a.min), _ = (0, $TusQn.computed)(()=>y.value - b.value), q = (0, $TusQn.computed)(()=>W(b.value)), T = (0, $TusQn.computed)(()=>W(y.value)), P = (0, $TusQn.computed)(()=>!0 === a.vertical ? !0 === g.value ? "bottom" : "top" : !0 === g.value ? "right" : "left"), $ = (0, $TusQn.computed)(()=>!0 === a.vertical ? "height" : "width"), M = (0, $TusQn.computed)(()=>!0 === a.vertical ? "width" : "height"), B = (0, $TusQn.computed)(()=>!0 === a.vertical ? "vertical" : "horizontal"), E = (0, $TusQn.computed)(()=>{
        const e = {
            role: "slider",
            "aria-valuemin": b.value,
            "aria-valuemax": y.value,
            "aria-orientation": B.value,
            "data-step": a.step
        };
        return !0 === a.disable ? e["aria-disabled"] = "true" : !0 === a.readonly && (e["aria-readonly"] = "true"), e;
    }), Q = (0, $TusQn.computed)(()=>`q-slider q-slider${m.value} q-slider--${!0 === c.value ? "" : "in"}active inline no-wrap ` + (!0 === a.vertical ? "row" : "column") + (!0 === a.disable ? " disabled" : " q-slider--enabled" + (!0 === S.value ? " q-slider--editable" : "")) + ("both" === p.value ? " q-slider--focus" : "") + (a.label || !0 === a.labelAlways ? " q-slider--label" : "") + (!0 === a.labelAlways ? " q-slider--label-always" : "") + (!0 === s.value ? " q-slider--dark" : "") + (!0 === a.dense ? " q-slider--dense q-slider--dense" + m.value : ""));
    function A(e) {
        const t = "q-slider__" + e;
        return `${t} ${t}${m.value} ${t}${m.value}${f.value}`;
    }
    function L(e) {
        const t = "q-slider__" + e;
        return `${t} ${t}${m.value}`;
    }
    const O = (0, $TusQn.computed)(()=>{
        const e = a.selectionColor || a.color;
        return "q-slider__selection absolute" + (void 0 !== e ? ` text-${e}` : "");
    }), F = (0, $TusQn.computed)(()=>L("markers") + " absolute overflow-hidden"), R = (0, $TusQn.computed)(()=>L("track-container")), D = (0, $TusQn.computed)(()=>A("pin")), z = (0, $TusQn.computed)(()=>A("label")), I = (0, $TusQn.computed)(()=>A("text-container")), V = (0, $TusQn.computed)(()=>A("marker-labels-container") + (void 0 !== a.markerLabelsClass ? ` ${a.markerLabelsClass}` : "")), H = (0, $TusQn.computed)(()=>"q-slider__track relative-position no-outline" + (void 0 !== a.trackColor ? ` bg-${a.trackColor}` : "")), N = (0, $TusQn.computed)(()=>{
        const e = {
            [M.value]: a.trackSize
        };
        return void 0 !== a.trackImg && (e.backgroundImage = `url(${a.trackImg}) !important`), e;
    }), j = (0, $TusQn.computed)(()=>"q-slider__inner absolute" + (void 0 !== a.innerTrackColor ? ` bg-${a.innerTrackColor}` : "")), U = (0, $TusQn.computed)(()=>{
        const e = {
            [P.value]: `${100 * q.value}%`,
            [$.value]: `${100 * (T.value - q.value)}%`
        };
        return void 0 !== a.innerTrackImg && (e.backgroundImage = `url(${a.innerTrackImg}) !important`), e;
    });
    function K(e) {
        const { min: t, max: o, step: n } = a;
        let l = t + e * (o - t);
        if (n > 0) {
            const e = (l - t) % n;
            l += (Math.abs(e) >= n / 2 ? (e < 0 ? -1 : 1) * n : 0) - e;
        }
        return w.value > 0 && (l = parseFloat(l.toFixed(w.value))), $ec2fc4c0d7a3c6c6$var$between(l, b.value, y.value);
    }
    function W(e) {
        return 0 === k.value ? 0 : (e - a.min) / k.value;
    }
    function Y(e, t) {
        const o = $ec2fc4c0d7a3c6c6$var$position(e), n = !0 === a.vertical ? $ec2fc4c0d7a3c6c6$var$between((o.top - t.top) / t.height, 0, 1) : $ec2fc4c0d7a3c6c6$var$between((o.left - t.left) / t.width, 0, 1);
        return $ec2fc4c0d7a3c6c6$var$between(!0 === g.value ? 1 - n : n, q.value, T.value);
    }
    const G = (0, $TusQn.computed)(()=>!0 === $ec2fc4c0d7a3c6c6$var$isNumber(a.markers) ? a.markers : C.value), X = (0, $TusQn.computed)(()=>{
        const e = [], t = G.value, o = a.max;
        let n = a.min;
        do e.push(n), n += t;
        while (n < o);
        return e.push(o), e;
    }), Z = (0, $TusQn.computed)(()=>{
        const e = ` ${$ec2fc4c0d7a3c6c6$var$markerPrefixClass}${m.value}-`;
        return $ec2fc4c0d7a3c6c6$var$markerPrefixClass + `${e}${!0 === a.switchMarkerLabelsSide ? "switched" : "standard"}` + `${e}${!0 === g.value ? "rtl" : "ltr"}`;
    }), J = (0, $TusQn.computed)(()=>{
        return !1 === a.markerLabels ? null : oe(a.markerLabels).map((e, t)=>({
                index: t,
                value: e.value,
                label: e.label || e.value,
                classes: Z.value + (void 0 !== e.classes ? " " + e.classes : ""),
                style: {
                    ...ne(e.value),
                    ...e.style || {}
                }
            }));
    }), ee = (0, $TusQn.computed)(()=>({
            markerList: J.value,
            markerMap: ae.value,
            classes: Z.value,
            getStyle: ne
        })), te = (0, $TusQn.computed)(()=>{
        if (0 !== _.value) {
            const e = 100 * G.value / _.value;
            return {
                ...U.value,
                backgroundSize: !0 === a.vertical ? `2px ${e}%` : `${e}% 2px`
            };
        }
        return null;
    });
    function oe(e) {
        if (!1 === e) return null;
        if (!0 === e) return X.value.map($ec2fc4c0d7a3c6c6$var$defaultMarkerConvertFn);
        if ("function" === typeof e) return X.value.map((t)=>{
            const o = e(t);
            return !0 === $ec2fc4c0d7a3c6c6$var$isObject(o) ? {
                ...o,
                value: t
            } : {
                value: t,
                label: o
            };
        });
        const t = ({ value: e })=>e >= a.min && e <= a.max;
        return !0 === Array.isArray(e) ? e.map((e)=>!0 === $ec2fc4c0d7a3c6c6$var$isObject(e) ? e : {
                value: e
            }).filter(t) : Object.keys(e).map((t)=>{
            const o = e[t], n = Number(t);
            return !0 === $ec2fc4c0d7a3c6c6$var$isObject(o) ? {
                ...o,
                value: n
            } : {
                value: n,
                label: o
            };
        }).filter(t);
    }
    function ne(e) {
        return {
            [P.value]: `${100 * (e - a.min) / k.value}%`
        };
    }
    const ae = (0, $TusQn.computed)(()=>{
        if (!1 === a.markerLabels) return null;
        const e = {};
        return J.value.forEach((t)=>{
            e[t.value] = t;
        }), e;
    });
    function le() {
        if (void 0 !== i["marker-label-group"]) return i["marker-label-group"](ee.value);
        const e = i["marker-label"] || $ec2fc4c0d7a3c6c6$var$defaultMarkerLabelRenderFn;
        return J.value.map((t)=>e({
                marker: t,
                ...ee.value
            }));
    }
    const ie = (0, $TusQn.computed)(()=>{
        return [
            [
                $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                re,
                void 0,
                {
                    [B.value]: !0,
                    prevent: !0,
                    stop: !0,
                    mouse: !0,
                    mouseAllDir: !0
                }
            ]
        ];
    });
    function re(n) {
        !0 === n.isFinal ? (void 0 !== v.value && (t(n.evt), !0 === n.touch && e(!0), v.value = void 0, l("pan", "end")), c.value = !1, p.value = !1) : !0 === n.isFirst ? (v.value = o(n.evt), t(n.evt), e(), c.value = !0, l("pan", "start")) : (t(n.evt), e());
    }
    function se() {
        p.value = !1;
    }
    function ue(n) {
        t(n, o(n)), e(), d.value = !0, c.value = !0, document.addEventListener("mouseup", ce, !0);
    }
    function ce() {
        d.value = !1, c.value = !1, e(!0), se(), document.removeEventListener("mouseup", ce, !0);
    }
    function de(n) {
        t(n, o(n)), e(!0);
    }
    function pe(t) {
        $ec2fc4c0d7a3c6c6$var$keyCodes$2.includes(t.keyCode) && e(!0);
    }
    function ve(e) {
        if (!0 === a.vertical) return null;
        const t = r.lang.rtl !== a.reverse ? 1 - e : e;
        return {
            transform: `translateX(calc(${2 * t - 1} * ${a.thumbSize} / 2 + ${50 - 100 * t}%))`
        };
    }
    function me(e) {
        const t = (0, $TusQn.computed)(()=>!1 !== d.value || p.value !== e.focusValue && "both" !== p.value ? "" : " q-slider--focus"), o = (0, $TusQn.computed)(()=>`q-slider__thumb q-slider__thumb${m.value} q-slider__thumb${m.value}-${!0 === g.value ? "rtl" : "ltr"} absolute non-selectable` + t.value + (void 0 !== e.thumbColor.value ? ` text-${e.thumbColor.value}` : "")), n = (0, $TusQn.computed)(()=>({
                width: a.thumbSize,
                height: a.thumbSize,
                [P.value]: `${100 * e.ratio.value}%`,
                zIndex: p.value === e.focusValue ? 2 : void 0
            })), l = (0, $TusQn.computed)(()=>void 0 !== e.labelColor.value ? ` text-${e.labelColor.value}` : ""), i = (0, $TusQn.computed)(()=>ve(e.ratio.value)), r = (0, $TusQn.computed)(()=>"q-slider__text" + (void 0 !== e.labelTextColor.value ? ` text-${e.labelTextColor.value}` : ""));
        return ()=>{
            const t = [
                (0, $TusQn.h)("svg", {
                    class: "q-slider__thumb-shape absolute-full",
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                }, [
                    (0, $TusQn.h)("path", {
                        d: a.thumbPath
                    })
                ]),
                (0, $TusQn.h)("div", {
                    class: "q-slider__focus-ring fit"
                })
            ];
            return !0 !== a.label && !0 !== a.labelAlways || (t.push((0, $TusQn.h)("div", {
                class: D.value + " absolute fit no-pointer-events" + l.value
            }, [
                (0, $TusQn.h)("div", {
                    class: z.value,
                    style: {
                        minWidth: a.thumbSize
                    }
                }, [
                    (0, $TusQn.h)("div", {
                        class: I.value,
                        style: i.value
                    }, [
                        (0, $TusQn.h)("span", {
                            class: r.value
                        }, e.label.value)
                    ])
                ])
            ])), void 0 !== a.name && !0 !== a.disable && u(t, "push")), (0, $TusQn.h)("div", {
                class: o.value,
                style: n.value,
                ...e.getNodeData()
            }, t);
        };
    }
    function fe(e, t, o, n) {
        const l = [];
        "transparent" !== a.innerTrackColor && l.push((0, $TusQn.h)("div", {
            key: "inner",
            class: j.value,
            style: U.value
        })), "transparent" !== a.selectionColor && l.push((0, $TusQn.h)("div", {
            key: "selection",
            class: O.value,
            style: e.value
        })), !1 !== a.markers && l.push((0, $TusQn.h)("div", {
            key: "marker",
            class: F.value,
            style: te.value
        })), n(l);
        const i = [
            $ec2fc4c0d7a3c6c6$var$hDir("div", {
                key: "trackC",
                class: R.value,
                tabindex: t.value,
                ...o.value
            }, [
                (0, $TusQn.h)("div", {
                    class: H.value,
                    style: N.value
                }, l)
            ], "slide", S.value, ()=>ie.value)
        ];
        if (!1 !== a.markerLabels) {
            const e = !0 === a.switchMarkerLabelsSide ? "unshift" : "push";
            i[e]((0, $TusQn.h)("div", {
                key: "markerL",
                class: V.value
            }, le()));
        }
        return i;
    }
    return (0, $TusQn.onBeforeUnmount)(()=>{
        document.removeEventListener("mouseup", ce, !0);
    }), {
        state: {
            active: c,
            focus: p,
            preventFocus: d,
            dragging: v,
            editable: S,
            classes: Q,
            tabindex: x,
            attributes: E,
            step: C,
            decimals: w,
            trackLen: k,
            innerMin: b,
            innerMinRatio: q,
            innerMax: y,
            innerMaxRatio: T,
            positionProp: P,
            sizeProp: $,
            isReversed: g
        },
        methods: {
            onActivate: ue,
            onMobileClick: de,
            onBlur: se,
            onKeyup: pe,
            getContent: fe,
            getThumbRenderFn: me,
            convertRatioToModel: K,
            convertModelToRatio: W,
            getDraggingRatio: Y
        }
    };
}
const $ec2fc4c0d7a3c6c6$var$getNodeData = ()=>({});
var $ec2fc4c0d7a3c6c6$export$eccd46d4261ec748 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSlider",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useSliderProps,
        modelValue: {
            required: !0,
            default: null,
            validator: (e)=>"number" === typeof e || null === e
        },
        labelValue: [
            String,
            Number
        ]
    },
    emits: $ec2fc4c0d7a3c6c6$var$useSliderEmits,
    setup (e, { emit: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), { state: n, methods: a } = $ec2fc4c0d7a3c6c6$var$useSlider({
            updateValue: m,
            updatePosition: g,
            getDragging: f,
            formAttrs: $ec2fc4c0d7a3c6c6$var$useFormAttrs(e)
        }), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(0), r = (0, $01W3b.ref)(0);
        function s() {
            r.value = null === e.modelValue ? n.innerMin.value : $ec2fc4c0d7a3c6c6$var$between(e.modelValue, n.innerMin.value, n.innerMax.value);
        }
        (0, $TusQn.watch)(()=>`${e.modelValue}|${n.innerMin.value}|${n.innerMax.value}`, s), s();
        const u = (0, $TusQn.computed)(()=>a.convertModelToRatio(r.value)), c = (0, $TusQn.computed)(()=>!0 === n.active.value ? i.value : u.value), d = (0, $TusQn.computed)(()=>{
            const t = {
                [n.positionProp.value]: `${100 * n.innerMinRatio.value}%`,
                [n.sizeProp.value]: `${100 * (c.value - n.innerMinRatio.value)}%`
            };
            return void 0 !== e.selectionImg && (t.backgroundImage = `url(${e.selectionImg}) !important`), t;
        }), p = a.getThumbRenderFn({
            focusValue: !0,
            getNodeData: $ec2fc4c0d7a3c6c6$var$getNodeData,
            ratio: c,
            label: (0, $TusQn.computed)(()=>void 0 !== e.labelValue ? e.labelValue : r.value),
            thumbColor: (0, $TusQn.computed)(()=>e.thumbColor || e.color),
            labelColor: (0, $TusQn.computed)(()=>e.labelColor),
            labelTextColor: (0, $TusQn.computed)(()=>e.labelTextColor)
        }), v = (0, $TusQn.computed)(()=>{
            return !0 !== n.editable.value ? {} : !0 === o.platform.is.mobile ? {
                onClick: a.onMobileClick
            } : {
                onMousedown: a.onActivate,
                onFocus: b,
                onBlur: a.onBlur,
                onKeydown: y,
                onKeyup: a.onKeyup
            };
        });
        function m(o) {
            r.value !== e.modelValue && t("update:modelValue", r.value), !0 === o && t("change", r.value);
        }
        function f() {
            return l.value.getBoundingClientRect();
        }
        function g(t, o = n.dragging.value) {
            const l = a.getDraggingRatio(t, o);
            r.value = a.convertRatioToModel(l), i.value = !0 !== e.snap || 0 === e.step ? l : a.convertModelToRatio(r.value);
        }
        function b() {
            n.focus.value = !0;
        }
        function y(t) {
            if (!$ec2fc4c0d7a3c6c6$var$keyCodes$2.includes(t.keyCode)) return;
            $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t);
            const o = ([
                34,
                33
            ].includes(t.keyCode) ? 10 : 1) * n.step.value, a = ([
                34,
                37,
                40
            ].includes(t.keyCode) ? -1 : 1) * (!0 === n.isReversed.value ? -1 : 1) * (!0 === e.vertical ? -1 : 1) * o;
            r.value = $ec2fc4c0d7a3c6c6$var$between(parseFloat((r.value + a).toFixed(n.decimals.value)), n.innerMin.value, n.innerMax.value), m();
        }
        return ()=>{
            const t = a.getContent(d, n.tabindex, v, (e)=>{
                e.push(p());
            });
            return (0, $TusQn.h)("div", {
                ref: l,
                class: n.classes.value + (null === e.modelValue ? " q-slider--no-value" : ""),
                ...n.attributes.value,
                "aria-valuenow": e.modelValue
            }, t);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$useCanRender() {
    const e = (0, $01W3b.ref)(!$ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value);
    return !1 === e.value && (0, $TusQn.onMounted)(()=>{
        e.value = !0;
    }), e;
}
const $ec2fc4c0d7a3c6c6$var$hasObserver = "undefined" !== typeof ResizeObserver, $ec2fc4c0d7a3c6c6$var$resizeProps = !0 === $ec2fc4c0d7a3c6c6$var$hasObserver ? {} : {
    style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
    url: "about:blank"
};
var $ec2fc4c0d7a3c6c6$export$614f53fe102a3da7 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QResizeObserver",
    props: {
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        }
    },
    emits: [
        "resize"
    ],
    setup (e, { emit: t }) {
        let o, n = null, a = {
            width: -1,
            height: -1
        };
        function l(t) {
            !0 === t || 0 === e.debounce || "0" === e.debounce ? i() : null === n && (n = setTimeout(i, e.debounce));
        }
        function i() {
            if (null !== n && (clearTimeout(n), n = null), o) {
                const { offsetWidth: e, offsetHeight: n } = o;
                e === a.width && n === a.height || (a = {
                    width: e,
                    height: n
                }, t("resize", a));
            }
        }
        const { proxy: r } = (0, $TusQn.getCurrentInstance)();
        if (!0 === $ec2fc4c0d7a3c6c6$var$hasObserver) {
            let e;
            const t = (n)=>{
                o = r.$el.parentNode, o ? (e = new ResizeObserver(l), e.observe(o), i()) : !0 !== n && (0, $TusQn.nextTick)(()=>{
                    t(!0);
                });
            };
            return (0, $TusQn.onMounted)(()=>{
                t();
            }), (0, $TusQn.onBeforeUnmount)(()=>{
                null !== n && clearTimeout(n), void 0 !== e && (void 0 !== e.disconnect ? e.disconnect() : o && e.unobserve(o));
            }), $ec2fc4c0d7a3c6c6$export$8793edee2d425525;
        }
        {
            const e = $ec2fc4c0d7a3c6c6$var$useCanRender();
            let t;
            function s() {
                null !== n && (clearTimeout(n), n = null), void 0 !== t && (void 0 !== t.removeEventListener && t.removeEventListener("resize", l, $ec2fc4c0d7a3c6c6$var$listenOpts.passive), t = void 0);
            }
            function u() {
                s(), o && o.contentDocument && (t = o.contentDocument.defaultView, t.addEventListener("resize", l, $ec2fc4c0d7a3c6c6$var$listenOpts.passive), i());
            }
            return (0, $TusQn.onMounted)(()=>{
                (0, $TusQn.nextTick)(()=>{
                    o = r.$el, o && u();
                });
            }), (0, $TusQn.onBeforeUnmount)(s), r.trigger = l, ()=>{
                if (!0 === e.value) return (0, $TusQn.h)("object", {
                    style: $ec2fc4c0d7a3c6c6$var$resizeProps.style,
                    tabindex: -1,
                    type: "text/html",
                    data: $ec2fc4c0d7a3c6c6$var$resizeProps.url,
                    "aria-hidden": "true",
                    onLoad: u
                });
            };
        }
    }
});
let $ec2fc4c0d7a3c6c6$var$rtlHasScrollBug = !1;
{
    const e = document.createElement("div");
    e.setAttribute("dir", "rtl"), Object.assign(e.style, {
        width: "1px",
        height: "1px",
        overflow: "auto"
    });
    const t = document.createElement("div");
    Object.assign(t.style, {
        width: "1000px",
        height: "1px"
    }), document.body.appendChild(e), e.appendChild(t), e.scrollLeft = -1000, $ec2fc4c0d7a3c6c6$var$rtlHasScrollBug = e.scrollLeft >= 0, e.remove();
}function $ec2fc4c0d7a3c6c6$var$getIndicatorClass(e, t, o) {
    const n = !0 === o ? [
        "left",
        "right"
    ] : [
        "top",
        "bottom"
    ];
    return `absolute-${!0 === t ? n[0] : n[1]}${e ? ` text-${e}` : ""}`;
}
const $ec2fc4c0d7a3c6c6$var$alignValues$1 = [
    "left",
    "center",
    "right",
    "justify"
];
var $ec2fc4c0d7a3c6c6$export$f3e10d2f5515bdea = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTabs",
    props: {
        modelValue: [
            Number,
            String
        ],
        align: {
            type: String,
            default: "center",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$alignValues$1.includes(e)
        },
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        vertical: Boolean,
        shrink: Boolean,
        stretch: Boolean,
        activeClass: String,
        activeColor: String,
        activeBgColor: String,
        indicatorColor: String,
        leftIcon: String,
        rightIcon: String,
        outsideArrows: Boolean,
        mobileArrows: Boolean,
        switchIndicator: Boolean,
        narrowIndicator: Boolean,
        inlineLabel: Boolean,
        noCaps: Boolean,
        dense: Boolean,
        contentClass: String,
        "onUpdate:modelValue": [
            Function,
            Array
        ]
    },
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, { registerTick: l } = $ec2fc4c0d7a3c6c6$var$useTick(), { registerTick: i } = $ec2fc4c0d7a3c6c6$var$useTick(), { registerTick: r } = $ec2fc4c0d7a3c6c6$var$useTick(), { registerTimeout: s, removeTimeout: u } = $ec2fc4c0d7a3c6c6$var$useTimeout(), { registerTimeout: c, removeTimeout: d } = $ec2fc4c0d7a3c6c6$var$useTimeout(), p = (0, $01W3b.ref)(null), v = (0, $01W3b.ref)(null), m = (0, $01W3b.ref)(e.modelValue), f = (0, $01W3b.ref)(!1), g = (0, $01W3b.ref)(!0), b = (0, $01W3b.ref)(!1), y = (0, $01W3b.ref)(!1), S = [], w = (0, $01W3b.ref)(0), C = (0, $01W3b.ref)(!1);
        let x, k = null, _ = null;
        const q = (0, $TusQn.computed)(()=>({
                activeClass: e.activeClass,
                activeColor: e.activeColor,
                activeBgColor: e.activeBgColor,
                indicatorClass: $ec2fc4c0d7a3c6c6$var$getIndicatorClass(e.indicatorColor, e.switchIndicator, e.vertical),
                narrowIndicator: e.narrowIndicator,
                inlineLabel: e.inlineLabel,
                noCaps: e.noCaps
            })), T = (0, $TusQn.computed)(()=>{
            const e = w.value, t = m.value;
            for(let o = 0; o < e; o++)if (S[o].name.value === t) return !0;
            return !1;
        }), P = (0, $TusQn.computed)(()=>{
            const t = !0 === f.value ? "left" : !0 === y.value ? "justify" : e.align;
            return `q-tabs__content--align-${t}`;
        }), $ = (0, $TusQn.computed)(()=>"q-tabs row no-wrap items-center" + ` q-tabs--${!0 === f.value ? "" : "not-"}scrollable` + ` q-tabs--${!0 === e.vertical ? "vertical" : "horizontal"}` + ` q-tabs__arrows--${!0 === e.outsideArrows ? "outside" : "inside"}` + ` q-tabs--mobile-with${!0 === e.mobileArrows ? "" : "out"}-arrows` + (!0 === e.dense ? " q-tabs--dense" : "") + (!0 === e.shrink ? " col-shrink" : "") + (!0 === e.stretch ? " self-stretch" : "")), M = (0, $TusQn.computed)(()=>"q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + P.value + (void 0 !== e.contentClass ? ` ${e.contentClass}` : "")), B = (0, $TusQn.computed)(()=>!0 === e.vertical ? {
                container: "height",
                content: "offsetHeight",
                scroll: "scrollHeight"
            } : {
                container: "width",
                content: "offsetWidth",
                scroll: "scrollWidth"
            }), E = (0, $TusQn.computed)(()=>!0 !== e.vertical && !0 === a.lang.rtl), Q = (0, $TusQn.computed)(()=>!1 === $ec2fc4c0d7a3c6c6$var$rtlHasScrollBug && !0 === E.value);
        function A({ name: t, setCurrent: n, skipEmit: a }) {
            m.value !== t && (!0 !== a && void 0 !== e["onUpdate:modelValue"] && o("update:modelValue", t), !0 !== n && void 0 !== e["onUpdate:modelValue"] || (F(m.value, t), m.value = t));
        }
        function L() {
            l(()=>{
                O({
                    width: p.value.offsetWidth,
                    height: p.value.offsetHeight
                });
            });
        }
        function O(t) {
            if (void 0 === B.value || null === v.value) return;
            const o = t[B.value.container], n = Math.min(v.value[B.value.scroll], Array.prototype.reduce.call(v.value.children, (e, t)=>e + (t[B.value.content] || 0), 0)), a = o > 0 && n > o;
            f.value = a, !0 === a && i(D), y.value = o < parseInt(e.breakpoint, 10);
        }
        function F(t, o) {
            const n = void 0 !== t && null !== t && "" !== t ? S.find((e)=>e.name.value === t) : null, a = void 0 !== o && null !== o && "" !== o ? S.find((e)=>e.name.value === o) : null;
            if (n && a) {
                const t = n.tabIndicatorRef.value, o = a.tabIndicatorRef.value;
                null !== k && (clearTimeout(k), k = null), t.style.transition = "none", t.style.transform = "none", o.style.transition = "none", o.style.transform = "none";
                const l = t.getBoundingClientRect(), i = o.getBoundingClientRect();
                o.style.transform = !0 === e.vertical ? `translate3d(0,${l.top - i.top}px,0) scale3d(1,${i.height ? l.height / i.height : 1},1)` : `translate3d(${l.left - i.left}px,0,0) scale3d(${i.width ? l.width / i.width : 1},1,1)`, r(()=>{
                    k = setTimeout(()=>{
                        k = null, o.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)", o.style.transform = "none";
                    }, 70);
                });
            }
            a && !0 === f.value && R(a.rootRef.value);
        }
        function R(t) {
            const { left: o, width: n, top: a, height: l } = v.value.getBoundingClientRect(), i = t.getBoundingClientRect();
            let r = !0 === e.vertical ? i.top - a : i.left - o;
            if (r < 0) return v.value[!0 === e.vertical ? "scrollTop" : "scrollLeft"] += Math.floor(r), void D();
            r += !0 === e.vertical ? i.height - l : i.width - n, r > 0 && (v.value[!0 === e.vertical ? "scrollTop" : "scrollLeft"] += Math.ceil(r), D());
        }
        function D() {
            const t = v.value;
            if (null === t) return;
            const o = t.getBoundingClientRect(), n = !0 === e.vertical ? t.scrollTop : Math.abs(t.scrollLeft);
            !0 === E.value ? (g.value = Math.ceil(n + o.width) < t.scrollWidth - 1, b.value = n > 0) : (g.value = n > 0, b.value = !0 === e.vertical ? Math.ceil(n + o.height) < t.scrollHeight : Math.ceil(n + o.width) < t.scrollWidth);
        }
        function z(e) {
            null !== _ && clearInterval(_), _ = setInterval(()=>{
                !0 === U(e) && H();
            }, 5);
        }
        function I() {
            z(!0 === Q.value ? Number.MAX_SAFE_INTEGER : 0);
        }
        function V() {
            z(!0 === Q.value ? 0 : Number.MAX_SAFE_INTEGER);
        }
        function H() {
            null !== _ && (clearInterval(_), _ = null);
        }
        function N(t, o) {
            const n = Array.prototype.filter.call(v.value.children, (e)=>e === o || e.matches && !0 === e.matches(".q-tab.q-focusable")), a = n.length;
            if (0 === a) return;
            if (36 === t) return R(n[0]), n[0].focus(), !0;
            if (35 === t) return R(n[a - 1]), n[a - 1].focus(), !0;
            const l = t === (!0 === e.vertical ? 38 : 37), i = t === (!0 === e.vertical ? 40 : 39), r = !0 === l ? -1 : !0 === i ? 1 : void 0;
            if (void 0 !== r) {
                const e = !0 === E.value ? -1 : 1, t = n.indexOf(o) + r * e;
                return t >= 0 && t < a && (R(n[t]), n[t].focus({
                    preventScroll: !0
                })), !0;
            }
        }
        (0, $TusQn.watch)(E, D), (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            A({
                name: e,
                setCurrent: !0,
                skipEmit: !0
            });
        }), (0, $TusQn.watch)(()=>e.outsideArrows, L);
        const j = (0, $TusQn.computed)(()=>!0 === Q.value ? {
                get: (e)=>Math.abs(e.scrollLeft),
                set: (e, t)=>{
                    e.scrollLeft = -t;
                }
            } : !0 === e.vertical ? {
                get: (e)=>e.scrollTop,
                set: (e, t)=>{
                    e.scrollTop = t;
                }
            } : {
                get: (e)=>e.scrollLeft,
                set: (e, t)=>{
                    e.scrollLeft = t;
                }
            });
        function U(e) {
            const t = v.value, { get: o, set: n } = j.value;
            let a = !1, l = o(t);
            const i = e < l ? -1 : 1;
            return l += 5 * i, l < 0 ? (a = !0, l = 0) : (-1 === i && l <= e || 1 === i && l >= e) && (a = !0, l = e), n(t, l), D(), a;
        }
        function K(e, t) {
            for(const o in e)if (e[o] !== t[o]) return !1;
            return !0;
        }
        function W() {
            let e = null, t = {
                matchedLen: 0,
                queryDiff: 9999,
                hrefLen: 0
            };
            const o = S.filter((e)=>void 0 !== e.routeData && !0 === e.routeData.hasRouterLink.value), { hash: a, query: l } = n.$route, i = Object.keys(l).length;
            for (const n of o){
                const o = !0 === n.routeData.exact.value;
                if (!0 !== n.routeData[!0 === o ? "linkIsExactActive" : "linkIsActive"].value) continue;
                const { hash: r, query: s, matched: u, href: c } = n.routeData.resolvedLink.value, d = Object.keys(s).length;
                if (!0 === o) {
                    if (r !== a) continue;
                    if (d !== i || !1 === K(l, s)) continue;
                    e = n.name.value;
                    break;
                }
                if ("" !== r && r !== a) continue;
                if (0 !== d && !1 === K(s, l)) continue;
                const p = {
                    matchedLen: u.length,
                    queryDiff: i - d,
                    hrefLen: c.length - r.length
                };
                if (p.matchedLen > t.matchedLen) e = n.name.value, t = p;
                else if (p.matchedLen === t.matchedLen) {
                    if (p.queryDiff < t.queryDiff) e = n.name.value, t = p;
                    else if (p.queryDiff !== t.queryDiff) continue;
                    p.hrefLen > t.hrefLen && (e = n.name.value, t = p);
                }
            }
            null === e && !0 === S.some((e)=>void 0 === e.routeData && e.name.value === m.value) || A({
                name: e,
                setCurrent: !0
            });
        }
        function Y(e) {
            if (u(), !0 !== C.value && null !== p.value && e.target && "function" === typeof e.target.closest) {
                const t = e.target.closest(".q-tab");
                t && !0 === p.value.contains(t) && (C.value = !0, !0 === f.value && R(t));
            }
        }
        function G() {
            s(()=>{
                C.value = !1;
            }, 30);
        }
        function X() {
            !1 === te.avoidRouteWatcher ? c(W) : d();
        }
        function Z() {
            if (void 0 === x) {
                const e = (0, $TusQn.watch)(()=>n.$route.fullPath, X);
                x = ()=>{
                    e(), x = void 0;
                };
            }
        }
        function J(e) {
            S.push(e), w.value++, L(), void 0 === e.routeData || void 0 === n.$route ? c(()=>{
                if (!0 === f.value) {
                    const e = m.value, t = void 0 !== e && null !== e && "" !== e ? S.find((t)=>t.name.value === e) : null;
                    t && R(t.rootRef.value);
                }
            }) : (Z(), !0 === e.routeData.hasRouterLink.value && X());
        }
        function ee(e) {
            S.splice(S.indexOf(e), 1), w.value--, L(), void 0 !== x && void 0 !== e.routeData && (!0 === S.every((e)=>void 0 === e.routeData) && x(), X());
        }
        const te = {
            currentModel: m,
            tabProps: q,
            hasFocus: C,
            hasActiveTab: T,
            registerTab: J,
            unregisterTab: ee,
            verifyRouteModel: X,
            updateModel: A,
            onKbdNavigate: N,
            avoidRouteWatcher: !1
        };
        function oe() {
            null !== k && clearTimeout(k), H(), void 0 !== x && x();
        }
        let ne;
        return (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$tabsKey, te), (0, $TusQn.onBeforeUnmount)(oe), (0, $TusQn.onDeactivated)(()=>{
            ne = void 0 !== x, oe();
        }), (0, $TusQn.onActivated)(()=>{
            !0 === ne && Z(), L();
        }), ()=>{
            return (0, $TusQn.h)("div", {
                ref: p,
                class: $.value,
                role: "tablist",
                onFocusin: Y,
                onFocusout: G
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                    onResize: O
                }),
                (0, $TusQn.h)("div", {
                    ref: v,
                    class: M.value,
                    onScroll: D
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (!0 === g.value ? "" : " q-tabs__arrow--faded"),
                    name: e.leftIcon || a.iconSet.tabs[!0 === e.vertical ? "up" : "left"],
                    onMousedownPassive: I,
                    onTouchstartPassive: I,
                    onMouseupPassive: H,
                    onMouseleavePassive: H,
                    onTouchendPassive: H
                }),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (!0 === b.value ? "" : " q-tabs__arrow--faded"),
                    name: e.rightIcon || a.iconSet.tabs[!0 === e.vertical ? "down" : "right"],
                    onMousedownPassive: V,
                    onTouchstartPassive: V,
                    onMouseupPassive: H,
                    onMouseleavePassive: H,
                    onTouchendPassive: H
                })
            ]);
        };
    }
});
let $ec2fc4c0d7a3c6c6$var$id$1 = 0;
const $ec2fc4c0d7a3c6c6$var$useTabEmits = [
    "click",
    "keydown"
], $ec2fc4c0d7a3c6c6$var$useTabProps = {
    icon: String,
    label: [
        Number,
        String
    ],
    alert: [
        Boolean,
        String
    ],
    alertIcon: String,
    name: {
        type: [
            Number,
            String
        ],
        default: ()=>`t_${$ec2fc4c0d7a3c6c6$var$id$1++}`
    },
    noCaps: Boolean,
    tabindex: [
        String,
        Number
    ],
    disable: Boolean,
    contentClass: String,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    }
};
function $ec2fc4c0d7a3c6c6$var$useTab(e, t, o, n) {
    const a = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$tabsKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
    if (a === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QTab/QRouteTab component needs to be child of QTabs"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
    const { proxy: l } = (0, $TusQn.getCurrentInstance)(), i = (0, $01W3b.ref)(null), r = (0, $01W3b.ref)(null), s = (0, $01W3b.ref)(null), u = (0, $TusQn.computed)(()=>!0 !== e.disable && !1 !== e.ripple && Object.assign({
            keyCodes: [
                13,
                32
            ],
            early: !0
        }, !0 === e.ripple ? {} : e.ripple)), c = (0, $TusQn.computed)(()=>a.currentModel.value === e.name), d = (0, $TusQn.computed)(()=>"q-tab relative-position self-stretch flex flex-center text-center" + (!0 === c.value ? " q-tab--active" + (a.tabProps.value.activeClass ? " " + a.tabProps.value.activeClass : "") + (a.tabProps.value.activeColor ? ` text-${a.tabProps.value.activeColor}` : "") + (a.tabProps.value.activeBgColor ? ` bg-${a.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (e.icon && e.label && !1 === a.tabProps.value.inlineLabel ? " q-tab--full" : "") + (!0 === e.noCaps || !0 === a.tabProps.value.noCaps ? " q-tab--no-caps" : "") + (!0 === e.disable ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (void 0 !== n ? n.linkClass.value : "")), p = (0, $TusQn.computed)(()=>"q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + (!0 === a.tabProps.value.inlineLabel ? "row no-wrap q-tab__content--inline" : "column") + (void 0 !== e.contentClass ? ` ${e.contentClass}` : "")), v = (0, $TusQn.computed)(()=>!0 === e.disable || !0 === a.hasFocus.value || !1 === c.value && !0 === a.hasActiveTab.value ? -1 : e.tabindex || 0);
    function m(t, l) {
        if (!0 !== l && null !== i.value && i.value.focus(), !0 !== e.disable) {
            if (void 0 === n) return a.updateModel({
                name: e.name
            }), void o("click", t);
            if (!0 === n.hasRouterLink.value) {
                const l = (o = {})=>{
                    let l;
                    const i = void 0 === o.to || !0 === $ec2fc4c0d7a3c6c6$var$isDeepEqual(o.to, e.to) ? a.avoidRouteWatcher = $ec2fc4c0d7a3c6c6$export$e2a22331486dcca0() : null;
                    return n.navigateToRouterLink(t, {
                        ...o,
                        returnRouterError: !0
                    }).catch((e)=>{
                        l = e;
                    }).then((t)=>{
                        if (i === a.avoidRouteWatcher && (a.avoidRouteWatcher = !1, void 0 !== l || void 0 !== t && !0 !== t.message.startsWith("Avoided redundant navigation") || a.updateModel({
                            name: e.name
                        })), !0 === o.returnRouterError) return void 0 !== l ? Promise.reject(l) : t;
                    });
                };
                return o("click", t, l), void (!0 !== t.defaultPrevented && l());
            }
            o("click", t);
        } else void 0 !== n && !0 === n.hasRouterLink.value && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t);
    }
    function f(e) {
        $ec2fc4c0d7a3c6c6$var$isKeyCode(e, [
            13,
            32
        ]) ? m(e, !0) : !0 !== $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(e) && e.keyCode >= 35 && e.keyCode <= 40 && !0 !== e.altKey && !0 !== e.metaKey && !0 === a.onKbdNavigate(e.keyCode, l.$el) && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), o("keydown", e);
    }
    function g() {
        const o = a.tabProps.value.narrowIndicator, n = [], l = (0, $TusQn.h)("div", {
            ref: s,
            class: [
                "q-tab__indicator",
                a.tabProps.value.indicatorClass
            ]
        });
        void 0 !== e.icon && n.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
            class: "q-tab__icon",
            name: e.icon
        })), void 0 !== e.label && n.push((0, $TusQn.h)("div", {
            class: "q-tab__label"
        }, e.label)), !1 !== e.alert && n.push(void 0 !== e.alertIcon ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
            class: "q-tab__alert-icon",
            color: !0 !== e.alert ? e.alert : void 0,
            name: e.alertIcon
        }) : (0, $TusQn.h)("div", {
            class: "q-tab__alert" + (!0 !== e.alert ? ` text-${e.alert}` : "")
        })), !0 === o && n.push(l);
        const r = [
            (0, $TusQn.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: i
            }),
            (0, $TusQn.h)("div", {
                class: p.value
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, n))
        ];
        return !1 === o && r.push(l), r;
    }
    const b = {
        name: (0, $TusQn.computed)(()=>e.name),
        rootRef: r,
        tabIndicatorRef: s,
        routeData: n
    };
    function y(t, o) {
        const n = {
            ref: r,
            class: d.value,
            tabindex: v.value,
            role: "tab",
            "aria-selected": !0 === c.value ? "true" : "false",
            "aria-disabled": !0 === e.disable ? "true" : void 0,
            onClick: m,
            onKeydown: f,
            ...o
        };
        return (0, $TusQn.withDirectives)((0, $TusQn.h)(t, n, g()), [
            [
                $ec2fc4c0d7a3c6c6$export$9e9146f7e027fdaa,
                u.value
            ]
        ]);
    }
    return (0, $TusQn.onBeforeUnmount)(()=>{
        a.unregisterTab(b);
    }), (0, $TusQn.onMounted)(()=>{
        a.registerTab(b);
    }), {
        renderTab: y,
        $tabs: a
    };
}
var $ec2fc4c0d7a3c6c6$export$39ade007f653a559 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTab",
    props: $ec2fc4c0d7a3c6c6$var$useTabProps,
    emits: $ec2fc4c0d7a3c6c6$var$useTabEmits,
    setup (e, { slots: t, emit: o }) {
        const { renderTab: n } = $ec2fc4c0d7a3c6c6$var$useTab(e, t, o);
        return ()=>n("div");
    }
}), $ec2fc4c0d7a3c6c6$export$305a5380acbec321 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTabPanels",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$usePanelProps,
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps
    },
    emits: $ec2fc4c0d7a3c6c6$var$usePanelEmits,
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q), { updatePanelsList: a, getPanelContent: l, panelDirectives: i } = $ec2fc4c0d7a3c6c6$var$usePanel(), r = (0, $TusQn.computed)(()=>"q-tab-panels q-panel-parent" + (!0 === n.value ? " q-tab-panels--dark q-dark" : ""));
        return ()=>{
            return a(t), $ec2fc4c0d7a3c6c6$var$hDir("div", {
                class: r.value
            }, l(), "pan", e.swipeable, ()=>i.value);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$a513456409dea750 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTabPanel",
    props: $ec2fc4c0d7a3c6c6$var$usePanelChildProps,
    setup (e, { slots: t }) {
        return ()=>(0, $TusQn.h)("div", {
                class: "q-tab-panel",
                role: "tabpanel"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, $ec2fc4c0d7a3c6c6$var$hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, $ec2fc4c0d7a3c6c6$var$hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, $ec2fc4c0d7a3c6c6$var$rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, $ec2fc4c0d7a3c6c6$var$rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/, $ec2fc4c0d7a3c6c6$var$testPattern = {
    date: (e)=>/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e),
    time: (e)=>/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(e),
    fulltime: (e)=>/^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(e),
    timeOrFulltime: (e)=>/^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(e),
    email: (e)=>/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e),
    hexColor: (e)=>$ec2fc4c0d7a3c6c6$var$hex.test(e),
    hexaColor: (e)=>$ec2fc4c0d7a3c6c6$var$hexa.test(e),
    hexOrHexaColor: (e)=>$ec2fc4c0d7a3c6c6$var$hexOrHexa.test(e),
    rgbColor: (e)=>$ec2fc4c0d7a3c6c6$var$rgb.test(e),
    rgbaColor: (e)=>$ec2fc4c0d7a3c6c6$var$rgba.test(e),
    rgbOrRgbaColor: (e)=>$ec2fc4c0d7a3c6c6$var$rgb.test(e) || $ec2fc4c0d7a3c6c6$var$rgba.test(e),
    hexOrRgbColor: (e)=>$ec2fc4c0d7a3c6c6$var$hex.test(e) || $ec2fc4c0d7a3c6c6$var$rgb.test(e),
    hexaOrRgbaColor: (e)=>$ec2fc4c0d7a3c6c6$var$hexa.test(e) || $ec2fc4c0d7a3c6c6$var$rgba.test(e),
    anyColor: (e)=>$ec2fc4c0d7a3c6c6$var$hexOrHexa.test(e) || $ec2fc4c0d7a3c6c6$var$rgb.test(e) || $ec2fc4c0d7a3c6c6$var$rgba.test(e)
};
var $ec2fc4c0d7a3c6c6$export$ac7ce348c2237f4e = {
    testPattern: $ec2fc4c0d7a3c6c6$var$testPattern
};
const $ec2fc4c0d7a3c6c6$var$reRGBA = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function $ec2fc4c0d7a3c6c6$var$rgbToHex({ r: e, g: t, b: o, a: n }) {
    const a = void 0 !== n;
    if (e = Math.round(e), t = Math.round(t), o = Math.round(o), e > 255 || t > 255 || o > 255 || a && n > 100) throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
    return n = a ? (256 | Math.round(255 * n / 100)).toString(16).slice(1) : "", "#" + (o | t << 8 | e << 16 | 16777216).toString(16).slice(1) + n;
}
function $ec2fc4c0d7a3c6c6$var$rgbToString({ r: e, g: t, b: o, a: n }) {
    return `rgb${void 0 !== n ? "a" : ""}(${e},${t},${o}${void 0 !== n ? "," + n / 100 : ""})`;
}
function $ec2fc4c0d7a3c6c6$var$hexToRgb(e) {
    if ("string" !== typeof e) throw new TypeError("Expected a string");
    e = e.replace(/^#/, ""), 3 === e.length ? e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] : 4 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] + e[3] + e[3]);
    const t = parseInt(e, 16);
    return e.length > 6 ? {
        r: t >> 24 & 255,
        g: t >> 16 & 255,
        b: t >> 8 & 255,
        a: Math.round((255 & t) / 2.55)
    } : {
        r: t >> 16,
        g: t >> 8 & 255,
        b: 255 & t
    };
}
function $ec2fc4c0d7a3c6c6$var$hsvToRgb({ h: e, s: t, v: o, a: n }) {
    let a, l, i;
    t /= 100, o /= 100, e /= 360;
    const r = Math.floor(6 * e), s = 6 * e - r, u = o * (1 - t), c = o * (1 - s * t), d = o * (1 - (1 - s) * t);
    switch(r % 6){
        case 0:
            a = o, l = d, i = u;
            break;
        case 1:
            a = c, l = o, i = u;
            break;
        case 2:
            a = u, l = o, i = d;
            break;
        case 3:
            a = u, l = c, i = o;
            break;
        case 4:
            a = d, l = u, i = o;
            break;
        case 5:
            a = o, l = u, i = c;
            break;
    }
    return {
        r: Math.round(255 * a),
        g: Math.round(255 * l),
        b: Math.round(255 * i),
        a: n
    };
}
function $ec2fc4c0d7a3c6c6$var$rgbToHsv({ r: e, g: t, b: o, a: n }) {
    const a = Math.max(e, t, o), l = Math.min(e, t, o), i = a - l, r = 0 === a ? 0 : i / a, s = a / 255;
    let u;
    switch(a){
        case l:
            u = 0;
            break;
        case e:
            u = t - o + i * (t < o ? 6 : 0), u /= 6 * i;
            break;
        case t:
            u = o - e + 2 * i, u /= 6 * i;
            break;
        case o:
            u = e - t + 4 * i, u /= 6 * i;
            break;
    }
    return {
        h: Math.round(360 * u),
        s: Math.round(100 * r),
        v: Math.round(100 * s),
        a: n
    };
}
function $ec2fc4c0d7a3c6c6$var$textToRgb(e) {
    if ("string" !== typeof e) throw new TypeError("Expected a string");
    const t = e.replace(/ /g, ""), o = $ec2fc4c0d7a3c6c6$var$reRGBA.exec(t);
    if (null === o) return $ec2fc4c0d7a3c6c6$var$hexToRgb(t);
    const n = {
        r: Math.min(255, parseInt(o[2], 10)),
        g: Math.min(255, parseInt(o[3], 10)),
        b: Math.min(255, parseInt(o[4], 10))
    };
    if (o[1]) {
        const e = parseFloat(o[5]);
        n.a = 100 * Math.min(1, !0 === isNaN(e) ? 1 : e);
    }
    return n;
}
function $ec2fc4c0d7a3c6c6$var$lighten(e, t) {
    if ("string" !== typeof e) throw new TypeError("Expected a string as color");
    if ("number" !== typeof t) throw new TypeError("Expected a numeric percent");
    const o = $ec2fc4c0d7a3c6c6$var$textToRgb(e), n = t < 0 ? 0 : 255, a = Math.abs(t) / 100, l = o.r, i = o.g, r = o.b;
    return "#" + (16777216 + 65536 * (Math.round((n - l) * a) + l) + 256 * (Math.round((n - i) * a) + i) + (Math.round((n - r) * a) + r)).toString(16).slice(1);
}
function $ec2fc4c0d7a3c6c6$var$luminosity(e) {
    if ("string" !== typeof e && (!e || void 0 === e.r)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    const t = "string" === typeof e ? $ec2fc4c0d7a3c6c6$var$textToRgb(e) : e, o = t.r / 255, n = t.g / 255, a = t.b / 255, l = o <= .03928 ? o / 12.92 : Math.pow((o + .055) / 1.055, 2.4), i = n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4), r = a <= .03928 ? a / 12.92 : Math.pow((a + .055) / 1.055, 2.4);
    return .2126 * l + .7152 * i + .0722 * r;
}
function $ec2fc4c0d7a3c6c6$var$brightness(e) {
    if ("string" !== typeof e && (!e || void 0 === e.r)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    const t = "string" === typeof e ? $ec2fc4c0d7a3c6c6$var$textToRgb(e) : e;
    return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
}
function $ec2fc4c0d7a3c6c6$var$blend(e, t) {
    if ("string" !== typeof e && (!e || void 0 === e.r)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
    if ("string" !== typeof t && (!t || void 0 === t.r)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
    const o = "string" === typeof e ? $ec2fc4c0d7a3c6c6$var$textToRgb(e) : e, n = o.r / 255, a = o.g / 255, l = o.b / 255, i = void 0 !== o.a ? o.a / 100 : 1, r = "string" === typeof t ? $ec2fc4c0d7a3c6c6$var$textToRgb(t) : t, s = r.r / 255, u = r.g / 255, c = r.b / 255, d = void 0 !== r.a ? r.a / 100 : 1, p = i + d * (1 - i), v = Math.round((n * i + s * d * (1 - i)) / p * 255), m = Math.round((a * i + u * d * (1 - i)) / p * 255), f = Math.round((l * i + c * d * (1 - i)) / p * 255), h = {
        r: v,
        g: m,
        b: f,
        a: Math.round(100 * p)
    };
    return "string" === typeof e ? $ec2fc4c0d7a3c6c6$var$rgbToHex(h) : h;
}
function $ec2fc4c0d7a3c6c6$var$changeAlpha(e, t) {
    if ("string" !== typeof e) throw new TypeError("Expected a string as color");
    if (void 0 === t || t < -1 || t > 1) throw new TypeError("Expected offset to be between -1 and 1");
    const { r: o, g: n, b: a, a: l } = $ec2fc4c0d7a3c6c6$var$textToRgb(e), i = void 0 !== l ? l / 100 : 0;
    return $ec2fc4c0d7a3c6c6$var$rgbToHex({
        r: o,
        g: n,
        b: a,
        a: Math.round(100 * Math.min(1, Math.max(0, i + t)))
    });
}
function $ec2fc4c0d7a3c6c6$var$getPaletteColor(e) {
    if ("string" !== typeof e) throw new TypeError("Expected a string as color");
    const t = document.createElement("div");
    t.className = `text-${e} invisible fixed no-pointer-events`, document.body.appendChild(t);
    const o = getComputedStyle(t).getPropertyValue("color");
    return t.remove(), $ec2fc4c0d7a3c6c6$var$rgbToHex($ec2fc4c0d7a3c6c6$var$textToRgb(o));
}
var $ec2fc4c0d7a3c6c6$export$8f45430ccf837300 = {
    rgbToHex: $ec2fc4c0d7a3c6c6$var$rgbToHex,
    hexToRgb: $ec2fc4c0d7a3c6c6$var$hexToRgb,
    hsvToRgb: $ec2fc4c0d7a3c6c6$var$hsvToRgb,
    rgbToHsv: $ec2fc4c0d7a3c6c6$var$rgbToHsv,
    textToRgb: $ec2fc4c0d7a3c6c6$var$textToRgb,
    lighten: $ec2fc4c0d7a3c6c6$var$lighten,
    luminosity: $ec2fc4c0d7a3c6c6$var$luminosity,
    brightness: $ec2fc4c0d7a3c6c6$var$brightness,
    blend: $ec2fc4c0d7a3c6c6$var$blend,
    changeAlpha: $ec2fc4c0d7a3c6c6$var$changeAlpha,
    getPaletteColor: $ec2fc4c0d7a3c6c6$var$getPaletteColor
};
const $ec2fc4c0d7a3c6c6$var$palette = [
    "rgb(255,204,204)",
    "rgb(255,230,204)",
    "rgb(255,255,204)",
    "rgb(204,255,204)",
    "rgb(204,255,230)",
    "rgb(204,255,255)",
    "rgb(204,230,255)",
    "rgb(204,204,255)",
    "rgb(230,204,255)",
    "rgb(255,204,255)",
    "rgb(255,153,153)",
    "rgb(255,204,153)",
    "rgb(255,255,153)",
    "rgb(153,255,153)",
    "rgb(153,255,204)",
    "rgb(153,255,255)",
    "rgb(153,204,255)",
    "rgb(153,153,255)",
    "rgb(204,153,255)",
    "rgb(255,153,255)",
    "rgb(255,102,102)",
    "rgb(255,179,102)",
    "rgb(255,255,102)",
    "rgb(102,255,102)",
    "rgb(102,255,179)",
    "rgb(102,255,255)",
    "rgb(102,179,255)",
    "rgb(102,102,255)",
    "rgb(179,102,255)",
    "rgb(255,102,255)",
    "rgb(255,51,51)",
    "rgb(255,153,51)",
    "rgb(255,255,51)",
    "rgb(51,255,51)",
    "rgb(51,255,153)",
    "rgb(51,255,255)",
    "rgb(51,153,255)",
    "rgb(51,51,255)",
    "rgb(153,51,255)",
    "rgb(255,51,255)",
    "rgb(255,0,0)",
    "rgb(255,128,0)",
    "rgb(255,255,0)",
    "rgb(0,255,0)",
    "rgb(0,255,128)",
    "rgb(0,255,255)",
    "rgb(0,128,255)",
    "rgb(0,0,255)",
    "rgb(128,0,255)",
    "rgb(255,0,255)",
    "rgb(245,0,0)",
    "rgb(245,123,0)",
    "rgb(245,245,0)",
    "rgb(0,245,0)",
    "rgb(0,245,123)",
    "rgb(0,245,245)",
    "rgb(0,123,245)",
    "rgb(0,0,245)",
    "rgb(123,0,245)",
    "rgb(245,0,245)",
    "rgb(214,0,0)",
    "rgb(214,108,0)",
    "rgb(214,214,0)",
    "rgb(0,214,0)",
    "rgb(0,214,108)",
    "rgb(0,214,214)",
    "rgb(0,108,214)",
    "rgb(0,0,214)",
    "rgb(108,0,214)",
    "rgb(214,0,214)",
    "rgb(163,0,0)",
    "rgb(163,82,0)",
    "rgb(163,163,0)",
    "rgb(0,163,0)",
    "rgb(0,163,82)",
    "rgb(0,163,163)",
    "rgb(0,82,163)",
    "rgb(0,0,163)",
    "rgb(82,0,163)",
    "rgb(163,0,163)",
    "rgb(92,0,0)",
    "rgb(92,46,0)",
    "rgb(92,92,0)",
    "rgb(0,92,0)",
    "rgb(0,92,46)",
    "rgb(0,92,92)",
    "rgb(0,46,92)",
    "rgb(0,0,92)",
    "rgb(46,0,92)",
    "rgb(92,0,92)",
    "rgb(255,255,255)",
    "rgb(205,205,205)",
    "rgb(178,178,178)",
    "rgb(153,153,153)",
    "rgb(127,127,127)",
    "rgb(102,102,102)",
    "rgb(76,76,76)",
    "rgb(51,51,51)",
    "rgb(25,25,25)",
    "rgb(0,0,0)"
], $ec2fc4c0d7a3c6c6$var$thumbPath = "M5 5 h10 v10 h-10 v-10 z", $ec2fc4c0d7a3c6c6$var$alphaTrackImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==";
var $ec2fc4c0d7a3c6c6$export$32ed8655ecd274c2 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QColor",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        modelValue: String,
        defaultValue: String,
        defaultView: {
            type: String,
            default: "spectrum",
            validator: (e)=>[
                    "spectrum",
                    "tune",
                    "palette"
                ].includes(e)
        },
        formatModel: {
            type: String,
            default: "auto",
            validator: (e)=>[
                    "auto",
                    "hex",
                    "rgb",
                    "hexa",
                    "rgba"
                ].includes(e)
        },
        palette: Array,
        noHeader: Boolean,
        noHeaderTabs: Boolean,
        noFooter: Boolean,
        square: Boolean,
        flat: Boolean,
        bordered: Boolean,
        disable: Boolean,
        readonly: Boolean
    },
    emits: [
        "update:modelValue",
        "change"
    ],
    setup (e, { emit: t }) {
        const { proxy: o } = (0, $TusQn.getCurrentInstance)(), { $q: n } = o, a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), { getCache: l } = $ec2fc4c0d7a3c6c6$var$useCache(), i = (0, $01W3b.ref)(null), r = (0, $01W3b.ref)(null), s = (0, $TusQn.computed)(()=>"auto" === e.formatModel ? null : e.formatModel.indexOf("hex") > -1), u = (0, $TusQn.computed)(()=>"auto" === e.formatModel ? null : e.formatModel.indexOf("a") > -1), c = (0, $01W3b.ref)("auto" === e.formatModel ? void 0 === e.modelValue || null === e.modelValue || "" === e.modelValue || e.modelValue.startsWith("#") ? "hex" : "rgb" : e.formatModel.startsWith("hex") ? "hex" : "rgb"), d = (0, $01W3b.ref)(e.defaultView), p = (0, $01W3b.ref)($(e.modelValue || e.defaultValue)), v = (0, $TusQn.computed)(()=>!0 !== e.disable && !0 !== e.readonly), m = (0, $TusQn.computed)(()=>void 0 === e.modelValue || null === e.modelValue || "" === e.modelValue || e.modelValue.startsWith("#")), f = (0, $TusQn.computed)(()=>null !== s.value ? s.value : m.value), g = (0, $TusQn.computed)(()=>({
                type: "hidden",
                name: e.name,
                value: p.value[!0 === f.value ? "hex" : "rgb"]
            })), b = $ec2fc4c0d7a3c6c6$var$useFormInject(g), y = (0, $TusQn.computed)(()=>null !== u.value ? u.value : void 0 !== p.value.a), S = (0, $TusQn.computed)(()=>({
                backgroundColor: p.value.rgb || "#000"
            })), w = (0, $TusQn.computed)(()=>{
            const e = void 0 !== p.value.a && p.value.a < 65 || $ec2fc4c0d7a3c6c6$var$luminosity(p.value) > .4;
            return "q-color-picker__header-content" + ` q-color-picker__header-content--${e ? "light" : "dark"}`;
        }), C = (0, $TusQn.computed)(()=>({
                background: `hsl(${p.value.h},100%,50%)`
            })), x = (0, $TusQn.computed)(()=>({
                top: `${100 - p.value.v}%`,
                [!0 === n.lang.rtl ? "right" : "left"]: `${p.value.s}%`
            })), k = (0, $TusQn.computed)(()=>void 0 !== e.palette && 0 !== e.palette.length ? e.palette : $ec2fc4c0d7a3c6c6$var$palette), _ = (0, $TusQn.computed)(()=>"q-color-picker" + (!0 === e.bordered ? " q-color-picker--bordered" : "") + (!0 === e.square ? " q-color-picker--square no-border-radius" : "") + (!0 === e.flat ? " q-color-picker--flat no-shadow" : "") + (!0 === e.disable ? " disabled" : "") + (!0 === a.value ? " q-color-picker--dark q-dark" : "")), q = (0, $TusQn.computed)(()=>{
            return !0 === e.disable ? {
                "aria-disabled": "true"
            } : !0 === e.readonly ? {
                "aria-readonly": "true"
            } : {};
        }), T = (0, $TusQn.computed)(()=>{
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    L,
                    void 0,
                    {
                        prevent: !0,
                        stop: !0,
                        mouse: !0
                    }
                ]
            ];
        });
        function P(e, o) {
            p.value.hex = $ec2fc4c0d7a3c6c6$var$rgbToHex(e), p.value.rgb = $ec2fc4c0d7a3c6c6$var$rgbToString(e), p.value.r = e.r, p.value.g = e.g, p.value.b = e.b, p.value.a = e.a;
            const n = p.value[!0 === f.value ? "hex" : "rgb"];
            t("update:modelValue", n), !0 === o && t("change", n);
        }
        function $(t) {
            const o = void 0 !== u.value ? u.value : "auto" === e.formatModel ? null : e.formatModel.indexOf("a") > -1;
            if ("string" !== typeof t || 0 === t.length || !0 !== $ec2fc4c0d7a3c6c6$var$testPattern.anyColor(t.replace(/ /g, ""))) return {
                h: 0,
                s: 0,
                v: 0,
                r: 0,
                g: 0,
                b: 0,
                a: !0 === o ? 100 : void 0,
                hex: void 0,
                rgb: void 0
            };
            const n = $ec2fc4c0d7a3c6c6$var$textToRgb(t);
            return !0 === o && void 0 === n.a && (n.a = 100), n.hex = $ec2fc4c0d7a3c6c6$var$rgbToHex(n), n.rgb = $ec2fc4c0d7a3c6c6$var$rgbToString(n), Object.assign(n, $ec2fc4c0d7a3c6c6$var$rgbToHsv(n));
        }
        function M(e, t, o) {
            const a = i.value;
            if (null === a) return;
            const l = a.clientWidth, r = a.clientHeight, s = a.getBoundingClientRect();
            let u = Math.min(l, Math.max(0, e - s.left));
            !0 === n.lang.rtl && (u = l - u);
            const c = Math.min(r, Math.max(0, t - s.top)), d = Math.round(100 * u / l), v = Math.round(100 * Math.max(0, Math.min(1, -c / r + 1))), m = $ec2fc4c0d7a3c6c6$var$hsvToRgb({
                h: p.value.h,
                s: d,
                v: v,
                a: !0 === y.value ? p.value.a : void 0
            });
            p.value.s = d, p.value.v = v, P(m, o);
        }
        function B(e, t) {
            const o = Math.round(e), n = $ec2fc4c0d7a3c6c6$var$hsvToRgb({
                h: o,
                s: p.value.s,
                v: p.value.v,
                a: !0 === y.value ? p.value.a : void 0
            });
            p.value.h = o, P(n, t);
        }
        function E(e, t, n, a, l) {
            if (void 0 !== a && $ec2fc4c0d7a3c6c6$var$stop(a), !/^[0-9]+$/.test(e)) return void (!0 === l && o.$forceUpdate());
            const i = Math.floor(Number(e));
            if (i < 0 || i > n) return void (!0 === l && o.$forceUpdate());
            const r = {
                r: "r" === t ? i : p.value.r,
                g: "g" === t ? i : p.value.g,
                b: "b" === t ? i : p.value.b,
                a: !0 === y.value ? "a" === t ? i : p.value.a : void 0
            };
            if ("a" !== t) {
                const e = $ec2fc4c0d7a3c6c6$var$rgbToHsv(r);
                p.value.h = e.h, p.value.s = e.s, p.value.v = e.v;
            }
            if (P(r, l), void 0 !== a && !0 !== l && void 0 !== a.target.selectionEnd) {
                const e = a.target.selectionEnd;
                (0, $TusQn.nextTick)(()=>{
                    a.target.setSelectionRange(e, e);
                });
            }
        }
        function Q(e, t) {
            let o;
            const n = e.target.value;
            if ($ec2fc4c0d7a3c6c6$var$stop(e), "hex" === c.value) {
                if (n.length !== (!0 === y.value ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(n)) return !0;
                o = $ec2fc4c0d7a3c6c6$var$hexToRgb(n);
            } else {
                let e;
                if (!n.endsWith(")")) return !0;
                if (!0 !== y.value && n.startsWith("rgb(")) {
                    if (e = n.substring(4, n.length - 1).split(",").map((e)=>parseInt(e, 10)), 3 !== e.length || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(n)) return !0;
                } else {
                    if (!0 !== y.value || !n.startsWith("rgba(")) return !0;
                    {
                        if (e = n.substring(5, n.length - 1).split(","), 4 !== e.length || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(n)) return !0;
                        for(let o = 0; o < 3; o++){
                            const t = parseInt(e[o], 10);
                            if (t < 0 || t > 255) return !0;
                            e[o] = t;
                        }
                        const t = parseFloat(e[3]);
                        if (t < 0 || t > 1) return !0;
                        e[3] = t;
                    }
                }
                if (e[0] < 0 || e[0] > 255 || e[1] < 0 || e[1] > 255 || e[2] < 0 || e[2] > 255 || !0 === y.value && (e[3] < 0 || e[3] > 1)) return !0;
                o = {
                    r: e[0],
                    g: e[1],
                    b: e[2],
                    a: !0 === y.value ? 100 * e[3] : void 0
                };
            }
            const a = $ec2fc4c0d7a3c6c6$var$rgbToHsv(o);
            if (p.value.h = a.h, p.value.s = a.s, p.value.v = a.v, P(o, t), !0 !== t) {
                const t = e.target.selectionEnd;
                (0, $TusQn.nextTick)(()=>{
                    e.target.setSelectionRange(t, t);
                });
            }
        }
        function A(e) {
            const t = $(e), o = {
                r: t.r,
                g: t.g,
                b: t.b,
                a: t.a
            };
            void 0 === o.a && (o.a = p.value.a), p.value.h = t.h, p.value.s = t.s, p.value.v = t.v, P(o, !0);
        }
        function L(e) {
            e.isFinal ? M(e.position.left, e.position.top, !0) : O(e);
        }
        (0, $TusQn.watch)(()=>e.modelValue, (t)=>{
            const o = $(t || e.defaultValue);
            o.hex !== p.value.hex && (p.value = o);
        }), (0, $TusQn.watch)(()=>e.defaultValue, (t)=>{
            if (!e.modelValue && t) {
                const e = $(t);
                e.hex !== p.value.hex && (p.value = e);
            }
        });
        const O = $ec2fc4c0d7a3c6c6$export$de363e709c412c8a((e)=>{
            M(e.position.left, e.position.top);
        }, 20);
        function F(e) {
            M(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset, !0);
        }
        function R(e) {
            M(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset);
        }
        function D(e) {
            null !== r.value && (r.value.$el.style.opacity = e ? 1 : 0);
        }
        function z() {
            const t = [];
            return !0 !== e.noHeaderTabs && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$f3e10d2f5515bdea, {
                class: "q-color-picker__header-tabs",
                modelValue: c.value,
                dense: !0,
                align: "justify",
                ...l("topVTab", {
                    "onUpdate:modelValue": (e)=>{
                        c.value = e;
                    }
                })
            }, ()=>[
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$39ade007f653a559, {
                        label: "HEX" + (!0 === y.value ? "A" : ""),
                        name: "hex",
                        ripple: !1
                    }),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$39ade007f653a559, {
                        label: "RGB" + (!0 === y.value ? "A" : ""),
                        name: "rgb",
                        ripple: !1
                    })
                ])), t.push((0, $TusQn.h)("div", {
                class: "q-color-picker__header-banner row flex-center no-wrap"
            }, [
                (0, $TusQn.h)("input", {
                    class: "fit",
                    value: p.value[c.value],
                    ...!0 !== v.value ? {
                        readonly: !0
                    } : {},
                    ...l("topIn", {
                        onInput: (e)=>{
                            D(!0 === Q(e));
                        },
                        onChange: $ec2fc4c0d7a3c6c6$var$stop,
                        onBlur: (e)=>{
                            !0 === Q(e, !0) && o.$forceUpdate(), D(!1);
                        }
                    })
                }),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    ref: r,
                    class: "q-color-picker__error-icon absolute no-pointer-events",
                    name: n.iconSet.type.negative
                })
            ])), (0, $TusQn.h)("div", {
                class: "q-color-picker__header relative-position overflow-hidden"
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-color-picker__header-bg absolute-full"
                }),
                (0, $TusQn.h)("div", {
                    class: w.value,
                    style: S.value
                }, t)
            ]);
        }
        function I() {
            return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$305a5380acbec321, {
                modelValue: d.value,
                animated: !0
            }, ()=>[
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a513456409dea750, {
                        class: "q-color-picker__spectrum-tab overflow-hidden",
                        name: "spectrum"
                    }, H),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a513456409dea750, {
                        class: "q-pa-md q-color-picker__tune-tab",
                        name: "tune"
                    }, N),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a513456409dea750, {
                        class: "q-color-picker__palette-tab",
                        name: "palette"
                    }, j)
                ]);
        }
        function V() {
            return (0, $TusQn.h)("div", {
                class: "q-color-picker__footer relative-position overflow-hidden"
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$f3e10d2f5515bdea, {
                    class: "absolute-full",
                    modelValue: d.value,
                    dense: !0,
                    align: "justify",
                    ...l("ftIn", {
                        "onUpdate:modelValue": (e)=>{
                            d.value = e;
                        }
                    })
                }, ()=>[
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$39ade007f653a559, {
                            icon: n.iconSet.colorPicker.spectrum,
                            name: "spectrum",
                            ripple: !1
                        }),
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$39ade007f653a559, {
                            icon: n.iconSet.colorPicker.tune,
                            name: "tune",
                            ripple: !1
                        }),
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$39ade007f653a559, {
                            icon: n.iconSet.colorPicker.palette,
                            name: "palette",
                            ripple: !1
                        })
                    ])
            ]);
        }
        function H() {
            const e = {
                ref: i,
                class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (!0 !== v.value ? " readonly" : ""),
                style: C.value,
                ...!0 === v.value ? {
                    onClick: F,
                    onMousedown: R
                } : {}
            }, t = [
                (0, $TusQn.h)("div", {
                    style: {
                        paddingBottom: "100%"
                    }
                }),
                (0, $TusQn.h)("div", {
                    class: "q-color-picker__spectrum-white absolute-full"
                }),
                (0, $TusQn.h)("div", {
                    class: "q-color-picker__spectrum-black absolute-full"
                }),
                (0, $TusQn.h)("div", {
                    class: "absolute",
                    style: x.value
                }, [
                    void 0 !== p.value.hex ? (0, $TusQn.h)("div", {
                        class: "q-color-picker__spectrum-circle"
                    }) : null
                ])
            ], o = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$eccd46d4261ec748, {
                    class: "q-color-picker__hue non-selectable",
                    modelValue: p.value.h,
                    min: 0,
                    max: 360,
                    trackSize: "8px",
                    innerTrackColor: "transparent",
                    selectionColor: "transparent",
                    readonly: !0 !== v.value,
                    thumbPath: $ec2fc4c0d7a3c6c6$var$thumbPath,
                    "onUpdate:modelValue": B,
                    ...l("lazyhue", {
                        onChange: (e)=>B(e, !0)
                    })
                })
            ];
            return !0 === y.value && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$eccd46d4261ec748, {
                class: "q-color-picker__alpha non-selectable",
                modelValue: p.value.a,
                min: 0,
                max: 100,
                trackSize: "8px",
                trackColor: "white",
                innerTrackColor: "transparent",
                selectionColor: "transparent",
                trackImg: $ec2fc4c0d7a3c6c6$var$alphaTrackImg,
                readonly: !0 !== v.value,
                hideSelection: !0,
                thumbPath: $ec2fc4c0d7a3c6c6$var$thumbPath,
                ...l("alphaSlide", {
                    "onUpdate:modelValue": (e)=>E(e, "a", 100),
                    onChange: (e)=>E(e, "a", 100, void 0, !0)
                })
            })), [
                $ec2fc4c0d7a3c6c6$var$hDir("div", e, t, "spec", v.value, ()=>T.value),
                (0, $TusQn.h)("div", {
                    class: "q-color-picker__sliders"
                }, o)
            ];
        }
        function N() {
            return [
                (0, $TusQn.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $TusQn.h)("div", "R"),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$eccd46d4261ec748, {
                        modelValue: p.value.r,
                        min: 0,
                        max: 255,
                        color: "red",
                        dark: a.value,
                        readonly: !0 !== v.value,
                        ...l("rSlide", {
                            "onUpdate:modelValue": (e)=>E(e, "r", 255),
                            onChange: (e)=>E(e, "r", 255, void 0, !0)
                        })
                    }),
                    (0, $TusQn.h)("input", {
                        value: p.value.r,
                        maxlength: 3,
                        readonly: !0 !== v.value,
                        onChange: $ec2fc4c0d7a3c6c6$var$stop,
                        ...l("rIn", {
                            onInput: (e)=>E(e.target.value, "r", 255, e),
                            onBlur: (e)=>E(e.target.value, "r", 255, e, !0)
                        })
                    })
                ]),
                (0, $TusQn.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $TusQn.h)("div", "G"),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$eccd46d4261ec748, {
                        modelValue: p.value.g,
                        min: 0,
                        max: 255,
                        color: "green",
                        dark: a.value,
                        readonly: !0 !== v.value,
                        ...l("gSlide", {
                            "onUpdate:modelValue": (e)=>E(e, "g", 255),
                            onChange: (e)=>E(e, "g", 255, void 0, !0)
                        })
                    }),
                    (0, $TusQn.h)("input", {
                        value: p.value.g,
                        maxlength: 3,
                        readonly: !0 !== v.value,
                        onChange: $ec2fc4c0d7a3c6c6$var$stop,
                        ...l("gIn", {
                            onInput: (e)=>E(e.target.value, "g", 255, e),
                            onBlur: (e)=>E(e.target.value, "g", 255, e, !0)
                        })
                    })
                ]),
                (0, $TusQn.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $TusQn.h)("div", "B"),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$eccd46d4261ec748, {
                        modelValue: p.value.b,
                        min: 0,
                        max: 255,
                        color: "blue",
                        readonly: !0 !== v.value,
                        dark: a.value,
                        ...l("bSlide", {
                            "onUpdate:modelValue": (e)=>E(e, "b", 255),
                            onChange: (e)=>E(e, "b", 255, void 0, !0)
                        })
                    }),
                    (0, $TusQn.h)("input", {
                        value: p.value.b,
                        maxlength: 3,
                        readonly: !0 !== v.value,
                        onChange: $ec2fc4c0d7a3c6c6$var$stop,
                        ...l("bIn", {
                            onInput: (e)=>E(e.target.value, "b", 255, e),
                            onBlur: (e)=>E(e.target.value, "b", 255, e, !0)
                        })
                    })
                ]),
                !0 === y.value ? (0, $TusQn.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $TusQn.h)("div", "A"),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$eccd46d4261ec748, {
                        modelValue: p.value.a,
                        color: "grey",
                        readonly: !0 !== v.value,
                        dark: a.value,
                        ...l("aSlide", {
                            "onUpdate:modelValue": (e)=>E(e, "a", 100),
                            onChange: (e)=>E(e, "a", 100, void 0, !0)
                        })
                    }),
                    (0, $TusQn.h)("input", {
                        value: p.value.a,
                        maxlength: 3,
                        readonly: !0 !== v.value,
                        onChange: $ec2fc4c0d7a3c6c6$var$stop,
                        ...l("aIn", {
                            onInput: (e)=>E(e.target.value, "a", 100, e),
                            onBlur: (e)=>E(e.target.value, "a", 100, e, !0)
                        })
                    })
                ]) : null
            ];
        }
        function j() {
            const e = (e)=>(0, $TusQn.h)("div", {
                    class: "q-color-picker__cube col-auto",
                    style: {
                        backgroundColor: e
                    },
                    ...!0 === v.value ? l("palette#" + e, {
                        onClick: ()=>{
                            A(e);
                        }
                    }) : {}
                });
            return [
                (0, $TusQn.h)("div", {
                    class: "row items-center q-color-picker__palette-rows" + (!0 === v.value ? " q-color-picker__palette-rows--editable" : "")
                }, k.value.map(e))
            ];
        }
        return ()=>{
            const t = [
                I()
            ];
            return void 0 !== e.name && !0 !== e.disable && b(t, "push"), !0 !== e.noHeader && t.unshift(z()), !0 !== e.noFooter && t.push(V()), (0, $TusQn.h)("div", {
                class: _.value,
                ...q.value
            }, t);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$breaks = [
    -61,
    9,
    38,
    199,
    426,
    686,
    756,
    818,
    1111,
    1181,
    1210,
    1635,
    2060,
    2097,
    2192,
    2262,
    2324,
    2394,
    2456,
    3178
];
function $ec2fc4c0d7a3c6c6$var$toJalaali(e, t, o) {
    return "[object Date]" === Object.prototype.toString.call(e) && (o = e.getDate(), t = e.getMonth() + 1, e = e.getFullYear()), $ec2fc4c0d7a3c6c6$var$d2j($ec2fc4c0d7a3c6c6$var$g2d(e, t, o));
}
function $ec2fc4c0d7a3c6c6$var$toGregorian(e, t, o) {
    return $ec2fc4c0d7a3c6c6$var$d2g($ec2fc4c0d7a3c6c6$var$j2d(e, t, o));
}
function $ec2fc4c0d7a3c6c6$var$isLeapJalaaliYear(e) {
    return 0 === $ec2fc4c0d7a3c6c6$var$jalCalLeap(e);
}
function $ec2fc4c0d7a3c6c6$var$jalaaliMonthLength(e, t) {
    return t <= 6 ? 31 : t <= 11 ? 30 : $ec2fc4c0d7a3c6c6$var$isLeapJalaaliYear(e) ? 30 : 29;
}
function $ec2fc4c0d7a3c6c6$var$jalCalLeap(e) {
    const t = $ec2fc4c0d7a3c6c6$var$breaks.length;
    let o, n, a, l, i, r = $ec2fc4c0d7a3c6c6$var$breaks[0];
    if (e < r || e >= $ec2fc4c0d7a3c6c6$var$breaks[t - 1]) throw new Error("Invalid Jalaali year " + e);
    for(i = 1; i < t; i += 1){
        if (o = $ec2fc4c0d7a3c6c6$var$breaks[i], n = o - r, e < o) break;
        r = o;
    }
    return l = e - r, n - l < 6 && (l = l - n + 33 * $ec2fc4c0d7a3c6c6$var$div(n + 4, 33)), a = $ec2fc4c0d7a3c6c6$var$mod($ec2fc4c0d7a3c6c6$var$mod(l + 1, 33) - 1, 4), -1 === a && (a = 4), a;
}
function $ec2fc4c0d7a3c6c6$var$jalCal(e, t) {
    const o = $ec2fc4c0d7a3c6c6$var$breaks.length, n = e + 621;
    let a, l, i, r, s, u = -14, c = $ec2fc4c0d7a3c6c6$var$breaks[0];
    if (e < c || e >= $ec2fc4c0d7a3c6c6$var$breaks[o - 1]) throw new Error("Invalid Jalaali year " + e);
    for(s = 1; s < o; s += 1){
        if (a = $ec2fc4c0d7a3c6c6$var$breaks[s], l = a - c, e < a) break;
        u = u + 8 * $ec2fc4c0d7a3c6c6$var$div(l, 33) + $ec2fc4c0d7a3c6c6$var$div($ec2fc4c0d7a3c6c6$var$mod(l, 33), 4), c = a;
    }
    r = e - c, u = u + 8 * $ec2fc4c0d7a3c6c6$var$div(r, 33) + $ec2fc4c0d7a3c6c6$var$div($ec2fc4c0d7a3c6c6$var$mod(r, 33) + 3, 4), 4 === $ec2fc4c0d7a3c6c6$var$mod(l, 33) && l - r === 4 && (u += 1);
    const d = $ec2fc4c0d7a3c6c6$var$div(n, 4) - $ec2fc4c0d7a3c6c6$var$div(3 * ($ec2fc4c0d7a3c6c6$var$div(n, 100) + 1), 4) - 150, p = 20 + u - d;
    return t || (l - r < 6 && (r = r - l + 33 * $ec2fc4c0d7a3c6c6$var$div(l + 4, 33)), i = $ec2fc4c0d7a3c6c6$var$mod($ec2fc4c0d7a3c6c6$var$mod(r + 1, 33) - 1, 4), -1 === i && (i = 4)), {
        leap: i,
        gy: n,
        march: p
    };
}
function $ec2fc4c0d7a3c6c6$var$j2d(e, t, o) {
    const n = $ec2fc4c0d7a3c6c6$var$jalCal(e, !0);
    return $ec2fc4c0d7a3c6c6$var$g2d(n.gy, 3, n.march) + 31 * (t - 1) - $ec2fc4c0d7a3c6c6$var$div(t, 7) * (t - 7) + o - 1;
}
function $ec2fc4c0d7a3c6c6$var$d2j(e) {
    const t = $ec2fc4c0d7a3c6c6$var$d2g(e).gy;
    let o, n, a, l = t - 621;
    const i = $ec2fc4c0d7a3c6c6$var$jalCal(l, !1), r = $ec2fc4c0d7a3c6c6$var$g2d(t, 3, i.march);
    if (a = e - r, a >= 0) {
        if (a <= 185) return n = 1 + $ec2fc4c0d7a3c6c6$var$div(a, 31), o = $ec2fc4c0d7a3c6c6$var$mod(a, 31) + 1, {
            jy: l,
            jm: n,
            jd: o
        };
        a -= 186;
    } else l -= 1, a += 179, 1 === i.leap && (a += 1);
    return n = 7 + $ec2fc4c0d7a3c6c6$var$div(a, 30), o = $ec2fc4c0d7a3c6c6$var$mod(a, 30) + 1, {
        jy: l,
        jm: n,
        jd: o
    };
}
function $ec2fc4c0d7a3c6c6$var$g2d(e, t, o) {
    let n = $ec2fc4c0d7a3c6c6$var$div(1461 * (e + $ec2fc4c0d7a3c6c6$var$div(t - 8, 6) + 100100), 4) + $ec2fc4c0d7a3c6c6$var$div(153 * $ec2fc4c0d7a3c6c6$var$mod(t + 9, 12) + 2, 5) + o - 34840408;
    return n = n - $ec2fc4c0d7a3c6c6$var$div(3 * $ec2fc4c0d7a3c6c6$var$div(e + 100100 + $ec2fc4c0d7a3c6c6$var$div(t - 8, 6), 100), 4) + 752, n;
}
function $ec2fc4c0d7a3c6c6$var$d2g(e) {
    let t = 4 * e + 139361631;
    t = t + 4 * $ec2fc4c0d7a3c6c6$var$div(3 * $ec2fc4c0d7a3c6c6$var$div(4 * e + 183187720, 146097), 4) - 3908;
    const o = 5 * $ec2fc4c0d7a3c6c6$var$div($ec2fc4c0d7a3c6c6$var$mod(t, 1461), 4) + 308, n = $ec2fc4c0d7a3c6c6$var$div($ec2fc4c0d7a3c6c6$var$mod(o, 153), 5) + 1, a = $ec2fc4c0d7a3c6c6$var$mod($ec2fc4c0d7a3c6c6$var$div(o, 153), 12) + 1, l = $ec2fc4c0d7a3c6c6$var$div(t, 1461) - 100100 + $ec2fc4c0d7a3c6c6$var$div(8 - a, 6);
    return {
        gy: l,
        gm: a,
        gd: n
    };
}
function $ec2fc4c0d7a3c6c6$var$div(e, t) {
    return ~~(e / t);
}
function $ec2fc4c0d7a3c6c6$var$mod(e, t) {
    return e - ~~(e / t) * t;
}
const $ec2fc4c0d7a3c6c6$var$calendars = [
    "gregorian",
    "persian"
], $ec2fc4c0d7a3c6c6$var$useDatetimeProps = {
    modelValue: {
        required: !0
    },
    mask: {
        type: String
    },
    locale: Object,
    calendar: {
        type: String,
        validator: (e)=>$ec2fc4c0d7a3c6c6$var$calendars.includes(e),
        default: "gregorian"
    },
    landscape: Boolean,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    readonly: Boolean,
    disable: Boolean
}, $ec2fc4c0d7a3c6c6$var$useDatetimeEmits = [
    "update:modelValue"
];
function $ec2fc4c0d7a3c6c6$var$getDayHash(e) {
    return e.year + "/" + $ec2fc4c0d7a3c6c6$var$pad(e.month) + "/" + $ec2fc4c0d7a3c6c6$var$pad(e.day);
}
function $ec2fc4c0d7a3c6c6$var$useDatetime(e, t) {
    const o = (0, $TusQn.computed)(()=>{
        return !0 !== e.disable && !0 !== e.readonly;
    }), n = (0, $TusQn.computed)(()=>{
        return !0 === o.value ? 0 : -1;
    }), a = (0, $TusQn.computed)(()=>{
        const t = [];
        return void 0 !== e.color && t.push(`bg-${e.color}`), void 0 !== e.textColor && t.push(`text-${e.textColor}`), t.join(" ");
    });
    function l() {
        return void 0 !== e.locale ? {
            ...t.lang.date,
            ...e.locale
        } : t.lang.date;
    }
    function i(t) {
        const o = new Date, n = !0 === t ? null : 0;
        if ("persian" === e.calendar) {
            const e = $ec2fc4c0d7a3c6c6$var$toJalaali(o);
            return {
                year: e.jy,
                month: e.jm,
                day: e.jd
            };
        }
        return {
            year: o.getFullYear(),
            month: o.getMonth() + 1,
            day: o.getDate(),
            hour: n,
            minute: n,
            second: n,
            millisecond: n
        };
    }
    return {
        editable: o,
        tabindex: n,
        headerClass: a,
        getLocale: l,
        getCurrentDate: i
    };
}
const $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_DAY = 864e5, $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_HOUR = 36e5, $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_MINUTE = 6e4, $ec2fc4c0d7a3c6c6$var$defaultMask = "YYYY-MM-DDTHH:mm:ss.SSSZ", $ec2fc4c0d7a3c6c6$var$token = /\[((?:[^\]\\]|\\]|\\)*)\]|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g, $ec2fc4c0d7a3c6c6$var$reverseToken = /(\[[^\]]*\])|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g, $ec2fc4c0d7a3c6c6$var$regexStore = {};
function $ec2fc4c0d7a3c6c6$var$getRegexData(e, t) {
    const o = "(" + t.days.join("|") + ")", n = e + o;
    if (void 0 !== $ec2fc4c0d7a3c6c6$var$regexStore[n]) return $ec2fc4c0d7a3c6c6$var$regexStore[n];
    const a = "(" + t.daysShort.join("|") + ")", l = "(" + t.months.join("|") + ")", i = "(" + t.monthsShort.join("|") + ")", r = {};
    let s = 0;
    const u = e.replace($ec2fc4c0d7a3c6c6$var$reverseToken, (e)=>{
        switch(s++, e){
            case "YY":
                return r.YY = s, "(-?\\d{1,2})";
            case "YYYY":
                return r.YYYY = s, "(-?\\d{1,4})";
            case "M":
                return r.M = s, "(\\d{1,2})";
            case "MM":
                return r.M = s, "(\\d{2})";
            case "MMM":
                return r.MMM = s, i;
            case "MMMM":
                return r.MMMM = s, l;
            case "D":
                return r.D = s, "(\\d{1,2})";
            case "Do":
                return r.D = s++, "(\\d{1,2}(st|nd|rd|th))";
            case "DD":
                return r.D = s, "(\\d{2})";
            case "H":
                return r.H = s, "(\\d{1,2})";
            case "HH":
                return r.H = s, "(\\d{2})";
            case "h":
                return r.h = s, "(\\d{1,2})";
            case "hh":
                return r.h = s, "(\\d{2})";
            case "m":
                return r.m = s, "(\\d{1,2})";
            case "mm":
                return r.m = s, "(\\d{2})";
            case "s":
                return r.s = s, "(\\d{1,2})";
            case "ss":
                return r.s = s, "(\\d{2})";
            case "S":
                return r.S = s, "(\\d{1})";
            case "SS":
                return r.S = s, "(\\d{2})";
            case "SSS":
                return r.S = s, "(\\d{3})";
            case "A":
                return r.A = s, "(AM|PM)";
            case "a":
                return r.a = s, "(am|pm)";
            case "aa":
                return r.aa = s, "(a\\.m\\.|p\\.m\\.)";
            case "ddd":
                return a;
            case "dddd":
                return o;
            case "Q":
            case "d":
            case "E":
                return "(\\d{1})";
            case "Qo":
                return "(1st|2nd|3rd|4th)";
            case "DDD":
            case "DDDD":
                return "(\\d{1,3})";
            case "w":
                return "(\\d{1,2})";
            case "ww":
                return "(\\d{2})";
            case "Z":
                return r.Z = s, "(Z|[+-]\\d{2}:\\d{2})";
            case "ZZ":
                return r.ZZ = s, "(Z|[+-]\\d{2}\\d{2})";
            case "X":
                return r.X = s, "(-?\\d+)";
            case "x":
                return r.x = s, "(-?\\d{4,})";
            default:
                return s--, "[" === e[0] && (e = e.substring(1, e.length - 1)), e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
    }), c = {
        map: r,
        regex: new RegExp("^" + u)
    };
    return $ec2fc4c0d7a3c6c6$var$regexStore[n] = c, c;
}
function $ec2fc4c0d7a3c6c6$var$getDateLocale(e, t) {
    return void 0 !== e ? e : void 0 !== t ? t.date : $ec2fc4c0d7a3c6c6$var$defaultLang.date;
}
function $ec2fc4c0d7a3c6c6$var$formatTimezone(e, t = "") {
    const o = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), l = n % 60;
    return o + $ec2fc4c0d7a3c6c6$var$pad(a) + t + $ec2fc4c0d7a3c6c6$var$pad(l);
}
function $ec2fc4c0d7a3c6c6$var$applyYearMonthDayChange(e, t, o) {
    let n = e.getFullYear(), a = e.getMonth();
    const l = e.getDate();
    return void 0 !== t.year && (n += o * t.year, delete t.year), void 0 !== t.month && (a += o * t.month, delete t.month), e.setDate(1), e.setMonth(2), e.setFullYear(n), e.setMonth(a), e.setDate(Math.min(l, $ec2fc4c0d7a3c6c6$var$daysInMonth(e))), void 0 !== t.date && (e.setDate(e.getDate() + o * t.date), delete t.date), e;
}
function $ec2fc4c0d7a3c6c6$var$applyYearMonthDay(e, t, o) {
    const n = void 0 !== t.year ? t.year : e[`get${o}FullYear`](), a = void 0 !== t.month ? t.month - 1 : e[`get${o}Month`](), l = new Date(n, a + 1, 0).getDate(), i = Math.min(l, void 0 !== t.date ? t.date : e[`get${o}Date`]());
    return e[`set${o}Date`](1), e[`set${o}Month`](2), e[`set${o}FullYear`](n), e[`set${o}Month`](a), e[`set${o}Date`](i), delete t.year, delete t.month, delete t.date, e;
}
function $ec2fc4c0d7a3c6c6$var$getChange(e, t, o) {
    const n = $ec2fc4c0d7a3c6c6$var$normalizeMod(t), a = new Date(e), l = void 0 !== n.year || void 0 !== n.month || void 0 !== n.date ? $ec2fc4c0d7a3c6c6$var$applyYearMonthDayChange(a, n, o) : a;
    for(const i in n){
        const e = $ec2fc4c0d7a3c6c6$var$capitalize(i);
        l[`set${e}`](l[`get${e}`]() + o * n[i]);
    }
    return l;
}
function $ec2fc4c0d7a3c6c6$var$normalizeMod(e) {
    const t = {
        ...e
    };
    return void 0 !== e.years && (t.year = e.years, delete t.years), void 0 !== e.months && (t.month = e.months, delete t.months), void 0 !== e.days && (t.date = e.days, delete t.days), void 0 !== e.day && (t.date = e.day, delete t.day), void 0 !== e.hour && (t.hours = e.hour, delete t.hour), void 0 !== e.minute && (t.minutes = e.minute, delete t.minute), void 0 !== e.second && (t.seconds = e.second, delete t.second), void 0 !== e.millisecond && (t.milliseconds = e.millisecond, delete t.millisecond), t;
}
function $ec2fc4c0d7a3c6c6$var$adjustDate(e, t, o) {
    const n = $ec2fc4c0d7a3c6c6$var$normalizeMod(t), a = !0 === o ? "UTC" : "", l = new Date(e), i = void 0 !== n.year || void 0 !== n.month || void 0 !== n.date ? $ec2fc4c0d7a3c6c6$var$applyYearMonthDay(l, n, a) : l;
    for(const r in n){
        const e = r.charAt(0).toUpperCase() + r.slice(1);
        i[`set${a}${e}`](n[r]);
    }
    return i;
}
function $ec2fc4c0d7a3c6c6$var$extractDate(e, t, o) {
    const n = $ec2fc4c0d7a3c6c6$var$__splitDate(e, t, o), a = new Date(n.year, null === n.month ? null : n.month - 1, null === n.day ? 1 : n.day, n.hour, n.minute, n.second, n.millisecond), l = a.getTimezoneOffset();
    return null === n.timezoneOffset || n.timezoneOffset === l ? a : $ec2fc4c0d7a3c6c6$var$getChange(a, {
        minutes: n.timezoneOffset - l
    }, 1);
}
function $ec2fc4c0d7a3c6c6$var$__splitDate(e, t, o, n, a) {
    const l = {
        year: null,
        month: null,
        day: null,
        hour: null,
        minute: null,
        second: null,
        millisecond: null,
        timezoneOffset: null,
        dateHash: null,
        timeHash: null
    };
    if (void 0 !== a && Object.assign(l, a), void 0 === e || null === e || "" === e || "string" !== typeof e) return l;
    void 0 === t && (t = $ec2fc4c0d7a3c6c6$var$defaultMask);
    const i = $ec2fc4c0d7a3c6c6$var$getDateLocale(o, $ec2fc4c0d7a3c6c6$var$Plugin$8.props), r = i.months, s = i.monthsShort, { regex: u, map: c } = $ec2fc4c0d7a3c6c6$var$getRegexData(t, i), d = e.match(u);
    if (null === d) return l;
    let p = "";
    if (void 0 !== c.X || void 0 !== c.x) {
        const e = parseInt(d[void 0 !== c.X ? c.X : c.x], 10);
        if (!0 === isNaN(e) || e < 0) return l;
        const t = new Date(e * (void 0 !== c.X ? 1e3 : 1));
        l.year = t.getFullYear(), l.month = t.getMonth() + 1, l.day = t.getDate(), l.hour = t.getHours(), l.minute = t.getMinutes(), l.second = t.getSeconds(), l.millisecond = t.getMilliseconds();
    } else {
        if (void 0 !== c.YYYY) l.year = parseInt(d[c.YYYY], 10);
        else if (void 0 !== c.YY) {
            const e = parseInt(d[c.YY], 10);
            l.year = e < 0 ? e : 2e3 + e;
        }
        if (void 0 !== c.M) {
            if (l.month = parseInt(d[c.M], 10), l.month < 1 || l.month > 12) return l;
        } else void 0 !== c.MMM ? l.month = s.indexOf(d[c.MMM]) + 1 : void 0 !== c.MMMM && (l.month = r.indexOf(d[c.MMMM]) + 1);
        if (void 0 !== c.D) {
            if (l.day = parseInt(d[c.D], 10), null === l.year || null === l.month || l.day < 1) return l;
            const e = "persian" !== n ? new Date(l.year, l.month, 0).getDate() : $ec2fc4c0d7a3c6c6$var$jalaaliMonthLength(l.year, l.month);
            if (l.day > e) return l;
        }
        void 0 !== c.H ? l.hour = parseInt(d[c.H], 10) % 24 : void 0 !== c.h && (l.hour = parseInt(d[c.h], 10) % 12, (c.A && "PM" === d[c.A] || c.a && "pm" === d[c.a] || c.aa && "p.m." === d[c.aa]) && (l.hour += 12), l.hour = l.hour % 24), void 0 !== c.m && (l.minute = parseInt(d[c.m], 10) % 60), void 0 !== c.s && (l.second = parseInt(d[c.s], 10) % 60), void 0 !== c.S && (l.millisecond = parseInt(d[c.S], 10) * 10 ** (3 - d[c.S].length)), void 0 === c.Z && void 0 === c.ZZ || (p = void 0 !== c.Z ? d[c.Z].replace(":", "") : d[c.ZZ], l.timezoneOffset = ("+" === p[0] ? -1 : 1) * (60 * p.slice(1, 3) + 1 * p.slice(3, 5)));
    }
    return l.dateHash = $ec2fc4c0d7a3c6c6$var$pad(l.year, 6) + "/" + $ec2fc4c0d7a3c6c6$var$pad(l.month) + "/" + $ec2fc4c0d7a3c6c6$var$pad(l.day), l.timeHash = $ec2fc4c0d7a3c6c6$var$pad(l.hour) + ":" + $ec2fc4c0d7a3c6c6$var$pad(l.minute) + ":" + $ec2fc4c0d7a3c6c6$var$pad(l.second) + p, l;
}
function $ec2fc4c0d7a3c6c6$var$isValid(e) {
    return "number" === typeof e || !1 === isNaN(Date.parse(e));
}
function $ec2fc4c0d7a3c6c6$var$buildDate(e, t) {
    return $ec2fc4c0d7a3c6c6$var$adjustDate(new Date, e, t);
}
function $ec2fc4c0d7a3c6c6$var$getDayOfWeek(e) {
    const t = new Date(e).getDay();
    return 0 === t ? 7 : t;
}
function $ec2fc4c0d7a3c6c6$var$getWeekOfYear(e) {
    const t = new Date(e.getFullYear(), e.getMonth(), e.getDate());
    t.setDate(t.getDate() - (t.getDay() + 6) % 7 + 3);
    const o = new Date(t.getFullYear(), 0, 4);
    o.setDate(o.getDate() - (o.getDay() + 6) % 7 + 3);
    const n = t.getTimezoneOffset() - o.getTimezoneOffset();
    t.setHours(t.getHours() - n);
    const a = (t - o) / (7 * $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_DAY);
    return 1 + Math.floor(a);
}
function $ec2fc4c0d7a3c6c6$var$getDayIdentifier(e) {
    return 1e4 * e.getFullYear() + 100 * e.getMonth() + e.getDate();
}
function $ec2fc4c0d7a3c6c6$var$getDateIdentifier(e, t) {
    const o = new Date(e);
    return !0 === t ? $ec2fc4c0d7a3c6c6$var$getDayIdentifier(o) : o.getTime();
}
function $ec2fc4c0d7a3c6c6$var$isBetweenDates(e, t, o, n = {}) {
    const a = $ec2fc4c0d7a3c6c6$var$getDateIdentifier(t, n.onlyDate), l = $ec2fc4c0d7a3c6c6$var$getDateIdentifier(o, n.onlyDate), i = $ec2fc4c0d7a3c6c6$var$getDateIdentifier(e, n.onlyDate);
    return (i > a || !0 === n.inclusiveFrom && i === a) && (i < l || !0 === n.inclusiveTo && i === l);
}
function $ec2fc4c0d7a3c6c6$var$addToDate(e, t) {
    return $ec2fc4c0d7a3c6c6$var$getChange(e, t, 1);
}
function $ec2fc4c0d7a3c6c6$var$subtractFromDate(e, t) {
    return $ec2fc4c0d7a3c6c6$var$getChange(e, t, -1);
}
function $ec2fc4c0d7a3c6c6$var$startOfDate(e, t, o) {
    const n = new Date(e), a = `set${!0 === o ? "UTC" : ""}`;
    switch(t){
        case "year":
        case "years":
            n[`${a}Month`](0);
        case "month":
        case "months":
            n[`${a}Date`](1);
        case "day":
        case "days":
        case "date":
            n[`${a}Hours`](0);
        case "hour":
        case "hours":
            n[`${a}Minutes`](0);
        case "minute":
        case "minutes":
            n[`${a}Seconds`](0);
        case "second":
        case "seconds":
            n[`${a}Milliseconds`](0);
    }
    return n;
}
function $ec2fc4c0d7a3c6c6$var$endOfDate(e, t, o) {
    const n = new Date(e), a = `set${!0 === o ? "UTC" : ""}`;
    switch(t){
        case "year":
        case "years":
            n[`${a}Month`](11);
        case "month":
        case "months":
            n[`${a}Date`]($ec2fc4c0d7a3c6c6$var$daysInMonth(n));
        case "day":
        case "days":
        case "date":
            n[`${a}Hours`](23);
        case "hour":
        case "hours":
            n[`${a}Minutes`](59);
        case "minute":
        case "minutes":
            n[`${a}Seconds`](59);
        case "second":
        case "seconds":
            n[`${a}Milliseconds`](999);
    }
    return n;
}
function $ec2fc4c0d7a3c6c6$var$getMaxDate(e) {
    let t = new Date(e);
    return Array.prototype.slice.call(arguments, 1).forEach((e)=>{
        t = Math.max(t, new Date(e));
    }), t;
}
function $ec2fc4c0d7a3c6c6$var$getMinDate(e) {
    let t = new Date(e);
    return Array.prototype.slice.call(arguments, 1).forEach((e)=>{
        t = Math.min(t, new Date(e));
    }), t;
}
function $ec2fc4c0d7a3c6c6$var$getDiff(e, t, o) {
    return (e.getTime() - e.getTimezoneOffset() * $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_MINUTE - (t.getTime() - t.getTimezoneOffset() * $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_MINUTE)) / o;
}
function $ec2fc4c0d7a3c6c6$var$getDateDiff(e, t, o = "days") {
    const n = new Date(e), a = new Date(t);
    switch(o){
        case "years":
        case "year":
            return n.getFullYear() - a.getFullYear();
        case "months":
        case "month":
            return 12 * (n.getFullYear() - a.getFullYear()) + n.getMonth() - a.getMonth();
        case "days":
        case "day":
        case "date":
            return $ec2fc4c0d7a3c6c6$var$getDiff($ec2fc4c0d7a3c6c6$var$startOfDate(n, "day"), $ec2fc4c0d7a3c6c6$var$startOfDate(a, "day"), $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_DAY);
        case "hours":
        case "hour":
            return $ec2fc4c0d7a3c6c6$var$getDiff($ec2fc4c0d7a3c6c6$var$startOfDate(n, "hour"), $ec2fc4c0d7a3c6c6$var$startOfDate(a, "hour"), $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_HOUR);
        case "minutes":
        case "minute":
            return $ec2fc4c0d7a3c6c6$var$getDiff($ec2fc4c0d7a3c6c6$var$startOfDate(n, "minute"), $ec2fc4c0d7a3c6c6$var$startOfDate(a, "minute"), $ec2fc4c0d7a3c6c6$var$MILLISECONDS_IN_MINUTE);
        case "seconds":
        case "second":
            return $ec2fc4c0d7a3c6c6$var$getDiff($ec2fc4c0d7a3c6c6$var$startOfDate(n, "second"), $ec2fc4c0d7a3c6c6$var$startOfDate(a, "second"), 1e3);
    }
}
function $ec2fc4c0d7a3c6c6$var$getDayOfYear(e) {
    return $ec2fc4c0d7a3c6c6$var$getDateDiff(e, $ec2fc4c0d7a3c6c6$var$startOfDate(e, "year"), "days") + 1;
}
function $ec2fc4c0d7a3c6c6$var$inferDateFormat(e) {
    return !0 === $ec2fc4c0d7a3c6c6$var$isDate(e) ? "date" : "number" === typeof e ? "number" : "string";
}
function $ec2fc4c0d7a3c6c6$var$getDateBetween(e, t, o) {
    const n = new Date(e);
    if (t) {
        const e = new Date(t);
        if (n < e) return e;
    }
    if (o) {
        const e = new Date(o);
        if (n > e) return e;
    }
    return n;
}
function $ec2fc4c0d7a3c6c6$var$isSameDate(e, t, o) {
    const n = new Date(e), a = new Date(t);
    if (void 0 === o) return n.getTime() === a.getTime();
    switch(o){
        case "second":
        case "seconds":
            if (n.getSeconds() !== a.getSeconds()) return !1;
        case "minute":
        case "minutes":
            if (n.getMinutes() !== a.getMinutes()) return !1;
        case "hour":
        case "hours":
            if (n.getHours() !== a.getHours()) return !1;
        case "day":
        case "days":
        case "date":
            if (n.getDate() !== a.getDate()) return !1;
        case "month":
        case "months":
            if (n.getMonth() !== a.getMonth()) return !1;
        case "year":
        case "years":
            if (n.getFullYear() !== a.getFullYear()) return !1;
            break;
        default:
            throw new Error(`date isSameDate unknown unit ${o}`);
    }
    return !0;
}
function $ec2fc4c0d7a3c6c6$var$daysInMonth(e) {
    return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
}
function $ec2fc4c0d7a3c6c6$var$getOrdinal(e) {
    if (e >= 11 && e <= 13) return `${e}th`;
    switch(e % 10){
        case 1:
            return `${e}st`;
        case 2:
            return `${e}nd`;
        case 3:
            return `${e}rd`;
    }
    return `${e}th`;
}
const $ec2fc4c0d7a3c6c6$var$formatter = {
    YY (e, t, o) {
        const n = this.YYYY(e, t, o) % 100;
        return n >= 0 ? $ec2fc4c0d7a3c6c6$var$pad(n) : "-" + $ec2fc4c0d7a3c6c6$var$pad(Math.abs(n));
    },
    YYYY (e, t, o) {
        return void 0 !== o && null !== o ? o : e.getFullYear();
    },
    M (e) {
        return e.getMonth() + 1;
    },
    MM (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(e.getMonth() + 1);
    },
    MMM (e, t) {
        return t.monthsShort[e.getMonth()];
    },
    MMMM (e, t) {
        return t.months[e.getMonth()];
    },
    Q (e) {
        return Math.ceil((e.getMonth() + 1) / 3);
    },
    Qo (e) {
        return $ec2fc4c0d7a3c6c6$var$getOrdinal(this.Q(e));
    },
    D (e) {
        return e.getDate();
    },
    Do (e) {
        return $ec2fc4c0d7a3c6c6$var$getOrdinal(e.getDate());
    },
    DD (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(e.getDate());
    },
    DDD (e) {
        return $ec2fc4c0d7a3c6c6$var$getDayOfYear(e);
    },
    DDDD (e) {
        return $ec2fc4c0d7a3c6c6$var$pad($ec2fc4c0d7a3c6c6$var$getDayOfYear(e), 3);
    },
    d (e) {
        return e.getDay();
    },
    dd (e, t) {
        return this.dddd(e, t).slice(0, 2);
    },
    ddd (e, t) {
        return t.daysShort[e.getDay()];
    },
    dddd (e, t) {
        return t.days[e.getDay()];
    },
    E (e) {
        return e.getDay() || 7;
    },
    w (e) {
        return $ec2fc4c0d7a3c6c6$var$getWeekOfYear(e);
    },
    ww (e) {
        return $ec2fc4c0d7a3c6c6$var$pad($ec2fc4c0d7a3c6c6$var$getWeekOfYear(e));
    },
    H (e) {
        return e.getHours();
    },
    HH (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(e.getHours());
    },
    h (e) {
        const t = e.getHours();
        return 0 === t ? 12 : t > 12 ? t % 12 : t;
    },
    hh (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(this.h(e));
    },
    m (e) {
        return e.getMinutes();
    },
    mm (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(e.getMinutes());
    },
    s (e) {
        return e.getSeconds();
    },
    ss (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(e.getSeconds());
    },
    S (e) {
        return Math.floor(e.getMilliseconds() / 100);
    },
    SS (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(Math.floor(e.getMilliseconds() / 10));
    },
    SSS (e) {
        return $ec2fc4c0d7a3c6c6$var$pad(e.getMilliseconds(), 3);
    },
    A (e) {
        return this.H(e) < 12 ? "AM" : "PM";
    },
    a (e) {
        return this.H(e) < 12 ? "am" : "pm";
    },
    aa (e) {
        return this.H(e) < 12 ? "a.m." : "p.m.";
    },
    Z (e, t, o, n) {
        const a = void 0 === n || null === n ? e.getTimezoneOffset() : n;
        return $ec2fc4c0d7a3c6c6$var$formatTimezone(a, ":");
    },
    ZZ (e, t, o, n) {
        const a = void 0 === n || null === n ? e.getTimezoneOffset() : n;
        return $ec2fc4c0d7a3c6c6$var$formatTimezone(a);
    },
    X (e) {
        return Math.floor(e.getTime() / 1e3);
    },
    x (e) {
        return e.getTime();
    }
};
function $ec2fc4c0d7a3c6c6$var$formatDate(e, t, o, n, a) {
    if (0 !== e && !e || e === 1 / 0 || e === -1 / 0) return;
    const l = new Date(e);
    if (isNaN(l)) return;
    void 0 === t && (t = $ec2fc4c0d7a3c6c6$var$defaultMask);
    const i = $ec2fc4c0d7a3c6c6$var$getDateLocale(o, $ec2fc4c0d7a3c6c6$var$Plugin$8.props);
    return t.replace($ec2fc4c0d7a3c6c6$var$token, (e, t)=>e in $ec2fc4c0d7a3c6c6$var$formatter ? $ec2fc4c0d7a3c6c6$var$formatter[e](l, i, n, a) : void 0 === t ? e : t.split("\\]").join("]"));
}
function $ec2fc4c0d7a3c6c6$var$clone(e) {
    return !0 === $ec2fc4c0d7a3c6c6$var$isDate(e) ? new Date(e.getTime()) : e;
}
var $ec2fc4c0d7a3c6c6$export$324d90190a8b822a = {
    isValid: $ec2fc4c0d7a3c6c6$var$isValid,
    extractDate: $ec2fc4c0d7a3c6c6$var$extractDate,
    buildDate: $ec2fc4c0d7a3c6c6$var$buildDate,
    getDayOfWeek: $ec2fc4c0d7a3c6c6$var$getDayOfWeek,
    getWeekOfYear: $ec2fc4c0d7a3c6c6$var$getWeekOfYear,
    isBetweenDates: $ec2fc4c0d7a3c6c6$var$isBetweenDates,
    addToDate: $ec2fc4c0d7a3c6c6$var$addToDate,
    subtractFromDate: $ec2fc4c0d7a3c6c6$var$subtractFromDate,
    adjustDate: $ec2fc4c0d7a3c6c6$var$adjustDate,
    startOfDate: $ec2fc4c0d7a3c6c6$var$startOfDate,
    endOfDate: $ec2fc4c0d7a3c6c6$var$endOfDate,
    getMaxDate: $ec2fc4c0d7a3c6c6$var$getMaxDate,
    getMinDate: $ec2fc4c0d7a3c6c6$var$getMinDate,
    getDateDiff: $ec2fc4c0d7a3c6c6$var$getDateDiff,
    getDayOfYear: $ec2fc4c0d7a3c6c6$var$getDayOfYear,
    inferDateFormat: $ec2fc4c0d7a3c6c6$var$inferDateFormat,
    getDateBetween: $ec2fc4c0d7a3c6c6$var$getDateBetween,
    isSameDate: $ec2fc4c0d7a3c6c6$var$isSameDate,
    daysInMonth: $ec2fc4c0d7a3c6c6$var$daysInMonth,
    formatDate: $ec2fc4c0d7a3c6c6$var$formatDate,
    clone: $ec2fc4c0d7a3c6c6$var$clone
};
const $ec2fc4c0d7a3c6c6$var$yearsInterval = 20, $ec2fc4c0d7a3c6c6$var$views = [
    "Calendar",
    "Years",
    "Months"
], $ec2fc4c0d7a3c6c6$var$viewIsValid = (e)=>$ec2fc4c0d7a3c6c6$var$views.includes(e), $ec2fc4c0d7a3c6c6$var$yearMonthValidator = (e)=>/^-?[\d]+\/[0-1]\d$/.test(e), $ec2fc4c0d7a3c6c6$var$lineStr = " — ";
function $ec2fc4c0d7a3c6c6$var$getMonthHash(e) {
    return e.year + "/" + $ec2fc4c0d7a3c6c6$var$pad(e.month);
}
var $ec2fc4c0d7a3c6c6$export$599a443f7d1feef = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QDate",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDatetimeProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        multiple: Boolean,
        range: Boolean,
        title: String,
        subtitle: String,
        mask: {
            default: "YYYY/MM/DD"
        },
        defaultYearMonth: {
            type: String,
            validator: $ec2fc4c0d7a3c6c6$var$yearMonthValidator
        },
        yearsInMonthView: Boolean,
        events: [
            Array,
            Function
        ],
        eventColor: [
            String,
            Function
        ],
        emitImmediately: Boolean,
        options: [
            Array,
            Function
        ],
        navigationMinYearMonth: {
            type: String,
            validator: $ec2fc4c0d7a3c6c6$var$yearMonthValidator
        },
        navigationMaxYearMonth: {
            type: String,
            validator: $ec2fc4c0d7a3c6c6$var$yearMonthValidator
        },
        noUnset: Boolean,
        firstDayOfWeek: [
            String,
            Number
        ],
        todayBtn: Boolean,
        minimal: Boolean,
        defaultView: {
            type: String,
            default: "Calendar",
            validator: $ec2fc4c0d7a3c6c6$var$viewIsValid
        }
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useDatetimeEmits,
        "rangeStart",
        "rangeEnd",
        "navigation"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = $ec2fc4c0d7a3c6c6$var$useDark(e, a), { getCache: i } = $ec2fc4c0d7a3c6c6$var$useCache(), { tabindex: r, headerClass: s, getLocale: u, getCurrentDate: c } = $ec2fc4c0d7a3c6c6$var$useDatetime(e, a);
        let d;
        const p = $ec2fc4c0d7a3c6c6$var$useFormAttrs(e), v = $ec2fc4c0d7a3c6c6$var$useFormInject(p), m = (0, $01W3b.ref)(null), f = (0, $01W3b.ref)(de()), g = (0, $01W3b.ref)(u()), b = (0, $TusQn.computed)(()=>de()), y = (0, $TusQn.computed)(()=>u()), S = (0, $TusQn.computed)(()=>c()), w = (0, $01W3b.ref)(ve(f.value, g.value)), C = (0, $01W3b.ref)(e.defaultView), x = !0 === a.lang.rtl ? "right" : "left", k = (0, $01W3b.ref)(x.value), _ = (0, $01W3b.ref)(x.value), q = w.value.year, T = (0, $01W3b.ref)(q - q % $ec2fc4c0d7a3c6c6$var$yearsInterval - (q < 0 ? $ec2fc4c0d7a3c6c6$var$yearsInterval : 0)), P = (0, $01W3b.ref)(null), $ = (0, $TusQn.computed)(()=>{
            const t = !0 === e.landscape ? "landscape" : "portrait";
            return `q-date q-date--${t} q-date--${t}-${!0 === e.minimal ? "minimal" : "standard"}` + (!0 === l.value ? " q-date--dark q-dark" : "") + (!0 === e.bordered ? " q-date--bordered" : "") + (!0 === e.square ? " q-date--square no-border-radius" : "") + (!0 === e.flat ? " q-date--flat no-shadow" : "") + (!0 === e.disable ? " disabled" : !0 === e.readonly ? " q-date--readonly" : "");
        }), M = (0, $TusQn.computed)(()=>{
            return e.color || "primary";
        }), B = (0, $TusQn.computed)(()=>{
            return e.textColor || "white";
        }), E = (0, $TusQn.computed)(()=>!0 === e.emitImmediately && !0 !== e.multiple && !0 !== e.range), Q = (0, $TusQn.computed)(()=>!0 === Array.isArray(e.modelValue) ? e.modelValue : null !== e.modelValue && void 0 !== e.modelValue ? [
                e.modelValue
            ] : []), A = (0, $TusQn.computed)(()=>Q.value.filter((e)=>"string" === typeof e).map((e)=>pe(e, f.value, g.value)).filter((e)=>null !== e.dateHash && null !== e.day && null !== e.month && null !== e.year)), L = (0, $TusQn.computed)(()=>{
            const e = (e)=>pe(e, f.value, g.value);
            return Q.value.filter((e)=>!0 === $ec2fc4c0d7a3c6c6$var$isObject(e) && void 0 !== e.from && void 0 !== e.to).map((t)=>({
                    from: e(t.from),
                    to: e(t.to)
                })).filter((e)=>null !== e.from.dateHash && null !== e.to.dateHash && e.from.dateHash < e.to.dateHash);
        }), O = (0, $TusQn.computed)(()=>"persian" !== e.calendar ? (e)=>new Date(e.year, e.month - 1, e.day) : (e)=>{
                const t = $ec2fc4c0d7a3c6c6$var$toGregorian(e.year, e.month, e.day);
                return new Date(t.gy, t.gm - 1, t.gd);
            }), F = (0, $TusQn.computed)(()=>"persian" === e.calendar ? $ec2fc4c0d7a3c6c6$var$getDayHash : (e, t, o)=>$ec2fc4c0d7a3c6c6$var$formatDate(new Date(e.year, e.month - 1, e.day, e.hour, e.minute, e.second, e.millisecond), void 0 === t ? f.value : t, void 0 === o ? g.value : o, e.year, e.timezoneOffset)), R = (0, $TusQn.computed)(()=>A.value.length + L.value.reduce((e, t)=>e + 1 + $ec2fc4c0d7a3c6c6$var$getDateDiff(O.value(t.to), O.value(t.from)), 0)), D = (0, $TusQn.computed)(()=>{
            if (void 0 !== e.title && null !== e.title && 0 !== e.title.length) return e.title;
            if (null !== P.value) {
                const e = P.value.init, t = O.value(e);
                return g.value.daysShort[t.getDay()] + ", " + g.value.monthsShort[e.month - 1] + " " + e.day + $ec2fc4c0d7a3c6c6$var$lineStr + "?";
            }
            if (0 === R.value) return $ec2fc4c0d7a3c6c6$var$lineStr;
            if (R.value > 1) return `${R.value} ${g.value.pluralDay}`;
            const t = A.value[0], o = O.value(t);
            return !0 === isNaN(o.valueOf()) ? $ec2fc4c0d7a3c6c6$var$lineStr : void 0 !== g.value.headerTitle ? g.value.headerTitle(o, t) : g.value.daysShort[o.getDay()] + ", " + g.value.monthsShort[t.month - 1] + " " + t.day;
        }), z = (0, $TusQn.computed)(()=>{
            const e = A.value.concat(L.value.map((e)=>e.from)).sort((e, t)=>e.year - t.year || e.month - t.month);
            return e[0];
        }), I = (0, $TusQn.computed)(()=>{
            const e = A.value.concat(L.value.map((e)=>e.to)).sort((e, t)=>t.year - e.year || t.month - e.month);
            return e[0];
        }), V = (0, $TusQn.computed)(()=>{
            if (void 0 !== e.subtitle && null !== e.subtitle && 0 !== e.subtitle.length) return e.subtitle;
            if (0 === R.value) return $ec2fc4c0d7a3c6c6$var$lineStr;
            if (R.value > 1) {
                const e = z.value, t = I.value, o = g.value.monthsShort;
                return o[e.month - 1] + (e.year !== t.year ? " " + e.year + $ec2fc4c0d7a3c6c6$var$lineStr + o[t.month - 1] + " " : e.month !== t.month ? $ec2fc4c0d7a3c6c6$var$lineStr + o[t.month - 1] : "") + " " + t.year;
            }
            return A.value[0].year;
        }), H = (0, $TusQn.computed)(()=>{
            const e = [
                a.iconSet.datetime.arrowLeft,
                a.iconSet.datetime.arrowRight
            ];
            return !0 === a.lang.rtl ? e.reverse() : e;
        }), N = (0, $TusQn.computed)(()=>void 0 !== e.firstDayOfWeek ? Number(e.firstDayOfWeek) : g.value.firstDayOfWeek), j = (0, $TusQn.computed)(()=>{
            const e = g.value.daysShort, t = N.value;
            return t > 0 ? e.slice(t, 7).concat(e.slice(0, t)) : e;
        }), U = (0, $TusQn.computed)(()=>{
            const t = w.value;
            return "persian" !== e.calendar ? new Date(t.year, t.month, 0).getDate() : $ec2fc4c0d7a3c6c6$var$jalaaliMonthLength(t.year, t.month);
        }), K = (0, $TusQn.computed)(()=>"function" === typeof e.eventColor ? e.eventColor : ()=>e.eventColor), W = (0, $TusQn.computed)(()=>{
            if (void 0 === e.navigationMinYearMonth) return null;
            const t = e.navigationMinYearMonth.split("/");
            return {
                year: parseInt(t[0], 10),
                month: parseInt(t[1], 10)
            };
        }), Y = (0, $TusQn.computed)(()=>{
            if (void 0 === e.navigationMaxYearMonth) return null;
            const t = e.navigationMaxYearMonth.split("/");
            return {
                year: parseInt(t[0], 10),
                month: parseInt(t[1], 10)
            };
        }), G = (0, $TusQn.computed)(()=>{
            const e = {
                month: {
                    prev: !0,
                    next: !0
                },
                year: {
                    prev: !0,
                    next: !0
                }
            };
            return null !== W.value && W.value.year >= w.value.year && (e.year.prev = !1, W.value.year === w.value.year && W.value.month >= w.value.month && (e.month.prev = !1)), null !== Y.value && Y.value.year <= w.value.year && (e.year.next = !1, Y.value.year === w.value.year && Y.value.month <= w.value.month && (e.month.next = !1)), e;
        }), X = (0, $TusQn.computed)(()=>{
            const e = {};
            return A.value.forEach((t)=>{
                const o = $ec2fc4c0d7a3c6c6$var$getMonthHash(t);
                void 0 === e[o] && (e[o] = []), e[o].push(t.day);
            }), e;
        }), Z = (0, $TusQn.computed)(()=>{
            const e = {};
            return L.value.forEach((t)=>{
                const o = $ec2fc4c0d7a3c6c6$var$getMonthHash(t.from), n = $ec2fc4c0d7a3c6c6$var$getMonthHash(t.to);
                if (void 0 === e[o] && (e[o] = []), e[o].push({
                    from: t.from.day,
                    to: o === n ? t.to.day : void 0,
                    range: t
                }), o < n) {
                    let o;
                    const { year: a, month: l } = t.from, i = l < 12 ? {
                        year: a,
                        month: l + 1
                    } : {
                        year: a + 1,
                        month: 1
                    };
                    while((o = $ec2fc4c0d7a3c6c6$var$getMonthHash(i)) <= n)void 0 === e[o] && (e[o] = []), e[o].push({
                        from: void 0,
                        to: o === n ? t.to.day : void 0,
                        range: t
                    }), i.month++, i.month > 12 && (i.year++, i.month = 1);
                }
            }), e;
        }), J = (0, $TusQn.computed)(()=>{
            if (null === P.value) return;
            const { init: e, initHash: t, final: o, finalHash: n } = P.value, [a, l] = t <= n ? [
                e,
                o
            ] : [
                o,
                e
            ], i = $ec2fc4c0d7a3c6c6$var$getMonthHash(a), r = $ec2fc4c0d7a3c6c6$var$getMonthHash(l);
            if (i !== ee.value && r !== ee.value) return;
            const s = {};
            return i === ee.value ? (s.from = a.day, s.includeFrom = !0) : s.from = 1, r === ee.value ? (s.to = l.day, s.includeTo = !0) : s.to = U.value, s;
        }), ee = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getMonthHash(w.value)), te = (0, $TusQn.computed)(()=>{
            const t = {};
            if (void 0 === e.options) {
                for(let e = 1; e <= U.value; e++)t[e] = !0;
                return t;
            }
            const o = "function" === typeof e.options ? e.options : (t)=>e.options.includes(t);
            for(let e = 1; e <= U.value; e++){
                const n = ee.value + "/" + $ec2fc4c0d7a3c6c6$var$pad(e);
                t[e] = o(n);
            }
            return t;
        }), oe = (0, $TusQn.computed)(()=>{
            const t = {};
            if (void 0 === e.events) for(let e = 1; e <= U.value; e++)t[e] = !1;
            else {
                const o = "function" === typeof e.events ? e.events : (t)=>e.events.includes(t);
                for(let e = 1; e <= U.value; e++){
                    const n = ee.value + "/" + $ec2fc4c0d7a3c6c6$var$pad(e);
                    t[e] = !0 === o(n) && K.value(n);
                }
            }
            return t;
        }), ne = (0, $TusQn.computed)(()=>{
            let t, o;
            const { year: n, month: a } = w.value;
            if ("persian" !== e.calendar) t = new Date(n, a - 1, 1), o = new Date(n, a - 1, 0).getDate();
            else {
                const e = $ec2fc4c0d7a3c6c6$var$toGregorian(n, a, 1);
                t = new Date(e.gy, e.gm - 1, e.gd);
                let l = a - 1, i = n;
                0 === l && (l = 12, i--), o = $ec2fc4c0d7a3c6c6$var$jalaaliMonthLength(i, l);
            }
            return {
                days: t.getDay() - N.value - 1,
                endDay: o
            };
        }), ae = (0, $TusQn.computed)(()=>{
            const e = [], { days: t, endDay: o } = ne.value, n = t < 0 ? t + 7 : t;
            if (n < 6) for(let i = o - n; i <= o; i++)e.push({
                i: i,
                fill: !0
            });
            const a = e.length;
            for(let i = 1; i <= U.value; i++){
                const t = {
                    i: i,
                    event: oe.value[i],
                    classes: []
                };
                !0 === te.value[i] && (t.in = !0, t.flat = !0), e.push(t);
            }
            if (void 0 !== X.value[ee.value] && X.value[ee.value].forEach((t)=>{
                const o = a + t - 1;
                Object.assign(e[o], {
                    selected: !0,
                    unelevated: !0,
                    flat: !1,
                    color: M.value,
                    textColor: B.value
                });
            }), void 0 !== Z.value[ee.value] && Z.value[ee.value].forEach((t)=>{
                if (void 0 !== t.from) {
                    const o = a + t.from - 1, n = a + (t.to || U.value) - 1;
                    for(let a = o; a <= n; a++)Object.assign(e[a], {
                        range: t.range,
                        unelevated: !0,
                        color: M.value,
                        textColor: B.value
                    });
                    Object.assign(e[o], {
                        rangeFrom: !0,
                        flat: !1
                    }), void 0 !== t.to && Object.assign(e[n], {
                        rangeTo: !0,
                        flat: !1
                    });
                } else if (void 0 !== t.to) {
                    const o = a + t.to - 1;
                    for(let n = a; n <= o; n++)Object.assign(e[n], {
                        range: t.range,
                        unelevated: !0,
                        color: M.value,
                        textColor: B.value
                    });
                    Object.assign(e[o], {
                        flat: !1,
                        rangeTo: !0
                    });
                } else {
                    const o = a + U.value - 1;
                    for(let n = a; n <= o; n++)Object.assign(e[n], {
                        range: t.range,
                        unelevated: !0,
                        color: M.value,
                        textColor: B.value
                    });
                }
            }), void 0 !== J.value) {
                const t = a + J.value.from - 1, o = a + J.value.to - 1;
                for(let n = t; n <= o; n++)e[n].color = M.value, e[n].editRange = !0;
                !0 === J.value.includeFrom && (e[t].editRangeFrom = !0), !0 === J.value.includeTo && (e[o].editRangeTo = !0);
            }
            w.value.year === S.value.year && w.value.month === S.value.month && (e[a + S.value.day - 1].today = !0);
            const l = e.length % 7;
            if (l > 0) {
                const t = 7 - l;
                for(let o = 1; o <= t; o++)e.push({
                    i: o,
                    fill: !0
                });
            }
            return e.forEach((e)=>{
                let t = "q-date__calendar-item ";
                !0 === e.fill ? t += "q-date__calendar-item--fill" : (t += `q-date__calendar-item--${!0 === e.in ? "in" : "out"}`, void 0 !== e.range && (t += ` q-date__range${!0 === e.rangeTo ? "-to" : !0 === e.rangeFrom ? "-from" : ""}`), !0 === e.editRange && (t += ` q-date__edit-range${!0 === e.editRangeFrom ? "-from" : ""}${!0 === e.editRangeTo ? "-to" : ""}`), void 0 === e.range && !0 !== e.editRange || (t += ` text-${e.color}`)), e.classes = t;
            }), e;
        }), le = (0, $TusQn.computed)(()=>!0 === e.disable ? {
                "aria-disabled": "true"
            } : !0 === e.readonly ? {
                "aria-readonly": "true"
            } : {});
        function ie() {
            const e = S.value, t = X.value[$ec2fc4c0d7a3c6c6$var$getMonthHash(e)];
            void 0 !== t && !1 !== t.includes(e.day) || qe(e), ue(e.year, e.month);
        }
        function re(e) {
            !0 === $ec2fc4c0d7a3c6c6$var$viewIsValid(e) && (C.value = e);
        }
        function se(e, t) {
            if ([
                "month",
                "year"
            ].includes(e)) {
                const o = "month" === e ? fe : he;
                o(!0 === t ? -1 : 1);
            }
        }
        function ue(e, t) {
            C.value = "Calendar", we(e, t);
        }
        function ce(t, o) {
            if (!1 === e.range || !t) return void (P.value = null);
            const n = Object.assign({
                ...w.value
            }, t), a = void 0 !== o ? Object.assign({
                ...w.value
            }, o) : n;
            P.value = {
                init: n,
                initHash: $ec2fc4c0d7a3c6c6$var$getDayHash(n),
                final: a,
                finalHash: $ec2fc4c0d7a3c6c6$var$getDayHash(a)
            }, ue(n.year, n.month);
        }
        function de() {
            return "persian" === e.calendar ? "YYYY/MM/DD" : e.mask;
        }
        function pe(t, o, n) {
            return $ec2fc4c0d7a3c6c6$var$__splitDate(t, o, n, e.calendar, {
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            });
        }
        function ve(t, o) {
            const n = !0 === Array.isArray(e.modelValue) ? e.modelValue : e.modelValue ? [
                e.modelValue
            ] : [];
            if (0 === n.length) return me();
            const a = n[n.length - 1], l = pe(void 0 !== a.from ? a.from : a, t, o);
            return null === l.dateHash ? me() : l;
        }
        function me() {
            let t, o;
            if (void 0 !== e.defaultYearMonth) {
                const n = e.defaultYearMonth.split("/");
                t = parseInt(n[0], 10), o = parseInt(n[1], 10);
            } else {
                const e = void 0 !== S.value ? S.value : c();
                t = e.year, o = e.month;
            }
            return {
                year: t,
                month: o,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                dateHash: t + "/" + $ec2fc4c0d7a3c6c6$var$pad(o) + "/01"
            };
        }
        function fe(e) {
            let t = w.value.year, o = Number(w.value.month) + e;
            13 === o ? (o = 1, t++) : 0 === o && (o = 12, t--), we(t, o), !0 === E.value && xe("month");
        }
        function he(e) {
            const t = Number(w.value.year) + e;
            we(t, w.value.month), !0 === E.value && xe("year");
        }
        function ge(t) {
            we(t, w.value.month), C.value = "Years" === e.defaultView ? "Months" : "Calendar", !0 === E.value && xe("year");
        }
        function be(e) {
            we(w.value.year, e), C.value = "Calendar", !0 === E.value && xe("month");
        }
        function ye(e, t) {
            const o = X.value[t], n = void 0 !== o && !0 === o.includes(e.day) ? Te : qe;
            n(e);
        }
        function Se(e) {
            return {
                year: e.year,
                month: e.month,
                day: e.day
            };
        }
        function we(e, t, o) {
            if (null !== W.value && e <= W.value.year && (e = W.value.year, t < W.value.month && (t = W.value.month)), null !== Y.value && e >= Y.value.year && (e = Y.value.year, t > Y.value.month && (t = Y.value.month)), void 0 !== o) {
                const { hour: e, minute: t, second: n, millisecond: a, timezoneOffset: l, timeHash: i } = o;
                Object.assign(w.value, {
                    hour: e,
                    minute: t,
                    second: n,
                    millisecond: a,
                    timezoneOffset: l,
                    timeHash: i
                });
            }
            const n = e + "/" + $ec2fc4c0d7a3c6c6$var$pad(t) + "/01";
            n !== w.value.dateHash && (k.value = w.value.dateHash < n === (!0 !== a.lang.rtl) ? "left" : "right", e !== w.value.year && (_.value = k.value), (0, $TusQn.nextTick)(()=>{
                T.value = e - e % $ec2fc4c0d7a3c6c6$var$yearsInterval - (e < 0 ? $ec2fc4c0d7a3c6c6$var$yearsInterval : 0), Object.assign(w.value, {
                    year: e,
                    month: t,
                    day: 1,
                    dateHash: n
                });
            }));
        }
        function Ce(t, n, a) {
            const l = null !== t && 1 === t.length && !1 === e.multiple ? t[0] : t;
            d = l;
            const { reason: i, details: r } = ke(n, a);
            o("update:modelValue", l, i, r);
        }
        function xe(t) {
            const n = void 0 !== A.value[0] && null !== A.value[0].dateHash ? {
                ...A.value[0]
            } : {
                ...w.value
            };
            (0, $TusQn.nextTick)(()=>{
                n.year = w.value.year, n.month = w.value.month;
                const a = "persian" !== e.calendar ? new Date(n.year, n.month, 0).getDate() : $ec2fc4c0d7a3c6c6$var$jalaaliMonthLength(n.year, n.month);
                n.day = Math.min(Math.max(1, n.day), a);
                const l = _e(n);
                d = l;
                const { details: i } = ke("", n);
                o("update:modelValue", l, t, i);
            });
        }
        function ke(e, t) {
            return void 0 !== t.from ? {
                reason: `${e}-range`,
                details: {
                    ...Se(t.target),
                    from: Se(t.from),
                    to: Se(t.to)
                }
            } : {
                reason: `${e}-day`,
                details: Se(t)
            };
        }
        function _e(e, t, o) {
            return void 0 !== e.from ? {
                from: F.value(e.from, t, o),
                to: F.value(e.to, t, o)
            } : F.value(e, t, o);
        }
        function qe(t) {
            let o;
            if (!0 === e.multiple) {
                if (void 0 !== t.from) {
                    const e = $ec2fc4c0d7a3c6c6$var$getDayHash(t.from), n = $ec2fc4c0d7a3c6c6$var$getDayHash(t.to), a = A.value.filter((t)=>t.dateHash < e || t.dateHash > n), l = L.value.filter(({ from: t, to: o })=>o.dateHash < e || t.dateHash > n);
                    o = a.concat(l).concat(t).map((e)=>_e(e));
                } else {
                    const e = Q.value.slice();
                    e.push(_e(t)), o = e;
                }
            } else o = _e(t);
            Ce(o, "add", t);
        }
        function Te(t) {
            if (!0 === e.noUnset) return;
            let o = null;
            if (!0 === e.multiple && !0 === Array.isArray(e.modelValue)) {
                const n = _e(t);
                o = void 0 !== t.from ? e.modelValue.filter((e)=>void 0 === e.from || e.from !== n.from && e.to !== n.to) : e.modelValue.filter((e)=>e !== n), 0 === o.length && (o = null);
            }
            Ce(o, "remove", t);
        }
        function Pe(t, n, a) {
            const l = A.value.concat(L.value).map((e)=>_e(e, t, n)).filter((e)=>{
                return void 0 !== e.from ? null !== e.from.dateHash && null !== e.to.dateHash : null !== e.dateHash;
            });
            o("update:modelValue", (!0 === e.multiple ? l : l[0]) || null, a);
        }
        function $e() {
            if (!0 !== e.minimal) return (0, $TusQn.h)("div", {
                class: "q-date__header " + s.value
            }, [
                (0, $TusQn.h)("div", {
                    class: "relative-position"
                }, [
                    (0, $TusQn.h)((0, $eeJ70.Transition), {
                        name: "q-transition--fade"
                    }, ()=>(0, $TusQn.h)("div", {
                            key: "h-yr-" + V.value,
                            class: "q-date__header-subtitle q-date__header-link " + ("Years" === C.value ? "q-date__header-link--active" : "cursor-pointer"),
                            tabindex: r.value,
                            ...i("vY", {
                                onClick () {
                                    C.value = "Years";
                                },
                                onKeyup (e) {
                                    13 === e.keyCode && (C.value = "Years");
                                }
                            })
                        }, [
                            V.value
                        ]))
                ]),
                (0, $TusQn.h)("div", {
                    class: "q-date__header-title relative-position flex no-wrap"
                }, [
                    (0, $TusQn.h)("div", {
                        class: "relative-position col"
                    }, [
                        (0, $TusQn.h)((0, $eeJ70.Transition), {
                            name: "q-transition--fade"
                        }, ()=>(0, $TusQn.h)("div", {
                                key: "h-sub" + D.value,
                                class: "q-date__header-title-label q-date__header-link " + ("Calendar" === C.value ? "q-date__header-link--active" : "cursor-pointer"),
                                tabindex: r.value,
                                ...i("vC", {
                                    onClick () {
                                        C.value = "Calendar";
                                    },
                                    onKeyup (e) {
                                        13 === e.keyCode && (C.value = "Calendar");
                                    }
                                })
                            }, [
                                D.value
                            ]))
                    ]),
                    !0 === e.todayBtn ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        class: "q-date__header-today self-start",
                        icon: a.iconSet.datetime.today,
                        flat: !0,
                        size: "sm",
                        round: !0,
                        tabindex: r.value,
                        onClick: ie
                    }) : null
                ])
            ]);
        }
        function Me({ label: e, type: t, key: o, dir: n, goTo: a, boundaries: l, cls: s }) {
            return [
                (0, $TusQn.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        round: !0,
                        dense: !0,
                        size: "sm",
                        flat: !0,
                        icon: H.value[0],
                        tabindex: r.value,
                        disable: !1 === l.prev,
                        ...i("go-#" + t, {
                            onClick () {
                                a(-1);
                            }
                        })
                    })
                ]),
                (0, $TusQn.h)("div", {
                    class: "relative-position overflow-hidden flex flex-center" + s
                }, [
                    (0, $TusQn.h)((0, $eeJ70.Transition), {
                        name: "q-transition--jump-" + n
                    }, ()=>(0, $TusQn.h)("div", {
                            key: o
                        }, [
                            (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                                flat: !0,
                                dense: !0,
                                noCaps: !0,
                                label: e,
                                tabindex: r.value,
                                ...i("view#" + t, {
                                    onClick: ()=>{
                                        C.value = t;
                                    }
                                })
                            })
                        ]))
                ]),
                (0, $TusQn.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        round: !0,
                        dense: !0,
                        size: "sm",
                        flat: !0,
                        icon: H.value[1],
                        tabindex: r.value,
                        disable: !1 === l.next,
                        ...i("go+#" + t, {
                            onClick () {
                                a(1);
                            }
                        })
                    })
                ])
            ];
        }
        (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            if (d === e) d = 0;
            else {
                const e = ve(f.value, g.value);
                we(e.year, e.month, e);
            }
        }), (0, $TusQn.watch)(C, ()=>{
            null !== m.value && !0 === n.$el.contains(document.activeElement) && m.value.focus();
        }), (0, $TusQn.watch)(()=>w.value.year + "|" + w.value.month, ()=>{
            o("navigation", {
                year: w.value.year,
                month: w.value.month
            });
        }), (0, $TusQn.watch)(b, (e)=>{
            Pe(e, g.value, "mask"), f.value = e;
        }), (0, $TusQn.watch)(y, (e)=>{
            Pe(f.value, e, "locale"), g.value = e;
        });
        const Be = {
            Calendar: ()=>[
                    (0, $TusQn.h)("div", {
                        key: "calendar-view",
                        class: "q-date__view q-date__calendar"
                    }, [
                        (0, $TusQn.h)("div", {
                            class: "q-date__navigation row items-center no-wrap"
                        }, Me({
                            label: g.value.months[w.value.month - 1],
                            type: "Months",
                            key: w.value.month,
                            dir: k.value,
                            goTo: fe,
                            boundaries: G.value.month,
                            cls: " col"
                        }).concat(Me({
                            label: w.value.year,
                            type: "Years",
                            key: w.value.year,
                            dir: _.value,
                            goTo: he,
                            boundaries: G.value.year,
                            cls: ""
                        }))),
                        (0, $TusQn.h)("div", {
                            class: "q-date__calendar-weekdays row items-center no-wrap"
                        }, j.value.map((e)=>(0, $TusQn.h)("div", {
                                class: "q-date__calendar-item"
                            }, [
                                (0, $TusQn.h)("div", e)
                            ]))),
                        (0, $TusQn.h)("div", {
                            class: "q-date__calendar-days-container relative-position overflow-hidden"
                        }, [
                            (0, $TusQn.h)((0, $eeJ70.Transition), {
                                name: "q-transition--slide-" + k.value
                            }, ()=>(0, $TusQn.h)("div", {
                                    key: ee.value,
                                    class: "q-date__calendar-days fit"
                                }, ae.value.map((e)=>(0, $TusQn.h)("div", {
                                        class: e.classes
                                    }, [
                                        !0 === e.in ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                                            class: !0 === e.today ? "q-date__today" : "",
                                            dense: !0,
                                            flat: e.flat,
                                            unelevated: e.unelevated,
                                            color: e.color,
                                            textColor: e.textColor,
                                            label: e.i,
                                            tabindex: r.value,
                                            ...i("day#" + e.i, {
                                                onClick: ()=>{
                                                    Ee(e.i);
                                                },
                                                onMouseover: ()=>{
                                                    Qe(e.i);
                                                }
                                            })
                                        }, !1 !== e.event ? ()=>(0, $TusQn.h)("div", {
                                                class: "q-date__event bg-" + e.event
                                            }) : null) : (0, $TusQn.h)("div", "" + e.i)
                                    ]))))
                        ])
                    ])
                ],
            Months () {
                const t = w.value.year === S.value.year, o = (e)=>{
                    return null !== W.value && w.value.year === W.value.year && W.value.month > e || null !== Y.value && w.value.year === Y.value.year && Y.value.month < e;
                }, n = g.value.monthsShort.map((e, n)=>{
                    const a = w.value.month === n + 1;
                    return (0, $TusQn.h)("div", {
                        class: "q-date__months-item flex flex-center"
                    }, [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                            class: !0 === t && S.value.month === n + 1 ? "q-date__today" : null,
                            flat: !0 !== a,
                            label: e,
                            unelevated: a,
                            color: !0 === a ? M.value : null,
                            textColor: !0 === a ? B.value : null,
                            tabindex: r.value,
                            disable: o(n + 1),
                            ...i("month#" + n, {
                                onClick: ()=>{
                                    be(n + 1);
                                }
                            })
                        })
                    ]);
                });
                return !0 === e.yearsInMonthView && n.unshift((0, $TusQn.h)("div", {
                    class: "row no-wrap full-width"
                }, [
                    Me({
                        label: w.value.year,
                        type: "Years",
                        key: w.value.year,
                        dir: _.value,
                        goTo: he,
                        boundaries: G.value.year,
                        cls: " col"
                    })
                ])), (0, $TusQn.h)("div", {
                    key: "months-view",
                    class: "q-date__view q-date__months flex flex-center"
                }, n);
            },
            Years () {
                const e = T.value, t = e + $ec2fc4c0d7a3c6c6$var$yearsInterval, o = [], n = (e)=>{
                    return null !== W.value && W.value.year > e || null !== Y.value && Y.value.year < e;
                };
                for(let a = e; a <= t; a++){
                    const e = w.value.year === a;
                    o.push((0, $TusQn.h)("div", {
                        class: "q-date__years-item flex flex-center"
                    }, [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                            key: "yr" + a,
                            class: S.value.year === a ? "q-date__today" : null,
                            flat: !e,
                            label: a,
                            dense: !0,
                            unelevated: e,
                            color: !0 === e ? M.value : null,
                            textColor: !0 === e ? B.value : null,
                            tabindex: r.value,
                            disable: n(a),
                            ...i("yr#" + a, {
                                onClick: ()=>{
                                    ge(a);
                                }
                            })
                        })
                    ]));
                }
                return (0, $TusQn.h)("div", {
                    class: "q-date__view q-date__years flex flex-center"
                }, [
                    (0, $TusQn.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                            round: !0,
                            dense: !0,
                            flat: !0,
                            icon: H.value[0],
                            tabindex: r.value,
                            disable: n(e),
                            ...i("y-", {
                                onClick: ()=>{
                                    T.value -= $ec2fc4c0d7a3c6c6$var$yearsInterval;
                                }
                            })
                        })
                    ]),
                    (0, $TusQn.h)("div", {
                        class: "q-date__years-content col self-stretch row items-center"
                    }, o),
                    (0, $TusQn.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                            round: !0,
                            dense: !0,
                            flat: !0,
                            icon: H.value[1],
                            tabindex: r.value,
                            disable: n(t),
                            ...i("y+", {
                                onClick: ()=>{
                                    T.value += $ec2fc4c0d7a3c6c6$var$yearsInterval;
                                }
                            })
                        })
                    ])
                ]);
            }
        };
        function Ee(t) {
            const n = {
                ...w.value,
                day: t
            };
            if (!1 !== e.range) {
                if (null === P.value) {
                    const a = ae.value.find((e)=>!0 !== e.fill && e.i === t);
                    if (!0 !== e.noUnset && void 0 !== a.range) return void Te({
                        target: n,
                        from: a.range.from,
                        to: a.range.to
                    });
                    if (!0 === a.selected) return void Te(n);
                    const l = $ec2fc4c0d7a3c6c6$var$getDayHash(n);
                    P.value = {
                        init: n,
                        initHash: l,
                        final: n,
                        finalHash: l
                    }, o("rangeStart", Se(n));
                } else {
                    const e = P.value.initHash, t = $ec2fc4c0d7a3c6c6$var$getDayHash(n), a = e <= t ? {
                        from: P.value.init,
                        to: n
                    } : {
                        from: n,
                        to: P.value.init
                    };
                    P.value = null, qe(e === t ? n : {
                        target: n,
                        ...a
                    }), o("rangeEnd", {
                        from: Se(a.from),
                        to: Se(a.to)
                    });
                }
            } else ye(n, ee.value);
        }
        function Qe(e) {
            if (null !== P.value) {
                const t = {
                    ...w.value,
                    day: e
                };
                Object.assign(P.value, {
                    final: t,
                    finalHash: $ec2fc4c0d7a3c6c6$var$getDayHash(t)
                });
            }
        }
        return Object.assign(n, {
            setToday: ie,
            setView: re,
            offsetCalendar: se,
            setCalendarTo: ue,
            setEditingRange: ce
        }), ()=>{
            const o = [
                (0, $TusQn.h)("div", {
                    class: "q-date__content col relative-position"
                }, [
                    (0, $TusQn.h)((0, $eeJ70.Transition), {
                        name: "q-transition--fade"
                    }, Be[C.value])
                ])
            ], n = $ec2fc4c0d7a3c6c6$var$hSlot(t.default);
            return void 0 !== n && o.push((0, $TusQn.h)("div", {
                class: "q-date__actions"
            }, n)), void 0 !== e.name && !0 !== e.disable && v(o, "push"), (0, $TusQn.h)("div", {
                class: $.value,
                ...le.value
            }, [
                $e(),
                (0, $TusQn.h)("div", {
                    ref: m,
                    class: "q-date__main col column",
                    tabindex: -1
                }, o)
            ]);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$useHistory(e, t, o) {
    let n;
    function a() {
        void 0 !== n && ($ec2fc4c0d7a3c6c6$var$History.remove(n), n = void 0);
    }
    return (0, $TusQn.onBeforeUnmount)(()=>{
        !0 === e.value && a();
    }), {
        removeFromHistory: a,
        addToHistory () {
            n = {
                condition: ()=>!0 === o.value,
                handler: t
            }, $ec2fc4c0d7a3c6c6$var$History.add(n);
        }
    };
}
let $ec2fc4c0d7a3c6c6$var$scrollPositionX, $ec2fc4c0d7a3c6c6$var$scrollPositionY, $ec2fc4c0d7a3c6c6$var$maxScrollTop, $ec2fc4c0d7a3c6c6$var$bodyLeft, $ec2fc4c0d7a3c6c6$var$bodyTop, $ec2fc4c0d7a3c6c6$var$href, $ec2fc4c0d7a3c6c6$var$registered = 0, $ec2fc4c0d7a3c6c6$var$vpPendingUpdate = !1, $ec2fc4c0d7a3c6c6$var$closeTimer = null;
function $ec2fc4c0d7a3c6c6$var$onWheel(e) {
    $ec2fc4c0d7a3c6c6$var$shouldPreventScroll(e) && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
}
function $ec2fc4c0d7a3c6c6$var$shouldPreventScroll(e) {
    if (e.target === document.body || e.target.classList.contains("q-layout__backdrop")) return !0;
    const t = $ec2fc4c0d7a3c6c6$var$getEventPath(e), o = e.shiftKey && !e.deltaX, n = !o && Math.abs(e.deltaX) <= Math.abs(e.deltaY), a = o || n ? e.deltaY : e.deltaX;
    for(let l = 0; l < t.length; l++){
        const e = t[l];
        if ($ec2fc4c0d7a3c6c6$var$hasScrollbar(e, n)) return n ? a < 0 && 0 === e.scrollTop || a > 0 && e.scrollTop + e.clientHeight === e.scrollHeight : a < 0 && 0 === e.scrollLeft || a > 0 && e.scrollLeft + e.clientWidth === e.scrollWidth;
    }
    return !0;
}
function $ec2fc4c0d7a3c6c6$var$onAppleScroll(e) {
    e.target === document && (document.scrollingElement.scrollTop = document.scrollingElement.scrollTop);
}
function $ec2fc4c0d7a3c6c6$var$onAppleResize(e) {
    !0 !== $ec2fc4c0d7a3c6c6$var$vpPendingUpdate && ($ec2fc4c0d7a3c6c6$var$vpPendingUpdate = !0, requestAnimationFrame(()=>{
        $ec2fc4c0d7a3c6c6$var$vpPendingUpdate = !1;
        const { height: t } = e.target, { clientHeight: o, scrollTop: n } = document.scrollingElement;
        void 0 !== $ec2fc4c0d7a3c6c6$var$maxScrollTop && t === window.innerHeight || ($ec2fc4c0d7a3c6c6$var$maxScrollTop = o - t, document.scrollingElement.scrollTop = n), n > $ec2fc4c0d7a3c6c6$var$maxScrollTop && (document.scrollingElement.scrollTop -= Math.ceil((n - $ec2fc4c0d7a3c6c6$var$maxScrollTop) / 8));
    }));
}
function $ec2fc4c0d7a3c6c6$var$apply$1(e) {
    const t = document.body, o = void 0 !== window.visualViewport;
    if ("add" === e) {
        const { overflowY: e, overflowX: n } = window.getComputedStyle(t);
        $ec2fc4c0d7a3c6c6$var$scrollPositionX = $ec2fc4c0d7a3c6c6$var$getHorizontalScrollPosition(window), $ec2fc4c0d7a3c6c6$var$scrollPositionY = $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(window), $ec2fc4c0d7a3c6c6$var$bodyLeft = t.style.left, $ec2fc4c0d7a3c6c6$var$bodyTop = t.style.top, $ec2fc4c0d7a3c6c6$var$href = window.location.href, t.style.left = `-${$ec2fc4c0d7a3c6c6$var$scrollPositionX}px`, t.style.top = `-${$ec2fc4c0d7a3c6c6$var$scrollPositionY}px`, "hidden" !== n && ("scroll" === n || t.scrollWidth > window.innerWidth) && t.classList.add("q-body--force-scrollbar-x"), "hidden" !== e && ("scroll" === e || t.scrollHeight > window.innerHeight) && t.classList.add("q-body--force-scrollbar-y"), t.classList.add("q-body--prevent-scroll"), document.qScrollPrevented = !0, !0 === $ec2fc4c0d7a3c6c6$var$client.is.ios && (!0 === o ? (window.scrollTo(0, 0), window.visualViewport.addEventListener("resize", $ec2fc4c0d7a3c6c6$var$onAppleResize, $ec2fc4c0d7a3c6c6$var$listenOpts.passiveCapture), window.visualViewport.addEventListener("scroll", $ec2fc4c0d7a3c6c6$var$onAppleResize, $ec2fc4c0d7a3c6c6$var$listenOpts.passiveCapture), window.scrollTo(0, 0)) : window.addEventListener("scroll", $ec2fc4c0d7a3c6c6$var$onAppleScroll, $ec2fc4c0d7a3c6c6$var$listenOpts.passiveCapture));
    }
    !0 === $ec2fc4c0d7a3c6c6$var$client.is.desktop && !0 === $ec2fc4c0d7a3c6c6$var$client.is.mac && window[`${e}EventListener`]("wheel", $ec2fc4c0d7a3c6c6$var$onWheel, $ec2fc4c0d7a3c6c6$var$listenOpts.notPassive), "remove" === e && (!0 === $ec2fc4c0d7a3c6c6$var$client.is.ios && (!0 === o ? (window.visualViewport.removeEventListener("resize", $ec2fc4c0d7a3c6c6$var$onAppleResize, $ec2fc4c0d7a3c6c6$var$listenOpts.passiveCapture), window.visualViewport.removeEventListener("scroll", $ec2fc4c0d7a3c6c6$var$onAppleResize, $ec2fc4c0d7a3c6c6$var$listenOpts.passiveCapture)) : window.removeEventListener("scroll", $ec2fc4c0d7a3c6c6$var$onAppleScroll, $ec2fc4c0d7a3c6c6$var$listenOpts.passiveCapture)), t.classList.remove("q-body--prevent-scroll"), t.classList.remove("q-body--force-scrollbar-x"), t.classList.remove("q-body--force-scrollbar-y"), document.qScrollPrevented = !1, t.style.left = $ec2fc4c0d7a3c6c6$var$bodyLeft, t.style.top = $ec2fc4c0d7a3c6c6$var$bodyTop, window.location.href === $ec2fc4c0d7a3c6c6$var$href && window.scrollTo($ec2fc4c0d7a3c6c6$var$scrollPositionX, $ec2fc4c0d7a3c6c6$var$scrollPositionY), $ec2fc4c0d7a3c6c6$var$maxScrollTop = void 0);
}
function $ec2fc4c0d7a3c6c6$var$preventScroll(e) {
    let t = "add";
    if (!0 === e) {
        if ($ec2fc4c0d7a3c6c6$var$registered++, null !== $ec2fc4c0d7a3c6c6$var$closeTimer) return clearTimeout($ec2fc4c0d7a3c6c6$var$closeTimer), void ($ec2fc4c0d7a3c6c6$var$closeTimer = null);
        if ($ec2fc4c0d7a3c6c6$var$registered > 1) return;
    } else {
        if (0 === $ec2fc4c0d7a3c6c6$var$registered) return;
        if ($ec2fc4c0d7a3c6c6$var$registered--, $ec2fc4c0d7a3c6c6$var$registered > 0) return;
        if (t = "remove", !0 === $ec2fc4c0d7a3c6c6$var$client.is.ios && !0 === $ec2fc4c0d7a3c6c6$var$client.is.nativeMobile) return null !== $ec2fc4c0d7a3c6c6$var$closeTimer && clearTimeout($ec2fc4c0d7a3c6c6$var$closeTimer), void ($ec2fc4c0d7a3c6c6$var$closeTimer = setTimeout(()=>{
            $ec2fc4c0d7a3c6c6$var$apply$1(t), $ec2fc4c0d7a3c6c6$var$closeTimer = null;
        }, 100));
    }
    $ec2fc4c0d7a3c6c6$var$apply$1(t);
}
function $ec2fc4c0d7a3c6c6$var$usePreventScroll() {
    let e;
    return {
        preventBodyScroll (t) {
            t === e || void 0 === e && !0 !== t || (e = t, $ec2fc4c0d7a3c6c6$var$preventScroll(t));
        }
    };
}
let $ec2fc4c0d7a3c6c6$var$maximizedModals = 0;
const $ec2fc4c0d7a3c6c6$var$positionClass$1 = {
    standard: "fixed-full flex-center",
    top: "fixed-top justify-center",
    bottom: "fixed-bottom justify-center",
    right: "fixed-right items-center",
    left: "fixed-left items-center"
}, $ec2fc4c0d7a3c6c6$var$defaultTransitions = {
    standard: [
        "scale",
        "scale"
    ],
    top: [
        "slide-down",
        "slide-up"
    ],
    bottom: [
        "slide-up",
        "slide-down"
    ],
    right: [
        "slide-left",
        "slide-right"
    ],
    left: [
        "slide-right",
        "slide-left"
    ]
};
var $ec2fc4c0d7a3c6c6$export$e6ccdac5fb3e2417 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QDialog",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleProps,
        ...$ec2fc4c0d7a3c6c6$var$useTransitionProps,
        transitionShow: String,
        transitionHide: String,
        persistent: Boolean,
        autoClose: Boolean,
        allowFocusOutside: Boolean,
        noEscDismiss: Boolean,
        noBackdropDismiss: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        noShake: Boolean,
        seamless: Boolean,
        maximized: Boolean,
        fullWidth: Boolean,
        fullHeight: Boolean,
        square: Boolean,
        position: {
            type: String,
            default: "standard",
            validator: (e)=>"standard" === e || [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].includes(e)
        }
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleEmits,
        "shake",
        "click",
        "escapeKey"
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        const a = (0, $TusQn.getCurrentInstance)(), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(!1), r = (0, $01W3b.ref)(!1);
        let s, u, c = null, d = null;
        const p = (0, $TusQn.computed)(()=>!0 !== e.persistent && !0 !== e.noRouteDismiss && !0 !== e.seamless), { preventBodyScroll: v } = $ec2fc4c0d7a3c6c6$var$usePreventScroll(), { registerTimeout: m } = $ec2fc4c0d7a3c6c6$var$useTimeout(), { registerTick: f, removeTick: g } = $ec2fc4c0d7a3c6c6$var$useTick(), { transitionProps: b, transitionStyle: y } = $ec2fc4c0d7a3c6c6$var$useTransition(e, ()=>$ec2fc4c0d7a3c6c6$var$defaultTransitions[e.position][0], ()=>$ec2fc4c0d7a3c6c6$var$defaultTransitions[e.position][1]), { showPortal: S, hidePortal: w, portalIsAccessible: C, renderPortal: x } = $ec2fc4c0d7a3c6c6$var$usePortal(a, l, I, "dialog"), { hide: k } = $ec2fc4c0d7a3c6c6$var$useModelToggle({
            showing: i,
            hideOnRouteChange: p,
            handleShow: B,
            handleHide: E,
            processOnMount: !0
        }), { addToHistory: _, removeFromHistory: q } = $ec2fc4c0d7a3c6c6$var$useHistory(i, k, p), T = (0, $TusQn.computed)(()=>"q-dialog__inner flex no-pointer-events" + ` q-dialog__inner--${!0 === e.maximized ? "maximized" : "minimized"}` + ` q-dialog__inner--${e.position} ${$ec2fc4c0d7a3c6c6$var$positionClass$1[e.position]}` + (!0 === r.value ? " q-dialog__inner--animating" : "") + (!0 === e.fullWidth ? " q-dialog__inner--fullwidth" : "") + (!0 === e.fullHeight ? " q-dialog__inner--fullheight" : "") + (!0 === e.square ? " q-dialog__inner--square" : "")), P = (0, $TusQn.computed)(()=>!0 === i.value && !0 !== e.seamless), $ = (0, $TusQn.computed)(()=>!0 === e.autoClose ? {
                onClick: R
            } : {}), M = (0, $TusQn.computed)(()=>[
                "q-dialog fullscreen no-pointer-events " + `q-dialog--${!0 === P.value ? "modal" : "seamless"}`,
                n.class
            ]);
        function B(t) {
            _(), d = !1 === e.noRefocus && null !== document.activeElement ? document.activeElement : null, F(e.maximized), S(), r.value = !0, !0 !== e.noFocus ? (null !== document.activeElement && document.activeElement.blur(), f(Q)) : g(), m(()=>{
                if (!0 === a.proxy.$q.platform.is.ios) {
                    if (!0 !== e.seamless && document.activeElement) {
                        const { top: e, bottom: t } = document.activeElement.getBoundingClientRect(), { innerHeight: o } = window, n = void 0 !== window.visualViewport ? window.visualViewport.height : o;
                        e > 0 && t > n / 2 && (document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollHeight - n, t >= o ? 1 / 0 : Math.ceil(document.scrollingElement.scrollTop + t - n / 2))), document.activeElement.scrollIntoView();
                    }
                    u = !0, l.value.click(), u = !1;
                }
                S(!0), r.value = !1, o("show", t);
            }, e.transitionDuration);
        }
        function E(t) {
            g(), q(), O(!0), r.value = !0, w(), null !== d && (((t && 0 === t.type.indexOf("key") ? d.closest('[tabindex]:not([tabindex^="-"])') : void 0) || d).focus(), d = null), m(()=>{
                w(!0), r.value = !1, o("hide", t);
            }, e.transitionDuration);
        }
        function Q(e) {
            $ec2fc4c0d7a3c6c6$var$addFocusFn(()=>{
                let t = l.value;
                null !== t && !0 !== t.contains(document.activeElement) && (t = ("" !== e ? t.querySelector(e) : null) || t.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || t.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || t.querySelector("[autofocus], [data-autofocus]") || t, t.focus({
                    preventScroll: !0
                }));
            });
        }
        function A(e) {
            e && "function" === typeof e.focus ? e.focus({
                preventScroll: !0
            }) : Q(), o("shake");
            const t = l.value;
            null !== t && (t.classList.remove("q-animate--scale"), t.classList.add("q-animate--scale"), null !== c && clearTimeout(c), c = setTimeout(()=>{
                c = null, null !== l.value && (t.classList.remove("q-animate--scale"), Q());
            }, 170));
        }
        function L() {
            !0 !== e.seamless && (!0 === e.persistent || !0 === e.noEscDismiss ? !0 !== e.maximized && !0 !== e.noShake && A() : (o("escapeKey"), k()));
        }
        function O(t) {
            null !== c && (clearTimeout(c), c = null), !0 !== t && !0 !== i.value || (F(!1), !0 !== e.seamless && (v(!1), $ec2fc4c0d7a3c6c6$var$removeFocusout(z), $ec2fc4c0d7a3c6c6$var$removeEscapeKey(L))), !0 !== t && (d = null);
        }
        function F(e) {
            !0 === e ? !0 !== s && ($ec2fc4c0d7a3c6c6$var$maximizedModals < 1 && document.body.classList.add("q-body--dialog"), $ec2fc4c0d7a3c6c6$var$maximizedModals++, s = !0) : !0 === s && ($ec2fc4c0d7a3c6c6$var$maximizedModals < 2 && document.body.classList.remove("q-body--dialog"), $ec2fc4c0d7a3c6c6$var$maximizedModals--, s = !1);
        }
        function R(e) {
            !0 !== u && (k(e), o("click", e));
        }
        function D(t) {
            !0 !== e.persistent && !0 !== e.noBackdropDismiss ? k(t) : !0 !== e.noShake && A();
        }
        function z(t) {
            !0 !== e.allowFocusOutside && !0 === C.value && !0 !== $ec2fc4c0d7a3c6c6$var$childHasFocus(l.value, t.target) && Q('[tabindex]:not([tabindex="-1"])');
        }
        function I() {
            return (0, $TusQn.h)("div", {
                role: "dialog",
                "aria-modal": !0 === P.value ? "true" : "false",
                ...n,
                class: M.value
            }, [
                (0, $TusQn.h)((0, $eeJ70.Transition), {
                    name: "q-transition--fade",
                    appear: !0
                }, ()=>!0 === P.value ? (0, $TusQn.h)("div", {
                        class: "q-dialog__backdrop fixed-full",
                        style: y.value,
                        "aria-hidden": "true",
                        tabindex: -1,
                        onClick: D
                    }) : null),
                (0, $TusQn.h)((0, $eeJ70.Transition), b.value, ()=>!0 === i.value ? (0, $TusQn.h)("div", {
                        ref: l,
                        class: T.value,
                        style: y.value,
                        tabindex: -1,
                        ...$.value
                    }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)) : null)
            ]);
        }
        return (0, $TusQn.watch)(()=>e.maximized, (e)=>{
            !0 === i.value && F(e);
        }), (0, $TusQn.watch)(P, (e)=>{
            v(e), !0 === e ? ($ec2fc4c0d7a3c6c6$var$addFocusout(z), $ec2fc4c0d7a3c6c6$var$addEscapeKey(L)) : ($ec2fc4c0d7a3c6c6$var$removeFocusout(z), $ec2fc4c0d7a3c6c6$var$removeEscapeKey(L));
        }), Object.assign(a.proxy, {
            focus: Q,
            shake: A,
            __updateRefocusTarget (e) {
                d = e || null;
            }
        }), (0, $TusQn.onBeforeUnmount)(O), x;
    }
});
const $ec2fc4c0d7a3c6c6$var$duration = 150;
var $ec2fc4c0d7a3c6c6$export$8bd189b8cd6124c2 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QDrawer",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleProps,
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        side: {
            type: String,
            default: "left",
            validator: (e)=>[
                    "left",
                    "right"
                ].includes(e)
        },
        width: {
            type: Number,
            default: 300
        },
        mini: Boolean,
        miniToOverlay: Boolean,
        miniWidth: {
            type: Number,
            default: 57
        },
        noMiniAnimation: Boolean,
        breakpoint: {
            type: Number,
            default: 1023
        },
        showIfAbove: Boolean,
        behavior: {
            type: String,
            validator: (e)=>[
                    "default",
                    "desktop",
                    "mobile"
                ].includes(e),
            default: "default"
        },
        bordered: Boolean,
        elevated: Boolean,
        overlay: Boolean,
        persistent: Boolean,
        noSwipeOpen: Boolean,
        noSwipeClose: Boolean,
        noSwipeBackdrop: Boolean
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleEmits,
        "onLayout",
        "miniState"
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        const a = (0, $TusQn.getCurrentInstance)(), { proxy: { $q: l } } = a, i = $ec2fc4c0d7a3c6c6$var$useDark(e, l), { preventBodyScroll: r } = $ec2fc4c0d7a3c6c6$var$usePreventScroll(), { registerTimeout: s, removeTimeout: u } = $ec2fc4c0d7a3c6c6$var$useTimeout(), c = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$layoutKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (c === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QDrawer needs to be child of QLayout"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        let d, p, v = null;
        const m = (0, $01W3b.ref)("mobile" === e.behavior || "desktop" !== e.behavior && c.totalWidth.value <= e.breakpoint), f = (0, $TusQn.computed)(()=>!0 === e.mini && !0 !== m.value), g = (0, $TusQn.computed)(()=>!0 === f.value ? e.miniWidth : e.width), b = (0, $01W3b.ref)(!0 === e.showIfAbove && !1 === m.value || !0 === e.modelValue), y = (0, $TusQn.computed)(()=>!0 !== e.persistent && (!0 === m.value || !0 === F.value));
        function S(e, t) {
            if (k(), !1 !== e && c.animate(), G(0), !0 === m.value) {
                const e = c.instances[Q.value];
                void 0 !== e && !0 === e.belowBreakpoint && e.hide(!1), X(1), !0 !== c.isContainer.value && r(!0);
            } else X(0), !1 !== e && Z(!1);
            s(()=>{
                !1 !== e && Z(!0), !0 !== t && o("show", e);
            }, $ec2fc4c0d7a3c6c6$var$duration);
        }
        function w(e, t) {
            _(), !1 !== e && c.animate(), X(0), G(P.value * g.value), oe(), !0 !== t ? s(()=>{
                o("hide", e);
            }, $ec2fc4c0d7a3c6c6$var$duration) : u();
        }
        const { show: C, hide: x } = $ec2fc4c0d7a3c6c6$var$useModelToggle({
            showing: b,
            hideOnRouteChange: y,
            handleShow: S,
            handleHide: w
        }), { addToHistory: k, removeFromHistory: _ } = $ec2fc4c0d7a3c6c6$var$useHistory(b, x, y), q = {
            belowBreakpoint: m,
            hide: x
        }, T = (0, $TusQn.computed)(()=>"right" === e.side), P = (0, $TusQn.computed)(()=>(!0 === l.lang.rtl ? -1 : 1) * (!0 === T.value ? 1 : -1)), $ = (0, $01W3b.ref)(0), M = (0, $01W3b.ref)(!1), B = (0, $01W3b.ref)(!1), E = (0, $01W3b.ref)(g.value * P.value), Q = (0, $TusQn.computed)(()=>!0 === T.value ? "left" : "right"), A = (0, $TusQn.computed)(()=>!0 === b.value && !1 === m.value && !1 === e.overlay ? !0 === e.miniToOverlay ? e.miniWidth : g.value : 0), L = (0, $TusQn.computed)(()=>!0 === e.overlay || !0 === e.miniToOverlay || c.view.value.indexOf(T.value ? "R" : "L") > -1 || !0 === l.platform.is.ios && !0 === c.isContainer.value), O = (0, $TusQn.computed)(()=>!1 === e.overlay && !0 === b.value && !1 === m.value), F = (0, $TusQn.computed)(()=>!0 === e.overlay && !0 === b.value && !1 === m.value), R = (0, $TusQn.computed)(()=>"fullscreen q-drawer__backdrop" + (!1 === b.value && !1 === M.value ? " hidden" : "")), D = (0, $TusQn.computed)(()=>({
                backgroundColor: `rgba(0,0,0,${.4 * $.value})`
            })), z = (0, $TusQn.computed)(()=>!0 === T.value ? "r" === c.rows.value.top[2] : "l" === c.rows.value.top[0]), I = (0, $TusQn.computed)(()=>!0 === T.value ? "r" === c.rows.value.bottom[2] : "l" === c.rows.value.bottom[0]), V = (0, $TusQn.computed)(()=>{
            const e = {};
            return !0 === c.header.space && !1 === z.value && (!0 === L.value ? e.top = `${c.header.offset}px` : !0 === c.header.space && (e.top = `${c.header.size}px`)), !0 === c.footer.space && !1 === I.value && (!0 === L.value ? e.bottom = `${c.footer.offset}px` : !0 === c.footer.space && (e.bottom = `${c.footer.size}px`)), e;
        }), H = (0, $TusQn.computed)(()=>{
            const e = {
                width: `${g.value}px`,
                transform: `translateX(${E.value}px)`
            };
            return !0 === m.value ? e : Object.assign(e, V.value);
        }), N = (0, $TusQn.computed)(()=>"q-drawer__content fit " + (!0 !== c.isContainer.value ? "scroll" : "overflow-auto")), j = (0, $TusQn.computed)(()=>`q-drawer q-drawer--${e.side}` + (!0 === B.value ? " q-drawer--mini-animate" : "") + (!0 === e.bordered ? " q-drawer--bordered" : "") + (!0 === i.value ? " q-drawer--dark q-dark" : "") + (!0 === M.value ? " no-transition" : !0 === b.value ? "" : " q-layout--prevent-focus") + (!0 === m.value ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${!0 === f.value ? "mini" : "standard"}` + (!0 === L.value || !0 !== O.value ? " fixed" : "") + (!0 === e.overlay || !0 === e.miniToOverlay ? " q-drawer--on-top" : "") + (!0 === z.value ? " q-drawer--top-padding" : ""))), U = (0, $TusQn.computed)(()=>{
            const t = !0 === l.lang.rtl ? e.side : Q.value;
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    ee,
                    void 0,
                    {
                        [t]: !0,
                        mouse: !0
                    }
                ]
            ];
        }), K = (0, $TusQn.computed)(()=>{
            const t = !0 === l.lang.rtl ? Q.value : e.side;
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    te,
                    void 0,
                    {
                        [t]: !0,
                        mouse: !0
                    }
                ]
            ];
        }), W = (0, $TusQn.computed)(()=>{
            const t = !0 === l.lang.rtl ? Q.value : e.side;
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    te,
                    void 0,
                    {
                        [t]: !0,
                        mouse: !0,
                        mouseAllDir: !0
                    }
                ]
            ];
        });
        function Y() {
            ae(m, "mobile" === e.behavior || "desktop" !== e.behavior && c.totalWidth.value <= e.breakpoint);
        }
        function G(e) {
            void 0 === e ? (0, $TusQn.nextTick)(()=>{
                e = !0 === b.value ? 0 : g.value, G(P.value * e);
            }) : (!0 !== c.isContainer.value || !0 !== T.value || !0 !== m.value && Math.abs(e) !== g.value || (e += P.value * c.scrollbarWidth.value), E.value = e);
        }
        function X(e) {
            $.value = e;
        }
        function Z(e) {
            const t = !0 === e ? "remove" : !0 !== c.isContainer.value ? "add" : "";
            "" !== t && document.body.classList[t]("q-body--drawer-toggle");
        }
        function J() {
            null !== v && clearTimeout(v), a.proxy && a.proxy.$el && a.proxy.$el.classList.add("q-drawer--mini-animate"), B.value = !0, v = setTimeout(()=>{
                v = null, B.value = !1, a && a.proxy && a.proxy.$el && a.proxy.$el.classList.remove("q-drawer--mini-animate");
            }, 150);
        }
        function ee(e) {
            if (!1 !== b.value) return;
            const t = g.value, o = $ec2fc4c0d7a3c6c6$var$between(e.distance.x, 0, t);
            if (!0 === e.isFinal) {
                const e = o >= Math.min(75, t);
                return !0 === e ? C() : (c.animate(), X(0), G(P.value * t)), void (M.value = !1);
            }
            G((!0 === l.lang.rtl ? !0 !== T.value : T.value) ? Math.max(t - o, 0) : Math.min(0, o - t)), X($ec2fc4c0d7a3c6c6$var$between(o / t, 0, 1)), !0 === e.isFirst && (M.value = !0);
        }
        function te(t) {
            if (!0 !== b.value) return;
            const o = g.value, n = t.direction === e.side, a = (!0 === l.lang.rtl ? !0 !== n : n) ? $ec2fc4c0d7a3c6c6$var$between(t.distance.x, 0, o) : 0;
            if (!0 === t.isFinal) {
                const e = Math.abs(a) < Math.min(75, o);
                return !0 === e ? (c.animate(), X(1), G(0)) : x(), void (M.value = !1);
            }
            G(P.value * a), X($ec2fc4c0d7a3c6c6$var$between(1 - a / o, 0, 1)), !0 === t.isFirst && (M.value = !0);
        }
        function oe() {
            r(!1), Z(!0);
        }
        function ne(t, o) {
            c.update(e.side, t, o);
        }
        function ae(e, t) {
            e.value !== t && (e.value = t);
        }
        function le(t, o) {
            ne("size", !0 === t ? e.miniWidth : o);
        }
        return (0, $TusQn.watch)(m, (t)=>{
            !0 === t ? (d = b.value, !0 === b.value && x(!1)) : !1 === e.overlay && "mobile" !== e.behavior && !1 !== d && (!0 === b.value ? (G(0), X(0), oe()) : C(!1));
        }), (0, $TusQn.watch)(()=>e.side, (e, t)=>{
            c.instances[t] === q && (c.instances[t] = void 0, c[t].space = !1, c[t].offset = 0), c.instances[e] = q, c[e].size = g.value, c[e].space = O.value, c[e].offset = A.value;
        }), (0, $TusQn.watch)(c.totalWidth, ()=>{
            !0 !== c.isContainer.value && !0 === document.qScrollPrevented || Y();
        }), (0, $TusQn.watch)(()=>e.behavior + e.breakpoint, Y), (0, $TusQn.watch)(c.isContainer, (e)=>{
            !0 === b.value && r(!0 !== e), !0 === e && Y();
        }), (0, $TusQn.watch)(c.scrollbarWidth, ()=>{
            G(!0 === b.value ? 0 : void 0);
        }), (0, $TusQn.watch)(A, (e)=>{
            ne("offset", e);
        }), (0, $TusQn.watch)(O, (e)=>{
            o("onLayout", e), ne("space", e);
        }), (0, $TusQn.watch)(T, ()=>{
            G();
        }), (0, $TusQn.watch)(g, (t)=>{
            G(), le(e.miniToOverlay, t);
        }), (0, $TusQn.watch)(()=>e.miniToOverlay, (e)=>{
            le(e, g.value);
        }), (0, $TusQn.watch)(()=>l.lang.rtl, ()=>{
            G();
        }), (0, $TusQn.watch)(()=>e.mini, ()=>{
            e.noMiniAnimation || !0 === e.modelValue && (J(), c.animate());
        }), (0, $TusQn.watch)(f, (e)=>{
            o("miniState", e);
        }), c.instances[e.side] = q, le(e.miniToOverlay, g.value), ne("space", O.value), ne("offset", A.value), !0 === e.showIfAbove && !0 !== e.modelValue && !0 === b.value && void 0 !== e["onUpdate:modelValue"] && o("update:modelValue", !0), (0, $TusQn.onMounted)(()=>{
            o("onLayout", O.value), o("miniState", f.value), d = !0 === e.showIfAbove;
            const t = ()=>{
                const e = !0 === b.value ? S : w;
                e(!1, !0);
            };
            0 === c.totalWidth.value ? p = (0, $TusQn.watch)(c.totalWidth, ()=>{
                p(), p = void 0, !1 === b.value && !0 === e.showIfAbove && !1 === m.value ? C(!1) : t();
            }) : (0, $TusQn.nextTick)(t);
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            void 0 !== p && p(), null !== v && (clearTimeout(v), v = null), !0 === b.value && oe(), c.instances[e.side] === q && (c.instances[e.side] = void 0, ne("size", 0), ne("offset", 0), ne("space", !1));
        }), ()=>{
            const o = [];
            !0 === m.value && (!1 === e.noSwipeOpen && o.push((0, $TusQn.withDirectives)((0, $TusQn.h)("div", {
                key: "open",
                class: `q-drawer__opener fixed-${e.side}`,
                "aria-hidden": "true"
            }), U.value)), o.push($ec2fc4c0d7a3c6c6$var$hDir("div", {
                ref: "backdrop",
                class: R.value,
                style: D.value,
                "aria-hidden": "true",
                onClick: x
            }, void 0, "backdrop", !0 !== e.noSwipeBackdrop && !0 === b.value, ()=>W.value)));
            const a = !0 === f.value && void 0 !== t.mini, l = [
                (0, $TusQn.h)("div", {
                    ...n,
                    key: "" + a,
                    class: [
                        N.value,
                        n.class
                    ]
                }, !0 === a ? t.mini() : $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ];
            return !0 === e.elevated && !0 === b.value && l.push((0, $TusQn.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), o.push($ec2fc4c0d7a3c6c6$var$hDir("aside", {
                ref: "content",
                class: j.value,
                style: H.value
            }, l, "contentclose", !0 !== e.noSwipeClose && !0 === m.value, ()=>K.value)), (0, $TusQn.h)("div", {
                class: "q-drawer-container"
            }, o);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$getBlockElement(e, t) {
    if (t && e === t) return null;
    const o = e.nodeName.toLowerCase();
    if (!0 === [
        "div",
        "li",
        "ul",
        "ol",
        "blockquote"
    ].includes(o)) return e;
    const n = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle, a = n.display;
    return "block" === a || "table" === a ? e : $ec2fc4c0d7a3c6c6$var$getBlockElement(e.parentNode);
}
function $ec2fc4c0d7a3c6c6$var$isChildOf(e, t, o) {
    return !(!e || e === document.body) && (!0 === o && e === t || (t === document ? document.body : t).contains(e.parentNode));
}
function $ec2fc4c0d7a3c6c6$var$createRange(e, t, o) {
    if (o || (o = document.createRange(), o.selectNode(e), o.setStart(e, 0)), 0 === t.count) o.setEnd(e, t.count);
    else if (t.count > 0) {
        if (e.nodeType === Node.TEXT_NODE) e.textContent.length < t.count ? t.count -= e.textContent.length : (o.setEnd(e, t.count), t.count = 0);
        else for(let n = 0; 0 !== t.count && n < e.childNodes.length; n++)o = $ec2fc4c0d7a3c6c6$var$createRange(e.childNodes[n], t, o);
    }
    return o;
}
const $ec2fc4c0d7a3c6c6$var$urlRegex = /^https?:\/\//;
class $ec2fc4c0d7a3c6c6$var$Caret {
    constructor(e, t){
        this.el = e, this.eVm = t, this._range = null;
    }
    get selection() {
        if (this.el) {
            const e = document.getSelection();
            if ($ec2fc4c0d7a3c6c6$var$isChildOf(e.anchorNode, this.el, !0) && $ec2fc4c0d7a3c6c6$var$isChildOf(e.focusNode, this.el, !0)) return e;
        }
        return null;
    }
    get hasSelection() {
        return null !== this.selection && 0 !== this.selection.toString().length;
    }
    get range() {
        const e = this.selection;
        return null !== e && e.rangeCount ? e.getRangeAt(0) : this._range;
    }
    get parent() {
        const e = this.range;
        if (null !== e) {
            const t = e.startContainer;
            return t.nodeType === document.ELEMENT_NODE ? t : t.parentNode;
        }
        return null;
    }
    get blockParent() {
        const e = this.parent;
        return null !== e ? $ec2fc4c0d7a3c6c6$var$getBlockElement(e, this.el) : null;
    }
    save(e = this.range) {
        null !== e && (this._range = e);
    }
    restore(e = this._range) {
        const t = document.createRange(), o = document.getSelection();
        null !== e ? (t.setStart(e.startContainer, e.startOffset), t.setEnd(e.endContainer, e.endOffset), o.removeAllRanges(), o.addRange(t)) : (o.selectAllChildren(this.el), o.collapseToEnd());
    }
    savePosition() {
        let e, t = -1;
        const o = document.getSelection(), n = this.el.parentNode;
        if (o.focusNode && $ec2fc4c0d7a3c6c6$var$isChildOf(o.focusNode, n)) {
            e = o.focusNode, t = o.focusOffset;
            while(e && e !== n)e !== this.el && e.previousSibling ? (e = e.previousSibling, t += e.textContent.length) : e = e.parentNode;
        }
        this.savedPos = t;
    }
    restorePosition(e = 0) {
        if (this.savedPos > 0 && this.savedPos < e) {
            const e = window.getSelection(), t = $ec2fc4c0d7a3c6c6$var$createRange(this.el, {
                count: this.savedPos
            });
            t && (t.collapse(!1), e.removeAllRanges(), e.addRange(t));
        }
    }
    hasParent(e, t) {
        const o = t ? this.parent : this.blockParent;
        return null !== o && o.nodeName.toLowerCase() === e.toLowerCase();
    }
    hasParents(e, t, o = this.parent) {
        return null !== o && (!0 === e.includes(o.nodeName.toLowerCase()) || !0 === t && this.hasParents(e, t, o.parentNode));
    }
    is(e, t) {
        if (null === this.selection) return !1;
        switch(e){
            case "formatBlock":
                return "DIV" === t && this.parent === this.el || this.hasParent(t, "PRE" === t);
            case "link":
                return this.hasParent("A", !0);
            case "fontSize":
                return document.queryCommandValue(e) === t;
            case "fontName":
                const o = document.queryCommandValue(e);
                return o === `"${t}"` || o === t;
            case "fullscreen":
                return this.eVm.inFullscreen.value;
            case "viewsource":
                return this.eVm.isViewingSource.value;
            case void 0:
                return !1;
            default:
                const n = document.queryCommandState(e);
                return void 0 !== t ? n === t : n;
        }
    }
    getParentAttribute(e) {
        return null !== this.parent ? this.parent.getAttribute(e) : null;
    }
    can(e) {
        return "outdent" === e ? this.hasParents([
            "blockquote",
            "li"
        ], !0) : "indent" === e ? this.hasParents([
            "li"
        ], !0) : "link" === e ? null !== this.selection || this.is("link") : void 0;
    }
    apply(e, t, o = $ec2fc4c0d7a3c6c6$export$8793edee2d425525) {
        if ("formatBlock" === e) [
            "BLOCKQUOTE",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6"
        ].includes(t) && this.is(e, t) && (e = "outdent", t = null), "PRE" === t && this.is(e, "PRE") && (t = "P");
        else {
            if ("print" === e) {
                o();
                const e = window.open();
                return e.document.write(`\n        <!doctype html>\n        <html>\n          <head>\n            <title>Print - ${document.title}</title>\n          </head>\n          <body>\n            <div>${this.el.innerHTML}</div>\n          </body>\n        </html>\n      `), e.print(), void e.close();
            }
            if ("link" === e) {
                const e = this.getParentAttribute("href");
                if (null === e) {
                    const e = this.selectWord(this.selection), t = e ? e.toString() : "";
                    if (!t.length && (!this.range || !this.range.cloneContents().querySelector("img"))) return;
                    this.eVm.editLinkUrl.value = $ec2fc4c0d7a3c6c6$var$urlRegex.test(t) ? t : "https://", document.execCommand("createLink", !1, this.eVm.editLinkUrl.value), this.save(e.getRangeAt(0));
                } else this.eVm.editLinkUrl.value = e, this.range.selectNodeContents(this.parent), this.save();
                return;
            }
            if ("fullscreen" === e) return this.eVm.toggleFullscreen(), void o();
            if ("viewsource" === e) return this.eVm.isViewingSource.value = !1 === this.eVm.isViewingSource.value, this.eVm.setContent(this.eVm.props.modelValue), void o();
        }
        document.execCommand(e, !1, t), o();
    }
    selectWord(e) {
        if (null === e || !0 !== e.isCollapsed || void 0 === e.modify) return e;
        const t = document.createRange();
        t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
        const o = t.collapsed ? [
            "backward",
            "forward"
        ] : [
            "forward",
            "backward"
        ];
        t.detach();
        const n = e.focusNode, a = e.focusOffset;
        return e.collapse(e.anchorNode, e.anchorOffset), e.modify("move", o[0], "character"), e.modify("move", o[1], "word"), e.extend(n, a), e.modify("extend", o[1], "character"), e.modify("extend", o[0], "word"), e;
    }
}
var $ec2fc4c0d7a3c6c6$export$b4dba0bbe7f6a787 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTooltip",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useAnchorProps,
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleProps,
        ...$ec2fc4c0d7a3c6c6$var$useTransitionProps,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        },
        transitionShow: {
            default: "jump-down"
        },
        transitionHide: {
            default: "jump-up"
        },
        anchor: {
            type: String,
            default: "bottom middle",
            validator: $ec2fc4c0d7a3c6c6$var$validatePosition
        },
        self: {
            type: String,
            default: "top middle",
            validator: $ec2fc4c0d7a3c6c6$var$validatePosition
        },
        offset: {
            type: Array,
            default: ()=>[
                    14,
                    14
                ],
            validator: $ec2fc4c0d7a3c6c6$var$validateOffset
        },
        scrollTarget: {
            default: void 0
        },
        delay: {
            type: Number,
            default: 0
        },
        hideDelay: {
            type: Number,
            default: 0
        }
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleEmits
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        let a, l;
        const i = (0, $TusQn.getCurrentInstance)(), { proxy: { $q: r } } = i, s = (0, $01W3b.ref)(null), u = (0, $01W3b.ref)(!1), c = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$parsePosition(e.anchor, r.lang.rtl)), d = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$parsePosition(e.self, r.lang.rtl)), p = (0, $TusQn.computed)(()=>!0 !== e.persistent), { registerTick: v, removeTick: m } = $ec2fc4c0d7a3c6c6$var$useTick(), { registerTimeout: f } = $ec2fc4c0d7a3c6c6$var$useTimeout(), { transitionProps: g, transitionStyle: b } = $ec2fc4c0d7a3c6c6$var$useTransition(e), { localScrollTarget: y, changeScrollEvent: S, unconfigureScrollTarget: w } = $ec2fc4c0d7a3c6c6$var$useScrollTarget(e, F), { anchorEl: C, canShow: x, anchorEvents: k } = $ec2fc4c0d7a3c6c6$var$useAnchor({
            showing: u,
            configureAnchorEl: O
        }), { show: _, hide: q } = $ec2fc4c0d7a3c6c6$var$useModelToggle({
            showing: u,
            canShow: x,
            handleShow: M,
            handleHide: B,
            hideOnRouteChange: p,
            processOnMount: !0
        });
        Object.assign(k, {
            delayShow: A,
            delayHide: L
        });
        const { showPortal: T, hidePortal: P, renderPortal: $ } = $ec2fc4c0d7a3c6c6$var$usePortal(i, s, D, "tooltip");
        if (!0 === r.platform.is.mobile) {
            const t = {
                anchorEl: C,
                innerRef: s,
                onClickOutside (e) {
                    return q(e), e.target.classList.contains("q-dialog__backdrop") && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), !0;
                }
            }, o = (0, $TusQn.computed)(()=>null === e.modelValue && !0 !== e.persistent && !0 === u.value);
            (0, $TusQn.watch)(o, (e)=>{
                const o = !0 === e ? $ec2fc4c0d7a3c6c6$var$addClickOutside : $ec2fc4c0d7a3c6c6$var$removeClickOutside;
                o(t);
            }), (0, $TusQn.onBeforeUnmount)(()=>{
                $ec2fc4c0d7a3c6c6$var$removeClickOutside(t);
            });
        }
        function M(t) {
            T(), v(()=>{
                l = new MutationObserver(()=>Q()), l.observe(s.value, {
                    attributes: !1,
                    childList: !0,
                    characterData: !0,
                    subtree: !0
                }), Q(), F();
            }), void 0 === a && (a = (0, $TusQn.watch)(()=>r.screen.width + "|" + r.screen.height + "|" + e.self + "|" + e.anchor + "|" + r.lang.rtl, Q)), f(()=>{
                T(!0), o("show", t);
            }, e.transitionDuration);
        }
        function B(t) {
            m(), P(), E(), f(()=>{
                P(!0), o("hide", t);
            }, e.transitionDuration);
        }
        function E() {
            void 0 !== l && (l.disconnect(), l = void 0), void 0 !== a && (a(), a = void 0), w(), $ec2fc4c0d7a3c6c6$var$cleanEvt(k, "tooltipTemp");
        }
        function Q() {
            $ec2fc4c0d7a3c6c6$var$setPosition({
                targetEl: s.value,
                offset: e.offset,
                anchorEl: C.value,
                anchorOrigin: c.value,
                selfOrigin: d.value,
                maxHeight: e.maxHeight,
                maxWidth: e.maxWidth
            });
        }
        function A(t) {
            if (!0 === r.platform.is.mobile) {
                $ec2fc4c0d7a3c6c6$var$clearSelection(), document.body.classList.add("non-selectable");
                const e = C.value, t = [
                    "touchmove",
                    "touchcancel",
                    "touchend",
                    "click"
                ].map((t)=>[
                        e,
                        t,
                        "delayHide",
                        "passiveCapture"
                    ]);
                $ec2fc4c0d7a3c6c6$var$addEvt(k, "tooltipTemp", t);
            }
            f(()=>{
                _(t);
            }, e.delay);
        }
        function L(t) {
            !0 === r.platform.is.mobile && ($ec2fc4c0d7a3c6c6$var$cleanEvt(k, "tooltipTemp"), $ec2fc4c0d7a3c6c6$var$clearSelection(), setTimeout(()=>{
                document.body.classList.remove("non-selectable");
            }, 10)), f(()=>{
                q(t);
            }, e.hideDelay);
        }
        function O() {
            if (!0 === e.noParentEvent || null === C.value) return;
            const t = !0 === r.platform.is.mobile ? [
                [
                    C.value,
                    "touchstart",
                    "delayShow",
                    "passive"
                ]
            ] : [
                [
                    C.value,
                    "mouseenter",
                    "delayShow",
                    "passive"
                ],
                [
                    C.value,
                    "mouseleave",
                    "delayHide",
                    "passive"
                ]
            ];
            $ec2fc4c0d7a3c6c6$var$addEvt(k, "anchor", t);
        }
        function F() {
            if (null !== C.value || void 0 !== e.scrollTarget) {
                y.value = $ec2fc4c0d7a3c6c6$var$getScrollTarget(C.value, e.scrollTarget);
                const t = !0 === e.noParentEvent ? Q : q;
                S(y.value, t);
            }
        }
        function R() {
            return !0 === u.value ? (0, $TusQn.h)("div", {
                ...n,
                ref: s,
                class: [
                    "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
                    n.class
                ],
                style: [
                    n.style,
                    b.value
                ],
                role: "tooltip"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)) : null;
        }
        function D() {
            return (0, $TusQn.h)((0, $eeJ70.Transition), g.value, R);
        }
        return (0, $TusQn.onBeforeUnmount)(E), Object.assign(i.proxy, {
            updatePosition: Q
        }), $;
    }
}), $ec2fc4c0d7a3c6c6$export$adf75769807ad87e = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QItem",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useRouterLinkProps,
        tag: {
            type: String,
            default: "div"
        },
        active: {
            type: Boolean,
            default: null
        },
        clickable: Boolean,
        dense: Boolean,
        insetLevel: Number,
        tabindex: [
            String,
            Number
        ],
        focused: Boolean,
        manualFocus: Boolean
    },
    emits: [
        "click",
        "keyup"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), { hasLink: l, linkAttrs: i, linkClass: r, linkTag: s, navigateOnClick: u } = $ec2fc4c0d7a3c6c6$var$useRouterLink(), c = (0, $01W3b.ref)(null), d = (0, $01W3b.ref)(null), p = (0, $TusQn.computed)(()=>!0 === e.clickable || !0 === l.value || "label" === e.tag), v = (0, $TusQn.computed)(()=>!0 !== e.disable && !0 === p.value), m = (0, $TusQn.computed)(()=>"q-item q-item-type row no-wrap" + (!0 === e.dense ? " q-item--dense" : "") + (!0 === a.value ? " q-item--dark" : "") + (!0 === l.value && null === e.active ? r.value : !0 === e.active ? ` q-item--active${void 0 !== e.activeClass ? ` ${e.activeClass}` : ""}` : "") + (!0 === e.disable ? " disabled" : "") + (!0 === v.value ? " q-item--clickable q-link cursor-pointer " + (!0 === e.manualFocus ? "q-manual-focusable" : "q-focusable q-hoverable") + (!0 === e.focused ? " q-manual-focusable--focused" : "") : "")), f = (0, $TusQn.computed)(()=>{
            if (void 0 === e.insetLevel) return null;
            const t = !0 === n.lang.rtl ? "Right" : "Left";
            return {
                ["padding" + t]: 16 + 56 * e.insetLevel + "px"
            };
        });
        function g(e) {
            !0 === v.value && (null !== d.value && (!0 !== e.qKeyEvent && document.activeElement === c.value ? d.value.focus() : document.activeElement === d.value && c.value.focus()), u(e));
        }
        function b(e) {
            if (!0 === v.value && !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, 13)) {
                $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), e.qKeyEvent = !0;
                const t = new MouseEvent("click", e);
                t.qKeyEvent = !0, c.value.dispatchEvent(t);
            }
            o("keyup", e);
        }
        function y() {
            const e = $ec2fc4c0d7a3c6c6$var$hUniqueSlot(t.default, []);
            return !0 === v.value && e.unshift((0, $TusQn.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: d
            })), e;
        }
        return ()=>{
            const t = {
                ref: c,
                class: m.value,
                style: f.value,
                role: "listitem",
                onClick: g,
                onKeyup: b
            };
            return !0 === v.value ? (t.tabindex = e.tabindex || "0", Object.assign(t, i.value)) : !0 === p.value && (t["aria-disabled"] = "true"), (0, $TusQn.h)(s.value, t, y());
        };
    }
}), $ec2fc4c0d7a3c6c6$export$9579d29612d4e773 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QItemSection",
    props: {
        avatar: Boolean,
        thumbnail: Boolean,
        side: Boolean,
        top: Boolean,
        noWrap: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>"q-item__section column" + ` q-item__section--${!0 === e.avatar || !0 === e.side || !0 === e.thumbnail ? "side" : "main"}` + (!0 === e.top ? " q-item__section--top justify-start" : " justify-center") + (!0 === e.avatar ? " q-item__section--avatar" : "") + (!0 === e.thumbnail ? " q-item__section--thumbnail" : "") + (!0 === e.noWrap ? " q-item__section--nowrap" : ""));
        return ()=>(0, $TusQn.h)("div", {
                class: o.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
function $ec2fc4c0d7a3c6c6$var$run(e, t, o) {
    t.handler ? t.handler(e, o, o.caret) : o.runCmd(t.cmd, t.param);
}
function $ec2fc4c0d7a3c6c6$var$getGroup(e) {
    return (0, $TusQn.h)("div", {
        class: "q-editor__toolbar-group"
    }, e);
}
function $ec2fc4c0d7a3c6c6$var$getBtn(e, t, o, n = !1) {
    const a = n || "toggle" === t.type && (t.toggled ? t.toggled(e) : t.cmd && e.caret.is(t.cmd, t.param)), l = [];
    if (t.tip && e.$q.platform.is.desktop) {
        const e = t.key ? (0, $TusQn.h)("div", [
            (0, $TusQn.h)("small", `(CTRL + ${String.fromCharCode(t.key)})`)
        ]) : null;
        l.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$b4dba0bbe7f6a787, {
            delay: 1e3
        }, ()=>[
                (0, $TusQn.h)("div", {
                    innerHTML: t.tip
                }),
                e
            ]));
    }
    return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
        ...e.buttonProps.value,
        icon: null !== t.icon ? t.icon : void 0,
        color: a ? t.toggleColor || e.props.toolbarToggleColor : t.color || e.props.toolbarColor,
        textColor: a && !e.props.toolbarPush ? null : t.textColor || e.props.toolbarTextColor,
        label: t.label,
        disable: !!t.disable && ("function" !== typeof t.disable || t.disable(e)),
        size: "sm",
        onClick (n) {
            o && o(), $ec2fc4c0d7a3c6c6$var$run(n, t, e);
        }
    }, ()=>l);
}
function $ec2fc4c0d7a3c6c6$var$getDropdown(e, t) {
    const o = "only-icons" === t.list;
    let n, a, l = t.label, i = null !== t.icon ? t.icon : void 0;
    function r() {
        u.component.proxy.hide();
    }
    if (o) a = t.options.map((t)=>{
        const o = void 0 === t.type && e.caret.is(t.cmd, t.param);
        return o && (l = t.tip, i = null !== t.icon ? t.icon : void 0), $ec2fc4c0d7a3c6c6$var$getBtn(e, t, r, o);
    }), n = e.toolbarBackgroundClass.value, a = [
        $ec2fc4c0d7a3c6c6$var$getGroup(a)
    ];
    else {
        const o = void 0 !== e.props.toolbarToggleColor ? `text-${e.props.toolbarToggleColor}` : null, s = void 0 !== e.props.toolbarTextColor ? `text-${e.props.toolbarTextColor}` : null, u = "no-icons" === t.list;
        a = t.options.map((t)=>{
            const n = !!t.disable && t.disable(e), a = void 0 === t.type && e.caret.is(t.cmd, t.param);
            a && (l = t.tip, i = null !== t.icon ? t.icon : void 0);
            const c = t.htmlTip;
            return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$adf75769807ad87e, {
                active: a,
                activeClass: o,
                clickable: !0,
                disable: n,
                dense: !0,
                onClick (o) {
                    r(), null !== e.contentRef.value && e.contentRef.value.focus(), e.caret.restore(), $ec2fc4c0d7a3c6c6$var$run(o, t, e);
                }
            }, ()=>[
                    !0 === u ? null : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, {
                        class: a ? o : s,
                        side: !0
                    }, ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                            name: null !== t.icon ? t.icon : void 0
                        })),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, c ? ()=>(0, $TusQn.h)("div", {
                            class: "text-no-wrap",
                            innerHTML: t.htmlTip
                        }) : t.tip ? ()=>(0, $TusQn.h)("div", {
                            class: "text-no-wrap"
                        }, t.tip) : void 0)
                ]);
        }), n = [
            e.toolbarBackgroundClass.value,
            s
        ];
    }
    const s = t.highlight && l !== t.label, u = (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$ed13f95342ac4309, {
        ...e.buttonProps.value,
        noCaps: !0,
        noWrap: !0,
        color: s ? e.props.toolbarToggleColor : e.props.toolbarColor,
        textColor: s && !e.props.toolbarPush ? null : e.props.toolbarTextColor,
        label: t.fixedLabel ? t.label : l,
        icon: t.fixedIcon ? null !== t.icon ? t.icon : void 0 : i,
        contentClass: n,
        onShow: (t)=>e.emit("dropdownShow", t),
        onHide: (t)=>e.emit("dropdownHide", t),
        onBeforeShow: (t)=>e.emit("dropdownBeforeShow", t),
        onBeforeHide: (t)=>e.emit("dropdownBeforeHide", t)
    }, ()=>a);
    return u;
}
function $ec2fc4c0d7a3c6c6$var$getToolbar(e) {
    if (e.caret) return e.buttons.value.filter((t)=>{
        return !e.isViewingSource.value || t.find((e)=>"viewsource" === e.cmd);
    }).map((t)=>$ec2fc4c0d7a3c6c6$var$getGroup(t.map((t)=>{
            return (!e.isViewingSource.value || "viewsource" === t.cmd) && ("slot" === t.type ? $ec2fc4c0d7a3c6c6$var$hSlot(e.slots[t.slot]) : "dropdown" === t.type ? $ec2fc4c0d7a3c6c6$var$getDropdown(e, t) : $ec2fc4c0d7a3c6c6$var$getBtn(e, t));
        })));
}
function $ec2fc4c0d7a3c6c6$var$getFonts(e, t, o, n = {}) {
    const a = Object.keys(n);
    if (0 === a.length) return {};
    const l = {
        default_font: {
            cmd: "fontName",
            param: e,
            icon: o,
            tip: t
        }
    };
    return a.forEach((e)=>{
        const t = n[e];
        l[e] = {
            cmd: "fontName",
            param: t,
            icon: o,
            tip: t,
            htmlTip: `<font face="${t}">${t}</font>`
        };
    }), l;
}
function $ec2fc4c0d7a3c6c6$var$getLinkEditor(e) {
    if (e.caret) {
        const t = e.props.toolbarColor || e.props.toolbarTextColor;
        let o = e.editLinkUrl.value;
        const n = ()=>{
            e.caret.restore(), o !== e.editLinkUrl.value && document.execCommand("createLink", !1, "" === o ? " " : o), e.editLinkUrl.value = null;
        };
        return [
            (0, $TusQn.h)("div", {
                class: `q-mx-xs text-${t}`
            }, `${e.$q.lang.editor.url}: `),
            (0, $TusQn.h)("input", {
                key: "qedt_btm_input",
                class: "col q-editor__link-input",
                value: o,
                onInput: (e)=>{
                    $ec2fc4c0d7a3c6c6$var$stop(e), o = e.target.value;
                },
                onKeydown: (t)=>{
                    if (!0 !== $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(t)) switch(t.keyCode){
                        case 13:
                            return $ec2fc4c0d7a3c6c6$var$prevent(t), n();
                        case 27:
                            $ec2fc4c0d7a3c6c6$var$prevent(t), e.caret.restore(), e.editLinkUrl.value && "https://" !== e.editLinkUrl.value || document.execCommand("unlink"), e.editLinkUrl.value = null;
                            break;
                    }
                }
            }),
            $ec2fc4c0d7a3c6c6$var$getGroup([
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    key: "qedt_btm_rem",
                    tabindex: -1,
                    ...e.buttonProps.value,
                    label: e.$q.lang.label.remove,
                    noCaps: !0,
                    onClick: ()=>{
                        e.caret.restore(), document.execCommand("unlink"), e.editLinkUrl.value = null;
                    }
                }),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    key: "qedt_btm_upd",
                    ...e.buttonProps.value,
                    label: e.$q.lang.label.update,
                    noCaps: !0,
                    onClick: n
                })
            ])
        ];
    }
}
const $ec2fc4c0d7a3c6c6$var$listenerRE = /^on[A-Z]/;
function $ec2fc4c0d7a3c6c6$var$useSplitAttrs(e, t) {
    const o = {
        listeners: (0, $01W3b.ref)({}),
        attributes: (0, $01W3b.ref)({})
    };
    function n() {
        const n = {}, a = {};
        for(const t in e)"class" !== t && "style" !== t && !1 === $ec2fc4c0d7a3c6c6$var$listenerRE.test(t) && (n[t] = e[t]);
        for(const e in t.props)!0 === $ec2fc4c0d7a3c6c6$var$listenerRE.test(e) && (a[e] = t.props[e]);
        o.attributes.value = n, o.listeners.value = a;
    }
    return (0, $TusQn.onBeforeUpdate)(n), n(), o;
}
const $ec2fc4c0d7a3c6c6$var$toString = Object.prototype.toString, $ec2fc4c0d7a3c6c6$var$hasOwn = Object.prototype.hasOwnProperty, $ec2fc4c0d7a3c6c6$var$notPlainObject = new Set([
    "Boolean",
    "Number",
    "String",
    "Function",
    "Array",
    "Date",
    "RegExp"
].map((e)=>"[object " + e + "]"));
function $ec2fc4c0d7a3c6c6$var$isPlainObject(e) {
    if (e !== Object(e) || !0 === $ec2fc4c0d7a3c6c6$var$notPlainObject.has($ec2fc4c0d7a3c6c6$var$toString.call(e))) return !1;
    if (e.constructor && !1 === $ec2fc4c0d7a3c6c6$var$hasOwn.call(e, "constructor") && !1 === $ec2fc4c0d7a3c6c6$var$hasOwn.call(e.constructor.prototype, "isPrototypeOf")) return !1;
    let t;
    for(t in e);
    return void 0 === t || $ec2fc4c0d7a3c6c6$var$hasOwn.call(e, t);
}
function $ec2fc4c0d7a3c6c6$export$8b58be045bf06082() {
    let e, t, o, n, a, l, i = arguments[0] || {}, r = 1, s = !1;
    const u = arguments.length;
    for("boolean" === typeof i && (s = i, i = arguments[1] || {}, r = 2), Object(i) !== i && "function" !== typeof i && (i = {}), u === r && (i = this, r--); r < u; r++)if (null !== (e = arguments[r])) for(t in e)o = i[t], n = e[t], i !== n && (!0 === s && n && ((a = Array.isArray(n)) || !0 === $ec2fc4c0d7a3c6c6$var$isPlainObject(n)) ? (l = !0 === a ? !0 === Array.isArray(o) ? o : [] : !0 === $ec2fc4c0d7a3c6c6$var$isPlainObject(o) ? o : {}, i[t] = $ec2fc4c0d7a3c6c6$export$8b58be045bf06082(s, l, n)) : void 0 !== n && (i[t] = n));
    return i;
}
var $ec2fc4c0d7a3c6c6$export$2107e7367505ec8a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QEditor",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useFullscreenProps,
        modelValue: {
            type: String,
            required: !0
        },
        readonly: Boolean,
        disable: Boolean,
        minHeight: {
            type: String,
            default: "10rem"
        },
        maxHeight: String,
        height: String,
        definitions: Object,
        fonts: Object,
        placeholder: String,
        toolbar: {
            type: Array,
            validator: (e)=>0 === e.length || e.every((e)=>e.length),
            default () {
                return [
                    [
                        "left",
                        "center",
                        "right",
                        "justify"
                    ],
                    [
                        "bold",
                        "italic",
                        "underline",
                        "strike"
                    ],
                    [
                        "undo",
                        "redo"
                    ]
                ];
            }
        },
        toolbarColor: String,
        toolbarBg: String,
        toolbarTextColor: String,
        toolbarToggleColor: {
            type: String,
            default: "primary"
        },
        toolbarOutline: Boolean,
        toolbarPush: Boolean,
        toolbarRounded: Boolean,
        paragraphTag: {
            type: String,
            validator: (e)=>[
                    "div",
                    "p"
                ].includes(e),
            default: "div"
        },
        contentStyle: Object,
        contentClass: [
            Object,
            Array,
            String
        ],
        square: Boolean,
        flat: Boolean,
        dense: Boolean
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useFullscreenEmits,
        "update:modelValue",
        "keydown",
        "click",
        "mouseup",
        "keyup",
        "touchend",
        "focus",
        "blur",
        "dropdownShow",
        "dropdownHide",
        "dropdownBeforeShow",
        "dropdownBeforeHide",
        "linkShow",
        "linkHide"
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        const { proxy: a, vnode: l } = (0, $TusQn.getCurrentInstance)(), { $q: i } = a, r = $ec2fc4c0d7a3c6c6$var$useDark(e, i), { inFullscreen: s, toggleFullscreen: u } = $ec2fc4c0d7a3c6c6$var$useFullscreen(), c = $ec2fc4c0d7a3c6c6$var$useSplitAttrs(n, l), d = (0, $01W3b.ref)(null), p = (0, $01W3b.ref)(null), v = (0, $01W3b.ref)(null), m = (0, $01W3b.ref)(!1), f = (0, $TusQn.computed)(()=>!e.readonly && !e.disable);
        let g, b, y = e.modelValue;
        document.execCommand("defaultParagraphSeparator", !1, e.paragraphTag), g = window.getComputedStyle(document.body).fontFamily;
        const S = (0, $TusQn.computed)(()=>e.toolbarBg ? ` bg-${e.toolbarBg}` : ""), w = (0, $TusQn.computed)(()=>{
            const t = !0 !== e.toolbarOutline && !0 !== e.toolbarPush;
            return {
                type: "a",
                flat: t,
                noWrap: !0,
                outline: e.toolbarOutline,
                push: e.toolbarPush,
                rounded: e.toolbarRounded,
                dense: !0,
                color: e.toolbarColor,
                disable: !f.value,
                size: "sm"
            };
        }), C = (0, $TusQn.computed)(()=>{
            const t = i.lang.editor, o = i.iconSet.editor;
            return {
                bold: {
                    cmd: "bold",
                    icon: o.bold,
                    tip: t.bold,
                    key: 66
                },
                italic: {
                    cmd: "italic",
                    icon: o.italic,
                    tip: t.italic,
                    key: 73
                },
                strike: {
                    cmd: "strikeThrough",
                    icon: o.strikethrough,
                    tip: t.strikethrough,
                    key: 83
                },
                underline: {
                    cmd: "underline",
                    icon: o.underline,
                    tip: t.underline,
                    key: 85
                },
                unordered: {
                    cmd: "insertUnorderedList",
                    icon: o.unorderedList,
                    tip: t.unorderedList
                },
                ordered: {
                    cmd: "insertOrderedList",
                    icon: o.orderedList,
                    tip: t.orderedList
                },
                subscript: {
                    cmd: "subscript",
                    icon: o.subscript,
                    tip: t.subscript,
                    htmlTip: "x<subscript>2</subscript>"
                },
                superscript: {
                    cmd: "superscript",
                    icon: o.superscript,
                    tip: t.superscript,
                    htmlTip: "x<superscript>2</superscript>"
                },
                link: {
                    cmd: "link",
                    disable: (e)=>e.caret && !e.caret.can("link"),
                    icon: o.hyperlink,
                    tip: t.hyperlink,
                    key: 76
                },
                fullscreen: {
                    cmd: "fullscreen",
                    icon: o.toggleFullscreen,
                    tip: t.toggleFullscreen,
                    key: 70
                },
                viewsource: {
                    cmd: "viewsource",
                    icon: o.viewSource,
                    tip: t.viewSource
                },
                quote: {
                    cmd: "formatBlock",
                    param: "BLOCKQUOTE",
                    icon: o.quote,
                    tip: t.quote,
                    key: 81
                },
                left: {
                    cmd: "justifyLeft",
                    icon: o.left,
                    tip: t.left
                },
                center: {
                    cmd: "justifyCenter",
                    icon: o.center,
                    tip: t.center
                },
                right: {
                    cmd: "justifyRight",
                    icon: o.right,
                    tip: t.right
                },
                justify: {
                    cmd: "justifyFull",
                    icon: o.justify,
                    tip: t.justify
                },
                print: {
                    type: "no-state",
                    cmd: "print",
                    icon: o.print,
                    tip: t.print,
                    key: 80
                },
                outdent: {
                    type: "no-state",
                    disable: (e)=>e.caret && !e.caret.can("outdent"),
                    cmd: "outdent",
                    icon: o.outdent,
                    tip: t.outdent
                },
                indent: {
                    type: "no-state",
                    disable: (e)=>e.caret && !e.caret.can("indent"),
                    cmd: "indent",
                    icon: o.indent,
                    tip: t.indent
                },
                removeFormat: {
                    type: "no-state",
                    cmd: "removeFormat",
                    icon: o.removeFormat,
                    tip: t.removeFormat
                },
                hr: {
                    type: "no-state",
                    cmd: "insertHorizontalRule",
                    icon: o.hr,
                    tip: t.hr
                },
                undo: {
                    type: "no-state",
                    cmd: "undo",
                    icon: o.undo,
                    tip: t.undo,
                    key: 90
                },
                redo: {
                    type: "no-state",
                    cmd: "redo",
                    icon: o.redo,
                    tip: t.redo,
                    key: 89
                },
                h1: {
                    cmd: "formatBlock",
                    param: "H1",
                    icon: o.heading1 || o.heading,
                    tip: t.heading1,
                    htmlTip: `<h1 class="q-ma-none">${t.heading1}</h1>`
                },
                h2: {
                    cmd: "formatBlock",
                    param: "H2",
                    icon: o.heading2 || o.heading,
                    tip: t.heading2,
                    htmlTip: `<h2 class="q-ma-none">${t.heading2}</h2>`
                },
                h3: {
                    cmd: "formatBlock",
                    param: "H3",
                    icon: o.heading3 || o.heading,
                    tip: t.heading3,
                    htmlTip: `<h3 class="q-ma-none">${t.heading3}</h3>`
                },
                h4: {
                    cmd: "formatBlock",
                    param: "H4",
                    icon: o.heading4 || o.heading,
                    tip: t.heading4,
                    htmlTip: `<h4 class="q-ma-none">${t.heading4}</h4>`
                },
                h5: {
                    cmd: "formatBlock",
                    param: "H5",
                    icon: o.heading5 || o.heading,
                    tip: t.heading5,
                    htmlTip: `<h5 class="q-ma-none">${t.heading5}</h5>`
                },
                h6: {
                    cmd: "formatBlock",
                    param: "H6",
                    icon: o.heading6 || o.heading,
                    tip: t.heading6,
                    htmlTip: `<h6 class="q-ma-none">${t.heading6}</h6>`
                },
                p: {
                    cmd: "formatBlock",
                    param: e.paragraphTag,
                    icon: o.heading,
                    tip: t.paragraph
                },
                code: {
                    cmd: "formatBlock",
                    param: "PRE",
                    icon: o.code,
                    htmlTip: `<code>${t.code}</code>`
                },
                "size-1": {
                    cmd: "fontSize",
                    param: "1",
                    icon: o.size1 || o.size,
                    tip: t.size1,
                    htmlTip: `<font size="1">${t.size1}</font>`
                },
                "size-2": {
                    cmd: "fontSize",
                    param: "2",
                    icon: o.size2 || o.size,
                    tip: t.size2,
                    htmlTip: `<font size="2">${t.size2}</font>`
                },
                "size-3": {
                    cmd: "fontSize",
                    param: "3",
                    icon: o.size3 || o.size,
                    tip: t.size3,
                    htmlTip: `<font size="3">${t.size3}</font>`
                },
                "size-4": {
                    cmd: "fontSize",
                    param: "4",
                    icon: o.size4 || o.size,
                    tip: t.size4,
                    htmlTip: `<font size="4">${t.size4}</font>`
                },
                "size-5": {
                    cmd: "fontSize",
                    param: "5",
                    icon: o.size5 || o.size,
                    tip: t.size5,
                    htmlTip: `<font size="5">${t.size5}</font>`
                },
                "size-6": {
                    cmd: "fontSize",
                    param: "6",
                    icon: o.size6 || o.size,
                    tip: t.size6,
                    htmlTip: `<font size="6">${t.size6}</font>`
                },
                "size-7": {
                    cmd: "fontSize",
                    param: "7",
                    icon: o.size7 || o.size,
                    tip: t.size7,
                    htmlTip: `<font size="7">${t.size7}</font>`
                }
            };
        }), x = (0, $TusQn.computed)(()=>{
            const t = e.definitions || {}, o = e.definitions || e.fonts ? $ec2fc4c0d7a3c6c6$export$8b58be045bf06082(!0, {}, C.value, t, $ec2fc4c0d7a3c6c6$var$getFonts(g, i.lang.editor.defaultFont, i.iconSet.editor.font, e.fonts)) : C.value;
            return e.toolbar.map((e)=>e.map((e)=>{
                    if (e.options) return {
                        type: "dropdown",
                        icon: e.icon,
                        label: e.label,
                        size: "sm",
                        dense: !0,
                        fixedLabel: e.fixedLabel,
                        fixedIcon: e.fixedIcon,
                        highlight: e.highlight,
                        list: e.list,
                        options: e.options.map((e)=>o[e])
                    };
                    const n = o[e];
                    return n ? "no-state" === n.type || t[e] && (void 0 === n.cmd || C.value[n.cmd] && "no-state" === C.value[n.cmd].type) ? n : Object.assign({
                        type: "toggle"
                    }, n) : {
                        type: "slot",
                        slot: e
                    };
                }));
        }), k = {
            $q: i,
            props: e,
            slots: t,
            emit: o,
            inFullscreen: s,
            toggleFullscreen: u,
            runCmd: I,
            isViewingSource: m,
            editLinkUrl: v,
            toolbarBackgroundClass: S,
            buttonProps: w,
            contentRef: p,
            buttons: x,
            setContent: z
        };
        (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            y !== e && (y = e, z(e, !0));
        }), (0, $TusQn.watch)(v, (e)=>{
            o(`link${e ? "Show" : "Hide"}`);
        });
        const _ = (0, $TusQn.computed)(()=>e.toolbar && 0 !== e.toolbar.length), q = (0, $TusQn.computed)(()=>{
            const e = {}, t = (t)=>{
                t.key && (e[t.key] = {
                    cmd: t.cmd,
                    param: t.param
                });
            };
            return x.value.forEach((e)=>{
                e.forEach((e)=>{
                    e.options ? e.options.forEach(t) : t(e);
                });
            }), e;
        }), T = (0, $TusQn.computed)(()=>s.value ? e.contentStyle : [
                {
                    minHeight: e.minHeight,
                    height: e.height,
                    maxHeight: e.maxHeight
                },
                e.contentStyle
            ]), P = (0, $TusQn.computed)(()=>`q-editor q-editor--${!0 === m.value ? "source" : "default"}` + (!0 === e.disable ? " disabled" : "") + (!0 === s.value ? " fullscreen column" : "") + (!0 === e.square ? " q-editor--square no-border-radius" : "") + (!0 === e.flat ? " q-editor--flat" : "") + (!0 === e.dense ? " q-editor--dense" : "") + (!0 === r.value ? " q-editor--dark q-dark" : "")), $ = (0, $TusQn.computed)(()=>[
                e.contentClass,
                "q-editor__content",
                {
                    col: s.value,
                    "overflow-auto": s.value || e.maxHeight
                }
            ]), M = (0, $TusQn.computed)(()=>!0 === e.disable ? {
                "aria-disabled": "true"
            } : !0 === e.readonly ? {
                "aria-readonly": "true"
            } : {});
        function B() {
            if (null !== p.value) {
                const t = `inner${!0 === m.value ? "Text" : "HTML"}`, n = p.value[t];
                n !== e.modelValue && (y = n, o("update:modelValue", n));
            }
        }
        function E(e) {
            if (o("keydown", e), !0 !== e.ctrlKey || !0 === $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(e)) return void V();
            const t = e.keyCode, n = q.value[t];
            if (void 0 !== n) {
                const { cmd: t, param: o } = n;
                $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), I(t, o, !1);
            }
        }
        function Q(e) {
            V(), o("click", e);
        }
        function A(e) {
            if (null !== p.value) {
                const { scrollTop: e, scrollHeight: t } = p.value;
                b = t - e;
            }
            k.caret.save(), o("blur", e);
        }
        function L(e) {
            (0, $TusQn.nextTick)(()=>{
                null !== p.value && void 0 !== b && (p.value.scrollTop = p.value.scrollHeight - b);
            }), o("focus", e);
        }
        function O(e) {
            const t = d.value;
            if (null !== t && !0 === t.contains(e.target) && (null === e.relatedTarget || !0 !== t.contains(e.relatedTarget))) {
                const e = `inner${!0 === m.value ? "Text" : "HTML"}`;
                k.caret.restorePosition(p.value[e].length), V();
            }
        }
        function F(e) {
            const t = d.value;
            null === t || !0 !== t.contains(e.target) || null !== e.relatedTarget && !0 === t.contains(e.relatedTarget) || (k.caret.savePosition(), V());
        }
        function R() {
            b = void 0;
        }
        function D(e) {
            k.caret.save();
        }
        function z(e, t) {
            if (null !== p.value) {
                !0 === t && k.caret.savePosition();
                const o = `inner${!0 === m.value ? "Text" : "HTML"}`;
                p.value[o] = e, !0 === t && (k.caret.restorePosition(p.value[o].length), V());
            }
        }
        function I(e, t, o = !0) {
            H(), k.caret.restore(), k.caret.apply(e, t, ()=>{
                H(), k.caret.save(), o && V();
            });
        }
        function V() {
            setTimeout(()=>{
                v.value = null, a.$forceUpdate();
            }, 1);
        }
        function H() {
            $ec2fc4c0d7a3c6c6$var$addFocusFn(()=>{
                null !== p.value && p.value.focus({
                    preventScroll: !0
                });
            });
        }
        function N() {
            return p.value;
        }
        return (0, $TusQn.onMounted)(()=>{
            k.caret = a.caret = new $ec2fc4c0d7a3c6c6$var$Caret(p.value, k), z(e.modelValue), V(), document.addEventListener("selectionchange", D);
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            document.removeEventListener("selectionchange", D);
        }), Object.assign(a, {
            runCmd: I,
            refreshToolbar: V,
            focus: H,
            getContentEl: N
        }), ()=>{
            let t;
            if (_.value) {
                const e = [
                    (0, $TusQn.h)("div", {
                        key: "qedt_top",
                        class: "q-editor__toolbar row no-wrap scroll-x" + S.value
                    }, $ec2fc4c0d7a3c6c6$var$getToolbar(k))
                ];
                null !== v.value && e.push((0, $TusQn.h)("div", {
                    key: "qedt_btm",
                    class: "q-editor__toolbar row no-wrap items-center scroll-x" + S.value
                }, $ec2fc4c0d7a3c6c6$var$getLinkEditor(k))), t = (0, $TusQn.h)("div", {
                    key: "toolbar_ctainer",
                    class: "q-editor__toolbars-container"
                }, e);
            }
            return (0, $TusQn.h)("div", {
                ref: d,
                class: P.value,
                style: {
                    height: !0 === s.value ? "100%" : null
                },
                ...M.value,
                onFocusin: O,
                onFocusout: F
            }, [
                t,
                (0, $TusQn.h)("div", {
                    ref: p,
                    style: T.value,
                    class: $.value,
                    contenteditable: f.value,
                    placeholder: e.placeholder,
                    ...c.listeners.value,
                    onInput: B,
                    onKeydown: E,
                    onClick: Q,
                    onBlur: A,
                    onFocus: L,
                    onMousedown: R,
                    onTouchstartPassive: R
                })
            ]);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$17cb5eb1f3204256 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QItemLabel",
    props: {
        overline: Boolean,
        caption: Boolean,
        header: Boolean,
        lines: [
            Number,
            String
        ]
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>parseInt(e.lines, 10)), n = (0, $TusQn.computed)(()=>"q-item__label" + (!0 === e.overline ? " q-item__label--overline text-overline" : "") + (!0 === e.caption ? " q-item__label--caption text-caption" : "") + (!0 === e.header ? " q-item__label--header" : "") + (1 === o.value ? " ellipsis" : "")), a = (0, $TusQn.computed)(()=>{
            return void 0 !== e.lines && o.value > 1 ? {
                overflow: "hidden",
                display: "-webkit-box",
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": o.value
            } : null;
        });
        return ()=>(0, $TusQn.h)("div", {
                style: a.value,
                class: n.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$1712cdc175d4649d = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSlideTransition",
    props: {
        appear: Boolean,
        duration: {
            type: Number,
            default: 300
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup (e, { slots: t, emit: o }) {
        let n, a, l, i, r = !1, s = null, u = null;
        function c() {
            n && n(), n = null, r = !1, null !== s && (clearTimeout(s), s = null), null !== u && (clearTimeout(u), u = null), void 0 !== a && a.removeEventListener("transitionend", l), l = null;
        }
        function d(t, o, a) {
            void 0 !== o && (t.style.height = `${o}px`), t.style.transition = `height ${e.duration}ms cubic-bezier(.25, .8, .50, 1)`, r = !0, n = a;
        }
        function p(e, t) {
            e.style.overflowY = null, e.style.height = null, e.style.transition = null, c(), t !== i && o(t);
        }
        function v(t, o) {
            let n = 0;
            a = t, !0 === r ? (c(), n = t.offsetHeight === t.scrollHeight ? 0 : void 0) : (i = "hide", t.style.overflowY = "hidden"), d(t, n, o), s = setTimeout(()=>{
                s = null, t.style.height = `${t.scrollHeight}px`, l = (e)=>{
                    u = null, Object(e) === e && e.target !== t || p(t, "show");
                }, t.addEventListener("transitionend", l), u = setTimeout(l, 1.1 * e.duration);
            }, 100);
        }
        function m(t, o) {
            let n;
            a = t, !0 === r ? c() : (i = "show", t.style.overflowY = "hidden", n = t.scrollHeight), d(t, n, o), s = setTimeout(()=>{
                s = null, t.style.height = 0, l = (e)=>{
                    u = null, Object(e) === e && e.target !== t || p(t, "hide");
                }, t.addEventListener("transitionend", l), u = setTimeout(l, 1.1 * e.duration);
            }, 100);
        }
        return (0, $TusQn.onBeforeUnmount)(()=>{
            !0 === r && c();
        }), ()=>(0, $TusQn.h)((0, $eeJ70.Transition), {
                css: !1,
                appear: e.appear,
                onEnter: v,
                onLeave: m
            }, t.default);
    }
});
const $ec2fc4c0d7a3c6c6$var$insetMap = {
    true: "inset",
    item: "item-inset",
    "item-thumbnail": "item-thumbnail-inset"
}, $ec2fc4c0d7a3c6c6$var$margins = {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 24
};
var $ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSeparator",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        spaced: [
            Boolean,
            String
        ],
        inset: [
            Boolean,
            String
        ],
        vertical: Boolean,
        color: String,
        size: String
    },
    setup (e) {
        const t = (0, $TusQn.getCurrentInstance)(), o = $ec2fc4c0d7a3c6c6$var$useDark(e, t.proxy.$q), n = (0, $TusQn.computed)(()=>!0 === e.vertical ? "vertical" : "horizontal"), a = (0, $TusQn.computed)(()=>` q-separator--${n.value}`), l = (0, $TusQn.computed)(()=>!1 !== e.inset ? `${a.value}-${$ec2fc4c0d7a3c6c6$var$insetMap[e.inset]}` : ""), i = (0, $TusQn.computed)(()=>`q-separator${a.value}${l.value}` + (void 0 !== e.color ? ` bg-${e.color}` : "") + (!0 === o.value ? " q-separator--dark" : "")), r = (0, $TusQn.computed)(()=>{
            const t = {};
            if (void 0 !== e.size && (t[!0 === e.vertical ? "width" : "height"] = e.size), !1 !== e.spaced) {
                const o = !0 === e.spaced ? `${$ec2fc4c0d7a3c6c6$var$margins.md}px` : e.spaced in $ec2fc4c0d7a3c6c6$var$margins ? `${$ec2fc4c0d7a3c6c6$var$margins[e.spaced]}px` : e.spaced, n = !0 === e.vertical ? [
                    "Left",
                    "Right"
                ] : [
                    "Top",
                    "Bottom"
                ];
                t[`margin${n[0]}`] = t[`margin${n[1]}`] = o;
            }
            return t;
        });
        return ()=>(0, $TusQn.h)("hr", {
                class: i.value,
                style: r.value,
                "aria-orientation": n.value
            });
    }
});
const $ec2fc4c0d7a3c6c6$var$itemGroups = (0, $01W3b.shallowReactive)({}), $ec2fc4c0d7a3c6c6$var$LINK_PROPS = Object.keys($ec2fc4c0d7a3c6c6$var$useRouterLinkProps);
var $ec2fc4c0d7a3c6c6$export$eb8cb4fb55e6cd84 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QExpansionItem",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useRouterLinkProps,
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleProps,
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        icon: String,
        label: String,
        labelLines: [
            Number,
            String
        ],
        caption: String,
        captionLines: [
            Number,
            String
        ],
        dense: Boolean,
        toggleAriaLabel: String,
        expandIcon: String,
        expandedIcon: String,
        expandIconClass: [
            Array,
            String,
            Object
        ],
        duration: Number,
        headerInsetLevel: Number,
        contentInsetLevel: Number,
        expandSeparator: Boolean,
        defaultOpened: Boolean,
        hideExpandIcon: Boolean,
        expandIconToggle: Boolean,
        switchToggleSide: Boolean,
        denseToggle: Boolean,
        group: String,
        popup: Boolean,
        headerStyle: [
            Array,
            String,
            Object
        ],
        headerClass: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleEmits,
        "click",
        "afterShow",
        "afterHide"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), l = (0, $01W3b.ref)(null !== e.modelValue ? e.modelValue : e.defaultOpened), i = (0, $01W3b.ref)(null), r = $ec2fc4c0d7a3c6c6$export$e2a22331486dcca0(), { show: s, hide: u, toggle: c } = $ec2fc4c0d7a3c6c6$var$useModelToggle({
            showing: l
        });
        let d, p;
        const v = (0, $TusQn.computed)(()=>"q-expansion-item q-item-type" + ` q-expansion-item--${!0 === l.value ? "expanded" : "collapsed"}` + ` q-expansion-item--${!0 === e.popup ? "popup" : "standard"}`), m = (0, $TusQn.computed)(()=>{
            if (void 0 === e.contentInsetLevel) return null;
            const t = !0 === n.lang.rtl ? "Right" : "Left";
            return {
                ["padding" + t]: 56 * e.contentInsetLevel + "px"
            };
        }), f = (0, $TusQn.computed)(()=>!0 !== e.disable && (void 0 !== e.href || void 0 !== e.to && null !== e.to && "" !== e.to)), g = (0, $TusQn.computed)(()=>{
            const t = {};
            return $ec2fc4c0d7a3c6c6$var$LINK_PROPS.forEach((o)=>{
                t[o] = e[o];
            }), t;
        }), b = (0, $TusQn.computed)(()=>!0 === f.value || !0 !== e.expandIconToggle), y = (0, $TusQn.computed)(()=>void 0 !== e.expandedIcon && !0 === l.value ? e.expandedIcon : e.expandIcon || n.iconSet.expansionItem[!0 === e.denseToggle ? "denseIcon" : "icon"]), S = (0, $TusQn.computed)(()=>!0 !== e.disable && (!0 === f.value || !0 === e.expandIconToggle)), w = (0, $TusQn.computed)(()=>({
                expanded: !0 === l.value,
                detailsId: e.targetUid,
                toggle: c,
                show: s,
                hide: u
            })), C = (0, $TusQn.computed)(()=>{
            const t = void 0 !== e.toggleAriaLabel ? e.toggleAriaLabel : n.lang.label[!0 === l.value ? "collapse" : "expand"](e.label);
            return {
                role: "button",
                "aria-expanded": !0 === l.value ? "true" : "false",
                "aria-controls": r,
                "aria-label": t
            };
        });
        function x(e) {
            !0 !== f.value && c(e), o("click", e);
        }
        function k(e) {
            13 === e.keyCode && _(e, !0);
        }
        function _(e, t) {
            !0 !== t && null !== i.value && i.value.focus(), c(e), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
        }
        function q() {
            o("afterShow");
        }
        function T() {
            o("afterHide");
        }
        function P() {
            void 0 === d && (d = $ec2fc4c0d7a3c6c6$export$e2a22331486dcca0()), !0 === l.value && ($ec2fc4c0d7a3c6c6$var$itemGroups[e.group] = d);
            const t = (0, $TusQn.watch)(l, (t)=>{
                !0 === t ? $ec2fc4c0d7a3c6c6$var$itemGroups[e.group] = d : $ec2fc4c0d7a3c6c6$var$itemGroups[e.group] === d && delete $ec2fc4c0d7a3c6c6$var$itemGroups[e.group];
            }), o = (0, $TusQn.watch)(()=>$ec2fc4c0d7a3c6c6$var$itemGroups[e.group], (e, t)=>{
                t === d && void 0 !== e && e !== d && u();
            });
            p = ()=>{
                t(), o(), $ec2fc4c0d7a3c6c6$var$itemGroups[e.group] === d && delete $ec2fc4c0d7a3c6c6$var$itemGroups[e.group], p = void 0;
            };
        }
        function $() {
            const t = {
                class: [
                    "q-focusable relative-position cursor-pointer" + `${!0 === e.denseToggle && !0 === e.switchToggleSide ? " items-end" : ""}`,
                    e.expandIconClass
                ],
                side: !0 !== e.switchToggleSide,
                avatar: e.switchToggleSide
            }, o = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    class: "q-expansion-item__toggle-icon" + (void 0 === e.expandedIcon && !0 === l.value ? " q-expansion-item__toggle-icon--rotated" : ""),
                    name: y.value
                })
            ];
            return !0 === S.value && (Object.assign(t, {
                tabindex: 0,
                ...C.value,
                onClick: _,
                onKeyup: k
            }), o.unshift((0, $TusQn.h)("div", {
                ref: i,
                class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
                tabindex: -1
            }))), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, t, ()=>o);
        }
        function M() {
            let o;
            return void 0 !== t.header ? o = [].concat(t.header(w.value)) : (o = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, ()=>[
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$17cb5eb1f3204256, {
                            lines: e.labelLines
                        }, ()=>e.label || ""),
                        e.caption ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$17cb5eb1f3204256, {
                            lines: e.captionLines,
                            caption: !0
                        }, ()=>e.caption) : null
                    ])
            ], e.icon && o[!0 === e.switchToggleSide ? "push" : "unshift"]((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, {
                side: !0 === e.switchToggleSide,
                avatar: !0 !== e.switchToggleSide
            }, ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    name: e.icon
                })))), !0 !== e.disable && !0 !== e.hideExpandIcon && o[!0 === e.switchToggleSide ? "unshift" : "push"]($()), o;
        }
        function B() {
            const t = {
                ref: "item",
                style: e.headerStyle,
                class: e.headerClass,
                dark: a.value,
                disable: e.disable,
                dense: e.dense,
                insetLevel: e.headerInsetLevel
            };
            return !0 === b.value && (t.clickable = !0, t.onClick = x, Object.assign(t, !0 === f.value ? g.value : C.value)), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$adf75769807ad87e, t, M);
        }
        function E() {
            return (0, $TusQn.withDirectives)((0, $TusQn.h)("div", {
                key: "e-content",
                class: "q-expansion-item__content relative-position",
                style: m.value,
                id: r
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)), [
                [
                    (0, $eeJ70.vShow),
                    l.value
                ]
            ]);
        }
        function Q() {
            const t = [
                B(),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$1712cdc175d4649d, {
                    duration: e.duration,
                    onShow: q,
                    onHide: T
                }, E)
            ];
            return !0 === e.expandSeparator && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
                dark: a.value
            }), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
                dark: a.value
            })), t;
        }
        return (0, $TusQn.watch)(()=>e.group, (e)=>{
            void 0 !== p && p(), void 0 !== e && P();
        }), void 0 !== e.group && P(), (0, $TusQn.onBeforeUnmount)(()=>{
            void 0 !== p && p();
        }), ()=>(0, $TusQn.h)("div", {
                class: v.value
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-expansion-item__container relative-position"
                }, Q())
            ]);
    }
});
const $ec2fc4c0d7a3c6c6$var$labelPositions = [
    "top",
    "right",
    "bottom",
    "left"
], $ec2fc4c0d7a3c6c6$var$useFabProps = {
    type: {
        type: String,
        default: "a"
    },
    outline: Boolean,
    push: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    square: Boolean,
    padding: String,
    label: {
        type: [
            String,
            Number
        ],
        default: ""
    },
    labelPosition: {
        type: String,
        default: "right",
        validator: (e)=>$ec2fc4c0d7a3c6c6$var$labelPositions.includes(e)
    },
    externalLabel: Boolean,
    hideLabel: {
        type: Boolean
    },
    labelClass: [
        Array,
        String,
        Object
    ],
    labelStyle: [
        Array,
        String,
        Object
    ],
    disable: Boolean,
    tabindex: [
        Number,
        String
    ]
};
function $ec2fc4c0d7a3c6c6$var$useFab(e, t) {
    return {
        formClass: (0, $TusQn.computed)(()=>`q-fab--form-${!0 === e.square ? "square" : "rounded"}`),
        stacked: (0, $TusQn.computed)(()=>!1 === e.externalLabel && [
                "top",
                "bottom"
            ].includes(e.labelPosition)),
        labelProps: (0, $TusQn.computed)(()=>{
            if (!0 === e.externalLabel) {
                const o = null === e.hideLabel ? !1 === t.value : e.hideLabel;
                return {
                    action: "push",
                    data: {
                        class: [
                            e.labelClass,
                            "q-fab__label q-tooltip--style q-fab__label--external" + ` q-fab__label--external-${e.labelPosition}` + (!0 === o ? " q-fab__label--external-hidden" : "")
                        ],
                        style: e.labelStyle
                    }
                };
            }
            return {
                action: [
                    "left",
                    "top"
                ].includes(e.labelPosition) ? "unshift" : "push",
                data: {
                    class: [
                        e.labelClass,
                        `q-fab__label q-fab__label--internal q-fab__label--internal-${e.labelPosition}` + (!0 === e.hideLabel ? " q-fab__label--internal-hidden" : "")
                    ],
                    style: e.labelStyle
                }
            };
        })
    };
}
const $ec2fc4c0d7a3c6c6$var$directions = [
    "up",
    "right",
    "down",
    "left"
], $ec2fc4c0d7a3c6c6$var$alignValues = [
    "left",
    "center",
    "right"
];
var $ec2fc4c0d7a3c6c6$export$feca39a40ec06c6e = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QFab",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useFabProps,
        ...$ec2fc4c0d7a3c6c6$var$useModelToggleProps,
        icon: String,
        activeIcon: String,
        hideIcon: Boolean,
        hideLabel: {
            default: null
        },
        direction: {
            type: String,
            default: "right",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$directions.includes(e)
        },
        persistent: Boolean,
        verticalActionsAlign: {
            type: String,
            default: "center",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$alignValues.includes(e)
        }
    },
    emits: $ec2fc4c0d7a3c6c6$var$useModelToggleEmits,
    setup (e, { slots: t }) {
        const o = (0, $01W3b.ref)(null), n = (0, $01W3b.ref)(!0 === e.modelValue), a = $ec2fc4c0d7a3c6c6$export$e2a22331486dcca0(), { proxy: { $q: l } } = (0, $TusQn.getCurrentInstance)(), { formClass: i, labelProps: r } = $ec2fc4c0d7a3c6c6$var$useFab(e, n), s = (0, $TusQn.computed)(()=>!0 !== e.persistent), { hide: u, toggle: c } = $ec2fc4c0d7a3c6c6$var$useModelToggle({
            showing: n,
            hideOnRouteChange: s
        }), d = (0, $TusQn.computed)(()=>({
                opened: n.value
            })), p = (0, $TusQn.computed)(()=>"q-fab z-fab row inline justify-center" + ` q-fab--align-${e.verticalActionsAlign} ${i.value}` + (!0 === n.value ? " q-fab--opened" : " q-fab--closed")), v = (0, $TusQn.computed)(()=>"q-fab__actions flex no-wrap inline" + ` q-fab__actions--${e.direction}` + ` q-fab__actions--${!0 === n.value ? "opened" : "closed"}`), m = (0, $TusQn.computed)(()=>{
            const e = {
                id: a,
                role: "menu"
            };
            return !0 !== n.value && (e["aria-hidden"] = "true"), e;
        }), f = (0, $TusQn.computed)(()=>"q-fab__icon-holder " + ` q-fab__icon-holder--${!0 === n.value ? "opened" : "closed"}`);
        function g(o, n) {
            const a = t[o], i = `q-fab__${o} absolute-full`;
            return void 0 === a ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: i,
                name: e[n] || l.iconSet.fab[n]
            }) : (0, $TusQn.h)("div", {
                class: i
            }, a(d.value));
        }
        function b() {
            const o = [];
            return !0 !== e.hideIcon && o.push((0, $TusQn.h)("div", {
                class: f.value
            }, [
                g("icon", "icon"),
                g("active-icon", "activeIcon")
            ])), "" === e.label && void 0 === t.label || o[r.value.action]((0, $TusQn.h)("div", r.value.data, void 0 !== t.label ? t.label(d.value) : [
                e.label
            ])), $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.tooltip, o);
        }
        return (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$fabKey, {
            showing: n,
            onChildClick (e) {
                u(e), null !== o.value && o.value.$el.focus();
            }
        }), ()=>(0, $TusQn.h)("div", {
                class: p.value
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    ref: o,
                    class: i.value,
                    ...e,
                    noWrap: !0,
                    stack: e.stacked,
                    align: void 0,
                    icon: void 0,
                    label: void 0,
                    noCaps: !0,
                    fab: !0,
                    "aria-expanded": !0 === n.value ? "true" : "false",
                    "aria-haspopup": "true",
                    "aria-controls": a,
                    onClick: c
                }, b),
                (0, $TusQn.h)("div", {
                    class: v.value,
                    ...m.value
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ]);
    }
});
const $ec2fc4c0d7a3c6c6$var$anchorMap = {
    start: "self-end",
    center: "self-center",
    end: "self-start"
}, $ec2fc4c0d7a3c6c6$var$anchorValues = Object.keys($ec2fc4c0d7a3c6c6$var$anchorMap);
var $ec2fc4c0d7a3c6c6$export$a1eb3675933e8b79 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QFabAction",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useFabProps,
        icon: {
            type: String,
            default: ""
        },
        anchor: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$anchorValues.includes(e)
        },
        to: [
            String,
            Object
        ],
        replace: Boolean
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$fabKey, ()=>({
                showing: {
                    value: !0
                },
                onChildClick: $ec2fc4c0d7a3c6c6$export$8793edee2d425525
            })), { formClass: a, labelProps: l } = $ec2fc4c0d7a3c6c6$var$useFab(e, n.showing), i = (0, $TusQn.computed)(()=>{
            const t = $ec2fc4c0d7a3c6c6$var$anchorMap[e.anchor];
            return a.value + (void 0 !== t ? ` ${t}` : "");
        }), r = (0, $TusQn.computed)(()=>!0 === e.disable || !0 !== n.showing.value);
        function s(e) {
            n.onChildClick(e), o("click", e);
        }
        function u() {
            const o = [];
            return void 0 !== t.icon ? o.push(t.icon()) : "" !== e.icon && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                name: e.icon
            })), "" === e.label && void 0 === t.label || o[l.value.action]((0, $TusQn.h)("div", l.value.data, void 0 !== t.label ? t.label() : [
                e.label
            ])), $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, o);
        }
        const c = (0, $TusQn.getCurrentInstance)();
        return Object.assign(c.proxy, {
            click: s
        }), ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                class: i.value,
                ...e,
                noWrap: !0,
                stack: e.stacked,
                icon: void 0,
                label: void 0,
                noCaps: !0,
                fabMini: !0,
                disable: r.value,
                onClick: s
            }, u);
    }
});
function $ec2fc4c0d7a3c6c6$export$78d4b0ea29932732({ validate: e, resetValidation: t, requiresQForm: o }) {
    const n = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$formKey, !1);
    if (!1 !== n) {
        const { props: o, proxy: a } = (0, $TusQn.getCurrentInstance)();
        Object.assign(a, {
            validate: e,
            resetValidation: t
        }), (0, $TusQn.watch)(()=>o.disable, (e)=>{
            !0 === e ? ("function" === typeof t && t(), n.unbindComponent(a)) : n.bindComponent(a);
        }), (0, $TusQn.onMounted)(()=>{
            !0 !== o.disable && n.bindComponent(a);
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            !0 !== o.disable && n.unbindComponent(a);
        });
    } else !0 === o && console.error("Parent QForm not found on useFormChild()!");
}
const $ec2fc4c0d7a3c6c6$var$lazyRulesValues = [
    !0,
    !1,
    "ondemand"
], $ec2fc4c0d7a3c6c6$var$useValidateProps = {
    modelValue: {},
    error: {
        type: Boolean,
        default: null
    },
    errorMessage: String,
    noErrorIcon: Boolean,
    rules: Array,
    reactiveRules: Boolean,
    lazyRules: {
        type: [
            Boolean,
            String
        ],
        validator: (e)=>$ec2fc4c0d7a3c6c6$var$lazyRulesValues.includes(e)
    }
};
function $ec2fc4c0d7a3c6c6$var$useValidate(e, t) {
    const { props: o, proxy: n } = (0, $TusQn.getCurrentInstance)(), a = (0, $01W3b.ref)(!1), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(null);
    $ec2fc4c0d7a3c6c6$export$78d4b0ea29932732({
        validate: m,
        resetValidation: v
    });
    let r, s = 0;
    const u = (0, $TusQn.computed)(()=>void 0 !== o.rules && null !== o.rules && 0 !== o.rules.length), c = (0, $TusQn.computed)(()=>!0 !== o.disable && !0 === u.value), d = (0, $TusQn.computed)(()=>!0 === o.error || !0 === a.value), p = (0, $TusQn.computed)(()=>"string" === typeof o.errorMessage && 0 !== o.errorMessage.length ? o.errorMessage : l.value);
    function v() {
        s++, t.value = !1, i.value = null, a.value = !1, l.value = null, h.cancel();
    }
    function m(e = o.modelValue) {
        if (!0 !== c.value) return !0;
        const n = ++s, r = !0 !== t.value ? ()=>{
            i.value = !0;
        } : ()=>{}, u = (e, o)=>{
            !0 === e && r(), a.value = e, l.value = o || null, t.value = !1;
        }, d = [];
        for(let t = 0; t < o.rules.length; t++){
            const n = o.rules[t];
            let a;
            if ("function" === typeof n ? a = n(e, $ec2fc4c0d7a3c6c6$var$testPattern) : "string" === typeof n && void 0 !== $ec2fc4c0d7a3c6c6$var$testPattern[n] && (a = $ec2fc4c0d7a3c6c6$var$testPattern[n](e)), !1 === a || "string" === typeof a) return u(!0, a), !1;
            !0 !== a && void 0 !== a && d.push(a);
        }
        return 0 === d.length ? (u(!1), !0) : (t.value = !0, Promise.all(d).then((e)=>{
            if (void 0 === e || !1 === Array.isArray(e) || 0 === e.length) return n === s && u(!1), !0;
            const t = e.find((e)=>!1 === e || "string" === typeof e);
            return n === s && u(void 0 !== t, t), void 0 === t;
        }, (e)=>{
            return n === s && (console.error(e), u(!0)), !1;
        }));
    }
    function f(e) {
        !0 === c.value && "ondemand" !== o.lazyRules && (!0 === i.value || !0 !== o.lazyRules && !0 !== e) && h();
    }
    (0, $TusQn.watch)(()=>o.modelValue, ()=>{
        f();
    }), (0, $TusQn.watch)(()=>o.reactiveRules, (e)=>{
        !0 === e ? void 0 === r && (r = (0, $TusQn.watch)(()=>o.rules, ()=>{
            f(!0);
        })) : void 0 !== r && (r(), r = void 0);
    }, {
        immediate: !0
    }), (0, $TusQn.watch)(e, (e)=>{
        !0 === e ? null === i.value && (i.value = !1) : !1 === i.value && (i.value = !0, !0 === c.value && "ondemand" !== o.lazyRules && !1 === t.value && h());
    });
    const h = $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(m, 0);
    return (0, $TusQn.onBeforeUnmount)(()=>{
        void 0 !== r && r(), h.cancel();
    }), Object.assign(n, {
        resetValidation: v,
        validate: m
    }), $ec2fc4c0d7a3c6c6$var$injectProp(n, "hasError", ()=>d.value), {
        isDirtyModel: i,
        hasRules: u,
        hasError: d,
        errorMessage: p,
        validate: m,
        resetValidation: v
    };
}
function $ec2fc4c0d7a3c6c6$var$getTargetUid(e) {
    return void 0 === e ? `f_${$ec2fc4c0d7a3c6c6$export$e2a22331486dcca0()}` : e;
}
function $ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(e) {
    return void 0 !== e && null !== e && 0 !== ("" + e).length;
}
const $ec2fc4c0d7a3c6c6$var$useFieldProps = {
    ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
    ...$ec2fc4c0d7a3c6c6$var$useValidateProps,
    label: String,
    stackLabel: Boolean,
    hint: String,
    hideHint: Boolean,
    prefix: String,
    suffix: String,
    labelColor: String,
    color: String,
    bgColor: String,
    filled: Boolean,
    outlined: Boolean,
    borderless: Boolean,
    standout: [
        Boolean,
        String
    ],
    square: Boolean,
    loading: Boolean,
    labelSlot: Boolean,
    bottomSlots: Boolean,
    hideBottomSpace: Boolean,
    rounded: Boolean,
    dense: Boolean,
    itemAligned: Boolean,
    counter: Boolean,
    clearable: Boolean,
    clearIcon: String,
    disable: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
    for: String,
    maxlength: [
        Number,
        String
    ]
}, $ec2fc4c0d7a3c6c6$var$useFieldEmits = [
    "update:modelValue",
    "clear",
    "focus",
    "blur",
    "popupShow",
    "popupHide"
];
function $ec2fc4c0d7a3c6c6$var$useFieldState() {
    const { props: e, attrs: t, proxy: o, vnode: n } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useDark(e, o.$q);
    return {
        isDark: a,
        editable: (0, $TusQn.computed)(()=>!0 !== e.disable && !0 !== e.readonly),
        innerLoading: (0, $01W3b.ref)(!1),
        focused: (0, $01W3b.ref)(!1),
        hasPopupOpen: !1,
        splitAttrs: $ec2fc4c0d7a3c6c6$var$useSplitAttrs(t, n),
        targetUid: (0, $01W3b.ref)($ec2fc4c0d7a3c6c6$var$getTargetUid(e.for)),
        rootRef: (0, $01W3b.ref)(null),
        targetRef: (0, $01W3b.ref)(null),
        controlRef: (0, $01W3b.ref)(null)
    };
}
function $ec2fc4c0d7a3c6c6$var$useField(e) {
    const { props: t, emit: o, slots: n, attrs: a, proxy: l } = (0, $TusQn.getCurrentInstance)(), { $q: i } = l;
    let r = null;
    void 0 === e.hasValue && (e.hasValue = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(t.modelValue))), void 0 === e.emitValue && (e.emitValue = (e)=>{
        o("update:modelValue", e);
    }), void 0 === e.controlEvents && (e.controlEvents = {
        onFocusin: q,
        onFocusout: T
    }), Object.assign(e, {
        clearValue: P,
        onControlFocusin: q,
        onControlFocusout: T,
        focus: k
    }), void 0 === e.computedCounter && (e.computedCounter = (0, $TusQn.computed)(()=>{
        if (!1 !== t.counter) {
            const e = "string" === typeof t.modelValue || "number" === typeof t.modelValue ? ("" + t.modelValue).length : !0 === Array.isArray(t.modelValue) ? t.modelValue.length : 0, o = void 0 !== t.maxlength ? t.maxlength : t.maxValues;
            return e + (void 0 !== o ? " / " + o : "");
        }
    }));
    const { isDirtyModel: s, hasRules: u, hasError: c, errorMessage: d, resetValidation: p } = $ec2fc4c0d7a3c6c6$var$useValidate(e.focused, e.innerLoading), v = void 0 !== e.floatingLabel ? (0, $TusQn.computed)(()=>!0 === t.stackLabel || !0 === e.focused.value || !0 === e.floatingLabel.value) : (0, $TusQn.computed)(()=>!0 === t.stackLabel || !0 === e.focused.value || !0 === e.hasValue.value), m = (0, $TusQn.computed)(()=>!0 === t.bottomSlots || void 0 !== t.hint || !0 === u.value || !0 === t.counter || null !== t.error), f = (0, $TusQn.computed)(()=>{
        return !0 === t.filled ? "filled" : !0 === t.outlined ? "outlined" : !0 === t.borderless ? "borderless" : t.standout ? "standout" : "standard";
    }), g = (0, $TusQn.computed)(()=>`q-field row no-wrap items-start q-field--${f.value}` + (void 0 !== e.fieldClass ? ` ${e.fieldClass.value}` : "") + (!0 === t.rounded ? " q-field--rounded" : "") + (!0 === t.square ? " q-field--square" : "") + (!0 === v.value ? " q-field--float" : "") + (!0 === y.value ? " q-field--labeled" : "") + (!0 === t.dense ? " q-field--dense" : "") + (!0 === t.itemAligned ? " q-field--item-aligned q-item-type" : "") + (!0 === e.isDark.value ? " q-field--dark" : "") + (void 0 === e.getControl ? " q-field--auto-height" : "") + (!0 === e.focused.value ? " q-field--focused" : "") + (!0 === c.value ? " q-field--error" : "") + (!0 === c.value || !0 === e.focused.value ? " q-field--highlighted" : "") + (!0 !== t.hideBottomSpace && !0 === m.value ? " q-field--with-bottom" : "") + (!0 === t.disable ? " q-field--disabled" : !0 === t.readonly ? " q-field--readonly" : "")), b = (0, $TusQn.computed)(()=>"q-field__control relative-position row no-wrap" + (void 0 !== t.bgColor ? ` bg-${t.bgColor}` : "") + (!0 === c.value ? " text-negative" : "string" === typeof t.standout && 0 !== t.standout.length && !0 === e.focused.value ? ` ${t.standout}` : void 0 !== t.color ? ` text-${t.color}` : "")), y = (0, $TusQn.computed)(()=>!0 === t.labelSlot || void 0 !== t.label), S = (0, $TusQn.computed)(()=>"q-field__label no-pointer-events absolute ellipsis" + (void 0 !== t.labelColor && !0 !== c.value ? ` text-${t.labelColor}` : "")), w = (0, $TusQn.computed)(()=>({
            id: e.targetUid.value,
            editable: e.editable.value,
            focused: e.focused.value,
            floatingLabel: v.value,
            modelValue: t.modelValue,
            emitValue: e.emitValue
        })), C = (0, $TusQn.computed)(()=>{
        const o = {
            for: e.targetUid.value
        };
        return !0 === t.disable ? o["aria-disabled"] = "true" : !0 === t.readonly && (o["aria-readonly"] = "true"), o;
    });
    function x() {
        const t = document.activeElement;
        let o = void 0 !== e.targetRef && e.targetRef.value;
        !o || null !== t && t.id === e.targetUid.value || (!0 === o.hasAttribute("tabindex") || (o = o.querySelector("[tabindex]")), o && o !== t && o.focus({
            preventScroll: !0
        }));
    }
    function k() {
        $ec2fc4c0d7a3c6c6$var$addFocusFn(x);
    }
    function _() {
        $ec2fc4c0d7a3c6c6$var$removeFocusFn(x);
        const t = document.activeElement;
        null !== t && e.rootRef.value.contains(t) && t.blur();
    }
    function q(t) {
        null !== r && (clearTimeout(r), r = null), !0 === e.editable.value && !1 === e.focused.value && (e.focused.value = !0, o("focus", t));
    }
    function T(t, n) {
        null !== r && clearTimeout(r), r = setTimeout(()=>{
            r = null, (!0 !== document.hasFocus() || !0 !== e.hasPopupOpen && void 0 !== e.controlRef && null !== e.controlRef.value && !1 === e.controlRef.value.contains(document.activeElement)) && (!0 === e.focused.value && (e.focused.value = !1, o("blur", t)), void 0 !== n && n());
        });
    }
    function P(n) {
        if ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(n), !0 !== i.platform.is.mobile) {
            const t = void 0 !== e.targetRef && e.targetRef.value || e.rootRef.value;
            t.focus();
        } else !0 === e.rootRef.value.contains(document.activeElement) && document.activeElement.blur();
        "file" === t.type && (e.inputRef.value.value = null), o("update:modelValue", null), o("clear", t.modelValue), (0, $TusQn.nextTick)(()=>{
            p(), !0 !== i.platform.is.mobile && (s.value = !1);
        });
    }
    function $() {
        const o = [];
        return void 0 !== n.prepend && o.push((0, $TusQn.h)("div", {
            class: "q-field__prepend q-field__marginal row no-wrap items-center",
            key: "prepend",
            onClick: $ec2fc4c0d7a3c6c6$var$prevent
        }, n.prepend())), o.push((0, $TusQn.h)("div", {
            class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
        }, M())), !0 === c.value && !1 === t.noErrorIcon && o.push(E("error", [
            (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                name: i.iconSet.field.error,
                color: "negative"
            })
        ])), !0 === t.loading || !0 === e.innerLoading.value ? o.push(E("inner-loading-append", void 0 !== n.loading ? n.loading() : [
            (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0, {
                color: t.color
            })
        ])) : !0 === t.clearable && !0 === e.hasValue.value && !0 === e.editable.value && o.push(E("inner-clearable-append", [
            (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: "q-field__focusable-action",
                tag: "button",
                name: t.clearIcon || i.iconSet.field.clear,
                tabindex: 0,
                type: "button",
                "aria-hidden": null,
                role: null,
                onClick: P
            })
        ])), void 0 !== n.append && o.push((0, $TusQn.h)("div", {
            class: "q-field__append q-field__marginal row no-wrap items-center",
            key: "append",
            onClick: $ec2fc4c0d7a3c6c6$var$prevent
        }, n.append())), void 0 !== e.getInnerAppend && o.push(E("inner-append", e.getInnerAppend())), void 0 !== e.getControlChild && o.push(e.getControlChild()), o;
    }
    function M() {
        const o = [];
        return void 0 !== t.prefix && null !== t.prefix && o.push((0, $TusQn.h)("div", {
            class: "q-field__prefix no-pointer-events row items-center"
        }, t.prefix)), void 0 !== e.getShadowControl && !0 === e.hasShadow.value && o.push(e.getShadowControl()), void 0 !== e.getControl ? o.push(e.getControl()) : void 0 !== n.rawControl ? o.push(n.rawControl()) : void 0 !== n.control && o.push((0, $TusQn.h)("div", {
            ref: e.targetRef,
            class: "q-field__native row",
            tabindex: -1,
            ...e.splitAttrs.attributes.value,
            "data-autofocus": !0 === t.autofocus || void 0
        }, n.control(w.value))), !0 === y.value && o.push((0, $TusQn.h)("div", {
            class: S.value
        }, $ec2fc4c0d7a3c6c6$var$hSlot(n.label, t.label))), void 0 !== t.suffix && null !== t.suffix && o.push((0, $TusQn.h)("div", {
            class: "q-field__suffix no-pointer-events row items-center"
        }, t.suffix)), o.concat($ec2fc4c0d7a3c6c6$var$hSlot(n.default));
    }
    function B() {
        let o, a;
        !0 === c.value ? null !== d.value ? (o = [
            (0, $TusQn.h)("div", {
                role: "alert"
            }, d.value)
        ], a = `q--slot-error-${d.value}`) : (o = $ec2fc4c0d7a3c6c6$var$hSlot(n.error), a = "q--slot-error") : !0 === t.hideHint && !0 !== e.focused.value || (void 0 !== t.hint ? (o = [
            (0, $TusQn.h)("div", t.hint)
        ], a = `q--slot-hint-${t.hint}`) : (o = $ec2fc4c0d7a3c6c6$var$hSlot(n.hint), a = "q--slot-hint"));
        const l = !0 === t.counter || void 0 !== n.counter;
        if (!0 === t.hideBottomSpace && !1 === l && void 0 === o) return;
        const i = (0, $TusQn.h)("div", {
            key: a,
            class: "q-field__messages col"
        }, o);
        return (0, $TusQn.h)("div", {
            class: "q-field__bottom row items-start q-field__bottom--" + (!0 !== t.hideBottomSpace ? "animated" : "stale"),
            onClick: $ec2fc4c0d7a3c6c6$var$prevent
        }, [
            !0 === t.hideBottomSpace ? i : (0, $TusQn.h)((0, $eeJ70.Transition), {
                name: "q-transition--field-message"
            }, ()=>i),
            !0 === l ? (0, $TusQn.h)("div", {
                class: "q-field__counter"
            }, void 0 !== n.counter ? n.counter() : e.computedCounter.value) : null
        ]);
    }
    function E(e, t) {
        return null === t ? null : (0, $TusQn.h)("div", {
            key: e,
            class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
        }, t);
    }
    (0, $TusQn.watch)(()=>t.for, (t)=>{
        e.targetUid.value = $ec2fc4c0d7a3c6c6$var$getTargetUid(t);
    });
    let Q = !1;
    return (0, $TusQn.onDeactivated)(()=>{
        Q = !0;
    }), (0, $TusQn.onActivated)(()=>{
        !0 === Q && !0 === t.autofocus && l.focus();
    }), (0, $TusQn.onMounted)(()=>{
        !0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value && void 0 === t.for && (e.targetUid.value = $ec2fc4c0d7a3c6c6$var$getTargetUid()), !0 === t.autofocus && l.focus();
    }), (0, $TusQn.onBeforeUnmount)(()=>{
        null !== r && clearTimeout(r);
    }), Object.assign(l, {
        focus: k,
        blur: _
    }), function() {
        const o = void 0 === e.getControl && void 0 === n.control ? {
            ...e.splitAttrs.attributes.value,
            "data-autofocus": !0 === t.autofocus || void 0,
            ...C.value
        } : C.value;
        return (0, $TusQn.h)("label", {
            ref: e.rootRef,
            class: [
                g.value,
                a.class
            ],
            style: a.style,
            ...o
        }, [
            void 0 !== n.before ? (0, $TusQn.h)("div", {
                class: "q-field__before q-field__marginal row no-wrap items-center",
                onClick: $ec2fc4c0d7a3c6c6$var$prevent
            }, n.before()) : null,
            (0, $TusQn.h)("div", {
                class: "q-field__inner relative-position col self-stretch"
            }, [
                (0, $TusQn.h)("div", {
                    ref: e.controlRef,
                    class: b.value,
                    tabindex: -1,
                    ...e.controlEvents
                }, $()),
                !0 === m.value ? B() : null
            ]),
            void 0 !== n.after ? (0, $TusQn.h)("div", {
                class: "q-field__after q-field__marginal row no-wrap items-center",
                onClick: $ec2fc4c0d7a3c6c6$var$prevent
            }, n.after()) : null
        ]);
    };
}
var $ec2fc4c0d7a3c6c6$export$9e1d68206b908513 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QField",
    inheritAttrs: !1,
    props: $ec2fc4c0d7a3c6c6$var$useFieldProps,
    emits: $ec2fc4c0d7a3c6c6$var$useFieldEmits,
    setup () {
        return $ec2fc4c0d7a3c6c6$var$useField($ec2fc4c0d7a3c6c6$var$useFieldState());
    }
});
function $ec2fc4c0d7a3c6c6$var$filterFiles(e, t, o, n) {
    const a = [];
    return e.forEach((e)=>{
        !0 === n(e) ? a.push(e) : t.push({
            failedPropValidation: o,
            file: e
        });
    }), a;
}
function $ec2fc4c0d7a3c6c6$var$stopAndPreventDrag(e) {
    e && e.dataTransfer && (e.dataTransfer.dropEffect = "copy"), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
}
const $ec2fc4c0d7a3c6c6$var$useFileProps = {
    multiple: Boolean,
    accept: String,
    capture: String,
    maxFileSize: [
        Number,
        String
    ],
    maxTotalSize: [
        Number,
        String
    ],
    maxFiles: [
        Number,
        String
    ],
    filter: Function
}, $ec2fc4c0d7a3c6c6$var$useFileEmits = [
    "rejected"
];
function $ec2fc4c0d7a3c6c6$var$useFile({ editable: e, dnd: t, getFileInput: o, addFilesToQueue: n }) {
    const { props: a, emit: l, proxy: i } = (0, $TusQn.getCurrentInstance)(), r = (0, $01W3b.ref)(null), s = (0, $TusQn.computed)(()=>void 0 !== a.accept ? a.accept.split(",").map((e)=>{
            return e = e.trim(), "*" === e ? "*/" : (e.endsWith("/*") && (e = e.slice(0, e.length - 1)), e.toUpperCase());
        }) : null), u = (0, $TusQn.computed)(()=>parseInt(a.maxFiles, 10)), c = (0, $TusQn.computed)(()=>parseInt(a.maxTotalSize, 10));
    function d(t) {
        if (e.value) {
            if (t !== Object(t) && (t = {
                target: null
            }), null !== t.target && !0 === t.target.matches('input[type="file"]')) 0 === t.clientX && 0 === t.clientY && $ec2fc4c0d7a3c6c6$var$stop(t);
            else {
                const e = o();
                e && e !== t.target && e.click(t);
            }
        }
    }
    function p(t) {
        e.value && t && n(null, t);
    }
    function v(e, t, o, n) {
        let i = Array.from(t || e.target.files);
        const r = [], d = ()=>{
            0 !== r.length && l("rejected", r);
        };
        if (void 0 !== a.accept && -1 === s.value.indexOf("*/") && (i = $ec2fc4c0d7a3c6c6$var$filterFiles(i, r, "accept", (e)=>{
            return s.value.some((t)=>e.type.toUpperCase().startsWith(t) || e.name.toUpperCase().endsWith(t));
        }), 0 === i.length)) return d();
        if (void 0 !== a.maxFileSize) {
            const e = parseInt(a.maxFileSize, 10);
            if (i = $ec2fc4c0d7a3c6c6$var$filterFiles(i, r, "max-file-size", (t)=>{
                return t.size <= e;
            }), 0 === i.length) return d();
        }
        if (!0 !== a.multiple && 0 !== i.length && (i = [
            i[0]
        ]), i.forEach((e)=>{
            e.__key = e.webkitRelativePath + e.lastModified + e.name + e.size;
        }), !0 === n) {
            const e = o.map((e)=>e.__key);
            i = $ec2fc4c0d7a3c6c6$var$filterFiles(i, r, "duplicate", (t)=>{
                return !1 === e.includes(t.__key);
            });
        }
        if (0 === i.length) return d();
        if (void 0 !== a.maxTotalSize) {
            let e = !0 === n ? o.reduce((e, t)=>e + t.size, 0) : 0;
            if (i = $ec2fc4c0d7a3c6c6$var$filterFiles(i, r, "max-total-size", (t)=>{
                return e += t.size, e <= c.value;
            }), 0 === i.length) return d();
        }
        if ("function" === typeof a.filter) {
            const e = a.filter(i);
            i = $ec2fc4c0d7a3c6c6$var$filterFiles(i, r, "filter", (t)=>{
                return e.includes(t);
            });
        }
        if (void 0 !== a.maxFiles) {
            let e = !0 === n ? o.length : 0;
            if (i = $ec2fc4c0d7a3c6c6$var$filterFiles(i, r, "max-files", ()=>{
                return e++, e <= u.value;
            }), 0 === i.length) return d();
        }
        return d(), 0 !== i.length ? i : void 0;
    }
    function m(e) {
        $ec2fc4c0d7a3c6c6$var$stopAndPreventDrag(e), !0 !== t.value && (t.value = !0);
    }
    function f(e) {
        $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
        const o = null !== e.relatedTarget || !0 !== $ec2fc4c0d7a3c6c6$var$client.is.safari ? e.relatedTarget !== r.value : !1 === document.elementsFromPoint(e.clientX, e.clientY).includes(r.value);
        !0 === o && (t.value = !1);
    }
    function g(e) {
        $ec2fc4c0d7a3c6c6$var$stopAndPreventDrag(e);
        const o = e.dataTransfer.files;
        0 !== o.length && n(null, o), t.value = !1;
    }
    function b(e) {
        if (!0 === t.value) return (0, $TusQn.h)("div", {
            ref: r,
            class: `q-${e}__dnd absolute-full`,
            onDragenter: $ec2fc4c0d7a3c6c6$var$stopAndPreventDrag,
            onDragover: $ec2fc4c0d7a3c6c6$var$stopAndPreventDrag,
            onDragleave: f,
            onDrop: g
        });
    }
    return Object.assign(i, {
        pickFiles: d,
        addFiles: p
    }), {
        pickFiles: d,
        addFiles: p,
        onDragover: m,
        onDragleave: f,
        processFiles: v,
        getDndNode: b,
        maxFilesNumber: u,
        maxTotalSizeNumber: c
    };
}
function $ec2fc4c0d7a3c6c6$var$useFileFormDomProps(e, t) {
    function o() {
        const t = e.modelValue;
        try {
            const e = "DataTransfer" in window ? new DataTransfer : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
            return Object(t) === t && ("length" in t ? Array.from(t) : [
                t
            ]).forEach((t)=>{
                e.items.add(t);
            }), {
                files: e.files
            };
        } catch (e) {
            return {
                files: void 0
            };
        }
    }
    return (0, $TusQn.computed)(!0 === t ? ()=>{
        if ("file" === e.type) return o();
    } : o);
}
var $ec2fc4c0d7a3c6c6$export$f9762928c84dca74 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QFile",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useFieldProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        ...$ec2fc4c0d7a3c6c6$var$useFileProps,
        modelValue: [
            File,
            FileList,
            Array
        ],
        append: Boolean,
        useChips: Boolean,
        displayValue: [
            String,
            Number
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        counterLabel: Function,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useFieldEmits,
        ...$ec2fc4c0d7a3c6c6$var$useFileEmits
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        const { proxy: a } = (0, $TusQn.getCurrentInstance)(), l = $ec2fc4c0d7a3c6c6$var$useFieldState(), i = (0, $01W3b.ref)(null), r = (0, $01W3b.ref)(!1), s = $ec2fc4c0d7a3c6c6$var$useFormInputNameAttr(e), { pickFiles: u, onDragover: c, onDragleave: d, processFiles: p, getDndNode: v } = $ec2fc4c0d7a3c6c6$var$useFile({
            editable: l.editable,
            dnd: r,
            getFileInput: $,
            addFilesToQueue: M
        }), m = $ec2fc4c0d7a3c6c6$var$useFileFormDomProps(e), f = (0, $TusQn.computed)(()=>Object(e.modelValue) === e.modelValue ? "length" in e.modelValue ? Array.from(e.modelValue) : [
                e.modelValue
            ] : []), g = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(f.value)), b = (0, $TusQn.computed)(()=>f.value.map((e)=>e.name).join(", ")), y = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$humanStorageSize(f.value.reduce((e, t)=>e + t.size, 0))), S = (0, $TusQn.computed)(()=>({
                totalSize: y.value,
                filesNumber: f.value.length,
                maxFiles: e.maxFiles
            })), w = (0, $TusQn.computed)(()=>({
                tabindex: -1,
                type: "file",
                title: "",
                accept: e.accept,
                capture: e.capture,
                name: s.value,
                ...n,
                id: l.targetUid.value,
                disabled: !0 !== l.editable.value
            })), C = (0, $TusQn.computed)(()=>"q-file q-field--auto-height" + (!0 === r.value ? " q-file--dnd" : "")), x = (0, $TusQn.computed)(()=>!0 === e.multiple && !0 === e.append);
        function k(e) {
            const t = f.value.slice();
            t.splice(e, 1), q(t);
        }
        function _(e) {
            const t = f.value.indexOf(e);
            t > -1 && k(t);
        }
        function q(t) {
            o("update:modelValue", !0 === e.multiple ? t : t[0]);
        }
        function T(e) {
            13 === e.keyCode && $ec2fc4c0d7a3c6c6$var$prevent(e);
        }
        function P(e) {
            13 !== e.keyCode && 32 !== e.keyCode || u(e);
        }
        function $() {
            return i.value;
        }
        function M(t, o) {
            const n = p(t, o, f.value, x.value), a = $();
            void 0 !== a && null !== a && (a.value = ""), void 0 !== n && ((!0 === e.multiple ? e.modelValue && n.every((e)=>f.value.includes(e)) : e.modelValue === n[0]) || q(!0 === x.value ? f.value.concat(n) : n));
        }
        function B() {
            return [
                (0, $TusQn.h)("input", {
                    class: [
                        e.inputClass,
                        "q-file__filler"
                    ],
                    style: e.inputStyle
                })
            ];
        }
        function E() {
            if (void 0 !== t.file) return 0 === f.value.length ? B() : f.value.map((e, o)=>t.file({
                    index: o,
                    file: e,
                    ref: this
                }));
            if (void 0 !== t.selected) return 0 === f.value.length ? B() : t.selected({
                files: f.value,
                ref: this
            });
            if (!0 === e.useChips) return 0 === f.value.length ? B() : f.value.map((t, o)=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$fe8abce8a0a972d6, {
                    key: "file-" + o,
                    removable: l.editable.value,
                    dense: !0,
                    textColor: e.color,
                    tabindex: e.tabindex,
                    onRemove: ()=>{
                        k(o);
                    }
                }, ()=>(0, $TusQn.h)("span", {
                        class: "ellipsis",
                        textContent: t.name
                    })));
            const o = void 0 !== e.displayValue ? e.displayValue : b.value;
            return 0 !== o.length ? [
                (0, $TusQn.h)("div", {
                    class: e.inputClass,
                    style: e.inputStyle,
                    textContent: o
                })
            ] : B();
        }
        function Q() {
            const t = {
                ref: i,
                ...w.value,
                ...m.value,
                class: "q-field__input fit absolute-full cursor-pointer",
                onChange: M
            };
            return !0 === e.multiple && (t.multiple = !0), (0, $TusQn.h)("input", t);
        }
        return Object.assign(l, {
            fieldClass: C,
            emitValue: q,
            hasValue: g,
            inputRef: i,
            innerValue: f,
            floatingLabel: (0, $TusQn.computed)(()=>!0 === g.value || $ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(e.displayValue)),
            computedCounter: (0, $TusQn.computed)(()=>{
                if (void 0 !== e.counterLabel) return e.counterLabel(S.value);
                const t = e.maxFiles;
                return `${f.value.length}${void 0 !== t ? " / " + t : ""} (${y.value})`;
            }),
            getControlChild: ()=>v("file"),
            getControl: ()=>{
                const t = {
                    ref: l.targetRef,
                    class: "q-field__native row items-center cursor-pointer",
                    tabindex: e.tabindex
                };
                return !0 === l.editable.value && Object.assign(t, {
                    onDragover: c,
                    onDragleave: d,
                    onKeydown: T,
                    onKeyup: P
                }), (0, $TusQn.h)("div", t, [
                    Q()
                ].concat(E()));
            }
        }), Object.assign(a, {
            removeAtIndex: k,
            removeFile: _,
            getNativeElement: ()=>i.value
        }), $ec2fc4c0d7a3c6c6$var$injectProp(a, "nativeEl", ()=>i.value), $ec2fc4c0d7a3c6c6$var$useField(l);
    }
}), $ec2fc4c0d7a3c6c6$export$bf2298245c72b04b = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QFooter",
    props: {
        modelValue: {
            type: Boolean,
            default: !0
        },
        reveal: Boolean,
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$layoutKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (a === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QFooter needs to be child of QLayout"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        const l = (0, $01W3b.ref)(parseInt(e.heightHint, 10)), i = (0, $01W3b.ref)(!0), r = (0, $01W3b.ref)(!0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value || !0 === a.isContainer.value ? 0 : window.innerHeight), s = (0, $TusQn.computed)(()=>!0 === e.reveal || a.view.value.indexOf("F") > -1 || n.platform.is.ios && !0 === a.isContainer.value), u = (0, $TusQn.computed)(()=>!0 === a.isContainer.value ? a.containerHeight.value : r.value), c = (0, $TusQn.computed)(()=>{
            if (!0 !== e.modelValue) return 0;
            if (!0 === s.value) return !0 === i.value ? l.value : 0;
            const t = a.scroll.value.position + u.value + l.value - a.height.value;
            return t > 0 ? t : 0;
        }), d = (0, $TusQn.computed)(()=>!0 !== e.modelValue || !0 === s.value && !0 !== i.value), p = (0, $TusQn.computed)(()=>!0 === e.modelValue && !0 === d.value && !0 === e.reveal), v = (0, $TusQn.computed)(()=>"q-footer q-layout__section--marginal " + (!0 === s.value ? "fixed" : "absolute") + "-bottom" + (!0 === e.bordered ? " q-footer--bordered" : "") + (!0 === d.value ? " q-footer--hidden" : "") + (!0 !== e.modelValue ? " q-layout--prevent-focus" + (!0 !== s.value ? " hidden" : "") : "")), m = (0, $TusQn.computed)(()=>{
            const e = a.rows.value.bottom, t = {};
            return "l" === e[0] && !0 === a.left.space && (t[!0 === n.lang.rtl ? "right" : "left"] = `${a.left.size}px`), "r" === e[2] && !0 === a.right.space && (t[!0 === n.lang.rtl ? "left" : "right"] = `${a.right.size}px`), t;
        });
        function f(e, t) {
            a.update("footer", e, t);
        }
        function g(e, t) {
            e.value !== t && (e.value = t);
        }
        function b({ height: e }) {
            g(l, e), f("size", e);
        }
        function y() {
            if (!0 !== e.reveal) return;
            const { direction: t, position: o, inflectionPoint: n } = a.scroll.value;
            g(i, "up" === t || o - n < 100 || a.height.value - u.value - o - l.value < 300);
        }
        function S(e) {
            !0 === p.value && g(i, !0), o("focusin", e);
        }
        (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            f("space", e), g(i, !0), a.animate();
        }), (0, $TusQn.watch)(c, (e)=>{
            f("offset", e);
        }), (0, $TusQn.watch)(()=>e.reveal, (t)=>{
            !1 === t && g(i, e.modelValue);
        }), (0, $TusQn.watch)(i, (e)=>{
            a.animate(), o("reveal", e);
        }), (0, $TusQn.watch)([
            l,
            a.scroll,
            a.height
        ], y), (0, $TusQn.watch)(()=>n.screen.height, (e)=>{
            !0 !== a.isContainer.value && g(r, e);
        });
        const w = {};
        return a.instances.footer = w, !0 === e.modelValue && f("size", l.value), f("space", e.modelValue), f("offset", c.value), (0, $TusQn.onBeforeUnmount)(()=>{
            a.instances.footer === w && (a.instances.footer = void 0, f("size", 0), f("offset", 0), f("space", !1));
        }), ()=>{
            const o = $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                    debounce: 0,
                    onResize: b
                })
            ]);
            return !0 === e.elevated && o.push((0, $TusQn.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), (0, $TusQn.h)("footer", {
                class: v.value,
                style: m.value,
                onFocusin: S
            }, o);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$1f74a2a6ec5f7e27 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QForm",
    props: {
        autofocus: Boolean,
        noErrorFocus: Boolean,
        noResetFocus: Boolean,
        greedy: Boolean,
        onSubmit: Function
    },
    emits: [
        "reset",
        "validationSuccess",
        "validationError"
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $TusQn.getCurrentInstance)(), a = (0, $01W3b.ref)(null);
        let l = 0;
        const i = [];
        function r(t) {
            const n = "boolean" === typeof t ? t : !0 !== e.noErrorFocus, a = ++l, r = (e, t)=>{
                o("validation" + (!0 === e ? "Success" : "Error"), t);
            }, s = (e)=>{
                const t = e.validate();
                return "function" === typeof t.then ? t.then((t)=>({
                        valid: t,
                        comp: e
                    }), (t)=>({
                        valid: !1,
                        comp: e,
                        err: t
                    })) : Promise.resolve({
                    valid: t,
                    comp: e
                });
            }, u = !0 === e.greedy ? Promise.all(i.map(s)).then((e)=>e.filter((e)=>!0 !== e.valid)) : i.reduce((e, t)=>e.then(()=>{
                    return s(t).then((e)=>{
                        if (!1 === e.valid) return Promise.reject(e);
                    });
                }), Promise.resolve()).catch((e)=>[
                    e
                ]);
            return u.then((e)=>{
                if (void 0 === e || 0 === e.length) return a === l && r(!0), !0;
                if (a === l) {
                    const { comp: t, err: o } = e[0];
                    if (void 0 !== o && console.error(o), r(!1, t), !0 === n) {
                        const t = e.find(({ comp: e })=>"function" === typeof e.focus && !1 === $ec2fc4c0d7a3c6c6$var$vmIsDestroyed(e.$));
                        void 0 !== t && t.comp.focus();
                    }
                }
                return !1;
            });
        }
        function s() {
            l++, i.forEach((e)=>{
                "function" === typeof e.resetValidation && e.resetValidation();
            });
        }
        function u(t) {
            void 0 !== t && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t);
            const n = l + 1;
            r().then((a)=>{
                n === l && !0 === a && (void 0 !== e.onSubmit ? o("submit", t) : void 0 !== t && void 0 !== t.target && "function" === typeof t.target.submit && t.target.submit());
            });
        }
        function c(t) {
            void 0 !== t && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), o("reset"), (0, $TusQn.nextTick)(()=>{
                s(), !0 === e.autofocus && !0 !== e.noResetFocus && d();
            });
        }
        function d() {
            $ec2fc4c0d7a3c6c6$var$addFocusFn(()=>{
                if (null === a.value) return;
                const e = a.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || a.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || a.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(a.value.querySelectorAll("[tabindex]"), (e)=>e.tabIndex > -1);
                null !== e && void 0 !== e && e.focus({
                    preventScroll: !0
                });
            });
        }
        (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$formKey, {
            bindComponent (e) {
                i.push(e);
            },
            unbindComponent (e) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
        let p = !1;
        return (0, $TusQn.onDeactivated)(()=>{
            p = !0;
        }), (0, $TusQn.onActivated)(()=>{
            !0 === p && !0 === e.autofocus && d();
        }), (0, $TusQn.onMounted)(()=>{
            !0 === e.autofocus && d();
        }), Object.assign(n.proxy, {
            validate: r,
            resetValidation: s,
            submit: u,
            reset: c,
            focus: d,
            getValidationComponents: ()=>i
        }), ()=>(0, $TusQn.h)("form", {
                class: "q-form",
                ref: a,
                onSubmit: u,
                onReset: c
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$4c671bf544af0ee8 = {
    inject: {
        [$ec2fc4c0d7a3c6c6$var$formKey]: {
            default: $ec2fc4c0d7a3c6c6$export$8793edee2d425525
        }
    },
    watch: {
        disable (e) {
            const t = this.$.provides[$ec2fc4c0d7a3c6c6$var$formKey];
            void 0 !== t && (!0 === e ? (this.resetValidation(), t.unbindComponent(this)) : t.bindComponent(this));
        }
    },
    methods: {
        validate () {},
        resetValidation () {}
    },
    mounted () {
        const e = this.$.provides[$ec2fc4c0d7a3c6c6$var$formKey];
        void 0 !== e && !0 !== this.disable && e.bindComponent(this);
    },
    beforeUnmount () {
        const e = this.$.provides[$ec2fc4c0d7a3c6c6$var$formKey];
        void 0 !== e && !0 !== this.disable && e.unbindComponent(this);
    }
}, $ec2fc4c0d7a3c6c6$export$2dcc2a0b89cfff9b = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QHeader",
    props: {
        modelValue: {
            type: Boolean,
            default: !0
        },
        reveal: Boolean,
        revealOffset: {
            type: Number,
            default: 250
        },
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$layoutKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (a === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QHeader needs to be child of QLayout"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        const l = (0, $01W3b.ref)(parseInt(e.heightHint, 10)), i = (0, $01W3b.ref)(!0), r = (0, $TusQn.computed)(()=>!0 === e.reveal || a.view.value.indexOf("H") > -1 || n.platform.is.ios && !0 === a.isContainer.value), s = (0, $TusQn.computed)(()=>{
            if (!0 !== e.modelValue) return 0;
            if (!0 === r.value) return !0 === i.value ? l.value : 0;
            const t = l.value - a.scroll.value.position;
            return t > 0 ? t : 0;
        }), u = (0, $TusQn.computed)(()=>!0 !== e.modelValue || !0 === r.value && !0 !== i.value), c = (0, $TusQn.computed)(()=>!0 === e.modelValue && !0 === u.value && !0 === e.reveal), d = (0, $TusQn.computed)(()=>"q-header q-layout__section--marginal " + (!0 === r.value ? "fixed" : "absolute") + "-top" + (!0 === e.bordered ? " q-header--bordered" : "") + (!0 === u.value ? " q-header--hidden" : "") + (!0 !== e.modelValue ? " q-layout--prevent-focus" : "")), p = (0, $TusQn.computed)(()=>{
            const e = a.rows.value.top, t = {};
            return "l" === e[0] && !0 === a.left.space && (t[!0 === n.lang.rtl ? "right" : "left"] = `${a.left.size}px`), "r" === e[2] && !0 === a.right.space && (t[!0 === n.lang.rtl ? "left" : "right"] = `${a.right.size}px`), t;
        });
        function v(e, t) {
            a.update("header", e, t);
        }
        function m(e, t) {
            e.value !== t && (e.value = t);
        }
        function f({ height: e }) {
            m(l, e), v("size", e);
        }
        function g(e) {
            !0 === c.value && m(i, !0), o("focusin", e);
        }
        (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            v("space", e), m(i, !0), a.animate();
        }), (0, $TusQn.watch)(s, (e)=>{
            v("offset", e);
        }), (0, $TusQn.watch)(()=>e.reveal, (t)=>{
            !1 === t && m(i, e.modelValue);
        }), (0, $TusQn.watch)(i, (e)=>{
            a.animate(), o("reveal", e);
        }), (0, $TusQn.watch)(a.scroll, (t)=>{
            !0 === e.reveal && m(i, "up" === t.direction || t.position <= e.revealOffset || t.position - t.inflectionPoint < 100);
        });
        const b = {};
        return a.instances.header = b, !0 === e.modelValue && v("size", l.value), v("space", e.modelValue), v("offset", s.value), (0, $TusQn.onBeforeUnmount)(()=>{
            a.instances.header === b && (a.instances.header = void 0, v("size", 0), v("offset", 0), v("space", !1));
        }), ()=>{
            const o = $ec2fc4c0d7a3c6c6$var$hUniqueSlot(t.default, []);
            return !0 === e.elevated && o.push((0, $TusQn.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                debounce: 0,
                onResize: f
            })), (0, $TusQn.h)("header", {
                class: d.value,
                style: p.value,
                onFocusin: g
            }, o);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$useRatioProps = {
    ratio: [
        String,
        Number
    ]
};
function $ec2fc4c0d7a3c6c6$var$useRatio(e, t) {
    return (0, $TusQn.computed)(()=>{
        const o = Number(e.ratio || (void 0 !== t ? t.value : void 0));
        return !0 !== isNaN(o) && o > 0 ? {
            paddingBottom: `${100 / o}%`
        } : null;
    });
}
const $ec2fc4c0d7a3c6c6$var$defaultRatio = 16 / 9;
var $ec2fc4c0d7a3c6c6$export$b76c0105a5546ea6 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QImg",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useRatioProps,
        src: String,
        srcset: String,
        sizes: String,
        alt: String,
        crossorigin: String,
        decoding: String,
        referrerpolicy: String,
        draggable: Boolean,
        loading: {
            type: String,
            default: "lazy"
        },
        fetchpriority: {
            type: String,
            default: "auto"
        },
        width: String,
        height: String,
        initialRatio: {
            type: [
                Number,
                String
            ],
            default: $ec2fc4c0d7a3c6c6$var$defaultRatio
        },
        placeholderSrc: String,
        fit: {
            type: String,
            default: "cover"
        },
        position: {
            type: String,
            default: "50% 50%"
        },
        imgClass: String,
        imgStyle: Object,
        noSpinner: Boolean,
        noNativeMenu: Boolean,
        noTransition: Boolean,
        spinnerColor: String,
        spinnerSize: String
    },
    emits: [
        "load",
        "error"
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $01W3b.ref)(e.initialRatio), a = $ec2fc4c0d7a3c6c6$var$useRatio(e, n);
        let l = null, i = !1;
        const r = [
            (0, $01W3b.ref)(null),
            (0, $01W3b.ref)(g())
        ], s = (0, $01W3b.ref)(0), u = (0, $01W3b.ref)(!1), c = (0, $01W3b.ref)(!1), d = (0, $TusQn.computed)(()=>`q-img q-img--${!0 === e.noNativeMenu ? "no-" : ""}menu`), p = (0, $TusQn.computed)(()=>({
                width: e.width,
                height: e.height
            })), v = (0, $TusQn.computed)(()=>`q-img__image ${void 0 !== e.imgClass ? e.imgClass + " " : ""}` + `q-img__image--with${!0 === e.noTransition ? "out" : ""}-transition`), m = (0, $TusQn.computed)(()=>({
                ...e.imgStyle,
                objectFit: e.fit,
                objectPosition: e.position
            }));
        function f() {
            return e.src || e.srcset || e.sizes ? {
                src: e.src,
                srcset: e.srcset,
                sizes: e.sizes
            } : null;
        }
        function g() {
            return void 0 !== e.placeholderSrc ? {
                src: e.placeholderSrc
            } : null;
        }
        function b(e) {
            null !== l && (clearTimeout(l), l = null), c.value = !1, null === e ? (u.value = !1, r[1 ^ s.value].value = g()) : u.value = !0, r[s.value].value = e;
        }
        function y({ target: e }) {
            !0 !== i && (null !== l && (clearTimeout(l), l = null), n.value = 0 === e.naturalHeight ? .5 : e.naturalWidth / e.naturalHeight, S(e, 1));
        }
        function S(e, t) {
            !0 !== i && 1e3 !== t && (!0 === e.complete ? w(e) : l = setTimeout(()=>{
                l = null, S(e, t + 1);
            }, 50));
        }
        function w(e) {
            !0 !== i && (s.value = 1 ^ s.value, r[s.value].value = null, u.value = !1, c.value = !1, o("load", e.currentSrc || e.src));
        }
        function C(e) {
            null !== l && (clearTimeout(l), l = null), u.value = !1, c.value = !0, r[s.value].value = null, r[1 ^ s.value].value = g(), o("error", e);
        }
        function x(t) {
            const o = r[t].value, n = {
                key: "img_" + t,
                class: v.value,
                style: m.value,
                crossorigin: e.crossorigin,
                decoding: e.decoding,
                referrerpolicy: e.referrerpolicy,
                height: e.height,
                width: e.width,
                loading: e.loading,
                fetchpriority: e.fetchpriority,
                "aria-hidden": "true",
                draggable: e.draggable,
                ...o
            };
            return s.value === t ? (n.class += " q-img__image--waiting", Object.assign(n, {
                onLoad: y,
                onError: C
            })) : n.class += " q-img__image--loaded", (0, $TusQn.h)("div", {
                class: "q-img__container absolute-full",
                key: "img" + t
            }, (0, $TusQn.h)("img", n));
        }
        function k() {
            return !0 !== u.value ? (0, $TusQn.h)("div", {
                key: "content",
                class: "q-img__content absolute-full q-anchor--skip"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t[!0 === c.value ? "error" : "default"])) : (0, $TusQn.h)("div", {
                key: "loading",
                class: "q-img__loading absolute-full flex flex-center"
            }, void 0 !== t.loading ? t.loading() : !0 === e.noSpinner ? void 0 : [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0, {
                    color: e.spinnerColor,
                    size: e.spinnerSize
                })
            ]);
        }
        return (0, $TusQn.watch)(()=>f(), b), b(f()), (0, $TusQn.onBeforeUnmount)(()=>{
            i = !0, null !== l && (clearTimeout(l), l = null);
        }), ()=>{
            const t = [];
            return null !== a.value && t.push((0, $TusQn.h)("div", {
                key: "filler",
                style: a.value
            })), !0 !== c.value && (null !== r[0].value && t.push(x(0)), null !== r[1].value && t.push(x(1))), t.push((0, $TusQn.h)((0, $eeJ70.Transition), {
                name: "q-transition--fade"
            }, k)), (0, $TusQn.h)("div", {
                class: d.value,
                style: p.value,
                role: "img",
                "aria-label": e.alt
            }, t);
        };
    }
});
const { passive: $ec2fc4c0d7a3c6c6$var$passive$3 } = $ec2fc4c0d7a3c6c6$var$listenOpts;
var $ec2fc4c0d7a3c6c6$export$cc6e9b131bede082 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QInfiniteScroll",
    props: {
        offset: {
            type: Number,
            default: 500
        },
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        },
        scrollTarget: {
            default: void 0
        },
        initialIndex: Number,
        disable: Boolean,
        reverse: Boolean
    },
    emits: [
        "load"
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $01W3b.ref)(!1), a = (0, $01W3b.ref)(!0), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(null);
        let r, s, u = e.initialIndex || 0;
        const c = (0, $TusQn.computed)(()=>"q-infinite-scroll__loading" + (!0 === n.value ? "" : " invisible"));
        function d() {
            if (!0 === e.disable || !0 === n.value || !1 === a.value) return;
            const t = $ec2fc4c0d7a3c6c6$var$getScrollHeight(r), o = $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(r), l = $ec2fc4c0d7a3c6c6$var$height(r);
            !1 === e.reverse ? Math.round(o + l + e.offset) >= Math.round(t) && p() : Math.round(o) <= e.offset && p();
        }
        function p() {
            if (!0 === e.disable || !0 === n.value || !1 === a.value) return;
            u++, n.value = !0;
            const t = $ec2fc4c0d7a3c6c6$var$getScrollHeight(r);
            o("load", u, (o)=>{
                !0 === a.value && (n.value = !1, (0, $TusQn.nextTick)(()=>{
                    if (!0 === e.reverse) {
                        const e = $ec2fc4c0d7a3c6c6$var$getScrollHeight(r), o = $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(r), n = e - t;
                        $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition(r, o + n);
                    }
                    !0 === o ? f() : l.value && l.value.closest("body") && s();
                }));
            });
        }
        function v() {
            u = 0;
        }
        function m() {
            !1 === a.value && (a.value = !0, r.addEventListener("scroll", s, $ec2fc4c0d7a3c6c6$var$passive$3)), d();
        }
        function f() {
            !0 === a.value && (a.value = !1, n.value = !1, r.removeEventListener("scroll", s, $ec2fc4c0d7a3c6c6$var$passive$3), void 0 !== s && void 0 !== s.cancel && s.cancel());
        }
        function g() {
            if (r && !0 === a.value && r.removeEventListener("scroll", s, $ec2fc4c0d7a3c6c6$var$passive$3), r = $ec2fc4c0d7a3c6c6$var$getScrollTarget(l.value, e.scrollTarget), !0 === a.value) {
                if (r.addEventListener("scroll", s, $ec2fc4c0d7a3c6c6$var$passive$3), !0 === e.reverse) {
                    const e = $ec2fc4c0d7a3c6c6$var$getScrollHeight(r), t = $ec2fc4c0d7a3c6c6$var$height(r);
                    $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition(r, e - t);
                }
                d();
            }
        }
        function b(e) {
            u = e;
        }
        function y(e) {
            e = parseInt(e, 10);
            const t = s;
            s = e <= 0 ? d : $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(d, !0 === isNaN(e) ? 100 : e), r && !0 === a.value && (void 0 !== t && r.removeEventListener("scroll", t, $ec2fc4c0d7a3c6c6$var$passive$3), r.addEventListener("scroll", s, $ec2fc4c0d7a3c6c6$var$passive$3));
        }
        function S(e) {
            if (!0 === w.value) {
                if (null === i.value) return void (!0 !== e && (0, $TusQn.nextTick)(()=>{
                    S(!0);
                }));
                const t = `${!0 === n.value ? "un" : ""}pauseAnimations`;
                Array.from(i.value.getElementsByTagName("svg")).forEach((e)=>{
                    e[t]();
                });
            }
        }
        const w = (0, $TusQn.computed)(()=>!0 !== e.disable && !0 === a.value);
        (0, $TusQn.watch)([
            n,
            w
        ], ()=>{
            S();
        }), (0, $TusQn.watch)(()=>e.disable, (e)=>{
            !0 === e ? f() : m();
        }), (0, $TusQn.watch)(()=>e.reverse, ()=>{
            !1 === n.value && !0 === a.value && d();
        }), (0, $TusQn.watch)(()=>e.scrollTarget, g), (0, $TusQn.watch)(()=>e.debounce, y);
        let C = !1;
        (0, $TusQn.onActivated)(()=>{
            !1 !== C && r && $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition(r, C);
        }), (0, $TusQn.onDeactivated)(()=>{
            C = !!r && $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(r);
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            !0 === a.value && r.removeEventListener("scroll", s, $ec2fc4c0d7a3c6c6$var$passive$3);
        }), (0, $TusQn.onMounted)(()=>{
            y(e.debounce), g(), !1 === n.value && S();
        });
        const x = (0, $TusQn.getCurrentInstance)();
        return Object.assign(x.proxy, {
            poll: ()=>{
                void 0 !== s && s();
            },
            trigger: p,
            stop: f,
            reset: v,
            resume: m,
            setIndex: b
        }), ()=>{
            const o = $ec2fc4c0d7a3c6c6$var$hUniqueSlot(t.default, []);
            return !0 === w.value && o[!1 === e.reverse ? "push" : "unshift"]((0, $TusQn.h)("div", {
                ref: i,
                class: c.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.loading))), (0, $TusQn.h)("div", {
                class: "q-infinite-scroll",
                ref: l
            }, o);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$d3667a9435d68192 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QInnerLoading",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useTransitionProps,
        showing: Boolean,
        color: String,
        size: {
            type: [
                String,
                Number
            ],
            default: 42
        },
        label: String,
        labelClass: String,
        labelStyle: [
            String,
            Array,
            Object
        ]
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q), { transitionProps: a, transitionStyle: l } = $ec2fc4c0d7a3c6c6$var$useTransition(e), i = (0, $TusQn.computed)(()=>"q-inner-loading absolute-full column flex-center" + (!0 === n.value ? " q-inner-loading--dark" : "")), r = (0, $TusQn.computed)(()=>"q-inner-loading__label" + (void 0 !== e.labelClass ? ` ${e.labelClass}` : ""));
        function s() {
            const t = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0, {
                    size: e.size,
                    color: e.color
                })
            ];
            return void 0 !== e.label && t.push((0, $TusQn.h)("div", {
                class: r.value,
                style: e.labelStyle
            }, [
                e.label
            ])), t;
        }
        function u() {
            return !0 === e.showing ? (0, $TusQn.h)("div", {
                class: i.value,
                style: l.value
            }, void 0 !== t.default ? t.default() : s()) : null;
        }
        return ()=>(0, $TusQn.h)((0, $eeJ70.Transition), a.value, u);
    }
});
const $ec2fc4c0d7a3c6c6$var$NAMED_MASKS = {
    date: "####/##/##",
    datetime: "####/##/## ##:##",
    time: "##:##",
    fulltime: "##:##:##",
    phone: "(###) ### - ####",
    card: "#### #### #### ####"
}, $ec2fc4c0d7a3c6c6$var$TOKENS = {
    "#": {
        pattern: "[\\d]",
        negate: "[^\\d]"
    },
    S: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]"
    },
    N: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]"
    },
    A: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: (e)=>e.toLocaleUpperCase()
    },
    a: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: (e)=>e.toLocaleLowerCase()
    },
    X: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: (e)=>e.toLocaleUpperCase()
    },
    x: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: (e)=>e.toLocaleLowerCase()
    }
}, $ec2fc4c0d7a3c6c6$var$KEYS = Object.keys($ec2fc4c0d7a3c6c6$var$TOKENS);
$ec2fc4c0d7a3c6c6$var$KEYS.forEach((e)=>{
    $ec2fc4c0d7a3c6c6$var$TOKENS[e].regex = new RegExp($ec2fc4c0d7a3c6c6$var$TOKENS[e].pattern);
});
const $ec2fc4c0d7a3c6c6$var$tokenRegexMask = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + $ec2fc4c0d7a3c6c6$var$KEYS.join("") + "])|(.)", "g"), $ec2fc4c0d7a3c6c6$var$escRegex = /[.*+?^${}()|[\]\\]/g, $ec2fc4c0d7a3c6c6$var$MARKER = String.fromCharCode(1), $ec2fc4c0d7a3c6c6$var$useMaskProps = {
    mask: String,
    reverseFillMask: Boolean,
    fillMask: [
        Boolean,
        String
    ],
    unmaskedValue: Boolean
};
function $ec2fc4c0d7a3c6c6$var$useMask(e, t, o, n) {
    let a, l, i, r, s, u;
    const c = (0, $01W3b.ref)(null), d = (0, $01W3b.ref)(v());
    function p() {
        return !0 === e.autogrow || [
            "textarea",
            "text",
            "search",
            "url",
            "tel",
            "password"
        ].includes(e.type);
    }
    function v() {
        if (f(), !0 === c.value) {
            const t = w(x(e.modelValue));
            return !1 !== e.fillMask ? k(t) : t;
        }
        return e.modelValue;
    }
    function m(e) {
        if (e < a.length) return a.slice(-e);
        let t = "", o = a;
        const n = o.indexOf($ec2fc4c0d7a3c6c6$var$MARKER);
        if (n > -1) {
            for(let n = e - o.length; n > 0; n--)t += $ec2fc4c0d7a3c6c6$var$MARKER;
            o = o.slice(0, n) + t + o.slice(n);
        }
        return o;
    }
    function f() {
        if (c.value = void 0 !== e.mask && 0 !== e.mask.length && p(), !1 === c.value) return r = void 0, a = "", void (l = "");
        const t = void 0 === $ec2fc4c0d7a3c6c6$var$NAMED_MASKS[e.mask] ? e.mask : $ec2fc4c0d7a3c6c6$var$NAMED_MASKS[e.mask], o = "string" === typeof e.fillMask && 0 !== e.fillMask.length ? e.fillMask.slice(0, 1) : "_", n = o.replace($ec2fc4c0d7a3c6c6$var$escRegex, "\\$&"), s = [], u = [], d = [];
        let v = !0 === e.reverseFillMask, m = "", f = "";
        t.replace($ec2fc4c0d7a3c6c6$var$tokenRegexMask, (e, t, o, n, a)=>{
            if (void 0 !== n) {
                const e = $ec2fc4c0d7a3c6c6$var$TOKENS[n];
                d.push(e), f = e.negate, !0 === v && (u.push("(?:" + f + "+)?(" + e.pattern + "+)?(?:" + f + "+)?(" + e.pattern + "+)?"), v = !1), u.push("(?:" + f + "+)?(" + e.pattern + ")?");
            } else if (void 0 !== o) m = "\\" + ("\\" === o ? "" : o), d.push(o), s.push("([^" + m + "]+)?" + m + "?");
            else {
                const e = void 0 !== t ? t : a;
                m = "\\" === e ? "\\\\\\\\" : e.replace($ec2fc4c0d7a3c6c6$var$escRegex, "\\\\$&"), d.push(e), s.push("([^" + m + "]+)?" + m + "?");
            }
        });
        const h = new RegExp("^" + s.join("") + "(" + ("" === m ? "." : "[^" + m + "]") + "+)?" + ("" === m ? "" : "[" + m + "]*") + "$"), g = u.length - 1, b = u.map((t, o)=>{
            return 0 === o && !0 === e.reverseFillMask ? new RegExp("^" + n + "*" + t) : o === g ? new RegExp("^" + t + "(" + ("" === f ? "." : f) + "+)?" + (!0 === e.reverseFillMask ? "$" : n + "*")) : new RegExp("^" + t);
        });
        i = d, r = (t)=>{
            const o = h.exec(!0 === e.reverseFillMask ? t : t.slice(0, d.length + 1));
            null !== o && (t = o.slice(1).join(""));
            const n = [], a = b.length;
            for(let e = 0, l = t; e < a; e++){
                const t = b[e].exec(l);
                if (null === t) break;
                l = l.slice(t.shift().length), n.push(...t);
            }
            return 0 !== n.length ? n.join("") : t;
        }, a = d.map((e)=>"string" === typeof e ? e : $ec2fc4c0d7a3c6c6$var$MARKER).join(""), l = a.split($ec2fc4c0d7a3c6c6$var$MARKER).join(o);
    }
    function h(t, i, r) {
        const u = n.value, c = u.selectionEnd, p = u.value.length - c, v = x(t);
        !0 === i && f();
        const m = w(v), h = !1 !== e.fillMask ? k(m) : m, g = d.value !== h;
        u.value !== h && (u.value = h), !0 === g && (d.value = h), document.activeElement === u && (0, $TusQn.nextTick)(()=>{
            if (h !== l) {
                if ("insertFromPaste" !== r || !0 === e.reverseFillMask) {
                    if ([
                        "deleteContentBackward",
                        "deleteContentForward"
                    ].indexOf(r) > -1) {
                        const t = !0 === e.reverseFillMask ? 0 === c ? h.length > m.length ? 1 : 0 : Math.max(0, h.length - (h === l ? 0 : Math.min(m.length, p) + 1)) + 1 : c;
                        u.setSelectionRange(t, t, "forward");
                    } else if (!0 === e.reverseFillMask) {
                        if (!0 === g) {
                            const e = Math.max(0, h.length - (h === l ? 0 : Math.min(m.length, p + 1)));
                            1 === e && 1 === c ? u.setSelectionRange(e, e, "forward") : b.rightReverse(u, e);
                        } else {
                            const e = h.length - p;
                            u.setSelectionRange(e, e, "backward");
                        }
                    } else if (!0 === g) {
                        const e = Math.max(0, a.indexOf($ec2fc4c0d7a3c6c6$var$MARKER), Math.min(m.length, c) - 1);
                        b.right(u, e);
                    } else {
                        const e = c - 1;
                        b.right(u, e);
                    }
                } else {
                    const e = u.selectionEnd;
                    let t = c - 1;
                    for(let o = s; o <= t && o < e; o++)a[o] !== $ec2fc4c0d7a3c6c6$var$MARKER && t++;
                    b.right(u, t);
                }
            } else {
                const t = !0 === e.reverseFillMask ? l.length : 0;
                u.setSelectionRange(t, t, "forward");
            }
        });
        const y = !0 === e.unmaskedValue ? x(h) : h;
        String(e.modelValue) !== y && o(y, !0);
    }
    function g(e, t, o) {
        const n = w(x(e.value));
        t = Math.max(0, a.indexOf($ec2fc4c0d7a3c6c6$var$MARKER), Math.min(n.length, t)), s = t, e.setSelectionRange(t, o, "forward");
    }
    (0, $TusQn.watch)(()=>e.type + e.autogrow, f), (0, $TusQn.watch)(()=>e.mask, (o)=>{
        if (void 0 !== o) h(d.value, !0);
        else {
            const o = x(d.value);
            f(), e.modelValue !== o && t("update:modelValue", o);
        }
    }), (0, $TusQn.watch)(()=>e.fillMask + e.reverseFillMask, ()=>{
        !0 === c.value && h(d.value, !0);
    }), (0, $TusQn.watch)(()=>e.unmaskedValue, ()=>{
        !0 === c.value && h(d.value);
    });
    const b = {
        left (e, t) {
            const o = -1 === a.slice(t - 1).indexOf($ec2fc4c0d7a3c6c6$var$MARKER);
            let n = Math.max(0, t - 1);
            for(; n >= 0; n--)if (a[n] === $ec2fc4c0d7a3c6c6$var$MARKER) {
                t = n, !0 === o && t++;
                break;
            }
            if (n < 0 && void 0 !== a[t] && a[t] !== $ec2fc4c0d7a3c6c6$var$MARKER) return b.right(e, 0);
            t >= 0 && e.setSelectionRange(t, t, "backward");
        },
        right (e, t) {
            const o = e.value.length;
            let n = Math.min(o, t + 1);
            for(; n <= o; n++){
                if (a[n] === $ec2fc4c0d7a3c6c6$var$MARKER) {
                    t = n;
                    break;
                }
                a[n - 1] === $ec2fc4c0d7a3c6c6$var$MARKER && (t = n);
            }
            if (n > o && void 0 !== a[t - 1] && a[t - 1] !== $ec2fc4c0d7a3c6c6$var$MARKER) return b.left(e, o);
            e.setSelectionRange(t, t, "forward");
        },
        leftReverse (e, t) {
            const o = m(e.value.length);
            let n = Math.max(0, t - 1);
            for(; n >= 0; n--){
                if (o[n - 1] === $ec2fc4c0d7a3c6c6$var$MARKER) {
                    t = n;
                    break;
                }
                if (o[n] === $ec2fc4c0d7a3c6c6$var$MARKER && (t = n, 0 === n)) break;
            }
            if (n < 0 && void 0 !== o[t] && o[t] !== $ec2fc4c0d7a3c6c6$var$MARKER) return b.rightReverse(e, 0);
            t >= 0 && e.setSelectionRange(t, t, "backward");
        },
        rightReverse (e, t) {
            const o = e.value.length, n = m(o), a = -1 === n.slice(0, t + 1).indexOf($ec2fc4c0d7a3c6c6$var$MARKER);
            let l = Math.min(o, t + 1);
            for(; l <= o; l++)if (n[l - 1] === $ec2fc4c0d7a3c6c6$var$MARKER) {
                t = l, t > 0 && !0 === a && t--;
                break;
            }
            if (l > o && void 0 !== n[t - 1] && n[t - 1] !== $ec2fc4c0d7a3c6c6$var$MARKER) return b.leftReverse(e, o);
            e.setSelectionRange(t, t, "forward");
        }
    };
    function y(e) {
        t("click", e), u = void 0;
    }
    function S(o) {
        if (t("keydown", o), !0 === $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(o) || !0 === o.altKey) return;
        const a = n.value, l = a.selectionStart, i = a.selectionEnd;
        if (o.shiftKey || (u = void 0), 37 === o.keyCode || 39 === o.keyCode) {
            o.shiftKey && void 0 === u && (u = "forward" === a.selectionDirection ? l : i);
            const t = b[(39 === o.keyCode ? "right" : "left") + (!0 === e.reverseFillMask ? "Reverse" : "")];
            if (o.preventDefault(), t(a, u === l ? i : l), o.shiftKey) {
                const e = a.selectionStart;
                a.setSelectionRange(Math.min(u, e), Math.max(u, e), "forward");
            }
        } else 8 === o.keyCode && !0 !== e.reverseFillMask && l === i ? (b.left(a, l), a.setSelectionRange(a.selectionStart, i, "backward")) : 46 === o.keyCode && !0 === e.reverseFillMask && l === i && (b.rightReverse(a, i), a.setSelectionRange(l, a.selectionEnd, "forward"));
    }
    function w(t) {
        if (void 0 === t || null === t || "" === t) return "";
        if (!0 === e.reverseFillMask) return C(t);
        const o = i;
        let n = 0, a = "";
        for(let e = 0; e < o.length; e++){
            const l = t[n], i = o[e];
            if ("string" === typeof i) a += i, l === i && n++;
            else {
                if (void 0 === l || !i.regex.test(l)) return a;
                a += void 0 !== i.transform ? i.transform(l) : l, n++;
            }
        }
        return a;
    }
    function C(e) {
        const t = i, o = a.indexOf($ec2fc4c0d7a3c6c6$var$MARKER);
        let n = e.length - 1, l = "";
        for(let a = t.length - 1; a >= 0 && n > -1; a--){
            const i = t[a];
            let r = e[n];
            if ("string" === typeof i) l = i + l, r === i && n--;
            else {
                if (void 0 === r || !i.regex.test(r)) return l;
                do l = (void 0 !== i.transform ? i.transform(r) : r) + l, n--, r = e[n];
                while (o === a && void 0 !== r && i.regex.test(r));
            }
        }
        return l;
    }
    function x(e) {
        return "string" !== typeof e || void 0 === r ? "number" === typeof e ? r("" + e) : e : r(e);
    }
    function k(t) {
        return l.length - t.length <= 0 ? t : !0 === e.reverseFillMask && 0 !== t.length ? l.slice(0, -t.length) + t : t + l.slice(t.length);
    }
    return {
        innerValue: d,
        hasMask: c,
        moveCursorForPaste: g,
        updateMaskValue: h,
        onMaskedKeydown: S,
        onMaskedClick: y
    };
}
const $ec2fc4c0d7a3c6c6$var$isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/, $ec2fc4c0d7a3c6c6$var$isChinese = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u, $ec2fc4c0d7a3c6c6$var$isKorean = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/, $ec2fc4c0d7a3c6c6$var$isPlainText = /[a-z0-9_ -]$/i;
function $ec2fc4c0d7a3c6c6$var$useKeyComposition(e) {
    return function(t) {
        if ("compositionend" === t.type || "change" === t.type) {
            if (!0 !== t.target.qComposing) return;
            t.target.qComposing = !1, e(t);
        } else if ("compositionupdate" === t.type && !0 !== t.target.qComposing && "string" === typeof t.data) {
            const e = !0 === $ec2fc4c0d7a3c6c6$var$client.is.firefox ? !1 === $ec2fc4c0d7a3c6c6$var$isPlainText.test(t.data) : !0 === $ec2fc4c0d7a3c6c6$var$isJapanese.test(t.data) || !0 === $ec2fc4c0d7a3c6c6$var$isChinese.test(t.data) || !0 === $ec2fc4c0d7a3c6c6$var$isKorean.test(t.data);
            !0 === e && (t.target.qComposing = !0);
        }
    };
}
var $ec2fc4c0d7a3c6c6$export$b1c6a0c22e16b328 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QInput",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useFieldProps,
        ...$ec2fc4c0d7a3c6c6$var$useMaskProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        modelValue: {
            required: !1
        },
        shadowText: String,
        type: {
            type: String,
            default: "text"
        },
        debounce: [
            String,
            Number
        ],
        autogrow: Boolean,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useFieldEmits,
        "paste",
        "change",
        "keydown",
        "click",
        "animationend"
    ],
    setup (e, { emit: t, attrs: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = {};
        let i, r, s, u = NaN, c = null;
        const d = (0, $01W3b.ref)(null), p = $ec2fc4c0d7a3c6c6$var$useFormInputNameAttr(e), { innerValue: v, hasMask: m, moveCursorForPaste: f, updateMaskValue: g, onMaskedKeydown: b, onMaskedClick: y } = $ec2fc4c0d7a3c6c6$var$useMask(e, t, Q, d), S = $ec2fc4c0d7a3c6c6$var$useFileFormDomProps(e, !0), w = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(v.value)), C = $ec2fc4c0d7a3c6c6$var$useKeyComposition(B), x = $ec2fc4c0d7a3c6c6$var$useFieldState(), k = (0, $TusQn.computed)(()=>"textarea" === e.type || !0 === e.autogrow), _ = (0, $TusQn.computed)(()=>!0 === k.value || [
                "text",
                "search",
                "url",
                "tel",
                "password"
            ].includes(e.type)), q = (0, $TusQn.computed)(()=>{
            const t = {
                ...x.splitAttrs.listeners.value,
                onInput: B,
                onPaste: M,
                onChange: L,
                onBlur: O,
                onFocus: $ec2fc4c0d7a3c6c6$var$stop
            };
            return t.onCompositionstart = t.onCompositionupdate = t.onCompositionend = C, !0 === m.value && (t.onKeydown = b, t.onClick = y), !0 === e.autogrow && (t.onAnimationend = E), t;
        }), T = (0, $TusQn.computed)(()=>{
            const t = {
                tabindex: 0,
                "data-autofocus": !0 === e.autofocus || void 0,
                rows: "textarea" === e.type ? 6 : void 0,
                "aria-label": e.label,
                name: p.value,
                ...x.splitAttrs.attributes.value,
                id: x.targetUid.value,
                maxlength: e.maxlength,
                disabled: !0 === e.disable,
                readonly: !0 === e.readonly
            };
            return !1 === k.value && (t.type = e.type), !0 === e.autogrow && (t.rows = 1), t;
        });
        function P() {
            $ec2fc4c0d7a3c6c6$var$addFocusFn(()=>{
                const e = document.activeElement;
                null === d.value || d.value === e || null !== e && e.id === x.targetUid.value || d.value.focus({
                    preventScroll: !0
                });
            });
        }
        function $() {
            null !== d.value && d.value.select();
        }
        function M(o) {
            if (!0 === m.value && !0 !== e.reverseFillMask) {
                const e = o.target;
                f(e, e.selectionStart, e.selectionEnd);
            }
            t("paste", o);
        }
        function B(o) {
            if (!o || !o.target) return;
            if ("file" === e.type) return void t("update:modelValue", o.target.files);
            const n = o.target.value;
            if (!0 !== o.target.qComposing) {
                if (!0 === m.value) g(n, !1, o.inputType);
                else if (Q(n), !0 === _.value && o.target === document.activeElement) {
                    const { selectionStart: e, selectionEnd: t } = o.target;
                    void 0 !== e && void 0 !== t && (0, $TusQn.nextTick)(()=>{
                        o.target === document.activeElement && 0 === n.indexOf(o.target.value) && o.target.setSelectionRange(e, t);
                    });
                }
                !0 === e.autogrow && A();
            } else l.value = n;
        }
        function E(e) {
            t("animationend", e), A();
        }
        function Q(o, n) {
            s = ()=>{
                c = null, "number" !== e.type && !0 === l.hasOwnProperty("value") && delete l.value, e.modelValue !== o && u !== o && (u = o, !0 === n && (r = !0), t("update:modelValue", o), (0, $TusQn.nextTick)(()=>{
                    u === o && (u = NaN);
                })), s = void 0;
            }, "number" === e.type && (i = !0, l.value = o), void 0 !== e.debounce ? (null !== c && clearTimeout(c), l.value = o, c = setTimeout(s, e.debounce)) : s();
        }
        function A() {
            requestAnimationFrame(()=>{
                const e = d.value;
                if (null !== e) {
                    const t = e.parentNode.style, { scrollTop: o } = e, { overflowY: n, maxHeight: l } = !0 === a.platform.is.firefox ? {} : window.getComputedStyle(e), i = void 0 !== n && "scroll" !== n;
                    !0 === i && (e.style.overflowY = "hidden"), t.marginBottom = e.scrollHeight - 1 + "px", e.style.height = "1px", e.style.height = e.scrollHeight + "px", !0 === i && (e.style.overflowY = parseInt(l, 10) < e.scrollHeight ? "auto" : "hidden"), t.marginBottom = "", e.scrollTop = o;
                }
            });
        }
        function L(e) {
            C(e), null !== c && (clearTimeout(c), c = null), void 0 !== s && s(), t("change", e.target.value);
        }
        function O(t) {
            void 0 !== t && $ec2fc4c0d7a3c6c6$var$stop(t), null !== c && (clearTimeout(c), c = null), void 0 !== s && s(), i = !1, r = !1, delete l.value, "file" !== e.type && setTimeout(()=>{
                null !== d.value && (d.value.value = void 0 !== v.value ? v.value : "");
            });
        }
        function F() {
            return !0 === l.hasOwnProperty("value") ? l.value : void 0 !== v.value ? v.value : "";
        }
        (0, $TusQn.watch)(()=>e.type, ()=>{
            d.value && (d.value.value = e.modelValue);
        }), (0, $TusQn.watch)(()=>e.modelValue, (t)=>{
            if (!0 === m.value) {
                if (!0 === r && (r = !1, String(t) === u)) return;
                g(t);
            } else v.value !== t && (v.value = t, "number" === e.type && !0 === l.hasOwnProperty("value") && (!0 === i ? i = !1 : delete l.value));
            !0 === e.autogrow && (0, $TusQn.nextTick)(A);
        }), (0, $TusQn.watch)(()=>e.autogrow, (e)=>{
            !0 === e ? (0, $TusQn.nextTick)(A) : null !== d.value && o.rows > 0 && (d.value.style.height = "auto");
        }), (0, $TusQn.watch)(()=>e.dense, ()=>{
            !0 === e.autogrow && (0, $TusQn.nextTick)(A);
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            O();
        }), (0, $TusQn.onMounted)(()=>{
            !0 === e.autogrow && A();
        }), Object.assign(x, {
            innerValue: v,
            fieldClass: (0, $TusQn.computed)(()=>`q-${!0 === k.value ? "textarea" : "input"}` + (!0 === e.autogrow ? " q-textarea--autogrow" : "")),
            hasShadow: (0, $TusQn.computed)(()=>"file" !== e.type && "string" === typeof e.shadowText && 0 !== e.shadowText.length),
            inputRef: d,
            emitValue: Q,
            hasValue: w,
            floatingLabel: (0, $TusQn.computed)(()=>!0 === w.value && ("number" !== e.type || !1 === isNaN(v.value)) || $ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(e.displayValue)),
            getControl: ()=>{
                return (0, $TusQn.h)(!0 === k.value ? "textarea" : "input", {
                    ref: d,
                    class: [
                        "q-field__native q-placeholder",
                        e.inputClass
                    ],
                    style: e.inputStyle,
                    ...T.value,
                    ...q.value,
                    ..."file" !== e.type ? {
                        value: F()
                    } : S.value
                });
            },
            getShadowControl: ()=>{
                return (0, $TusQn.h)("div", {
                    class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (!0 === k.value ? "" : " text-no-wrap")
                }, [
                    (0, $TusQn.h)("span", {
                        class: "invisible"
                    }, F()),
                    (0, $TusQn.h)("span", e.shadowText)
                ]);
            }
        });
        const R = $ec2fc4c0d7a3c6c6$var$useField(x);
        return Object.assign(n, {
            focus: P,
            select: $,
            getNativeElement: ()=>d.value
        }), $ec2fc4c0d7a3c6c6$var$injectProp(n, "nativeEl", ()=>d.value), R;
    }
});
const $ec2fc4c0d7a3c6c6$var$defaultCfg$1 = {
    threshold: 0,
    root: null,
    rootMargin: "0px"
};
function $ec2fc4c0d7a3c6c6$var$update$3(e, t, o) {
    let n, a, l;
    "function" === typeof o ? (n = o, a = $ec2fc4c0d7a3c6c6$var$defaultCfg$1, l = void 0 === t.cfg) : (n = o.handler, a = Object.assign({}, $ec2fc4c0d7a3c6c6$var$defaultCfg$1, o.cfg), l = void 0 === t.cfg || !1 === $ec2fc4c0d7a3c6c6$var$isDeepEqual(t.cfg, a)), t.handler !== n && (t.handler = n), !0 === l && (t.cfg = a, void 0 !== t.observer && t.observer.unobserve(e), t.observer = new IntersectionObserver(([o])=>{
        if ("function" === typeof t.handler) {
            if (null === o.rootBounds && !0 === document.body.contains(e)) return t.observer.unobserve(e), void t.observer.observe(e);
            const n = t.handler(o, t.observer);
            (!1 === n || !0 === t.once && !0 === o.isIntersecting) && $ec2fc4c0d7a3c6c6$var$destroy$1(e);
        }
    }, a), t.observer.observe(e));
}
function $ec2fc4c0d7a3c6c6$var$destroy$1(e) {
    const t = e.__qvisible;
    void 0 !== t && (void 0 !== t.observer && t.observer.unobserve(e), delete e.__qvisible);
}
var $ec2fc4c0d7a3c6c6$export$869c896bf338bf5a = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "intersection",
    mounted (e, { modifiers: t, value: o }) {
        const n = {
            once: !0 === t.once
        };
        $ec2fc4c0d7a3c6c6$var$update$3(e, n, o), e.__qvisible = n;
    },
    updated (e, t) {
        const o = e.__qvisible;
        void 0 !== o && $ec2fc4c0d7a3c6c6$var$update$3(e, o, t.value);
    },
    beforeUnmount: $ec2fc4c0d7a3c6c6$var$destroy$1
}), $ec2fc4c0d7a3c6c6$export$bfb6b34b3c68a45a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QIntersection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        once: Boolean,
        transition: String,
        transitionDuration: {
            type: [
                String,
                Number
            ],
            default: 300
        },
        ssrPrerender: Boolean,
        margin: String,
        threshold: [
            Number,
            Array
        ],
        root: {
            default: null
        },
        disable: Boolean,
        onVisibility: Function
    },
    setup (e, { slots: t, emit: o }) {
        const n = (0, $01W3b.ref)(!0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value && e.ssrPrerender), a = (0, $TusQn.computed)(()=>void 0 !== e.root || void 0 !== e.margin || void 0 !== e.threshold ? {
                handler: s,
                cfg: {
                    root: e.root,
                    rootMargin: e.margin,
                    threshold: e.threshold
                }
            } : s), l = (0, $TusQn.computed)(()=>!0 !== e.disable && (!0 !== $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value || !0 !== e.once || !0 !== e.ssrPrerender)), i = (0, $TusQn.computed)(()=>{
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$869c896bf338bf5a,
                    a.value,
                    void 0,
                    {
                        once: e.once
                    }
                ]
            ];
        }), r = (0, $TusQn.computed)(()=>`--q-transition-duration: ${e.transitionDuration}ms`);
        function s(t) {
            n.value !== t.isIntersecting && (n.value = t.isIntersecting, void 0 !== e.onVisibility && o("visibility", n.value));
        }
        function u() {
            return !0 === n.value ? [
                (0, $TusQn.h)("div", {
                    key: "content",
                    style: r.value
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ] : void 0 !== t.hidden ? [
                (0, $TusQn.h)("div", {
                    key: "hidden",
                    style: r.value
                }, t.hidden())
            ] : void 0;
        }
        return ()=>{
            const t = e.transition ? [
                (0, $TusQn.h)((0, $eeJ70.Transition), {
                    name: "q-transition--" + e.transition
                }, u)
            ] : u();
            return $ec2fc4c0d7a3c6c6$var$hDir(e.tag, {
                class: "q-intersection"
            }, t, "main", l.value, ()=>i.value);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$546da2cac02ecac2 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QList",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        bordered: Boolean,
        dense: Boolean,
        separator: Boolean,
        padding: Boolean,
        tag: {
            type: String,
            default: "div"
        }
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q), a = (0, $TusQn.computed)(()=>"q-list" + (!0 === e.bordered ? " q-list--bordered" : "") + (!0 === e.dense ? " q-list--dense" : "") + (!0 === e.separator ? " q-list--separator" : "") + (!0 === n.value ? " q-list--dark" : "") + (!0 === e.padding ? " q-list--padding" : ""));
        return ()=>(0, $TusQn.h)(e.tag, {
                class: a.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$keyCodes$1 = [
    34,
    37,
    40,
    33,
    39,
    38
], $ec2fc4c0d7a3c6c6$var$commonPropsName = Object.keys($ec2fc4c0d7a3c6c6$var$useCircularCommonProps);
var $ec2fc4c0d7a3c6c6$export$6c883daf6170407d = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QKnob",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        ...$ec2fc4c0d7a3c6c6$var$useCircularCommonProps,
        modelValue: {
            type: Number,
            required: !0
        },
        innerMin: Number,
        innerMax: Number,
        step: {
            type: Number,
            default: 1,
            validator: (e)=>e >= 0
        },
        tabindex: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        disable: Boolean,
        readonly: Boolean
    },
    emits: [
        "update:modelValue",
        "change",
        "dragValue"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = (0, $01W3b.ref)(e.modelValue), i = (0, $01W3b.ref)(!1), r = (0, $TusQn.computed)(()=>!0 === isNaN(e.innerMin) || e.innerMin < e.min ? e.min : e.innerMin), s = (0, $TusQn.computed)(()=>!0 === isNaN(e.innerMax) || e.innerMax > e.max ? e.max : e.innerMax);
        let u;
        function c() {
            l.value = null === e.modelValue ? r.value : $ec2fc4c0d7a3c6c6$var$between(e.modelValue, r.value, s.value), P(!0);
        }
        (0, $TusQn.watch)(()=>`${e.modelValue}|${r.value}|${s.value}`, c), c();
        const d = (0, $TusQn.computed)(()=>!1 === e.disable && !1 === e.readonly), p = (0, $TusQn.computed)(()=>"q-knob non-selectable" + (!0 === d.value ? " q-knob--editable" : !0 === e.disable ? " disabled" : "")), v = (0, $TusQn.computed)(()=>(String(e.step).trim().split(".")[1] || "").length), m = (0, $TusQn.computed)(()=>0 === e.step ? 1 : e.step), f = (0, $TusQn.computed)(()=>!0 === e.instantFeedback || !0 === i.value), g = !0 === a.platform.is.mobile ? (0, $TusQn.computed)(()=>!0 === d.value ? {
                onClick: k
            } : {}) : (0, $TusQn.computed)(()=>!0 === d.value ? {
                onMousedown: x,
                onClick: k,
                onKeydown: _,
                onKeyup: T
            } : {}), b = (0, $TusQn.computed)(()=>!0 === d.value ? {
                tabindex: e.tabindex
            } : {
                [`aria-${!0 === e.disable ? "disabled" : "readonly"}`]: "true"
            }), y = (0, $TusQn.computed)(()=>{
            const t = {};
            return $ec2fc4c0d7a3c6c6$var$commonPropsName.forEach((o)=>{
                t[o] = e[o];
            }), t;
        });
        function S(e) {
            e.isFinal ? (q(e.evt, !0), i.value = !1) : e.isFirst ? (C(), i.value = !0, q(e.evt)) : q(e.evt);
        }
        const w = (0, $TusQn.computed)(()=>{
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    S,
                    void 0,
                    {
                        prevent: !0,
                        stop: !0,
                        mouse: !0
                    }
                ]
            ];
        });
        function C() {
            const { top: e, left: t, width: o, height: a } = n.$el.getBoundingClientRect();
            u = {
                top: e + a / 2,
                left: t + o / 2
            };
        }
        function x(e) {
            C(), q(e);
        }
        function k(e) {
            C(), q(e, !0);
        }
        function _(e) {
            if (!$ec2fc4c0d7a3c6c6$var$keyCodes$1.includes(e.keyCode)) return;
            $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
            const t = ([
                34,
                33
            ].includes(e.keyCode) ? 10 : 1) * m.value, o = [
                34,
                37,
                40
            ].includes(e.keyCode) ? -t : t;
            l.value = $ec2fc4c0d7a3c6c6$var$between(parseFloat((l.value + o).toFixed(v.value)), r.value, s.value), P();
        }
        function q(t, n) {
            const i = $ec2fc4c0d7a3c6c6$var$position(t), c = Math.abs(i.top - u.top), d = Math.sqrt(c ** 2 + Math.abs(i.left - u.left) ** 2);
            let p = Math.asin(c / d) * (180 / Math.PI);
            p = i.top < u.top ? u.left < i.left ? 90 - p : 270 + p : u.left < i.left ? p + 90 : 270 - p, !0 === a.lang.rtl ? p = $ec2fc4c0d7a3c6c6$var$normalizeToInterval(-p - e.angle, 0, 360) : e.angle && (p = $ec2fc4c0d7a3c6c6$var$normalizeToInterval(p - e.angle, 0, 360)), !0 === e.reverse && (p = 360 - p);
            let f = e.min + p / 360 * (e.max - e.min);
            if (0 !== m.value) {
                const e = f % m.value;
                f = f - e + (Math.abs(e) >= m.value / 2 ? (e < 0 ? -1 : 1) * m.value : 0), f = parseFloat(f.toFixed(v.value));
            }
            f = $ec2fc4c0d7a3c6c6$var$between(f, r.value, s.value), o("dragValue", f), l.value !== f && (l.value = f), P(n);
        }
        function T(e) {
            $ec2fc4c0d7a3c6c6$var$keyCodes$1.includes(e.keyCode) && P(!0);
        }
        function P(t) {
            e.modelValue !== l.value && o("update:modelValue", l.value), !0 === t && o("change", l.value);
        }
        const $ = $ec2fc4c0d7a3c6c6$var$useFormAttrs(e);
        function M() {
            return (0, $TusQn.h)("input", $.value);
        }
        return ()=>{
            const o = {
                class: p.value,
                role: "slider",
                "aria-valuemin": r.value,
                "aria-valuemax": s.value,
                "aria-valuenow": e.modelValue,
                ...b.value,
                ...y.value,
                value: l.value,
                instantFeedback: f.value,
                ...g.value
            }, n = {
                default: t.default
            };
            return !0 === d.value && void 0 !== e.name && (n.internal = M), $ec2fc4c0d7a3c6c6$var$hDir($ec2fc4c0d7a3c6c6$export$3bbfcedf93eff7f7, o, n, "knob", d.value, ()=>w.value);
        };
    }
});
const { passive: $ec2fc4c0d7a3c6c6$var$passive$2 } = $ec2fc4c0d7a3c6c6$var$listenOpts, $ec2fc4c0d7a3c6c6$var$axisValues = [
    "both",
    "horizontal",
    "vertical"
];
var $ec2fc4c0d7a3c6c6$export$d6d34850bd31dad = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QScrollObserver",
    props: {
        axis: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$axisValues.includes(e),
            default: "vertical"
        },
        debounce: [
            String,
            Number
        ],
        scrollTarget: {
            default: void 0
        }
    },
    emits: [
        "scroll"
    ],
    setup (e, { emit: t }) {
        const o = {
            position: {
                top: 0,
                left: 0
            },
            direction: "down",
            directionChanged: !1,
            delta: {
                top: 0,
                left: 0
            },
            inflectionPoint: {
                top: 0,
                left: 0
            }
        };
        let n, a, l = null;
        function i() {
            null !== l && l();
            const a = Math.max(0, $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(n)), i = $ec2fc4c0d7a3c6c6$var$getHorizontalScrollPosition(n), r = {
                top: a - o.position.top,
                left: i - o.position.left
            };
            if ("vertical" === e.axis && 0 === r.top || "horizontal" === e.axis && 0 === r.left) return;
            const s = Math.abs(r.top) >= Math.abs(r.left) ? r.top < 0 ? "up" : "down" : r.left < 0 ? "left" : "right";
            o.position = {
                top: a,
                left: i
            }, o.directionChanged = o.direction !== s, o.delta = r, !0 === o.directionChanged && (o.direction = s, o.inflectionPoint = o.position), t("scroll", {
                ...o
            });
        }
        function r() {
            n = $ec2fc4c0d7a3c6c6$var$getScrollTarget(a, e.scrollTarget), n.addEventListener("scroll", u, $ec2fc4c0d7a3c6c6$var$passive$2), u(!0);
        }
        function s() {
            void 0 !== n && (n.removeEventListener("scroll", u, $ec2fc4c0d7a3c6c6$var$passive$2), n = void 0);
        }
        function u(t) {
            if (!0 === t || 0 === e.debounce || "0" === e.debounce) i();
            else if (null === l) {
                const [t, o] = e.debounce ? [
                    setTimeout(i, e.debounce),
                    clearTimeout
                ] : [
                    requestAnimationFrame(i),
                    cancelAnimationFrame
                ];
                l = ()=>{
                    o(t), l = null;
                };
            }
        }
        (0, $TusQn.watch)(()=>e.scrollTarget, ()=>{
            s(), r();
        });
        const { proxy: c } = (0, $TusQn.getCurrentInstance)();
        return (0, $TusQn.watch)(()=>c.$q.lang.rtl, i), (0, $TusQn.onMounted)(()=>{
            a = c.$el.parentNode, r();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            null !== l && l(), s();
        }), Object.assign(c, {
            trigger: u,
            getPosition: ()=>o
        }), $ec2fc4c0d7a3c6c6$export$8793edee2d425525;
    }
}), $ec2fc4c0d7a3c6c6$export$c40af6af424a1775 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QLayout",
    props: {
        container: Boolean,
        view: {
            type: String,
            default: "hhh lpr fff",
            validator: (e)=>/^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(e.toLowerCase())
        },
        onScroll: Function,
        onScrollHeight: Function,
        onResize: Function
    },
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = (0, $01W3b.ref)(null), l = (0, $01W3b.ref)(n.screen.height), i = (0, $01W3b.ref)(!0 === e.container ? 0 : n.screen.width), r = (0, $01W3b.ref)({
            position: 0,
            direction: "down",
            inflectionPoint: 0
        }), s = (0, $01W3b.ref)(0), u = (0, $01W3b.ref)(!0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value ? 0 : $ec2fc4c0d7a3c6c6$var$getScrollbarWidth()), c = (0, $TusQn.computed)(()=>"q-layout q-layout--" + (!0 === e.container ? "containerized" : "standard")), d = (0, $TusQn.computed)(()=>!1 === e.container ? {
                minHeight: n.screen.height + "px"
            } : null), p = (0, $TusQn.computed)(()=>0 !== u.value ? {
                [!0 === n.lang.rtl ? "left" : "right"]: `${u.value}px`
            } : null), v = (0, $TusQn.computed)(()=>0 !== u.value ? {
                [!0 === n.lang.rtl ? "right" : "left"]: 0,
                [!0 === n.lang.rtl ? "left" : "right"]: `-${u.value}px`,
                width: `calc(100% + ${u.value}px)`
            } : null);
        function m(t) {
            if (!0 === e.container || !0 !== document.qScrollPrevented) {
                const n = {
                    position: t.position.top,
                    direction: t.direction,
                    directionChanged: t.directionChanged,
                    inflectionPoint: t.inflectionPoint.top,
                    delta: t.delta.top
                };
                r.value = n, void 0 !== e.onScroll && o("scroll", n);
            }
        }
        function f(t) {
            const { height: n, width: a } = t;
            let r = !1;
            l.value !== n && (r = !0, l.value = n, void 0 !== e.onScrollHeight && o("scrollHeight", n), b()), i.value !== a && (r = !0, i.value = a), !0 === r && void 0 !== e.onResize && o("resize", t);
        }
        function g({ height: e }) {
            s.value !== e && (s.value = e, b());
        }
        function b() {
            if (!0 === e.container) {
                const e = l.value > s.value ? $ec2fc4c0d7a3c6c6$var$getScrollbarWidth() : 0;
                u.value !== e && (u.value = e);
            }
        }
        let y = null;
        const S = {
            instances: {},
            view: (0, $TusQn.computed)(()=>e.view),
            isContainer: (0, $TusQn.computed)(()=>e.container),
            rootRef: a,
            height: l,
            containerHeight: s,
            scrollbarWidth: u,
            totalWidth: (0, $TusQn.computed)(()=>i.value + u.value),
            rows: (0, $TusQn.computed)(()=>{
                const t = e.view.toLowerCase().split(" ");
                return {
                    top: t[0].split(""),
                    middle: t[1].split(""),
                    bottom: t[2].split("")
                };
            }),
            header: (0, $01W3b.reactive)({
                size: 0,
                offset: 0,
                space: !1
            }),
            right: (0, $01W3b.reactive)({
                size: 300,
                offset: 0,
                space: !1
            }),
            footer: (0, $01W3b.reactive)({
                size: 0,
                offset: 0,
                space: !1
            }),
            left: (0, $01W3b.reactive)({
                size: 300,
                offset: 0,
                space: !1
            }),
            scroll: r,
            animate () {
                null !== y ? clearTimeout(y) : document.body.classList.add("q-body--layout-animate"), y = setTimeout(()=>{
                    y = null, document.body.classList.remove("q-body--layout-animate");
                }, 155);
            },
            update (e, t, o) {
                S[e][t] = o;
            }
        };
        if ((0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$layoutKey, S), $ec2fc4c0d7a3c6c6$var$getScrollbarWidth() > 0) {
            let t = null;
            const o = document.body;
            function w() {
                t = null, o.classList.remove("hide-scrollbar");
            }
            function C() {
                if (null === t) {
                    if (o.scrollHeight > n.screen.height) return;
                    o.classList.add("hide-scrollbar");
                } else clearTimeout(t);
                t = setTimeout(w, 300);
            }
            function x(e) {
                null !== t && "remove" === e && (clearTimeout(t), w()), window[`${e}EventListener`]("resize", C);
            }
            (0, $TusQn.watch)(()=>!0 !== e.container ? "add" : "remove", x), !0 !== e.container && x("add"), (0, $TusQn.onUnmounted)(()=>{
                x("remove");
            });
        }
        return ()=>{
            const o = $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d6d34850bd31dad, {
                    onScroll: m
                }),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                    onResize: f
                })
            ]), n = (0, $TusQn.h)("div", {
                class: c.value,
                style: d.value,
                ref: !0 === e.container ? void 0 : a,
                tabindex: -1
            }, o);
            return !0 === e.container ? (0, $TusQn.h)("div", {
                class: "q-layout-container overflow-hidden",
                ref: a
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                    onResize: g
                }),
                (0, $TusQn.h)("div", {
                    class: "absolute-full",
                    style: p.value
                }, [
                    (0, $TusQn.h)("div", {
                        class: "scroll",
                        style: v.value
                    }, [
                        n
                    ])
                ])
            ]) : n;
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$separatorValues = [
    "horizontal",
    "vertical",
    "cell",
    "none"
];
var $ec2fc4c0d7a3c6c6$export$96e16f0b01ad0bca = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QMarkupTable",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        wrapCells: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$separatorValues.includes(e)
        }
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q), a = (0, $TusQn.computed)(()=>"q-markup-table q-table__container q-table__card" + ` q-table--${e.separator}-separator` + (!0 === n.value ? " q-table--dark q-table__card--dark q-dark" : "") + (!0 === e.dense ? " q-table--dense" : "") + (!0 === e.flat ? " q-table--flat" : "") + (!0 === e.bordered ? " q-table--bordered" : "") + (!0 === e.square ? " q-table--square" : "") + (!1 === e.wrapCells ? " q-table--no-wrap" : ""));
        return ()=>(0, $TusQn.h)("div", {
                class: a.value
            }, [
                (0, $TusQn.h)("table", {
                    class: "q-table"
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ]);
    }
}), $ec2fc4c0d7a3c6c6$export$20500169d4287824 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QNoSsr",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        placeholder: String
    },
    setup (e, { slots: t }) {
        const o = $ec2fc4c0d7a3c6c6$var$useCanRender();
        return ()=>{
            const n = {};
            if (!0 === o.value) {
                const o = $ec2fc4c0d7a3c6c6$var$hSlot(t.default);
                return void 0 === o ? o : o.length > 1 ? (0, $TusQn.h)(e.tag, n, o) : o[0];
            }
            n.class = "q-no-ssr-placeholder";
            const a = $ec2fc4c0d7a3c6c6$var$hSlot(t.placeholder);
            return void 0 !== a ? a.length > 1 ? (0, $TusQn.h)(e.tag, n, a) : a[0] : void 0 !== e.placeholder ? (0, $TusQn.h)(e.tag, n, e.placeholder) : void 0;
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$m = (0, $TusQn.h)("svg", {
    key: "svg",
    class: "q-radio__bg absolute non-selectable",
    viewBox: "0 0 24 24"
}, [
    (0, $TusQn.h)("path", {
        d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
    }),
    (0, $TusQn.h)("path", {
        class: "q-radio__check",
        d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
    })
]);
var $ec2fc4c0d7a3c6c6$export$339924d2c57b87f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QRadio",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        modelValue: {
            required: !0
        },
        val: {
            required: !0
        },
        label: String,
        leftLabel: Boolean,
        checkedIcon: String,
        uncheckedIcon: String,
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        disable: Boolean,
        tabindex: [
            String,
            Number
        ]
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useDark(e, n.$q), l = $ec2fc4c0d7a3c6c6$var$useSize(e, $ec2fc4c0d7a3c6c6$var$optionSizes), i = (0, $01W3b.ref)(null), { refocusTargetEl: r, refocusTarget: s } = $ec2fc4c0d7a3c6c6$var$useRefocusTarget(e, i), u = (0, $TusQn.computed)(()=>(0, $01W3b.toRaw)(e.modelValue) === (0, $01W3b.toRaw)(e.val)), c = (0, $TusQn.computed)(()=>"q-radio cursor-pointer no-outline row inline no-wrap items-center" + (!0 === e.disable ? " disabled" : "") + (!0 === a.value ? " q-radio--dark" : "") + (!0 === e.dense ? " q-radio--dense" : "") + (!0 === e.leftLabel ? " reverse" : "")), d = (0, $TusQn.computed)(()=>{
            const t = void 0 === e.color || !0 !== e.keepColor && !0 !== u.value ? "" : ` text-${e.color}`;
            return "q-radio__inner relative-position " + `q-radio__inner--${!0 === u.value ? "truthy" : "falsy"}${t}`;
        }), p = (0, $TusQn.computed)(()=>(!0 === u.value ? e.checkedIcon : e.uncheckedIcon) || null), v = (0, $TusQn.computed)(()=>!0 === e.disable ? -1 : e.tabindex || 0), m = (0, $TusQn.computed)(()=>{
            const t = {
                type: "radio"
            };
            return void 0 !== e.name && Object.assign(t, {
                ".checked": !0 === u.value,
                "^checked": !0 === u.value ? "checked" : void 0,
                name: e.name,
                value: e.val
            }), t;
        }), f = $ec2fc4c0d7a3c6c6$var$useFormInject(m);
        function g(t) {
            void 0 !== t && ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), s(t)), !0 !== e.disable && !0 !== u.value && o("update:modelValue", e.val, t);
        }
        function b(e) {
            13 !== e.keyCode && 32 !== e.keyCode || $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
        }
        function y(e) {
            13 !== e.keyCode && 32 !== e.keyCode || g(e);
        }
        return Object.assign(n, {
            set: g
        }), ()=>{
            const o = null !== p.value ? [
                (0, $TusQn.h)("div", {
                    key: "icon",
                    class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
                }, [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        class: "q-radio__icon",
                        name: p.value
                    })
                ])
            ] : [
                $ec2fc4c0d7a3c6c6$var$svg$m
            ];
            !0 !== e.disable && f(o, "unshift", " q-radio__native q-ma-none q-pa-none");
            const n = [
                (0, $TusQn.h)("div", {
                    class: d.value,
                    style: l.value,
                    "aria-hidden": "true"
                }, o)
            ];
            null !== r.value && n.push(r.value);
            const a = void 0 !== e.label ? $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                e.label
            ]) : $ec2fc4c0d7a3c6c6$var$hSlot(t.default);
            return void 0 !== a && n.push((0, $TusQn.h)("div", {
                class: "q-radio__label q-anchor--skip"
            }, a)), (0, $TusQn.h)("div", {
                ref: i,
                class: c.value,
                tabindex: v.value,
                role: "radio",
                "aria-label": e.label,
                "aria-checked": !0 === u.value ? "true" : "false",
                "aria-disabled": !0 === e.disable ? "true" : void 0,
                onClick: g,
                onKeydown: b,
                onKeyup: y
            }, n);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$16e415cb3321864c = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QToggle",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useCheckboxProps,
        icon: String,
        iconColor: String
    },
    emits: $ec2fc4c0d7a3c6c6$var$useCheckboxEmits,
    setup (e) {
        function t(t, o) {
            const n = (0, $TusQn.computed)(()=>(!0 === t.value ? e.checkedIcon : !0 === o.value ? e.indeterminateIcon : e.uncheckedIcon) || e.icon), a = (0, $TusQn.computed)(()=>!0 === t.value ? e.iconColor : null);
            return ()=>[
                    (0, $TusQn.h)("div", {
                        class: "q-toggle__track"
                    }),
                    (0, $TusQn.h)("div", {
                        class: "q-toggle__thumb absolute flex flex-center no-wrap"
                    }, void 0 !== n.value ? [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                            name: n.value,
                            color: a.value
                        })
                    ] : void 0)
                ];
        }
        return $ec2fc4c0d7a3c6c6$var$useCheckbox("toggle", t);
    }
});
const $ec2fc4c0d7a3c6c6$var$components$1 = {
    radio: $ec2fc4c0d7a3c6c6$export$339924d2c57b87f,
    checkbox: $ec2fc4c0d7a3c6c6$export$a3430661ad019cfb,
    toggle: $ec2fc4c0d7a3c6c6$export$16e415cb3321864c
}, $ec2fc4c0d7a3c6c6$var$typeValues = Object.keys($ec2fc4c0d7a3c6c6$var$components$1);
var $ec2fc4c0d7a3c6c6$export$3ceb287b9597da0e = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QOptionGroup",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        modelValue: {
            required: !0
        },
        options: {
            type: Array,
            validator: (e)=>e.every((e)=>"value" in e && "label" in e)
        },
        name: String,
        type: {
            default: "radio",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$typeValues.includes(e)
        },
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        size: String,
        leftLabel: Boolean,
        inline: Boolean,
        disable: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { emit: t, slots: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = Array.isArray(e.modelValue);
        "radio" === e.type ? !0 === a && console.error("q-option-group: model should not be array") : !1 === a && console.error("q-option-group: model should be array in your case");
        const l = $ec2fc4c0d7a3c6c6$var$useDark(e, n), i = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$components$1[e.type]), r = (0, $TusQn.computed)(()=>"q-option-group q-gutter-x-sm" + (!0 === e.inline ? " q-option-group--inline" : "")), s = (0, $TusQn.computed)(()=>{
            const t = {
                role: "group"
            };
            return "radio" === e.type && (t.role = "radiogroup", !0 === e.disable && (t["aria-disabled"] = "true")), t;
        });
        function u(e) {
            t("update:modelValue", e);
        }
        return ()=>(0, $TusQn.h)("div", {
                class: r.value,
                ...s.value
            }, e.options.map((t, n)=>{
                const a = void 0 !== o["label-" + n] ? ()=>o["label-" + n](t) : void 0 !== o.label ? ()=>o.label(t) : void 0;
                return (0, $TusQn.h)("div", [
                    (0, $TusQn.h)(i.value, {
                        modelValue: e.modelValue,
                        val: t.value,
                        name: void 0 === t.name ? e.name : t.name,
                        disable: e.disable || t.disable,
                        label: void 0 === a ? t.label : null,
                        leftLabel: void 0 === t.leftLabel ? e.leftLabel : t.leftLabel,
                        color: void 0 === t.color ? e.color : t.color,
                        checkedIcon: t.checkedIcon,
                        uncheckedIcon: t.uncheckedIcon,
                        dark: t.dark || l.value,
                        size: void 0 === t.size ? e.size : t.size,
                        dense: e.dense,
                        keepColor: void 0 === t.keepColor ? e.keepColor : t.keepColor,
                        "onUpdate:modelValue": u
                    }, a)
                ]);
            }));
    }
}), $ec2fc4c0d7a3c6c6$export$2739fb63d58d99fc = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPage",
    props: {
        padding: Boolean,
        styleFn: Function
    },
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$layoutKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (n === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QPage needs to be a deep child of QLayout"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        const a = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$pageContainerKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (a === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QPage needs to be child of QPageContainer"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        const l = (0, $TusQn.computed)(()=>{
            const t = (!0 === n.header.space ? n.header.size : 0) + (!0 === n.footer.space ? n.footer.size : 0);
            if ("function" === typeof e.styleFn) {
                const a = !0 === n.isContainer.value ? n.containerHeight.value : o.screen.height;
                return e.styleFn(t, a);
            }
            return {
                minHeight: !0 === n.isContainer.value ? n.containerHeight.value - t + "px" : 0 === o.screen.height ? 0 !== t ? `calc(100vh - ${t}px)` : "100vh" : o.screen.height - t + "px"
            };
        }), i = (0, $TusQn.computed)(()=>`q-page${!0 === e.padding ? " q-layout-padding" : ""}`);
        return ()=>(0, $TusQn.h)("main", {
                class: i.value,
                style: l.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$c532236a32af6b2e = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPageContainer",
    setup (e, { slots: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$layoutKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (n === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QPageContainer needs to be child of QLayout"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$pageContainerKey, !0);
        const a = (0, $TusQn.computed)(()=>{
            const e = {};
            return !0 === n.header.space && (e.paddingTop = `${n.header.size}px`), !0 === n.right.space && (e[`padding${!0 === o.lang.rtl ? "Left" : "Right"}`] = `${n.right.size}px`), !0 === n.footer.space && (e.paddingBottom = `${n.footer.size}px`), !0 === n.left.space && (e[`padding${!0 === o.lang.rtl ? "Right" : "Left"}`] = `${n.left.size}px`), e;
        });
        return ()=>(0, $TusQn.h)("div", {
                class: "q-page-container",
                style: a.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$usePageStickyProps = {
    position: {
        type: String,
        default: "bottom-right",
        validator: (e)=>[
                "top-right",
                "top-left",
                "bottom-right",
                "bottom-left",
                "top",
                "right",
                "bottom",
                "left"
            ].includes(e)
    },
    offset: {
        type: Array,
        validator: (e)=>2 === e.length
    },
    expand: Boolean
};
function $ec2fc4c0d7a3c6c6$var$usePageSticky() {
    const { props: e, proxy: { $q: t } } = (0, $TusQn.getCurrentInstance)(), o = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$layoutKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
    if (o === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QPageSticky needs to be child of QLayout"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
    const n = (0, $TusQn.computed)(()=>{
        const t = e.position;
        return {
            top: t.indexOf("top") > -1,
            right: t.indexOf("right") > -1,
            bottom: t.indexOf("bottom") > -1,
            left: t.indexOf("left") > -1,
            vertical: "top" === t || "bottom" === t,
            horizontal: "left" === t || "right" === t
        };
    }), a = (0, $TusQn.computed)(()=>o.header.offset), l = (0, $TusQn.computed)(()=>o.right.offset), i = (0, $TusQn.computed)(()=>o.footer.offset), r = (0, $TusQn.computed)(()=>o.left.offset), s = (0, $TusQn.computed)(()=>{
        let o = 0, s = 0;
        const u = n.value, c = !0 === t.lang.rtl ? -1 : 1;
        !0 === u.top && 0 !== a.value ? s = `${a.value}px` : !0 === u.bottom && 0 !== i.value && (s = `${-i.value}px`), !0 === u.left && 0 !== r.value ? o = `${c * r.value}px` : !0 === u.right && 0 !== l.value && (o = `${-c * l.value}px`);
        const d = {
            transform: `translate(${o}, ${s})`
        };
        return e.offset && (d.margin = `${e.offset[1]}px ${e.offset[0]}px`), !0 === u.vertical ? (0 !== r.value && (d[!0 === t.lang.rtl ? "right" : "left"] = `${r.value}px`), 0 !== l.value && (d[!0 === t.lang.rtl ? "left" : "right"] = `${l.value}px`)) : !0 === u.horizontal && (0 !== a.value && (d.top = `${a.value}px`), 0 !== i.value && (d.bottom = `${i.value}px`)), d;
    }), u = (0, $TusQn.computed)(()=>`q-page-sticky row flex-center fixed-${e.position}` + ` q-page-sticky--${!0 === e.expand ? "expand" : "shrink"}`);
    function c(t) {
        const o = $ec2fc4c0d7a3c6c6$var$hSlot(t.default);
        return (0, $TusQn.h)("div", {
            class: u.value,
            style: s.value
        }, !0 === e.expand ? o : [
            (0, $TusQn.h)("div", o)
        ]);
    }
    return {
        $layout: o,
        getStickyContent: c
    };
}
var $ec2fc4c0d7a3c6c6$export$757ee84fd3b4950f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPageScroller",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$usePageStickyProps,
        scrollOffset: {
            type: Number,
            default: 1e3
        },
        reverse: Boolean,
        duration: {
            type: Number,
            default: 300
        },
        offset: {
            default: ()=>[
                    18,
                    18
                ]
        }
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), { $layout: a, getStickyContent: l } = $ec2fc4c0d7a3c6c6$var$usePageSticky(), i = (0, $01W3b.ref)(null);
        let r;
        const s = (0, $TusQn.computed)(()=>a.height.value - (!0 === a.isContainer.value ? a.containerHeight.value : n.screen.height));
        function u() {
            return !0 === e.reverse ? s.value - a.scroll.value.position > e.scrollOffset : a.scroll.value.position > e.scrollOffset;
        }
        const c = (0, $01W3b.ref)(u());
        function d() {
            const e = u();
            c.value !== e && (c.value = e);
        }
        function p() {
            !0 === e.reverse ? void 0 === r && (r = (0, $TusQn.watch)(s, d)) : v();
        }
        function v() {
            void 0 !== r && (r(), r = void 0);
        }
        function m(t) {
            const n = $ec2fc4c0d7a3c6c6$var$getScrollTarget(!0 === a.isContainer.value ? i.value : a.rootRef.value);
            $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition(n, !0 === e.reverse ? a.height.value : 0, e.duration), o("click", t);
        }
        function f() {
            return !0 === c.value ? (0, $TusQn.h)("div", {
                ref: i,
                class: "q-page-scroller",
                onClick: m
            }, l(t)) : null;
        }
        return (0, $TusQn.watch)(a.scroll, d), (0, $TusQn.watch)(()=>e.reverse, p), p(), (0, $TusQn.onBeforeUnmount)(v), ()=>(0, $TusQn.h)((0, $eeJ70.Transition), {
                name: "q-transition--fade"
            }, f);
    }
}), $ec2fc4c0d7a3c6c6$export$fb6e3b1b2833174c = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPageSticky",
    props: $ec2fc4c0d7a3c6c6$var$usePageStickyProps,
    setup (e, { slots: t }) {
        const { getStickyContent: o } = $ec2fc4c0d7a3c6c6$var$usePageSticky();
        return ()=>o(t);
    }
});
function $ec2fc4c0d7a3c6c6$var$getBool(e, t) {
    return [
        !0,
        !1
    ].includes(e) ? e : t;
}
var $ec2fc4c0d7a3c6c6$export$e0e0e4dfbf7cf819 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPagination",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        modelValue: {
            type: Number,
            required: !0
        },
        min: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        max: {
            type: [
                Number,
                String
            ],
            required: !0
        },
        maxPages: {
            type: [
                Number,
                String
            ],
            default: 0,
            validator: (e)=>("string" === typeof e ? parseInt(e, 10) : e) >= 0
        },
        inputStyle: [
            Array,
            String,
            Object
        ],
        inputClass: [
            Array,
            String,
            Object
        ],
        size: String,
        disable: Boolean,
        input: Boolean,
        iconPrev: String,
        iconNext: String,
        iconFirst: String,
        iconLast: String,
        toFn: Function,
        boundaryLinks: {
            type: Boolean,
            default: null
        },
        boundaryNumbers: {
            type: Boolean,
            default: null
        },
        directionLinks: {
            type: Boolean,
            default: null
        },
        ellipses: {
            type: Boolean,
            default: null
        },
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: null
        },
        round: Boolean,
        rounded: Boolean,
        flat: Boolean,
        outline: Boolean,
        unelevated: Boolean,
        push: Boolean,
        glossy: Boolean,
        color: {
            type: String,
            default: "primary"
        },
        textColor: String,
        activeDesign: {
            type: String,
            default: "",
            values: (e)=>"" === e || $ec2fc4c0d7a3c6c6$var$btnDesignOptions.includes(e)
        },
        activeColor: String,
        activeTextColor: String,
        gutter: String,
        padding: {
            type: String,
            default: "3px 2px"
        }
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { emit: t }) {
        const { proxy: o } = (0, $TusQn.getCurrentInstance)(), { $q: n } = o, a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), l = (0, $TusQn.computed)(()=>parseInt(e.min, 10)), i = (0, $TusQn.computed)(()=>parseInt(e.max, 10)), r = (0, $TusQn.computed)(()=>parseInt(e.maxPages, 10)), s = (0, $TusQn.computed)(()=>m.value + " / " + i.value), u = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBool(e.boundaryLinks, e.input)), c = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBool(e.boundaryNumbers, !e.input)), d = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBool(e.directionLinks, e.input)), p = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBool(e.ellipses, !e.input)), v = (0, $01W3b.ref)(null), m = (0, $TusQn.computed)({
            get: ()=>e.modelValue,
            set: (o)=>{
                if (o = parseInt(o, 10), e.disable || isNaN(o)) return;
                const n = $ec2fc4c0d7a3c6c6$var$between(o, l.value, i.value);
                e.modelValue !== n && t("update:modelValue", n);
            }
        });
        (0, $TusQn.watch)(()=>`${l.value}|${i.value}`, ()=>{
            m.value = e.modelValue;
        });
        const f = (0, $TusQn.computed)(()=>"q-pagination row no-wrap items-center" + (!0 === e.disable ? " disabled" : "")), g = (0, $TusQn.computed)(()=>e.gutter in $ec2fc4c0d7a3c6c6$var$btnPadding ? `${$ec2fc4c0d7a3c6c6$var$btnPadding[e.gutter]}px` : e.gutter || null), b = (0, $TusQn.computed)(()=>null !== g.value ? `--q-pagination-gutter-parent:-${g.value};--q-pagination-gutter-child:${g.value}` : null), y = (0, $TusQn.computed)(()=>{
            const t = [
                e.iconFirst || n.iconSet.pagination.first,
                e.iconPrev || n.iconSet.pagination.prev,
                e.iconNext || n.iconSet.pagination.next,
                e.iconLast || n.iconSet.pagination.last
            ];
            return !0 === n.lang.rtl ? t.reverse() : t;
        }), S = (0, $TusQn.computed)(()=>({
                "aria-disabled": !0 === e.disable ? "true" : "false",
                role: "navigation"
            })), w = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getBtnDesign(e, "flat")), C = (0, $TusQn.computed)(()=>({
                [w.value]: !0,
                round: e.round,
                rounded: e.rounded,
                padding: e.padding,
                color: e.color,
                textColor: e.textColor,
                size: e.size,
                ripple: null === e.ripple || e.ripple
            })), x = (0, $TusQn.computed)(()=>{
            const t = {
                [w.value]: !1
            };
            return "" !== e.activeDesign && (t[e.activeDesign] = !0), t;
        }), k = (0, $TusQn.computed)(()=>({
                ...x.value,
                color: e.activeColor || e.color,
                textColor: e.activeTextColor || e.textColor
            })), _ = (0, $TusQn.computed)(()=>{
            let t = Math.max(r.value, 1 + (p.value ? 2 : 0) + (c.value ? 2 : 0));
            const o = {
                pgFrom: l.value,
                pgTo: i.value,
                ellipsesStart: !1,
                ellipsesEnd: !1,
                boundaryStart: !1,
                boundaryEnd: !1,
                marginalStyle: {
                    minWidth: `${Math.max(2, String(i.value).length)}em`
                }
            };
            return r.value && t < i.value - l.value + 1 && (t = 1 + 2 * Math.floor(t / 2), o.pgFrom = Math.max(l.value, Math.min(i.value - t + 1, e.modelValue - Math.floor(t / 2))), o.pgTo = Math.min(i.value, o.pgFrom + t - 1), c.value && (o.boundaryStart = !0, o.pgFrom++), p.value && o.pgFrom > l.value + (c.value ? 1 : 0) && (o.ellipsesStart = !0, o.pgFrom++), c.value && (o.boundaryEnd = !0, o.pgTo--), p.value && o.pgTo < i.value - (c.value ? 1 : 0) && (o.ellipsesEnd = !0, o.pgTo--)), o;
        });
        function q(e) {
            m.value = e;
        }
        function T(e) {
            m.value = m.value + e;
        }
        const P = (0, $TusQn.computed)(()=>{
            function e() {
                m.value = v.value, v.value = null;
            }
            return {
                "onUpdate:modelValue": (e)=>{
                    v.value = e;
                },
                onKeyup: (t)=>{
                    !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(t, 13) && e();
                },
                onBlur: e
            };
        });
        function $(t, o, n) {
            const a = {
                "aria-label": o,
                "aria-current": "false",
                ...C.value,
                ...t
            };
            return !0 === n && Object.assign(a, {
                "aria-current": "true",
                ...k.value
            }), void 0 !== o && (void 0 !== e.toFn ? a.to = e.toFn(o) : a.onClick = ()=>{
                q(o);
            }), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, a);
        }
        return Object.assign(o, {
            set: q,
            setByOffset: T
        }), ()=>{
            const t = [], o = [];
            let n;
            if (!0 === u.value && (t.push($({
                key: "bls",
                disable: e.disable || e.modelValue <= l.value,
                icon: y.value[0]
            }, l.value)), o.unshift($({
                key: "ble",
                disable: e.disable || e.modelValue >= i.value,
                icon: y.value[3]
            }, i.value))), !0 === d.value && (t.push($({
                key: "bdp",
                disable: e.disable || e.modelValue <= l.value,
                icon: y.value[1]
            }, e.modelValue - 1)), o.unshift($({
                key: "bdn",
                disable: e.disable || e.modelValue >= i.value,
                icon: y.value[2]
            }, e.modelValue + 1))), !0 !== e.input) {
                n = [];
                const { pgFrom: a, pgTo: r, marginalStyle: s } = _.value;
                if (!0 === _.value.boundaryStart) {
                    const o = l.value === e.modelValue;
                    t.push($({
                        key: "bns",
                        style: s,
                        disable: e.disable,
                        label: l.value
                    }, l.value, o));
                }
                if (!0 === _.value.boundaryEnd) {
                    const t = i.value === e.modelValue;
                    o.unshift($({
                        key: "bne",
                        style: s,
                        disable: e.disable,
                        label: i.value
                    }, i.value, t));
                }
                !0 === _.value.ellipsesStart && t.push($({
                    key: "bes",
                    style: s,
                    disable: e.disable,
                    label: "…",
                    ripple: !1
                }, a - 1)), !0 === _.value.ellipsesEnd && o.unshift($({
                    key: "bee",
                    style: s,
                    disable: e.disable,
                    label: "…",
                    ripple: !1
                }, r + 1));
                for(let t = a; t <= r; t++)n.push($({
                    key: `bpg${t}`,
                    style: s,
                    disable: e.disable,
                    label: t
                }, t, t === e.modelValue));
            }
            return (0, $TusQn.h)("div", {
                class: f.value,
                ...S.value
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-pagination__content row no-wrap items-center",
                    style: b.value
                }, [
                    ...t,
                    !0 === e.input ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$b1c6a0c22e16b328, {
                        class: "inline",
                        style: {
                            width: `${s.value.length / 1.5}em`
                        },
                        type: "number",
                        dense: !0,
                        value: v.value,
                        disable: e.disable,
                        dark: a.value,
                        borderless: !0,
                        inputClass: e.inputClass,
                        inputStyle: e.inputStyle,
                        placeholder: s.value,
                        min: l.value,
                        max: i.value,
                        ...P.value
                    }) : (0, $TusQn.h)("div", {
                        class: "q-pagination__middle row justify-center"
                    }, n),
                    ...o
                ])
            ]);
        };
    }
});
function $ec2fc4c0d7a3c6c6$export$f07ce136d7462df5(e) {
    let t, o, n = !1;
    function a() {
        o = arguments, !0 !== n && (n = !0, t = requestAnimationFrame(()=>{
            e.apply(this, o), o = void 0, n = !1;
        }));
    }
    return a.cancel = ()=>{
        window.cancelAnimationFrame(t), n = !1;
    }, a;
}
const { passive: $ec2fc4c0d7a3c6c6$var$passive$1 } = $ec2fc4c0d7a3c6c6$var$listenOpts;
var $ec2fc4c0d7a3c6c6$export$7edd9a653cb140a3 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QParallax",
    props: {
        src: String,
        height: {
            type: Number,
            default: 500
        },
        speed: {
            type: Number,
            default: 1,
            validator: (e)=>e >= 0 && e <= 1
        },
        scrollTarget: {
            default: void 0
        },
        onScroll: Function
    },
    setup (e, { slots: t, emit: o }) {
        const n = (0, $01W3b.ref)(0), a = (0, $01W3b.ref)(null), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(null);
        let r, s, u, c, d, p;
        (0, $TusQn.watch)(()=>e.height, ()=>{
            !0 === r && m();
        }), (0, $TusQn.watch)(()=>e.scrollTarget, ()=>{
            !0 === r && (y(), b());
        });
        let v = (t)=>{
            n.value = t, void 0 !== e.onScroll && o("scroll", t);
        };
        function m() {
            let t, o, n;
            p === window ? (t = 0, n = o = window.innerHeight) : (t = $ec2fc4c0d7a3c6c6$var$offset(p).top, o = $ec2fc4c0d7a3c6c6$var$height(p), n = t + o);
            const l = $ec2fc4c0d7a3c6c6$var$offset(a.value).top, i = l + e.height;
            if (void 0 !== d || i > t && l < n) {
                const t = (n - l) / (e.height + o);
                f((u - e.height) * t * e.speed), v(t);
            }
        }
        let f = (e)=>{
            s.style.transform = `translate3d(-50%,${Math.round(e)}px,0)`;
        };
        function g() {
            u = s.naturalHeight || s.videoHeight || $ec2fc4c0d7a3c6c6$var$height(s), !0 === r && m();
        }
        function b() {
            r = !0, p = $ec2fc4c0d7a3c6c6$var$getScrollTarget(a.value, e.scrollTarget), p.addEventListener("scroll", m, $ec2fc4c0d7a3c6c6$var$passive$1), window.addEventListener("resize", c, $ec2fc4c0d7a3c6c6$var$passive$1), m();
        }
        function y() {
            !0 === r && (r = !1, p.removeEventListener("scroll", m, $ec2fc4c0d7a3c6c6$var$passive$1), window.removeEventListener("resize", c, $ec2fc4c0d7a3c6c6$var$passive$1), p = void 0, f.cancel(), v.cancel(), c.cancel());
        }
        return (0, $TusQn.onMounted)(()=>{
            f = $ec2fc4c0d7a3c6c6$export$f07ce136d7462df5(f), v = $ec2fc4c0d7a3c6c6$export$f07ce136d7462df5(v), c = $ec2fc4c0d7a3c6c6$export$f07ce136d7462df5(g), s = void 0 !== t.media ? l.value.children[0] : i.value, s.onload = s.onloadstart = s.loadedmetadata = g, g(), s.style.display = "initial", void 0 !== window.IntersectionObserver ? (d = new IntersectionObserver((e)=>{
                const t = !0 === e[0].isIntersecting ? b : y;
                t();
            }), d.observe(a.value)) : b();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            y(), void 0 !== d && d.disconnect(), s.onload = s.onloadstart = s.loadedmetadata = null;
        }), ()=>{
            return (0, $TusQn.h)("div", {
                ref: a,
                class: "q-parallax",
                style: {
                    height: `${e.height}px`
                }
            }, [
                (0, $TusQn.h)("div", {
                    ref: l,
                    class: "q-parallax__media absolute-full"
                }, void 0 !== t.media ? t.media() : [
                    (0, $TusQn.h)("img", {
                        ref: i,
                        src: e.src
                    })
                ]),
                (0, $TusQn.h)("div", {
                    class: "q-parallax__content absolute-full column flex-center"
                }, void 0 !== t.content ? t.content({
                    percentScrolled: n.value
                }) : $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ]);
        };
    }
});
function $ec2fc4c0d7a3c6c6$export$9cd59f9826255e47(e, t = new WeakMap) {
    if (Object(e) !== e) return e;
    if (t.has(e)) return t.get(e);
    const o = e instanceof Date ? new Date(e) : e instanceof RegExp ? new RegExp(e.source, e.flags) : e instanceof Set ? new Set : e instanceof Map ? new Map : "function" !== typeof e.constructor ? Object.create(null) : void 0 !== e.prototype && "function" === typeof e.prototype.constructor ? e : new e.constructor;
    if ("function" === typeof e.constructor && "function" === typeof e.valueOf) {
        const o = e.valueOf();
        if (Object(o) !== o) {
            const n = new e.constructor(o);
            return t.set(e, n), n;
        }
    }
    return t.set(e, o), e instanceof Set ? e.forEach((e)=>{
        o.add($ec2fc4c0d7a3c6c6$export$9cd59f9826255e47(e, t));
    }) : e instanceof Map && e.forEach((e, n)=>{
        o.set(n, $ec2fc4c0d7a3c6c6$export$9cd59f9826255e47(e, t));
    }), Object.assign(o, ...Object.keys(e).map((o)=>({
            [o]: $ec2fc4c0d7a3c6c6$export$9cd59f9826255e47(e[o], t)
        })));
}
var $ec2fc4c0d7a3c6c6$export$7a21aee2db893a36 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPopupEdit",
    props: {
        modelValue: {
            required: !0
        },
        title: String,
        buttons: Boolean,
        labelSet: String,
        labelCancel: String,
        color: {
            type: String,
            default: "primary"
        },
        validate: {
            type: Function,
            default: ()=>!0
        },
        autoSave: Boolean,
        cover: {
            type: Boolean,
            default: !0
        },
        disable: Boolean
    },
    emits: [
        "update:modelValue",
        "save",
        "cancel",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(""), r = (0, $01W3b.ref)("");
        let s = !1;
        const u = (0, $TusQn.computed)(()=>{
            return $ec2fc4c0d7a3c6c6$var$injectProp({
                initialValue: i.value,
                validate: e.validate,
                set: c,
                cancel: d,
                updatePosition: p
            }, "value", ()=>r.value, (e)=>{
                r.value = e;
            });
        });
        function c() {
            !1 !== e.validate(r.value) && (!0 === v() && (o("save", r.value, i.value), o("update:modelValue", r.value)), m());
        }
        function d() {
            !0 === v() && o("cancel", r.value, i.value), m();
        }
        function p() {
            (0, $TusQn.nextTick)(()=>{
                l.value.updatePosition();
            });
        }
        function v() {
            return !1 === $ec2fc4c0d7a3c6c6$var$isDeepEqual(r.value, i.value);
        }
        function m() {
            s = !0, l.value.hide();
        }
        function f() {
            s = !1, i.value = $ec2fc4c0d7a3c6c6$export$9cd59f9826255e47(e.modelValue), r.value = $ec2fc4c0d7a3c6c6$export$9cd59f9826255e47(e.modelValue), o("beforeShow");
        }
        function g() {
            o("show");
        }
        function b() {
            !1 === s && !0 === v() && (!0 === e.autoSave && !0 === e.validate(r.value) ? (o("save", r.value, i.value), o("update:modelValue", r.value)) : o("cancel", r.value, i.value)), o("beforeHide");
        }
        function y() {
            o("hide");
        }
        function S() {
            const o = void 0 !== t.default ? [].concat(t.default(u.value)) : [];
            return e.title && o.unshift((0, $TusQn.h)("div", {
                class: "q-dialog__title q-mt-sm q-mb-sm"
            }, e.title)), !0 === e.buttons && o.push((0, $TusQn.h)("div", {
                class: "q-popup-edit__buttons row justify-center no-wrap"
            }, [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    flat: !0,
                    color: e.color,
                    label: e.labelCancel || a.lang.label.cancel,
                    onClick: d
                }),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    flat: !0,
                    color: e.color,
                    label: e.labelSet || a.lang.label.set,
                    onClick: c
                })
            ])), o;
        }
        return Object.assign(n, {
            set: c,
            cancel: d,
            show (e) {
                null !== l.value && l.value.show(e);
            },
            hide (e) {
                null !== l.value && l.value.hide(e);
            },
            updatePosition: p
        }), ()=>{
            if (!0 !== e.disable) return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$73537802004a2118, {
                ref: l,
                class: "q-popup-edit",
                cover: e.cover,
                onBeforeShow: f,
                onShow: g,
                onBeforeHide: b,
                onHide: y,
                onEscapeKey: d
            }, S);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$8d66f956927c5a7b = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPopupProxy",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useAnchorProps,
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 450
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup (e, { slots: t, emit: o, attrs: n }) {
        const { proxy: a } = (0, $TusQn.getCurrentInstance)(), { $q: l } = a, i = (0, $01W3b.ref)(!1), r = (0, $01W3b.ref)(null), s = (0, $TusQn.computed)(()=>parseInt(e.breakpoint, 10)), { canShow: u } = $ec2fc4c0d7a3c6c6$var$useAnchor({
            showing: i
        });
        function c() {
            return l.screen.width < s.value || l.screen.height < s.value ? "dialog" : "menu";
        }
        const d = (0, $01W3b.ref)(c()), p = (0, $TusQn.computed)(()=>"menu" === d.value ? {
                maxHeight: "99vh"
            } : {});
        function v(e) {
            i.value = !0, o("show", e);
        }
        function m(e) {
            i.value = !1, d.value = c(), o("hide", e);
        }
        return (0, $TusQn.watch)(()=>c(), (e)=>{
            !0 !== i.value && (d.value = e);
        }), Object.assign(a, {
            show (e) {
                !0 === u(e) && r.value.show(e);
            },
            hide (e) {
                r.value.hide(e);
            },
            toggle (e) {
                r.value.toggle(e);
            }
        }), $ec2fc4c0d7a3c6c6$var$injectProp(a, "currentComponent", ()=>({
                type: d.value,
                ref: r.value
            })), ()=>{
            const o = {
                ref: r,
                ...p.value,
                ...n,
                onShow: v,
                onHide: m
            };
            let a;
            return "dialog" === d.value ? a = $ec2fc4c0d7a3c6c6$export$e6ccdac5fb3e2417 : (a = $ec2fc4c0d7a3c6c6$export$73537802004a2118, Object.assign(o, {
                target: e.target,
                contextMenu: e.contextMenu,
                noParentEvent: !0,
                separateClosePopup: !0
            })), (0, $TusQn.h)(a, o, t.default);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$defaultSizes = {
    xs: 2,
    sm: 4,
    md: 6,
    lg: 10,
    xl: 14
};
function $ec2fc4c0d7a3c6c6$var$width(e, t, o) {
    return {
        transform: !0 === t ? `translateX(${!0 === o.lang.rtl ? "-" : ""}100%) scale3d(${-e},1,1)` : `scale3d(${e},1,1)`
    };
}
var $ec2fc4c0d7a3c6c6$export$2d10adb726183d68 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QLinearProgress",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
        value: {
            type: Number,
            default: 0
        },
        buffer: Number,
        color: String,
        trackColor: String,
        reverse: Boolean,
        stripe: Boolean,
        indeterminate: Boolean,
        query: Boolean,
        rounded: Boolean,
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 2100
        },
        instantFeedback: Boolean
    },
    setup (e, { slots: t }) {
        const { proxy: o } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.$q), a = $ec2fc4c0d7a3c6c6$var$useSize(e, $ec2fc4c0d7a3c6c6$var$defaultSizes), l = (0, $TusQn.computed)(()=>!0 === e.indeterminate || !0 === e.query), i = (0, $TusQn.computed)(()=>e.reverse !== e.query), r = (0, $TusQn.computed)(()=>({
                ...null !== a.value ? a.value : {},
                "--q-linear-progress-speed": `${e.animationSpeed}ms`
            })), s = (0, $TusQn.computed)(()=>"q-linear-progress" + (void 0 !== e.color ? ` text-${e.color}` : "") + (!0 === e.reverse || !0 === e.query ? " q-linear-progress--reverse" : "") + (!0 === e.rounded ? " rounded-borders" : "")), u = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$width(void 0 !== e.buffer ? e.buffer : 1, i.value, o.$q)), c = (0, $TusQn.computed)(()=>`with${!0 === e.instantFeedback ? "out" : ""}-transition`), d = (0, $TusQn.computed)(()=>"q-linear-progress__track absolute-full" + ` q-linear-progress__track--${c.value}` + ` q-linear-progress__track--${!0 === n.value ? "dark" : "light"}` + (void 0 !== e.trackColor ? ` bg-${e.trackColor}` : "")), p = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$width(!0 === l.value ? 1 : e.value, i.value, o.$q)), v = (0, $TusQn.computed)(()=>"q-linear-progress__model absolute-full" + ` q-linear-progress__model--${c.value}` + ` q-linear-progress__model--${!0 === l.value ? "in" : ""}determinate`), m = (0, $TusQn.computed)(()=>({
                width: `${100 * e.value}%`
            })), f = (0, $TusQn.computed)(()=>`q-linear-progress__stripe absolute-${!0 === e.reverse ? "right" : "left"}` + ` q-linear-progress__stripe--${c.value}`);
        return ()=>{
            const o = [
                (0, $TusQn.h)("div", {
                    class: d.value,
                    style: u.value
                }),
                (0, $TusQn.h)("div", {
                    class: v.value,
                    style: p.value
                })
            ];
            return !0 === e.stripe && !1 === l.value && o.push((0, $TusQn.h)("div", {
                class: f.value,
                style: m.value
            })), (0, $TusQn.h)("div", {
                class: s.value,
                style: r.value,
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 1,
                "aria-valuenow": !0 === e.indeterminate ? void 0 : e.value
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, o));
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT = 40, $ec2fc4c0d7a3c6c6$var$OFFSET_TOP = 20;
var $ec2fc4c0d7a3c6c6$export$38ad2c7cb47d3fec = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QPullToRefresh",
    props: {
        color: String,
        bgColor: String,
        icon: String,
        noMouse: Boolean,
        disable: Boolean,
        scrollTarget: {
            default: void 0
        }
    },
    emits: [
        "refresh"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = (0, $01W3b.ref)("pull"), i = (0, $01W3b.ref)(0), r = (0, $01W3b.ref)(!1), s = (0, $01W3b.ref)(-$ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT), u = (0, $01W3b.ref)(!1), c = (0, $01W3b.ref)({}), d = (0, $TusQn.computed)(()=>({
                opacity: i.value,
                transform: `translateY(${s.value}px) rotate(${360 * i.value}deg)`
            })), p = (0, $TusQn.computed)(()=>"q-pull-to-refresh__puller row flex-center" + (!0 === u.value ? " q-pull-to-refresh__puller--animating" : "") + (void 0 !== e.bgColor ? ` bg-${e.bgColor}` : ""));
        function v(e) {
            if (!0 === e.isFinal) return void (!0 === r.value && (r.value = !1, "pulled" === l.value ? (l.value = "refreshing", w({
                pos: $ec2fc4c0d7a3c6c6$var$OFFSET_TOP
            }), g()) : "pull" === l.value && w({
                pos: -$ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT,
                ratio: 0
            })));
            if (!0 === u.value || "refreshing" === l.value) return !1;
            if (!0 === e.isFirst) {
                if (0 !== $ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(y) || "down" !== e.direction) return !0 === r.value && (r.value = !1, l.value = "pull", w({
                    pos: -$ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT,
                    ratio: 0
                })), !1;
                r.value = !0;
                const { top: t, left: o } = b.getBoundingClientRect();
                c.value = {
                    top: t + "px",
                    left: o + "px",
                    width: window.getComputedStyle(b).getPropertyValue("width")
                };
            }
            $ec2fc4c0d7a3c6c6$var$prevent(e.evt);
            const t = Math.min(140, Math.max(0, e.distance.y));
            s.value = t - $ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT, i.value = $ec2fc4c0d7a3c6c6$var$between(t / ($ec2fc4c0d7a3c6c6$var$OFFSET_TOP + $ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT), 0, 1);
            const o = s.value > $ec2fc4c0d7a3c6c6$var$OFFSET_TOP ? "pulled" : "pull";
            l.value !== o && (l.value = o);
        }
        const m = (0, $TusQn.computed)(()=>{
            const t = {
                down: !0
            };
            return !0 !== e.noMouse && (t.mouse = !0), [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    v,
                    void 0,
                    t
                ]
            ];
        }), f = (0, $TusQn.computed)(()=>`q-pull-to-refresh__content${!0 === r.value ? " no-pointer-events" : ""}`);
        function g() {
            o("refresh", ()=>{
                w({
                    pos: -$ec2fc4c0d7a3c6c6$var$PULLER_HEIGHT,
                    ratio: 0
                }, ()=>{
                    l.value = "pull";
                });
            });
        }
        let b, y, S = null;
        function w({ pos: e, ratio: t }, o) {
            u.value = !0, s.value = e, void 0 !== t && (i.value = t), null !== S && clearTimeout(S), S = setTimeout(()=>{
                S = null, u.value = !1, o && o();
            }, 300);
        }
        function C() {
            y = $ec2fc4c0d7a3c6c6$var$getScrollTarget(b, e.scrollTarget);
        }
        return (0, $TusQn.watch)(()=>e.scrollTarget, C), (0, $TusQn.onMounted)(()=>{
            b = n.$el, C();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            null !== S && clearTimeout(S);
        }), Object.assign(n, {
            trigger: g,
            updateScrollTarget: C
        }), ()=>{
            const o = [
                (0, $TusQn.h)("div", {
                    class: f.value
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default)),
                (0, $TusQn.h)("div", {
                    class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
                    style: c.value
                }, [
                    (0, $TusQn.h)("div", {
                        class: p.value,
                        style: d.value
                    }, [
                        "refreshing" !== l.value ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                            name: e.icon || a.iconSet.pullToRefresh.icon,
                            color: e.color,
                            size: "32px"
                        }) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0, {
                            size: "24px",
                            color: e.color
                        })
                    ])
                ])
            ];
            return $ec2fc4c0d7a3c6c6$var$hDir("div", {
                class: "q-pull-to-refresh"
            }, o, "main", !1 === e.disable, ()=>m.value);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$dragType = {
    MIN: 0,
    RANGE: 1,
    MAX: 2
};
var $ec2fc4c0d7a3c6c6$export$396f1d127e5ea44f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QRange",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useSliderProps,
        modelValue: {
            type: Object,
            default: ()=>({
                    min: null,
                    max: null
                }),
            validator: (e)=>"min" in e && "max" in e
        },
        dragRange: Boolean,
        dragOnlyRange: Boolean,
        leftLabelColor: String,
        leftLabelTextColor: String,
        rightLabelColor: String,
        rightLabelTextColor: String,
        leftLabelValue: [
            String,
            Number
        ],
        rightLabelValue: [
            String,
            Number
        ],
        leftThumbColor: String,
        rightThumbColor: String
    },
    emits: $ec2fc4c0d7a3c6c6$var$useSliderEmits,
    setup (e, { emit: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), { state: n, methods: a } = $ec2fc4c0d7a3c6c6$var$useSlider({
            updateValue: _,
            updatePosition: T,
            getDragging: q,
            formAttrs: (0, $TusQn.computed)(()=>({
                    type: "hidden",
                    name: e.name,
                    value: `${e.modelValue.min}|${e.modelValue.max}`
                }))
        }), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(0), r = (0, $01W3b.ref)(0), s = (0, $01W3b.ref)({
            min: 0,
            max: 0
        });
        function u() {
            s.value.min = null === e.modelValue.min ? n.innerMin.value : $ec2fc4c0d7a3c6c6$var$between(e.modelValue.min, n.innerMin.value, n.innerMax.value), s.value.max = null === e.modelValue.max ? n.innerMax.value : $ec2fc4c0d7a3c6c6$var$between(e.modelValue.max, n.innerMin.value, n.innerMax.value);
        }
        (0, $TusQn.watch)(()=>`${e.modelValue.min}|${e.modelValue.max}|${n.innerMin.value}|${n.innerMax.value}`, u), u();
        const c = (0, $TusQn.computed)(()=>a.convertModelToRatio(s.value.min)), d = (0, $TusQn.computed)(()=>a.convertModelToRatio(s.value.max)), p = (0, $TusQn.computed)(()=>!0 === n.active.value ? i.value : c.value), v = (0, $TusQn.computed)(()=>!0 === n.active.value ? r.value : d.value), m = (0, $TusQn.computed)(()=>{
            const t = {
                [n.positionProp.value]: `${100 * p.value}%`,
                [n.sizeProp.value]: `${100 * (v.value - p.value)}%`
            };
            return void 0 !== e.selectionImg && (t.backgroundImage = `url(${e.selectionImg}) !important`), t;
        }), f = (0, $TusQn.computed)(()=>{
            if (!0 !== n.editable.value) return {};
            if (!0 === o.platform.is.mobile) return {
                onClick: a.onMobileClick
            };
            const t = {
                onMousedown: a.onActivate
            };
            return !0 !== e.dragRange && !0 !== e.dragOnlyRange || Object.assign(t, {
                onFocus: ()=>{
                    n.focus.value = "both";
                },
                onBlur: a.onBlur,
                onKeydown: P,
                onKeyup: a.onKeyup
            }), t;
        });
        function g(t) {
            return !0 !== o.platform.is.mobile && !0 === n.editable.value && !0 !== e.dragOnlyRange ? {
                onFocus: ()=>{
                    n.focus.value = t;
                },
                onBlur: a.onBlur,
                onKeydown: P,
                onKeyup: a.onKeyup
            } : {};
        }
        const b = (0, $TusQn.computed)(()=>!0 !== e.dragOnlyRange ? n.tabindex.value : null), y = (0, $TusQn.computed)(()=>!0 === o.platform.is.mobile || !e.dragRange && !0 !== e.dragOnlyRange ? null : n.tabindex.value), S = (0, $01W3b.ref)(null), w = (0, $TusQn.computed)(()=>g("min")), C = a.getThumbRenderFn({
            focusValue: "min",
            getNodeData: ()=>({
                    ref: S,
                    key: "tmin",
                    ...w.value,
                    tabindex: b.value
                }),
            ratio: p,
            label: (0, $TusQn.computed)(()=>void 0 !== e.leftLabelValue ? e.leftLabelValue : s.value.min),
            thumbColor: (0, $TusQn.computed)(()=>e.leftThumbColor || e.thumbColor || e.color),
            labelColor: (0, $TusQn.computed)(()=>e.leftLabelColor || e.labelColor),
            labelTextColor: (0, $TusQn.computed)(()=>e.leftLabelTextColor || e.labelTextColor)
        }), x = (0, $TusQn.computed)(()=>g("max")), k = a.getThumbRenderFn({
            focusValue: "max",
            getNodeData: ()=>({
                    ...x.value,
                    key: "tmax",
                    tabindex: b.value
                }),
            ratio: v,
            label: (0, $TusQn.computed)(()=>void 0 !== e.rightLabelValue ? e.rightLabelValue : s.value.max),
            thumbColor: (0, $TusQn.computed)(()=>e.rightThumbColor || e.thumbColor || e.color),
            labelColor: (0, $TusQn.computed)(()=>e.rightLabelColor || e.labelColor),
            labelTextColor: (0, $TusQn.computed)(()=>e.rightLabelTextColor || e.labelTextColor)
        });
        function _(o) {
            s.value.min === e.modelValue.min && s.value.max === e.modelValue.max || t("update:modelValue", {
                ...s.value
            }), !0 === o && t("change", {
                ...s.value
            });
        }
        function q(t) {
            const { left: o, top: n, width: i, height: r } = l.value.getBoundingClientRect(), u = !0 === e.dragOnlyRange ? 0 : !0 === e.vertical ? S.value.offsetHeight / (2 * r) : S.value.offsetWidth / (2 * i), p = {
                left: o,
                top: n,
                width: i,
                height: r,
                valueMin: s.value.min,
                valueMax: s.value.max,
                ratioMin: c.value,
                ratioMax: d.value
            }, v = a.getDraggingRatio(t, p);
            return !0 !== e.dragOnlyRange && v < p.ratioMin + u ? p.type = $ec2fc4c0d7a3c6c6$var$dragType.MIN : !0 === e.dragOnlyRange || v < p.ratioMax - u ? !0 === e.dragRange || !0 === e.dragOnlyRange ? (p.type = $ec2fc4c0d7a3c6c6$var$dragType.RANGE, Object.assign(p, {
                offsetRatio: v,
                offsetModel: a.convertRatioToModel(v),
                rangeValue: p.valueMax - p.valueMin,
                rangeRatio: p.ratioMax - p.ratioMin
            })) : p.type = p.ratioMax - v < v - p.ratioMin ? $ec2fc4c0d7a3c6c6$var$dragType.MAX : $ec2fc4c0d7a3c6c6$var$dragType.MIN : p.type = $ec2fc4c0d7a3c6c6$var$dragType.MAX, p;
        }
        function T(t, o = n.dragging.value) {
            let l;
            const u = a.getDraggingRatio(t, o), c = a.convertRatioToModel(u);
            switch(o.type){
                case $ec2fc4c0d7a3c6c6$var$dragType.MIN:
                    u <= o.ratioMax ? (l = {
                        minR: u,
                        maxR: o.ratioMax,
                        min: c,
                        max: o.valueMax
                    }, n.focus.value = "min") : (l = {
                        minR: o.ratioMax,
                        maxR: u,
                        min: o.valueMax,
                        max: c
                    }, n.focus.value = "max");
                    break;
                case $ec2fc4c0d7a3c6c6$var$dragType.MAX:
                    u >= o.ratioMin ? (l = {
                        minR: o.ratioMin,
                        maxR: u,
                        min: o.valueMin,
                        max: c
                    }, n.focus.value = "max") : (l = {
                        minR: u,
                        maxR: o.ratioMin,
                        min: c,
                        max: o.valueMin
                    }, n.focus.value = "min");
                    break;
                case $ec2fc4c0d7a3c6c6$var$dragType.RANGE:
                    const t1 = u - o.offsetRatio, a1 = $ec2fc4c0d7a3c6c6$var$between(o.ratioMin + t1, 0, 1 - o.rangeRatio), i1 = c - o.offsetModel, r1 = $ec2fc4c0d7a3c6c6$var$between(o.valueMin + i1, e.min, e.max - o.rangeValue);
                    l = {
                        minR: a1,
                        maxR: a1 + o.rangeRatio,
                        min: parseFloat(r1.toFixed(n.decimals.value)),
                        max: parseFloat((r1 + o.rangeValue).toFixed(n.decimals.value))
                    }, n.focus.value = "both";
                    break;
            }
            s.value = null === s.value.min || null === s.value.max ? {
                min: l.min || e.min,
                max: l.max || e.max
            } : {
                min: l.min,
                max: l.max
            }, !0 !== e.snap || 0 === e.step ? (i.value = l.minR, r.value = l.maxR) : (i.value = a.convertModelToRatio(s.value.min), r.value = a.convertModelToRatio(s.value.max));
        }
        function P(t) {
            if (!$ec2fc4c0d7a3c6c6$var$keyCodes$2.includes(t.keyCode)) return;
            $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t);
            const o = ([
                34,
                33
            ].includes(t.keyCode) ? 10 : 1) * n.step.value, a = ([
                34,
                37,
                40
            ].includes(t.keyCode) ? -1 : 1) * (!0 === n.isReversed.value ? -1 : 1) * (!0 === e.vertical ? -1 : 1) * o;
            if ("both" === n.focus.value) {
                const e = s.value.max - s.value.min, t = $ec2fc4c0d7a3c6c6$var$between(parseFloat((s.value.min + a).toFixed(n.decimals.value)), n.innerMin.value, n.innerMax.value - e);
                s.value = {
                    min: t,
                    max: parseFloat((t + e).toFixed(n.decimals.value))
                };
            } else {
                if (!1 === n.focus.value) return;
                {
                    const e = n.focus.value;
                    s.value = {
                        ...s.value,
                        [e]: $ec2fc4c0d7a3c6c6$var$between(parseFloat((s.value[e] + a).toFixed(n.decimals.value)), "min" === e ? n.innerMin.value : s.value.min, "max" === e ? n.innerMax.value : s.value.max)
                    };
                }
            }
            _();
        }
        return ()=>{
            const t = a.getContent(m, y, f, (e)=>{
                e.push(C(), k());
            });
            return (0, $TusQn.h)("div", {
                ref: l,
                class: "q-range " + n.classes.value + (null === e.modelValue.min || null === e.modelValue.max ? " q-slider--no-value" : ""),
                ...n.attributes.value,
                "aria-valuenow": e.modelValue.min + "|" + e.modelValue.max
            }, t);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$97d378c58b81b163 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QRating",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useSizeProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        modelValue: {
            type: Number,
            required: !0
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 5
        },
        icon: [
            String,
            Array
        ],
        iconHalf: [
            String,
            Array
        ],
        iconSelected: [
            String,
            Array
        ],
        iconAriaLabel: [
            String,
            Array
        ],
        color: [
            String,
            Array
        ],
        colorHalf: [
            String,
            Array
        ],
        colorSelected: [
            String,
            Array
        ],
        noReset: Boolean,
        noDimming: Boolean,
        readonly: Boolean,
        disable: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useSize(e), l = $ec2fc4c0d7a3c6c6$var$useFormAttrs(e), i = $ec2fc4c0d7a3c6c6$var$useFormInject(l), r = (0, $01W3b.ref)(0);
        let s = {};
        const u = (0, $TusQn.computed)(()=>!0 !== e.readonly && !0 !== e.disable), c = (0, $TusQn.computed)(()=>"q-rating row inline items-center" + ` q-rating--${!0 === u.value ? "" : "non-"}editable` + (!0 === e.noDimming ? " q-rating--no-dimming" : "") + (!0 === e.disable ? " disabled" : "") + (void 0 !== e.color && !1 === Array.isArray(e.color) ? ` text-${e.color}` : "")), d = (0, $TusQn.computed)(()=>{
            const t = !0 === Array.isArray(e.icon) ? e.icon.length : 0, o = !0 === Array.isArray(e.iconSelected) ? e.iconSelected.length : 0, n = !0 === Array.isArray(e.iconHalf) ? e.iconHalf.length : 0, a = !0 === Array.isArray(e.color) ? e.color.length : 0, l = !0 === Array.isArray(e.colorSelected) ? e.colorSelected.length : 0, i = !0 === Array.isArray(e.colorHalf) ? e.colorHalf.length : 0;
            return {
                iconLen: t,
                icon: t > 0 ? e.icon[t - 1] : e.icon,
                selIconLen: o,
                selIcon: o > 0 ? e.iconSelected[o - 1] : e.iconSelected,
                halfIconLen: n,
                halfIcon: n > 0 ? e.iconHalf[o - 1] : e.iconHalf,
                colorLen: a,
                color: a > 0 ? e.color[a - 1] : e.color,
                selColorLen: l,
                selColor: l > 0 ? e.colorSelected[l - 1] : e.colorSelected,
                halfColorLen: i,
                halfColor: i > 0 ? e.colorHalf[i - 1] : e.colorHalf
            };
        }), p = (0, $TusQn.computed)(()=>{
            if ("string" === typeof e.iconAriaLabel) {
                const t = 0 !== e.iconAriaLabel.length ? `${e.iconAriaLabel} ` : "";
                return (e)=>`${t}${e}`;
            }
            if (!0 === Array.isArray(e.iconAriaLabel)) {
                const t = e.iconAriaLabel.length;
                if (t > 0) return (o)=>e.iconAriaLabel[Math.min(o, t) - 1];
            }
            return (e, t)=>`${t} ${e}`;
        }), v = (0, $TusQn.computed)(()=>{
            const t = [], o = d.value, a = Math.ceil(e.modelValue), l = !0 === u.value ? 0 : null, i = void 0 === e.iconHalf || a === e.modelValue ? -1 : a;
            for(let s = 1; s <= e.max; s++){
                const u = 0 === r.value && e.modelValue >= s || r.value > 0 && r.value >= s, c = i === s && r.value < s, d = r.value > 0 && (!0 === c ? a : e.modelValue) >= s && r.value < s, v = !0 === c ? s <= o.halfColorLen ? e.colorHalf[s - 1] : o.halfColor : void 0 !== o.selColor && !0 === u ? s <= o.selColorLen ? e.colorSelected[s - 1] : o.selColor : s <= o.colorLen ? e.color[s - 1] : o.color, m = (!0 === c ? s <= o.halfIconLen ? e.iconHalf[s - 1] : o.halfIcon : void 0 === o.selIcon || !0 !== u && !0 !== d ? s <= o.iconLen ? e.icon[s - 1] : o.icon : s <= o.selIconLen ? e.iconSelected[s - 1] : o.selIcon) || n.iconSet.rating.icon;
                t.push({
                    name: (!0 === c ? s <= o.halfIconLen ? e.iconHalf[s - 1] : o.halfIcon : void 0 === o.selIcon || !0 !== u && !0 !== d ? s <= o.iconLen ? e.icon[s - 1] : o.icon : s <= o.selIconLen ? e.iconSelected[s - 1] : o.selIcon) || n.iconSet.rating.icon,
                    attrs: {
                        tabindex: l,
                        role: "radio",
                        "aria-checked": e.modelValue === s ? "true" : "false",
                        "aria-label": p.value(s, m)
                    },
                    iconClass: "q-rating__icon" + (!0 === u || !0 === c ? " q-rating__icon--active" : "") + (!0 === d ? " q-rating__icon--exselected" : "") + (r.value === s ? " q-rating__icon--hovered" : "") + (void 0 !== v ? ` text-${v}` : "")
                });
            }
            return t;
        }), m = (0, $TusQn.computed)(()=>{
            const t = {
                role: "radiogroup"
            };
            return !0 === e.disable && (t["aria-disabled"] = "true"), !0 === e.readonly && (t["aria-readonly"] = "true"), t;
        });
        function f(t) {
            if (!0 === u.value) {
                const n = $ec2fc4c0d7a3c6c6$var$between(parseInt(t, 10), 1, parseInt(e.max, 10)), a = !0 !== e.noReset && e.modelValue === n ? 0 : n;
                a !== e.modelValue && o("update:modelValue", a), r.value = 0;
            }
        }
        function g(e) {
            !0 === u.value && (r.value = e);
        }
        function b(e, t) {
            switch(e.keyCode){
                case 13:
                case 32:
                    return f(t), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
                case 37:
                case 40:
                    return s[`rt${t - 1}`] && s[`rt${t - 1}`].focus(), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
                case 39:
                case 38:
                    return s[`rt${t + 1}`] && s[`rt${t + 1}`].focus(), $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e);
            }
        }
        function y() {
            r.value = 0;
        }
        return (0, $TusQn.onBeforeUpdate)(()=>{
            s = {};
        }), ()=>{
            const o = [];
            return v.value.forEach(({ iconClass: e, name: n, attrs: a }, l)=>{
                const i = l + 1;
                o.push((0, $TusQn.h)("div", {
                    key: i,
                    ref: (e)=>{
                        s[`rt${i}`] = e;
                    },
                    class: "q-rating__icon-container flex flex-center",
                    ...a,
                    onClick () {
                        f(i);
                    },
                    onMouseover () {
                        g(i);
                    },
                    onMouseout: y,
                    onFocus () {
                        g(i);
                    },
                    onBlur: y,
                    onKeyup (e) {
                        b(e, i);
                    }
                }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t[`tip-${i}`], [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        class: e,
                        name: n
                    })
                ])));
            }), void 0 !== e.name && !0 !== e.disable && i(o, "push"), (0, $TusQn.h)("div", {
                class: c.value,
                style: a.value,
                ...m.value
            }, o);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$9f7ab13694915fcc = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QResponsive",
    props: $ec2fc4c0d7a3c6c6$var$useRatioProps,
    setup (e, { slots: t }) {
        const o = $ec2fc4c0d7a3c6c6$var$useRatio(e);
        return ()=>(0, $TusQn.h)("div", {
                class: "q-responsive"
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-responsive__filler overflow-hidden"
                }, [
                    (0, $TusQn.h)("div", {
                        style: o.value
                    })
                ]),
                (0, $TusQn.h)("div", {
                    class: "q-responsive__content absolute-full fit"
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default))
            ]);
    }
});
const $ec2fc4c0d7a3c6c6$var$axisList = [
    "vertical",
    "horizontal"
], $ec2fc4c0d7a3c6c6$var$dirProps = {
    vertical: {
        offset: "offsetY",
        scroll: "scrollTop",
        dir: "down",
        dist: "y"
    },
    horizontal: {
        offset: "offsetX",
        scroll: "scrollLeft",
        dir: "right",
        dist: "x"
    }
}, $ec2fc4c0d7a3c6c6$var$panOpts = {
    prevent: !0,
    mouse: !0,
    mouseAllDir: !0
}, $ec2fc4c0d7a3c6c6$var$getMinThumbSize = (e)=>e >= 250 ? 50 : Math.ceil(e / 5);
var $ec2fc4c0d7a3c6c6$export$6c88fb8d3b5e5b80 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QScrollArea",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        thumbStyle: Object,
        verticalThumbStyle: Object,
        horizontalThumbStyle: Object,
        barStyle: [
            Array,
            String,
            Object
        ],
        verticalBarStyle: [
            Array,
            String,
            Object
        ],
        horizontalBarStyle: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        contentActiveStyle: [
            Array,
            String,
            Object
        ],
        delay: {
            type: [
                String,
                Number
            ],
            default: 1e3
        },
        visible: {
            type: Boolean,
            default: null
        },
        tabindex: [
            String,
            Number
        ],
        onScroll: Function
    },
    setup (e, { slots: t, emit: o }) {
        const n = (0, $01W3b.ref)(!1), a = (0, $01W3b.ref)(!1), l = (0, $01W3b.ref)(!1), i = {
            vertical: (0, $01W3b.ref)(0),
            horizontal: (0, $01W3b.ref)(0)
        }, r = {
            vertical: {
                ref: (0, $01W3b.ref)(null),
                position: (0, $01W3b.ref)(0),
                size: (0, $01W3b.ref)(0)
            },
            horizontal: {
                ref: (0, $01W3b.ref)(null),
                position: (0, $01W3b.ref)(0),
                size: (0, $01W3b.ref)(0)
            }
        }, { proxy: s } = (0, $TusQn.getCurrentInstance)(), u = $ec2fc4c0d7a3c6c6$var$useDark(e, s.$q);
        let c, d = null;
        const p = (0, $01W3b.ref)(null), v = (0, $TusQn.computed)(()=>"q-scrollarea" + (!0 === u.value ? " q-scrollarea--dark" : ""));
        r.vertical.percentage = (0, $TusQn.computed)(()=>{
            const e = r.vertical.size.value - i.vertical.value;
            if (e <= 0) return 0;
            const t = $ec2fc4c0d7a3c6c6$var$between(r.vertical.position.value / e, 0, 1);
            return Math.round(1e4 * t) / 1e4;
        }), r.vertical.thumbHidden = (0, $TusQn.computed)(()=>!0 !== (null === e.visible ? l.value : e.visible) && !1 === n.value && !1 === a.value || r.vertical.size.value <= i.vertical.value + 1), r.vertical.thumbStart = (0, $TusQn.computed)(()=>r.vertical.percentage.value * (i.vertical.value - r.vertical.thumbSize.value)), r.vertical.thumbSize = (0, $TusQn.computed)(()=>Math.round($ec2fc4c0d7a3c6c6$var$between(i.vertical.value * i.vertical.value / r.vertical.size.value, $ec2fc4c0d7a3c6c6$var$getMinThumbSize(i.vertical.value), i.vertical.value))), r.vertical.style = (0, $TusQn.computed)(()=>{
            return {
                ...e.thumbStyle,
                ...e.verticalThumbStyle,
                top: `${r.vertical.thumbStart.value}px`,
                height: `${r.vertical.thumbSize.value}px`
            };
        }), r.vertical.thumbClass = (0, $TusQn.computed)(()=>"q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (!0 === r.vertical.thumbHidden.value ? " q-scrollarea__thumb--invisible" : "")), r.vertical.barClass = (0, $TusQn.computed)(()=>"q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (!0 === r.vertical.thumbHidden.value ? " q-scrollarea__bar--invisible" : "")), r.horizontal.percentage = (0, $TusQn.computed)(()=>{
            const e = r.horizontal.size.value - i.horizontal.value;
            if (e <= 0) return 0;
            const t = $ec2fc4c0d7a3c6c6$var$between(Math.abs(r.horizontal.position.value) / e, 0, 1);
            return Math.round(1e4 * t) / 1e4;
        }), r.horizontal.thumbHidden = (0, $TusQn.computed)(()=>!0 !== (null === e.visible ? l.value : e.visible) && !1 === n.value && !1 === a.value || r.horizontal.size.value <= i.horizontal.value + 1), r.horizontal.thumbStart = (0, $TusQn.computed)(()=>r.horizontal.percentage.value * (i.horizontal.value - r.horizontal.thumbSize.value)), r.horizontal.thumbSize = (0, $TusQn.computed)(()=>Math.round($ec2fc4c0d7a3c6c6$var$between(i.horizontal.value * i.horizontal.value / r.horizontal.size.value, $ec2fc4c0d7a3c6c6$var$getMinThumbSize(i.horizontal.value), i.horizontal.value))), r.horizontal.style = (0, $TusQn.computed)(()=>{
            return {
                ...e.thumbStyle,
                ...e.horizontalThumbStyle,
                [!0 === s.$q.lang.rtl ? "right" : "left"]: `${r.horizontal.thumbStart.value}px`,
                width: `${r.horizontal.thumbSize.value}px`
            };
        }), r.horizontal.thumbClass = (0, $TusQn.computed)(()=>"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (!0 === r.horizontal.thumbHidden.value ? " q-scrollarea__thumb--invisible" : "")), r.horizontal.barClass = (0, $TusQn.computed)(()=>"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (!0 === r.horizontal.thumbHidden.value ? " q-scrollarea__bar--invisible" : ""));
        const m = (0, $TusQn.computed)(()=>!0 === r.vertical.thumbHidden.value && !0 === r.horizontal.thumbHidden.value ? e.contentStyle : e.contentActiveStyle), f = [
            [
                $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                (e)=>{
                    k(e, "vertical");
                },
                void 0,
                {
                    vertical: !0,
                    ...$ec2fc4c0d7a3c6c6$var$panOpts
                }
            ]
        ], g = [
            [
                $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                (e)=>{
                    k(e, "horizontal");
                },
                void 0,
                {
                    horizontal: !0,
                    ...$ec2fc4c0d7a3c6c6$var$panOpts
                }
            ]
        ];
        function b() {
            const e = {};
            return $ec2fc4c0d7a3c6c6$var$axisList.forEach((t)=>{
                const o = r[t];
                e[t + "Position"] = o.position.value, e[t + "Percentage"] = o.percentage.value, e[t + "Size"] = o.size.value, e[t + "ContainerSize"] = i[t].value;
            }), e;
        }
        const y = $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(()=>{
            const e = b();
            e.ref = s, o("scroll", e);
        }, 0);
        function S(e, t, o) {
            if (!1 === $ec2fc4c0d7a3c6c6$var$axisList.includes(e)) return void console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
            const n = "vertical" === e ? $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition : $ec2fc4c0d7a3c6c6$var$setHorizontalScrollPosition;
            n(p.value, t, o);
        }
        function w({ height: e, width: t }) {
            let o = !1;
            i.vertical.value !== e && (i.vertical.value = e, o = !0), i.horizontal.value !== t && (i.horizontal.value = t, o = !0), !0 === o && P();
        }
        function C({ position: e }) {
            let t = !1;
            r.vertical.position.value !== e.top && (r.vertical.position.value = e.top, t = !0), r.horizontal.position.value !== e.left && (r.horizontal.position.value = e.left, t = !0), !0 === t && P();
        }
        function x({ height: e, width: t }) {
            r.horizontal.size.value !== t && (r.horizontal.size.value = t, P()), r.vertical.size.value !== e && (r.vertical.size.value = e, P());
        }
        function k(e, t) {
            const o = r[t];
            if (!0 === e.isFirst) {
                if (!0 === o.thumbHidden.value) return;
                c = o.position.value, a.value = !0;
            } else if (!0 !== a.value) return;
            !0 === e.isFinal && (a.value = !1);
            const n = $ec2fc4c0d7a3c6c6$var$dirProps[t], l = i[t].value, s = (o.size.value - l) / (l - o.thumbSize.value), u = e.distance[n.dist], d = c + (e.direction === n.dir ? 1 : -1) * u * s;
            $(d, t);
        }
        function _(e, t) {
            const o = r[t];
            if (!0 !== o.thumbHidden.value) {
                const n = e[$ec2fc4c0d7a3c6c6$var$dirProps[t].offset];
                if (n < o.thumbStart.value || n > o.thumbStart.value + o.thumbSize.value) {
                    const e = n - o.thumbSize.value / 2;
                    $(e / i[t].value * o.size.value, t);
                }
                null !== o.ref.value && o.ref.value.dispatchEvent(new MouseEvent(e.type, e));
            }
        }
        function q(e) {
            _(e, "vertical");
        }
        function T(e) {
            _(e, "horizontal");
        }
        function P() {
            n.value = !0, null !== d && clearTimeout(d), d = setTimeout(()=>{
                d = null, n.value = !1;
            }, e.delay), void 0 !== e.onScroll && y();
        }
        function $(e, t) {
            p.value[$ec2fc4c0d7a3c6c6$var$dirProps[t].scroll] = e;
        }
        function M() {
            l.value = !0;
        }
        function B() {
            l.value = !1;
        }
        let E = null;
        return (0, $TusQn.watch)(()=>s.$q.lang.rtl, (e)=>{
            null !== p.value && $ec2fc4c0d7a3c6c6$var$setHorizontalScrollPosition(p.value, Math.abs(r.horizontal.position.value) * (!0 === e ? -1 : 1));
        }), (0, $TusQn.onDeactivated)(()=>{
            E = {
                top: r.vertical.position.value,
                left: r.horizontal.position.value
            };
        }), (0, $TusQn.onActivated)(()=>{
            if (null === E) return;
            const e = p.value;
            null !== e && ($ec2fc4c0d7a3c6c6$var$setHorizontalScrollPosition(e, E.left), $ec2fc4c0d7a3c6c6$var$setVerticalScrollPosition(e, E.top));
        }), (0, $TusQn.onBeforeUnmount)(y.cancel), Object.assign(s, {
            getScrollTarget: ()=>p.value,
            getScroll: b,
            getScrollPosition: ()=>({
                    top: r.vertical.position.value,
                    left: r.horizontal.position.value
                }),
            getScrollPercentage: ()=>({
                    top: r.vertical.percentage.value,
                    left: r.horizontal.percentage.value
                }),
            setScrollPosition: S,
            setScrollPercentage (e, t, o) {
                S(e, t * (r[e].size.value - i[e].value) * ("horizontal" === e && !0 === s.$q.lang.rtl ? -1 : 1), o);
            }
        }), ()=>{
            return (0, $TusQn.h)("div", {
                class: v.value,
                onMouseenter: M,
                onMouseleave: B
            }, [
                (0, $TusQn.h)("div", {
                    ref: p,
                    class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
                    tabindex: void 0 !== e.tabindex ? e.tabindex : void 0
                }, [
                    (0, $TusQn.h)("div", {
                        class: "q-scrollarea__content absolute",
                        style: m.value
                    }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                            debounce: 0,
                            onResize: x
                        })
                    ])),
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d6d34850bd31dad, {
                        axis: "both",
                        onScroll: C
                    })
                ]),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$614f53fe102a3da7, {
                    debounce: 0,
                    onResize: w
                }),
                (0, $TusQn.h)("div", {
                    class: r.vertical.barClass.value,
                    style: [
                        e.barStyle,
                        e.verticalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: q
                }),
                (0, $TusQn.h)("div", {
                    class: r.horizontal.barClass.value,
                    style: [
                        e.barStyle,
                        e.horizontalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: T
                }),
                (0, $TusQn.withDirectives)((0, $TusQn.h)("div", {
                    ref: r.vertical.ref,
                    class: r.vertical.thumbClass.value,
                    style: r.vertical.style.value,
                    "aria-hidden": "true"
                }), f),
                (0, $TusQn.withDirectives)((0, $TusQn.h)("div", {
                    ref: r.horizontal.ref,
                    class: r.horizontal.thumbClass.value,
                    style: r.horizontal.style.value,
                    "aria-hidden": "true"
                }), g)
            ]);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$aggBucketSize = 1e3, $ec2fc4c0d7a3c6c6$var$scrollToEdges = [
    "start",
    "center",
    "end",
    "start-force",
    "center-force",
    "end-force"
], $ec2fc4c0d7a3c6c6$var$filterProto = Array.prototype.filter, $ec2fc4c0d7a3c6c6$var$setOverflowAnchor = void 0 === window.getComputedStyle(document.body).overflowAnchor ? $ec2fc4c0d7a3c6c6$export$8793edee2d425525 : function(e, t) {
    null !== e && (void 0 !== e._qOverflowAnimationFrame && cancelAnimationFrame(e._qOverflowAnimationFrame), e._qOverflowAnimationFrame = requestAnimationFrame(()=>{
        if (null === e) return;
        e._qOverflowAnimationFrame = void 0;
        const o = e.children || [];
        $ec2fc4c0d7a3c6c6$var$filterProto.call(o, (e)=>e.dataset && void 0 !== e.dataset.qVsAnchor).forEach((e)=>{
            delete e.dataset.qVsAnchor;
        });
        const n = o[t];
        n && n.dataset && (n.dataset.qVsAnchor = "");
    }));
};
function $ec2fc4c0d7a3c6c6$var$sumFn(e, t) {
    return e + t;
}
function $ec2fc4c0d7a3c6c6$var$getScrollDetails(e, t, o, n, a, l, i, r) {
    const s = e === window ? document.scrollingElement || document.documentElement : e, u = !0 === a ? "offsetWidth" : "offsetHeight", c = {
        scrollStart: 0,
        scrollViewSize: -i - r,
        scrollMaxSize: 0,
        offsetStart: -i,
        offsetEnd: -r
    };
    if (!0 === a ? (e === window ? (c.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, c.scrollViewSize += document.documentElement.clientWidth) : (c.scrollStart = s.scrollLeft, c.scrollViewSize += s.clientWidth), c.scrollMaxSize = s.scrollWidth, !0 === l && (c.scrollStart = (!0 === $ec2fc4c0d7a3c6c6$var$rtlHasScrollBug ? c.scrollMaxSize - c.scrollViewSize : 0) - c.scrollStart)) : (e === window ? (c.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0, c.scrollViewSize += document.documentElement.clientHeight) : (c.scrollStart = s.scrollTop, c.scrollViewSize += s.clientHeight), c.scrollMaxSize = s.scrollHeight), null !== o) for(let d = o.previousElementSibling; null !== d; d = d.previousElementSibling)!1 === d.classList.contains("q-virtual-scroll--skip") && (c.offsetStart += d[u]);
    if (null !== n) for(let d = n.nextElementSibling; null !== d; d = d.nextElementSibling)!1 === d.classList.contains("q-virtual-scroll--skip") && (c.offsetEnd += d[u]);
    if (t !== e) {
        const o = s.getBoundingClientRect(), n = t.getBoundingClientRect();
        !0 === a ? (c.offsetStart += n.left - o.left, c.offsetEnd -= n.width) : (c.offsetStart += n.top - o.top, c.offsetEnd -= n.height), e !== window && (c.offsetStart += c.scrollStart), c.offsetEnd += c.scrollMaxSize - c.offsetStart;
    }
    return c;
}
function $ec2fc4c0d7a3c6c6$var$setScroll(e, t, o, n) {
    "end" === t && (t = (e === window ? document.body : e)[!0 === o ? "scrollWidth" : "scrollHeight"]), e === window ? !0 === o ? (!0 === n && (t = (!0 === $ec2fc4c0d7a3c6c6$var$rtlHasScrollBug ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - t), window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0)) : window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t) : !0 === o ? (!0 === n && (t = (!0 === $ec2fc4c0d7a3c6c6$var$rtlHasScrollBug ? e.scrollWidth - e.offsetWidth : 0) - t), e.scrollLeft = t) : e.scrollTop = t;
}
function $ec2fc4c0d7a3c6c6$var$sumSize(e, t, o, n) {
    if (o >= n) return 0;
    const a = t.length, l = Math.floor(o / $ec2fc4c0d7a3c6c6$var$aggBucketSize), i = Math.floor((n - 1) / $ec2fc4c0d7a3c6c6$var$aggBucketSize) + 1;
    let r = e.slice(l, i).reduce($ec2fc4c0d7a3c6c6$var$sumFn, 0);
    return o % $ec2fc4c0d7a3c6c6$var$aggBucketSize !== 0 && (r -= t.slice(l * $ec2fc4c0d7a3c6c6$var$aggBucketSize, o).reduce($ec2fc4c0d7a3c6c6$var$sumFn, 0)), n % $ec2fc4c0d7a3c6c6$var$aggBucketSize !== 0 && n !== a && (r -= t.slice(n, i * $ec2fc4c0d7a3c6c6$var$aggBucketSize).reduce($ec2fc4c0d7a3c6c6$var$sumFn, 0)), r;
}
const $ec2fc4c0d7a3c6c6$var$commonVirtScrollProps = {
    virtualScrollSliceSize: {
        type: [
            Number,
            String
        ],
        default: null
    },
    virtualScrollSliceRatioBefore: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollSliceRatioAfter: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollItemSize: {
        type: [
            Number,
            String
        ],
        default: 24
    },
    virtualScrollStickySizeStart: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    virtualScrollStickySizeEnd: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    tableColspan: [
        Number,
        String
    ]
}, $ec2fc4c0d7a3c6c6$var$commonVirtPropsList = Object.keys($ec2fc4c0d7a3c6c6$var$commonVirtScrollProps), $ec2fc4c0d7a3c6c6$var$useVirtualScrollProps = {
    virtualScrollHorizontal: Boolean,
    onVirtualScroll: Function,
    ...$ec2fc4c0d7a3c6c6$var$commonVirtScrollProps
};
function $ec2fc4c0d7a3c6c6$var$useVirtualScroll({ virtualScrollLength: e, getVirtualScrollTarget: t, getVirtualScrollEl: o, virtualScrollItemSizeComputed: n }) {
    const a = (0, $TusQn.getCurrentInstance)(), { props: l, emit: i, proxy: r } = a, { $q: s } = r;
    let u, c, d, p, v = [];
    const m = (0, $01W3b.ref)(0), f = (0, $01W3b.ref)(0), g = (0, $01W3b.ref)({}), b = (0, $01W3b.ref)(null), y = (0, $01W3b.ref)(null), S = (0, $01W3b.ref)(null), w = (0, $01W3b.ref)({
        from: 0,
        to: 0
    }), C = (0, $TusQn.computed)(()=>void 0 !== l.tableColspan ? l.tableColspan : 100);
    void 0 === n && (n = (0, $TusQn.computed)(()=>l.virtualScrollItemSize));
    const x = (0, $TusQn.computed)(()=>n.value + ";" + l.virtualScrollHorizontal), k = (0, $TusQn.computed)(()=>x.value + ";" + l.virtualScrollSliceRatioBefore + ";" + l.virtualScrollSliceRatioAfter);
    function _() {
        E(c, !0);
    }
    function q(e) {
        E(void 0 === e ? c : e);
    }
    function T(n, a) {
        const i = t();
        if (void 0 === i || null === i || 8 === i.nodeType) return;
        const r = $ec2fc4c0d7a3c6c6$var$getScrollDetails(i, o(), b.value, y.value, l.virtualScrollHorizontal, s.lang.rtl, l.virtualScrollStickySizeStart, l.virtualScrollStickySizeEnd);
        d !== r.scrollViewSize && Q(r.scrollViewSize), $(i, r, Math.min(e.value - 1, Math.max(0, parseInt(n, 10) || 0)), 0, $ec2fc4c0d7a3c6c6$var$scrollToEdges.indexOf(a) > -1 ? a : c > -1 && n > c ? "end" : "start");
    }
    function P() {
        const n = t();
        if (void 0 === n || null === n || 8 === n.nodeType) return;
        const a = $ec2fc4c0d7a3c6c6$var$getScrollDetails(n, o(), b.value, y.value, l.virtualScrollHorizontal, s.lang.rtl, l.virtualScrollStickySizeStart, l.virtualScrollStickySizeEnd), i = e.value - 1, r = a.scrollMaxSize - a.offsetStart - a.offsetEnd - f.value;
        if (u === a.scrollStart) return;
        if (a.scrollMaxSize <= 0) return void $(n, a, 0, 0);
        d !== a.scrollViewSize && Q(a.scrollViewSize), M(w.value.from);
        const c = Math.floor(a.scrollMaxSize - Math.max(a.scrollViewSize, a.offsetEnd) - Math.min(p[i], a.scrollViewSize / 2));
        if (c > 0 && Math.ceil(a.scrollStart) >= c) return void $(n, a, i, a.scrollMaxSize - a.offsetEnd - v.reduce($ec2fc4c0d7a3c6c6$var$sumFn, 0));
        let h = 0, g = a.scrollStart - a.offsetStart, S = g;
        if (g <= r && g + a.scrollViewSize >= m.value) g -= m.value, h = w.value.from, S = g;
        else for(let e = 0; g >= v[e] && h < i; e++)g -= v[e], h += $ec2fc4c0d7a3c6c6$var$aggBucketSize;
        while(g > 0 && h < i)g -= p[h], g > -a.scrollViewSize ? (h++, S = g) : S = p[h] + g;
        $(n, a, h, S);
    }
    function $(t, o, n, a, i) {
        const r = "string" === typeof i && i.indexOf("-force") > -1, c = !0 === r ? i.replace("-force", "") : i, d = void 0 !== c ? c : "start";
        let h = Math.max(0, n - g.value[d]), b = h + g.value.total;
        b > e.value && (b = e.value, h = Math.max(0, b - g.value.total)), u = o.scrollStart;
        const y = h !== w.value.from || b !== w.value.to;
        if (!1 === y && void 0 === c) return void L(n);
        const { activeElement: C } = document, x = S.value;
        !0 === y && null !== x && x !== C && !0 === x.contains(C) && (x.addEventListener("focusout", B), setTimeout(()=>{
            null !== x && x.removeEventListener("focusout", B);
        })), $ec2fc4c0d7a3c6c6$var$setOverflowAnchor(x, n - h);
        const k = void 0 !== c ? p.slice(h, n).reduce($ec2fc4c0d7a3c6c6$var$sumFn, 0) : 0;
        if (!0 === y) {
            const t = b >= w.value.from && h <= w.value.to ? w.value.to : b;
            w.value = {
                from: h,
                to: t
            }, m.value = $ec2fc4c0d7a3c6c6$var$sumSize(v, p, 0, h), f.value = $ec2fc4c0d7a3c6c6$var$sumSize(v, p, b, e.value), requestAnimationFrame(()=>{
                w.value.to !== b && u === o.scrollStart && (w.value = {
                    from: w.value.from,
                    to: b
                }, f.value = $ec2fc4c0d7a3c6c6$var$sumSize(v, p, b, e.value));
            });
        }
        requestAnimationFrame(()=>{
            if (u !== o.scrollStart) return;
            !0 === y && M(h);
            const e = p.slice(h, n).reduce($ec2fc4c0d7a3c6c6$var$sumFn, 0), i = e + o.offsetStart + m.value, d = i + p[n];
            let v = i + a;
            if (void 0 !== c) {
                const t = e - k, a = o.scrollStart + t;
                v = !0 !== r && a < i && d < a + o.scrollViewSize ? a : "end" === c ? d - o.scrollViewSize : i - ("start" === c ? 0 : Math.round((o.scrollViewSize - p[n]) / 2));
            }
            u = v, $ec2fc4c0d7a3c6c6$var$setScroll(t, v, l.virtualScrollHorizontal, s.lang.rtl), L(n);
        });
    }
    function M(e) {
        const t = S.value;
        if (t) {
            const o = $ec2fc4c0d7a3c6c6$var$filterProto.call(t.children, (e)=>e.classList && !1 === e.classList.contains("q-virtual-scroll--skip")), n = o.length, a = !0 === l.virtualScrollHorizontal ? (e)=>e.getBoundingClientRect().width : (e)=>e.offsetHeight;
            let i, r, s = e;
            for(let e = 0; e < n;){
                i = a(o[e]), e++;
                while(e < n && !0 === o[e].classList.contains("q-virtual-scroll--with-prev"))i += a(o[e]), e++;
                r = i - p[s], 0 !== r && (p[s] += r, v[Math.floor(s / $ec2fc4c0d7a3c6c6$var$aggBucketSize)] += r), s++;
            }
        }
    }
    function B() {
        null !== S.value && void 0 !== S.value && S.value.focus();
    }
    function E(t, o) {
        const a = 1 * n.value;
        !0 !== o && !1 !== Array.isArray(p) || (p = []);
        const l = p.length;
        p.length = e.value;
        for(let n = e.value - 1; n >= l; n--)p[n] = a;
        const i = Math.floor((e.value - 1) / $ec2fc4c0d7a3c6c6$var$aggBucketSize);
        v = [];
        for(let n = 0; n <= i; n++){
            let t = 0;
            const o = Math.min((n + 1) * $ec2fc4c0d7a3c6c6$var$aggBucketSize, e.value);
            for(let e = n * $ec2fc4c0d7a3c6c6$var$aggBucketSize; e < o; e++)t += p[e];
            v.push(t);
        }
        c = -1, u = void 0, m.value = $ec2fc4c0d7a3c6c6$var$sumSize(v, p, 0, w.value.from), f.value = $ec2fc4c0d7a3c6c6$var$sumSize(v, p, w.value.to, e.value), t >= 0 ? (M(w.value.from), (0, $TusQn.nextTick)(()=>{
            T(t);
        })) : O();
    }
    function Q(e) {
        if (void 0 === e && "undefined" !== typeof window) {
            const n = t();
            void 0 !== n && null !== n && 8 !== n.nodeType && (e = $ec2fc4c0d7a3c6c6$var$getScrollDetails(n, o(), b.value, y.value, l.virtualScrollHorizontal, s.lang.rtl, l.virtualScrollStickySizeStart, l.virtualScrollStickySizeEnd).scrollViewSize);
        }
        d = e;
        const a = parseFloat(l.virtualScrollSliceRatioBefore) || 0, i = parseFloat(l.virtualScrollSliceRatioAfter) || 0, r = 1 + a + i, u = void 0 === e || e <= 0 ? 1 : Math.ceil(e / n.value), c = Math.max(1, u, Math.ceil((l.virtualScrollSliceSize > 0 ? l.virtualScrollSliceSize : 10) / r));
        g.value = {
            total: Math.ceil(c * r),
            start: Math.ceil(c * a),
            center: Math.ceil(c * (.5 + a)),
            end: Math.ceil(c * (1 + a)),
            view: u
        };
    }
    function A(e, t) {
        const o = !0 === l.virtualScrollHorizontal ? "width" : "height", a = {
            ["--q-virtual-scroll-item-" + o]: n.value + "px"
        };
        return [
            "tbody" === e ? (0, $TusQn.h)(e, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: b
            }, [
                (0, $TusQn.h)("tr", [
                    (0, $TusQn.h)("td", {
                        style: {
                            [o]: `${m.value}px`,
                            ...a
                        },
                        colspan: C.value
                    })
                ])
            ]) : (0, $TusQn.h)(e, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: b,
                style: {
                    [o]: `${m.value}px`,
                    ...a
                }
            }),
            (0, $TusQn.h)(e, {
                class: "q-virtual-scroll__content",
                key: "content",
                ref: S,
                tabindex: -1
            }, t.flat()),
            "tbody" === e ? (0, $TusQn.h)(e, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: y
            }, [
                (0, $TusQn.h)("tr", [
                    (0, $TusQn.h)("td", {
                        style: {
                            [o]: `${f.value}px`,
                            ...a
                        },
                        colspan: C.value
                    })
                ])
            ]) : (0, $TusQn.h)(e, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: y,
                style: {
                    [o]: `${f.value}px`,
                    ...a
                }
            })
        ];
    }
    function L(e) {
        c !== e && (void 0 !== l.onVirtualScroll && i("virtualScroll", {
            index: e,
            from: w.value.from,
            to: w.value.to - 1,
            direction: e < c ? "decrease" : "increase",
            ref: r
        }), c = e);
    }
    (0, $TusQn.watch)(k, ()=>{
        Q();
    }), (0, $TusQn.watch)(x, _), Q();
    const O = $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(P, !0 === s.platform.is.ios ? 120 : 35);
    (0, $TusQn.onBeforeMount)(()=>{
        Q();
    });
    let F = !1;
    return (0, $TusQn.onDeactivated)(()=>{
        F = !0;
    }), (0, $TusQn.onActivated)(()=>{
        if (!0 !== F) return;
        const e = t();
        void 0 !== u && void 0 !== e && null !== e && 8 !== e.nodeType ? $ec2fc4c0d7a3c6c6$var$setScroll(e, u, l.virtualScrollHorizontal, s.lang.rtl) : T(c);
    }), (0, $TusQn.onBeforeUnmount)(()=>{
        O.cancel();
    }), Object.assign(r, {
        scrollTo: T,
        reset: _,
        refresh: q
    }), {
        virtualScrollSliceRange: w,
        virtualScrollSliceSizeComputed: g,
        setVirtualScrollSize: Q,
        onVirtualScrollEvt: O,
        localResetVirtualScroll: E,
        padVirtualScroll: A,
        scrollTo: T,
        reset: _,
        refresh: q
    };
}
const $ec2fc4c0d7a3c6c6$var$validateNewValueMode = (e)=>[
        "add",
        "add-unique",
        "toggle"
    ].includes(e), $ec2fc4c0d7a3c6c6$var$reEscapeList = ".*+?^${}()|[]\\", $ec2fc4c0d7a3c6c6$var$fieldPropsList = Object.keys($ec2fc4c0d7a3c6c6$var$useFieldProps);
var $ec2fc4c0d7a3c6c6$export$c6f171932ae1be1a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSelect",
    inheritAttrs: !1,
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useVirtualScrollProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        ...$ec2fc4c0d7a3c6c6$var$useFieldProps,
        modelValue: {
            required: !0
        },
        multiple: Boolean,
        displayValue: [
            String,
            Number
        ],
        displayValueHtml: Boolean,
        dropdownIcon: String,
        options: {
            type: Array,
            default: ()=>[]
        },
        optionValue: [
            Function,
            String
        ],
        optionLabel: [
            Function,
            String
        ],
        optionDisable: [
            Function,
            String
        ],
        hideSelected: Boolean,
        hideDropdownIcon: Boolean,
        fillInput: Boolean,
        maxValues: [
            Number,
            String
        ],
        optionsDense: Boolean,
        optionsDark: {
            type: Boolean,
            default: null
        },
        optionsSelectedClass: String,
        optionsHtml: Boolean,
        optionsCover: Boolean,
        menuShrink: Boolean,
        menuAnchor: String,
        menuSelf: String,
        menuOffset: Array,
        popupContentClass: String,
        popupContentStyle: [
            String,
            Array,
            Object
        ],
        useInput: Boolean,
        useChips: Boolean,
        newValueMode: {
            type: String,
            validator: $ec2fc4c0d7a3c6c6$var$validateNewValueMode
        },
        mapOptions: Boolean,
        emitValue: Boolean,
        inputDebounce: {
            type: [
                Number,
                String
            ],
            default: 500
        },
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        autocomplete: String,
        transitionShow: String,
        transitionHide: String,
        transitionDuration: [
            String,
            Number
        ],
        behavior: {
            type: String,
            validator: (e)=>[
                    "default",
                    "menu",
                    "dialog"
                ].includes(e),
            default: "default"
        },
        virtualScrollItemSize: {
            type: [
                Number,
                String
            ],
            default: void 0
        },
        onNewValue: Function,
        onFilter: Function
    },
    emits: [
        ...$ec2fc4c0d7a3c6c6$var$useFieldEmits,
        "add",
        "remove",
        "inputValue",
        "newValue",
        "keyup",
        "keypress",
        "keydown",
        "filterAbort"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = (0, $01W3b.ref)(!1), i = (0, $01W3b.ref)(!1), r = (0, $01W3b.ref)(-1), s = (0, $01W3b.ref)(""), u = (0, $01W3b.ref)(!1), c = (0, $01W3b.ref)(!1);
        let d, p, v, m, f, g, b, y = null, S = null;
        const w = (0, $01W3b.ref)(null), C = (0, $01W3b.ref)(null), x = (0, $01W3b.ref)(null), k = (0, $01W3b.ref)(null), _ = (0, $01W3b.ref)(null), q = $ec2fc4c0d7a3c6c6$var$useFormInputNameAttr(e), T = $ec2fc4c0d7a3c6c6$var$useKeyComposition(Pe), P = (0, $TusQn.computed)(()=>Array.isArray(e.options) ? e.options.length : 0), $ = (0, $TusQn.computed)(()=>void 0 === e.virtualScrollItemSize ? !0 === e.optionsDense ? 24 : 48 : e.virtualScrollItemSize), { virtualScrollSliceRange: M, virtualScrollSliceSizeComputed: B, localResetVirtualScroll: E, padVirtualScroll: Q, onVirtualScrollEvt: A, scrollTo: L, setVirtualScrollSize: O } = $ec2fc4c0d7a3c6c6$var$useVirtualScroll({
            virtualScrollLength: P,
            getVirtualScrollTarget: ke,
            getVirtualScrollEl: xe,
            virtualScrollItemSizeComputed: $
        }), F = $ec2fc4c0d7a3c6c6$var$useFieldState(), R = (0, $TusQn.computed)(()=>{
            const t = !0 === e.mapOptions && !0 !== e.multiple, o = void 0 === e.modelValue || null === e.modelValue && !0 !== t ? [] : !0 === e.multiple && Array.isArray(e.modelValue) ? e.modelValue : [
                e.modelValue
            ];
            if (!0 === e.mapOptions && !0 === Array.isArray(e.options)) {
                const n = !0 === e.mapOptions && void 0 !== d ? d : [], a = o.map((e)=>fe(e, n));
                return null === e.modelValue && !0 === t ? a.filter((e)=>null !== e) : a;
            }
            return o;
        }), D = (0, $TusQn.computed)(()=>{
            const t = {};
            return $ec2fc4c0d7a3c6c6$var$fieldPropsList.forEach((o)=>{
                const n = e[o];
                void 0 !== n && (t[o] = n);
            }), t;
        }), z = (0, $TusQn.computed)(()=>null === e.optionsDark ? F.isDark.value : e.optionsDark), I = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(R.value)), V = (0, $TusQn.computed)(()=>{
            let t = "q-field__input q-placeholder col";
            return !0 === e.hideSelected || 0 === R.value.length ? [
                t,
                e.inputClass
            ] : (t += " q-field__input--padding", void 0 === e.inputClass ? t : [
                t,
                e.inputClass
            ]);
        }), H = (0, $TusQn.computed)(()=>(!0 === e.virtualScrollHorizontal ? "q-virtual-scroll--horizontal" : "") + (e.popupContentClass ? " " + e.popupContentClass : "")), N = (0, $TusQn.computed)(()=>0 === P.value), j = (0, $TusQn.computed)(()=>R.value.map((e)=>ae.value(e)).join(", ")), U = (0, $TusQn.computed)(()=>void 0 !== e.displayValue ? e.displayValue : j.value), K = (0, $TusQn.computed)(()=>!0 === e.optionsHtml ? ()=>!0 : (e)=>void 0 !== e && null !== e && !0 === e.html), W = (0, $TusQn.computed)(()=>!0 === e.displayValueHtml || void 0 === e.displayValue && (!0 === e.optionsHtml || R.value.some(K.value))), Y = (0, $TusQn.computed)(()=>!0 === F.focused.value ? e.tabindex : -1), G = (0, $TusQn.computed)(()=>{
            const t = {
                tabindex: e.tabindex,
                role: "combobox",
                "aria-label": e.label,
                "aria-readonly": !0 === e.readonly ? "true" : "false",
                "aria-autocomplete": !0 === e.useInput ? "list" : "none",
                "aria-expanded": !0 === l.value ? "true" : "false",
                "aria-controls": `${F.targetUid.value}_lb`
            };
            return r.value >= 0 && (t["aria-activedescendant"] = `${F.targetUid.value}_${r.value}`), t;
        }), X = (0, $TusQn.computed)(()=>({
                id: `${F.targetUid.value}_lb`,
                role: "listbox",
                "aria-multiselectable": !0 === e.multiple ? "true" : "false"
            })), Z = (0, $TusQn.computed)(()=>{
            return R.value.map((e, t)=>({
                    index: t,
                    opt: e,
                    html: K.value(e),
                    selected: !0,
                    removeAtIndex: ce,
                    toggleOption: pe,
                    tabindex: Y.value
                }));
        }), J = (0, $TusQn.computed)(()=>{
            if (0 === P.value) return [];
            const { from: t, to: o } = M.value;
            return e.options.slice(t, o).map((o, n)=>{
                const i = !0 === le.value(o), s = t + n, u = {
                    clickable: !0,
                    active: !1,
                    activeClass: oe.value,
                    manualFocus: !0,
                    focused: !1,
                    disable: i,
                    tabindex: -1,
                    dense: e.optionsDense,
                    dark: z.value,
                    role: "option",
                    id: `${F.targetUid.value}_${s}`,
                    onClick: ()=>{
                        pe(o);
                    }
                };
                return !0 !== i && (!0 === ge(o) && (u.active = !0), r.value === s && (u.focused = !0), u["aria-selected"] = !0 === u.active ? "true" : "false", !0 === a.platform.is.desktop && (u.onMousemove = ()=>{
                    !0 === l.value && ve(s);
                })), {
                    index: s,
                    opt: o,
                    html: K.value(o),
                    label: ae.value(o),
                    selected: u.active,
                    focused: u.focused,
                    toggleOption: pe,
                    setOptionIndex: ve,
                    itemProps: u
                };
            });
        }), ee = (0, $TusQn.computed)(()=>void 0 !== e.dropdownIcon ? e.dropdownIcon : a.iconSet.arrow.dropdown), te = (0, $TusQn.computed)(()=>!1 === e.optionsCover && !0 !== e.outlined && !0 !== e.standout && !0 !== e.borderless && !0 !== e.rounded), oe = (0, $TusQn.computed)(()=>void 0 !== e.optionsSelectedClass ? e.optionsSelectedClass : void 0 !== e.color ? `text-${e.color}` : ""), ne = (0, $TusQn.computed)(()=>he(e.optionValue, "value")), ae = (0, $TusQn.computed)(()=>he(e.optionLabel, "label")), le = (0, $TusQn.computed)(()=>he(e.optionDisable, "disable")), ie = (0, $TusQn.computed)(()=>R.value.map((e)=>ne.value(e))), re = (0, $TusQn.computed)(()=>{
            const e = {
                onInput: Pe,
                onChange: T,
                onKeydown: Ce,
                onKeyup: Se,
                onKeypress: we,
                onFocus: be,
                onClick (e) {
                    !0 === p && $ec2fc4c0d7a3c6c6$var$stop(e);
                }
            };
            return e.onCompositionstart = e.onCompositionupdate = e.onCompositionend = T, e;
        });
        function se(t) {
            return !0 === e.emitValue ? ne.value(t) : t;
        }
        function ue(t) {
            if (t > -1 && t < R.value.length) {
                if (!0 === e.multiple) {
                    const n = e.modelValue.slice();
                    o("remove", {
                        index: t,
                        value: n.splice(t, 1)[0]
                    }), o("update:modelValue", n);
                } else o("update:modelValue", null);
            }
        }
        function ce(e) {
            ue(e), F.focus();
        }
        function de(t, n) {
            const a = se(t);
            if (!0 !== e.multiple) return !0 === e.fillInput && Me(ae.value(t), !0, !0), void o("update:modelValue", a);
            if (0 === R.value.length) return o("add", {
                index: 0,
                value: a
            }), void o("update:modelValue", !0 === e.multiple ? [
                a
            ] : a);
            if (!0 === n && !0 === ge(t)) return;
            if (void 0 !== e.maxValues && e.modelValue.length >= e.maxValues) return;
            const l = e.modelValue.slice();
            o("add", {
                index: l.length,
                value: a
            }), l.push(a), o("update:modelValue", l);
        }
        function pe(t, n) {
            if (!0 !== F.editable.value || void 0 === t || !0 === le.value(t)) return;
            const a = ne.value(t);
            if (!0 !== e.multiple) return !0 !== n && (Me(!0 === e.fillInput ? ae.value(t) : "", !0, !0), He()), null !== C.value && C.value.focus(), void (0 !== R.value.length && !0 === $ec2fc4c0d7a3c6c6$var$isDeepEqual(ne.value(R.value[0]), a) || o("update:modelValue", !0 === e.emitValue ? a : t));
            if ((!0 !== p || !0 === u.value) && F.focus(), be(), 0 === R.value.length) {
                const n = !0 === e.emitValue ? a : t;
                return o("add", {
                    index: 0,
                    value: n
                }), void o("update:modelValue", !0 === e.multiple ? [
                    n
                ] : n);
            }
            const l = e.modelValue.slice(), i = ie.value.findIndex((e)=>$ec2fc4c0d7a3c6c6$var$isDeepEqual(e, a));
            if (i > -1) o("remove", {
                index: i,
                value: l.splice(i, 1)[0]
            });
            else {
                if (void 0 !== e.maxValues && l.length >= e.maxValues) return;
                const n = !0 === e.emitValue ? a : t;
                o("add", {
                    index: l.length,
                    value: n
                }), l.push(n);
            }
            o("update:modelValue", l);
        }
        function ve(e) {
            if (!0 !== a.platform.is.desktop) return;
            const t = e > -1 && e < P.value ? e : -1;
            r.value !== t && (r.value = t);
        }
        function me(t = 1, o) {
            if (!0 === l.value) {
                let n = r.value;
                do n = $ec2fc4c0d7a3c6c6$var$normalizeToInterval(n + t, -1, P.value - 1);
                while (-1 !== n && n !== r.value && !0 === le.value(e.options[n]));
                r.value !== n && (ve(n), L(n), !0 !== o && !0 === e.useInput && !0 === e.fillInput && $e(n >= 0 ? ae.value(e.options[n]) : m));
            }
        }
        function fe(t, o) {
            const n = (e)=>$ec2fc4c0d7a3c6c6$var$isDeepEqual(ne.value(e), t);
            return e.options.find(n) || o.find(n) || t;
        }
        function he(e, t) {
            const o = void 0 !== e ? e : t;
            return "function" === typeof o ? o : (e)=>null !== e && "object" === typeof e && o in e ? e[o] : e;
        }
        function ge(e) {
            const t = ne.value(e);
            return void 0 !== ie.value.find((e)=>$ec2fc4c0d7a3c6c6$var$isDeepEqual(e, t));
        }
        function be(t) {
            !0 === e.useInput && null !== C.value && (void 0 === t || C.value === t.target && t.target.value === j.value) && C.value.select();
        }
        function ye(e) {
            !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, 27) && !0 === l.value && ($ec2fc4c0d7a3c6c6$var$stop(e), He(), Ne()), o("keyup", e);
        }
        function Se(t) {
            const { value: o } = t.target;
            if (void 0 === t.keyCode) {
                if (t.target.value = "", null !== y && (clearTimeout(y), y = null), Ne(), "string" === typeof o && 0 !== o.length) {
                    const t = o.toLocaleLowerCase(), n = (o)=>{
                        const n = e.options.find((e)=>o.value(e).toLocaleLowerCase() === t);
                        return void 0 !== n && (-1 === R.value.indexOf(n) ? pe(n) : He(), !0);
                    }, a = (e)=>{
                        !0 !== n(ne) && !0 !== n(ae) && !0 !== e && Be(o, !0, ()=>a(!0));
                    };
                    a();
                } else F.clearValue(t);
            } else ye(t);
        }
        function we(e) {
            o("keypress", e);
        }
        function Ce(t) {
            if (o("keydown", t), !0 === $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(t)) return;
            const n = 0 !== s.value.length && (void 0 !== e.newValueMode || void 0 !== e.onNewValue), a = !0 !== t.shiftKey && !0 !== e.multiple && (r.value > -1 || !0 === n);
            if (27 === t.keyCode) return void $ec2fc4c0d7a3c6c6$var$prevent(t);
            if (9 === t.keyCode && !1 === a) return void Ie();
            if (void 0 === t.target || t.target.id !== F.targetUid.value || !0 !== F.editable.value) return;
            if (40 === t.keyCode && !0 !== F.innerLoading.value && !1 === l.value) return $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), void Ve();
            if (8 === t.keyCode && !0 !== e.hideSelected && 0 === s.value.length) return void (!0 === e.multiple && !0 === Array.isArray(e.modelValue) ? ue(e.modelValue.length - 1) : !0 !== e.multiple && null !== e.modelValue && o("update:modelValue", null));
            35 !== t.keyCode && 36 !== t.keyCode || "string" === typeof s.value && 0 !== s.value.length || ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), r.value = -1, me(36 === t.keyCode ? 1 : -1, e.multiple)), 33 !== t.keyCode && 34 !== t.keyCode || void 0 === B.value || ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), r.value = Math.max(-1, Math.min(P.value, r.value + (33 === t.keyCode ? -1 : 1) * B.value.view)), me(33 === t.keyCode ? 1 : -1, e.multiple)), 38 !== t.keyCode && 40 !== t.keyCode || ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), me(38 === t.keyCode ? -1 : 1, e.multiple));
            const i = P.value;
            if ((void 0 === g || b < Date.now()) && (g = ""), i > 0 && !0 !== e.useInput && void 0 !== t.key && 1 === t.key.length && !1 === t.altKey && !1 === t.ctrlKey && !1 === t.metaKey && (32 !== t.keyCode || 0 !== g.length)) {
                !0 !== l.value && Ve(t);
                const o = t.key.toLocaleLowerCase(), n = 1 === g.length && g[0] === o;
                b = Date.now() + 1500, !1 === n && ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), g += o);
                const a = new RegExp("^" + g.split("").map((e)=>$ec2fc4c0d7a3c6c6$var$reEscapeList.indexOf(e) > -1 ? "\\" + e : e).join(".*"), "i");
                let s = r.value;
                if (!0 === n || s < 0 || !0 !== a.test(ae.value(e.options[s]))) do s = $ec2fc4c0d7a3c6c6$var$normalizeToInterval(s + 1, -1, i - 1);
                while (s !== r.value && (!0 === le.value(e.options[s]) || !0 !== a.test(ae.value(e.options[s]))));
                r.value !== s && (0, $TusQn.nextTick)(()=>{
                    ve(s), L(s), s >= 0 && !0 === e.useInput && !0 === e.fillInput && $e(ae.value(e.options[s]));
                });
            } else if (13 === t.keyCode || 32 === t.keyCode && !0 !== e.useInput && "" === g || 9 === t.keyCode && !1 !== a) {
                if (9 !== t.keyCode && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), r.value > -1 && r.value < i) pe(e.options[r.value]);
                else {
                    if (!0 === n) {
                        const t = (t, o)=>{
                            if (o) {
                                if (!0 !== $ec2fc4c0d7a3c6c6$var$validateNewValueMode(o)) return;
                            } else o = e.newValueMode;
                            if (Me("", !0 !== e.multiple, !0), void 0 === t || null === t) return;
                            const n = "toggle" === o ? pe : de;
                            n(t, "add-unique" === o), !0 !== e.multiple && (null !== C.value && C.value.focus(), He());
                        };
                        if (void 0 !== e.onNewValue ? o("newValue", s.value, t) : t(s.value), !0 !== e.multiple) return;
                    }
                    !0 === l.value ? Ie() : !0 !== F.innerLoading.value && Ve();
                }
            }
        }
        function xe() {
            return !0 === p ? _.value : null !== x.value && null !== x.value.contentEl ? x.value.contentEl : void 0;
        }
        function ke() {
            return xe();
        }
        function _e() {
            return !0 === e.hideSelected ? [] : void 0 !== t["selected-item"] ? Z.value.map((e)=>t["selected-item"](e)).slice() : void 0 !== t.selected ? [].concat(t.selected()) : !0 === e.useChips ? Z.value.map((t, o)=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$fe8abce8a0a972d6, {
                    key: "option-" + o,
                    removable: !0 === F.editable.value && !0 !== le.value(t.opt),
                    dense: !0,
                    textColor: e.color,
                    tabindex: Y.value,
                    onRemove () {
                        t.removeAtIndex(o);
                    }
                }, ()=>(0, $TusQn.h)("span", {
                        class: "ellipsis",
                        [!0 === t.html ? "innerHTML" : "textContent"]: ae.value(t.opt)
                    }))) : [
                (0, $TusQn.h)("span", {
                    [!0 === W.value ? "innerHTML" : "textContent"]: U.value
                })
            ];
        }
        function qe() {
            if (!0 === N.value) return void 0 !== t["no-option"] ? t["no-option"]({
                inputValue: s.value
            }) : void 0;
            const e = void 0 !== t.option ? t.option : (e)=>{
                return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$adf75769807ad87e, {
                    key: e.index,
                    ...e.itemProps
                }, ()=>{
                    return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$17cb5eb1f3204256, ()=>(0, $TusQn.h)("span", {
                                [!0 === e.html ? "innerHTML" : "textContent"]: e.label
                            })));
                });
            };
            let o = Q("div", J.value.map(e));
            return void 0 !== t["before-options"] && (o = t["before-options"]().concat(o)), $ec2fc4c0d7a3c6c6$var$hMergeSlot(t["after-options"], o);
        }
        function Te(t, o) {
            const n = !0 === o ? {
                ...G.value,
                ...F.splitAttrs.attributes.value
            } : void 0, a = {
                ref: !0 === o ? C : void 0,
                key: "i_t",
                class: V.value,
                style: e.inputStyle,
                value: void 0 !== s.value ? s.value : "",
                type: "search",
                ...n,
                id: !0 === o ? F.targetUid.value : void 0,
                maxlength: e.maxlength,
                autocomplete: e.autocomplete,
                "data-autofocus": !0 === t || !0 === e.autofocus || void 0,
                disabled: !0 === e.disable,
                readonly: !0 === e.readonly,
                ...re.value
            };
            return !0 !== t && !0 === p && (!0 === Array.isArray(a.class) ? a.class = [
                ...a.class,
                "no-pointer-events"
            ] : a.class += " no-pointer-events"), (0, $TusQn.h)("input", a);
        }
        function Pe(t) {
            null !== y && (clearTimeout(y), y = null), t && t.target && !0 === t.target.qComposing || ($e(t.target.value || ""), v = !0, m = s.value, !0 === F.focused.value || !0 === p && !0 !== u.value || F.focus(), void 0 !== e.onFilter && (y = setTimeout(()=>{
                y = null, Be(s.value);
            }, e.inputDebounce)));
        }
        function $e(e) {
            s.value !== e && (s.value = e, o("inputValue", e));
        }
        function Me(t, o, n) {
            v = !0 !== n, !0 === e.useInput && ($e(t), !0 !== o && !0 === n || (m = t), !0 !== o && Be(t));
        }
        function Be(t, a, i) {
            if (void 0 === e.onFilter || !0 !== a && !0 !== F.focused.value) return;
            !0 === F.innerLoading.value ? o("filterAbort") : (F.innerLoading.value = !0, c.value = !0), "" !== t && !0 !== e.multiple && 0 !== R.value.length && !0 !== v && t === ae.value(R.value[0]) && (t = "");
            const r = setTimeout(()=>{
                !0 === l.value && (l.value = !1);
            }, 10);
            null !== S && clearTimeout(S), S = r, o("filter", t, (e, t)=>{
                !0 !== a && !0 !== F.focused.value || S !== r || (clearTimeout(S), "function" === typeof e && e(), c.value = !1, (0, $TusQn.nextTick)(()=>{
                    F.innerLoading.value = !1, !0 === F.editable.value && (!0 === a ? !0 === l.value && He() : !0 === l.value ? je(!0) : l.value = !0), "function" === typeof t && (0, $TusQn.nextTick)(()=>{
                        t(n);
                    }), "function" === typeof i && (0, $TusQn.nextTick)(()=>{
                        i(n);
                    });
                }));
            }, ()=>{
                !0 === F.focused.value && S === r && (clearTimeout(S), F.innerLoading.value = !1, c.value = !1), !0 === l.value && (l.value = !1);
            });
        }
        function Ee() {
            return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$73537802004a2118, {
                ref: x,
                class: H.value,
                style: e.popupContentStyle,
                modelValue: l.value,
                fit: !0 !== e.menuShrink,
                cover: !0 === e.optionsCover && !0 !== N.value && !0 !== e.useInput,
                anchor: e.menuAnchor,
                self: e.menuSelf,
                offset: e.menuOffset,
                dark: z.value,
                noParentEvent: !0,
                noRefocus: !0,
                noFocus: !0,
                square: te.value,
                transitionShow: e.transitionShow,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                separateClosePopup: !0,
                ...X.value,
                onScrollPassive: A,
                onBeforeShow: We,
                onBeforeHide: Qe,
                onShow: Ae
            }, qe);
        }
        function Qe(e) {
            Ye(e), Ie();
        }
        function Ae() {
            O();
        }
        function Le(e) {
            $ec2fc4c0d7a3c6c6$var$stop(e), null !== C.value && C.value.focus(), u.value = !0, window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
        }
        function Oe(e) {
            $ec2fc4c0d7a3c6c6$var$stop(e), (0, $TusQn.nextTick)(()=>{
                u.value = !1;
            });
        }
        function Fe() {
            const o = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9e1d68206b908513, {
                    class: `col-auto ${F.fieldClass.value}`,
                    ...D.value,
                    for: F.targetUid.value,
                    dark: z.value,
                    square: !0,
                    loading: c.value,
                    itemAligned: !1,
                    filled: !0,
                    stackLabel: 0 !== s.value.length,
                    ...F.splitAttrs.listeners.value,
                    onFocus: Le,
                    onBlur: Oe
                }, {
                    ...t,
                    rawControl: ()=>F.getControl(!0),
                    before: void 0,
                    after: void 0
                })
            ];
            return !0 === l.value && o.push((0, $TusQn.h)("div", {
                ref: _,
                class: H.value + " scroll",
                style: e.popupContentStyle,
                ...X.value,
                onClick: $ec2fc4c0d7a3c6c6$var$prevent,
                onScrollPassive: A
            }, qe())), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$e6ccdac5fb3e2417, {
                ref: k,
                modelValue: i.value,
                position: !0 === e.useInput ? "top" : void 0,
                transitionShow: f,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                onBeforeShow: We,
                onBeforeHide: Re,
                onHide: De,
                onShow: ze
            }, ()=>(0, $TusQn.h)("div", {
                    class: "q-select__dialog" + (!0 === z.value ? " q-select__dialog--dark q-dark" : "") + (!0 === u.value ? " q-select__dialog--focused" : "")
                }, o));
        }
        function Re(e) {
            Ye(e), null !== k.value && k.value.__updateRefocusTarget(F.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")), F.focused.value = !1;
        }
        function De(e) {
            He(), !1 === F.focused.value && o("blur", e), Ne();
        }
        function ze() {
            const e = document.activeElement;
            null !== e && e.id === F.targetUid.value || null === C.value || C.value === e || C.value.focus(), O();
        }
        function Ie() {
            !0 !== i.value && (r.value = -1, !0 === l.value && (l.value = !1), !1 === F.focused.value && (null !== S && (clearTimeout(S), S = null), !0 === F.innerLoading.value && (o("filterAbort"), F.innerLoading.value = !1, c.value = !1)));
        }
        function Ve(o) {
            !0 === F.editable.value && (!0 === p ? (F.onControlFocusin(o), i.value = !0, (0, $TusQn.nextTick)(()=>{
                F.focus();
            })) : F.focus(), void 0 !== e.onFilter ? Be(s.value) : !0 === N.value && void 0 === t["no-option"] || (l.value = !0));
        }
        function He() {
            i.value = !1, Ie();
        }
        function Ne() {
            !0 === e.useInput && Me(!0 !== e.multiple && !0 === e.fillInput && 0 !== R.value.length && ae.value(R.value[0]) || "", !0, !0);
        }
        function je(t) {
            let o = -1;
            if (!0 === t) {
                if (0 !== R.value.length) {
                    const t = ne.value(R.value[0]);
                    o = e.options.findIndex((e)=>$ec2fc4c0d7a3c6c6$var$isDeepEqual(ne.value(e), t));
                }
                E(o);
            }
            ve(o);
        }
        function Ue(e, t) {
            !0 === l.value && !1 === F.innerLoading.value && (E(-1, !0), (0, $TusQn.nextTick)(()=>{
                !0 === l.value && !1 === F.innerLoading.value && (e > t ? E() : je(!0));
            }));
        }
        function Ke() {
            !1 === i.value && null !== x.value && x.value.updatePosition();
        }
        function We(e) {
            void 0 !== e && $ec2fc4c0d7a3c6c6$var$stop(e), o("popupShow", e), F.hasPopupOpen = !0, F.onControlFocusin(e);
        }
        function Ye(e) {
            void 0 !== e && $ec2fc4c0d7a3c6c6$var$stop(e), o("popupHide", e), F.hasPopupOpen = !1, F.onControlFocusout(e);
        }
        function Ge() {
            p = (!0 === a.platform.is.mobile || "dialog" === e.behavior) && "menu" !== e.behavior && (!0 !== e.useInput || void 0 !== t["no-option"] || void 0 !== e.onFilter || !1 === N.value), f = !0 === a.platform.is.ios && !0 === p && !0 === e.useInput ? "fade" : e.transitionShow;
        }
        return (0, $TusQn.watch)(R, (t)=>{
            d = t, !0 === e.useInput && !0 === e.fillInput && !0 !== e.multiple && !0 !== F.innerLoading.value && (!0 !== i.value && !0 !== l.value || !0 !== I.value) && (!0 !== v && Ne(), !0 !== i.value && !0 !== l.value || Be(""));
        }, {
            immediate: !0
        }), (0, $TusQn.watch)(()=>e.fillInput, Ne), (0, $TusQn.watch)(l, je), (0, $TusQn.watch)(P, Ue), (0, $TusQn.onBeforeUpdate)(Ge), (0, $TusQn.onUpdated)(Ke), Ge(), (0, $TusQn.onBeforeUnmount)(()=>{
            null !== y && clearTimeout(y);
        }), Object.assign(n, {
            showPopup: Ve,
            hidePopup: He,
            removeAtIndex: ue,
            add: de,
            toggleOption: pe,
            getOptionIndex: ()=>r.value,
            setOptionIndex: ve,
            moveOptionSelection: me,
            filter: Be,
            updateMenuPosition: Ke,
            updateInputValue: Me,
            isOptionSelected: ge,
            getEmittingOptionValue: se,
            isOptionDisabled: (...e)=>!0 === le.value.apply(null, e),
            getOptionValue: (...e)=>ne.value.apply(null, e),
            getOptionLabel: (...e)=>ae.value.apply(null, e)
        }), Object.assign(F, {
            innerValue: R,
            fieldClass: (0, $TusQn.computed)(()=>`q-select q-field--auto-height q-select--with${!0 !== e.useInput ? "out" : ""}-input` + ` q-select--with${!0 !== e.useChips ? "out" : ""}-chips` + ` q-select--${!0 === e.multiple ? "multiple" : "single"}`),
            inputRef: w,
            targetRef: C,
            hasValue: I,
            showPopup: Ve,
            floatingLabel: (0, $TusQn.computed)(()=>!0 !== e.hideSelected && !0 === I.value || "number" === typeof s.value || 0 !== s.value.length || $ec2fc4c0d7a3c6c6$var$fieldValueIsFilled(e.displayValue)),
            getControlChild: ()=>{
                if (!1 !== F.editable.value && (!0 === i.value || !0 !== N.value || void 0 !== t["no-option"])) return !0 === p ? Fe() : Ee();
                !0 === F.hasPopupOpen && (F.hasPopupOpen = !1);
            },
            controlEvents: {
                onFocusin (e) {
                    F.onControlFocusin(e);
                },
                onFocusout (e) {
                    F.onControlFocusout(e, ()=>{
                        Ne(), Ie();
                    });
                },
                onClick (e) {
                    if ($ec2fc4c0d7a3c6c6$var$prevent(e), !0 !== p && !0 === l.value) return Ie(), void (null !== C.value && C.value.focus());
                    Ve(e);
                }
            },
            getControl: (t)=>{
                const o = _e(), n = !0 === t || !0 !== i.value || !0 !== p;
                if (!0 === e.useInput) o.push(Te(t, n));
                else if (!0 === F.editable.value) {
                    const a = !0 === n ? G.value : void 0;
                    o.push((0, $TusQn.h)("input", {
                        ref: !0 === n ? C : void 0,
                        key: "d_t",
                        class: "q-select__focus-target",
                        id: !0 === n ? F.targetUid.value : void 0,
                        value: U.value,
                        readonly: !0,
                        "data-autofocus": !0 === t || !0 === e.autofocus || void 0,
                        ...a,
                        onKeydown: Ce,
                        onKeyup: ye,
                        onKeypress: we
                    })), !0 === n && "string" === typeof e.autocomplete && 0 !== e.autocomplete.length && o.push((0, $TusQn.h)("input", {
                        class: "q-select__autocomplete-input",
                        autocomplete: e.autocomplete,
                        tabindex: -1,
                        onKeyup: Se
                    }));
                }
                if (void 0 !== q.value && !0 !== e.disable && 0 !== ie.value.length) {
                    const t = ie.value.map((e)=>(0, $TusQn.h)("option", {
                            value: e,
                            selected: !0
                        }));
                    o.push((0, $TusQn.h)("select", {
                        class: "hidden",
                        name: q.value,
                        multiple: e.multiple
                    }, t));
                }
                const a = !0 === e.useInput || !0 !== n ? void 0 : F.splitAttrs.attributes.value;
                return (0, $TusQn.h)("div", {
                    class: "q-field__native row items-center",
                    ...a,
                    ...F.splitAttrs.listeners.value
                }, o);
            },
            getInnerAppend: ()=>!0 !== e.loading && !0 !== c.value && !0 !== e.hideDropdownIcon ? [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        class: "q-select__dropdown-icon" + (!0 === l.value ? " rotate-180" : ""),
                        name: ee.value
                    })
                ] : null
        }), $ec2fc4c0d7a3c6c6$var$useField(F);
    }
});
const $ec2fc4c0d7a3c6c6$var$skeletonTypes = [
    "text",
    "rect",
    "circle",
    "QBtn",
    "QBadge",
    "QChip",
    "QToolbar",
    "QCheckbox",
    "QRadio",
    "QToggle",
    "QSlider",
    "QRange",
    "QInput",
    "QAvatar"
], $ec2fc4c0d7a3c6c6$var$skeletonAnimations = [
    "wave",
    "pulse",
    "pulse-x",
    "pulse-y",
    "fade",
    "blink",
    "none"
];
var $ec2fc4c0d7a3c6c6$export$c03597c5c32a1b2c = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSkeleton",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        tag: {
            type: String,
            default: "div"
        },
        type: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$skeletonTypes.includes(e),
            default: "rect"
        },
        animation: {
            type: String,
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$skeletonAnimations.includes(e),
            default: "wave"
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 1500
        },
        square: Boolean,
        bordered: Boolean,
        size: String,
        width: String,
        height: String
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q), a = (0, $TusQn.computed)(()=>{
            const t = void 0 !== e.size ? [
                e.size,
                e.size
            ] : [
                e.width,
                e.height
            ];
            return {
                "--q-skeleton-speed": `${e.animationSpeed}ms`,
                width: t[0],
                height: t[1]
            };
        }), l = (0, $TusQn.computed)(()=>`q-skeleton q-skeleton--${!0 === n.value ? "dark" : "light"} q-skeleton--type-${e.type}` + ("none" !== e.animation ? ` q-skeleton--anim q-skeleton--anim-${e.animation}` : "") + (!0 === e.square ? " q-skeleton--square" : "") + (!0 === e.bordered ? " q-skeleton--bordered" : ""));
        return ()=>(0, $TusQn.h)(e.tag, {
                class: l.value,
                style: a.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$slotsDef = [
    [
        "left",
        "center",
        "start",
        "width"
    ],
    [
        "right",
        "center",
        "end",
        "width"
    ],
    [
        "top",
        "start",
        "center",
        "height"
    ],
    [
        "bottom",
        "end",
        "center",
        "height"
    ]
];
var $ec2fc4c0d7a3c6c6$export$4b0d074f5c781fdc = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSlideItem",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        leftColor: String,
        rightColor: String,
        topColor: String,
        bottomColor: String,
        onSlide: Function
    },
    emits: [
        "action",
        "top",
        "right",
        "bottom",
        "left"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = $ec2fc4c0d7a3c6c6$var$useDark(e, a), { getCacheWithFn: i } = $ec2fc4c0d7a3c6c6$var$useCache(), r = (0, $01W3b.ref)(null);
        let s = null, u = {}, c = {}, d = {};
        const p = (0, $TusQn.computed)(()=>!0 === a.lang.rtl ? {
                left: "right",
                right: "left"
            } : {
                left: "left",
                right: "right"
            }), v = (0, $TusQn.computed)(()=>"q-slide-item q-item-type overflow-hidden" + (!0 === l.value ? " q-slide-item--dark q-dark" : ""));
        function m() {
            r.value.style.transform = "translate(0,0)";
        }
        function f(t, n, a) {
            void 0 !== e.onSlide && o("slide", {
                side: t,
                ratio: n,
                isReset: a
            });
        }
        function g(e) {
            const n = r.value;
            if (e.isFirst) u = {
                dir: null,
                size: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                scale: 0
            }, n.classList.add("no-transition"), $ec2fc4c0d7a3c6c6$var$slotsDef.forEach((e)=>{
                if (void 0 !== t[e[0]]) {
                    const t = d[e[0]];
                    t.style.transform = "scale(1)", u.size[e[0]] = t.getBoundingClientRect()[e[3]];
                }
            }), u.axis = "up" === e.direction || "down" === e.direction ? "Y" : "X";
            else {
                if (e.isFinal) return n.classList.remove("no-transition"), void (1 === u.scale ? (n.style.transform = `translate${u.axis}(${100 * u.dir}%)`, null !== s && clearTimeout(s), s = setTimeout(()=>{
                    s = null, o(u.showing, {
                        reset: m
                    }), o("action", {
                        side: u.showing,
                        reset: m
                    });
                }, 230)) : (n.style.transform = "translate(0,0)", f(u.showing, 0, !0)));
                e.direction = "X" === u.axis ? e.offset.x < 0 ? "left" : "right" : e.offset.y < 0 ? "up" : "down";
            }
            if (void 0 === t.left && e.direction === p.value.right || void 0 === t.right && e.direction === p.value.left || void 0 === t.top && "down" === e.direction || void 0 === t.bottom && "up" === e.direction) return void (n.style.transform = "translate(0,0)");
            let a, l, i;
            "X" === u.axis ? (l = "left" === e.direction ? -1 : 1, a = 1 === l ? p.value.left : p.value.right, i = e.distance.x) : (l = "up" === e.direction ? -2 : 2, a = 2 === l ? "top" : "bottom", i = e.distance.y), null !== u.dir && Math.abs(l) !== Math.abs(u.dir) || (u.dir !== l && ([
                "left",
                "right",
                "top",
                "bottom"
            ].forEach((e)=>{
                c[e] && (c[e].style.visibility = a === e ? "visible" : "hidden");
            }), u.showing = a, u.dir = l), u.scale = Math.max(0, Math.min(1, (i - 40) / u.size[a])), n.style.transform = `translate${u.axis}(${i * l / Math.abs(l)}px)`, d[a].style.transform = `scale(${u.scale})`, f(a, u.scale, !1));
        }
        return (0, $TusQn.onBeforeUpdate)(()=>{
            c = {}, d = {};
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            null !== s && clearTimeout(s);
        }), Object.assign(n, {
            reset: m
        }), ()=>{
            const o = [], n = {
                left: void 0 !== t[p.value.right],
                right: void 0 !== t[p.value.left],
                up: void 0 !== t.bottom,
                down: void 0 !== t.top
            }, a = Object.keys(n).filter((e)=>!0 === n[e]);
            $ec2fc4c0d7a3c6c6$var$slotsDef.forEach((n)=>{
                const a = n[0];
                void 0 !== t[a] && o.push((0, $TusQn.h)("div", {
                    ref: (e)=>{
                        c[a] = e;
                    },
                    class: `q-slide-item__${a} absolute-full row no-wrap items-${n[1]} justify-${n[2]}` + (void 0 !== e[a + "Color"] ? ` bg-${e[a + "Color"]}` : "")
                }, [
                    (0, $TusQn.h)("div", {
                        ref: (e)=>{
                            d[a] = e;
                        }
                    }, t[a]())
                ]));
            });
            const l = (0, $TusQn.h)("div", {
                key: `${0 === a.length ? "only-" : ""} content`,
                ref: r,
                class: "q-slide-item__content"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
            return 0 === a.length ? o.push(l) : o.push((0, $TusQn.withDirectives)(l, i("dir#" + a.join(""), ()=>{
                const e = {
                    prevent: !0,
                    stop: !0,
                    mouse: !0
                };
                return a.forEach((t)=>{
                    e[t] = !0;
                }), [
                    [
                        $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                        g,
                        void 0,
                        e
                    ]
                ];
            }))), (0, $TusQn.h)("div", {
                class: v.value
            }, o);
        };
    }
});
const $ec2fc4c0d7a3c6c6$var$space = (0, $TusQn.h)("div", {
    class: "q-space"
});
var $ec2fc4c0d7a3c6c6$export$e2e812bf9ee33e1a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpace",
    setup () {
        return ()=>$ec2fc4c0d7a3c6c6$var$space;
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$l = [
    (0, $TusQn.h)("g", {
        transform: "matrix(1 0 0 -1 0 80)"
    }, [
        (0, $TusQn.h)("rect", {
            width: "10",
            height: "20",
            rx: "3"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "4.3s",
                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("rect", {
            x: "15",
            width: "10",
            height: "80",
            rx: "3"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "2s",
                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("rect", {
            x: "30",
            width: "10",
            height: "50",
            rx: "3"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "1.4s",
                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("rect", {
            x: "45",
            width: "10",
            height: "30",
            rx: "3"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "2s",
                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$65a05f088d8e2ad5 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerAudio",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 55 80",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$l);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$k = [
    (0, $TusQn.h)("g", {
        transform: "translate(1 1)",
        "stroke-width": "2",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $TusQn.h)("circle", {
            cx: "5",
            cy: "50",
            r: "5"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                values: "50;5;50;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "cx",
                begin: "0s",
                dur: "2.2s",
                values: "5;27;49;5",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("circle", {
            cx: "27",
            cy: "5",
            r: "5"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                from: "5",
                to: "5",
                values: "5;50;50;5",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "cx",
                begin: "0s",
                dur: "2.2s",
                from: "27",
                to: "27",
                values: "27;49;5;27",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("circle", {
            cx: "49",
            cy: "50",
            r: "5"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                values: "50;50;5;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "cx",
                from: "49",
                to: "49",
                begin: "0s",
                dur: "2.2s",
                values: "49;5;27;49",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$bccad2bfd65ba3b3 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerBall",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 57 57",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$k);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$j = [
    (0, $TusQn.h)("rect", {
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("rect", {
        x: "30",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("rect", {
        x: "60",
        width: "15",
        height: "140",
        rx: "6"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "y",
            begin: "0s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("rect", {
        x: "90",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("rect", {
        x: "120",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$4a50726b08ffdead = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerBars",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 135 140",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$j);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$i = [
    (0, $TusQn.h)("rect", {
        x: "25",
        y: "25",
        width: "50",
        height: "50",
        fill: "none",
        "stroke-width": "4",
        stroke: "currentColor"
    }, [
        (0, $TusQn.h)("animateTransform", {
            id: "spinnerBox",
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "180 50 50",
            dur: "0.5s",
            begin: "rectBox.end"
        })
    ]),
    (0, $TusQn.h)("rect", {
        x: "27",
        y: "27",
        width: "46",
        height: "50",
        fill: "currentColor"
    }, [
        (0, $TusQn.h)("animate", {
            id: "rectBox",
            attributeName: "height",
            begin: "0s;spinnerBox.end",
            dur: "1.3s",
            from: "50",
            to: "0",
            fill: "freeze"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$dca5c45bff96781d = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerBox",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$i);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$h = [
    (0, $TusQn.h)("circle", {
        cx: "50",
        cy: "50",
        r: "48",
        fill: "none",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor"
    }),
    (0, $TusQn.h)("line", {
        "stroke-linecap": "round",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor",
        x1: "50",
        y1: "50",
        x2: "85",
        y2: "50.5"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "2s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("line", {
        "stroke-linecap": "round",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor",
        x1: "50",
        y1: "50",
        x2: "49.5",
        y2: "74"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "15s",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$ecf55558d357e9b2 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerClock",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$h);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$g = [
    (0, $TusQn.h)("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none"
    }),
    (0, $TusQn.h)("path", {
        d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
        fill: "currentColor"
    }),
    (0, $TusQn.h)("circle", {
        cx: "30",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;1;1",
            keyTimes: "0;0.2;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "50",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;0;1;1",
            keyTimes: "0;0.2;0.4;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "70",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;0;1;1",
            keyTimes: "0;0.4;0.6;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$6e35813dfe5ed5df = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerComment",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, $ec2fc4c0d7a3c6c6$var$svg$g);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$f = [
    (0, $TusQn.h)("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none"
    }),
    (0, $TusQn.h)("g", {
        transform: "translate(25 25)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.9"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(75 25)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.8"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.1s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(25 75)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.7"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.3s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(75 75)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.6"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.2s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$6a272c7550b80d16 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerCube",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, $ec2fc4c0d7a3c6c6$var$svg$f);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$e = [
    (0, $TusQn.h)("circle", {
        cx: "15",
        cy: "15",
        r: "15"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "60",
        cy: "15",
        r: "9",
        "fill-opacity": ".3"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "r",
            from: "9",
            to: "9",
            begin: "0s",
            dur: "0.8s",
            values: "9;15;9",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            from: ".5",
            to: ".5",
            begin: "0s",
            dur: "0.8s",
            values: ".5;1;.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "105",
        cy: "15",
        r: "15"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$d62eca58f8bab60f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerDots",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 120 30",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$e);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$d = [
    (0, $TusQn.h)("g", {
        transform: "translate(20 50)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.6"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(50 50)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.8"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0.1s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(80 50)"
    }, [
        (0, $TusQn.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.9"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0.2s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$bf634d821185ef2f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerFacebook",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid"
            }, $ec2fc4c0d7a3c6c6$var$svg$d);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$c = [
    (0, $TusQn.h)("g", {
        transform: "translate(-20,-20)"
    }, [
        (0, $TusQn.h)("path", {
            d: "M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z",
            fill: "currentColor"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "90 50 50",
                to: "0 50 50",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(20,20) rotate(15 50 50)"
    }, [
        (0, $TusQn.h)("path", {
            d: "M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z",
            fill: "currentColor"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 50 50",
                to: "90 50 50",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$d13dda2748f0ba28 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerGears",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$c);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$b = [
    (0, $TusQn.h)("circle", {
        cx: "12.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "12.5",
        cy: "52.5",
        r: "12.5",
        "fill-opacity": ".5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "100ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "52.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "300ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "52.5",
        cy: "52.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "600ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "92.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "800ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "92.5",
        cy: "52.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "400ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "12.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "700ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "52.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "500ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("circle", {
        cx: "92.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "200ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$ba3edcdf00657f3b = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerGrid",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 105 105",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$b);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$a = [
    (0, $TusQn.h)("path", {
        d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
        "fill-opacity": ".5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("path", {
        d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
        "fill-opacity": ".5"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0.7s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("path", {
        d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
    })
];
var $ec2fc4c0d7a3c6c6$export$cb77d8a2fc9a1a83 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerHearts",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 140 64",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$a);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$9 = [
    (0, $TusQn.h)("g", [
        (0, $TusQn.h)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "5",
            "stroke-miterlimit": "10",
            d: "M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"
        }),
        (0, $TusQn.h)("clipPath", {
            id: "uil-hourglass-clip1"
        }, [
            (0, $TusQn.h)("rect", {
                x: "15",
                y: "20",
                width: "70",
                height: "25"
            }, [
                (0, $TusQn.h)("animate", {
                    attributeName: "height",
                    from: "25",
                    to: "0",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "25;0;0",
                    keyTimes: "0;0.5;1"
                }),
                (0, $TusQn.h)("animate", {
                    attributeName: "y",
                    from: "20",
                    to: "45",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "20;45;45",
                    keyTimes: "0;0.5;1"
                })
            ])
        ]),
        (0, $TusQn.h)("clipPath", {
            id: "uil-hourglass-clip2"
        }, [
            (0, $TusQn.h)("rect", {
                x: "15",
                y: "55",
                width: "70",
                height: "25"
            }, [
                (0, $TusQn.h)("animate", {
                    attributeName: "height",
                    from: "0",
                    to: "25",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "0;25;25",
                    keyTimes: "0;0.5;1"
                }),
                (0, $TusQn.h)("animate", {
                    attributeName: "y",
                    from: "80",
                    to: "55",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "80;55;55",
                    keyTimes: "0;0.5;1"
                })
            ])
        ]),
        (0, $TusQn.h)("path", {
            d: "M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z",
            "clip-path": "url(#uil-hourglass-clip1)",
            fill: "currentColor"
        }),
        (0, $TusQn.h)("path", {
            d: "M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z",
            "clip-path": "url(#uil-hourglass-clip2)",
            fill: "currentColor"
        }),
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "180 50 50",
            repeatCount: "indefinite",
            dur: "1s",
            values: "0 50 50;0 50 50;180 50 50",
            keyTimes: "0;0.7;1"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$44b7dee4e71f51cd = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerHourglass",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$9);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$8 = [
    (0, $TusQn.h)("path", {
        d: "M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "8",
        "stroke-dasharray": "10.691205342610678 10.691205342610678",
        "stroke-dashoffset": "0"
    }, [
        (0, $TusQn.h)("animate", {
            attributeName: "stroke-dashoffset",
            from: "0",
            to: "21.382410685221355",
            begin: "0",
            dur: "2s",
            repeatCount: "indefinite",
            fill: "freeze"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$b71cd080434d9a8a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerInfinity",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, $ec2fc4c0d7a3c6c6$var$svg$8);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$7 = [
    (0, $TusQn.h)("g", {
        "stroke-width": "4",
        "stroke-linecap": "round"
    }, [
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(180)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(210)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(240)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(270)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(300)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(330)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(0)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(30)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(60)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(90)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(120)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(150)"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$77e9349f3d025ec0 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerIos",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                stroke: "currentColor",
                fill: "currentColor",
                viewBox: "0 0 64 64"
            }, $ec2fc4c0d7a3c6c6$var$svg$7);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$6 = [
    (0, $TusQn.h)("circle", {
        cx: "50",
        cy: "50",
        r: "44",
        fill: "none",
        "stroke-width": "4",
        "stroke-opacity": ".5",
        stroke: "currentColor"
    }),
    (0, $TusQn.h)("circle", {
        cx: "8",
        cy: "54",
        r: "6",
        fill: "currentColor",
        "stroke-width": "3",
        stroke: "currentColor"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 48",
            to: "360 50 52",
            dur: "2s",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$a97e088b3d2632d = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerOrbit",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$6);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$5 = [
    (0, $TusQn.h)("g", {
        transform: "translate(1 1)",
        "stroke-width": "2",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $TusQn.h)("circle", {
            "stroke-opacity": ".5",
            cx: "18",
            cy: "18",
            r: "18"
        }),
        (0, $TusQn.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$36a3d935578134a2 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerOval",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$5);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$4 = [
    (0, $TusQn.h)("path", {
        d: "M0 50A50 50 0 0 1 50 0L50 50L0 50",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "0.8s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("path", {
        d: "M50 0A50 50 0 0 1 100 50L50 50L50 0",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "1.6s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("path", {
        d: "M100 50A50 50 0 0 1 50 100L50 50L100 50",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "2.4s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $TusQn.h)("path", {
        d: "M50 100A50 50 0 0 1 0 50L50 50L50 100",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $TusQn.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "3.2s",
            repeatCount: "indefinite"
        })
    ])
];
var $ec2fc4c0d7a3c6c6$export$e6f3833977eceb50 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerPie",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$4);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$3 = [
    (0, $TusQn.h)("g", {
        fill: "none",
        "fill-rule": "evenodd",
        "stroke-width": "2"
    }, [
        (0, $TusQn.h)("circle", {
            cx: "22",
            cy: "22",
            r: "1"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "r",
                begin: "0s",
                dur: "1.8s",
                values: "1; 20",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.165, 0.84, 0.44, 1",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "0s",
                dur: "1.8s",
                values: "1; 0",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.3, 0.61, 0.355, 1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("circle", {
            cx: "22",
            cy: "22",
            r: "1"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "r",
                begin: "-0.9s",
                dur: "1.8s",
                values: "1; 20",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.165, 0.84, 0.44, 1",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "-0.9s",
                dur: "1.8s",
                values: "1; 0",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.3, 0.61, 0.355, 1",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$56d4f370365c4ec9 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerPuff",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 44 44",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$3);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$2 = [
    (0, $TusQn.h)("g", {
        transform: "scale(0.55)"
    }, [
        (0, $TusQn.h)("circle", {
            cx: "30",
            cy: "150",
            r: "30",
            fill: "currentColor"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ]),
        (0, $TusQn.h)("path", {
            d: "M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z",
            fill: "currentColor"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0.1",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ]),
        (0, $TusQn.h)("path", {
            d: "M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z",
            fill: "currentColor"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0.2",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$7734a351fc7fed9d = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerRadio",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$2);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg$1 = [
    (0, $TusQn.h)("g", {
        fill: "none",
        "fill-rule": "evenodd",
        transform: "translate(1 1)",
        "stroke-width": "2"
    }, [
        (0, $TusQn.h)("circle", {
            cx: "22",
            cy: "22",
            r: "6"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "r",
                begin: "1.5s",
                dur: "3s",
                values: "6;22",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "1.5s",
                dur: "3s",
                values: "1;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-width",
                begin: "1.5s",
                dur: "3s",
                values: "2;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("circle", {
            cx: "22",
            cy: "22",
            r: "6"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "r",
                begin: "3s",
                dur: "3s",
                values: "6;22",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "3s",
                dur: "3s",
                values: "1;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $TusQn.h)("animate", {
                attributeName: "stroke-width",
                begin: "3s",
                dur: "3s",
                values: "2;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("circle", {
            cx: "22",
            cy: "22",
            r: "8"
        }, [
            (0, $TusQn.h)("animate", {
                attributeName: "r",
                begin: "0s",
                dur: "1.5s",
                values: "6;1;2;3;4;5;6",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$6d6e0a9951cccd21 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerRings",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 45 45",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg$1);
    }
});
const $ec2fc4c0d7a3c6c6$var$svg = [
    (0, $TusQn.h)("defs", [
        (0, $TusQn.h)("linearGradient", {
            x1: "8.042%",
            y1: "0%",
            x2: "65.682%",
            y2: "23.865%",
            id: "a"
        }, [
            (0, $TusQn.h)("stop", {
                "stop-color": "currentColor",
                "stop-opacity": "0",
                offset: "0%"
            }),
            (0, $TusQn.h)("stop", {
                "stop-color": "currentColor",
                "stop-opacity": ".631",
                offset: "63.146%"
            }),
            (0, $TusQn.h)("stop", {
                "stop-color": "currentColor",
                offset: "100%"
            })
        ])
    ]),
    (0, $TusQn.h)("g", {
        transform: "translate(1 1)",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $TusQn.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18",
            stroke: "url(#a)",
            "stroke-width": "2"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "0.9s",
                repeatCount: "indefinite"
            })
        ]),
        (0, $TusQn.h)("circle", {
            fill: "currentColor",
            cx: "36",
            cy: "18",
            r: "1"
        }, [
            (0, $TusQn.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "0.9s",
                repeatCount: "indefinite"
            })
        ])
    ])
];
var $ec2fc4c0d7a3c6c6$export$87ed3277eacd506 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSpinnerTail",
    props: $ec2fc4c0d7a3c6c6$var$useSpinnerProps,
    setup (e) {
        const { cSize: t, classes: o } = $ec2fc4c0d7a3c6c6$var$useSpinner(e);
        return ()=>(0, $TusQn.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg"
            }, $ec2fc4c0d7a3c6c6$var$svg);
    }
}), $ec2fc4c0d7a3c6c6$export$e24eb95a687f22c5 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QSplitter",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        modelValue: {
            type: Number,
            required: !0
        },
        reverse: Boolean,
        unit: {
            type: String,
            default: "%",
            validator: (e)=>[
                    "%",
                    "px"
                ].includes(e)
        },
        limits: {
            type: Array,
            validator: (e)=>{
                return 2 === e.length && "number" === typeof e[0] && "number" === typeof e[1] && e[0] >= 0 && e[0] <= e[1];
            }
        },
        emitImmediately: Boolean,
        horizontal: Boolean,
        disable: Boolean,
        beforeClass: [
            Array,
            String,
            Object
        ],
        afterClass: [
            Array,
            String,
            Object
        ],
        separatorClass: [
            Array,
            String,
            Object
        ],
        separatorStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), l = (0, $01W3b.ref)(null), i = {
            before: (0, $01W3b.ref)(null),
            after: (0, $01W3b.ref)(null)
        }, r = (0, $TusQn.computed)(()=>"q-splitter no-wrap " + `${!0 === e.horizontal ? "q-splitter--horizontal column" : "q-splitter--vertical row"}` + ` q-splitter--${!0 === e.disable ? "disabled" : "workable"}` + (!0 === a.value ? " q-splitter--dark" : "")), s = (0, $TusQn.computed)(()=>!0 === e.horizontal ? "height" : "width"), u = (0, $TusQn.computed)(()=>!0 !== e.reverse ? "before" : "after"), c = (0, $TusQn.computed)(()=>void 0 !== e.limits ? e.limits : "%" === e.unit ? [
                10,
                90
            ] : [
                50,
                1 / 0
            ]);
        function d(t) {
            return ("%" === e.unit ? t : Math.round(t)) + e.unit;
        }
        const p = (0, $TusQn.computed)(()=>({
                [u.value]: {
                    [s.value]: d(e.modelValue)
                }
            }));
        let v, m, f, g, b;
        function y(t) {
            if (!0 === t.isFirst) {
                const t = l.value.getBoundingClientRect()[s.value];
                return v = !0 === e.horizontal ? "up" : "left", m = "%" === e.unit ? 100 : t, f = Math.min(m, c.value[1], Math.max(c.value[0], e.modelValue)), g = (!0 !== e.reverse ? 1 : -1) * (!0 === e.horizontal ? 1 : !0 === n.lang.rtl ? -1 : 1) * ("%" === e.unit ? 0 === t ? 0 : 100 / t : 1), void l.value.classList.add("q-splitter--active");
            }
            if (!0 === t.isFinal) return b !== e.modelValue && o("update:modelValue", b), void l.value.classList.remove("q-splitter--active");
            const a = f + g * (t.direction === v ? -1 : 1) * t.distance[!0 === e.horizontal ? "y" : "x"];
            b = Math.min(m, c.value[1], Math.max(c.value[0], a)), i[u.value].value.style[s.value] = d(b), !0 === e.emitImmediately && e.modelValue !== b && o("update:modelValue", b);
        }
        const S = (0, $TusQn.computed)(()=>{
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    y,
                    void 0,
                    {
                        [!0 === e.horizontal ? "vertical" : "horizontal"]: !0,
                        prevent: !0,
                        stop: !0,
                        mouse: !0,
                        mouseAllDir: !0
                    }
                ]
            ];
        });
        function w(e, t) {
            e < t[0] ? o("update:modelValue", t[0]) : e > t[1] && o("update:modelValue", t[1]);
        }
        return (0, $TusQn.watch)(()=>e.modelValue, (e)=>{
            w(e, c.value);
        }), (0, $TusQn.watch)(()=>e.limits, ()=>{
            (0, $TusQn.nextTick)(()=>{
                w(e.modelValue, c.value);
            });
        }), ()=>{
            const o = [
                (0, $TusQn.h)("div", {
                    ref: i.before,
                    class: [
                        "q-splitter__panel q-splitter__before" + (!0 === e.reverse ? " col" : ""),
                        e.beforeClass
                    ],
                    style: p.value.before
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.before)),
                (0, $TusQn.h)("div", {
                    class: [
                        "q-splitter__separator",
                        e.separatorClass
                    ],
                    style: e.separatorStyle,
                    "aria-disabled": !0 === e.disable ? "true" : void 0
                }, [
                    $ec2fc4c0d7a3c6c6$var$hDir("div", {
                        class: "q-splitter__separator-area absolute-full"
                    }, $ec2fc4c0d7a3c6c6$var$hSlot(t.separator), "sep", !0 !== e.disable, ()=>S.value)
                ]),
                (0, $TusQn.h)("div", {
                    ref: i.after,
                    class: [
                        "q-splitter__panel q-splitter__after" + (!0 === e.reverse ? "" : " col"),
                        e.afterClass
                    ],
                    style: p.value.after
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.after))
            ];
            return (0, $TusQn.h)("div", {
                class: r.value,
                ref: l
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.default, o));
        };
    }
}), $ec2fc4c0d7a3c6c6$var$StepHeader = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "StepHeader",
    props: {
        stepper: {},
        step: {},
        goToPanel: Function
    },
    setup (e, { attrs: t }) {
        const { proxy: { $q: o } } = (0, $TusQn.getCurrentInstance)(), n = (0, $01W3b.ref)(null), a = (0, $TusQn.computed)(()=>e.stepper.modelValue === e.step.name), l = (0, $TusQn.computed)(()=>{
            const t = e.step.disable;
            return !0 === t || "" === t;
        }), i = (0, $TusQn.computed)(()=>{
            const t = e.step.error;
            return !0 === t || "" === t;
        }), r = (0, $TusQn.computed)(()=>{
            const t = e.step.done;
            return !1 === l.value && (!0 === t || "" === t);
        }), s = (0, $TusQn.computed)(()=>{
            const t = e.step.headerNav, o = !0 === t || "" === t || void 0 === t;
            return !1 === l.value && e.stepper.headerNav && o;
        }), u = (0, $TusQn.computed)(()=>{
            return e.step.prefix && (!1 === a.value || "none" === e.stepper.activeIcon) && (!1 === i.value || "none" === e.stepper.errorIcon) && (!1 === r.value || "none" === e.stepper.doneIcon);
        }), c = (0, $TusQn.computed)(()=>{
            const t = e.step.icon || e.stepper.inactiveIcon;
            if (!0 === a.value) {
                const n = e.step.activeIcon || e.stepper.activeIcon;
                return "none" === n ? t : n || o.iconSet.stepper.active;
            }
            if (!0 === i.value) {
                const n = e.step.errorIcon || e.stepper.errorIcon;
                return "none" === n ? t : n || o.iconSet.stepper.error;
            }
            if (!1 === l.value && !0 === r.value) {
                const n = e.step.doneIcon || e.stepper.doneIcon;
                return "none" === n ? t : n || o.iconSet.stepper.done;
            }
            return t;
        }), d = (0, $TusQn.computed)(()=>{
            const t = !0 === i.value ? e.step.errorColor || e.stepper.errorColor : void 0;
            if (!0 === a.value) {
                const o = e.step.activeColor || e.stepper.activeColor || e.step.color;
                return void 0 !== o ? o : t;
            }
            return void 0 !== t ? t : !1 === l.value && !0 === r.value ? e.step.doneColor || e.stepper.doneColor || e.step.color || e.stepper.inactiveColor : e.step.color || e.stepper.inactiveColor;
        }), p = (0, $TusQn.computed)(()=>{
            return "q-stepper__tab col-grow flex items-center no-wrap relative-position" + (void 0 !== d.value ? ` text-${d.value}` : "") + (!0 === i.value ? " q-stepper__tab--error q-stepper__tab--error-with-" + (!0 === u.value ? "prefix" : "icon") : "") + (!0 === a.value ? " q-stepper__tab--active" : "") + (!0 === r.value ? " q-stepper__tab--done" : "") + (!0 === s.value ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (!0 === l.value ? " q-stepper__tab--disabled" : "");
        }), v = (0, $TusQn.computed)(()=>!0 === e.stepper.headerNav && s.value);
        function m() {
            null !== n.value && n.value.focus(), !1 === a.value && e.goToPanel(e.step.name);
        }
        function f(t) {
            13 === t.keyCode && !1 === a.value && e.goToPanel(e.step.name);
        }
        return ()=>{
            const o = {
                class: p.value
            };
            !0 === s.value && (o.onClick = m, o.onKeyup = f, Object.assign(o, !0 === l.value ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: t.tabindex || 0
            }));
            const a = [
                (0, $TusQn.h)("div", {
                    class: "q-focus-helper",
                    tabindex: -1,
                    ref: n
                }),
                (0, $TusQn.h)("div", {
                    class: "q-stepper__dot row flex-center q-stepper__line relative-position"
                }, [
                    (0, $TusQn.h)("span", {
                        class: "row flex-center"
                    }, [
                        !0 === u.value ? e.step.prefix : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                            name: c.value
                        })
                    ])
                ])
            ];
            if (void 0 !== e.step.title && null !== e.step.title) {
                const t = [
                    (0, $TusQn.h)("div", {
                        class: "q-stepper__title"
                    }, e.step.title)
                ];
                void 0 !== e.step.caption && null !== e.step.caption && t.push((0, $TusQn.h)("div", {
                    class: "q-stepper__caption"
                }, e.step.caption)), a.push((0, $TusQn.h)("div", {
                    class: "q-stepper__label q-stepper__line relative-position"
                }, t));
            }
            return (0, $TusQn.withDirectives)((0, $TusQn.h)("div", o, a), [
                [
                    $ec2fc4c0d7a3c6c6$export$9e9146f7e027fdaa,
                    v.value
                ]
            ]);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$getStepWrapper(e) {
    return (0, $TusQn.h)("div", {
        class: "q-stepper__step-content"
    }, [
        (0, $TusQn.h)("div", {
            class: "q-stepper__step-inner"
        }, $ec2fc4c0d7a3c6c6$var$hSlot(e.default))
    ]);
}
const $ec2fc4c0d7a3c6c6$var$PanelWrapper = {
    setup (e, { slots: t }) {
        return ()=>$ec2fc4c0d7a3c6c6$var$getStepWrapper(t);
    }
};
var $ec2fc4c0d7a3c6c6$export$973d42224d50092f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QStep",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$usePanelChildProps,
        icon: String,
        color: String,
        title: {
            type: String,
            required: !0
        },
        caption: String,
        prefix: [
            String,
            Number
        ],
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String,
        headerNav: {
            type: Boolean,
            default: !0
        },
        done: Boolean,
        error: Boolean,
        onScroll: [
            Function,
            Array
        ]
    },
    setup (e, { slots: t, emit: o }) {
        const { proxy: { $q: n } } = (0, $TusQn.getCurrentInstance)(), a = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$stepperKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (a === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QStep needs to be a child of QStepper"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        const { getCacheWithFn: l } = $ec2fc4c0d7a3c6c6$var$useCache(), i = (0, $01W3b.ref)(null), r = (0, $TusQn.computed)(()=>a.value.modelValue === e.name), s = (0, $TusQn.computed)(()=>!0 !== n.platform.is.ios && !0 === n.platform.is.chrome || !0 !== r.value || !0 !== a.value.vertical ? {} : {
                onScroll (t) {
                    const { target: n } = t;
                    n.scrollTop > 0 && (n.scrollTop = 0), void 0 !== e.onScroll && o("scroll", t);
                }
            }), u = (0, $TusQn.computed)(()=>"string" === typeof e.name || "number" === typeof e.name ? e.name : String(e.name));
        function c() {
            const e = a.value.vertical;
            return !0 === e && !0 === a.value.keepAlive ? (0, $TusQn.h)((0, $TusQn.KeepAlive), a.value.keepAliveProps.value, !0 === r.value ? [
                (0, $TusQn.h)(!0 === a.value.needsUniqueKeepAliveWrapper.value ? l(u.value, ()=>({
                        ...$ec2fc4c0d7a3c6c6$var$PanelWrapper,
                        name: u.value
                    })) : $ec2fc4c0d7a3c6c6$var$PanelWrapper, {
                    key: u.value
                }, t.default)
            ] : void 0) : !0 !== e || !0 === r.value ? $ec2fc4c0d7a3c6c6$var$getStepWrapper(t) : void 0;
        }
        return ()=>(0, $TusQn.h)("div", {
                ref: i,
                class: "q-stepper__step",
                role: "tabpanel",
                ...s.value
            }, !0 === a.value.vertical ? [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$var$StepHeader, {
                    stepper: a.value,
                    step: e,
                    goToPanel: a.value.goToPanel
                }),
                !0 === a.value.animated ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$1712cdc175d4649d, c) : c()
            ] : [
                c()
            ]);
    }
});
const $ec2fc4c0d7a3c6c6$var$camelRE = /(-\w)/g;
function $ec2fc4c0d7a3c6c6$var$camelizeProps(e) {
    const t = {};
    for(const o in e){
        const n = o.replace($ec2fc4c0d7a3c6c6$var$camelRE, (e)=>e[1].toUpperCase());
        t[n] = e[o];
    }
    return t;
}
var $ec2fc4c0d7a3c6c6$export$9b249c4f2312b48e = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QStepper",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$usePanelProps,
        flat: Boolean,
        bordered: Boolean,
        alternativeLabels: Boolean,
        headerNav: Boolean,
        contracted: Boolean,
        headerClass: String,
        inactiveColor: String,
        inactiveIcon: String,
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String
    },
    emits: $ec2fc4c0d7a3c6c6$var$usePanelEmits,
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q), { updatePanelsList: a, isValidPanelName: l, updatePanelIndex: i, getPanelContent: r, getPanels: s, panelDirectives: u, goToPanel: c, keepAliveProps: d, needsUniqueKeepAliveWrapper: p } = $ec2fc4c0d7a3c6c6$var$usePanel();
        (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$stepperKey, (0, $TusQn.computed)(()=>({
                goToPanel: c,
                keepAliveProps: d,
                needsUniqueKeepAliveWrapper: p,
                ...e
            })));
        const v = (0, $TusQn.computed)(()=>`q-stepper q-stepper--${!0 === e.vertical ? "vertical" : "horizontal"}` + (!0 === e.flat ? " q-stepper--flat" : "") + (!0 === e.bordered ? " q-stepper--bordered" : "") + (!0 === n.value ? " q-stepper--dark q-dark" : "")), m = (0, $TusQn.computed)(()=>"q-stepper__header row items-stretch justify-between" + ` q-stepper__header--${!0 === e.alternativeLabels ? "alternative" : "standard"}-labels` + (!1 === e.flat || !0 === e.bordered ? " q-stepper__header--border" : "") + (!0 === e.contracted ? " q-stepper__header--contracted" : "") + (void 0 !== e.headerClass ? ` ${e.headerClass}` : ""));
        function f() {
            const o = $ec2fc4c0d7a3c6c6$var$hSlot(t.message, []);
            if (!0 === e.vertical) {
                l(e.modelValue) && i();
                const n = (0, $TusQn.h)("div", {
                    class: "q-stepper__content"
                }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
                return void 0 === o ? [
                    n
                ] : o.concat(n);
            }
            return [
                (0, $TusQn.h)("div", {
                    class: m.value
                }, s().map((t)=>{
                    const o = $ec2fc4c0d7a3c6c6$var$camelizeProps(t.props);
                    return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$var$StepHeader, {
                        key: o.name,
                        stepper: e,
                        step: o,
                        goToPanel: c
                    });
                })),
                o,
                $ec2fc4c0d7a3c6c6$var$hDir("div", {
                    class: "q-stepper__content q-panel-parent"
                }, r(), "cont", e.swipeable, ()=>u.value)
            ];
        }
        return ()=>{
            return a(t), (0, $TusQn.h)("div", {
                class: v.value
            }, $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.navigation, f()));
        };
    }
}), $ec2fc4c0d7a3c6c6$export$ccae125a3a1bd01f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QStepperNavigation",
    setup (e, { slots: t }) {
        return ()=>(0, $TusQn.h)("div", {
                class: "q-stepper__nav"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$f3b568562ea6363f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTh",
    props: {
        props: Object,
        autoWidth: Boolean
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $TusQn.getCurrentInstance)(), { proxy: { $q: a } } = n, l = (e)=>{
            o("click", e);
        };
        return ()=>{
            if (void 0 === e.props) return (0, $TusQn.h)("th", {
                class: !0 === e.autoWidth ? "q-table--col-auto-width" : "",
                onClick: l
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
            let o, i;
            const r = n.vnode.key;
            if (r) {
                if (o = e.props.colsMap[r], void 0 === o) return;
            } else o = e.props.col;
            if (!0 === o.sortable) {
                const e = "right" === o.align ? "unshift" : "push";
                i = $ec2fc4c0d7a3c6c6$var$hUniqueSlot(t.default, []), i[e]((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    class: o.__iconClass,
                    name: a.iconSet.table.arrowUp
                }));
            } else i = $ec2fc4c0d7a3c6c6$var$hSlot(t.default);
            const s = {
                class: o.__thClass + (!0 === e.autoWidth ? " q-table--col-auto-width" : ""),
                style: o.headerStyle,
                onClick: (t)=>{
                    !0 === o.sortable && e.props.sort(o), l(t);
                }
            };
            return (0, $TusQn.h)("th", s, i);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$getTableMiddle(e, t) {
    return (0, $TusQn.h)("div", e, [
        (0, $TusQn.h)("table", {
            class: "q-table"
        }, t)
    ]);
}
const $ec2fc4c0d7a3c6c6$var$comps = {
    list: $ec2fc4c0d7a3c6c6$export$546da2cac02ecac2,
    table: $ec2fc4c0d7a3c6c6$export$96e16f0b01ad0bca
}, $ec2fc4c0d7a3c6c6$var$typeOptions = [
    "list",
    "table",
    "__qtable"
];
var $ec2fc4c0d7a3c6c6$export$e23e912583dc74c1 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QVirtualScroll",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useVirtualScrollProps,
        type: {
            type: String,
            default: "list",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$typeOptions.includes(e)
        },
        items: {
            type: Array,
            default: ()=>[]
        },
        itemsFn: Function,
        itemsSize: Number,
        scrollTarget: {
            default: void 0
        }
    },
    setup (e, { slots: t, attrs: o }) {
        let n;
        const a = (0, $01W3b.ref)(null), l = (0, $TusQn.computed)(()=>e.itemsSize >= 0 && void 0 !== e.itemsFn ? parseInt(e.itemsSize, 10) : Array.isArray(e.items) ? e.items.length : 0), { virtualScrollSliceRange: i, localResetVirtualScroll: r, padVirtualScroll: s, onVirtualScrollEvt: u } = $ec2fc4c0d7a3c6c6$var$useVirtualScroll({
            virtualScrollLength: l,
            getVirtualScrollTarget: m,
            getVirtualScrollEl: v
        }), c = (0, $TusQn.computed)(()=>{
            if (0 === l.value) return [];
            const t = (e, t)=>({
                    index: i.value.from + t,
                    item: e
                });
            return void 0 === e.itemsFn ? e.items.slice(i.value.from, i.value.to).map(t) : e.itemsFn(i.value.from, i.value.to - i.value.from).map(t);
        }), d = (0, $TusQn.computed)(()=>"q-virtual-scroll q-virtual-scroll" + (!0 === e.virtualScrollHorizontal ? "--horizontal" : "--vertical") + (void 0 !== e.scrollTarget ? "" : " scroll")), p = (0, $TusQn.computed)(()=>void 0 !== e.scrollTarget ? {} : {
                tabindex: 0
            });
        function v() {
            return a.value.$el || a.value;
        }
        function m() {
            return n;
        }
        function f() {
            n = $ec2fc4c0d7a3c6c6$var$getScrollTarget(v(), e.scrollTarget), n.addEventListener("scroll", u, $ec2fc4c0d7a3c6c6$var$listenOpts.passive);
        }
        function g() {
            void 0 !== n && (n.removeEventListener("scroll", u, $ec2fc4c0d7a3c6c6$var$listenOpts.passive), n = void 0);
        }
        function b() {
            let o = s("list" === e.type ? "div" : "tbody", c.value.map(t.default));
            return void 0 !== t.before && (o = t.before().concat(o)), $ec2fc4c0d7a3c6c6$var$hMergeSlot(t.after, o);
        }
        return (0, $TusQn.watch)(l, ()=>{
            r();
        }), (0, $TusQn.watch)(()=>e.scrollTarget, ()=>{
            g(), f();
        }), (0, $TusQn.onBeforeMount)(()=>{
            r();
        }), (0, $TusQn.onMounted)(()=>{
            f();
        }), (0, $TusQn.onActivated)(()=>{
            f();
        }), (0, $TusQn.onDeactivated)(()=>{
            g();
        }), (0, $TusQn.onBeforeUnmount)(()=>{
            g();
        }), ()=>{
            if (void 0 !== t.default) return "__qtable" === e.type ? $ec2fc4c0d7a3c6c6$var$getTableMiddle({
                ref: a,
                class: "q-table__middle " + d.value
            }, b()) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$var$comps[e.type], {
                ...o,
                ref: a,
                class: [
                    o.class,
                    d.value
                ],
                ...p.value
            }, b);
            console.error("QVirtualScroll: default scoped slot is required for rendering");
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$sortDate(e, t) {
    return new Date(e) - new Date(t);
}
const $ec2fc4c0d7a3c6c6$var$useTableSortProps = {
    sortMethod: Function,
    binaryStateSort: Boolean,
    columnSortOrder: {
        type: String,
        validator: (e)=>"ad" === e || "da" === e,
        default: "ad"
    }
};
function $ec2fc4c0d7a3c6c6$var$useTableSort(e, t, o, n) {
    const a = (0, $TusQn.computed)(()=>{
        const { sortBy: e } = t.value;
        return e && o.value.find((t)=>t.name === e) || null;
    }), l = (0, $TusQn.computed)(()=>void 0 !== e.sortMethod ? e.sortMethod : (e, t, n)=>{
            const a = o.value.find((e)=>e.name === t);
            if (void 0 === a || void 0 === a.field) return e;
            const l = !0 === n ? -1 : 1, i = "function" === typeof a.field ? (e)=>a.field(e) : (e)=>e[a.field];
            return e.sort((e, t)=>{
                let o = i(e), n = i(t);
                return null === o || void 0 === o ? -1 * l : null === n || void 0 === n ? 1 * l : void 0 !== a.sort ? a.sort(o, n, e, t) * l : !0 === $ec2fc4c0d7a3c6c6$var$isNumber(o) && !0 === $ec2fc4c0d7a3c6c6$var$isNumber(n) ? (o - n) * l : !0 === $ec2fc4c0d7a3c6c6$var$isDate(o) && !0 === $ec2fc4c0d7a3c6c6$var$isDate(n) ? $ec2fc4c0d7a3c6c6$var$sortDate(o, n) * l : "boolean" === typeof o && "boolean" === typeof n ? (o - n) * l : ([o, n] = [
                    o,
                    n
                ].map((e)=>(e + "").toLocaleString().toLowerCase()), o < n ? -1 * l : o === n ? 0 : l);
            });
        });
    function i(a) {
        let l = e.columnSortOrder;
        if (!0 === $ec2fc4c0d7a3c6c6$var$isObject(a)) a.sortOrder && (l = a.sortOrder), a = a.name;
        else {
            const e = o.value.find((e)=>e.name === a);
            void 0 !== e && e.sortOrder && (l = e.sortOrder);
        }
        let { sortBy: i, descending: r } = t.value;
        i !== a ? (i = a, r = "da" === l) : !0 === e.binaryStateSort ? r = !r : !0 === r ? "ad" === l ? i = null : r = !1 : "ad" === l ? r = !0 : i = null, n({
            sortBy: i,
            descending: r,
            page: 1
        });
    }
    return {
        columnToSort: a,
        computedSortMethod: l,
        sort: i
    };
}
const $ec2fc4c0d7a3c6c6$var$useTableFilterProps = {
    filter: [
        String,
        Object
    ],
    filterMethod: Function
};
function $ec2fc4c0d7a3c6c6$var$useTableFilter(e, t) {
    const o = (0, $TusQn.computed)(()=>void 0 !== e.filterMethod ? e.filterMethod : (e, t, o, n)=>{
            const a = t ? t.toLowerCase() : "";
            return e.filter((e)=>o.some((t)=>{
                    const o = n(t, e) + "", l = "undefined" === o || "null" === o ? "" : o.toLowerCase();
                    return -1 !== l.indexOf(a);
                }));
        });
    return (0, $TusQn.watch)(()=>e.filter, ()=>{
        (0, $TusQn.nextTick)(()=>{
            t({
                page: 1
            }, !0);
        });
    }, {
        deep: !0
    }), {
        computedFilterMethod: o
    };
}
function $ec2fc4c0d7a3c6c6$var$samePagination(e, t) {
    for(const o in t)if (t[o] !== e[o]) return !1;
    return !0;
}
function $ec2fc4c0d7a3c6c6$var$fixPagination(e) {
    return e.page < 1 && (e.page = 1), void 0 !== e.rowsPerPage && e.rowsPerPage < 1 && (e.rowsPerPage = 0), e;
}
const $ec2fc4c0d7a3c6c6$var$useTablePaginationProps = {
    pagination: Object,
    rowsPerPageOptions: {
        type: Array,
        default: ()=>[
                5,
                7,
                10,
                15,
                20,
                25,
                50,
                0
            ]
    },
    "onUpdate:pagination": [
        Function,
        Array
    ]
};
function $ec2fc4c0d7a3c6c6$var$useTablePaginationState(e, t) {
    const { props: o, emit: n } = e, a = (0, $01W3b.ref)(Object.assign({
        sortBy: null,
        descending: !1,
        page: 1,
        rowsPerPage: 0 !== o.rowsPerPageOptions.length ? o.rowsPerPageOptions[0] : 5
    }, o.pagination)), l = (0, $TusQn.computed)(()=>{
        const e = void 0 !== o["onUpdate:pagination"] ? {
            ...a.value,
            ...o.pagination
        } : a.value;
        return $ec2fc4c0d7a3c6c6$var$fixPagination(e);
    }), i = (0, $TusQn.computed)(()=>void 0 !== l.value.rowsNumber);
    function r(e) {
        s({
            pagination: e,
            filter: o.filter
        });
    }
    function s(e = {}) {
        (0, $TusQn.nextTick)(()=>{
            n("request", {
                pagination: e.pagination || l.value,
                filter: e.filter || o.filter,
                getCellValue: t
            });
        });
    }
    function u(e, t) {
        const s = $ec2fc4c0d7a3c6c6$var$fixPagination({
            ...l.value,
            ...e
        });
        !0 !== $ec2fc4c0d7a3c6c6$var$samePagination(l.value, s) ? !0 !== i.value ? void 0 !== o.pagination && void 0 !== o["onUpdate:pagination"] ? n("update:pagination", s) : a.value = s : r(s) : !0 === i.value && !0 === t && r(s);
    }
    return {
        innerPagination: a,
        computedPagination: l,
        isServerSide: i,
        requestServerInteraction: s,
        setPagination: u
    };
}
function $ec2fc4c0d7a3c6c6$var$useTablePagination(e, t, o, n, a, l) {
    const { props: i, emit: r, proxy: { $q: s } } = e, u = (0, $TusQn.computed)(()=>!0 === n.value ? o.value.rowsNumber || 0 : l.value), c = (0, $TusQn.computed)(()=>{
        const { page: e, rowsPerPage: t } = o.value;
        return (e - 1) * t;
    }), d = (0, $TusQn.computed)(()=>{
        const { page: e, rowsPerPage: t } = o.value;
        return e * t;
    }), p = (0, $TusQn.computed)(()=>1 === o.value.page), v = (0, $TusQn.computed)(()=>0 === o.value.rowsPerPage ? 1 : Math.max(1, Math.ceil(u.value / o.value.rowsPerPage))), m = (0, $TusQn.computed)(()=>0 === d.value || o.value.page >= v.value), f = (0, $TusQn.computed)(()=>{
        const e = i.rowsPerPageOptions.includes(t.value.rowsPerPage) ? i.rowsPerPageOptions : [
            t.value.rowsPerPage
        ].concat(i.rowsPerPageOptions);
        return e.map((e)=>({
                label: 0 === e ? s.lang.table.allRows : "" + e,
                value: e
            }));
    });
    function h() {
        a({
            page: 1
        });
    }
    function g() {
        const { page: e } = o.value;
        e > 1 && a({
            page: e - 1
        });
    }
    function b() {
        const { page: e, rowsPerPage: t } = o.value;
        d.value > 0 && e * t < u.value && a({
            page: e + 1
        });
    }
    function y() {
        a({
            page: v.value
        });
    }
    return (0, $TusQn.watch)(v, (e, t)=>{
        if (e === t) return;
        const n = o.value.page;
        e && !n ? a({
            page: 1
        }) : e < n && a({
            page: e
        });
    }), void 0 !== i["onUpdate:pagination"] && r("update:pagination", {
        ...o.value
    }), {
        firstRowIndex: c,
        lastRowIndex: d,
        isFirstPage: p,
        isLastPage: m,
        pagesNumber: v,
        computedRowsPerPageOptions: f,
        computedRowsNumber: u,
        firstPage: h,
        prevPage: g,
        nextPage: b,
        lastPage: y
    };
}
const $ec2fc4c0d7a3c6c6$var$useTableRowSelectionProps = {
    selection: {
        type: String,
        default: "none",
        validator: (e)=>[
                "single",
                "multiple",
                "none"
            ].includes(e)
    },
    selected: {
        type: Array,
        default: ()=>[]
    }
}, $ec2fc4c0d7a3c6c6$var$useTableRowSelectionEmits = [
    "update:selected",
    "selection"
];
function $ec2fc4c0d7a3c6c6$var$useTableRowSelection(e, t, o, n) {
    const a = (0, $TusQn.computed)(()=>{
        const t = {};
        return e.selected.map(n.value).forEach((e)=>{
            t[e] = !0;
        }), t;
    }), l = (0, $TusQn.computed)(()=>{
        return "none" !== e.selection;
    }), i = (0, $TusQn.computed)(()=>{
        return "single" === e.selection;
    }), r = (0, $TusQn.computed)(()=>{
        return "multiple" === e.selection;
    }), s = (0, $TusQn.computed)(()=>0 !== o.value.length && o.value.every((e)=>!0 === a.value[n.value(e)])), u = (0, $TusQn.computed)(()=>!0 !== s.value && o.value.some((e)=>!0 === a.value[n.value(e)])), c = (0, $TusQn.computed)(()=>e.selected.length);
    function d(e) {
        return !0 === a.value[e];
    }
    function p() {
        t("update:selected", []);
    }
    function v(o, a, l, r) {
        t("selection", {
            rows: a,
            added: l,
            keys: o,
            evt: r
        });
        const s = !0 === i.value ? !0 === l ? a : [] : !0 === l ? e.selected.concat(a) : e.selected.filter((e)=>!1 === o.includes(n.value(e)));
        t("update:selected", s);
    }
    return {
        hasSelectionMode: l,
        singleSelection: i,
        multipleSelection: r,
        allRowsSelected: s,
        someRowsSelected: u,
        rowsSelectedNumber: c,
        isRowSelected: d,
        clearSelection: p,
        updateSelection: v
    };
}
function $ec2fc4c0d7a3c6c6$var$getVal(e) {
    return Array.isArray(e) ? e.slice() : [];
}
const $ec2fc4c0d7a3c6c6$var$useTableRowExpandProps = {
    expanded: Array
}, $ec2fc4c0d7a3c6c6$var$useTableRowExpandEmits = [
    "update:expanded"
];
function $ec2fc4c0d7a3c6c6$var$useTableRowExpand(e, t) {
    const o = (0, $01W3b.ref)($ec2fc4c0d7a3c6c6$var$getVal(e.expanded));
    function n(e) {
        return o.value.includes(e);
    }
    function a(n) {
        void 0 !== e.expanded ? t("update:expanded", n) : o.value = n;
    }
    function l(e, t) {
        const n = o.value.slice(), l = n.indexOf(e);
        !0 === t ? -1 === l && (n.push(e), a(n)) : -1 !== l && (n.splice(l, 1), a(n));
    }
    return (0, $TusQn.watch)(()=>e.expanded, (e)=>{
        o.value = $ec2fc4c0d7a3c6c6$var$getVal(e);
    }), {
        isRowExpanded: n,
        setExpanded: a,
        updateExpanded: l
    };
}
const $ec2fc4c0d7a3c6c6$var$useTableColumnSelectionProps = {
    visibleColumns: Array
};
function $ec2fc4c0d7a3c6c6$var$useTableColumnSelection(e, t, o) {
    const n = (0, $TusQn.computed)(()=>{
        if (void 0 !== e.columns) return e.columns;
        const t = e.rows[0];
        return void 0 !== t ? Object.keys(t).map((e)=>({
                name: e,
                label: e.toUpperCase(),
                field: e,
                align: $ec2fc4c0d7a3c6c6$var$isNumber(t[e]) ? "right" : "left",
                sortable: !0
            })) : [];
    }), a = (0, $TusQn.computed)(()=>{
        const { sortBy: o, descending: a } = t.value, l = void 0 !== e.visibleColumns ? n.value.filter((t)=>!0 === t.required || !0 === e.visibleColumns.includes(t.name)) : n.value;
        return l.map((e)=>{
            const t = e.align || "right", n = `text-${t}`;
            return {
                ...e,
                align: t,
                __iconClass: `q-table__sort-icon q-table__sort-icon--${t}`,
                __thClass: n + (void 0 !== e.headerClasses ? " " + e.headerClasses : "") + (!0 === e.sortable ? " sortable" : "") + (e.name === o ? ` sorted ${!0 === a ? "sort-desc" : ""}` : ""),
                __tdStyle: void 0 !== e.style ? "function" !== typeof e.style ? ()=>e.style : e.style : ()=>null,
                __tdClass: void 0 !== e.classes ? "function" !== typeof e.classes ? ()=>n + " " + e.classes : (t)=>n + " " + e.classes(t) : ()=>n
            };
        });
    }), l = (0, $TusQn.computed)(()=>{
        const e = {};
        return a.value.forEach((t)=>{
            e[t.name] = t;
        }), e;
    }), i = (0, $TusQn.computed)(()=>{
        return void 0 !== e.tableColspan ? e.tableColspan : a.value.length + (!0 === o.value ? 1 : 0);
    });
    return {
        colList: n,
        computedCols: a,
        computedColsMap: l,
        computedColspan: i
    };
}
const $ec2fc4c0d7a3c6c6$var$bottomClass = "q-table__bottom row items-center", $ec2fc4c0d7a3c6c6$var$commonVirtPropsObj = {};
$ec2fc4c0d7a3c6c6$var$commonVirtPropsList.forEach((e)=>{
    $ec2fc4c0d7a3c6c6$var$commonVirtPropsObj[e] = {};
});
var $ec2fc4c0d7a3c6c6$export$27fbdc739212cd86 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTable",
    props: {
        rows: {
            type: Array,
            default: ()=>[]
        },
        rowKey: {
            type: [
                String,
                Function
            ],
            default: "id"
        },
        columns: Array,
        loading: Boolean,
        iconFirstPage: String,
        iconPrevPage: String,
        iconNextPage: String,
        iconLastPage: String,
        title: String,
        hideHeader: Boolean,
        grid: Boolean,
        gridHeader: Boolean,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: (e)=>[
                    "horizontal",
                    "vertical",
                    "cell",
                    "none"
                ].includes(e)
        },
        wrapCells: Boolean,
        virtualScroll: Boolean,
        virtualScrollTarget: {
            default: void 0
        },
        ...$ec2fc4c0d7a3c6c6$var$commonVirtPropsObj,
        noDataLabel: String,
        noResultsLabel: String,
        loadingLabel: String,
        selectedRowsLabel: Function,
        rowsPerPageLabel: String,
        paginationLabel: Function,
        color: {
            type: String,
            default: "grey-8"
        },
        titleClass: [
            String,
            Array,
            Object
        ],
        tableStyle: [
            String,
            Array,
            Object
        ],
        tableClass: [
            String,
            Array,
            Object
        ],
        tableHeaderStyle: [
            String,
            Array,
            Object
        ],
        tableHeaderClass: [
            String,
            Array,
            Object
        ],
        cardContainerClass: [
            String,
            Array,
            Object
        ],
        cardContainerStyle: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ],
        cardClass: [
            String,
            Array,
            Object
        ],
        hideBottom: Boolean,
        hideSelectedBanner: Boolean,
        hideNoData: Boolean,
        hidePagination: Boolean,
        onRowClick: Function,
        onRowDblclick: Function,
        onRowContextmenu: Function,
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useFullscreenProps,
        ...$ec2fc4c0d7a3c6c6$var$useTableColumnSelectionProps,
        ...$ec2fc4c0d7a3c6c6$var$useTableFilterProps,
        ...$ec2fc4c0d7a3c6c6$var$useTablePaginationProps,
        ...$ec2fc4c0d7a3c6c6$var$useTableRowExpandProps,
        ...$ec2fc4c0d7a3c6c6$var$useTableRowSelectionProps,
        ...$ec2fc4c0d7a3c6c6$var$useTableSortProps
    },
    emits: [
        "request",
        "virtualScroll",
        ...$ec2fc4c0d7a3c6c6$var$useFullscreenEmits,
        ...$ec2fc4c0d7a3c6c6$var$useTableRowExpandEmits,
        ...$ec2fc4c0d7a3c6c6$var$useTableRowSelectionEmits
    ],
    setup (e, { slots: t, emit: o }) {
        const n = (0, $TusQn.getCurrentInstance)(), { proxy: { $q: a } } = n, l = $ec2fc4c0d7a3c6c6$var$useDark(e, a), { inFullscreen: i, toggleFullscreen: r } = $ec2fc4c0d7a3c6c6$var$useFullscreen(), s = (0, $TusQn.computed)(()=>"function" === typeof e.rowKey ? e.rowKey : (t)=>t[e.rowKey]), u = (0, $01W3b.ref)(null), c = (0, $01W3b.ref)(null), d = (0, $TusQn.computed)(()=>!0 !== e.grid && !0 === e.virtualScroll), p = (0, $TusQn.computed)(()=>" q-table__card" + (!0 === l.value ? " q-table__card--dark q-dark" : "") + (!0 === e.square ? " q-table--square" : "") + (!0 === e.flat ? " q-table--flat" : "") + (!0 === e.bordered ? " q-table--bordered" : "")), v = (0, $TusQn.computed)(()=>`q-table__container q-table--${e.separator}-separator column no-wrap` + (!0 === e.grid ? " q-table--grid" : p.value) + (!0 === l.value ? " q-table--dark" : "") + (!0 === e.dense ? " q-table--dense" : "") + (!1 === e.wrapCells ? " q-table--no-wrap" : "") + (!0 === i.value ? " fullscreen scroll" : "")), m = (0, $TusQn.computed)(()=>v.value + (!0 === e.loading ? " q-table--loading" : ""));
        (0, $TusQn.watch)(()=>e.tableStyle + e.tableClass + e.tableHeaderStyle + e.tableHeaderClass + v.value, ()=>{
            !0 === d.value && null !== c.value && c.value.reset();
        });
        const { innerPagination: f, computedPagination: g, isServerSide: b, requestServerInteraction: y, setPagination: S } = $ec2fc4c0d7a3c6c6$var$useTablePaginationState(n, me), { computedFilterMethod: w } = $ec2fc4c0d7a3c6c6$var$useTableFilter(e, S), { isRowExpanded: C, setExpanded: x, updateExpanded: k } = $ec2fc4c0d7a3c6c6$var$useTableRowExpand(e, o), _ = (0, $TusQn.computed)(()=>{
            let t = e.rows;
            if (!0 === b.value || 0 === t.length) return t;
            const { sortBy: o, descending: n } = g.value;
            return e.filter && (t = w.value(t, e.filter, R.value, me)), null !== I.value && (t = V.value(e.rows === t ? t.slice() : t, o, n)), t;
        }), q = (0, $TusQn.computed)(()=>_.value.length), T = (0, $TusQn.computed)(()=>{
            let t = _.value;
            if (!0 === b.value) return t;
            const { rowsPerPage: o } = g.value;
            return 0 !== o && (0 === N.value && e.rows !== t ? t.length > j.value && (t = t.slice(0, j.value)) : t = t.slice(N.value, j.value)), t;
        }), { hasSelectionMode: P, singleSelection: $, multipleSelection: M, allRowsSelected: B, someRowsSelected: E, rowsSelectedNumber: Q, isRowSelected: A, clearSelection: L, updateSelection: O } = $ec2fc4c0d7a3c6c6$var$useTableRowSelection(e, o, T, s), { colList: F, computedCols: R, computedColsMap: D, computedColspan: z } = $ec2fc4c0d7a3c6c6$var$useTableColumnSelection(e, g, P), { columnToSort: I, computedSortMethod: V, sort: H } = $ec2fc4c0d7a3c6c6$var$useTableSort(e, g, F, S), { firstRowIndex: N, lastRowIndex: j, isFirstPage: U, isLastPage: K, pagesNumber: W, computedRowsPerPageOptions: Y, computedRowsNumber: G, firstPage: X, prevPage: Z, nextPage: J, lastPage: ee } = $ec2fc4c0d7a3c6c6$var$useTablePagination(n, f, g, b, S, q), te = (0, $TusQn.computed)(()=>0 === T.value.length), oe = (0, $TusQn.computed)(()=>{
            const t = {};
            return $ec2fc4c0d7a3c6c6$var$commonVirtPropsList.forEach((o)=>{
                t[o] = e[o];
            }), void 0 === t.virtualScrollItemSize && (t.virtualScrollItemSize = !0 === e.dense ? 28 : 48), t;
        });
        function ne() {
            !0 === d.value && c.value.reset();
        }
        function ae() {
            if (!0 === e.grid) return Te();
            const o = !0 !== e.hideHeader ? be : null;
            if (!0 === d.value) {
                const n = t["top-row"], a = t["bottom-row"], l = {
                    default: (e)=>se(e.item, t.body, e.index)
                };
                if (void 0 !== n) {
                    const e = (0, $TusQn.h)("tbody", n({
                        cols: R.value
                    }));
                    l.before = null === o ? ()=>e : ()=>[
                            o()
                        ].concat(e);
                } else null !== o && (l.before = o);
                return void 0 !== a && (l.after = ()=>(0, $TusQn.h)("tbody", a({
                        cols: R.value
                    }))), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$e23e912583dc74c1, {
                    ref: c,
                    class: e.tableClass,
                    style: e.tableStyle,
                    ...oe.value,
                    scrollTarget: e.virtualScrollTarget,
                    items: T.value,
                    type: "__qtable",
                    tableColspan: z.value,
                    onVirtualScroll: ie
                }, l);
            }
            const n = [
                ue()
            ];
            return null !== o && n.unshift(o()), $ec2fc4c0d7a3c6c6$var$getTableMiddle({
                class: [
                    "q-table__middle scroll",
                    e.tableClass
                ],
                style: e.tableStyle
            }, n);
        }
        function le(t, n) {
            if (null !== c.value) return void c.value.scrollTo(t, n);
            t = parseInt(t, 10);
            const a = u.value.querySelector(`tbody tr:nth-of-type(${t + 1})`);
            if (null !== a) {
                const n = u.value.querySelector(".q-table__middle.scroll"), l = a.offsetTop - e.virtualScrollStickySizeStart, i = l < n.scrollTop ? "decrease" : "increase";
                n.scrollTop = l, o("virtualScroll", {
                    index: t,
                    from: 0,
                    to: f.value.rowsPerPage - 1,
                    direction: i
                });
            }
        }
        function ie(e) {
            o("virtualScroll", e);
        }
        function re() {
            return [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$2d10adb726183d68, {
                    class: "q-table__linear-progress",
                    color: e.color,
                    dark: l.value,
                    indeterminate: !0,
                    trackColor: "transparent"
                })
            ];
        }
        function se(n, a, i) {
            const r = s.value(n), u = A(r);
            if (void 0 !== a) return a(ce({
                key: r,
                row: n,
                pageIndex: i,
                __trClass: u ? "selected" : ""
            }));
            const c = t["body-cell"], d = R.value.map((e)=>{
                const o = t[`body-cell-${e.name}`], a = void 0 !== o ? o : c;
                return void 0 !== a ? a(de({
                    key: r,
                    row: n,
                    pageIndex: i,
                    col: e
                })) : (0, $TusQn.h)("td", {
                    class: e.__tdClass(n),
                    style: e.__tdStyle(n)
                }, me(e, n));
            });
            if (!0 === P.value) {
                const o = t["body-selection"], a = void 0 !== o ? o(pe({
                    key: r,
                    row: n,
                    pageIndex: i
                })) : [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3430661ad019cfb, {
                        modelValue: u,
                        color: e.color,
                        dark: l.value,
                        dense: e.dense,
                        "onUpdate:modelValue": (e, t)=>{
                            O([
                                r
                            ], [
                                n
                            ], e, t);
                        }
                    })
                ];
                d.unshift((0, $TusQn.h)("td", {
                    class: "q-table--col-auto-width"
                }, a));
            }
            const p = {
                key: r,
                class: {
                    selected: u
                }
            };
            return void 0 !== e.onRowClick && (p.class["cursor-pointer"] = !0, p.onClick = (e)=>{
                o("RowClick", e, n, i);
            }), void 0 !== e.onRowDblclick && (p.class["cursor-pointer"] = !0, p.onDblclick = (e)=>{
                o("RowDblclick", e, n, i);
            }), void 0 !== e.onRowContextmenu && (p.class["cursor-pointer"] = !0, p.onContextmenu = (e)=>{
                o("RowContextmenu", e, n, i);
            }), (0, $TusQn.h)("tr", p, d);
        }
        function ue() {
            const e = t.body, o = t["top-row"], n = t["bottom-row"];
            let a = T.value.map((t, o)=>se(t, e, o));
            return void 0 !== o && (a = o({
                cols: R.value
            }).concat(a)), void 0 !== n && (a = a.concat(n({
                cols: R.value
            }))), (0, $TusQn.h)("tbody", a);
        }
        function ce(e) {
            return ve(e), e.cols = e.cols.map((t)=>$ec2fc4c0d7a3c6c6$var$injectProp({
                    ...t
                }, "value", ()=>me(t, e.row))), e;
        }
        function de(e) {
            return ve(e), $ec2fc4c0d7a3c6c6$var$injectProp(e, "value", ()=>me(e.col, e.row)), e;
        }
        function pe(e) {
            return ve(e), e;
        }
        function ve(t) {
            Object.assign(t, {
                cols: R.value,
                colsMap: D.value,
                sort: H,
                rowIndex: N.value + t.pageIndex,
                color: e.color,
                dark: l.value,
                dense: e.dense
            }), !0 === P.value && $ec2fc4c0d7a3c6c6$var$injectProp(t, "selected", ()=>A(t.key), (e, o)=>{
                O([
                    t.key
                ], [
                    t.row
                ], e, o);
            }), $ec2fc4c0d7a3c6c6$var$injectProp(t, "expand", ()=>C(t.key), (e)=>{
                k(t.key, e);
            });
        }
        function me(e, t) {
            const o = "function" === typeof e.field ? e.field(t) : t[e.field];
            return void 0 !== e.format ? e.format(o, t) : o;
        }
        const fe = (0, $TusQn.computed)(()=>({
                pagination: g.value,
                pagesNumber: W.value,
                isFirstPage: U.value,
                isLastPage: K.value,
                firstPage: X,
                prevPage: Z,
                nextPage: J,
                lastPage: ee,
                inFullscreen: i.value,
                toggleFullscreen: r
            }));
        function he() {
            const o = t.top, n = t["top-left"], a = t["top-right"], l = t["top-selection"], i = !0 === P.value && void 0 !== l && Q.value > 0, r = "q-table__top relative-position row items-center";
            if (void 0 !== o) return (0, $TusQn.h)("div", {
                class: r
            }, [
                o(fe.value)
            ]);
            let s;
            return !0 === i ? s = l(fe.value).slice() : (s = [], void 0 !== n ? s.push((0, $TusQn.h)("div", {
                class: "q-table__control"
            }, [
                n(fe.value)
            ])) : e.title && s.push((0, $TusQn.h)("div", {
                class: "q-table__control"
            }, [
                (0, $TusQn.h)("div", {
                    class: [
                        "q-table__title",
                        e.titleClass
                    ]
                }, e.title)
            ]))), void 0 !== a && (s.push((0, $TusQn.h)("div", {
                class: "q-table__separator col"
            })), s.push((0, $TusQn.h)("div", {
                class: "q-table__control"
            }, [
                a(fe.value)
            ]))), 0 !== s.length ? (0, $TusQn.h)("div", {
                class: r
            }, s) : void 0;
        }
        const ge = (0, $TusQn.computed)(()=>!0 === E.value ? null : B.value);
        function be() {
            const o = ye();
            return !0 === e.loading && void 0 === t.loading && o.push((0, $TusQn.h)("tr", {
                class: "q-table__progress"
            }, [
                (0, $TusQn.h)("th", {
                    class: "relative-position",
                    colspan: z.value
                }, re())
            ])), (0, $TusQn.h)("thead", o);
        }
        function ye() {
            const o = t.header, n = t["header-cell"];
            if (void 0 !== o) return o(Se({
                header: !0
            })).slice();
            const a = R.value.map((e)=>{
                const o = t[`header-cell-${e.name}`], a = void 0 !== o ? o : n, l = Se({
                    col: e
                });
                return void 0 !== a ? a(l) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$f3b568562ea6363f, {
                    key: e.name,
                    props: l
                }, ()=>e.label);
            });
            if (!0 === $.value && !0 !== e.grid) a.unshift((0, $TusQn.h)("th", {
                class: "q-table--col-auto-width"
            }, " "));
            else if (!0 === M.value) {
                const o = t["header-selection"], n = void 0 !== o ? o(Se({})) : [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3430661ad019cfb, {
                        color: e.color,
                        modelValue: ge.value,
                        dark: l.value,
                        dense: e.dense,
                        "onUpdate:modelValue": we
                    })
                ];
                a.unshift((0, $TusQn.h)("th", {
                    class: "q-table--col-auto-width"
                }, n));
            }
            return [
                (0, $TusQn.h)("tr", {
                    class: e.tableHeaderClass,
                    style: e.tableHeaderStyle
                }, a)
            ];
        }
        function Se(t) {
            return Object.assign(t, {
                cols: R.value,
                sort: H,
                colsMap: D.value,
                color: e.color,
                dark: l.value,
                dense: e.dense
            }), !0 === M.value && $ec2fc4c0d7a3c6c6$var$injectProp(t, "selected", ()=>ge.value, we), t;
        }
        function we(e) {
            !0 === E.value && (e = !1), O(T.value.map(s.value), T.value, e);
        }
        const Ce = (0, $TusQn.computed)(()=>{
            const t = [
                e.iconFirstPage || a.iconSet.table.firstPage,
                e.iconPrevPage || a.iconSet.table.prevPage,
                e.iconNextPage || a.iconSet.table.nextPage,
                e.iconLastPage || a.iconSet.table.lastPage
            ];
            return !0 === a.lang.rtl ? t.reverse() : t;
        });
        function xe() {
            if (!0 === e.hideBottom) return;
            if (!0 === te.value) {
                if (!0 === e.hideNoData) return;
                const o = !0 === e.loading ? e.loadingLabel || a.lang.table.loading : e.filter ? e.noResultsLabel || a.lang.table.noResults : e.noDataLabel || a.lang.table.noData, n = t["no-data"], l = void 0 !== n ? [
                    n({
                        message: o,
                        icon: a.iconSet.table.warning,
                        filter: e.filter
                    })
                ] : [
                    (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        class: "q-table__bottom-nodata-icon",
                        name: a.iconSet.table.warning
                    }),
                    o
                ];
                return (0, $TusQn.h)("div", {
                    class: $ec2fc4c0d7a3c6c6$var$bottomClass + " q-table__bottom--nodata"
                }, l);
            }
            const o = t.bottom;
            if (void 0 !== o) return (0, $TusQn.h)("div", {
                class: $ec2fc4c0d7a3c6c6$var$bottomClass
            }, [
                o(fe.value)
            ]);
            const n = !0 !== e.hideSelectedBanner && !0 === P.value && Q.value > 0 ? [
                (0, $TusQn.h)("div", {
                    class: "q-table__control"
                }, [
                    (0, $TusQn.h)("div", [
                        (e.selectedRowsLabel || a.lang.table.selectedRecords)(Q.value)
                    ])
                ])
            ] : [];
            return !0 !== e.hidePagination ? (0, $TusQn.h)("div", {
                class: $ec2fc4c0d7a3c6c6$var$bottomClass + " justify-end"
            }, _e(n)) : 0 !== n.length ? (0, $TusQn.h)("div", {
                class: $ec2fc4c0d7a3c6c6$var$bottomClass
            }, n) : void 0;
        }
        function ke(e) {
            S({
                page: 1,
                rowsPerPage: e.value
            });
        }
        function _e(o) {
            let n;
            const { rowsPerPage: i } = g.value, r = e.paginationLabel || a.lang.table.pagination, s = t.pagination, u = e.rowsPerPageOptions.length > 1;
            if (o.push((0, $TusQn.h)("div", {
                class: "q-table__separator col"
            })), !0 === u && o.push((0, $TusQn.h)("div", {
                class: "q-table__control"
            }, [
                (0, $TusQn.h)("span", {
                    class: "q-table__bottom-item"
                }, [
                    e.rowsPerPageLabel || a.lang.table.recordsPerPage
                ]),
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$c6f171932ae1be1a, {
                    class: "q-table__select inline q-table__bottom-item",
                    color: e.color,
                    modelValue: i,
                    options: Y.value,
                    displayValue: 0 === i ? a.lang.table.allRows : i,
                    dark: l.value,
                    borderless: !0,
                    dense: !0,
                    optionsDense: !0,
                    optionsCover: !0,
                    "onUpdate:modelValue": ke
                })
            ])), void 0 !== s) n = s(fe.value);
            else if (n = [
                (0, $TusQn.h)("span", 0 !== i ? {
                    class: "q-table__bottom-item"
                } : {}, [
                    i ? r(N.value + 1, Math.min(j.value, G.value), G.value) : r(1, q.value, G.value)
                ])
            ], 0 !== i && W.value > 1) {
                const t = {
                    color: e.color,
                    round: !0,
                    dense: !0,
                    flat: !0
                };
                !0 === e.dense && (t.size = "sm"), W.value > 2 && n.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    key: "pgFirst",
                    ...t,
                    icon: Ce.value[0],
                    disable: U.value,
                    onClick: X
                })), n.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    key: "pgPrev",
                    ...t,
                    icon: Ce.value[1],
                    disable: U.value,
                    onClick: Z
                }), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    key: "pgNext",
                    ...t,
                    icon: Ce.value[2],
                    disable: K.value,
                    onClick: J
                })), W.value > 2 && n.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    key: "pgLast",
                    ...t,
                    icon: Ce.value[3],
                    disable: K.value,
                    onClick: ee
                }));
            }
            return o.push((0, $TusQn.h)("div", {
                class: "q-table__control"
            }, n)), o;
        }
        function qe() {
            const o = !0 === e.gridHeader ? [
                (0, $TusQn.h)("table", {
                    class: "q-table"
                }, [
                    be()
                ])
            ] : !0 === e.loading && void 0 === t.loading ? re() : void 0;
            return (0, $TusQn.h)("div", {
                class: "q-table__middle"
            }, o);
        }
        function Te() {
            const n = void 0 !== t.item ? t.item : (n)=>{
                const a = n.cols.map((e)=>(0, $TusQn.h)("div", {
                        class: "q-table__grid-item-row"
                    }, [
                        (0, $TusQn.h)("div", {
                            class: "q-table__grid-item-title"
                        }, [
                            e.label
                        ]),
                        (0, $TusQn.h)("div", {
                            class: "q-table__grid-item-value"
                        }, [
                            e.value
                        ])
                    ]));
                if (!0 === P.value) {
                    const o = t["body-selection"], i = void 0 !== o ? o(n) : [
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3430661ad019cfb, {
                            modelValue: n.selected,
                            color: e.color,
                            dark: l.value,
                            dense: e.dense,
                            "onUpdate:modelValue": (e, t)=>{
                                O([
                                    n.key
                                ], [
                                    n.row
                                ], e, t);
                            }
                        })
                    ];
                    a.unshift((0, $TusQn.h)("div", {
                        class: "q-table__grid-item-row"
                    }, i), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                        dark: l.value
                    }));
                }
                const i = {
                    class: [
                        "q-table__grid-item-card" + p.value,
                        e.cardClass
                    ],
                    style: e.cardStyle
                };
                return void 0 === e.onRowClick && void 0 === e.onRowDblclick || (i.class[0] += " cursor-pointer", void 0 !== e.onRowClick && (i.onClick = (e)=>{
                    o("RowClick", e, n.row, n.pageIndex);
                }), void 0 !== e.onRowDblclick && (i.onDblclick = (e)=>{
                    o("RowDblclick", e, n.row, n.pageIndex);
                })), (0, $TusQn.h)("div", {
                    class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (!0 === n.selected ? " q-table__grid-item--selected" : "")
                }, [
                    (0, $TusQn.h)("div", i, a)
                ]);
            };
            return (0, $TusQn.h)("div", {
                class: [
                    "q-table__grid-content row",
                    e.cardContainerClass
                ],
                style: e.cardContainerStyle
            }, T.value.map((e, t)=>{
                return n(ce({
                    key: s.value(e),
                    row: e,
                    pageIndex: t
                }));
            }));
        }
        return Object.assign(n.proxy, {
            requestServerInteraction: y,
            setPagination: S,
            firstPage: X,
            prevPage: Z,
            nextPage: J,
            lastPage: ee,
            isRowSelected: A,
            clearSelection: L,
            isRowExpanded: C,
            setExpanded: x,
            sort: H,
            resetVirtualScroll: ne,
            scrollTo: le,
            getCellValue: me
        }), $ec2fc4c0d7a3c6c6$var$injectMultipleProps(n.proxy, {
            filteredSortedRows: ()=>_.value,
            computedRows: ()=>T.value,
            computedRowsNumber: ()=>G.value
        }), ()=>{
            const o = [
                he()
            ], n = {
                ref: u,
                class: m.value
            };
            return !0 === e.grid ? o.push(qe()) : Object.assign(n, {
                class: [
                    n.class,
                    e.cardClass
                ],
                style: e.cardStyle
            }), o.push(ae(), xe()), !0 === e.loading && void 0 !== t.loading && o.push(t.loading()), (0, $TusQn.h)("div", n, o);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$eb796db58a736f8f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTr",
    props: {
        props: Object,
        noHover: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>"q-tr" + (void 0 === e.props || !0 === e.props.header ? "" : " " + e.props.__trClass) + (!0 === e.noHover ? " q-tr--no-hover" : ""));
        return ()=>(0, $TusQn.h)("tr", {
                class: o.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$f8a8c02d3a86d0c6 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTd",
    props: {
        props: Object,
        autoWidth: Boolean,
        noHover: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = (0, $TusQn.computed)(()=>"q-td" + (!0 === e.autoWidth ? " q-table--col-auto-width" : "") + (!0 === e.noHover ? " q-td--no-hover" : "") + " ");
        return ()=>{
            if (void 0 === e.props) return (0, $TusQn.h)("td", {
                class: n.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
            const a = o.vnode.key, l = (void 0 !== e.props.colsMap ? e.props.colsMap[a] : null) || e.props.col;
            if (void 0 === l) return;
            const { row: i } = e.props;
            return (0, $TusQn.h)("td", {
                class: n.value + l.__tdClass(i),
                style: l.__tdStyle(i)
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
        };
    }
}), $ec2fc4c0d7a3c6c6$export$fc20573fc4d541d2 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QRouteTab",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useRouterLinkProps,
        ...$ec2fc4c0d7a3c6c6$var$useTabProps
    },
    emits: $ec2fc4c0d7a3c6c6$var$useTabEmits,
    setup (e, { slots: t, emit: o }) {
        const n = $ec2fc4c0d7a3c6c6$var$useRouterLink({
            useDisableForRouterLinkProps: !1
        }), { renderTab: a, $tabs: l } = $ec2fc4c0d7a3c6c6$var$useTab(e, t, o, {
            exact: (0, $TusQn.computed)(()=>e.exact),
            ...n
        });
        return (0, $TusQn.watch)(()=>`${e.name} | ${e.exact} | ${(n.resolvedLink.value || {}).href}`, ()=>{
            l.verifyRouteModel();
        }), ()=>a(n.linkTag.value, n.linkAttrs.value);
    }
});
function $ec2fc4c0d7a3c6c6$var$getViewByModel(e, t) {
    if (null !== e.hour) {
        if (null === e.minute) return "minute";
        if (!0 === t && null === e.second) return "second";
    }
    return "hour";
}
function $ec2fc4c0d7a3c6c6$var$getCurrentTime() {
    const e = new Date;
    return {
        hour: e.getHours(),
        minute: e.getMinutes(),
        second: e.getSeconds(),
        millisecond: e.getMilliseconds()
    };
}
var $ec2fc4c0d7a3c6c6$export$75b50612c5275613 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTime",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        ...$ec2fc4c0d7a3c6c6$var$useFormProps,
        ...$ec2fc4c0d7a3c6c6$var$useDatetimeProps,
        mask: {
            default: null
        },
        format24h: {
            type: Boolean,
            default: null
        },
        defaultDate: {
            type: String,
            validator: (e)=>/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e)
        },
        options: Function,
        hourOptions: Array,
        minuteOptions: Array,
        secondOptions: Array,
        withSeconds: Boolean,
        nowBtn: Boolean
    },
    emits: $ec2fc4c0d7a3c6c6$var$useDatetimeEmits,
    setup (e, { slots: t, emit: o }) {
        const n = (0, $TusQn.getCurrentInstance)(), { $q: a } = n.proxy, l = $ec2fc4c0d7a3c6c6$var$useDark(e, a), { tabindex: i, headerClass: r, getLocale: s, getCurrentDate: u } = $ec2fc4c0d7a3c6c6$var$useDatetime(e, a), c = $ec2fc4c0d7a3c6c6$var$useFormAttrs(e), d = $ec2fc4c0d7a3c6c6$var$useFormInject(c);
        let p, v;
        const m = (0, $01W3b.ref)(null), f = (0, $TusQn.computed)(()=>V()), g = (0, $TusQn.computed)(()=>s()), b = (0, $TusQn.computed)(()=>H()), y = $ec2fc4c0d7a3c6c6$var$__splitDate(e.modelValue, f.value, g.value, e.calendar, b.value), S = (0, $01W3b.ref)($ec2fc4c0d7a3c6c6$var$getViewByModel(y)), w = (0, $01W3b.ref)(y), C = (0, $01W3b.ref)(null === y.hour || y.hour < 12), x = (0, $TusQn.computed)(()=>`q-time q-time--${!0 === e.landscape ? "landscape" : "portrait"}` + (!0 === l.value ? " q-time--dark q-dark" : "") + (!0 === e.disable ? " disabled" : !0 === e.readonly ? " q-time--readonly" : "") + (!0 === e.bordered ? " q-time--bordered" : "") + (!0 === e.square ? " q-time--square no-border-radius" : "") + (!0 === e.flat ? " q-time--flat no-shadow" : "")), k = (0, $TusQn.computed)(()=>{
            const e = w.value;
            return {
                hour: null === e.hour ? "--" : !0 === _.value ? $ec2fc4c0d7a3c6c6$var$pad(e.hour) : String(!0 === C.value ? 0 === e.hour ? 12 : e.hour : e.hour > 12 ? e.hour - 12 : e.hour),
                minute: null === e.minute ? "--" : $ec2fc4c0d7a3c6c6$var$pad(e.minute),
                second: null === e.second ? "--" : $ec2fc4c0d7a3c6c6$var$pad(e.second)
            };
        }), _ = (0, $TusQn.computed)(()=>null !== e.format24h ? e.format24h : a.lang.date.format24h), q = (0, $TusQn.computed)(()=>{
            const e = "hour" === S.value, t = !0 === e ? 12 : 60, o = w.value[S.value], n = Math.round(o * (360 / t)) - 180;
            let a = `rotate(${n}deg) translateX(-50%)`;
            return !0 === e && !0 === _.value && w.value.hour >= 12 && (a += " scale(.7)"), {
                transform: a
            };
        }), T = (0, $TusQn.computed)(()=>null !== w.value.hour), P = (0, $TusQn.computed)(()=>!0 === T.value && null !== w.value.minute), $ = (0, $TusQn.computed)(()=>void 0 !== e.hourOptions ? (t)=>e.hourOptions.includes(t) : void 0 !== e.options ? (t)=>e.options(t, null, null) : null), M = (0, $TusQn.computed)(()=>void 0 !== e.minuteOptions ? (t)=>e.minuteOptions.includes(t) : void 0 !== e.options ? (t)=>e.options(w.value.hour, t, null) : null), B = (0, $TusQn.computed)(()=>void 0 !== e.secondOptions ? (t)=>e.secondOptions.includes(t) : void 0 !== e.options ? (t)=>e.options(w.value.hour, w.value.minute, t) : null), E = (0, $TusQn.computed)(()=>{
            if (null === $.value) return null;
            const e = D(0, 11, $.value), t = D(12, 11, $.value);
            return {
                am: e,
                pm: t,
                values: e.values.concat(t.values)
            };
        }), Q = (0, $TusQn.computed)(()=>null !== M.value ? D(0, 59, M.value) : null), A = (0, $TusQn.computed)(()=>null !== B.value ? D(0, 59, B.value) : null), L = (0, $TusQn.computed)(()=>{
            switch(S.value){
                case "hour":
                    return E.value;
                case "minute":
                    return Q.value;
                case "second":
                    return A.value;
            }
        }), O = (0, $TusQn.computed)(()=>{
            let e, t, o = 0, n = 1;
            const a = null !== L.value ? L.value.values : void 0;
            "hour" === S.value ? !0 === _.value ? (e = 0, t = 23) : (e = 0, t = 11, !1 === C.value && (o = 12)) : (e = 0, t = 55, n = 5);
            const l = [];
            for(let i = e, r = e; i <= t; i += n, r++){
                const e = i + o, t = void 0 !== a && !1 === a.includes(e), n = "hour" === S.value && 0 === i ? !0 === _.value ? "00" : "12" : i;
                l.push({
                    val: e,
                    index: r,
                    disable: t,
                    label: n
                });
            }
            return l;
        }), F = (0, $TusQn.computed)(()=>{
            return [
                [
                    $ec2fc4c0d7a3c6c6$export$718797250d1e376,
                    U,
                    void 0,
                    {
                        stop: !0,
                        prevent: !0,
                        mouse: !0
                    }
                ]
            ];
        });
        function R() {
            const e = {
                ...u(),
                ...$ec2fc4c0d7a3c6c6$var$getCurrentTime()
            };
            ce(e), Object.assign(w.value, e), S.value = "hour";
        }
        function D(e, t, o) {
            const n = Array.apply(null, {
                length: t + 1
            }).map((t, n)=>{
                const a = n + e;
                return {
                    index: a,
                    val: !0 === o(a)
                };
            }).filter((e)=>!0 === e.val).map((e)=>e.index);
            return {
                min: n[0],
                max: n[n.length - 1],
                values: n,
                threshold: t + 1
            };
        }
        function z(e, t, o) {
            const n = Math.abs(e - t);
            return Math.min(n, o - n);
        }
        function I(e, { min: t, max: o, values: n, threshold: a }) {
            if (e === t) return t;
            if (e < t || e > o) return z(e, t, a) <= z(e, o, a) ? t : o;
            const l = n.findIndex((t)=>e <= t), i = n[l - 1], r = n[l];
            return e - i <= r - e ? i : r;
        }
        function V() {
            return "persian" !== e.calendar && null !== e.mask ? e.mask : `HH:mm${!0 === e.withSeconds ? ":ss" : ""}`;
        }
        function H() {
            if ("string" !== typeof e.defaultDate) {
                const e = u(!0);
                return e.dateHash = $ec2fc4c0d7a3c6c6$var$getDayHash(e), e;
            }
            return $ec2fc4c0d7a3c6c6$var$__splitDate(e.defaultDate, "YYYY/MM/DD", void 0, e.calendar);
        }
        function N() {
            return !0 === $ec2fc4c0d7a3c6c6$var$vmIsDestroyed(n) || null !== L.value && (0 === L.value.values.length || "hour" === S.value && !0 !== _.value && 0 === E.value[!0 === C.value ? "am" : "pm"].values.length);
        }
        function j() {
            const e = m.value, { top: t, left: o, width: n } = e.getBoundingClientRect(), a = n / 2;
            return {
                top: t + a,
                left: o + a,
                dist: .7 * a
            };
        }
        function U(e) {
            if (!0 !== N()) {
                if (!0 === e.isFirst) return p = j(), void (v = W(e.evt, p));
                v = W(e.evt, p, v), !0 === e.isFinal && (p = !1, v = null, K());
            }
        }
        function K() {
            "hour" === S.value ? S.value = "minute" : e.withSeconds && "minute" === S.value && (S.value = "second");
        }
        function W(e, t, o) {
            const n = $ec2fc4c0d7a3c6c6$var$position(e), a = Math.abs(n.top - t.top), l = Math.sqrt(Math.pow(Math.abs(n.top - t.top), 2) + Math.pow(Math.abs(n.left - t.left), 2));
            let i, r = Math.asin(a / l) * (180 / Math.PI);
            if (r = n.top < t.top ? t.left < n.left ? 90 - r : 270 + r : t.left < n.left ? r + 90 : 270 - r, "hour" === S.value) {
                if (i = r / 30, null !== E.value) {
                    const e = !0 !== _.value ? !0 === C.value : 0 !== E.value.am.values.length && 0 !== E.value.pm.values.length ? l >= t.dist : 0 !== E.value.am.values.length;
                    i = I(i + (!0 === e ? 0 : 12), E.value[!0 === e ? "am" : "pm"]);
                } else i = Math.round(i), !0 === _.value ? l < t.dist ? i < 12 && (i += 12) : 12 === i && (i = 0) : !0 === C.value && 12 === i ? i = 0 : !1 === C.value && 12 !== i && (i += 12);
                !0 === _.value && (C.value = i < 12);
            } else i = Math.round(r / 6) % 60, "minute" === S.value && null !== Q.value ? i = I(i, Q.value) : "second" === S.value && null !== A.value && (i = I(i, A.value));
            return o !== i && ie[S.value](i), i;
        }
        (0, $TusQn.watch)(()=>e.modelValue, (t)=>{
            const o = $ec2fc4c0d7a3c6c6$var$__splitDate(t, f.value, g.value, e.calendar, b.value);
            o.dateHash === w.value.dateHash && o.timeHash === w.value.timeHash || (w.value = o, null === o.hour ? S.value = "hour" : C.value = o.hour < 12);
        }), (0, $TusQn.watch)([
            f,
            g
        ], ()=>{
            (0, $TusQn.nextTick)(()=>{
                ce();
            });
        });
        const Y = {
            hour () {
                S.value = "hour";
            },
            minute () {
                S.value = "minute";
            },
            second () {
                S.value = "second";
            }
        };
        function G(e) {
            13 === e.keyCode && re();
        }
        function X(e) {
            13 === e.keyCode && se();
        }
        function Z(e) {
            !0 !== N() && (!0 !== a.platform.is.desktop && W(e, j()), K());
        }
        function J(e) {
            !0 !== N() && W(e, j());
        }
        function ee(e) {
            if (13 === e.keyCode) S.value = "hour";
            else if ([
                37,
                39
            ].includes(e.keyCode)) {
                const t = 37 === e.keyCode ? -1 : 1;
                if (null !== E.value) {
                    const e = !0 === _.value ? E.value.values : E.value[!0 === C.value ? "am" : "pm"].values;
                    if (0 === e.length) return;
                    if (null === w.value.hour) ne(e[0]);
                    else {
                        const o = (e.length + e.indexOf(w.value.hour) + t) % e.length;
                        ne(e[o]);
                    }
                } else {
                    const e = !0 === _.value ? 24 : 12, o = !0 !== _.value && !1 === C.value ? 12 : 0, n = null === w.value.hour ? -t : w.value.hour;
                    ne(o + (24 + n + t) % e);
                }
            }
        }
        function te(e) {
            if (13 === e.keyCode) S.value = "minute";
            else if ([
                37,
                39
            ].includes(e.keyCode)) {
                const t = 37 === e.keyCode ? -1 : 1;
                if (null !== Q.value) {
                    const e = Q.value.values;
                    if (0 === e.length) return;
                    if (null === w.value.minute) ae(e[0]);
                    else {
                        const o = (e.length + e.indexOf(w.value.minute) + t) % e.length;
                        ae(e[o]);
                    }
                } else {
                    const e = null === w.value.minute ? -t : w.value.minute;
                    ae((60 + e + t) % 60);
                }
            }
        }
        function oe(e) {
            if (13 === e.keyCode) S.value = "second";
            else if ([
                37,
                39
            ].includes(e.keyCode)) {
                const t = 37 === e.keyCode ? -1 : 1;
                if (null !== A.value) {
                    const e = A.value.values;
                    if (0 === e.length) return;
                    if (null === w.value.seconds) le(e[0]);
                    else {
                        const o = (e.length + e.indexOf(w.value.second) + t) % e.length;
                        le(e[o]);
                    }
                } else {
                    const e = null === w.value.second ? -t : w.value.second;
                    le((60 + e + t) % 60);
                }
            }
        }
        function ne(e) {
            w.value.hour !== e && (w.value.hour = e, ue());
        }
        function ae(e) {
            w.value.minute !== e && (w.value.minute = e, ue());
        }
        function le(e) {
            w.value.second !== e && (w.value.second = e, ue());
        }
        const ie = {
            hour: ne,
            minute: ae,
            second: le
        };
        function re() {
            !1 === C.value && (C.value = !0, null !== w.value.hour && (w.value.hour -= 12, ue()));
        }
        function se() {
            !0 === C.value && (C.value = !1, null !== w.value.hour && (w.value.hour += 12, ue()));
        }
        function ue() {
            return null !== $.value && !0 !== $.value(w.value.hour) ? (w.value = $ec2fc4c0d7a3c6c6$var$__splitDate(), void (S.value = "hour")) : null !== M.value && !0 !== M.value(w.value.minute) ? (w.value.minute = null, w.value.second = null, void (S.value = "minute")) : !0 === e.withSeconds && null !== B.value && !0 !== B.value(w.value.second) ? (w.value.second = null, void (S.value = "second")) : void (null === w.value.hour || null === w.value.minute || !0 === e.withSeconds && null === w.value.second || ce());
        }
        function ce(t) {
            const n = Object.assign({
                ...w.value
            }, t), a = "persian" === e.calendar ? $ec2fc4c0d7a3c6c6$var$pad(n.hour) + ":" + $ec2fc4c0d7a3c6c6$var$pad(n.minute) + (!0 === e.withSeconds ? ":" + $ec2fc4c0d7a3c6c6$var$pad(n.second) : "") : $ec2fc4c0d7a3c6c6$var$formatDate(new Date(n.year, null === n.month ? null : n.month - 1, n.day, n.hour, n.minute, n.second, n.millisecond), f.value, g.value, n.year, n.timezoneOffset);
            n.changed = a !== e.modelValue, o("update:modelValue", a, n);
        }
        function de() {
            const t = [
                (0, $TusQn.h)("div", {
                    class: "q-time__link " + ("hour" === S.value ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: i.value,
                    onClick: Y.hour,
                    onKeyup: ee
                }, k.value.hour),
                (0, $TusQn.h)("div", ":"),
                (0, $TusQn.h)("div", !0 === T.value ? {
                    class: "q-time__link " + ("minute" === S.value ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: i.value,
                    onKeyup: te,
                    onClick: Y.minute
                } : {
                    class: "q-time__link"
                }, k.value.minute)
            ];
            !0 === e.withSeconds && t.push((0, $TusQn.h)("div", ":"), (0, $TusQn.h)("div", !0 === P.value ? {
                class: "q-time__link " + ("second" === S.value ? "q-time__link--active" : "cursor-pointer"),
                tabindex: i.value,
                onKeyup: oe,
                onClick: Y.second
            } : {
                class: "q-time__link"
            }, k.value.second));
            const o = [
                (0, $TusQn.h)("div", {
                    class: "q-time__header-label row items-center no-wrap",
                    dir: "ltr"
                }, t)
            ];
            return !1 === _.value && o.push((0, $TusQn.h)("div", {
                class: "q-time__header-ampm column items-between no-wrap"
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-time__link " + (!0 === C.value ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: i.value,
                    onClick: re,
                    onKeyup: G
                }, "AM"),
                (0, $TusQn.h)("div", {
                    class: "q-time__link " + (!0 !== C.value ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: i.value,
                    onClick: se,
                    onKeyup: X
                }, "PM")
            ])), (0, $TusQn.h)("div", {
                class: "q-time__header flex flex-center no-wrap " + r.value
            }, o);
        }
        function pe() {
            const t = w.value[S.value];
            return (0, $TusQn.h)("div", {
                class: "q-time__content col relative-position"
            }, [
                (0, $TusQn.h)((0, $eeJ70.Transition), {
                    name: "q-transition--scale"
                }, ()=>(0, $TusQn.h)("div", {
                        key: "clock" + S.value,
                        class: "q-time__container-parent absolute-full"
                    }, [
                        (0, $TusQn.h)("div", {
                            ref: m,
                            class: "q-time__container-child fit overflow-hidden"
                        }, [
                            (0, $TusQn.withDirectives)((0, $TusQn.h)("div", {
                                class: "q-time__clock cursor-pointer non-selectable",
                                onClick: Z,
                                onMousedown: J
                            }, [
                                (0, $TusQn.h)("div", {
                                    class: "q-time__clock-circle fit"
                                }, [
                                    (0, $TusQn.h)("div", {
                                        class: "q-time__clock-pointer" + (null === w.value[S.value] ? " hidden" : void 0 !== e.color ? ` text-${e.color}` : ""),
                                        style: q.value
                                    }),
                                    O.value.map((e)=>(0, $TusQn.h)("div", {
                                            class: `q-time__clock-position row flex-center q-time__clock-pos-${e.index}` + (e.val === t ? " q-time__clock-position--active " + r.value : !0 === e.disable ? " q-time__clock-position--disable" : "")
                                        }, [
                                            (0, $TusQn.h)("span", e.label)
                                        ]))
                                ])
                            ]), F.value)
                        ])
                    ])),
                !0 === e.nowBtn ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                    class: "q-time__now-button absolute",
                    icon: a.iconSet.datetime.now,
                    unelevated: !0,
                    size: "sm",
                    round: !0,
                    color: e.color,
                    textColor: e.textColor,
                    tabindex: i.value,
                    onClick: R
                }) : null
            ]);
        }
        return n.proxy.setNow = R, ()=>{
            const o = [
                pe()
            ], n = $ec2fc4c0d7a3c6c6$var$hSlot(t.default);
            return void 0 !== n && o.push((0, $TusQn.h)("div", {
                class: "q-time__actions"
            }, n)), void 0 !== e.name && !0 !== e.disable && d(o, "push"), (0, $TusQn.h)("div", {
                class: x.value,
                tabindex: -1
            }, [
                de(),
                (0, $TusQn.h)("div", {
                    class: "q-time__main col overflow-auto"
                }, o)
            ]);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$aaf1acdf549e0e8f = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTimeline",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        color: {
            type: String,
            default: "primary"
        },
        side: {
            type: String,
            default: "right",
            validator: (e)=>[
                    "left",
                    "right"
                ].includes(e)
        },
        layout: {
            type: String,
            default: "dense",
            validator: (e)=>[
                    "dense",
                    "comfortable",
                    "loose"
                ].includes(e)
        }
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.proxy.$q);
        (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$timelineKey, e);
        const a = (0, $TusQn.computed)(()=>`q-timeline q-timeline--${e.layout} q-timeline--${e.layout}--${e.side}` + (!0 === n.value ? " q-timeline--dark" : ""));
        return ()=>(0, $TusQn.h)("ul", {
                class: a.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$d0a3fbd020401544 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTimelineEntry",
    props: {
        heading: Boolean,
        tag: {
            type: String,
            default: "h3"
        },
        side: {
            type: String,
            default: "right",
            validator: (e)=>[
                    "left",
                    "right"
                ].includes(e)
        },
        icon: String,
        avatar: String,
        color: String,
        title: String,
        subtitle: String,
        body: String
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$timelineKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        if (o === $ec2fc4c0d7a3c6c6$var$emptyRenderFn) return console.error("QTimelineEntry needs to be child of QTimeline"), $ec2fc4c0d7a3c6c6$var$emptyRenderFn;
        const n = (0, $TusQn.computed)(()=>`q-timeline__entry q-timeline__entry--${e.side}` + (void 0 !== e.icon || void 0 !== e.avatar ? " q-timeline__entry--icon" : "")), a = (0, $TusQn.computed)(()=>`q-timeline__dot text-${e.color || o.color}`), l = (0, $TusQn.computed)(()=>"comfortable" === o.layout && "left" === o.side);
        return ()=>{
            const o = $ec2fc4c0d7a3c6c6$var$hUniqueSlot(t.default, []);
            if (void 0 !== e.body && o.unshift(e.body), !0 === e.heading) {
                const t = [
                    (0, $TusQn.h)("div"),
                    (0, $TusQn.h)("div"),
                    (0, $TusQn.h)(e.tag, {
                        class: "q-timeline__heading-title"
                    }, o)
                ];
                return (0, $TusQn.h)("div", {
                    class: "q-timeline__heading"
                }, !0 === l.value ? t.reverse() : t);
            }
            let i;
            void 0 !== e.icon ? i = [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                    class: "row items-center justify-center",
                    name: e.icon
                })
            ] : void 0 !== e.avatar && (i = [
                (0, $TusQn.h)("img", {
                    class: "q-timeline__dot-img",
                    src: e.avatar
                })
            ]);
            const r = [
                (0, $TusQn.h)("div", {
                    class: "q-timeline__subtitle"
                }, [
                    (0, $TusQn.h)("span", {}, $ec2fc4c0d7a3c6c6$var$hSlot(t.subtitle, [
                        e.subtitle
                    ]))
                ]),
                (0, $TusQn.h)("div", {
                    class: a.value
                }, i),
                (0, $TusQn.h)("div", {
                    class: "q-timeline__content"
                }, [
                    (0, $TusQn.h)("h6", {
                        class: "q-timeline__title"
                    }, $ec2fc4c0d7a3c6c6$var$hSlot(t.title, [
                        e.title
                    ]))
                ].concat(o))
            ];
            return (0, $TusQn.h)("li", {
                class: n.value
            }, !0 === l.value ? r.reverse() : r);
        };
    }
}), $ec2fc4c0d7a3c6c6$export$9cfe29ba9f08864a = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QToolbar",
    props: {
        inset: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>"q-toolbar row no-wrap items-center" + (!0 === e.inset ? " q-toolbar--inset" : ""));
        return ()=>(0, $TusQn.h)("div", {
                class: o.value,
                role: "toolbar"
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
}), $ec2fc4c0d7a3c6c6$export$dbcf6fec4996856c = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QToolbarTitle",
    props: {
        shrink: Boolean
    },
    setup (e, { slots: t }) {
        const o = (0, $TusQn.computed)(()=>"q-toolbar__title ellipsis" + (!0 === e.shrink ? " col-shrink" : ""));
        return ()=>(0, $TusQn.h)("div", {
                class: o.value
            }, $ec2fc4c0d7a3c6c6$var$hSlot(t.default));
    }
});
const $ec2fc4c0d7a3c6c6$var$tickStrategyOptions = [
    "none",
    "strict",
    "leaf",
    "leaf-filtered"
];
var $ec2fc4c0d7a3c6c6$export$6ac73dd07dbdca3b = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QTree",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        nodes: {
            type: Array,
            required: !0
        },
        nodeKey: {
            type: String,
            required: !0
        },
        labelKey: {
            type: String,
            default: "label"
        },
        childrenKey: {
            type: String,
            default: "children"
        },
        dense: Boolean,
        color: String,
        controlColor: String,
        textColor: String,
        selectedColor: String,
        icon: String,
        tickStrategy: {
            type: String,
            default: "none",
            validator: (e)=>$ec2fc4c0d7a3c6c6$var$tickStrategyOptions.includes(e)
        },
        ticked: Array,
        expanded: Array,
        selected: {},
        noSelectionUnset: Boolean,
        defaultExpandAll: Boolean,
        accordion: Boolean,
        filter: String,
        filterMethod: Function,
        duration: Number,
        noConnectors: Boolean,
        noTransition: Boolean,
        noNodesLabel: String,
        noResultsLabel: String
    },
    emits: [
        "update:expanded",
        "update:ticked",
        "update:selected",
        "lazyLoad",
        "afterShow",
        "afterHide"
    ],
    setup (e, { slots: t, emit: o }) {
        const { proxy: n } = (0, $TusQn.getCurrentInstance)(), { $q: a } = n, l = $ec2fc4c0d7a3c6c6$var$useDark(e, a), i = (0, $01W3b.ref)({}), r = (0, $01W3b.ref)(e.ticked || []), s = (0, $01W3b.ref)(e.expanded || []);
        let u = {};
        (0, $TusQn.onBeforeUpdate)(()=>{
            u = {};
        });
        const c = (0, $TusQn.computed)(()=>`q-tree q-tree--${!0 === e.dense ? "dense" : "standard"}` + (!0 === e.noConnectors ? " q-tree--no-connectors" : "") + (!0 === l.value ? " q-tree--dark" : "") + (void 0 !== e.color ? ` text-${e.color}` : "")), d = (0, $TusQn.computed)(()=>void 0 !== e.selected), p = (0, $TusQn.computed)(()=>e.icon || a.iconSet.tree.icon), v = (0, $TusQn.computed)(()=>e.controlColor || e.color), m = (0, $TusQn.computed)(()=>void 0 !== e.textColor ? ` text-${e.textColor}` : ""), f = (0, $TusQn.computed)(()=>{
            const t = e.selectedColor || e.color;
            return t ? ` text-${t}` : "";
        }), g = (0, $TusQn.computed)(()=>void 0 !== e.filterMethod ? e.filterMethod : (t, o)=>{
                const n = o.toLowerCase();
                return t[e.labelKey] && t[e.labelKey].toLowerCase().indexOf(n) > -1;
            }), b = (0, $TusQn.computed)(()=>{
            const t = {}, o = (n, a)=>{
                const l = n.tickStrategy || (a ? a.tickStrategy : e.tickStrategy), u = n[e.nodeKey], c = n[e.childrenKey] && Array.isArray(n[e.childrenKey]) && 0 !== n[e.childrenKey].length, p = !0 !== n.disabled && !0 === d.value && !1 !== n.selectable, v = !0 !== n.disabled && !1 !== n.expandable, m = "none" !== l, f = "strict" === l, h = "leaf-filtered" === l, b = "leaf" === l || "leaf-filtered" === l;
                let y = !0 !== n.disabled && !1 !== n.tickable;
                !0 === b && !0 === y && a && !0 !== a.tickable && (y = !1);
                let S = n.lazy;
                !0 === S && void 0 !== i.value[u] && !0 === Array.isArray(n[e.childrenKey]) && (S = i.value[u]);
                const w = {
                    key: u,
                    parent: a,
                    isParent: c,
                    lazy: S,
                    disabled: n.disabled,
                    link: !0 !== n.disabled && (!0 === p || !0 === v && (!0 === c || !0 === S)),
                    children: [],
                    matchesFilter: !e.filter || g.value(n, e.filter),
                    selected: u === e.selected && !0 === p,
                    selectable: p,
                    expanded: !0 === c && s.value.includes(u),
                    expandable: v,
                    noTick: !0 === n.noTick || !0 !== f && S && "loaded" !== S,
                    tickable: y,
                    tickStrategy: l,
                    hasTicking: m,
                    strictTicking: f,
                    leafFilteredTicking: h,
                    leafTicking: b,
                    ticked: !0 === f ? r.value.includes(u) : !0 !== c && r.value.includes(u)
                };
                if (t[u] = w, !0 === c && (w.children = n[e.childrenKey].map((e)=>o(e, w)), e.filter && (!0 !== w.matchesFilter ? w.matchesFilter = w.children.some((e)=>e.matchesFilter) : !0 !== w.noTick && !0 !== w.disabled && !0 === w.tickable && !0 === h && !0 === w.children.every((e)=>!0 !== e.matchesFilter || !0 === e.noTick || !0 !== e.tickable) && (w.tickable = !1)), !0 === w.matchesFilter && (!0 !== w.noTick && !0 !== f && !0 === w.children.every((e)=>e.noTick) && (w.noTick = !0), b))) {
                    if (w.ticked = !1, w.indeterminate = w.children.some((e)=>!0 === e.indeterminate), w.tickable = !0 === w.tickable && w.children.some((e)=>e.tickable), !0 !== w.indeterminate) {
                        const e = w.children.reduce((e, t)=>!0 === t.ticked ? e + 1 : e, 0);
                        e === w.children.length ? w.ticked = !0 : e > 0 && (w.indeterminate = !0);
                    }
                    !0 === w.indeterminate && (w.indeterminateNextState = w.children.every((e)=>!0 !== e.tickable || !0 !== e.ticked));
                }
                return w;
            };
            return e.nodes.forEach((e)=>o(e, null)), t;
        });
        function y(t) {
            const o = [].reduce, n = (a, l)=>{
                return a || !l ? a : !0 === Array.isArray(l) ? o.call(Object(l), n, a) : l[e.nodeKey] === t ? l : l[e.childrenKey] ? n(null, l[e.childrenKey]) : void 0;
            };
            return n(null, e.nodes);
        }
        function S() {
            return r.value.map((e)=>y(e));
        }
        function w() {
            return s.value.map((e)=>y(e));
        }
        function C(e) {
            return !(!e || !b.value[e]) && b.value[e].expanded;
        }
        function x() {
            void 0 !== e.expanded ? o("update:expanded", []) : s.value = [];
        }
        function k() {
            const t = [], n = (o)=>{
                o[e.childrenKey] && 0 !== o[e.childrenKey].length && !1 !== o.expandable && !0 !== o.disabled && (t.push(o[e.nodeKey]), o[e.childrenKey].forEach(n));
            };
            e.nodes.forEach(n), void 0 !== e.expanded ? o("update:expanded", t) : s.value = t;
        }
        function _(t, n, a = y(t), l = b.value[t]) {
            if (l.lazy && "loaded" !== l.lazy) {
                if ("loading" === l.lazy) return;
                i.value[t] = "loading", !0 !== Array.isArray(a[e.childrenKey]) && (a[e.childrenKey] = []), o("lazyLoad", {
                    node: a,
                    key: t,
                    done: (o)=>{
                        i.value[t] = "loaded", a[e.childrenKey] = !0 === Array.isArray(o) ? o : [], (0, $TusQn.nextTick)(()=>{
                            const e = b.value[t];
                            e && !0 === e.isParent && q(t, !0);
                        });
                    },
                    fail: ()=>{
                        delete i.value[t], 0 === a[e.childrenKey].length && delete a[e.childrenKey];
                    }
                });
            } else !0 === l.isParent && !0 === l.expandable && q(t, n);
        }
        function q(t, n) {
            let a = s.value;
            const l = void 0 !== e.expanded;
            if (!0 === l && (a = a.slice()), n) {
                if (e.accordion && b.value[t]) {
                    const o = [];
                    b.value[t].parent ? b.value[t].parent.children.forEach((e)=>{
                        e.key !== t && !0 === e.expandable && o.push(e.key);
                    }) : e.nodes.forEach((n)=>{
                        const a = n[e.nodeKey];
                        a !== t && o.push(a);
                    }), 0 !== o.length && (a = a.filter((e)=>!1 === o.includes(e)));
                }
                a = a.concat([
                    t
                ]).filter((e, t, o)=>o.indexOf(e) === t);
            } else a = a.filter((e)=>e !== t);
            !0 === l ? o("update:expanded", a) : s.value = a;
        }
        function T(e) {
            return !(!e || !b.value[e]) && b.value[e].ticked;
        }
        function P(t, n) {
            let a = r.value;
            const l = void 0 !== e.ticked;
            !0 === l && (a = a.slice()), a = n ? a.concat(t).filter((e, t, o)=>o.indexOf(e) === t) : a.filter((e)=>!1 === t.includes(e)), !0 === l && o("update:ticked", a);
        }
        function $(t, o, a) {
            const i = {
                tree: n,
                node: t,
                key: a,
                color: e.color,
                dark: l.value
            };
            return $ec2fc4c0d7a3c6c6$var$injectProp(i, "expanded", ()=>{
                return o.expanded;
            }, (e)=>{
                e !== o.expanded && _(a, e);
            }), $ec2fc4c0d7a3c6c6$var$injectProp(i, "ticked", ()=>{
                return o.ticked;
            }, (e)=>{
                e !== o.ticked && P([
                    a
                ], e);
            }), i;
        }
        function M(t) {
            return (e.filter ? t.filter((t)=>b.value[t[e.nodeKey]].matchesFilter) : t).map((e)=>A(e));
        }
        function B(e) {
            if (void 0 !== e.icon) return (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                class: "q-tree__icon q-mr-sm",
                name: e.icon,
                color: e.iconColor
            });
            const t = e.img || e.avatar;
            return t ? (0, $TusQn.h)("img", {
                class: `q-tree__${e.img ? "img" : "avatar"} q-mr-sm`,
                src: t
            }) : void 0;
        }
        function E() {
            o("afterShow");
        }
        function Q() {
            o("afterHide");
        }
        function A(o) {
            const n = o[e.nodeKey], a = b.value[n], i = o.header && t[`header-${o.header}`] || t["default-header"], r = !0 === a.isParent ? M(o[e.childrenKey]) : [], s = 0 !== r.length || a.lazy && "loaded" !== a.lazy;
            let c = o.body && t[`body-${o.body}`] || t["default-body"];
            const d = void 0 !== i || void 0 !== c ? $(o, a, n) : null;
            return void 0 !== c && (c = (0, $TusQn.h)("div", {
                class: "q-tree__node-body relative-position"
            }, [
                (0, $TusQn.h)("div", {
                    class: m.value
                }, [
                    c(d)
                ])
            ])), (0, $TusQn.h)("div", {
                key: n,
                class: "q-tree__node relative-position" + ` q-tree__node--${!0 === s ? "parent" : "child"}`
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-tree__node-header relative-position row no-wrap items-center" + (!0 === a.link ? " q-tree__node--link q-hoverable q-focusable" : "") + (!0 === a.selected ? " q-tree__node--selected" : "") + (!0 === a.disabled ? " q-tree__node--disabled" : ""),
                    tabindex: !0 === a.link ? 0 : -1,
                    onClick: (e)=>{
                        O(o, a, e);
                    },
                    onKeypress (e) {
                        !0 !== $ec2fc4c0d7a3c6c6$var$shouldIgnoreKey(e) && (13 === e.keyCode ? O(o, a, e, !0) : 32 === e.keyCode && F(o, a, e, !0));
                    }
                }, [
                    (0, $TusQn.h)("div", {
                        class: "q-focus-helper",
                        tabindex: -1,
                        ref: (e)=>{
                            u[a.key] = e;
                        }
                    }),
                    "loading" === a.lazy ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0, {
                        class: "q-tree__spinner",
                        color: v.value
                    }) : !0 === s ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        class: "q-tree__arrow" + (!0 === a.expanded ? " q-tree__arrow--rotate" : ""),
                        name: p.value,
                        onClick (e) {
                            F(o, a, e);
                        }
                    }) : null,
                    !0 === a.hasTicking && !0 !== a.noTick ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3430661ad019cfb, {
                        class: "q-tree__tickbox",
                        modelValue: !0 === a.indeterminate ? null : a.ticked,
                        color: v.value,
                        dark: l.value,
                        dense: !0,
                        keepColor: !0,
                        disable: !0 !== a.tickable,
                        onKeydown: $ec2fc4c0d7a3c6c6$var$stopAndPrevent,
                        "onUpdate:modelValue": (e)=>{
                            R(a, e);
                        }
                    }) : null,
                    (0, $TusQn.h)("div", {
                        class: "q-tree__node-header-content col row no-wrap items-center" + (!0 === a.selected ? f.value : m.value)
                    }, [
                        i ? i(d) : [
                            B(o),
                            (0, $TusQn.h)("div", o[e.labelKey])
                        ]
                    ])
                ]),
                !0 === s ? !0 === e.noTransition ? (0, $TusQn.h)("div", {
                    class: "q-tree__node-collapsible" + m.value,
                    key: `${n}__q`
                }, [
                    c,
                    (0, $TusQn.h)("div", {
                        class: "q-tree__children" + (!0 === a.disabled ? " q-tree__node--disabled" : "")
                    }, a.expanded ? r : null)
                ]) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$1712cdc175d4649d, {
                    duration: e.duration,
                    onShow: E,
                    onHide: Q
                }, ()=>(0, $TusQn.withDirectives)((0, $TusQn.h)("div", {
                        class: "q-tree__node-collapsible" + m.value,
                        key: `${n}__q`
                    }, [
                        c,
                        (0, $TusQn.h)("div", {
                            class: "q-tree__children" + (!0 === a.disabled ? " q-tree__node--disabled" : "")
                        }, r)
                    ]), [
                        [
                            (0, $eeJ70.vShow),
                            a.expanded
                        ]
                    ])) : c
            ]);
        }
        function L(e) {
            const t = u[e];
            t && t.focus();
        }
        function O(t, n, a, l) {
            !0 !== l && !1 !== n.selectable && L(n.key), d.value && n.selectable ? !1 === e.noSelectionUnset ? o("update:selected", n.key !== e.selected ? n.key : null) : n.key !== e.selected && o("update:selected", void 0 === n.key ? null : n.key) : F(t, n, a, l), "function" === typeof t.handler && t.handler(t);
        }
        function F(e, t, o, n) {
            void 0 !== o && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(o), !0 !== n && !1 !== t.selectable && L(t.key), _(t.key, !t.expanded, e, t);
        }
        function R(e, t) {
            if (!0 === e.indeterminate && (t = e.indeterminateNextState), e.strictTicking) P([
                e.key
            ], t);
            else if (e.leafTicking) {
                const o = [], n = (e)=>{
                    e.isParent ? (!0 !== t && !0 !== e.noTick && !0 === e.tickable && o.push(e.key), !0 === e.leafTicking && e.children.forEach(n)) : !0 === e.noTick || !0 !== e.tickable || !0 === e.leafFilteredTicking && !0 !== e.matchesFilter || o.push(e.key);
                };
                n(e), P(o, t);
            }
        }
        return (0, $TusQn.watch)(()=>e.ticked, (e)=>{
            r.value = e;
        }), (0, $TusQn.watch)(()=>e.expanded, (e)=>{
            s.value = e;
        }), !0 === e.defaultExpandAll && k(), Object.assign(n, {
            getNodeByKey: y,
            getTickedNodes: S,
            getExpandedNodes: w,
            isExpanded: C,
            collapseAll: x,
            expandAll: k,
            setExpanded: _,
            isTicked: T,
            setTicked: P
        }), ()=>{
            const t = M(e.nodes);
            return (0, $TusQn.h)("div", {
                class: c.value
            }, 0 === t.length ? e.filter ? e.noResultsLabel || a.lang.tree.noResults : e.noNodesLabel || a.lang.tree.noNodes : t);
        };
    }
});
function $ec2fc4c0d7a3c6c6$var$getProgressLabel(e) {
    return (100 * e).toFixed(2) + "%";
}
const $ec2fc4c0d7a3c6c6$var$coreProps = {
    ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
    ...$ec2fc4c0d7a3c6c6$var$useFileProps,
    label: String,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    noThumbnails: Boolean,
    autoUpload: Boolean,
    hideUploadBtn: Boolean,
    disable: Boolean,
    readonly: Boolean
}, $ec2fc4c0d7a3c6c6$var$coreEmits = [
    ...$ec2fc4c0d7a3c6c6$var$useFileEmits,
    "start",
    "finish",
    "added",
    "removed"
];
function $ec2fc4c0d7a3c6c6$var$getRenderer(e, t) {
    const o = (0, $TusQn.getCurrentInstance)(), { props: n, slots: a, emit: l, proxy: i } = o, { $q: r } = i, s = $ec2fc4c0d7a3c6c6$var$useDark(n, r);
    function u(e, t, o) {
        if (e.__status = t, "idle" === t) return e.__uploaded = 0, e.__progress = 0, e.__sizeLabel = $ec2fc4c0d7a3c6c6$var$humanStorageSize(e.size), void (e.__progressLabel = "0.00%");
        "failed" !== t ? (e.__uploaded = "uploaded" === t ? e.size : o, e.__progress = "uploaded" === t ? 1 : Math.min(.9999, e.__uploaded / e.size), e.__progressLabel = $ec2fc4c0d7a3c6c6$var$getProgressLabel(e.__progress), i.$forceUpdate()) : i.$forceUpdate();
    }
    const c = (0, $TusQn.computed)(()=>!0 !== n.disable && !0 !== n.readonly), d = (0, $01W3b.ref)(!1), p = (0, $01W3b.ref)(null), v = (0, $01W3b.ref)(null), m = {
        files: (0, $01W3b.ref)([]),
        queuedFiles: (0, $01W3b.ref)([]),
        uploadedFiles: (0, $01W3b.ref)([]),
        uploadedSize: (0, $01W3b.ref)(0),
        updateFileStatus: u,
        isAlive: ()=>!1 === $ec2fc4c0d7a3c6c6$var$vmIsDestroyed(o)
    }, { pickFiles: f, addFiles: g, onDragover: b, onDragleave: y, processFiles: S, getDndNode: w, maxFilesNumber: C, maxTotalSizeNumber: x } = $ec2fc4c0d7a3c6c6$var$useFile({
        editable: c,
        dnd: d,
        getFileInput: R,
        addFilesToQueue: D
    });
    Object.assign(m, e({
        props: n,
        slots: a,
        emit: l,
        helpers: m,
        exposeApi: (e)=>{
            Object.assign(m, e);
        }
    })), void 0 === m.isBusy && (m.isBusy = (0, $01W3b.ref)(!1));
    const k = (0, $01W3b.ref)(0), _ = (0, $TusQn.computed)(()=>0 === k.value ? 0 : m.uploadedSize.value / k.value), q = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$getProgressLabel(_.value)), T = (0, $TusQn.computed)(()=>$ec2fc4c0d7a3c6c6$var$humanStorageSize(k.value)), P = (0, $TusQn.computed)(()=>!0 === c.value && !0 !== m.isUploading.value && (!0 === n.multiple || 0 === m.queuedFiles.value.length) && (void 0 === n.maxFiles || m.files.value.length < C.value) && (void 0 === n.maxTotalSize || k.value < x.value)), $ = (0, $TusQn.computed)(()=>!0 === c.value && !0 !== m.isBusy.value && !0 !== m.isUploading.value && 0 !== m.queuedFiles.value.length);
    (0, $TusQn.provide)($ec2fc4c0d7a3c6c6$var$uploaderKey, V);
    const M = (0, $TusQn.computed)(()=>"q-uploader column no-wrap" + (!0 === s.value ? " q-uploader--dark q-dark" : "") + (!0 === n.bordered ? " q-uploader--bordered" : "") + (!0 === n.square ? " q-uploader--square no-border-radius" : "") + (!0 === n.flat ? " q-uploader--flat no-shadow" : "") + (!0 === n.disable ? " disabled q-uploader--disable" : "") + (!0 === d.value ? " q-uploader--dnd" : "")), B = (0, $TusQn.computed)(()=>"q-uploader__header" + (void 0 !== n.color ? ` bg-${n.color}` : "") + (void 0 !== n.textColor ? ` text-${n.textColor}` : ""));
    function E() {
        !1 === n.disable && (m.abort(), m.uploadedSize.value = 0, k.value = 0, F(), m.files.value = [], m.queuedFiles.value = [], m.uploadedFiles.value = []);
    }
    function Q() {
        !1 === n.disable && L([
            "uploaded"
        ], ()=>{
            m.uploadedFiles.value = [];
        });
    }
    function A() {
        L([
            "idle",
            "failed"
        ], ({ size: e })=>{
            k.value -= e, m.queuedFiles.value = [];
        });
    }
    function L(e, t) {
        if (!0 === n.disable) return;
        const o = {
            files: [],
            size: 0
        }, a = m.files.value.filter((t)=>{
            return -1 === e.indexOf(t.__status) || (o.size += t.size, o.files.push(t), void 0 !== t.__img && window.URL.revokeObjectURL(t.__img.src), !1);
        });
        0 !== o.files.length && (m.files.value = a, t(o), l("removed", o.files));
    }
    function O(e) {
        n.disable || ("uploaded" === e.__status ? m.uploadedFiles.value = m.uploadedFiles.value.filter((t)=>t.__key !== e.__key) : "uploading" === e.__status ? e.__abort() : k.value -= e.size, m.files.value = m.files.value.filter((t)=>{
            return t.__key !== e.__key || (void 0 !== t.__img && window.URL.revokeObjectURL(t.__img.src), !1);
        }), m.queuedFiles.value = m.queuedFiles.value.filter((t)=>t.__key !== e.__key), l("removed", [
            e
        ]));
    }
    function F() {
        m.files.value.forEach((e)=>{
            void 0 !== e.__img && window.URL.revokeObjectURL(e.__img.src);
        });
    }
    function R() {
        return v.value || p.value.getElementsByClassName("q-uploader__input")[0];
    }
    function D(e, t) {
        const o = S(e, t, m.files.value, !0), a = R();
        void 0 !== a && null !== a && (a.value = ""), void 0 !== o && (o.forEach((e)=>{
            if (m.updateFileStatus(e, "idle"), k.value += e.size, !0 !== n.noThumbnails && e.type.toUpperCase().startsWith("IMAGE")) {
                const t = new Image;
                t.src = window.URL.createObjectURL(e), e.__img = t;
            }
        }), m.files.value = m.files.value.concat(o), m.queuedFiles.value = m.queuedFiles.value.concat(o), l("added", o), !0 === n.autoUpload && m.upload());
    }
    function z() {
        !0 === $.value && m.upload();
    }
    function I(e, t, o) {
        if (!0 === e) {
            const e = {
                type: "a",
                key: t,
                icon: r.iconSet.uploader[t],
                flat: !0,
                dense: !0
            };
            let n = void 0;
            return "add" === t ? (e.onClick = f, n = V) : e.onClick = o, (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, e, n);
        }
    }
    function V() {
        return (0, $TusQn.h)("input", {
            ref: v,
            class: "q-uploader__input overflow-hidden absolute-full",
            tabindex: -1,
            type: "file",
            title: "",
            accept: n.accept,
            multiple: !0 === n.multiple ? "multiple" : void 0,
            capture: n.capture,
            onMousedown: $ec2fc4c0d7a3c6c6$var$stop,
            onClick: f,
            onChange: D
        });
    }
    function H() {
        return void 0 !== a.header ? a.header(j) : [
            (0, $TusQn.h)("div", {
                class: "q-uploader__header-content column"
            }, [
                (0, $TusQn.h)("div", {
                    class: "flex flex-center no-wrap q-gutter-xs"
                }, [
                    I(0 !== m.queuedFiles.value.length, "removeQueue", A),
                    I(0 !== m.uploadedFiles.value.length, "removeUploaded", Q),
                    !0 === m.isUploading.value ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0, {
                        class: "q-uploader__spinner"
                    }) : null,
                    (0, $TusQn.h)("div", {
                        class: "col column justify-center"
                    }, [
                        void 0 !== n.label ? (0, $TusQn.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            n.label
                        ]) : null,
                        (0, $TusQn.h)("div", {
                            class: "q-uploader__subtitle"
                        }, [
                            T.value + " / " + q.value
                        ])
                    ]),
                    I(P.value, "add"),
                    I(!1 === n.hideUploadBtn && !0 === $.value, "upload", m.upload),
                    I(m.isUploading.value, "clear", m.abort)
                ])
            ])
        ];
    }
    function N() {
        return void 0 !== a.list ? a.list(j) : m.files.value.map((e)=>(0, $TusQn.h)("div", {
                key: e.__key,
                class: "q-uploader__file relative-position" + (!0 !== n.noThumbnails && void 0 !== e.__img ? " q-uploader__file--img" : "") + ("failed" === e.__status ? " q-uploader__file--failed" : "uploaded" === e.__status ? " q-uploader__file--uploaded" : ""),
                style: !0 !== n.noThumbnails && void 0 !== e.__img ? {
                    backgroundImage: 'url("' + e.__img.src + '")'
                } : null
            }, [
                (0, $TusQn.h)("div", {
                    class: "q-uploader__file-header row flex-center no-wrap"
                }, [
                    "failed" === e.__status ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        class: "q-uploader__file-status",
                        name: r.iconSet.type.negative,
                        color: "negative"
                    }) : null,
                    (0, $TusQn.h)("div", {
                        class: "q-uploader__file-header-content col"
                    }, [
                        (0, $TusQn.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            e.name
                        ]),
                        (0, $TusQn.h)("div", {
                            class: "q-uploader__subtitle row items-center no-wrap"
                        }, [
                            e.__sizeLabel + " / " + e.__progressLabel
                        ])
                    ]),
                    "uploading" === e.__status ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$3bbfcedf93eff7f7, {
                        value: e.__progress,
                        min: 0,
                        max: 1,
                        indeterminate: 0 === e.__progress
                    }) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, {
                        round: !0,
                        dense: !0,
                        flat: !0,
                        icon: r.iconSet.uploader["uploaded" === e.__status ? "done" : "clear"],
                        onClick: ()=>{
                            O(e);
                        }
                    })
                ])
            ]));
    }
    (0, $TusQn.watch)(m.isUploading, (e, t)=>{
        !1 === t && !0 === e ? l("start") : !0 === t && !1 === e && l("finish");
    }), (0, $TusQn.onBeforeUnmount)(()=>{
        !0 === m.isUploading.value && m.abort(), 0 !== m.files.value.length && F();
    });
    const j = {};
    for(const h in m)!0 === (0, $01W3b.isRef)(m[h]) ? $ec2fc4c0d7a3c6c6$var$injectProp(j, h, ()=>m[h].value) : j[h] = m[h];
    return Object.assign(j, {
        upload: z,
        reset: E,
        removeUploadedFiles: Q,
        removeQueuedFiles: A,
        removeFile: O,
        pickFiles: f,
        addFiles: g
    }), $ec2fc4c0d7a3c6c6$var$injectMultipleProps(j, {
        canAddFiles: ()=>P.value,
        canUpload: ()=>$.value,
        uploadSizeLabel: ()=>T.value,
        uploadProgressLabel: ()=>q.value
    }), t({
        ...m,
        upload: z,
        reset: E,
        removeUploadedFiles: Q,
        removeQueuedFiles: A,
        removeFile: O,
        pickFiles: f,
        addFiles: g,
        canAddFiles: P,
        canUpload: $,
        uploadSizeLabel: T,
        uploadProgressLabel: q
    }), ()=>{
        const e = [
            (0, $TusQn.h)("div", {
                class: B.value
            }, H()),
            (0, $TusQn.h)("div", {
                class: "q-uploader__list scroll"
            }, N()),
            w("uploader")
        ];
        !0 === m.isBusy.value && e.push((0, $TusQn.h)("div", {
            class: "q-uploader__overlay absolute-full flex flex-center"
        }, [
            (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$7418ab329b11fed0)
        ]));
        const t = {
            ref: p,
            class: M.value
        };
        return !0 === P.value && Object.assign(t, {
            onDragover: b,
            onDragleave: y
        }), (0, $TusQn.h)("div", t, e);
    };
}
const $ec2fc4c0d7a3c6c6$var$trueFn = ()=>!0;
function $ec2fc4c0d7a3c6c6$var$getEmitsObject(e) {
    const t = {};
    return e.forEach((e)=>{
        t[e] = $ec2fc4c0d7a3c6c6$var$trueFn;
    }), t;
}
const $ec2fc4c0d7a3c6c6$var$coreEmitsObject = $ec2fc4c0d7a3c6c6$var$getEmitsObject($ec2fc4c0d7a3c6c6$var$coreEmits);
var $ec2fc4c0d7a3c6c6$export$a45880d810098f01 = ({ name: e, props: t, emits: o, injectPlugin: n })=>$ec2fc4c0d7a3c6c6$var$createComponent({
        name: e,
        props: {
            ...$ec2fc4c0d7a3c6c6$var$coreProps,
            ...t
        },
        emits: !0 === $ec2fc4c0d7a3c6c6$var$isObject(o) ? {
            ...$ec2fc4c0d7a3c6c6$var$coreEmitsObject,
            ...o
        } : [
            ...$ec2fc4c0d7a3c6c6$var$coreEmits,
            ...o
        ],
        setup (e, { expose: t }) {
            return $ec2fc4c0d7a3c6c6$var$getRenderer(n, t);
        }
    });
function $ec2fc4c0d7a3c6c6$var$getFn(e) {
    return "function" === typeof e ? e : ()=>e;
}
const $ec2fc4c0d7a3c6c6$var$props$2 = {
    url: [
        Function,
        String
    ],
    method: {
        type: [
            Function,
            String
        ],
        default: "POST"
    },
    fieldName: {
        type: [
            Function,
            String
        ],
        default: ()=>{
            return (e)=>e.name;
        }
    },
    headers: [
        Function,
        Array
    ],
    formFields: [
        Function,
        Array
    ],
    withCredentials: [
        Function,
        Boolean
    ],
    sendRaw: [
        Function,
        Boolean
    ],
    batch: [
        Function,
        Boolean
    ],
    factory: Function
}, $ec2fc4c0d7a3c6c6$var$emits$1 = [
    "factoryFailed",
    "uploaded",
    "failed",
    "uploading"
];
function $ec2fc4c0d7a3c6c6$var$injectPlugin({ props: e, emit: t, helpers: o }) {
    const n = (0, $01W3b.ref)([]), a = (0, $01W3b.ref)([]), l = (0, $01W3b.ref)(0), i = (0, $TusQn.computed)(()=>({
            url: $ec2fc4c0d7a3c6c6$var$getFn(e.url),
            method: $ec2fc4c0d7a3c6c6$var$getFn(e.method),
            headers: $ec2fc4c0d7a3c6c6$var$getFn(e.headers),
            formFields: $ec2fc4c0d7a3c6c6$var$getFn(e.formFields),
            fieldName: $ec2fc4c0d7a3c6c6$var$getFn(e.fieldName),
            withCredentials: $ec2fc4c0d7a3c6c6$var$getFn(e.withCredentials),
            sendRaw: $ec2fc4c0d7a3c6c6$var$getFn(e.sendRaw),
            batch: $ec2fc4c0d7a3c6c6$var$getFn(e.batch)
        })), r = (0, $TusQn.computed)(()=>l.value > 0), s = (0, $TusQn.computed)(()=>0 !== a.value.length);
    let u;
    function c() {
        n.value.forEach((e)=>{
            e.abort();
        }), 0 !== a.value.length && (u = !0);
    }
    function d() {
        const e = o.queuedFiles.value.slice(0);
        o.queuedFiles.value = [], i.value.batch(e) ? p(e) : e.forEach((e)=>{
            p([
                e
            ]);
        });
    }
    function p(n) {
        if (l.value++, "function" !== typeof e.factory) return void v(n, {});
        const i = e.factory(n);
        if (i) {
            if ("function" === typeof i.catch && "function" === typeof i.then) {
                a.value.push(i);
                const e = (e)=>{
                    !0 === o.isAlive() && (a.value = a.value.filter((e)=>e !== i), 0 === a.value.length && (u = !1), o.queuedFiles.value = o.queuedFiles.value.concat(n), n.forEach((e)=>{
                        o.updateFileStatus(e, "failed");
                    }), t("factoryFailed", e, n), l.value--);
                };
                i.then((t)=>{
                    !0 === u ? e(new Error("Aborted")) : !0 === o.isAlive() && (a.value = a.value.filter((e)=>e !== i), v(n, t));
                }).catch(e);
            } else v(n, i || {});
        } else t("factoryFailed", new Error("QUploader: factory() does not return properly"), n), l.value--;
    }
    function v(e, a) {
        const r = new FormData, s = new XMLHttpRequest, u = (e, t)=>{
            return void 0 !== a[e] ? $ec2fc4c0d7a3c6c6$var$getFn(a[e])(t) : i.value[e](t);
        }, c = u("url", e);
        if (!c) return console.error("q-uploader: invalid or no URL specified"), void l.value--;
        const d = u("formFields", e);
        void 0 !== d && d.forEach((e)=>{
            r.append(e.name, e.value);
        });
        let p, v = 0, m = 0, f = 0, h = 0;
        s.upload.addEventListener("progress", (t)=>{
            if (!0 === p) return;
            const n = Math.min(h, t.loaded);
            o.uploadedSize.value += n - f, f = n;
            let a = f - m;
            for(let l = v; a > 0 && l < e.length; l++){
                const t = e[l], n = a > t.size;
                if (!n) return void o.updateFileStatus(t, "uploading", a);
                a -= t.size, v++, m += t.size, o.updateFileStatus(t, "uploading", t.size);
            }
        }, !1), s.onreadystatechange = ()=>{
            s.readyState < 4 || (s.status && s.status < 400 ? (o.uploadedFiles.value = o.uploadedFiles.value.concat(e), e.forEach((e)=>{
                o.updateFileStatus(e, "uploaded");
            }), t("uploaded", {
                files: e,
                xhr: s
            })) : (p = !0, o.uploadedSize.value -= f, o.queuedFiles.value = o.queuedFiles.value.concat(e), e.forEach((e)=>{
                o.updateFileStatus(e, "failed");
            }), t("failed", {
                files: e,
                xhr: s
            })), l.value--, n.value = n.value.filter((e)=>e !== s));
        }, s.open(u("method", e), c), !0 === u("withCredentials", e) && (s.withCredentials = !0);
        const g = u("headers", e);
        void 0 !== g && g.forEach((e)=>{
            s.setRequestHeader(e.name, e.value);
        });
        const b = u("sendRaw", e);
        e.forEach((e)=>{
            o.updateFileStatus(e, "uploading", 0), !0 !== b && r.append(u("fieldName", e), e, e.name), e.xhr = s, e.__abort = ()=>{
                s.abort();
            }, h += e.size;
        }), t("uploading", {
            files: e,
            xhr: s
        }), n.value.push(s), !0 === b ? s.send(new Blob(e)) : s.send(r);
    }
    return {
        isUploading: r,
        isBusy: s,
        abort: c,
        upload: d
    };
}
var $ec2fc4c0d7a3c6c6$var$xhrUploaderPlugin = {
    name: "QUploader",
    props: $ec2fc4c0d7a3c6c6$var$props$2,
    emits: $ec2fc4c0d7a3c6c6$var$emits$1,
    injectPlugin: $ec2fc4c0d7a3c6c6$var$injectPlugin
}, $ec2fc4c0d7a3c6c6$export$fb96d5a0acebf1f = $ec2fc4c0d7a3c6c6$export$a45880d810098f01($ec2fc4c0d7a3c6c6$var$xhrUploaderPlugin), $ec2fc4c0d7a3c6c6$export$6029b08fdeeb477 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QUploaderAddTrigger",
    setup () {
        const e = (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$uploaderKey, $ec2fc4c0d7a3c6c6$var$emptyRenderFn);
        return e === $ec2fc4c0d7a3c6c6$var$emptyRenderFn && console.error("QUploaderAddTrigger needs to be child of QUploader"), e;
    }
}), $ec2fc4c0d7a3c6c6$export$a88d736580abbe = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "QVideo",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useRatioProps,
        src: {
            type: String,
            required: !0
        },
        title: String,
        fetchpriority: {
            type: String,
            default: "auto"
        },
        loading: {
            type: String,
            default: "eager"
        },
        referrerpolicy: {
            type: String,
            default: "strict-origin-when-cross-origin"
        }
    },
    setup (e) {
        const t = $ec2fc4c0d7a3c6c6$var$useRatio(e), o = (0, $TusQn.computed)(()=>"q-video" + (void 0 !== e.ratio ? " q-video--responsive" : ""));
        return ()=>(0, $TusQn.h)("div", {
                class: o.value,
                style: t.value
            }, [
                (0, $TusQn.h)("iframe", {
                    src: e.src,
                    title: e.title,
                    fetchpriority: e.fetchpriority,
                    loading: e.loading,
                    referrerpolicy: e.referrerpolicy,
                    frameborder: "0",
                    allowfullscreen: !0
                })
            ]);
    }
}), $ec2fc4c0d7a3c6c6$var$components = Object.freeze({
    __proto__: null,
    QAjaxBar: $ec2fc4c0d7a3c6c6$export$b18d87171d171ca9,
    QAvatar: $ec2fc4c0d7a3c6c6$export$f3774053158ba051,
    QBadge: $ec2fc4c0d7a3c6c6$export$73f24ecabf561a88,
    QBanner: $ec2fc4c0d7a3c6c6$export$388879c71c3c10cf,
    QBar: $ec2fc4c0d7a3c6c6$export$31ac01ac4236208c,
    QBreadcrumbs: $ec2fc4c0d7a3c6c6$export$88a7ba48108b3d90,
    QBreadcrumbsEl: $ec2fc4c0d7a3c6c6$export$488745943e252354,
    QBtn: $ec2fc4c0d7a3c6c6$export$72abad9388e88b7,
    QBtnDropdown: $ec2fc4c0d7a3c6c6$export$ed13f95342ac4309,
    QBtnGroup: $ec2fc4c0d7a3c6c6$export$ec40a025a653c83b,
    QBtnToggle: $ec2fc4c0d7a3c6c6$export$1e5c1ca50ee4d96c,
    QCard: $ec2fc4c0d7a3c6c6$export$866037ffbc2a7c62,
    QCardSection: $ec2fc4c0d7a3c6c6$export$653482776a1a6c98,
    QCardActions: $ec2fc4c0d7a3c6c6$export$8c05ea70037eac6a,
    QCarousel: $ec2fc4c0d7a3c6c6$export$ceb1843391966906,
    QCarouselSlide: $ec2fc4c0d7a3c6c6$export$18e00ae665ca0ca8,
    QCarouselControl: $ec2fc4c0d7a3c6c6$export$99b8110ff6b4a7c0,
    QChatMessage: $ec2fc4c0d7a3c6c6$export$f38b603ba263988,
    QCheckbox: $ec2fc4c0d7a3c6c6$export$a3430661ad019cfb,
    QChip: $ec2fc4c0d7a3c6c6$export$fe8abce8a0a972d6,
    QCircularProgress: $ec2fc4c0d7a3c6c6$export$3bbfcedf93eff7f7,
    QColor: $ec2fc4c0d7a3c6c6$export$32ed8655ecd274c2,
    QDate: $ec2fc4c0d7a3c6c6$export$599a443f7d1feef,
    QDialog: $ec2fc4c0d7a3c6c6$export$e6ccdac5fb3e2417,
    QDrawer: $ec2fc4c0d7a3c6c6$export$8bd189b8cd6124c2,
    QEditor: $ec2fc4c0d7a3c6c6$export$2107e7367505ec8a,
    QExpansionItem: $ec2fc4c0d7a3c6c6$export$eb8cb4fb55e6cd84,
    QFab: $ec2fc4c0d7a3c6c6$export$feca39a40ec06c6e,
    QFabAction: $ec2fc4c0d7a3c6c6$export$a1eb3675933e8b79,
    QField: $ec2fc4c0d7a3c6c6$export$9e1d68206b908513,
    QFile: $ec2fc4c0d7a3c6c6$export$f9762928c84dca74,
    QFooter: $ec2fc4c0d7a3c6c6$export$bf2298245c72b04b,
    QForm: $ec2fc4c0d7a3c6c6$export$1f74a2a6ec5f7e27,
    QFormChildMixin: $ec2fc4c0d7a3c6c6$export$4c671bf544af0ee8,
    QHeader: $ec2fc4c0d7a3c6c6$export$2dcc2a0b89cfff9b,
    QIcon: $ec2fc4c0d7a3c6c6$export$d56d6691b226e237,
    QImg: $ec2fc4c0d7a3c6c6$export$b76c0105a5546ea6,
    QInfiniteScroll: $ec2fc4c0d7a3c6c6$export$cc6e9b131bede082,
    QInnerLoading: $ec2fc4c0d7a3c6c6$export$d3667a9435d68192,
    QInput: $ec2fc4c0d7a3c6c6$export$b1c6a0c22e16b328,
    QIntersection: $ec2fc4c0d7a3c6c6$export$bfb6b34b3c68a45a,
    QList: $ec2fc4c0d7a3c6c6$export$546da2cac02ecac2,
    QItem: $ec2fc4c0d7a3c6c6$export$adf75769807ad87e,
    QItemSection: $ec2fc4c0d7a3c6c6$export$9579d29612d4e773,
    QItemLabel: $ec2fc4c0d7a3c6c6$export$17cb5eb1f3204256,
    QKnob: $ec2fc4c0d7a3c6c6$export$6c883daf6170407d,
    QLayout: $ec2fc4c0d7a3c6c6$export$c40af6af424a1775,
    QMarkupTable: $ec2fc4c0d7a3c6c6$export$96e16f0b01ad0bca,
    QMenu: $ec2fc4c0d7a3c6c6$export$73537802004a2118,
    QNoSsr: $ec2fc4c0d7a3c6c6$export$20500169d4287824,
    QOptionGroup: $ec2fc4c0d7a3c6c6$export$3ceb287b9597da0e,
    QPage: $ec2fc4c0d7a3c6c6$export$2739fb63d58d99fc,
    QPageContainer: $ec2fc4c0d7a3c6c6$export$c532236a32af6b2e,
    QPageScroller: $ec2fc4c0d7a3c6c6$export$757ee84fd3b4950f,
    QPageSticky: $ec2fc4c0d7a3c6c6$export$fb6e3b1b2833174c,
    QPagination: $ec2fc4c0d7a3c6c6$export$e0e0e4dfbf7cf819,
    QParallax: $ec2fc4c0d7a3c6c6$export$7edd9a653cb140a3,
    QPopupEdit: $ec2fc4c0d7a3c6c6$export$7a21aee2db893a36,
    QPopupProxy: $ec2fc4c0d7a3c6c6$export$8d66f956927c5a7b,
    QLinearProgress: $ec2fc4c0d7a3c6c6$export$2d10adb726183d68,
    QPullToRefresh: $ec2fc4c0d7a3c6c6$export$38ad2c7cb47d3fec,
    QRadio: $ec2fc4c0d7a3c6c6$export$339924d2c57b87f,
    QRange: $ec2fc4c0d7a3c6c6$export$396f1d127e5ea44f,
    QRating: $ec2fc4c0d7a3c6c6$export$97d378c58b81b163,
    QResizeObserver: $ec2fc4c0d7a3c6c6$export$614f53fe102a3da7,
    QResponsive: $ec2fc4c0d7a3c6c6$export$9f7ab13694915fcc,
    QScrollArea: $ec2fc4c0d7a3c6c6$export$6c88fb8d3b5e5b80,
    QScrollObserver: $ec2fc4c0d7a3c6c6$export$d6d34850bd31dad,
    QSelect: $ec2fc4c0d7a3c6c6$export$c6f171932ae1be1a,
    QSeparator: $ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9,
    QSkeleton: $ec2fc4c0d7a3c6c6$export$c03597c5c32a1b2c,
    QSlideItem: $ec2fc4c0d7a3c6c6$export$4b0d074f5c781fdc,
    QSlideTransition: $ec2fc4c0d7a3c6c6$export$1712cdc175d4649d,
    QSlider: $ec2fc4c0d7a3c6c6$export$eccd46d4261ec748,
    QSpace: $ec2fc4c0d7a3c6c6$export$e2e812bf9ee33e1a,
    QSpinner: $ec2fc4c0d7a3c6c6$export$7418ab329b11fed0,
    QSpinnerAudio: $ec2fc4c0d7a3c6c6$export$65a05f088d8e2ad5,
    QSpinnerBall: $ec2fc4c0d7a3c6c6$export$bccad2bfd65ba3b3,
    QSpinnerBars: $ec2fc4c0d7a3c6c6$export$4a50726b08ffdead,
    QSpinnerBox: $ec2fc4c0d7a3c6c6$export$dca5c45bff96781d,
    QSpinnerClock: $ec2fc4c0d7a3c6c6$export$ecf55558d357e9b2,
    QSpinnerComment: $ec2fc4c0d7a3c6c6$export$6e35813dfe5ed5df,
    QSpinnerCube: $ec2fc4c0d7a3c6c6$export$6a272c7550b80d16,
    QSpinnerDots: $ec2fc4c0d7a3c6c6$export$d62eca58f8bab60f,
    QSpinnerFacebook: $ec2fc4c0d7a3c6c6$export$bf634d821185ef2f,
    QSpinnerGears: $ec2fc4c0d7a3c6c6$export$d13dda2748f0ba28,
    QSpinnerGrid: $ec2fc4c0d7a3c6c6$export$ba3edcdf00657f3b,
    QSpinnerHearts: $ec2fc4c0d7a3c6c6$export$cb77d8a2fc9a1a83,
    QSpinnerHourglass: $ec2fc4c0d7a3c6c6$export$44b7dee4e71f51cd,
    QSpinnerInfinity: $ec2fc4c0d7a3c6c6$export$b71cd080434d9a8a,
    QSpinnerIos: $ec2fc4c0d7a3c6c6$export$77e9349f3d025ec0,
    QSpinnerOrbit: $ec2fc4c0d7a3c6c6$export$a97e088b3d2632d,
    QSpinnerOval: $ec2fc4c0d7a3c6c6$export$36a3d935578134a2,
    QSpinnerPie: $ec2fc4c0d7a3c6c6$export$e6f3833977eceb50,
    QSpinnerPuff: $ec2fc4c0d7a3c6c6$export$56d4f370365c4ec9,
    QSpinnerRadio: $ec2fc4c0d7a3c6c6$export$7734a351fc7fed9d,
    QSpinnerRings: $ec2fc4c0d7a3c6c6$export$6d6e0a9951cccd21,
    QSpinnerTail: $ec2fc4c0d7a3c6c6$export$87ed3277eacd506,
    QSplitter: $ec2fc4c0d7a3c6c6$export$e24eb95a687f22c5,
    QStep: $ec2fc4c0d7a3c6c6$export$973d42224d50092f,
    QStepper: $ec2fc4c0d7a3c6c6$export$9b249c4f2312b48e,
    QStepperNavigation: $ec2fc4c0d7a3c6c6$export$ccae125a3a1bd01f,
    QTabPanels: $ec2fc4c0d7a3c6c6$export$305a5380acbec321,
    QTabPanel: $ec2fc4c0d7a3c6c6$export$a513456409dea750,
    QTable: $ec2fc4c0d7a3c6c6$export$27fbdc739212cd86,
    QTh: $ec2fc4c0d7a3c6c6$export$f3b568562ea6363f,
    QTr: $ec2fc4c0d7a3c6c6$export$eb796db58a736f8f,
    QTd: $ec2fc4c0d7a3c6c6$export$f8a8c02d3a86d0c6,
    QTabs: $ec2fc4c0d7a3c6c6$export$f3e10d2f5515bdea,
    QTab: $ec2fc4c0d7a3c6c6$export$39ade007f653a559,
    QRouteTab: $ec2fc4c0d7a3c6c6$export$fc20573fc4d541d2,
    QTime: $ec2fc4c0d7a3c6c6$export$75b50612c5275613,
    QTimeline: $ec2fc4c0d7a3c6c6$export$aaf1acdf549e0e8f,
    QTimelineEntry: $ec2fc4c0d7a3c6c6$export$d0a3fbd020401544,
    QToggle: $ec2fc4c0d7a3c6c6$export$16e415cb3321864c,
    QToolbar: $ec2fc4c0d7a3c6c6$export$9cfe29ba9f08864a,
    QToolbarTitle: $ec2fc4c0d7a3c6c6$export$dbcf6fec4996856c,
    QTooltip: $ec2fc4c0d7a3c6c6$export$b4dba0bbe7f6a787,
    QTree: $ec2fc4c0d7a3c6c6$export$6ac73dd07dbdca3b,
    QUploader: $ec2fc4c0d7a3c6c6$export$fb96d5a0acebf1f,
    QUploaderAddTrigger: $ec2fc4c0d7a3c6c6$export$6029b08fdeeb477,
    QVideo: $ec2fc4c0d7a3c6c6$export$a88d736580abbe,
    QVirtualScroll: $ec2fc4c0d7a3c6c6$export$e23e912583dc74c1
});
function $ec2fc4c0d7a3c6c6$var$getDepth(e) {
    if (!1 === e) return 0;
    if (!0 === e || void 0 === e) return 1;
    const t = parseInt(e, 10);
    return isNaN(t) ? 0 : t;
}
var $ec2fc4c0d7a3c6c6$export$5e283f024fc297b1 = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "close-popup",
    beforeMount (e, { value: t }) {
        const o = {
            depth: $ec2fc4c0d7a3c6c6$var$getDepth(t),
            handler (t) {
                0 !== o.depth && setTimeout(()=>{
                    const n = $ec2fc4c0d7a3c6c6$var$getPortalProxy(e);
                    void 0 !== n && $ec2fc4c0d7a3c6c6$var$closePortals(n, t, o.depth);
                });
            },
            handlerKey (e) {
                !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(e, 13) && o.handler(e);
            }
        };
        e.__qclosepopup = o, e.addEventListener("click", o.handler), e.addEventListener("keyup", o.handlerKey);
    },
    updated (e, { value: t, oldValue: o }) {
        t !== o && (e.__qclosepopup.depth = $ec2fc4c0d7a3c6c6$var$getDepth(t));
    },
    beforeUnmount (e) {
        const t = e.__qclosepopup;
        e.removeEventListener("click", t.handler), e.removeEventListener("keyup", t.handlerKey), delete e.__qclosepopup;
    }
});
let $ec2fc4c0d7a3c6c6$var$id = 0, $ec2fc4c0d7a3c6c6$var$offsetBase = void 0;
function $ec2fc4c0d7a3c6c6$var$getAbsolutePosition(e, t) {
    void 0 === $ec2fc4c0d7a3c6c6$var$offsetBase && ($ec2fc4c0d7a3c6c6$var$offsetBase = document.createElement("div"), $ec2fc4c0d7a3c6c6$var$offsetBase.style.cssText = "position: absolute; left: 0; top: 0", document.body.appendChild($ec2fc4c0d7a3c6c6$var$offsetBase));
    const o = e.getBoundingClientRect(), n = $ec2fc4c0d7a3c6c6$var$offsetBase.getBoundingClientRect(), { marginLeft: a, marginRight: l, marginTop: i, marginBottom: r } = window.getComputedStyle(e), s = parseInt(a, 10) + parseInt(l, 10), u = parseInt(i, 10) + parseInt(r, 10);
    return {
        left: o.left - n.left,
        top: o.top - n.top,
        width: o.right - o.left,
        height: o.bottom - o.top,
        widthM: o.right - o.left + (!0 === t ? 0 : s),
        heightM: o.bottom - o.top + (!0 === t ? 0 : u),
        marginH: !0 === t ? s : 0,
        marginV: !0 === t ? u : 0
    };
}
function $ec2fc4c0d7a3c6c6$var$getAbsoluteSize(e) {
    return {
        width: e.scrollWidth,
        height: e.scrollHeight
    };
}
const $ec2fc4c0d7a3c6c6$var$styleEdges = [
    "Top",
    "Right",
    "Bottom",
    "Left"
], $ec2fc4c0d7a3c6c6$var$styleBorderRadiuses = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
], $ec2fc4c0d7a3c6c6$var$reStyleSkipKey = /-block|-inline|block-|inline-/, $ec2fc4c0d7a3c6c6$var$reStyleSkipRule = /(-block|-inline|block-|inline-).*:/;
function $ec2fc4c0d7a3c6c6$var$getComputedStyle$1(e, t) {
    const o = window.getComputedStyle(e), n = {};
    for(let a = 0; a < t.length; a++){
        const e = t[a];
        if ("" === o[e]) {
            if ("cssText" === e) {
                const t = o.length;
                let a = "";
                for(let e = 0; e < t; e++)!0 !== $ec2fc4c0d7a3c6c6$var$reStyleSkipKey.test(o[e]) && (a += o[e] + ": " + o[o[e]] + "; ");
                n[e] = a;
            } else if ([
                "borderWidth",
                "borderStyle",
                "borderColor"
            ].indexOf(e) > -1) {
                const t = e.replace("border", "");
                let a = "";
                for(let e = 0; e < $ec2fc4c0d7a3c6c6$var$styleEdges.length; e++){
                    const n = "border" + $ec2fc4c0d7a3c6c6$var$styleEdges[e] + t;
                    a += o[n] + " ";
                }
                n[e] = a;
            } else if ("borderRadius" === e) {
                let t = "", a = "";
                for(let e = 0; e < $ec2fc4c0d7a3c6c6$var$styleBorderRadiuses.length; e++){
                    const n = o[$ec2fc4c0d7a3c6c6$var$styleBorderRadiuses[e]].split(" ");
                    t += n[0] + " ", a += (void 0 === n[1] ? n[0] : n[1]) + " ";
                }
                n[e] = t + "/ " + a;
            } else n[e] = o[e];
        } else n[e] = "cssText" === e ? o[e].split(";").filter((e)=>!0 !== $ec2fc4c0d7a3c6c6$var$reStyleSkipRule.test(e)).join(";") : o[e];
    }
    return n;
}
const $ec2fc4c0d7a3c6c6$var$zIndexPositions = [
    "absolute",
    "fixed",
    "relative",
    "sticky"
];
function $ec2fc4c0d7a3c6c6$var$getMaxZIndex(e) {
    let t = e, o = 0;
    while(null !== t && t !== document){
        const { position: n, zIndex: a } = window.getComputedStyle(t), l = Number(a);
        l > o && (t === e || !0 === $ec2fc4c0d7a3c6c6$var$zIndexPositions.includes(n)) && (o = l), t = t.parentNode;
    }
    return o;
}
function $ec2fc4c0d7a3c6c6$var$normalizeElements(e) {
    return {
        from: e.from,
        to: void 0 !== e.to ? e.to : e.from
    };
}
function $ec2fc4c0d7a3c6c6$var$normalizeOptions(e) {
    return "number" === typeof e ? e = {
        duration: e
    } : "function" === typeof e && (e = {
        onEnd: e
    }), {
        ...e,
        waitFor: void 0 === e.waitFor ? 0 : e.waitFor,
        duration: !0 === isNaN(e.duration) ? 300 : parseInt(e.duration, 10),
        easing: "string" === typeof e.easing && 0 !== e.easing.length ? e.easing : "ease-in-out",
        delay: !0 === isNaN(e.delay) ? 0 : parseInt(e.delay, 10),
        fill: "string" === typeof e.fill && 0 !== e.fill.length ? e.fill : "none",
        resize: !0 === e.resize,
        useCSS: !0 === e.useCSS || !0 === e.usecss,
        hideFromClone: !0 === e.hideFromClone || !0 === e.hidefromclone,
        keepToClone: !0 === e.keepToClone || !0 === e.keeptoclone,
        tween: !0 === e.tween,
        tweenFromOpacity: !0 === isNaN(e.tweenFromOpacity) ? .6 : parseFloat(e.tweenFromOpacity),
        tweenToOpacity: !0 === isNaN(e.tweenToOpacity) ? .5 : parseFloat(e.tweenToOpacity)
    };
}
function $ec2fc4c0d7a3c6c6$var$getElement(e) {
    const t = typeof e;
    return "function" === t ? e() : "string" === t ? document.querySelector(e) : e;
}
function $ec2fc4c0d7a3c6c6$var$isValidElement(e) {
    return e && e.ownerDocument === document && null !== e.parentNode;
}
function $ec2fc4c0d7a3c6c6$export$2e5e8c41f5d4e7c7(e) {
    let t = ()=>!1, o = !1, n = !0;
    const a = $ec2fc4c0d7a3c6c6$var$normalizeElements(e), l = $ec2fc4c0d7a3c6c6$var$normalizeOptions(e), i = $ec2fc4c0d7a3c6c6$var$getElement(a.from);
    if (!0 !== $ec2fc4c0d7a3c6c6$var$isValidElement(i)) return t;
    "function" === typeof i.qMorphCancel && i.qMorphCancel();
    let r = void 0, s = void 0, u = void 0, c = void 0;
    const d = i.parentNode, p = i.nextElementSibling, v = $ec2fc4c0d7a3c6c6$var$getAbsolutePosition(i, l.resize), { width: m, height: f } = $ec2fc4c0d7a3c6c6$var$getAbsoluteSize(d), { borderWidth: h, borderStyle: g, borderColor: b, borderRadius: y, backgroundColor: S, transform: w, position: C, cssText: x } = $ec2fc4c0d7a3c6c6$var$getComputedStyle$1(i, [
        "borderWidth",
        "borderStyle",
        "borderColor",
        "borderRadius",
        "backgroundColor",
        "transform",
        "position",
        "cssText"
    ]), k = i.classList.toString(), _ = i.style.cssText, q = i.cloneNode(!0), T = !0 === l.tween ? i.cloneNode(!0) : void 0;
    void 0 !== T && (T.className = T.classList.toString().split(" ").filter((e)=>!1 === /^bg-/.test(e)).join(" ")), !0 === l.hideFromClone && q.classList.add("q-morph--internal"), q.setAttribute("aria-hidden", "true"), q.style.transition = "none", q.style.animation = "none", q.style.pointerEvents = "none", d.insertBefore(q, p), i.qMorphCancel = ()=>{
        o = !0, q.remove(), void 0 !== T && T.remove(), !0 === l.hideFromClone && q.classList.remove("q-morph--internal"), i.qMorphCancel = void 0;
    };
    const P = ()=>{
        const e = $ec2fc4c0d7a3c6c6$var$getElement(a.to);
        if (!0 === o || !0 !== $ec2fc4c0d7a3c6c6$var$isValidElement(e)) return void ("function" === typeof i.qMorphCancel && i.qMorphCancel());
        i !== e && "function" === typeof e.qMorphCancel && e.qMorphCancel(), !0 !== l.keepToClone && e.classList.add("q-morph--internal"), q.classList.add("q-morph--internal");
        const { width: p, height: P } = $ec2fc4c0d7a3c6c6$var$getAbsoluteSize(d), { width: $, height: M } = $ec2fc4c0d7a3c6c6$var$getAbsoluteSize(e.parentNode);
        !0 !== l.hideFromClone && q.classList.remove("q-morph--internal"), e.qMorphCancel = ()=>{
            o = !0, q.remove(), void 0 !== T && T.remove(), !0 === l.hideFromClone && q.classList.remove("q-morph--internal"), !0 !== l.keepToClone && e.classList.remove("q-morph--internal"), i.qMorphCancel = void 0, e.qMorphCancel = void 0;
        };
        const B = ()=>{
            if (!0 === o) return void ("function" === typeof e.qMorphCancel && e.qMorphCancel());
            !0 !== l.hideFromClone && (q.classList.add("q-morph--internal"), q.innerHTML = "", q.style.left = 0, q.style.right = "unset", q.style.top = 0, q.style.bottom = "unset", q.style.transform = "none"), !0 !== l.keepToClone && e.classList.remove("q-morph--internal");
            const a = e.parentNode, { width: B, height: E } = $ec2fc4c0d7a3c6c6$var$getAbsoluteSize(a), Q = e.cloneNode(l.keepToClone);
            Q.setAttribute("aria-hidden", "true"), !0 !== l.keepToClone && (Q.style.left = 0, Q.style.right = "unset", Q.style.top = 0, Q.style.bottom = "unset", Q.style.transform = "none", Q.style.pointerEvents = "none"), Q.classList.add("q-morph--internal");
            const A = e === i && d === a ? q : e.nextElementSibling;
            a.insertBefore(Q, A);
            const { borderWidth: L, borderStyle: O, borderColor: F, borderRadius: R, backgroundColor: D, transform: z, position: I, cssText: V } = $ec2fc4c0d7a3c6c6$var$getComputedStyle$1(e, [
                "borderWidth",
                "borderStyle",
                "borderColor",
                "borderRadius",
                "backgroundColor",
                "transform",
                "position",
                "cssText"
            ]), H = e.classList.toString(), N = e.style.cssText;
            e.style.cssText = V, e.style.transform = "none", e.style.animation = "none", e.style.transition = "none", e.className = H.split(" ").filter((e)=>!1 === /^bg-/.test(e)).join(" ");
            const j = $ec2fc4c0d7a3c6c6$var$getAbsolutePosition(e, l.resize), U = v.left - j.left, K = v.top - j.top, W = v.width / (j.width > 0 ? j.width : 10), Y = v.height / (j.height > 0 ? j.height : 100), G = m - p, X = f - P, Z = B - $, J = E - M, ee = Math.max(v.widthM, G), te = Math.max(v.heightM, X), oe = Math.max(j.widthM, Z), ne = Math.max(j.heightM, J), ae = i === e && !1 === [
                "absolute",
                "fixed"
            ].includes(I) && !1 === [
                "absolute",
                "fixed"
            ].includes(C);
            let le = "fixed" === I, ie = a;
            while(!0 !== le && ie !== document)le = "fixed" === window.getComputedStyle(ie).position, ie = ie.parentNode;
            if (!0 !== l.hideFromClone && (q.style.display = "block", q.style.flex = "0 0 auto", q.style.opacity = 0, q.style.minWidth = "unset", q.style.maxWidth = "unset", q.style.minHeight = "unset", q.style.maxHeight = "unset", q.classList.remove("q-morph--internal")), !0 !== l.keepToClone && (Q.style.display = "block", Q.style.flex = "0 0 auto", Q.style.opacity = 0, Q.style.minWidth = "unset", Q.style.maxWidth = "unset", Q.style.minHeight = "unset", Q.style.maxHeight = "unset"), Q.classList.remove("q-morph--internal"), "string" === typeof l.classes && (e.className += " " + l.classes), "string" === typeof l.style) e.style.cssText += " " + l.style;
            else if (!0 === $ec2fc4c0d7a3c6c6$var$isObject(l.style)) for(const t in l.style)e.style[t] = l.style[t];
            const re = $ec2fc4c0d7a3c6c6$var$getMaxZIndex(q), se = $ec2fc4c0d7a3c6c6$var$getMaxZIndex(e), ue = !0 === le ? document.documentElement : {
                scrollLeft: 0,
                scrollTop: 0
            };
            e.style.position = !0 === le ? "fixed" : "absolute", e.style.left = `${j.left - ue.scrollLeft}px`, e.style.right = "unset", e.style.top = `${j.top - ue.scrollTop}px`, e.style.margin = 0, !0 === l.resize && (e.style.minWidth = "unset", e.style.maxWidth = "unset", e.style.minHeight = "unset", e.style.maxHeight = "unset", e.style.overflow = "hidden", e.style.overflowX = "hidden", e.style.overflowY = "hidden"), document.body.appendChild(e), void 0 !== T && (T.style.cssText = x, T.style.transform = "none", T.style.animation = "none", T.style.transition = "none", T.style.position = e.style.position, T.style.left = `${v.left - ue.scrollLeft}px`, T.style.right = "unset", T.style.top = `${v.top - ue.scrollTop}px`, T.style.margin = 0, T.style.pointerEvents = "none", !0 === l.resize && (T.style.minWidth = "unset", T.style.maxWidth = "unset", T.style.minHeight = "unset", T.style.maxHeight = "unset", T.style.overflow = "hidden", T.style.overflowX = "hidden", T.style.overflowY = "hidden"), document.body.appendChild(T));
            const ce = (o)=>{
                i === e && !0 !== n ? (e.style.cssText = _, e.className = k) : (e.style.cssText = N, e.className = H), Q.parentNode === a && a.insertBefore(e, Q), q.remove(), Q.remove(), void 0 !== T && T.remove(), t = ()=>!1, i.qMorphCancel = void 0, e.qMorphCancel = void 0, "function" === typeof l.onEnd && l.onEnd(!0 === n ? "to" : "from", !0 === o);
            };
            if (!0 !== l.useCSS && "function" === typeof e.animate) {
                const a = !0 === l.resize ? {
                    transform: `translate(${U}px, ${K}px)`,
                    width: `${ee}px`,
                    height: `${te}px`
                } : {
                    transform: `translate(${U}px, ${K}px) scale(${W}, ${Y})`
                }, d = !0 === l.resize ? {
                    width: `${oe}px`,
                    height: `${ne}px`
                } : {}, p = !0 === l.resize ? {
                    width: `${ee}px`,
                    height: `${te}px`
                } : {}, m = !0 === l.resize ? {
                    transform: `translate(${-1 * U}px, ${-1 * K}px)`,
                    width: `${oe}px`,
                    height: `${ne}px`
                } : {
                    transform: `translate(${-1 * U}px, ${-1 * K}px) scale(${1 / W}, ${1 / Y})`
                }, f = void 0 !== T ? {
                    opacity: l.tweenToOpacity
                } : {
                    backgroundColor: S
                }, C = void 0 !== T ? {
                    opacity: 1
                } : {
                    backgroundColor: D
                };
                c = e.animate([
                    {
                        margin: 0,
                        borderWidth: h,
                        borderStyle: g,
                        borderColor: b,
                        borderRadius: y,
                        zIndex: re,
                        transformOrigin: "0 0",
                        ...a,
                        ...f
                    },
                    {
                        margin: 0,
                        borderWidth: L,
                        borderStyle: O,
                        borderColor: F,
                        borderRadius: R,
                        zIndex: se,
                        transformOrigin: "0 0",
                        transform: z,
                        ...d,
                        ...C
                    }
                ], {
                    duration: l.duration,
                    easing: l.easing,
                    fill: l.fill,
                    delay: l.delay
                }), s = void 0 === T ? void 0 : T.animate([
                    {
                        opacity: l.tweenFromOpacity,
                        margin: 0,
                        borderWidth: h,
                        borderStyle: g,
                        borderColor: b,
                        borderRadius: y,
                        zIndex: re,
                        transformOrigin: "0 0",
                        transform: w,
                        ...p
                    },
                    {
                        opacity: 0,
                        margin: 0,
                        borderWidth: L,
                        borderStyle: O,
                        borderColor: F,
                        borderRadius: R,
                        zIndex: se,
                        transformOrigin: "0 0",
                        ...m
                    }
                ], {
                    duration: l.duration,
                    easing: l.easing,
                    fill: l.fill,
                    delay: l.delay
                }), r = !0 === l.hideFromClone || !0 === ae ? void 0 : q.animate([
                    {
                        margin: `${X < 0 ? X / 2 : 0}px ${G < 0 ? G / 2 : 0}px`,
                        width: `${ee + v.marginH}px`,
                        height: `${te + v.marginV}px`
                    },
                    {
                        margin: 0,
                        width: 0,
                        height: 0
                    }
                ], {
                    duration: l.duration,
                    easing: l.easing,
                    fill: l.fill,
                    delay: l.delay
                }), u = !0 === l.keepToClone ? void 0 : Q.animate([
                    !0 === ae ? {
                        margin: `${X < 0 ? X / 2 : 0}px ${G < 0 ? G / 2 : 0}px`,
                        width: `${ee + v.marginH}px`,
                        height: `${te + v.marginV}px`
                    } : {
                        margin: 0,
                        width: 0,
                        height: 0
                    },
                    {
                        margin: `${J < 0 ? J / 2 : 0}px ${Z < 0 ? Z / 2 : 0}px`,
                        width: `${oe + j.marginH}px`,
                        height: `${ne + j.marginV}px`
                    }
                ], {
                    duration: l.duration,
                    easing: l.easing,
                    fill: l.fill,
                    delay: l.delay
                });
                const x = (e)=>{
                    void 0 !== r && r.cancel(), void 0 !== s && s.cancel(), void 0 !== u && u.cancel(), c.cancel(), c.removeEventListener("finish", x), c.removeEventListener("cancel", x), ce(e), r = void 0, s = void 0, u = void 0, c = void 0;
                };
                i.qMorphCancel = ()=>{
                    i.qMorphCancel = void 0, o = !0, x();
                }, e.qMorphCancel = ()=>{
                    e.qMorphCancel = void 0, o = !0, x();
                }, c.addEventListener("finish", x), c.addEventListener("cancel", x), t = (e)=>{
                    return !0 !== o && void 0 !== c && (!0 === e ? (x(!0), !0) : (n = !0 !== n, void 0 !== r && r.reverse(), void 0 !== s && s.reverse(), void 0 !== u && u.reverse(), c.reverse(), !0));
                };
            } else {
                const a = `q-morph-anim-${++$ec2fc4c0d7a3c6c6$var$id}`, r = document.createElement("style"), s = !0 === l.resize ? `\n            transform: translate(${U}px, ${K}px);\n            width: ${ee}px;\n            height: ${te}px;\n          ` : `transform: translate(${U}px, ${K}px) scale(${W}, ${Y});`, u = !0 === l.resize ? `\n            width: ${oe}px;\n            height: ${ne}px;\n          ` : "", c = !0 === l.resize ? `\n            width: ${ee}px;\n            height: ${te}px;\n          ` : "", d = !0 === l.resize ? `\n            transform: translate(${-1 * U}px, ${-1 * K}px);\n            width: ${oe}px;\n            height: ${ne}px;\n          ` : `transform: translate(${-1 * U}px, ${-1 * K}px) scale(${1 / W}, ${1 / Y});`, p = void 0 !== T ? `opacity: ${l.tweenToOpacity};` : `background-color: ${S};`, m = void 0 !== T ? "opacity: 1;" : `background-color: ${D};`, f = void 0 === T ? "" : `\n            @keyframes ${a}-from-tween {\n              0% {\n                opacity: ${l.tweenFromOpacity};\n                margin: 0;\n                border-width: ${h};\n                border-style: ${g};\n                border-color: ${b};\n                border-radius: ${y};\n                z-index: ${re};\n                transform-origin: 0 0;\n                transform: ${w};\n                ${c}\n              }\n\n              100% {\n                opacity: 0;\n                margin: 0;\n                border-width: ${L};\n                border-style: ${O};\n                border-color: ${F};\n                border-radius: ${R};\n                z-index: ${se};\n                transform-origin: 0 0;\n                ${d}\n              }\n            }\n          `, C = !0 === l.hideFromClone || !0 === ae ? "" : `\n            @keyframes ${a}-from {\n              0% {\n                margin: ${X < 0 ? X / 2 : 0}px ${G < 0 ? G / 2 : 0}px;\n                width: ${ee + v.marginH}px;\n                height: ${te + v.marginV}px;\n              }\n\n              100% {\n                margin: 0;\n                width: 0;\n                height: 0;\n              }\n            }\n          `, x = !0 === ae ? `\n            margin: ${X < 0 ? X / 2 : 0}px ${G < 0 ? G / 2 : 0}px;\n            width: ${ee + v.marginH}px;\n            height: ${te + v.marginV}px;\n          ` : "\n            margin: 0;\n            width: 0;\n            height: 0;\n          ", k = !0 === l.keepToClone ? "" : `\n            @keyframes ${a}-to {\n              0% {\n                ${x}\n              }\n\n              100% {\n                margin: ${J < 0 ? J / 2 : 0}px ${Z < 0 ? Z / 2 : 0}px;\n                width: ${oe + j.marginH}px;\n                height: ${ne + j.marginV}px;\n              }\n            }\n          `;
                r.innerHTML = `\n          @keyframes ${a} {\n            0% {\n              margin: 0;\n              border-width: ${h};\n              border-style: ${g};\n              border-color: ${b};\n              border-radius: ${y};\n              background-color: ${S};\n              z-index: ${re};\n              transform-origin: 0 0;\n              ${s}\n              ${p}\n            }\n\n            100% {\n              margin: 0;\n              border-width: ${L};\n              border-style: ${O};\n              border-color: ${F};\n              border-radius: ${R};\n              background-color: ${D};\n              z-index: ${se};\n              transform-origin: 0 0;\n              transform: ${z};\n              ${u}\n              ${m}\n            }\n          }\n\n          ${C}\n\n          ${f}\n\n          ${k}\n        `, document.head.appendChild(r);
                let _ = "normal";
                q.style.animation = `${l.duration}ms ${l.easing} ${l.delay}ms ${_} ${l.fill} ${a}-from`, void 0 !== T && (T.style.animation = `${l.duration}ms ${l.easing} ${l.delay}ms ${_} ${l.fill} ${a}-from-tween`), Q.style.animation = `${l.duration}ms ${l.easing} ${l.delay}ms ${_} ${l.fill} ${a}-to`, e.style.animation = `${l.duration}ms ${l.easing} ${l.delay}ms ${_} ${l.fill} ${a}`;
                const P = (t)=>{
                    t === Object(t) && t.animationName !== a || (e.removeEventListener("animationend", P), e.removeEventListener("animationcancel", P), ce(), r.remove());
                };
                i.qMorphCancel = ()=>{
                    i.qMorphCancel = void 0, o = !0, P();
                }, e.qMorphCancel = ()=>{
                    e.qMorphCancel = void 0, o = !0, P();
                }, e.addEventListener("animationend", P), e.addEventListener("animationcancel", P), t = (t)=>{
                    return !!(!0 !== o && e && q && Q) && (!0 === t ? (P(), !0) : (n = !0 !== n, _ = "normal" === _ ? "reverse" : "normal", q.style.animationDirection = _, T.style.animationDirection = _, Q.style.animationDirection = _, e.style.animationDirection = _, !0));
                };
            }
        };
        if (l.waitFor > 0 || "transitionend" === l.waitFor || l.waitFor === Object(l.waitFor) && "function" === typeof l.waitFor.then) {
            const t = l.waitFor > 0 ? new Promise((e)=>setTimeout(e, l.waitFor)) : "transitionend" === l.waitFor ? new Promise((t)=>{
                const o = ()=>{
                    null !== n && (clearTimeout(n), n = null), e && (e.removeEventListener("transitionend", o), e.removeEventListener("transitioncancel", o)), t();
                };
                let n = setTimeout(o, 400);
                e.addEventListener("transitionend", o), e.addEventListener("transitioncancel", o);
            }) : l.waitFor;
            t.then(B).catch(()=>{
                "function" === typeof e.qMorphCancel && e.qMorphCancel();
            });
        } else B();
    };
    return "function" === typeof e.onToggle && e.onToggle(), requestAnimationFrame(P), (e)=>t(e);
}
const $ec2fc4c0d7a3c6c6$var$morphGroups = {}, $ec2fc4c0d7a3c6c6$var$props$1 = [
    "duration",
    "delay",
    "easing",
    "fill",
    "classes",
    "style",
    "duration",
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween",
    "tweenFromOpacity",
    "tweenToOpacity",
    "waitFor",
    "onEnd"
], $ec2fc4c0d7a3c6c6$var$mods = [
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween"
];
function $ec2fc4c0d7a3c6c6$var$changeClass(e, t) {
    e.clsAction !== t && (e.clsAction = t, e.el.classList[t]("q-morph--invisible"));
}
function $ec2fc4c0d7a3c6c6$var$trigger(e) {
    if (!0 === e.animating || e.queue.length < 2) return;
    const [t, o] = e.queue;
    e.animating = !0, t.animating = !0, o.animating = !0, $ec2fc4c0d7a3c6c6$var$changeClass(t, "remove"), $ec2fc4c0d7a3c6c6$var$changeClass(o, "remove");
    const n = $ec2fc4c0d7a3c6c6$export$2e5e8c41f5d4e7c7({
        from: t.el,
        to: o.el,
        onToggle () {
            $ec2fc4c0d7a3c6c6$var$changeClass(t, "add"), $ec2fc4c0d7a3c6c6$var$changeClass(o, "remove");
        },
        ...o.opts,
        onEnd (n, a) {
            void 0 !== o.opts.onEnd && o.opts.onEnd(n, a), !0 !== a && (t.animating = !1, o.animating = !1, e.animating = !1, e.cancel = void 0, e.queue.shift(), $ec2fc4c0d7a3c6c6$var$trigger(e));
        }
    });
    e.cancel = ()=>{
        n(!0), e.cancel = void 0;
    };
}
function $ec2fc4c0d7a3c6c6$var$updateModifiers(e, t) {
    const o = t.opts;
    $ec2fc4c0d7a3c6c6$var$mods.forEach((t)=>{
        o[t] = !0 === e[t];
    });
}
function $ec2fc4c0d7a3c6c6$var$insertArgs(e, t) {
    const o = "string" === typeof e && 0 !== e.length ? e.split(":") : [];
    t.name = o[0], t.group = o[1], Object.assign(t.opts, {
        duration: !0 === isNaN(o[2]) ? 300 : parseFloat(o[2]),
        waitFor: o[3]
    });
}
function $ec2fc4c0d7a3c6c6$var$updateArgs(e, t) {
    void 0 !== e.group && (t.group = e.group), void 0 !== e.name && (t.name = e.name);
    const o = t.opts;
    $ec2fc4c0d7a3c6c6$var$props$1.forEach((t)=>{
        void 0 !== e[t] && (o[t] = e[t]);
    });
}
function $ec2fc4c0d7a3c6c6$var$updateModel(e, t) {
    if (t.name !== e) !1 === t.animating && $ec2fc4c0d7a3c6c6$var$changeClass(t, "add");
    else {
        const o = $ec2fc4c0d7a3c6c6$var$morphGroups[t.group];
        void 0 === o ? ($ec2fc4c0d7a3c6c6$var$morphGroups[t.group] = {
            name: t.group,
            model: e,
            queue: [
                t
            ],
            animating: !1
        }, $ec2fc4c0d7a3c6c6$var$changeClass(t, "remove")) : o.model !== e && (o.model = e, o.queue.push(t), !1 === o.animating && 2 === o.queue.length && $ec2fc4c0d7a3c6c6$var$trigger(o));
    }
}
function $ec2fc4c0d7a3c6c6$var$updateValue(e, t) {
    let o;
    Object(t) === t ? (o = "" + t.model, $ec2fc4c0d7a3c6c6$var$updateArgs(t, e), $ec2fc4c0d7a3c6c6$var$updateModifiers(t, e)) : o = "" + t, o !== e.model ? (e.model = o, $ec2fc4c0d7a3c6c6$var$updateModel(o, e)) : !1 === e.animating && void 0 !== e.clsAction && e.el.classList[e.clsAction]("q-morph--invisible");
}
var $ec2fc4c0d7a3c6c6$export$24a95a7694c627b7 = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "morph",
    mounted (e, t) {
        const o = {
            el: e,
            animating: !1,
            opts: {}
        };
        $ec2fc4c0d7a3c6c6$var$updateModifiers(t.modifiers, o), $ec2fc4c0d7a3c6c6$var$insertArgs(t.arg, o), $ec2fc4c0d7a3c6c6$var$updateValue(o, t.value), e.__qmorph = o;
    },
    updated (e, t) {
        $ec2fc4c0d7a3c6c6$var$updateValue(e.__qmorph, t.value);
    },
    beforeUnmount (e) {
        const t = e.__qmorph, o = $ec2fc4c0d7a3c6c6$var$morphGroups[t.group];
        if (void 0 !== o) {
            const e = o.queue.indexOf(t);
            -1 !== e && (o.queue = o.queue.filter((e)=>e !== t), 0 === o.queue.length && (void 0 !== o.cancel && o.cancel(), delete $ec2fc4c0d7a3c6c6$var$morphGroups[t.group]));
        }
        "add" === t.clsAction && e.classList.remove("q-morph--invisible"), delete e.__qmorph;
    }
});
const $ec2fc4c0d7a3c6c6$var$defaultCfg = {
    childList: !0,
    subtree: !0,
    attributes: !0,
    characterData: !0,
    attributeOldValue: !0,
    characterDataOldValue: !0
};
function $ec2fc4c0d7a3c6c6$var$update$2(e, t, o) {
    t.handler = o, void 0 !== t.observer && t.observer.disconnect(), t.observer = new MutationObserver((o)=>{
        if ("function" === typeof t.handler) {
            const n = t.handler(o);
            !1 !== n && !0 !== t.once || $ec2fc4c0d7a3c6c6$var$destroy(e);
        }
    }), t.observer.observe(e, t.opts);
}
function $ec2fc4c0d7a3c6c6$var$destroy(e) {
    const t = e.__qmutation;
    void 0 !== t && (void 0 !== t.observer && t.observer.disconnect(), delete e.__qmutation);
}
var $ec2fc4c0d7a3c6c6$export$17b8b19c814bcf56 = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "mutation",
    mounted (e, { modifiers: { once: t, ...o }, value: n }) {
        const a = {
            once: t,
            opts: 0 === Object.keys(o).length ? $ec2fc4c0d7a3c6c6$var$defaultCfg : o
        };
        $ec2fc4c0d7a3c6c6$var$update$2(e, a, n), e.__qmutation = a;
    },
    updated (e, { oldValue: t, value: o }) {
        const n = e.__qmutation;
        void 0 !== n && t !== o && $ec2fc4c0d7a3c6c6$var$update$2(e, n, o);
    },
    beforeUnmount: $ec2fc4c0d7a3c6c6$var$destroy
});
const { passive: $ec2fc4c0d7a3c6c6$var$passive } = $ec2fc4c0d7a3c6c6$var$listenOpts;
function $ec2fc4c0d7a3c6c6$var$update$1(e, { value: t, oldValue: o }) {
    "function" === typeof t ? (e.handler = t, "function" !== typeof o && (e.scrollTarget.addEventListener("scroll", e.scroll, $ec2fc4c0d7a3c6c6$var$passive), e.scroll())) : e.scrollTarget.removeEventListener("scroll", e.scroll, $ec2fc4c0d7a3c6c6$var$passive);
}
var $ec2fc4c0d7a3c6c6$export$b9ac1153598b004c = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "scroll-fire",
    mounted (e, t) {
        const o = {
            scrollTarget: $ec2fc4c0d7a3c6c6$var$getScrollTarget(e),
            scroll: $ec2fc4c0d7a3c6c6$export$61fc7d43ac8f84b0(()=>{
                let t, n;
                o.scrollTarget === window ? (n = e.getBoundingClientRect().bottom, t = window.innerHeight) : (n = $ec2fc4c0d7a3c6c6$var$offset(e).top + $ec2fc4c0d7a3c6c6$var$height(e), t = $ec2fc4c0d7a3c6c6$var$offset(o.scrollTarget).top + $ec2fc4c0d7a3c6c6$var$height(o.scrollTarget)), n > 0 && n < t && (o.scrollTarget.removeEventListener("scroll", o.scroll, $ec2fc4c0d7a3c6c6$var$passive), o.handler(e));
            }, 25)
        };
        $ec2fc4c0d7a3c6c6$var$update$1(o, t), e.__qscrollfire = o;
    },
    updated (e, t) {
        t.value !== t.oldValue && $ec2fc4c0d7a3c6c6$var$update$1(e.__qscrollfire, t);
    },
    beforeUnmount (e) {
        const t = e.__qscrollfire;
        t.scrollTarget.removeEventListener("scroll", t.scroll, $ec2fc4c0d7a3c6c6$var$passive), t.scroll.cancel(), delete e.__qscrollfire;
    }
});
function $ec2fc4c0d7a3c6c6$var$update(e, { value: t, oldValue: o }) {
    "function" === typeof t ? (e.handler = t, "function" !== typeof o && e.scrollTarget.addEventListener("scroll", e.scroll, $ec2fc4c0d7a3c6c6$var$listenOpts.passive)) : e.scrollTarget.removeEventListener("scroll", e.scroll, $ec2fc4c0d7a3c6c6$var$listenOpts.passive);
}
var $ec2fc4c0d7a3c6c6$export$6ed4a4084f55ee7c = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "scroll",
    mounted (e, t) {
        const o = {
            scrollTarget: $ec2fc4c0d7a3c6c6$var$getScrollTarget(e),
            scroll () {
                o.handler($ec2fc4c0d7a3c6c6$var$getVerticalScrollPosition(o.scrollTarget), $ec2fc4c0d7a3c6c6$var$getHorizontalScrollPosition(o.scrollTarget));
            }
        };
        $ec2fc4c0d7a3c6c6$var$update(o, t), e.__qscroll = o;
    },
    updated (e, t) {
        void 0 !== e.__qscroll && t.oldValue !== t.value && $ec2fc4c0d7a3c6c6$var$update(e.__qscroll, t);
    },
    beforeUnmount (e) {
        const t = e.__qscroll;
        t.scrollTarget.removeEventListener("scroll", t.scroll, $ec2fc4c0d7a3c6c6$var$listenOpts.passive), delete e.__qscroll;
    }
}), $ec2fc4c0d7a3c6c6$export$2490d726097e21c2 = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "touch-hold",
    beforeMount (e, t) {
        const { modifiers: o } = t;
        if (!0 !== o.mouse && !0 !== $ec2fc4c0d7a3c6c6$var$client.has.touch) return;
        const n = {
            handler: t.value,
            noop: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
            mouseStart (e) {
                "function" === typeof n.handler && !0 === $ec2fc4c0d7a3c6c6$var$leftClick(e) && ($ec2fc4c0d7a3c6c6$var$addEvt(n, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "passiveCapture"
                    ],
                    [
                        document,
                        "click",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), n.start(e, !0));
            },
            touchStart (e) {
                if (void 0 !== e.target && "function" === typeof n.handler) {
                    const t = e.target;
                    $ec2fc4c0d7a3c6c6$var$addEvt(n, "temp", [
                        [
                            t,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            t,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            t,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), n.start(e);
                }
            },
            start (e, t) {
                n.origin = $ec2fc4c0d7a3c6c6$var$position(e);
                const o = Date.now();
                !0 === $ec2fc4c0d7a3c6c6$var$client.is.mobile && (document.body.classList.add("non-selectable"), $ec2fc4c0d7a3c6c6$var$clearSelection(), n.styleCleanup = (e)=>{
                    n.styleCleanup = void 0;
                    const t = ()=>{
                        document.body.classList.remove("non-selectable");
                    };
                    !0 === e ? ($ec2fc4c0d7a3c6c6$var$clearSelection(), setTimeout(t, 10)) : t();
                }), n.triggered = !1, n.sensitivity = !0 === t ? n.mouseSensitivity : n.touchSensitivity, n.timer = setTimeout(()=>{
                    n.timer = void 0, $ec2fc4c0d7a3c6c6$var$clearSelection(), n.triggered = !0, n.handler({
                        evt: e,
                        touch: !0 !== t,
                        mouse: !0 === t,
                        position: n.origin,
                        duration: Date.now() - o
                    });
                }, n.duration);
            },
            move (e) {
                const { top: t, left: o } = $ec2fc4c0d7a3c6c6$var$position(e);
                void 0 !== n.timer && (Math.abs(o - n.origin.left) >= n.sensitivity || Math.abs(t - n.origin.top) >= n.sensitivity) && (clearTimeout(n.timer), n.timer = void 0);
            },
            end (e) {
                $ec2fc4c0d7a3c6c6$var$cleanEvt(n, "temp"), void 0 !== n.styleCleanup && n.styleCleanup(n.triggered), !0 === n.triggered ? void 0 !== e && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e) : void 0 !== n.timer && (clearTimeout(n.timer), n.timer = void 0);
            }
        }, a = [
            600,
            5,
            7
        ];
        if ("string" === typeof t.arg && 0 !== t.arg.length && t.arg.split(":").forEach((e, t)=>{
            const o = parseInt(e, 10);
            o && (a[t] = o);
        }), [n.duration, n.touchSensitivity, n.mouseSensitivity] = a, e.__qtouchhold = n, !0 === o.mouse) {
            const t = !0 === o.mouseCapture || !0 === o.mousecapture ? "Capture" : "";
            $ec2fc4c0d7a3c6c6$var$addEvt(n, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${t}`
                ]
            ]);
        }
        !0 === $ec2fc4c0d7a3c6c6$var$client.has.touch && $ec2fc4c0d7a3c6c6$var$addEvt(n, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${!0 === o.capture ? "Capture" : ""}`
            ],
            [
                e,
                "touchend",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (e, t) {
        const o = e.__qtouchhold;
        void 0 !== o && t.oldValue !== t.value && ("function" !== typeof t.value && o.end(), o.handler = t.value);
    },
    beforeUnmount (e) {
        const t = e.__qtouchhold;
        void 0 !== t && ($ec2fc4c0d7a3c6c6$var$cleanEvt(t, "main"), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "temp"), void 0 !== t.timer && clearTimeout(t.timer), void 0 !== t.styleCleanup && t.styleCleanup(), delete e.__qtouchhold);
    }
});
const $ec2fc4c0d7a3c6c6$var$keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [
        8,
        46
    ]
}, $ec2fc4c0d7a3c6c6$var$keyRegex = new RegExp(`^([\\d+]+|${Object.keys($ec2fc4c0d7a3c6c6$var$keyCodes).join("|")})$`, "i");
function $ec2fc4c0d7a3c6c6$var$shouldEnd(e, t) {
    const { top: o, left: n } = $ec2fc4c0d7a3c6c6$var$position(e);
    return Math.abs(n - t.left) >= 7 || Math.abs(o - t.top) >= 7;
}
var $ec2fc4c0d7a3c6c6$export$a86a7e2bfeca2b3f = $ec2fc4c0d7a3c6c6$var$createDirective({
    name: "touch-repeat",
    beforeMount (e, { modifiers: t, value: o, arg: n }) {
        const a = Object.keys(t).reduce((e, t)=>{
            if (!0 === $ec2fc4c0d7a3c6c6$var$keyRegex.test(t)) {
                const o = isNaN(parseInt(t, 10)) ? $ec2fc4c0d7a3c6c6$var$keyCodes[t.toLowerCase()] : parseInt(t, 10);
                o >= 0 && e.push(o);
            }
            return e;
        }, []);
        if (!0 !== t.mouse && !0 !== $ec2fc4c0d7a3c6c6$var$client.has.touch && 0 === a.length) return;
        const l = "string" === typeof n && 0 !== n.length ? n.split(":").map((e)=>parseInt(e, 10)) : [
            0,
            600,
            300
        ], i = l.length - 1, r = {
            keyboard: a,
            handler: o,
            noop: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
            mouseStart (e) {
                void 0 === r.event && "function" === typeof r.handler && !0 === $ec2fc4c0d7a3c6c6$var$leftClick(e) && ($ec2fc4c0d7a3c6c6$var$addEvt(r, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "passiveCapture"
                    ],
                    [
                        document,
                        "click",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), r.start(e, !0));
            },
            keyboardStart (t) {
                if ("function" === typeof r.handler && !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(t, a)) {
                    if ((0 === l[0] || void 0 !== r.event) && ($ec2fc4c0d7a3c6c6$var$stopAndPrevent(t), e.focus(), void 0 !== r.event)) return;
                    $ec2fc4c0d7a3c6c6$var$addEvt(r, "temp", [
                        [
                            document,
                            "keyup",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            document,
                            "click",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), r.start(t, !1, !0);
                }
            },
            touchStart (e) {
                if (void 0 !== e.target && "function" === typeof r.handler) {
                    const t = e.target;
                    $ec2fc4c0d7a3c6c6$var$addEvt(r, "temp", [
                        [
                            t,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            t,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            t,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), r.start(e);
                }
            },
            start (e, t, o) {
                function n(e) {
                    r.styleCleanup = void 0, document.documentElement.style.cursor = "";
                    const t = ()=>{
                        document.body.classList.remove("non-selectable");
                    };
                    !0 === e ? ($ec2fc4c0d7a3c6c6$var$clearSelection(), setTimeout(t, 10)) : t();
                }
                !0 !== o && (r.origin = $ec2fc4c0d7a3c6c6$var$position(e)), !0 === $ec2fc4c0d7a3c6c6$var$client.is.mobile && (document.body.classList.add("non-selectable"), $ec2fc4c0d7a3c6c6$var$clearSelection(), r.styleCleanup = n), r.event = {
                    touch: !0 !== t && !0 !== o,
                    mouse: !0 === t,
                    keyboard: !0 === o,
                    startTime: Date.now(),
                    repeatCount: 0
                };
                const a = ()=>{
                    if (r.timer = void 0, void 0 === r.event) return;
                    0 === r.event.repeatCount && (r.event.evt = e, !0 === o ? r.event.keyCode = e.keyCode : r.event.position = $ec2fc4c0d7a3c6c6$var$position(e), !0 !== $ec2fc4c0d7a3c6c6$var$client.is.mobile && (document.documentElement.style.cursor = "pointer", document.body.classList.add("non-selectable"), $ec2fc4c0d7a3c6c6$var$clearSelection(), r.styleCleanup = n)), r.event.duration = Date.now() - r.event.startTime, r.event.repeatCount += 1, r.handler(r.event);
                    const t = i < r.event.repeatCount ? i : r.event.repeatCount;
                    r.timer = setTimeout(a, l[t]);
                };
                0 === l[0] ? a() : r.timer = setTimeout(a, l[0]);
            },
            move (e) {
                void 0 !== r.event && void 0 !== r.timer && !0 === $ec2fc4c0d7a3c6c6$var$shouldEnd(e, r.origin) && (clearTimeout(r.timer), r.timer = void 0);
            },
            end (e) {
                void 0 !== r.event && (void 0 !== r.styleCleanup && r.styleCleanup(!0), void 0 !== e && r.event.repeatCount > 0 && $ec2fc4c0d7a3c6c6$var$stopAndPrevent(e), $ec2fc4c0d7a3c6c6$var$cleanEvt(r, "temp"), void 0 !== r.timer && (clearTimeout(r.timer), r.timer = void 0), r.event = void 0);
            }
        };
        if (e.__qtouchrepeat = r, !0 === t.mouse) {
            const o = !0 === t.mouseCapture || !0 === t.mousecapture ? "Capture" : "";
            $ec2fc4c0d7a3c6c6$var$addEvt(r, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${o}`
                ]
            ]);
        }
        if (!0 === $ec2fc4c0d7a3c6c6$var$client.has.touch && $ec2fc4c0d7a3c6c6$var$addEvt(r, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${!0 === t.capture ? "Capture" : ""}`
            ],
            [
                e,
                "touchend",
                "noop",
                "passiveCapture"
            ]
        ]), 0 !== a.length) {
            const o = !0 === t.keyCapture || !0 === t.keycapture ? "Capture" : "";
            $ec2fc4c0d7a3c6c6$var$addEvt(r, "main", [
                [
                    e,
                    "keydown",
                    "keyboardStart",
                    `notPassive${o}`
                ]
            ]);
        }
    },
    updated (e, { oldValue: t, value: o }) {
        const n = e.__qtouchrepeat;
        void 0 !== n && t !== o && ("function" !== typeof o && n.end(), n.handler = o);
    },
    beforeUnmount (e) {
        const t = e.__qtouchrepeat;
        void 0 !== t && (void 0 !== t.timer && clearTimeout(t.timer), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "main"), $ec2fc4c0d7a3c6c6$var$cleanEvt(t, "temp"), void 0 !== t.styleCleanup && t.styleCleanup(), delete e.__qtouchrepeat);
    }
}), $ec2fc4c0d7a3c6c6$var$directives = Object.freeze({
    __proto__: null,
    ClosePopup: $ec2fc4c0d7a3c6c6$export$5e283f024fc297b1,
    Intersection: $ec2fc4c0d7a3c6c6$export$869c896bf338bf5a,
    Morph: $ec2fc4c0d7a3c6c6$export$24a95a7694c627b7,
    Mutation: $ec2fc4c0d7a3c6c6$export$17b8b19c814bcf56,
    Ripple: $ec2fc4c0d7a3c6c6$export$9e9146f7e027fdaa,
    ScrollFire: $ec2fc4c0d7a3c6c6$export$b9ac1153598b004c,
    Scroll: $ec2fc4c0d7a3c6c6$export$6ed4a4084f55ee7c,
    TouchHold: $ec2fc4c0d7a3c6c6$export$2490d726097e21c2,
    TouchPan: $ec2fc4c0d7a3c6c6$export$718797250d1e376,
    TouchRepeat: $ec2fc4c0d7a3c6c6$export$a86a7e2bfeca2b3f,
    TouchSwipe: $ec2fc4c0d7a3c6c6$export$945da4db66eba3a1
});
function $ec2fc4c0d7a3c6c6$export$57e6a6d9b8e425d7(e, t = document.body) {
    if ("string" !== typeof e) throw new TypeError("Expected a string as propName");
    if (!(t instanceof Element)) throw new TypeError("Expected a DOM element");
    return getComputedStyle(t).getPropertyValue(`--q-${e}`).trim() || null;
}
let $ec2fc4c0d7a3c6c6$var$metaValue;
function $ec2fc4c0d7a3c6c6$var$getProp() {
    return $ec2fc4c0d7a3c6c6$var$client.is.winphone ? "msapplication-navbutton-color" : $ec2fc4c0d7a3c6c6$var$client.is.safari ? "apple-mobile-web-app-status-bar-style" : "theme-color";
}
function $ec2fc4c0d7a3c6c6$var$getMetaTag(e) {
    const t = document.getElementsByTagName("META");
    for(const o in t)if (t[o].name === e) return t[o];
}
function $ec2fc4c0d7a3c6c6$var$setColor(e) {
    void 0 === $ec2fc4c0d7a3c6c6$var$metaValue && ($ec2fc4c0d7a3c6c6$var$metaValue = $ec2fc4c0d7a3c6c6$var$getProp());
    let t = $ec2fc4c0d7a3c6c6$var$getMetaTag($ec2fc4c0d7a3c6c6$var$metaValue);
    const o = void 0 === t;
    o && (t = document.createElement("meta"), t.setAttribute("name", $ec2fc4c0d7a3c6c6$var$metaValue)), t.setAttribute("content", e), o && document.head.appendChild(t);
}
var $ec2fc4c0d7a3c6c6$export$7e8bbd192bc25721 = {
    set: !0 !== $ec2fc4c0d7a3c6c6$var$client.is.mobile || !0 !== $ec2fc4c0d7a3c6c6$var$client.is.nativeMobile && !0 !== $ec2fc4c0d7a3c6c6$var$client.is.winphone && !0 !== $ec2fc4c0d7a3c6c6$var$client.is.safari && !0 !== $ec2fc4c0d7a3c6c6$var$client.is.webkit && !0 !== $ec2fc4c0d7a3c6c6$var$client.is.vivaldi ? $ec2fc4c0d7a3c6c6$export$8793edee2d425525 : (e)=>{
        const t = e || $ec2fc4c0d7a3c6c6$export$57e6a6d9b8e425d7("primary");
        !0 === $ec2fc4c0d7a3c6c6$var$client.is.nativeMobile && window.StatusBar ? window.StatusBar.backgroundColorByHexString(t) : $ec2fc4c0d7a3c6c6$var$setColor(t);
    },
    install ({ $q: e }) {
        e.addressbarColor = this, e.config.addressbarColor && this.set(e.config.addressbarColor);
    }
};
const $ec2fc4c0d7a3c6c6$var$prefixes = {};
function $ec2fc4c0d7a3c6c6$var$assignFn(e) {
    Object.assign($ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635, {
        request: e,
        exit: e,
        toggle: e
    });
}
function $ec2fc4c0d7a3c6c6$var$getFullscreenElement() {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function $ec2fc4c0d7a3c6c6$var$updateEl() {
    const e = $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.activeEl = !1 === $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive ? null : $ec2fc4c0d7a3c6c6$var$getFullscreenElement();
    $ec2fc4c0d7a3c6c6$var$changeGlobalNodesTarget(null === e || e === document.documentElement ? document.body : e);
}
function $ec2fc4c0d7a3c6c6$var$togglePluginState() {
    $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive = !1 === $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive, $ec2fc4c0d7a3c6c6$var$updateEl();
}
function $ec2fc4c0d7a3c6c6$var$promisify(e, t) {
    try {
        const o = e[t]();
        return void 0 === o ? Promise.resolve() : o;
    } catch (e) {
        return Promise.reject(e);
    }
}
const $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635 = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    isActive: !1,
    activeEl: null
}, {
    isCapable: !1,
    install ({ $q: e }) {
        e.fullscreen = this;
    }
});
$ec2fc4c0d7a3c6c6$var$prefixes.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
].find((e)=>void 0 !== document.documentElement[e]), $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isCapable = void 0 !== $ec2fc4c0d7a3c6c6$var$prefixes.request, !1 === $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isCapable ? $ec2fc4c0d7a3c6c6$var$assignFn(()=>Promise.reject("Not capable")) : (Object.assign($ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635, {
    request (e) {
        const t = e || document.documentElement, { activeEl: o } = $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635;
        if (t === o) return Promise.resolve();
        const n = null !== o && !0 === t.contains(o) ? $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.exit() : Promise.resolve();
        return n.finally(()=>$ec2fc4c0d7a3c6c6$var$promisify(t, $ec2fc4c0d7a3c6c6$var$prefixes.request));
    },
    exit () {
        return !0 === $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive ? $ec2fc4c0d7a3c6c6$var$promisify(document, $ec2fc4c0d7a3c6c6$var$prefixes.exit) : Promise.resolve();
    },
    toggle (e) {
        return !0 === $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive ? $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.exit() : $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.request(e);
    }
}), $ec2fc4c0d7a3c6c6$var$prefixes.exit = [
    "exitFullscreen",
    "msExitFullscreen",
    "mozCancelFullScreen",
    "webkitExitFullscreen"
].find((e)=>document[e]), $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive = Boolean($ec2fc4c0d7a3c6c6$var$getFullscreenElement()), !0 === $ec2fc4c0d7a3c6c6$export$ef7fdd8c6fbd4635.isActive && $ec2fc4c0d7a3c6c6$var$updateEl(), [
    "onfullscreenchange",
    "onmsfullscreenchange",
    "onwebkitfullscreenchange"
].forEach((e)=>{
    document[e] = $ec2fc4c0d7a3c6c6$var$togglePluginState;
}));
const $ec2fc4c0d7a3c6c6$export$1aceaed33e7eed17 = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    appVisible: !0
}, {
    install ({ $q: e }) {
        $ec2fc4c0d7a3c6c6$var$injectProp(e, "appVisible", ()=>this.appVisible);
    }
});
{
    let e, t;
    if ("undefined" !== typeof document.hidden ? (e = "hidden", t = "visibilitychange") : "undefined" !== typeof document.msHidden ? (e = "msHidden", t = "msvisibilitychange") : "undefined" !== typeof document.webkitHidden && (e = "webkitHidden", t = "webkitvisibilitychange"), t && "undefined" !== typeof document[e]) {
        const o = ()=>{
            $ec2fc4c0d7a3c6c6$export$1aceaed33e7eed17.appVisible = !document[e];
        };
        document.addEventListener(t, o, !1);
    }
}var $ec2fc4c0d7a3c6c6$var$BottomSheet$1 = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "BottomSheetPlugin",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        title: String,
        message: String,
        actions: Array,
        grid: Boolean,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    },
    emits: [
        "ok",
        "hide"
    ],
    setup (e, { emit: t }) {
        const { proxy: o } = (0, $TusQn.getCurrentInstance)(), n = $ec2fc4c0d7a3c6c6$var$useDark(e, o.$q), a = (0, $01W3b.ref)(null);
        function l() {
            a.value.show();
        }
        function i() {
            a.value.hide();
        }
        function r(e) {
            t("ok", e), i();
        }
        function s() {
            t("hide");
        }
        function u() {
            return e.actions.map((e)=>{
                const t = e.avatar || e.img;
                return void 0 === e.label ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                    class: "col-all",
                    dark: n.value
                }) : (0, $TusQn.h)("div", {
                    class: [
                        "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
                        e.class
                    ],
                    style: e.style,
                    tabindex: 0,
                    role: "listitem",
                    onClick () {
                        r(e);
                    },
                    onKeyup (t) {
                        13 === t.keyCode && r(e);
                    }
                }, [
                    (0, $TusQn.h)("div", {
                        class: "q-focus-helper"
                    }),
                    e.icon ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                        name: e.icon,
                        color: e.color
                    }) : t ? (0, $TusQn.h)("img", {
                        class: e.avatar ? "q-bottom-sheet__avatar" : "",
                        src: t
                    }) : (0, $TusQn.h)("div", {
                        class: "q-bottom-sheet__empty-icon"
                    }),
                    (0, $TusQn.h)("div", e.label)
                ]);
            });
        }
        function c() {
            return e.actions.map((e)=>{
                const t = e.avatar || e.img;
                return void 0 === e.label ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                    spaced: !0,
                    dark: n.value
                }) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$adf75769807ad87e, {
                    class: [
                        "q-bottom-sheet__item",
                        e.classes
                    ],
                    style: e.style,
                    tabindex: 0,
                    clickable: !0,
                    dark: n.value,
                    onClick () {
                        r(e);
                    }
                }, ()=>[
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, {
                            avatar: !0
                        }, ()=>e.icon ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                                name: e.icon,
                                color: e.color
                            }) : t ? (0, $TusQn.h)("img", {
                                class: e.avatar ? "q-bottom-sheet__avatar" : "",
                                src: t
                            }) : null),
                        (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$9579d29612d4e773, ()=>e.label)
                    ]);
            });
        }
        function d() {
            const t = [];
            return e.title && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: "q-dialog__title"
            }, ()=>e.title)), e.message && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: "q-dialog__message"
            }, ()=>e.message)), t.push(!0 === e.grid ? (0, $TusQn.h)("div", {
                class: "row items-stretch justify-start",
                role: "list"
            }, u()) : (0, $TusQn.h)("div", {
                role: "list"
            }, c())), t;
        }
        function p() {
            return [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$866037ffbc2a7c62, {
                    class: [
                        `q-bottom-sheet q-bottom-sheet--${!0 === e.grid ? "grid" : "list"}` + (!0 === n.value ? " q-bottom-sheet--dark q-dark" : ""),
                        e.cardClass
                    ],
                    style: e.cardStyle
                }, d)
            ];
        }
        return Object.assign(o, {
            show: l,
            hide: i
        }), ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$e6ccdac5fb3e2417, {
                ref: a,
                position: "bottom",
                onHide: s
            }, p);
    }
});
function $ec2fc4c0d7a3c6c6$var$merge(e, t) {
    for(const o in t)"spinner" !== o && Object(t[o]) === t[o] ? (e[o] = Object(e[o]) !== e[o] ? {} : {
        ...e[o]
    }, $ec2fc4c0d7a3c6c6$var$merge(e[o], t[o])) : e[o] = t[o];
}
function $ec2fc4c0d7a3c6c6$var$globalDialog(e, t, o) {
    return (n)=>{
        let a, l;
        const i = !0 === t && void 0 !== n.component;
        if (!0 === i) {
            const { component: e, componentProps: t } = n;
            a = "string" === typeof e ? o.component(e) : e, l = t || {};
        } else {
            const { class: t, style: o, ...i } = n;
            a = e, l = i, void 0 !== t && (i.cardClass = t), void 0 !== o && (i.cardStyle = o);
        }
        let r, s = !1;
        const u = (0, $01W3b.ref)(null), c = $ec2fc4c0d7a3c6c6$var$createGlobalNode(!1, "dialog"), d = (e)=>{
            if (null !== u.value && void 0 !== u.value[e]) return void u.value[e]();
            const t = r.$.subTree;
            if (t && t.component) {
                if (t.component.proxy && t.component.proxy[e]) return void t.component.proxy[e]();
                if (t.component.subTree && t.component.subTree.component && t.component.subTree.component.proxy && t.component.subTree.component.proxy[e]) return void t.component.subTree.component.proxy[e]();
            }
            console.error("[Quasar] Incorrectly defined Dialog component");
        }, p = [], v = [], m = {
            onOk (e) {
                return p.push(e), m;
            },
            onCancel (e) {
                return v.push(e), m;
            },
            onDismiss (e) {
                return p.push(e), v.push(e), m;
            },
            hide () {
                return d("hide"), m;
            },
            update (e) {
                if (null !== r) {
                    if (!0 === i) Object.assign(l, e);
                    else {
                        const { class: t, style: o, ...n } = e;
                        void 0 !== t && (n.cardClass = t), void 0 !== o && (n.cardStyle = o), $ec2fc4c0d7a3c6c6$var$merge(l, n);
                    }
                    r.$forceUpdate();
                }
                return m;
            }
        }, f = (e)=>{
            s = !0, p.forEach((t)=>{
                t(e);
            });
        }, g = ()=>{
            b.unmount(c), $ec2fc4c0d7a3c6c6$var$removeGlobalNode(c), b = null, r = null, !0 !== s && v.forEach((e)=>{
                e();
            });
        };
        let b = $ec2fc4c0d7a3c6c6$var$createChildApp({
            name: "QGlobalDialog",
            setup: ()=>()=>(0, $TusQn.h)(a, {
                        ...l,
                        ref: u,
                        onOk: f,
                        onHide: g,
                        onVnodeMounted (...e) {
                            "function" === typeof l.onVnodeMounted && l.onVnodeMounted(...e), (0, $TusQn.nextTick)(()=>d("show"));
                        }
                    })
        }, o);
        return r = b.mount(c), m;
    };
}
var $ec2fc4c0d7a3c6c6$export$2058ef1a26004a97 = {
    install ({ $q: e, parentApp: t }) {
        e.bottomSheet = $ec2fc4c0d7a3c6c6$var$globalDialog($ec2fc4c0d7a3c6c6$var$BottomSheet$1, !1, t), !0 !== this.__installed && (this.create = e.bottomSheet);
    }
};
function $ec2fc4c0d7a3c6c6$var$encode$1(e) {
    return encodeURIComponent(e);
}
function $ec2fc4c0d7a3c6c6$var$decode$1(e) {
    return decodeURIComponent(e);
}
function $ec2fc4c0d7a3c6c6$var$stringifyCookieValue(e) {
    return $ec2fc4c0d7a3c6c6$var$encode$1(e === Object(e) ? JSON.stringify(e) : "" + e);
}
function $ec2fc4c0d7a3c6c6$var$read(e) {
    if ("" === e) return e;
    0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\")), e = $ec2fc4c0d7a3c6c6$var$decode$1(e.replace(/\+/g, " "));
    try {
        const t = JSON.parse(e);
        t !== Object(t) && !0 !== Array.isArray(t) || (e = t);
    } catch (e) {}
    return e;
}
function $ec2fc4c0d7a3c6c6$var$getString(e) {
    const t = new Date;
    return t.setMilliseconds(t.getMilliseconds() + e), t.toUTCString();
}
function $ec2fc4c0d7a3c6c6$var$parseExpireString(e) {
    let t = 0;
    const o = e.match(/(\d+)d/), n = e.match(/(\d+)h/), a = e.match(/(\d+)m/), l = e.match(/(\d+)s/);
    return o && (t += 864e5 * o[1]), n && (t += 36e5 * n[1]), a && (t += 6e4 * a[1]), l && (t += 1e3 * l[1]), 0 === t ? e : $ec2fc4c0d7a3c6c6$var$getString(t);
}
function $ec2fc4c0d7a3c6c6$var$set(e, t, o = {}, n) {
    let a, l;
    void 0 !== o.expires && ("[object Date]" === Object.prototype.toString.call(o.expires) ? a = o.expires.toUTCString() : "string" === typeof o.expires ? a = $ec2fc4c0d7a3c6c6$var$parseExpireString(o.expires) : (l = parseFloat(o.expires), a = !1 === isNaN(l) ? $ec2fc4c0d7a3c6c6$var$getString(864e5 * l) : o.expires));
    const i = `${$ec2fc4c0d7a3c6c6$var$encode$1(e)}=${$ec2fc4c0d7a3c6c6$var$stringifyCookieValue(t)}`, r = [
        i,
        void 0 !== a ? "; Expires=" + a : "",
        o.path ? "; Path=" + o.path : "",
        o.domain ? "; Domain=" + o.domain : "",
        o.sameSite ? "; SameSite=" + o.sameSite : "",
        o.httpOnly ? "; HttpOnly" : "",
        o.secure ? "; Secure" : "",
        o.other ? "; " + o.other : ""
    ].join("");
    if (n) {
        n.req.qCookies ? n.req.qCookies.push(r) : n.req.qCookies = [
            r
        ], n.res.setHeader("Set-Cookie", n.req.qCookies);
        let t = n.req.headers.cookie || "";
        if (void 0 !== a && l < 0) {
            const o = $ec2fc4c0d7a3c6c6$var$get(e, n);
            void 0 !== o && (t = t.replace(`${e}=${o}; `, "").replace(`; ${e}=${o}`, "").replace(`${e}=${o}`, ""));
        } else t = t ? `${i}; ${t}` : r;
        n.req.headers.cookie = t;
    } else document.cookie = r;
}
function $ec2fc4c0d7a3c6c6$var$get(e, t) {
    const o = t ? t.req.headers : document, n = o.cookie ? o.cookie.split("; ") : [], a = n.length;
    let l, i, r, s = e ? null : {}, u = 0;
    for(; u < a; u++)if (l = n[u].split("="), i = $ec2fc4c0d7a3c6c6$var$decode$1(l.shift()), r = l.join("="), e) {
        if (e === i) {
            s = $ec2fc4c0d7a3c6c6$var$read(r);
            break;
        }
    } else s[i] = r;
    return s;
}
function $ec2fc4c0d7a3c6c6$var$remove(e, t, o) {
    $ec2fc4c0d7a3c6c6$var$set(e, "", {
        expires: -1,
        ...t
    }, o);
}
function $ec2fc4c0d7a3c6c6$var$has(e, t) {
    return null !== $ec2fc4c0d7a3c6c6$var$get(e, t);
}
function $ec2fc4c0d7a3c6c6$var$getObject(e) {
    return {
        get: (t)=>$ec2fc4c0d7a3c6c6$var$get(t, e),
        set: (t, o, n)=>$ec2fc4c0d7a3c6c6$var$set(t, o, n, e),
        has: (t)=>$ec2fc4c0d7a3c6c6$var$has(t, e),
        remove: (t, o)=>$ec2fc4c0d7a3c6c6$var$remove(t, o, e),
        getAll: ()=>$ec2fc4c0d7a3c6c6$var$get(null, e)
    };
}
const $ec2fc4c0d7a3c6c6$export$3a9db9793503eddb = {
    install ({ $q: e, ssrContext: t }) {
        e.cookies = this;
    }
};
Object.assign($ec2fc4c0d7a3c6c6$export$3a9db9793503eddb, $ec2fc4c0d7a3c6c6$var$getObject());
var $ec2fc4c0d7a3c6c6$var$DialogPlugin = $ec2fc4c0d7a3c6c6$var$createComponent({
    name: "DialogPlugin",
    props: {
        ...$ec2fc4c0d7a3c6c6$var$useDarkProps,
        title: String,
        message: String,
        prompt: Object,
        options: Object,
        progress: [
            Boolean,
            Object
        ],
        html: Boolean,
        ok: {
            type: [
                String,
                Object,
                Boolean
            ],
            default: !0
        },
        cancel: [
            String,
            Object,
            Boolean
        ],
        focus: {
            type: String,
            default: "ok",
            validator: (e)=>[
                    "ok",
                    "cancel",
                    "none"
                ].includes(e)
        },
        stackButtons: Boolean,
        color: String,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    },
    emits: [
        "ok",
        "hide"
    ],
    setup (e, { emit: t }) {
        const { proxy: o } = (0, $TusQn.getCurrentInstance)(), { $q: n } = o, a = $ec2fc4c0d7a3c6c6$var$useDark(e, n), l = (0, $01W3b.ref)(null), i = (0, $01W3b.ref)(void 0 !== e.prompt ? e.prompt.model : void 0 !== e.options ? e.options.model : void 0), r = (0, $TusQn.computed)(()=>"q-dialog-plugin" + (!0 === a.value ? " q-dialog-plugin--dark q-dark" : "") + (!1 !== e.progress ? " q-dialog-plugin--progress" : "")), s = (0, $TusQn.computed)(()=>e.color || (!0 === a.value ? "amber" : "primary")), u = (0, $TusQn.computed)(()=>!1 === e.progress ? null : !0 === $ec2fc4c0d7a3c6c6$var$isObject(e.progress) ? {
                component: e.progress.spinner || $ec2fc4c0d7a3c6c6$export$7418ab329b11fed0,
                props: {
                    color: e.progress.color || s.value
                }
            } : {
                component: $ec2fc4c0d7a3c6c6$export$7418ab329b11fed0,
                props: {
                    color: s.value
                }
            }), c = (0, $TusQn.computed)(()=>void 0 !== e.prompt || void 0 !== e.options), d = (0, $TusQn.computed)(()=>{
            if (!0 !== c.value) return {};
            const { model: t, isValid: o, items: n, ...a } = void 0 !== e.prompt ? e.prompt : e.options;
            return a;
        }), p = (0, $TusQn.computed)(()=>!0 === $ec2fc4c0d7a3c6c6$var$isObject(e.ok) ? n.lang.label.ok : !0 === e.ok ? n.lang.label.ok : e.ok), v = (0, $TusQn.computed)(()=>!0 === $ec2fc4c0d7a3c6c6$var$isObject(e.cancel) ? n.lang.label.cancel : !0 === e.cancel ? n.lang.label.cancel : e.cancel), m = (0, $TusQn.computed)(()=>{
            return void 0 !== e.prompt ? void 0 !== e.prompt.isValid && !0 !== e.prompt.isValid(i.value) : void 0 !== e.options && void 0 !== e.options.isValid && !0 !== e.options.isValid(i.value);
        }), f = (0, $TusQn.computed)(()=>({
                color: s.value,
                label: p.value,
                ripple: !1,
                disable: m.value,
                ...!0 === $ec2fc4c0d7a3c6c6$var$isObject(e.ok) ? e.ok : {
                    flat: !0
                },
                "data-autofocus": "ok" === e.focus && !0 !== c.value || void 0,
                onClick: S
            })), g = (0, $TusQn.computed)(()=>({
                color: s.value,
                label: v.value,
                ripple: !1,
                ...!0 === $ec2fc4c0d7a3c6c6$var$isObject(e.cancel) ? e.cancel : {
                    flat: !0
                },
                "data-autofocus": "cancel" === e.focus && !0 !== c.value || void 0,
                onClick: w
            }));
        function b() {
            l.value.show();
        }
        function y() {
            l.value.hide();
        }
        function S() {
            t("ok", (0, $01W3b.toRaw)(i.value)), y();
        }
        function w() {
            y();
        }
        function C() {
            t("hide");
        }
        function x(e) {
            i.value = e;
        }
        function k(t) {
            !0 !== m.value && "textarea" !== e.prompt.type && !0 === $ec2fc4c0d7a3c6c6$var$isKeyCode(t, 13) && S();
        }
        function _(t, o) {
            return !0 === e.html ? (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: t,
                innerHTML: o
            }) : (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: t
            }, ()=>o);
        }
        function q() {
            return [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$b1c6a0c22e16b328, {
                    color: s.value,
                    dense: !0,
                    autofocus: !0,
                    dark: a.value,
                    ...d.value,
                    modelValue: i.value,
                    "onUpdate:modelValue": x,
                    onKeyup: k
                })
            ];
        }
        function T() {
            return [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$3ceb287b9597da0e, {
                    color: s.value,
                    options: e.options.items,
                    dark: a.value,
                    ...d.value,
                    modelValue: i.value,
                    "onUpdate:modelValue": x
                })
            ];
        }
        function P() {
            const t = [];
            return e.cancel && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, g.value)), e.ok && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, f.value)), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$8c05ea70037eac6a, {
                class: !0 === e.stackButtons ? "items-end" : "",
                vertical: e.stackButtons,
                align: "right"
            }, ()=>t);
        }
        function $() {
            const t = [];
            return e.title && t.push(_("q-dialog__title", e.title)), !1 !== e.progress && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: "q-dialog__progress"
            }, ()=>(0, $TusQn.h)(u.value.component, u.value.props))), e.message && t.push(_("q-dialog__message", e.message)), void 0 !== e.prompt ? t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: "scroll q-dialog-plugin__form"
            }, q)) : void 0 !== e.options && t.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                dark: a.value
            }), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$653482776a1a6c98, {
                class: "scroll q-dialog-plugin__form"
            }, T), (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$a3fe6e564278fbe9, {
                dark: a.value
            })), (e.ok || e.cancel) && t.push(P()), t;
        }
        function M() {
            return [
                (0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$866037ffbc2a7c62, {
                    class: [
                        r.value,
                        e.cardClass
                    ],
                    style: e.cardStyle,
                    dark: a.value
                }, $)
            ];
        }
        return (0, $TusQn.watch)(()=>e.prompt && e.prompt.model, x), (0, $TusQn.watch)(()=>e.options && e.options.model, x), Object.assign(o, {
            show: b,
            hide: y
        }), ()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$e6ccdac5fb3e2417, {
                ref: l,
                onHide: C
            }, M);
    }
}), $ec2fc4c0d7a3c6c6$export$3ddf2d174ce01153 = {
    install ({ $q: e, parentApp: t }) {
        e.dialog = $ec2fc4c0d7a3c6c6$var$globalDialog($ec2fc4c0d7a3c6c6$var$DialogPlugin, !0, t), !0 !== this.__installed && (this.create = e.dialog);
    }
};
const $ec2fc4c0d7a3c6c6$var$barRef = (0, $01W3b.ref)(null), $ec2fc4c0d7a3c6c6$export$6665614bc5d690f6 = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    isActive: !1
}, {
    start: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    stop: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    increment: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    setDefaults: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
    install ({ $q: e, parentApp: t }) {
        if (e.loadingBar = this, !0 === this.__installed) return void (void 0 !== e.config.loadingBar && this.setDefaults(e.config.loadingBar));
        const o = (0, $01W3b.ref)(void 0 !== e.config.loadingBar ? {
            ...e.config.loadingBar
        } : {});
        function n() {
            $ec2fc4c0d7a3c6c6$export$6665614bc5d690f6.isActive = !0;
        }
        function a() {
            $ec2fc4c0d7a3c6c6$export$6665614bc5d690f6.isActive = !1;
        }
        const l = $ec2fc4c0d7a3c6c6$var$createGlobalNode("q-loading-bar");
        $ec2fc4c0d7a3c6c6$var$createChildApp({
            name: "LoadingBar",
            devtools: {
                hide: !0
            },
            setup: ()=>()=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$b18d87171d171ca9, {
                        ...o.value,
                        onStart: n,
                        onStop: a,
                        ref: $ec2fc4c0d7a3c6c6$var$barRef
                    })
        }, t).mount(l), Object.assign(this, {
            start (e) {
                $ec2fc4c0d7a3c6c6$var$barRef.value.start(e);
            },
            stop () {
                $ec2fc4c0d7a3c6c6$var$barRef.value.stop();
            },
            increment () {
                $ec2fc4c0d7a3c6c6$var$barRef.value.increment.apply(null, arguments);
            },
            setDefaults (e) {
                !0 === $ec2fc4c0d7a3c6c6$var$isObject(e) && Object.assign(o.value, e);
            }
        });
    }
});
let $ec2fc4c0d7a3c6c6$var$app, $ec2fc4c0d7a3c6c6$var$vm, $ec2fc4c0d7a3c6c6$var$uid$1 = 0, $ec2fc4c0d7a3c6c6$var$timeout = null, $ec2fc4c0d7a3c6c6$var$props = {}, $ec2fc4c0d7a3c6c6$var$activeGroups = {};
const $ec2fc4c0d7a3c6c6$var$originalDefaults = {
    group: "__default_quasar_group__",
    delay: 0,
    message: !1,
    html: !1,
    spinnerSize: 80,
    spinnerColor: "",
    messageColor: "",
    backgroundColor: "",
    boxClass: "",
    spinner: $ec2fc4c0d7a3c6c6$export$7418ab329b11fed0,
    customClass: ""
}, $ec2fc4c0d7a3c6c6$var$defaults$1 = {
    ...$ec2fc4c0d7a3c6c6$var$originalDefaults
};
function $ec2fc4c0d7a3c6c6$var$registerProps(e) {
    if (e && void 0 !== e.group && void 0 !== $ec2fc4c0d7a3c6c6$var$activeGroups[e.group]) return Object.assign($ec2fc4c0d7a3c6c6$var$activeGroups[e.group], e);
    const t = !0 === $ec2fc4c0d7a3c6c6$var$isObject(e) && !0 === e.ignoreDefaults ? {
        ...$ec2fc4c0d7a3c6c6$var$originalDefaults,
        ...e
    } : {
        ...$ec2fc4c0d7a3c6c6$var$defaults$1,
        ...e
    };
    return $ec2fc4c0d7a3c6c6$var$activeGroups[t.group] = t, t;
}
const $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf = $ec2fc4c0d7a3c6c6$var$defineReactivePlugin({
    isActive: !1
}, {
    show (e) {
        $ec2fc4c0d7a3c6c6$var$props = $ec2fc4c0d7a3c6c6$var$registerProps(e);
        const { group: t } = $ec2fc4c0d7a3c6c6$var$props;
        return $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.isActive = !0, void 0 !== $ec2fc4c0d7a3c6c6$var$app ? ($ec2fc4c0d7a3c6c6$var$props.uid = $ec2fc4c0d7a3c6c6$var$uid$1, $ec2fc4c0d7a3c6c6$var$vm.$forceUpdate()) : ($ec2fc4c0d7a3c6c6$var$props.uid = ++$ec2fc4c0d7a3c6c6$var$uid$1, null !== $ec2fc4c0d7a3c6c6$var$timeout && clearTimeout($ec2fc4c0d7a3c6c6$var$timeout), $ec2fc4c0d7a3c6c6$var$timeout = setTimeout(()=>{
            $ec2fc4c0d7a3c6c6$var$timeout = null;
            const e = $ec2fc4c0d7a3c6c6$var$createGlobalNode("q-loading");
            $ec2fc4c0d7a3c6c6$var$app = $ec2fc4c0d7a3c6c6$var$createChildApp({
                name: "QLoading",
                setup () {
                    function t() {
                        !0 !== $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.isActive && void 0 !== $ec2fc4c0d7a3c6c6$var$app && ($ec2fc4c0d7a3c6c6$var$preventScroll(!1), $ec2fc4c0d7a3c6c6$var$app.unmount(e), $ec2fc4c0d7a3c6c6$var$removeGlobalNode(e), $ec2fc4c0d7a3c6c6$var$app = void 0, $ec2fc4c0d7a3c6c6$var$vm = void 0);
                    }
                    function o() {
                        if (!0 !== $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.isActive) return null;
                        const e = [
                            (0, $TusQn.h)($ec2fc4c0d7a3c6c6$var$props.spinner, {
                                class: "q-loading__spinner",
                                color: $ec2fc4c0d7a3c6c6$var$props.spinnerColor,
                                size: $ec2fc4c0d7a3c6c6$var$props.spinnerSize
                            })
                        ];
                        return $ec2fc4c0d7a3c6c6$var$props.message && e.push((0, $TusQn.h)("div", {
                            class: "q-loading__message" + ($ec2fc4c0d7a3c6c6$var$props.messageColor ? ` text-${$ec2fc4c0d7a3c6c6$var$props.messageColor}` : ""),
                            [!0 === $ec2fc4c0d7a3c6c6$var$props.html ? "innerHTML" : "textContent"]: $ec2fc4c0d7a3c6c6$var$props.message
                        })), (0, $TusQn.h)("div", {
                            class: "q-loading fullscreen flex flex-center z-max " + $ec2fc4c0d7a3c6c6$var$props.customClass.trim(),
                            key: $ec2fc4c0d7a3c6c6$var$props.uid
                        }, [
                            (0, $TusQn.h)("div", {
                                class: "q-loading__backdrop" + ($ec2fc4c0d7a3c6c6$var$props.backgroundColor ? ` bg-${$ec2fc4c0d7a3c6c6$var$props.backgroundColor}` : "")
                            }),
                            (0, $TusQn.h)("div", {
                                class: "q-loading__box column items-center " + $ec2fc4c0d7a3c6c6$var$props.boxClass
                            }, e)
                        ]);
                    }
                    return (0, $TusQn.onMounted)(()=>{
                        $ec2fc4c0d7a3c6c6$var$preventScroll(!0);
                    }), ()=>(0, $TusQn.h)((0, $eeJ70.Transition), {
                            name: "q-transition--fade",
                            appear: !0,
                            onAfterLeave: t
                        }, o);
                }
            }, $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.__parentApp), $ec2fc4c0d7a3c6c6$var$vm = $ec2fc4c0d7a3c6c6$var$app.mount(e);
        }, $ec2fc4c0d7a3c6c6$var$props.delay)), (e)=>{
            void 0 !== e && Object(e) === e ? $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.show({
                ...e,
                group: t
            }) : $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.hide(t);
        };
    },
    hide (e) {
        if (!0 === $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.isActive) {
            if (void 0 === e) $ec2fc4c0d7a3c6c6$var$activeGroups = {};
            else {
                if (void 0 === $ec2fc4c0d7a3c6c6$var$activeGroups[e]) return;
                {
                    delete $ec2fc4c0d7a3c6c6$var$activeGroups[e];
                    const t = Object.keys($ec2fc4c0d7a3c6c6$var$activeGroups);
                    if (0 !== t.length) {
                        const e = t[t.length - 1];
                        return void $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.show({
                            group: e
                        });
                    }
                }
            }
            null !== $ec2fc4c0d7a3c6c6$var$timeout && (clearTimeout($ec2fc4c0d7a3c6c6$var$timeout), $ec2fc4c0d7a3c6c6$var$timeout = null), $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.isActive = !1;
        }
    },
    setDefaults (e) {
        !0 === $ec2fc4c0d7a3c6c6$var$isObject(e) && Object.assign($ec2fc4c0d7a3c6c6$var$defaults$1, e);
    },
    install ({ $q: e, parentApp: t }) {
        e.loading = this, $ec2fc4c0d7a3c6c6$export$669f6ea7d267feaf.__parentApp = t, void 0 !== e.config.loading && this.setDefaults(e.config.loading);
    }
});
let $ec2fc4c0d7a3c6c6$var$currentClientMeta, $ec2fc4c0d7a3c6c6$var$updateId = null;
const $ec2fc4c0d7a3c6c6$var$clientList = [];
function $ec2fc4c0d7a3c6c6$var$normalize(e) {
    e.title && (e.title = e.titleTemplate ? e.titleTemplate(e.title) : e.title, delete e.titleTemplate), [
        [
            "meta",
            "content"
        ],
        [
            "link",
            "href"
        ]
    ].forEach((t)=>{
        const o = e[t[0]], n = t[1];
        for(const e in o){
            const t = o[e];
            t.template && (1 === Object.keys(t).length ? delete o[e] : (t[n] = t.template(t[n] || ""), delete t.template));
        }
    });
}
function $ec2fc4c0d7a3c6c6$var$changed(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !0;
    for(const o in e)if (e[o] !== t[o]) return !0;
}
function $ec2fc4c0d7a3c6c6$var$bodyFilter(e) {
    return !1 === [
        "class",
        "style"
    ].includes(e);
}
function $ec2fc4c0d7a3c6c6$var$htmlFilter(e) {
    return !1 === [
        "lang",
        "dir"
    ].includes(e);
}
function $ec2fc4c0d7a3c6c6$var$diff(e, t) {
    const o = {}, n = {};
    return void 0 === e ? {
        add: t,
        remove: n
    } : (e.title !== t.title && (o.title = t.title), [
        "meta",
        "link",
        "script",
        "htmlAttr",
        "bodyAttr"
    ].forEach((a)=>{
        const l = e[a], i = t[a];
        if (n[a] = [], void 0 !== l && null !== l) {
            o[a] = {};
            for(const e in l)!1 === i.hasOwnProperty(e) && n[a].push(e);
            for(const e in i)!1 === l.hasOwnProperty(e) ? o[a][e] = i[e] : !0 === $ec2fc4c0d7a3c6c6$var$changed(l[e], i[e]) && (n[a].push(e), o[a][e] = i[e]);
        } else o[a] = i;
    }), {
        add: o,
        remove: n
    });
}
function $ec2fc4c0d7a3c6c6$var$apply({ add: e, remove: t }) {
    e.title && (document.title = e.title), 0 !== Object.keys(t).length && ([
        "meta",
        "link",
        "script"
    ].forEach((e)=>{
        t[e].forEach((t)=>{
            document.head.querySelector(`${e}[data-qmeta="${t}"]`).remove();
        });
    }), t.htmlAttr.filter($ec2fc4c0d7a3c6c6$var$htmlFilter).forEach((e)=>{
        document.documentElement.removeAttribute(e);
    }), t.bodyAttr.filter($ec2fc4c0d7a3c6c6$var$bodyFilter).forEach((e)=>{
        document.body.removeAttribute(e);
    })), [
        "meta",
        "link",
        "script"
    ].forEach((t)=>{
        const o = e[t];
        for(const e in o){
            const n = document.createElement(t);
            for(const t in o[e])"innerHTML" !== t && n.setAttribute(t, o[e][t]);
            n.setAttribute("data-qmeta", e), "script" === t && (n.innerHTML = o[e].innerHTML || ""), document.head.appendChild(n);
        }
    }), Object.keys(e.htmlAttr).filter($ec2fc4c0d7a3c6c6$var$htmlFilter).forEach((t)=>{
        document.documentElement.setAttribute(t, e.htmlAttr[t] || "");
    }), Object.keys(e.bodyAttr).filter($ec2fc4c0d7a3c6c6$var$bodyFilter).forEach((t)=>{
        document.body.setAttribute(t, e.bodyAttr[t] || "");
    });
}
function $ec2fc4c0d7a3c6c6$var$updateClientMeta() {
    $ec2fc4c0d7a3c6c6$var$updateId = null;
    const e = {
        title: "",
        titleTemplate: null,
        meta: {},
        link: {},
        script: {},
        htmlAttr: {},
        bodyAttr: {}
    };
    for(let t = 0; t < $ec2fc4c0d7a3c6c6$var$clientList.length; t++){
        const { active: o, val: n } = $ec2fc4c0d7a3c6c6$var$clientList[t];
        !0 === o && $ec2fc4c0d7a3c6c6$export$8b58be045bf06082(!0, e, n);
    }
    $ec2fc4c0d7a3c6c6$var$normalize(e), $ec2fc4c0d7a3c6c6$var$apply($ec2fc4c0d7a3c6c6$var$diff($ec2fc4c0d7a3c6c6$var$currentClientMeta, e)), $ec2fc4c0d7a3c6c6$var$currentClientMeta = e;
}
function $ec2fc4c0d7a3c6c6$var$planClientUpdate() {
    null !== $ec2fc4c0d7a3c6c6$var$updateId && clearTimeout($ec2fc4c0d7a3c6c6$var$updateId), $ec2fc4c0d7a3c6c6$var$updateId = setTimeout($ec2fc4c0d7a3c6c6$var$updateClientMeta, 50);
}
var $ec2fc4c0d7a3c6c6$export$b08a9033b36413fb = {
    install (e) {
        !0 !== this.__installed && !0 === $ec2fc4c0d7a3c6c6$var$isRuntimeSsrPreHydration.value && ($ec2fc4c0d7a3c6c6$var$currentClientMeta = window.__Q_META__, document.getElementById("qmeta-init").remove());
    }
};
let $ec2fc4c0d7a3c6c6$var$uid = 0;
const $ec2fc4c0d7a3c6c6$var$defaults = {}, $ec2fc4c0d7a3c6c6$var$groups = {}, $ec2fc4c0d7a3c6c6$var$notificationsList = {}, $ec2fc4c0d7a3c6c6$var$positionClass = {}, $ec2fc4c0d7a3c6c6$var$emptyRE = /^\s*$/, $ec2fc4c0d7a3c6c6$var$notifRefs = [], $ec2fc4c0d7a3c6c6$var$positionList = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "top",
    "bottom",
    "left",
    "right",
    "center"
], $ec2fc4c0d7a3c6c6$var$badgePositions = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
], $ec2fc4c0d7a3c6c6$var$notifTypes = {
    positive: {
        icon: (e)=>e.iconSet.type.positive,
        color: "positive"
    },
    negative: {
        icon: (e)=>e.iconSet.type.negative,
        color: "negative"
    },
    warning: {
        icon: (e)=>e.iconSet.type.warning,
        color: "warning",
        textColor: "dark"
    },
    info: {
        icon: (e)=>e.iconSet.type.info,
        color: "info"
    },
    ongoing: {
        group: !1,
        timeout: 0,
        spinner: !0,
        color: "grey-8"
    }
};
function $ec2fc4c0d7a3c6c6$var$addNotification(e, t, o) {
    if (!e) return $ec2fc4c0d7a3c6c6$var$logError("parameter required");
    let n;
    const a = {
        textColor: "white"
    };
    if (!0 !== e.ignoreDefaults && Object.assign(a, $ec2fc4c0d7a3c6c6$var$defaults), !1 === $ec2fc4c0d7a3c6c6$var$isObject(e) && (a.type && Object.assign(a, $ec2fc4c0d7a3c6c6$var$notifTypes[a.type]), e = {
        message: e
    }), Object.assign(a, $ec2fc4c0d7a3c6c6$var$notifTypes[e.type || a.type], e), "function" === typeof a.icon && (a.icon = a.icon(t)), a.spinner ? (!0 === a.spinner && (a.spinner = $ec2fc4c0d7a3c6c6$export$7418ab329b11fed0), a.spinner = (0, $01W3b.markRaw)(a.spinner)) : a.spinner = !1, a.meta = {
        hasMedia: Boolean(!1 !== a.spinner || a.icon || a.avatar),
        hasText: $ec2fc4c0d7a3c6c6$var$hasContent(a.message) || $ec2fc4c0d7a3c6c6$var$hasContent(a.caption)
    }, a.position) {
        if (!1 === $ec2fc4c0d7a3c6c6$var$positionList.includes(a.position)) return $ec2fc4c0d7a3c6c6$var$logError("wrong position", e);
    } else a.position = "bottom";
    if (void 0 === a.timeout) a.timeout = 5e3;
    else {
        const t = parseInt(a.timeout, 10);
        if (isNaN(t) || t < 0) return $ec2fc4c0d7a3c6c6$var$logError("wrong timeout", e);
        a.timeout = t;
    }
    0 === a.timeout ? a.progress = !1 : !0 === a.progress && (a.meta.progressClass = "q-notification__progress" + (a.progressClass ? ` ${a.progressClass}` : ""), a.meta.progressStyle = {
        animationDuration: `${a.timeout + 1e3}ms`
    });
    const l = (!0 === Array.isArray(e.actions) ? e.actions : []).concat(!0 !== e.ignoreDefaults && !0 === Array.isArray($ec2fc4c0d7a3c6c6$var$defaults.actions) ? $ec2fc4c0d7a3c6c6$var$defaults.actions : []).concat(void 0 !== $ec2fc4c0d7a3c6c6$var$notifTypes[e.type] && !0 === Array.isArray($ec2fc4c0d7a3c6c6$var$notifTypes[e.type].actions) ? $ec2fc4c0d7a3c6c6$var$notifTypes[e.type].actions : []), { closeBtn: i } = a;
    if (i && l.push({
        label: "string" === typeof i ? i : t.lang.label.close
    }), a.actions = l.map(({ handler: e, noDismiss: t, ...o })=>({
            flat: !0,
            ...o,
            onClick: "function" === typeof e ? ()=>{
                e(), !0 !== t && r();
            } : ()=>{
                r();
            }
        })), void 0 === a.multiLine && (a.multiLine = a.actions.length > 1), Object.assign(a.meta, {
        class: "q-notification row items-stretch" + ` q-notification--${!0 === a.multiLine ? "multi-line" : "standard"}` + (void 0 !== a.color ? ` bg-${a.color}` : "") + (void 0 !== a.textColor ? ` text-${a.textColor}` : "") + (void 0 !== a.classes ? ` ${a.classes}` : ""),
        wrapperClass: "q-notification__wrapper col relative-position border-radius-inherit " + (!0 === a.multiLine ? "column no-wrap justify-center" : "row items-center"),
        contentClass: "q-notification__content row items-center" + (!0 === a.multiLine ? "" : " col"),
        leftClass: !0 === a.meta.hasText ? "additional" : "single",
        attrs: {
            role: "alert",
            ...a.attrs
        }
    }), !1 === a.group ? (a.group = void 0, a.meta.group = void 0) : (void 0 !== a.group && !0 !== a.group || (a.group = [
        a.message,
        a.caption,
        a.multiline
    ].concat(a.actions.map((e)=>`${e.label}*${e.icon}`)).join("|")), a.meta.group = a.group + "|" + a.position), 0 === a.actions.length ? a.actions = void 0 : a.meta.actionsClass = "q-notification__actions row items-center " + (!0 === a.multiLine ? "justify-end" : "col-auto") + (!0 === a.meta.hasMedia ? " q-notification__actions--with-media" : ""), void 0 !== o) {
        o.notif.meta.timer && (clearTimeout(o.notif.meta.timer), o.notif.meta.timer = void 0), a.meta.uid = o.notif.meta.uid;
        const e = $ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value.indexOf(o.notif);
        $ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value[e] = a;
    } else {
        const t = $ec2fc4c0d7a3c6c6$var$groups[a.meta.group];
        if (void 0 === t) {
            if (a.meta.uid = $ec2fc4c0d7a3c6c6$var$uid++, a.meta.badge = 1, -1 !== [
                "left",
                "right",
                "center"
            ].indexOf(a.position)) $ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value.splice(Math.floor($ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value.length / 2), 0, a);
            else {
                const e = a.position.indexOf("top") > -1 ? "unshift" : "push";
                $ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value[e](a);
            }
            void 0 !== a.group && ($ec2fc4c0d7a3c6c6$var$groups[a.meta.group] = a);
        } else {
            if (t.meta.timer && (clearTimeout(t.meta.timer), t.meta.timer = void 0), void 0 !== a.badgePosition) {
                if (!1 === $ec2fc4c0d7a3c6c6$var$badgePositions.includes(a.badgePosition)) return $ec2fc4c0d7a3c6c6$var$logError("wrong badgePosition", e);
            } else a.badgePosition = `top-${a.position.indexOf("left") > -1 ? "right" : "left"}`;
            a.meta.uid = t.meta.uid, a.meta.badge = t.meta.badge + 1, a.meta.badgeClass = `q-notification__badge q-notification__badge--${a.badgePosition}` + (void 0 !== a.badgeColor ? ` bg-${a.badgeColor}` : "") + (void 0 !== a.badgeTextColor ? ` text-${a.badgeTextColor}` : "") + (a.badgeClass ? ` ${a.badgeClass}` : "");
            const o = $ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value.indexOf(t);
            $ec2fc4c0d7a3c6c6$var$notificationsList[a.position].value[o] = $ec2fc4c0d7a3c6c6$var$groups[a.meta.group] = a;
        }
    }
    const r = ()=>{
        $ec2fc4c0d7a3c6c6$var$removeNotification(a), n = void 0;
    };
    return a.timeout > 0 && (a.meta.timer = setTimeout(()=>{
        a.meta.timer = void 0, r();
    }, a.timeout + 1e3)), void 0 !== a.group ? (t)=>{
        void 0 !== t ? $ec2fc4c0d7a3c6c6$var$logError("trying to update a grouped one which is forbidden", e) : r();
    } : (n = {
        dismiss: r,
        config: e,
        notif: a
    }, void 0 === o ? (e)=>{
        if (void 0 !== n) {
            if (void 0 === e) n.dismiss();
            else {
                const o = Object.assign({}, n.config, e, {
                    group: !1,
                    position: a.position
                });
                $ec2fc4c0d7a3c6c6$var$addNotification(o, t, n);
            }
        }
    } : void Object.assign(o, n));
}
function $ec2fc4c0d7a3c6c6$var$removeNotification(e) {
    e.meta.timer && (clearTimeout(e.meta.timer), e.meta.timer = void 0);
    const t = $ec2fc4c0d7a3c6c6$var$notificationsList[e.position].value.indexOf(e);
    if (-1 !== t) {
        void 0 !== e.group && delete $ec2fc4c0d7a3c6c6$var$groups[e.meta.group];
        const o = $ec2fc4c0d7a3c6c6$var$notifRefs["" + e.meta.uid];
        if (o) {
            const { width: e, height: t } = getComputedStyle(o);
            o.style.left = `${o.offsetLeft}px`, o.style.width = e, o.style.height = t;
        }
        $ec2fc4c0d7a3c6c6$var$notificationsList[e.position].value.splice(t, 1), "function" === typeof e.onDismiss && e.onDismiss();
    }
}
function $ec2fc4c0d7a3c6c6$var$hasContent(e) {
    return void 0 !== e && null !== e && !0 !== $ec2fc4c0d7a3c6c6$var$emptyRE.test(e);
}
function $ec2fc4c0d7a3c6c6$var$logError(e, t) {
    return console.error(`Notify: ${e}`, t), !1;
}
function $ec2fc4c0d7a3c6c6$var$getComponent() {
    return $ec2fc4c0d7a3c6c6$var$createComponent({
        name: "QNotifications",
        devtools: {
            hide: !0
        },
        setup () {
            return ()=>(0, $TusQn.h)("div", {
                    class: "q-notifications"
                }, $ec2fc4c0d7a3c6c6$var$positionList.map((e)=>{
                    return (0, $TusQn.h)((0, $eeJ70.TransitionGroup), {
                        key: e,
                        class: $ec2fc4c0d7a3c6c6$var$positionClass[e],
                        tag: "div",
                        name: `q-notification--${e}`
                    }, ()=>$ec2fc4c0d7a3c6c6$var$notificationsList[e].value.map((e)=>{
                            const t = e.meta, o = [];
                            if (!0 === t.hasMedia && (!1 !== e.spinner ? o.push((0, $TusQn.h)(e.spinner, {
                                class: "q-notification__spinner q-notification__spinner--" + t.leftClass,
                                color: e.spinnerColor,
                                size: e.spinnerSize
                            })) : e.icon ? o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$d56d6691b226e237, {
                                class: "q-notification__icon q-notification__icon--" + t.leftClass,
                                name: e.icon,
                                color: e.iconColor,
                                size: e.iconSize,
                                role: "img"
                            })) : e.avatar && o.push((0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$f3774053158ba051, {
                                class: "q-notification__avatar q-notification__avatar--" + t.leftClass
                            }, ()=>(0, $TusQn.h)("img", {
                                    src: e.avatar,
                                    "aria-hidden": "true"
                                })))), !0 === t.hasText) {
                                let t;
                                const n = {
                                    class: "q-notification__message col"
                                };
                                if (!0 === e.html) n.innerHTML = e.caption ? `<div>${e.message}</div><div class="q-notification__caption">${e.caption}</div>` : e.message;
                                else {
                                    const o = [
                                        e.message
                                    ];
                                    t = e.caption ? [
                                        (0, $TusQn.h)("div", o),
                                        (0, $TusQn.h)("div", {
                                            class: "q-notification__caption"
                                        }, [
                                            e.caption
                                        ])
                                    ] : o;
                                }
                                o.push((0, $TusQn.h)("div", n, t));
                            }
                            const n = [
                                (0, $TusQn.h)("div", {
                                    class: t.contentClass
                                }, o)
                            ];
                            return !0 === e.progress && n.push((0, $TusQn.h)("div", {
                                key: `${t.uid}|p|${t.badge}`,
                                class: t.progressClass,
                                style: t.progressStyle
                            })), void 0 !== e.actions && n.push((0, $TusQn.h)("div", {
                                class: t.actionsClass
                            }, e.actions.map((e)=>(0, $TusQn.h)($ec2fc4c0d7a3c6c6$export$72abad9388e88b7, e)))), t.badge > 1 && n.push((0, $TusQn.h)("div", {
                                key: `${t.uid}|${t.badge}`,
                                class: e.meta.badgeClass,
                                style: e.badgeStyle
                            }, [
                                t.badge
                            ])), (0, $TusQn.h)("div", {
                                ref: (e)=>{
                                    $ec2fc4c0d7a3c6c6$var$notifRefs["" + t.uid] = e;
                                },
                                key: t.uid,
                                class: t.class,
                                ...t.attrs
                            }, [
                                (0, $TusQn.h)("div", {
                                    class: t.wrapperClass
                                }, n)
                            ]);
                        }));
                }));
        }
    });
}
var $ec2fc4c0d7a3c6c6$export$dd80a68918412a62 = {
    setDefaults (e) {
        !0 === $ec2fc4c0d7a3c6c6$var$isObject(e) && Object.assign($ec2fc4c0d7a3c6c6$var$defaults, e);
    },
    registerType (e, t) {
        !0 === $ec2fc4c0d7a3c6c6$var$isObject(t) && ($ec2fc4c0d7a3c6c6$var$notifTypes[e] = t);
    },
    install ({ $q: e, parentApp: t }) {
        if (e.notify = this.create = (t)=>$ec2fc4c0d7a3c6c6$var$addNotification(t, e), e.notify.setDefaults = this.setDefaults, e.notify.registerType = this.registerType, void 0 !== e.config.notify && this.setDefaults(e.config.notify), !0 !== this.__installed) {
            $ec2fc4c0d7a3c6c6$var$positionList.forEach((e)=>{
                $ec2fc4c0d7a3c6c6$var$notificationsList[e] = (0, $01W3b.ref)([]);
                const t = !0 === [
                    "left",
                    "center",
                    "right"
                ].includes(e) ? "center" : e.indexOf("top") > -1 ? "top" : "bottom", o = e.indexOf("left") > -1 ? "start" : e.indexOf("right") > -1 ? "end" : "center", n = [
                    "left",
                    "right"
                ].includes(e) ? `items-${"left" === e ? "start" : "end"} justify-center` : "center" === e ? "flex-center" : `items-${o}`;
                $ec2fc4c0d7a3c6c6$var$positionClass[e] = `q-notifications__list q-notifications__list--${t} fixed column no-wrap ${n}`;
            });
            const e = $ec2fc4c0d7a3c6c6$var$createGlobalNode("q-notify");
            $ec2fc4c0d7a3c6c6$var$createChildApp($ec2fc4c0d7a3c6c6$var$getComponent(), t).mount(e);
        }
    }
};
function $ec2fc4c0d7a3c6c6$var$encode(e) {
    return !0 === $ec2fc4c0d7a3c6c6$var$isDate(e) ? "__q_date|" + e.toUTCString() : !0 === $ec2fc4c0d7a3c6c6$var$isRegexp(e) ? "__q_expr|" + e.source : "number" === typeof e ? "__q_numb|" + e : "boolean" === typeof e ? "__q_bool|" + (e ? "1" : "0") : "string" === typeof e ? "__q_strn|" + e : "function" === typeof e ? "__q_strn|" + e.toString() : e === Object(e) ? "__q_objt|" + JSON.stringify(e) : e;
}
function $ec2fc4c0d7a3c6c6$var$decode(e) {
    const t = e.length;
    if (t < 9) return e;
    const o = e.substring(0, 8), n = e.substring(9);
    switch(o){
        case "__q_date":
            return new Date(n);
        case "__q_expr":
            return new RegExp(n);
        case "__q_numb":
            return Number(n);
        case "__q_bool":
            return Boolean("1" === n);
        case "__q_strn":
            return "" + n;
        case "__q_objt":
            return JSON.parse(n);
        default:
            return e;
    }
}
function $ec2fc4c0d7a3c6c6$var$getEmptyStorage() {
    const e = ()=>null;
    return {
        has: ()=>!1,
        getLength: ()=>0,
        getItem: e,
        getIndex: e,
        getKey: e,
        getAll: ()=>{},
        getAllKeys: ()=>[],
        set: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
        remove: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
        clear: $ec2fc4c0d7a3c6c6$export$8793edee2d425525,
        isEmpty: ()=>!0
    };
}
function $ec2fc4c0d7a3c6c6$var$getStorage(e) {
    const t = window[e + "Storage"], o = (e)=>{
        const o = t.getItem(e);
        return o ? $ec2fc4c0d7a3c6c6$var$decode(o) : null;
    };
    return {
        has: (e)=>null !== t.getItem(e),
        getLength: ()=>t.length,
        getItem: o,
        getIndex: (e)=>{
            return e < t.length ? o(t.key(e)) : null;
        },
        getKey: (e)=>{
            return e < t.length ? t.key(e) : null;
        },
        getAll: ()=>{
            let e;
            const n = {}, a = t.length;
            for(let l = 0; l < a; l++)e = t.key(l), n[e] = o(e);
            return n;
        },
        getAllKeys: ()=>{
            const e = [], o = t.length;
            for(let n = 0; n < o; n++)e.push(t.key(n));
            return e;
        },
        set: (e, o)=>{
            t.setItem(e, $ec2fc4c0d7a3c6c6$var$encode(o));
        },
        remove: (e)=>{
            t.removeItem(e);
        },
        clear: ()=>{
            t.clear();
        },
        isEmpty: ()=>0 === t.length
    };
}
const $ec2fc4c0d7a3c6c6$var$storage$1 = !1 === $ec2fc4c0d7a3c6c6$var$client.has.webStorage ? $ec2fc4c0d7a3c6c6$var$getEmptyStorage() : $ec2fc4c0d7a3c6c6$var$getStorage("local"), $ec2fc4c0d7a3c6c6$export$19fffca37ef3e106 = {
    install ({ $q: e }) {
        e.localStorage = $ec2fc4c0d7a3c6c6$var$storage$1;
    }
};
Object.assign($ec2fc4c0d7a3c6c6$export$19fffca37ef3e106, $ec2fc4c0d7a3c6c6$var$storage$1);
const $ec2fc4c0d7a3c6c6$var$storage = !1 === $ec2fc4c0d7a3c6c6$var$client.has.webStorage ? $ec2fc4c0d7a3c6c6$var$getEmptyStorage() : $ec2fc4c0d7a3c6c6$var$getStorage("session"), $ec2fc4c0d7a3c6c6$export$2c4b17e1c2e0931 = {
    install ({ $q: e }) {
        e.sessionStorage = $ec2fc4c0d7a3c6c6$var$storage;
    }
};
function $ec2fc4c0d7a3c6c6$export$e4253bd609c2f55d() {
    const { emit: e, proxy: t } = (0, $TusQn.getCurrentInstance)(), o = (0, $01W3b.ref)(null);
    function n() {
        o.value.show();
    }
    function a() {
        o.value.hide();
    }
    function l(t) {
        e("ok", t), a();
    }
    function i() {
        e("hide");
    }
    return Object.assign(t, {
        show: n,
        hide: a
    }), {
        dialogRef: o,
        onDialogHide: i,
        onDialogOK: l,
        onDialogCancel: a
    };
}
Object.assign($ec2fc4c0d7a3c6c6$export$2c4b17e1c2e0931, $ec2fc4c0d7a3c6c6$var$storage);
const $ec2fc4c0d7a3c6c6$var$emits = [
    "ok",
    "hide"
];
function $ec2fc4c0d7a3c6c6$export$3fb9275d3845bd5a(e) {
    {
        const t = {
            active: !0
        };
        if ("function" === typeof e) {
            const o = (0, $TusQn.computed)(e);
            t.val = o.value, (0, $TusQn.watch)(o, (e)=>{
                t.val = e, !0 === t.active && $ec2fc4c0d7a3c6c6$var$planClientUpdate();
            });
        } else t.val = e;
        $ec2fc4c0d7a3c6c6$var$clientList.push(t), $ec2fc4c0d7a3c6c6$var$planClientUpdate(), (0, $TusQn.onActivated)(()=>{
            t.active = !0, $ec2fc4c0d7a3c6c6$var$planClientUpdate();
        }), (0, $TusQn.onDeactivated)(()=>{
            t.active = !1, $ec2fc4c0d7a3c6c6$var$planClientUpdate();
        }), (0, $TusQn.onUnmounted)(()=>{
            $ec2fc4c0d7a3c6c6$var$clientList.splice($ec2fc4c0d7a3c6c6$var$clientList.indexOf(t), 1), $ec2fc4c0d7a3c6c6$var$planClientUpdate();
        });
    }
}
function $ec2fc4c0d7a3c6c6$export$b1dfd21c8751085() {
    return (0, $TusQn.inject)($ec2fc4c0d7a3c6c6$var$quasarKey);
}
function $ec2fc4c0d7a3c6c6$var$fallback(e) {
    const t = document.createElement("textarea");
    t.value = e, t.contentEditable = "true", t.style.position = "fixed";
    const o = ()=>{};
    $ec2fc4c0d7a3c6c6$var$addFocusout(o), document.body.appendChild(t), t.focus(), t.select();
    const n = document.execCommand("copy");
    return t.remove(), $ec2fc4c0d7a3c6c6$var$removeFocusout(o), n;
}
function $ec2fc4c0d7a3c6c6$export$2cdf1b96a9f86d16(e) {
    return void 0 !== navigator.clipboard ? navigator.clipboard.writeText(e) : new Promise((t, o)=>{
        const n = $ec2fc4c0d7a3c6c6$var$fallback(e);
        n ? t(!0) : o(n);
    });
}
$ec2fc4c0d7a3c6c6$export$e4253bd609c2f55d.emits = $ec2fc4c0d7a3c6c6$var$emits, $ec2fc4c0d7a3c6c6$export$e4253bd609c2f55d.emitsObject = $ec2fc4c0d7a3c6c6$var$getEmitsObject($ec2fc4c0d7a3c6c6$var$emits);
var $ec2fc4c0d7a3c6c6$export$f72a2bbac6b612b4 = (e)=>{
    const t = {
        activated () {
            this.__qMeta.active = !0, $ec2fc4c0d7a3c6c6$var$planClientUpdate();
        },
        deactivated () {
            this.__qMeta.active = !1, $ec2fc4c0d7a3c6c6$var$planClientUpdate();
        },
        unmounted () {
            $ec2fc4c0d7a3c6c6$var$clientList.splice($ec2fc4c0d7a3c6c6$var$clientList.indexOf(this.__qMeta), 1), $ec2fc4c0d7a3c6c6$var$planClientUpdate(), this.__qMeta = void 0;
        }
    };
    return "function" === typeof e ? Object.assign(t, {
        computed: {
            __qMetaOptions () {
                return e.call(this) || {};
            }
        },
        watch: {
            __qMetaOptions (e) {
                this.__qMeta.val = e, !0 === this.__qMeta.active && $ec2fc4c0d7a3c6c6$var$planClientUpdate();
            }
        },
        created () {
            this.__qMeta = {
                active: !0,
                val: this.__qMetaOptions
            }, $ec2fc4c0d7a3c6c6$var$clientList.push(this.__qMeta), $ec2fc4c0d7a3c6c6$var$planClientUpdate();
        }
    }) : t.created = function() {
        this.__qMeta = {
            active: !0,
            val: e
        }, $ec2fc4c0d7a3c6c6$var$clientList.push(this.__qMeta), $ec2fc4c0d7a3c6c6$var$planClientUpdate();
    }, t;
};
class $ec2fc4c0d7a3c6c6$export$5087227eb54526 {
    constructor(){
        this.__stack = {};
    }
    on(e, t, o) {
        return (this.__stack[e] || (this.__stack[e] = [])).push({
            fn: t,
            ctx: o
        }), this;
    }
    once(e, t, o) {
        const n = (...a)=>{
            this.off(e, n), t.apply(o, a);
        };
        return n.__callback = t, this.on(e, n, o);
    }
    emit(e) {
        const t = this.__stack[e];
        if (void 0 !== t) {
            const e = [].slice.call(arguments, 1);
            t.forEach((t)=>{
                t.fn.apply(t.ctx, e);
            });
        }
        return this;
    }
    off(e, t) {
        const o = this.__stack[e];
        if (void 0 === o) return this;
        if (void 0 === t) return delete this.__stack[e], this;
        const n = o.filter((e)=>e.fn !== t && e.fn.__callback !== t);
        return 0 !== n.length ? this.__stack[e] = n : delete this.__stack[e], this;
    }
}
function $ec2fc4c0d7a3c6c6$var$clean(e) {
    setTimeout(()=>{
        window.URL.revokeObjectURL(e.href);
    }, 1e4), e.remove();
}
function $ec2fc4c0d7a3c6c6$export$1343164278ec5939(e, t, o = {}) {
    const { mimeType: n, byteOrderMark: a, encoding: l } = "string" === typeof o ? {
        mimeType: o
    } : o, i = void 0 !== l ? new TextEncoder(l).encode([
        t
    ]) : t, r = void 0 !== a ? [
        a,
        i
    ] : [
        i
    ], s = new Blob(r, {
        type: n || "application/octet-stream"
    }), u = document.createElement("a");
    u.href = window.URL.createObjectURL(s), u.setAttribute("download", e), "undefined" === typeof u.download && u.setAttribute("target", "_blank"), u.classList.add("hidden"), u.style.position = "fixed", document.body.appendChild(u);
    try {
        return u.click(), $ec2fc4c0d7a3c6c6$var$clean(u), !0;
    } catch (e) {
        return $ec2fc4c0d7a3c6c6$var$clean(u), e;
    }
}
function $ec2fc4c0d7a3c6c6$var$parseFeatures(e) {
    const t = Object.assign({
        noopener: !0
    }, e), o = [];
    for(const n in t){
        const e = t[n];
        !0 === e ? o.push(n) : ($ec2fc4c0d7a3c6c6$var$isNumber(e) || "string" === typeof e && "" !== e) && o.push(n + "=" + e);
    }
    return o.join(",");
}
function $ec2fc4c0d7a3c6c6$var$openWindow(e, t, o) {
    let n = window.open;
    if (!0 === $ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389.is.cordova) {
        if (void 0 !== cordova && void 0 !== cordova.InAppBrowser && void 0 !== cordova.InAppBrowser.open) n = cordova.InAppBrowser.open;
        else if (void 0 !== navigator && void 0 !== navigator.app) return navigator.app.loadUrl(e, {
            openExternal: !0
        });
    }
    const a = n(e, "_blank", $ec2fc4c0d7a3c6c6$var$parseFeatures(o));
    if (a) return $ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389.is.desktop && a.focus(), a;
    t && t();
}
var $ec2fc4c0d7a3c6c6$export$eda597b8f512706d = (e, t, o)=>{
    if (!0 !== $ec2fc4c0d7a3c6c6$export$2dffd0b5373a4389.is.ios || void 0 === window.SafariViewController) return $ec2fc4c0d7a3c6c6$var$openWindow(e, t, o);
    window.SafariViewController.isAvailable((n)=>{
        n ? window.SafariViewController.show({
            url: e
        }, $ec2fc4c0d7a3c6c6$export$8793edee2d425525, t) : $ec2fc4c0d7a3c6c6$var$openWindow(e, t, o);
    });
};
function $ec2fc4c0d7a3c6c6$var$parsePromises(e) {
    const t = Array.isArray(e);
    if (!0 === t) {
        const o = e.length;
        return {
            isList: t,
            totalJobs: o,
            resultAggregator: Array(o).fill(null)
        };
    }
    const o = Object.keys(e), n = {};
    return o.forEach((e)=>{
        n[e] = null;
    }), {
        isList: t,
        totalJobs: o.length,
        resultAggregator: n,
        resultKeys: o
    };
}
function $ec2fc4c0d7a3c6c6$export$514dd18ef8f5c321(e, { threadsNumber: t = 1, abortOnFail: o = !0 } = {}) {
    let n = -1, a = !1;
    const { isList: l, totalJobs: i, resultAggregator: r, resultKeys: s } = $ec2fc4c0d7a3c6c6$var$parsePromises(e), u = ()=>new Promise((t, u)=>{
            function c() {
                const d = ++n;
                if (!0 === a || d >= i) return void t();
                const p = !0 === l ? d : s[d];
                e[p](r).then((e)=>{
                    !0 !== a ? (r[p] = {
                        key: p,
                        status: "fulfilled",
                        value: e
                    }, setTimeout(c)) : t();
                }).catch((e)=>{
                    if (!0 === a) return void t();
                    const n = {
                        key: p,
                        status: "rejected",
                        reason: e
                    };
                    if (r[p] = n, !0 === o) return a = !0, void u({
                        ...n,
                        resultAggregator: r
                    });
                    setTimeout(c);
                });
            }
            c();
        }), c = Array(t).fill(u());
    return Promise.all(c).then(()=>r);
}
const $ec2fc4c0d7a3c6c6$export$aa2891570c510a77 = {
    version: "2.12.5",
    install (e, t, o) {
        $ec2fc4c0d7a3c6c6$var$installQuasar(e, {
            components: $ec2fc4c0d7a3c6c6$var$components,
            directives: $ec2fc4c0d7a3c6c6$var$directives,
            ...t
        });
    },
    lang: $ec2fc4c0d7a3c6c6$var$Plugin$8,
    iconSet: $ec2fc4c0d7a3c6c6$var$Plugin$7
};

});


parcelRequire.register("4h9pT", function(module, exports) {

$parcel$export(module.exports, "render", () => $31d00dea6bc7cc92$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $31d00dea6bc7cc92$var$_hoisted_1 = {
    class: "text-h5"
};
const $31d00dea6bc7cc92$var$_hoisted_2 = {
    class: "text-h6"
};
const $31d00dea6bc7cc92$var$_hoisted_3 = [
    "name"
];
const $31d00dea6bc7cc92$var$_hoisted_4 = [
    "innerHTML"
];
const $31d00dea6bc7cc92$var$_hoisted_5 = [
    "onClick"
];
const $31d00dea6bc7cc92$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "text-body1"
}, " Une fois toutes les questions trait\xe9es, vous allez pouvoir continuer ", -1);
const $31d00dea6bc7cc92$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "text-h2"
}, "Merci pour votre participation", -1);
function $31d00dea6bc7cc92$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = (0, $TusQn.resolveComponent)("q-icon");
    const _component_q_card_section = (0, $TusQn.resolveComponent)("q-card-section");
    const _component_q_input = (0, $TusQn.resolveComponent)("q-input");
    const _component_q_radio = (0, $TusQn.resolveComponent)("q-radio");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        !$setup.done && $setup.survey && $setup.currentPage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8POXm.normalizeClass)(_ctx.$style.page)
        }, [
            (0, $TusQn.createElementVNode)("div", $31d00dea6bc7cc92$var$_hoisted_1, [
                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.survey.title) + " ", 1),
                (0, $TusQn.createVNode)(_component_q_icon, {
                    name: "chevron_right",
                    color: "primary"
                }),
                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($setup.currentPage.title), 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $31d00dea6bc7cc92$var$_hoisted_2, [
                (0, $TusQn.createVNode)(_component_q_card_section, {
                    innerHTML: $setup.currentPage.description
                }, null, 8, [
                    "innerHTML"
                ])
            ]),
            $setup.currentPage?.type == "questions" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 0,
                class: (0, $8POXm.normalizeClass)(_ctx.$style.questionsArea)
            }, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.currentPage.data.questions, (question)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        class: (0, $8POXm.normalizeClass)(_ctx.$style.question),
                        key: question.internalID
                    }, [
                        $setup.shouldShowQuestion(question, $setup.currentPage.data.questions) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                            key: 0,
                            name: question.body
                        }, [
                            (0, $TusQn.createElementVNode)("div", null, [
                                (0, $TusQn.createVNode)(_component_q_icon, {
                                    name: "arrow_forward",
                                    color: "primary"
                                }),
                                (0, $TusQn.createElementVNode)("span", {
                                    innerHTML: question.body
                                }, null, 8, $31d00dea6bc7cc92$var$_hoisted_4)
                            ]),
                            question.type === "multichoice" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: 0,
                                class: (0, $8POXm.normalizeClass)(_ctx.$style.answers)
                            }, [
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(question.answers, (answer)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                        class: (0, $8POXm.normalizeClass)({
                                            [_ctx.$style.answer]: true,
                                            [_ctx.$style.selected]: question.choice === answer.internalID
                                        }),
                                        onClick: ($event)=>$setup.selectAnswer(question, answer)
                                    }, [
                                        (0, $TusQn.createVNode)(_component_q_icon, {
                                            name: "task_alt",
                                            class: (0, $8POXm.normalizeClass)({
                                                [_ctx.$style.answerIcon]: true,
                                                [_ctx.$style.visible]: question.choice === answer.internalID
                                            })
                                        }, null, 8, [
                                            "class"
                                        ]),
                                        (0, $TusQn.createElementVNode)("div", null, (0, $8POXm.toDisplayString)(answer.body), 1)
                                    ], 10, $31d00dea6bc7cc92$var$_hoisted_5);
                                }), 256))
                            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
                            question.type === "string" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: 1,
                                class: (0, $8POXm.normalizeClass)(_ctx.$style.answers)
                            }, [
                                (0, $TusQn.createVNode)(_component_q_input, {
                                    modelValue: question.choice,
                                    "onUpdate:modelValue": ($event)=>question.choice = $event,
                                    modelModifiers: {
                                        trim: true
                                    },
                                    label: "R\xe9ponse"
                                }, null, 8, [
                                    "modelValue",
                                    "onUpdate:modelValue"
                                ])
                            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
                            question.type === "number" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                key: 2,
                                class: (0, $8POXm.normalizeClass)(_ctx.$style.answers)
                            }, [
                                (0, $TusQn.createVNode)(_component_q_input, {
                                    modelValue: question.choice,
                                    "onUpdate:modelValue": ($event)=>question.choice = $event,
                                    modelModifiers: {
                                        number: true
                                    },
                                    label: "R\xe9ponse",
                                    type: "number"
                                }, null, 8, [
                                    "modelValue",
                                    "onUpdate:modelValue"
                                ])
                            ], 2)) : (0, $TusQn.createCommentVNode)("", true)
                        ], 8, $31d00dea6bc7cc92$var$_hoisted_3)) : (0, $TusQn.createCommentVNode)("", true)
                    ], 2);
                }), 128))
            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
            $setup.currentPage?.type == "table" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 1,
                class: (0, $8POXm.normalizeClass)(_ctx.$style.questionsArea)
            }, [
                (0, $TusQn.createElementVNode)("table", {
                    class: (0, $8POXm.normalizeClass)(_ctx.$style.questionsTable)
                }, [
                    (0, $TusQn.createElementVNode)("tr", {
                        class: (0, $8POXm.normalizeClass)(_ctx.$style.tableHeader)
                    }, [
                        (0, $TusQn.createElementVNode)("th", {
                            class: (0, $8POXm.normalizeClass)(_ctx.$style.questionColumn)
                        }, null, 2),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.currentPage.data.answers, (answer)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("th", null, (0, $8POXm.toDisplayString)(answer.body), 1);
                        }), 256))
                    ], 2),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.currentPage.data.questions, (question)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", null, [
                            (0, $TusQn.createElementVNode)("td", {
                                class: (0, $8POXm.normalizeClass)(_ctx.$style.questionColumn)
                            }, (0, $8POXm.toDisplayString)(question.body), 3),
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.currentPage.data.answers, (answer)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("td", {
                                    class: (0, $8POXm.normalizeClass)(_ctx.$style.answerCell)
                                }, [
                                    (0, $TusQn.createVNode)(_component_q_radio, {
                                        modelValue: question.choice,
                                        "onUpdate:modelValue": ($event)=>question.choice = $event,
                                        val: answer.internalID,
                                        label: "",
                                        size: "xl",
                                        color: "teal"
                                    }, null, 8, [
                                        "modelValue",
                                        "onUpdate:modelValue",
                                        "val"
                                    ])
                                ], 2);
                            }), 256))
                        ]);
                    }), 256))
                ], 2)
            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
            $setup.somePageQuestionsNotAnswered ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                key: 2,
                class: (0, $8POXm.normalizeClass)(_ctx.$style.done)
            }, [
                (0, $TusQn.createElementVNode)("div", null, [
                    (0, $TusQn.createVNode)(_component_q_icon, {
                        name: "warning",
                        color: "red",
                        class: "text-h3"
                    })
                ]),
                $31d00dea6bc7cc92$var$_hoisted_6
            ], 2)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", {
                class: (0, $8POXm.normalizeClass)(_ctx.$style.actions)
            }, [
                $setup.currentPageIndex !== 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["QBtn"], {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.previousPage()),
                    color: "primary",
                    icon: "arrow_back",
                    label: "Pr\xe9c\xe9dent",
                    size: "xl"
                })) : (0, $TusQn.createCommentVNode)("", true),
                $setup.currentPageIndex === $setup.survey.pages.length - 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["QBtn"], {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.save()),
                    color: "primary",
                    icon: "save",
                    label: "Enregistrer",
                    size: "xl",
                    disable: $setup.somePageQuestionsNotAnswered
                }, null, 8, [
                    "disable"
                ])) : (0, $TusQn.createCommentVNode)("", true),
                $setup.currentPageIndex !== $setup.survey.pages.length - 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["QBtn"], {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.nextPage()),
                    color: "primary",
                    icon: "arrow_forward",
                    label: "Suivant",
                    size: "xl",
                    disable: $setup.somePageQuestionsNotAnswered
                }, null, 8, [
                    "disable"
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ], 2)
        ], 2)) : (0, $TusQn.createCommentVNode)("", true),
        $setup.done ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 1,
            class: (0, $8POXm.normalizeClass)(_ctx.$style.done)
        }, [
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createVNode)(_component_q_icon, {
                    name: "person_check",
                    color: "teal",
                    class: "text-h2"
                })
            ]),
            $31d00dea6bc7cc92$var$_hoisted_7
        ], 2)) : (0, $TusQn.createCommentVNode)("", true)
    ], 64);
}

});

parcelRequire.register("9VsqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $739f7e2fd21f31e4$export$2e2bcd8739ae039);
parcelRequire("4h9pT");
let $739f7e2fd21f31e4$var$cssModules = {
    "$style": {
        "question": "_question_1vklq_2",
        "answers": "_answers_1vklq_10",
        "answer": "_answer_1vklq_10",
        "answerIcon": "_answerIcon_1vklq_31",
        "selected": "_selected_1vklq_39",
        "visible": "_visible_1vklq_45",
        "actions": "_actions_1vklq_55",
        "page": "_page_1vklq_61",
        "questionsArea": "_questionsArea_1vklq_65",
        "questionsTable": "_questionsTable_1vklq_69",
        "questionColumn": "_questionColumn_1vklq_96",
        "answerCell": "_answerCell_1vklq_102",
        "tableHeader": "_tableHeader_1vklq_106",
        "done": "_done_1vklq_114"
    }
};
var $739f7e2fd21f31e4$export$2e2bcd8739ae039 = $739f7e2fd21f31e4$var$cssModules;

});

parcelRequire.register("2lP7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b653334956848db$export$2e2bcd8739ae039);
let $1b653334956848db$var$NOOP = ()=>{};
var $1b653334956848db$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("eehUc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eb32855d7a6ed43c$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $521sb = parcelRequire("521sb");

var $khdnb = parcelRequire("khdnb");
var $eb32855d7a6ed43c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "AdminPage",
    setup (__props, { expose: __expose }) {
        __expose();
        const router = (0, $73mM4.useRouter)();
        const surveys = (0, $01W3b.ref)([]);
        async function getSurveys() {
            (0, $khdnb.Loading).show();
            (0, $521sb.sendRequest)({
                uri: `/api/surveys`
            }).then(async (response)=>{
                surveys.value = await response.json();
            }).finally(()=>(0, $khdnb.Loading).hide());
        }
        async function createSurvey() {
            (0, $khdnb.Loading).show();
            (0, $521sb.sendRequest)({
                method: "POST",
                uri: `/api/admin/surveys/create`
            }).then(async (response)=>{
                const surveyID = await response.text();
                router.push({
                    path: "/edit",
                    query: {
                        id: surveyID
                    }
                });
            }).finally(()=>(0, $khdnb.Loading).hide());
        }
        function editSurvey(survey) {
            router.push({
                path: "/edit",
                query: {
                    id: survey.id
                }
            });
        }
        async function removeSurvey(survey) {
            (0, $khdnb.Dialog).create({
                title: "Confirm",
                message: `Supprimer le questionnaire '${survey.title}', ses ${survey.pages_count} questions et les réponses associées ?`,
                cancel: true,
                persistent: true
            }).onOk(()=>{
                (0, $khdnb.Loading).show();
                (0, $521sb.sendRequest)({
                    method: "DELETE",
                    uri: `/api/admin/surveys/${survey.id}`
                }).then(async (response)=>{
                    return getSurveys();
                });
            });
        }
        (0, $TusQn.onMounted)(getSurveys);
        const __returned__ = {
            router: router,
            surveys: surveys,
            getSurveys: getSurveys,
            createSurvey: createSurvey,
            editSurvey: editSurvey,
            removeSurvey: removeSurvey
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRequire.register("521sb", function(module, exports) {

$parcel$export(module.exports, "sendRequest", () => $a731835e37b20abb$export$d5a1e65f8aa21b51);
let $a731835e37b20abb$var$login = "";
let $a731835e37b20abb$var$password = "";
function $a731835e37b20abb$export$d5a1e65f8aa21b51({ method: method = "GET", uri: uri, body: body, headers: headers = {} }) {
    if ($a731835e37b20abb$var$login && $a731835e37b20abb$var$password) headers["Authorization"] = "Basic " + btoa(unescape(encodeURIComponent($a731835e37b20abb$var$login + ":" + $a731835e37b20abb$var$password)));
    return fetch(uri, {
        method: method,
        body: body,
        headers: headers,
        signal: AbortSignal.timeout(5000)
    }).then((response)=>{
        if (response.status === 401) {
            $a731835e37b20abb$var$login = prompt("Login") || "";
            $a731835e37b20abb$var$password = prompt("Password") || "";
            return $a731835e37b20abb$export$d5a1e65f8aa21b51({
                method: method,
                uri: uri,
                body: body,
                headers: headers
            });
        } else return response;
    });
}

});


parcelRequire.register("9ozJ9", function(module, exports) {

$parcel$export(module.exports, "render", () => $6d7211a0c71d8ea8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $6d7211a0c71d8ea8$var$_hoisted_1 = {
    class: "text-weight-medium"
};
const $6d7211a0c71d8ea8$var$_hoisted_2 = {
    class: "text-grey-8 q-gutter-xs"
};
function $6d7211a0c71d8ea8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_item_label = (0, $TusQn.resolveComponent)("q-item-label");
    const _component_q_btn = (0, $TusQn.resolveComponent)("q-btn");
    const _component_q_item = (0, $TusQn.resolveComponent)("q-item");
    const _component_q_separator = (0, $TusQn.resolveComponent)("q-separator");
    const _component_q_icon = (0, $TusQn.resolveComponent)("q-icon");
    const _component_q_item_section = (0, $TusQn.resolveComponent)("q-item-section");
    const _component_q_tooltip = (0, $TusQn.resolveComponent)("q-tooltip");
    const _component_q_list = (0, $TusQn.resolveComponent)("q-list");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", null, [
        (0, $TusQn.createVNode)(_component_q_list, {
            bordered: "",
            class: "rounded-borders"
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_q_item_label, {
                        header: ""
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)("Questionnaires")
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createVNode)(_component_q_item, null, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_q_btn, {
                                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.createSurvey()),
                                    icon: "add",
                                    label: "Nouveau questionnaire",
                                    outline: ""
                                })
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createVNode)(_component_q_separator),
                    $setup.surveys.length === 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_item, {
                        key: 0
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)("Aucun questionnaire n'est disponible")
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.surveys, (survey)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_item, {
                            class: (0, $8POXm.normalizeClass)(_ctx.$style.survey)
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_q_item_section, {
                                        avatar: "",
                                        top: "",
                                        onClick: ($event)=>$setup.editSurvey(survey),
                                        class: (0, $8POXm.normalizeClass)(_ctx.$style.clickable)
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createVNode)(_component_q_icon, {
                                                    name: "fact_check",
                                                    color: "black",
                                                    size: "34px"
                                                })
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "onClick",
                                        "class"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_q_item_section, {
                                        top: "",
                                        onClick: ($event)=>$setup.editSurvey(survey),
                                        class: (0, $8POXm.normalizeClass)(_ctx.$style.clickable)
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createVNode)(_component_q_item_label, null, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createElementVNode)("span", $6d7211a0c71d8ea8$var$_hoisted_1, (0, $8POXm.toDisplayString)(survey.title), 1)
                                                        ]),
                                                    _: 2
                                                }, 1024),
                                                (0, $TusQn.createVNode)(_component_q_item_label, {
                                                    caption: "",
                                                    lines: "1"
                                                }, {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(survey.pages_count) + " pages ", 1)
                                                        ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "onClick",
                                        "class"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_q_item_section, {
                                        top: "",
                                        side: ""
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createElementVNode)("div", $6d7211a0c71d8ea8$var$_hoisted_2, [
                                                    (0, $TusQn.createVNode)(_component_q_btn, {
                                                        class: "gt-xs",
                                                        size: "12px",
                                                        flat: "",
                                                        dense: "",
                                                        round: "",
                                                        icon: "edit",
                                                        to: {
                                                            path: "/edit",
                                                            query: {
                                                                id: survey.id
                                                            }
                                                        }
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_tooltip, null, {
                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                            (0, $TusQn.createTextVNode)("Modifier")
                                                                        ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                        _: 2
                                                    }, 1032, [
                                                        "to"
                                                    ]),
                                                    (0, $TusQn.createVNode)(_component_q_btn, {
                                                        class: "gt-xs",
                                                        size: "12px",
                                                        flat: "",
                                                        dense: "",
                                                        round: "",
                                                        icon: "preview",
                                                        to: {
                                                            path: "/",
                                                            query: {
                                                                id: survey.id,
                                                                u: "preview"
                                                            }
                                                        }
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_tooltip, null, {
                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                            (0, $TusQn.createTextVNode)("Pr\xe9visualiser")
                                                                        ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                        _: 2
                                                    }, 1032, [
                                                        "to"
                                                    ]),
                                                    (0, $TusQn.createVNode)(_component_q_btn, {
                                                        class: "gt-xs",
                                                        size: "12px",
                                                        flat: "",
                                                        dense: "",
                                                        round: "",
                                                        icon: "delete",
                                                        onClick: ($event)=>$setup.removeSurvey(survey)
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_tooltip, null, {
                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                            (0, $TusQn.createTextVNode)("Supprimer")
                                                                        ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                        _: 2
                                                    }, 1032, [
                                                        "onClick"
                                                    ])
                                                ])
                                            ]),
                                        _: 2
                                    }, 1024)
                                ]),
                            _: 2
                        }, 1032, [
                            "class"
                        ]);
                    }), 256))
                ]),
            _: 1
        })
    ]);
}

});

parcelRequire.register("3xyB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $293f4a898dc03165$export$2e2bcd8739ae039);
parcelRequire("9ozJ9");
let $293f4a898dc03165$var$cssModules = {
    "$style": {
        "body": "_body_1bvgx_2",
        "survey": "_survey_1bvgx_7",
        "clickable": "_clickable_1bvgx_11"
    }
};
var $293f4a898dc03165$export$2e2bcd8739ae039 = $293f4a898dc03165$var$cssModules;

});

parcelRequire.register("9exEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b8f85e443c8aad5$export$2e2bcd8739ae039);
let $6b8f85e443c8aad5$var$NOOP = ()=>{};
var $6b8f85e443c8aad5$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("j8u7V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6b02652b2b0eddab$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $khdnb = parcelRequire("khdnb");

var $cHm2O = parcelRequire("cHm2O");

var $i0TKe = parcelRequire("i0TKe");

var $521sb = parcelRequire("521sb");

var $2xmtF = parcelRequire("2xmtF");

var $cfJHQ = parcelRequire("cfJHQ");

var $778Ml = parcelRequire("778Ml");

var $8qY0g = parcelRequire("8qY0g");
var $6b02652b2b0eddab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "CreateSurveyPage",
    setup (__props, { expose: __expose }) {
        __expose();
        const surveyStore = (0, $8qY0g.useSurveysStore)();
        const route = (0, $73mM4.useRoute)();
        const survey_id = route.query.id;
        const showAddPageDialog = (0, $01W3b.ref)(false);
        const pagesColumnMode = (0, $01W3b.ref)(false);
        const newPageType = (0, $01W3b.ref)("questions");
        const newPageTitle = (0, $01W3b.ref)("");
        const newPageTypeOptions = (0, $01W3b.ref)([
            {
                label: "Questions",
                value: "questions"
            },
            {
                label: "Table",
                value: "table"
            }
        ]);
        const { survey: survey, currentPage: currentPage, currentPageIndex: currentPageIndex } = (0, $i0TKe.storeToRefs)(surveyStore);
        async function save() {
            (0, $khdnb.Loading).show();
            (0, $521sb.sendRequest)({
                method: "POST",
                uri: `/api/admin/surveys/${survey_id}`,
                body: JSON.stringify(survey.value),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(()=>{
                (0, $khdnb.Notify).create({
                    color: "positive",
                    message: "Sauvegard\xe9",
                    icon: "done"
                });
            }).catch(()=>{
                (0, $khdnb.Notify).create({
                    color: "negative",
                    message: "Echec de la sauvegarde",
                    icon: "report_problem"
                });
            }).finally(()=>(0, $khdnb.Loading).hide());
        }
        async function getSurvey() {
            (0, $khdnb.Loading).show({
                group: "getSurvey"
            });
            await surveyStore.loadSurvey(survey_id);
            if (survey.value?.pages.length !== 0) selectPageByIndex(0);
            (0, $khdnb.Loading).hide("getSurvey");
        }
        function selectPageByIndex(index) {
            surveyStore.setCurrentPage(index);
        }
        function addPage() {
            if (!survey.value) return;
            let data;
            if (newPageType.value === "table") data = {
                answers: [],
                questions: []
            };
            else if (newPageType.value === "questions") data = {
                questions: []
            };
            survey.value?.pages.push({
                title: newPageTitle.value,
                type: newPageType.value,
                data: data
            });
            newPageTitle.value = "";
            surveyStore.selectLastPage();
        }
        function removePage(index) {
            survey.value?.pages.splice(index, 1);
            currentPage.value = null;
            currentPageIndex.value = -1;
        }
        (0, $TusQn.onMounted)(getSurvey);
        const __returned__ = {
            surveyStore: surveyStore,
            route: route,
            survey_id: survey_id,
            showAddPageDialog: showAddPageDialog,
            pagesColumnMode: pagesColumnMode,
            newPageType: newPageType,
            newPageTitle: newPageTitle,
            newPageTypeOptions: newPageTypeOptions,
            survey: survey,
            currentPage: currentPage,
            currentPageIndex: currentPageIndex,
            save: save,
            getSurvey: getSurvey,
            selectPageByIndex: selectPageByIndex,
            addPage: addPage,
            removePage: removePage,
            get draggable () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($cHm2O));
            },
            AppInfoMessage: $2xmtF.default,
            AppQuestionsPageEditor: $cfJHQ.default,
            AppTablePageEditor: $778Ml.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRequire.register("cHm2O", function(module, exports) {


(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("ecd4d")), (parcelRequire("iVGQs")));
})(typeof self !== "undefined" ? self : module.exports, function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_a352__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "fb15");
    /******/ }({
        /***/ "00ee": /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__("b622");
            var TO_STRING_TAG = wellKnownSymbol("toStringTag");
            var test = {};
            test[TO_STRING_TAG] = "z";
            module1.exports = String(test) === "[object z]";
        /***/ },
        /***/ "0366": /***/ function(module1, exports, __webpack_require__) {
            var aFunction = __webpack_require__("1c0b");
            // optional / simple context binding
            module1.exports = function(fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch(length){
                    case 0:
                        return function() {
                            return fn.call(that);
                        };
                    case 1:
                        return function(a) {
                            return fn.call(that, a);
                        };
                    case 2:
                        return function(a, b) {
                            return fn.call(that, a, b);
                        };
                    case 3:
                        return function(a, b, c) {
                            return fn.call(that, a, b, c);
                        };
                }
                return function() {
                    return fn.apply(that, arguments);
                };
            };
        /***/ },
        /***/ "057f": /***/ function(module1, exports, __webpack_require__) {
            var toIndexedObject = __webpack_require__("fc6a");
            var nativeGetOwnPropertyNames = __webpack_require__("241c").f;
            var toString = {}.toString;
            var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
            var getWindowNames = function(it) {
                try {
                    return nativeGetOwnPropertyNames(it);
                } catch (error) {
                    return windowNames.slice();
                }
            };
            // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
            module1.exports.f = function getOwnPropertyNames(it) {
                return windowNames && toString.call(it) == "[object Window]" ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
            };
        /***/ },
        /***/ "06cf": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var propertyIsEnumerableModule = __webpack_require__("d1e7");
            var createPropertyDescriptor = __webpack_require__("5c6c");
            var toIndexedObject = __webpack_require__("fc6a");
            var toPrimitive = __webpack_require__("c04e");
            var has = __webpack_require__("5135");
            var IE8_DOM_DEFINE = __webpack_require__("0cfb");
            var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            // `Object.getOwnPropertyDescriptor` method
            // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
            exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                O = toIndexedObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE) try {
                    return nativeGetOwnPropertyDescriptor(O, P);
                } catch (error) {}
                if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
            };
        /***/ },
        /***/ "0cfb": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var fails = __webpack_require__("d039");
            var createElement = __webpack_require__("cc12");
            // Thank's IE8 for his funny defineProperty
            module1.exports = !DESCRIPTORS && !fails(function() {
                return Object.defineProperty(createElement("div"), "a", {
                    get: function() {
                        return 7;
                    }
                }).a != 7;
            });
        /***/ },
        /***/ "13d5": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var $reduce = __webpack_require__("d58f").left;
            var arrayMethodIsStrict = __webpack_require__("a640");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var STRICT_METHOD = arrayMethodIsStrict("reduce");
            var USES_TO_LENGTH = arrayMethodUsesToLength("reduce", {
                1: 0
            });
            // `Array.prototype.reduce` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
            $({
                target: "Array",
                proto: true,
                forced: !STRICT_METHOD || !USES_TO_LENGTH
            }, {
                reduce: function reduce(callbackfn /* , initialValue */ ) {
                    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
        /***/ },
        /***/ "14c3": /***/ function(module1, exports, __webpack_require__) {
            var classof = __webpack_require__("c6b6");
            var regexpExec = __webpack_require__("9263");
            // `RegExpExec` abstract operation
            // https://tc39.github.io/ecma262/#sec-regexpexec
            module1.exports = function(R, S) {
                var exec = R.exec;
                if (typeof exec === "function") {
                    var result = exec.call(R, S);
                    if (typeof result !== "object") throw TypeError("RegExp exec method returned something other than an Object or null");
                    return result;
                }
                if (classof(R) !== "RegExp") throw TypeError("RegExp#exec called on incompatible receiver");
                return regexpExec.call(R, S);
            };
        /***/ },
        /***/ "159b": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var DOMIterables = __webpack_require__("fdbc");
            var forEach = __webpack_require__("17c2");
            var createNonEnumerableProperty = __webpack_require__("9112");
            for(var COLLECTION_NAME in DOMIterables){
                var Collection = global[COLLECTION_NAME];
                var CollectionPrototype = Collection && Collection.prototype;
                // some Chrome versions have non-configurable methods on DOMTokenList
                if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
                    createNonEnumerableProperty(CollectionPrototype, "forEach", forEach);
                } catch (error) {
                    CollectionPrototype.forEach = forEach;
                }
            }
        /***/ },
        /***/ "17c2": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $forEach = __webpack_require__("b727").forEach;
            var arrayMethodIsStrict = __webpack_require__("a640");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var STRICT_METHOD = arrayMethodIsStrict("forEach");
            var USES_TO_LENGTH = arrayMethodUsesToLength("forEach");
            // `Array.prototype.forEach` method implementation
            // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
            module1.exports = !STRICT_METHOD || !USES_TO_LENGTH ? function forEach(callbackfn /* , thisArg */ ) {
                return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            } : [].forEach;
        /***/ },
        /***/ "1be4": /***/ function(module1, exports, __webpack_require__) {
            var getBuiltIn = __webpack_require__("d066");
            module1.exports = getBuiltIn("document", "documentElement");
        /***/ },
        /***/ "1c0b": /***/ function(module1, exports) {
            module1.exports = function(it) {
                if (typeof it != "function") throw TypeError(String(it) + " is not a function");
                return it;
            };
        /***/ },
        /***/ "1c7e": /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__("b622");
            var ITERATOR = wellKnownSymbol("iterator");
            var SAFE_CLOSING = false;
            try {
                var called = 0;
                var iteratorWithReturn = {
                    next: function() {
                        return {
                            done: !!called++
                        };
                    },
                    "return": function() {
                        SAFE_CLOSING = true;
                    }
                };
                iteratorWithReturn[ITERATOR] = function() {
                    return this;
                };
                // eslint-disable-next-line no-throw-literal
                Array.from(iteratorWithReturn, function() {
                    throw 2;
                });
            } catch (error) {}
            module1.exports = function(exec, SKIP_CLOSING) {
                if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                var ITERATION_SUPPORT = false;
                try {
                    var object = {};
                    object[ITERATOR] = function() {
                        return {
                            next: function() {
                                return {
                                    done: ITERATION_SUPPORT = true
                                };
                            }
                        };
                    };
                    exec(object);
                } catch (error) {}
                return ITERATION_SUPPORT;
            };
        /***/ },
        /***/ "1d80": /***/ function(module1, exports) {
            // `RequireObjectCoercible` abstract operation
            // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
            module1.exports = function(it) {
                if (it == undefined) throw TypeError("Can't call method on " + it);
                return it;
            };
        /***/ },
        /***/ "1dde": /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__("d039");
            var wellKnownSymbol = __webpack_require__("b622");
            var V8_VERSION = __webpack_require__("2d00");
            var SPECIES = wellKnownSymbol("species");
            module1.exports = function(METHOD_NAME) {
                // We can't use this feature detection in V8 since it causes
                // deoptimization and serious performance degradation
                // https://github.com/zloirock/core-js/issues/677
                return V8_VERSION >= 51 || !fails(function() {
                    var array = [];
                    var constructor = array.constructor = {};
                    constructor[SPECIES] = function() {
                        return {
                            foo: 1
                        };
                    };
                    return array[METHOD_NAME](Boolean).foo !== 1;
                });
            };
        /***/ },
        /***/ "23cb": /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__("a691");
            var max = Math.max;
            var min = Math.min;
            // Helper for a popular repeating case of the spec:
            // Let integer be ? ToInteger(index).
            // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
            module1.exports = function(index, length) {
                var integer = toInteger(index);
                return integer < 0 ? max(integer + length, 0) : min(integer, length);
            };
        /***/ },
        /***/ "23e7": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
            var createNonEnumerableProperty = __webpack_require__("9112");
            var redefine = __webpack_require__("6eeb");
            var setGlobal = __webpack_require__("ce4e");
            var copyConstructorProperties = __webpack_require__("e893");
            var isForced = __webpack_require__("94ca");
            /*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ module1.exports = function(options, source) {
                var TARGET = options.target;
                var GLOBAL = options.global;
                var STATIC = options.stat;
                var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                if (GLOBAL) target = global;
                else if (STATIC) target = global[TARGET] || setGlobal(TARGET, {});
                else target = (global[TARGET] || {}).prototype;
                if (target) for(key in source){
                    sourceProperty = source[key];
                    if (options.noTargetGet) {
                        descriptor = getOwnPropertyDescriptor(target, key);
                        targetProperty = descriptor && descriptor.value;
                    } else targetProperty = target[key];
                    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                    // contained in target
                    if (!FORCED && targetProperty !== undefined) {
                        if (typeof sourceProperty === typeof targetProperty) continue;
                        copyConstructorProperties(sourceProperty, targetProperty);
                    }
                    // add a flag to not completely full polyfills
                    if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
                    // extend global
                    redefine(target, key, sourceProperty, options);
                }
            };
        /***/ },
        /***/ "241c": /***/ function(module1, exports, __webpack_require__) {
            var internalObjectKeys = __webpack_require__("ca84");
            var enumBugKeys = __webpack_require__("7839");
            var hiddenKeys = enumBugKeys.concat("length", "prototype");
            // `Object.getOwnPropertyNames` method
            // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return internalObjectKeys(O, hiddenKeys);
            };
        /***/ },
        /***/ "25f0": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var redefine = __webpack_require__("6eeb");
            var anObject = __webpack_require__("825a");
            var fails = __webpack_require__("d039");
            var flags = __webpack_require__("ad6d");
            var TO_STRING = "toString";
            var RegExpPrototype = RegExp.prototype;
            var nativeToString = RegExpPrototype[TO_STRING];
            var NOT_GENERIC = fails(function() {
                return nativeToString.call({
                    source: "a",
                    flags: "b"
                }) != "/a/b";
            });
            // FF44- RegExp#toString has a wrong name
            var INCORRECT_NAME = nativeToString.name != TO_STRING;
            // `RegExp.prototype.toString` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
            if (NOT_GENERIC || INCORRECT_NAME) redefine(RegExp.prototype, TO_STRING, function toString() {
                var R = anObject(this);
                var p = String(R.source);
                var rf = R.flags;
                var f = String(rf === undefined && R instanceof RegExp && !("flags" in RegExpPrototype) ? flags.call(R) : rf);
                return "/" + p + "/" + f;
            }, {
                unsafe: true
            });
        /***/ },
        /***/ "2ca0": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
            var toLength = __webpack_require__("50c4");
            var notARegExp = __webpack_require__("5a34");
            var requireObjectCoercible = __webpack_require__("1d80");
            var correctIsRegExpLogic = __webpack_require__("ab13");
            var IS_PURE = __webpack_require__("c430");
            var nativeStartsWith = "".startsWith;
            var min = Math.min;
            var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("startsWith");
            // https://github.com/zloirock/core-js/pull/702
            var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
                var descriptor = getOwnPropertyDescriptor(String.prototype, "startsWith");
                return descriptor && !descriptor.writable;
            }();
            // `String.prototype.startsWith` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.startswith
            $({
                target: "String",
                proto: true,
                forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
            }, {
                startsWith: function startsWith(searchString /* , position = 0 */ ) {
                    var that = String(requireObjectCoercible(this));
                    notARegExp(searchString);
                    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
                    var search = String(searchString);
                    return nativeStartsWith ? nativeStartsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
                }
            });
        /***/ },
        /***/ "2d00": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var userAgent = __webpack_require__("342f");
            var process = global.process;
            var versions = process && process.versions;
            var v8 = versions && versions.v8;
            var match, version;
            if (v8) {
                match = v8.split(".");
                version = match[0] + match[1];
            } else if (userAgent) {
                match = userAgent.match(/Edge\/(\d+)/);
                if (!match || match[1] >= 74) {
                    match = userAgent.match(/Chrome\/(\d+)/);
                    if (match) version = match[1];
                }
            }
            module1.exports = version && +version;
        /***/ },
        /***/ "342f": /***/ function(module1, exports, __webpack_require__) {
            var getBuiltIn = __webpack_require__("d066");
            module1.exports = getBuiltIn("navigator", "userAgent") || "";
        /***/ },
        /***/ "35a1": /***/ function(module1, exports, __webpack_require__) {
            var classof = __webpack_require__("f5df");
            var Iterators = __webpack_require__("3f8c");
            var wellKnownSymbol = __webpack_require__("b622");
            var ITERATOR = wellKnownSymbol("iterator");
            module1.exports = function(it) {
                if (it != undefined) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
            };
        /***/ },
        /***/ "37e8": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var definePropertyModule = __webpack_require__("9bf2");
            var anObject = __webpack_require__("825a");
            var objectKeys = __webpack_require__("df75");
            // `Object.defineProperties` method
            // https://tc39.github.io/ecma262/#sec-object.defineproperties
            module1.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = objectKeys(Properties);
                var length = keys.length;
                var index = 0;
                var key;
                while(length > index)definePropertyModule.f(O, key = keys[index++], Properties[key]);
                return O;
            };
        /***/ },
        /***/ "3bbe": /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__("861d");
            module1.exports = function(it) {
                if (!isObject(it) && it !== null) throw TypeError("Can't set " + String(it) + " as a prototype");
                return it;
            };
        /***/ },
        /***/ "3ca3": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var charAt = __webpack_require__("6547").charAt;
            var InternalStateModule = __webpack_require__("69f3");
            var defineIterator = __webpack_require__("7dd0");
            var STRING_ITERATOR = "String Iterator";
            var setInternalState = InternalStateModule.set;
            var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
            // `String.prototype[@@iterator]` method
            // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
            defineIterator(String, "String", function(iterated) {
                setInternalState(this, {
                    type: STRING_ITERATOR,
                    string: String(iterated),
                    index: 0
                });
            // `%StringIteratorPrototype%.next` method
            // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
            }, function next() {
                var state = getInternalState(this);
                var string = state.string;
                var index = state.index;
                var point;
                if (index >= string.length) return {
                    value: undefined,
                    done: true
                };
                point = charAt(string, index);
                state.index += point.length;
                return {
                    value: point,
                    done: false
                };
            });
        /***/ },
        /***/ "3f8c": /***/ function(module1, exports) {
            module1.exports = {};
        /***/ },
        /***/ "4160": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var forEach = __webpack_require__("17c2");
            // `Array.prototype.forEach` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
            $({
                target: "Array",
                proto: true,
                forced: [].forEach != forEach
            }, {
                forEach: forEach
            });
        /***/ },
        /***/ "428f": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            module1.exports = global;
        /***/ },
        /***/ "44ad": /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__("d039");
            var classof = __webpack_require__("c6b6");
            var split = "".split;
            // fallback for non-array-like ES3 and non-enumerable old V8 strings
            module1.exports = fails(function() {
                // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                // eslint-disable-next-line no-prototype-builtins
                return !Object("z").propertyIsEnumerable(0);
            }) ? function(it) {
                return classof(it) == "String" ? split.call(it, "") : Object(it);
            } : Object;
        /***/ },
        /***/ "44d2": /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__("b622");
            var create = __webpack_require__("7c73");
            var definePropertyModule = __webpack_require__("9bf2");
            var UNSCOPABLES = wellKnownSymbol("unscopables");
            var ArrayPrototype = Array.prototype;
            // Array.prototype[@@unscopables]
            // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
            if (ArrayPrototype[UNSCOPABLES] == undefined) definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
                configurable: true,
                value: create(null)
            });
            // add a key to Array.prototype[@@unscopables]
            module1.exports = function(key) {
                ArrayPrototype[UNSCOPABLES][key] = true;
            };
        /***/ },
        /***/ "44e7": /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__("861d");
            var classof = __webpack_require__("c6b6");
            var wellKnownSymbol = __webpack_require__("b622");
            var MATCH = wellKnownSymbol("match");
            // `IsRegExp` abstract operation
            // https://tc39.github.io/ecma262/#sec-isregexp
            module1.exports = function(it) {
                var isRegExp;
                return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == "RegExp");
            };
        /***/ },
        /***/ "4930": /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__("d039");
            module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                // Chrome 38 Symbol has incorrect toString conversion
                // eslint-disable-next-line no-undef
                return !String(Symbol());
            });
        /***/ },
        /***/ "4d64": /***/ function(module1, exports, __webpack_require__) {
            var toIndexedObject = __webpack_require__("fc6a");
            var toLength = __webpack_require__("50c4");
            var toAbsoluteIndex = __webpack_require__("23cb");
            // `Array.prototype.{ indexOf, includes }` methods implementation
            var createMethod = function(IS_INCLUDES) {
                return function($this, el, fromIndex) {
                    var O = toIndexedObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el) while(length > index){
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare
                        if (value != value) return true;
                    // Array#indexOf ignores holes, Array#includes - not
                    }
                    else for(; length > index; index++){
                        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                    }
                    return !IS_INCLUDES && -1;
                };
            };
            module1.exports = {
                // `Array.prototype.includes` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.includes
                includes: createMethod(true),
                // `Array.prototype.indexOf` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
                indexOf: createMethod(false)
            };
        /***/ },
        /***/ "4de4": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var $filter = __webpack_require__("b727").filter;
            var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
            // Edge 14- issue
            var USES_TO_LENGTH = arrayMethodUsesToLength("filter");
            // `Array.prototype.filter` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.filter
            // with adding support of @@species
            $({
                target: "Array",
                proto: true,
                forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
            }, {
                filter: function filter(callbackfn /* , thisArg */ ) {
                    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
        /***/ },
        /***/ "4df4": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var bind = __webpack_require__("0366");
            var toObject = __webpack_require__("7b0b");
            var callWithSafeIterationClosing = __webpack_require__("9bdd");
            var isArrayIteratorMethod = __webpack_require__("e95a");
            var toLength = __webpack_require__("50c4");
            var createProperty = __webpack_require__("8418");
            var getIteratorMethod = __webpack_require__("35a1");
            // `Array.from` method implementation
            // https://tc39.github.io/ecma262/#sec-array.from
            module1.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
                var O = toObject(arrayLike);
                var C = typeof this == "function" ? this : Array;
                var argumentsLength = arguments.length;
                var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                var mapping = mapfn !== undefined;
                var iteratorMethod = getIteratorMethod(O);
                var index = 0;
                var length, result, step, iterator, next, value;
                if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
                // if the target is not iterable or it's an array with the default iterator - use a simple case
                if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
                    iterator = iteratorMethod.call(O);
                    next = iterator.next;
                    result = new C();
                    for(; !(step = next.call(iterator)).done; index++){
                        value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                            step.value,
                            index
                        ], true) : step.value;
                        createProperty(result, index, value);
                    }
                } else {
                    length = toLength(O.length);
                    result = new C(length);
                    for(; length > index; index++){
                        value = mapping ? mapfn(O[index], index) : O[index];
                        createProperty(result, index, value);
                    }
                }
                result.length = index;
                return result;
            };
        /***/ },
        /***/ "4fad": /***/ function(module1, exports, __webpack_require__) {
            var $ = __webpack_require__("23e7");
            var $entries = __webpack_require__("6f53").entries;
            // `Object.entries` method
            // https://tc39.github.io/ecma262/#sec-object.entries
            $({
                target: "Object",
                stat: true
            }, {
                entries: function entries(O) {
                    return $entries(O);
                }
            });
        /***/ },
        /***/ "50c4": /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__("a691");
            var min = Math.min;
            // `ToLength` abstract operation
            // https://tc39.github.io/ecma262/#sec-tolength
            module1.exports = function(argument) {
                return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
            };
        /***/ },
        /***/ "5135": /***/ function(module1, exports) {
            var hasOwnProperty = {}.hasOwnProperty;
            module1.exports = function(it, key) {
                return hasOwnProperty.call(it, key);
            };
        /***/ },
        /***/ "5319": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
            var anObject = __webpack_require__("825a");
            var toObject = __webpack_require__("7b0b");
            var toLength = __webpack_require__("50c4");
            var toInteger = __webpack_require__("a691");
            var requireObjectCoercible = __webpack_require__("1d80");
            var advanceStringIndex = __webpack_require__("8aa5");
            var regExpExec = __webpack_require__("14c3");
            var max = Math.max;
            var min = Math.min;
            var floor = Math.floor;
            var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
            var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;
            var maybeToString = function(it) {
                return it === undefined ? it : String(it);
            };
            // @@replace logic
            fixRegExpWellKnownSymbolLogic("replace", 2, function(REPLACE, nativeReplace, maybeCallNative, reason) {
                var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
                var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
                var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
                return [
                    // `String.prototype.replace` method
                    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                    function replace(searchValue, replaceValue) {
                        var O = requireObjectCoercible(this);
                        var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
                        return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
                    },
                    // `RegExp.prototype[@@replace]` method
                    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                    function(regexp, replaceValue) {
                        if (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0 || typeof replaceValue === "string" && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1) {
                            var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
                            if (res.done) return res.value;
                        }
                        var rx = anObject(regexp);
                        var S = String(this);
                        var functionalReplace = typeof replaceValue === "function";
                        if (!functionalReplace) replaceValue = String(replaceValue);
                        var global = rx.global;
                        if (global) {
                            var fullUnicode = rx.unicode;
                            rx.lastIndex = 0;
                        }
                        var results = [];
                        while(true){
                            var result = regExpExec(rx, S);
                            if (result === null) break;
                            results.push(result);
                            if (!global) break;
                            var matchStr = String(result[0]);
                            if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                        }
                        var accumulatedResult = "";
                        var nextSourcePosition = 0;
                        for(var i = 0; i < results.length; i++){
                            result = results[i];
                            var matched = String(result[0]);
                            var position = max(min(toInteger(result.index), S.length), 0);
                            var captures = [];
                            // NOTE: This is equivalent to
                            //   captures = result.slice(1).map(maybeToString)
                            // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                            // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                            // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                            for(var j = 1; j < result.length; j++)captures.push(maybeToString(result[j]));
                            var namedCaptures = result.groups;
                            if (functionalReplace) {
                                var replacerArgs = [
                                    matched
                                ].concat(captures, position, S);
                                if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                                var replacement = String(replaceValue.apply(undefined, replacerArgs));
                            } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                            if (position >= nextSourcePosition) {
                                accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                                nextSourcePosition = position + matched.length;
                            }
                        }
                        return accumulatedResult + S.slice(nextSourcePosition);
                    }
                ];
                // https://tc39.github.io/ecma262/#sec-getsubstitution
                function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
                    var tailPos = position + matched.length;
                    var m = captures.length;
                    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
                    if (namedCaptures !== undefined) {
                        namedCaptures = toObject(namedCaptures);
                        symbols = SUBSTITUTION_SYMBOLS;
                    }
                    return nativeReplace.call(replacement, symbols, function(match, ch) {
                        var capture;
                        switch(ch.charAt(0)){
                            case "$":
                                return "$";
                            case "&":
                                return matched;
                            case "`":
                                return str.slice(0, position);
                            case "'":
                                return str.slice(tailPos);
                            case "<":
                                capture = namedCaptures[ch.slice(1, -1)];
                                break;
                            default:
                                var n = +ch;
                                if (n === 0) return match;
                                if (n > m) {
                                    var f = floor(n / 10);
                                    if (f === 0) return match;
                                    if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                                    return match;
                                }
                                capture = captures[n - 1];
                        }
                        return capture === undefined ? "" : capture;
                    });
                }
            });
        /***/ },
        /***/ "5692": /***/ function(module1, exports, __webpack_require__) {
            var IS_PURE = __webpack_require__("c430");
            var store = __webpack_require__("c6cd");
            (module1.exports = function(key, value) {
                return store[key] || (store[key] = value !== undefined ? value : {});
            })("versions", []).push({
                version: "3.6.5",
                mode: IS_PURE ? "pure" : "global",
                copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
            });
        /***/ },
        /***/ "56ef": /***/ function(module1, exports, __webpack_require__) {
            var getBuiltIn = __webpack_require__("d066");
            var getOwnPropertyNamesModule = __webpack_require__("241c");
            var getOwnPropertySymbolsModule = __webpack_require__("7418");
            var anObject = __webpack_require__("825a");
            // all object keys, includes non-enumerable and symbols
            module1.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
                var keys = getOwnPropertyNamesModule.f(anObject(it));
                var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
            };
        /***/ },
        /***/ "5a34": /***/ function(module1, exports, __webpack_require__) {
            var isRegExp = __webpack_require__("44e7");
            module1.exports = function(it) {
                if (isRegExp(it)) throw TypeError("The method doesn't accept regular expressions");
                return it;
            };
        /***/ },
        /***/ "5c6c": /***/ function(module1, exports) {
            module1.exports = function(bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };
        /***/ },
        /***/ "5db7": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var flattenIntoArray = __webpack_require__("a2bf");
            var toObject = __webpack_require__("7b0b");
            var toLength = __webpack_require__("50c4");
            var aFunction = __webpack_require__("1c0b");
            var arraySpeciesCreate = __webpack_require__("65f0");
            // `Array.prototype.flatMap` method
            // https://github.com/tc39/proposal-flatMap
            $({
                target: "Array",
                proto: true
            }, {
                flatMap: function flatMap(callbackfn /* , thisArg */ ) {
                    var O = toObject(this);
                    var sourceLen = toLength(O.length);
                    var A;
                    aFunction(callbackfn);
                    A = arraySpeciesCreate(O, 0);
                    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    return A;
                }
            });
        /***/ },
        /***/ "6547": /***/ function(module1, exports, __webpack_require__) {
            var toInteger = __webpack_require__("a691");
            var requireObjectCoercible = __webpack_require__("1d80");
            // `String.prototype.{ codePointAt, at }` methods implementation
            var createMethod = function(CONVERT_TO_STRING) {
                return function($this, pos) {
                    var S = String(requireObjectCoercible($this));
                    var position = toInteger(pos);
                    var size = S.length;
                    var first, second;
                    if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
                    first = S.charCodeAt(position);
                    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
                };
            };
            module1.exports = {
                // `String.prototype.codePointAt` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
                codeAt: createMethod(false),
                // `String.prototype.at` method
                // https://github.com/mathiasbynens/String.prototype.at
                charAt: createMethod(true)
            };
        /***/ },
        /***/ "65f0": /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__("861d");
            var isArray = __webpack_require__("e8b5");
            var wellKnownSymbol = __webpack_require__("b622");
            var SPECIES = wellKnownSymbol("species");
            // `ArraySpeciesCreate` abstract operation
            // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
            module1.exports = function(originalArray, length) {
                var C;
                if (isArray(originalArray)) {
                    C = originalArray.constructor;
                    // cross-realm fallback
                    if (typeof C == "function" && (C === Array || isArray(C.prototype))) C = undefined;
                    else if (isObject(C)) {
                        C = C[SPECIES];
                        if (C === null) C = undefined;
                    }
                }
                return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
            };
        /***/ },
        /***/ "69f3": /***/ function(module1, exports, __webpack_require__) {
            var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
            var global = __webpack_require__("da84");
            var isObject = __webpack_require__("861d");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var objectHas = __webpack_require__("5135");
            var sharedKey = __webpack_require__("f772");
            var hiddenKeys = __webpack_require__("d012");
            var WeakMap = global.WeakMap;
            var set, get, has;
            var enforce = function(it) {
                return has(it) ? get(it) : set(it, {});
            };
            var getterFor = function(TYPE) {
                return function(it) {
                    var state;
                    if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
                    return state;
                };
            };
            if (NATIVE_WEAK_MAP) {
                var store = new WeakMap();
                var wmget = store.get;
                var wmhas = store.has;
                var wmset = store.set;
                set = function(it, metadata) {
                    wmset.call(store, it, metadata);
                    return metadata;
                };
                get = function(it) {
                    return wmget.call(store, it) || {};
                };
                has = function(it) {
                    return wmhas.call(store, it);
                };
            } else {
                var STATE = sharedKey("state");
                hiddenKeys[STATE] = true;
                set = function(it, metadata) {
                    createNonEnumerableProperty(it, STATE, metadata);
                    return metadata;
                };
                get = function(it) {
                    return objectHas(it, STATE) ? it[STATE] : {};
                };
                has = function(it) {
                    return objectHas(it, STATE);
                };
            }
            module1.exports = {
                set: set,
                get: get,
                has: has,
                enforce: enforce,
                getterFor: getterFor
            };
        /***/ },
        /***/ "6eeb": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var has = __webpack_require__("5135");
            var setGlobal = __webpack_require__("ce4e");
            var inspectSource = __webpack_require__("8925");
            var InternalStateModule = __webpack_require__("69f3");
            var getInternalState = InternalStateModule.get;
            var enforceInternalState = InternalStateModule.enforce;
            var TEMPLATE = String(String).split("String");
            (module1.exports = function(O, key, value, options) {
                var unsafe = options ? !!options.unsafe : false;
                var simple = options ? !!options.enumerable : false;
                var noTargetGet = options ? !!options.noTargetGet : false;
                if (typeof value == "function") {
                    if (typeof key == "string" && !has(value, "name")) createNonEnumerableProperty(value, "name", key);
                    enforceInternalState(value).source = TEMPLATE.join(typeof key == "string" ? key : "");
                }
                if (O === global) {
                    if (simple) O[key] = value;
                    else setGlobal(key, value);
                    return;
                } else if (!unsafe) delete O[key];
                else if (!noTargetGet && O[key]) simple = true;
                if (simple) O[key] = value;
                else createNonEnumerableProperty(O, key, value);
            // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
            })(Function.prototype, "toString", function toString() {
                return typeof this == "function" && getInternalState(this).source || inspectSource(this);
            });
        /***/ },
        /***/ "6f53": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var objectKeys = __webpack_require__("df75");
            var toIndexedObject = __webpack_require__("fc6a");
            var propertyIsEnumerable = __webpack_require__("d1e7").f;
            // `Object.{ entries, values }` methods implementation
            var createMethod = function(TO_ENTRIES) {
                return function(it) {
                    var O = toIndexedObject(it);
                    var keys = objectKeys(O);
                    var length = keys.length;
                    var i = 0;
                    var result = [];
                    var key;
                    while(length > i){
                        key = keys[i++];
                        if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) result.push(TO_ENTRIES ? [
                            key,
                            O[key]
                        ] : O[key]);
                    }
                    return result;
                };
            };
            module1.exports = {
                // `Object.entries` method
                // https://tc39.github.io/ecma262/#sec-object.entries
                entries: createMethod(true),
                // `Object.values` method
                // https://tc39.github.io/ecma262/#sec-object.values
                values: createMethod(false)
            };
        /***/ },
        /***/ "73d9": /***/ function(module1, exports, __webpack_require__) {
            // this method was added to unscopables after implementation
            // in popular engines, so it's moved to a separate module
            var addToUnscopables = __webpack_require__("44d2");
            addToUnscopables("flatMap");
        /***/ },
        /***/ "7418": /***/ function(module1, exports) {
            exports.f = Object.getOwnPropertySymbols;
        /***/ },
        /***/ "746f": /***/ function(module1, exports, __webpack_require__) {
            var path = __webpack_require__("428f");
            var has = __webpack_require__("5135");
            var wrappedWellKnownSymbolModule = __webpack_require__("e538");
            var defineProperty = __webpack_require__("9bf2").f;
            module1.exports = function(NAME) {
                var Symbol1 = path.Symbol || (path.Symbol = {});
                if (!has(Symbol1, NAME)) defineProperty(Symbol1, NAME, {
                    value: wrappedWellKnownSymbolModule.f(NAME)
                });
            };
        /***/ },
        /***/ "7839": /***/ function(module1, exports) {
            // IE8- don't enum bug keys
            module1.exports = [
                "constructor",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "toLocaleString",
                "toString",
                "valueOf"
            ];
        /***/ },
        /***/ "7b0b": /***/ function(module1, exports, __webpack_require__) {
            var requireObjectCoercible = __webpack_require__("1d80");
            // `ToObject` abstract operation
            // https://tc39.github.io/ecma262/#sec-toobject
            module1.exports = function(argument) {
                return Object(requireObjectCoercible(argument));
            };
        /***/ },
        /***/ "7c73": /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__("825a");
            var defineProperties = __webpack_require__("37e8");
            var enumBugKeys = __webpack_require__("7839");
            var hiddenKeys = __webpack_require__("d012");
            var html = __webpack_require__("1be4");
            var documentCreateElement = __webpack_require__("cc12");
            var sharedKey = __webpack_require__("f772");
            var GT = ">";
            var LT = "<";
            var PROTOTYPE = "prototype";
            var SCRIPT = "script";
            var IE_PROTO = sharedKey("IE_PROTO");
            var EmptyConstructor = function() {};
            var scriptTag = function(content) {
                return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
            };
            // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
            var NullProtoObjectViaActiveX = function(activeXDocument) {
                activeXDocument.write(scriptTag(""));
                activeXDocument.close();
                var temp = activeXDocument.parentWindow.Object;
                activeXDocument = null; // avoid memory leak
                return temp;
            };
            // Create object with fake `null` prototype: use iframe Object with cleared prototype
            var NullProtoObjectViaIFrame = function() {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = documentCreateElement("iframe");
                var JS = "java" + SCRIPT + ":";
                var iframeDocument;
                iframe.style.display = "none";
                html.appendChild(iframe);
                // https://github.com/zloirock/core-js/issues/475
                iframe.src = String(JS);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(scriptTag("document.F=Object"));
                iframeDocument.close();
                return iframeDocument.F;
            };
            // Check for document.domain and active x support
            // No need to use active x approach when document.domain is not set
            // see https://github.com/es-shims/es5-shim/issues/150
            // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
            // avoid IE GC bug
            var activeXDocument;
            var NullProtoObject = function() {
                try {
                    /* global ActiveXObject */ activeXDocument = document.domain && new ActiveXObject("htmlfile");
                } catch (error) {}
                NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
                var length = enumBugKeys.length;
                while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                return NullProtoObject();
            };
            hiddenKeys[IE_PROTO] = true;
            // `Object.create` method
            // https://tc39.github.io/ecma262/#sec-object.create
            module1.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    EmptyConstructor[PROTOTYPE] = anObject(O);
                    result = new EmptyConstructor();
                    EmptyConstructor[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                } else result = NullProtoObject();
                return Properties === undefined ? result : defineProperties(result, Properties);
            };
        /***/ },
        /***/ "7dd0": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var createIteratorConstructor = __webpack_require__("9ed3");
            var getPrototypeOf = __webpack_require__("e163");
            var setPrototypeOf = __webpack_require__("d2bb");
            var setToStringTag = __webpack_require__("d44e");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var redefine = __webpack_require__("6eeb");
            var wellKnownSymbol = __webpack_require__("b622");
            var IS_PURE = __webpack_require__("c430");
            var Iterators = __webpack_require__("3f8c");
            var IteratorsCore = __webpack_require__("ae93");
            var IteratorPrototype = IteratorsCore.IteratorPrototype;
            var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
            var ITERATOR = wellKnownSymbol("iterator");
            var KEYS = "keys";
            var VALUES = "values";
            var ENTRIES = "entries";
            var returnThis = function() {
                return this;
            };
            module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                createIteratorConstructor(IteratorConstructor, NAME, next);
                var getIterationMethod = function(KIND) {
                    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                    switch(KIND){
                        case KEYS:
                            return function keys() {
                                return new IteratorConstructor(this, KIND);
                            };
                        case VALUES:
                            return function values() {
                                return new IteratorConstructor(this, KIND);
                            };
                        case ENTRIES:
                            return function entries() {
                                return new IteratorConstructor(this, KIND);
                            };
                    }
                    return function() {
                        return new IteratorConstructor(this);
                    };
                };
                var TO_STRING_TAG = NAME + " Iterator";
                var INCORRECT_VALUES_NAME = false;
                var IterablePrototype = Iterable.prototype;
                var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
                var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
                var CurrentIteratorPrototype, methods, KEY;
                // fix native
                if (anyNativeIterator) {
                    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                        if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                            if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                            else if (typeof CurrentIteratorPrototype[ITERATOR] != "function") createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
                        }
                        // Set @@toStringTag to native iterators
                        setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                        if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                    INCORRECT_VALUES_NAME = true;
                    defaultIterator = function values() {
                        return nativeIterator.call(this);
                    };
                }
                // define iterator
                if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
                Iterators[NAME] = defaultIterator;
                // export additional methods
                if (DEFAULT) {
                    methods = {
                        values: getIterationMethod(VALUES),
                        keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                        entries: getIterationMethod(ENTRIES)
                    };
                    if (FORCED) {
                        for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
                    } else $({
                        target: NAME,
                        proto: true,
                        forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                    }, methods);
                }
                return methods;
            };
        /***/ },
        /***/ "7f9a": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var inspectSource = __webpack_require__("8925");
            var WeakMap = global.WeakMap;
            module1.exports = typeof WeakMap === "function" && /native code/.test(inspectSource(WeakMap));
        /***/ },
        /***/ "825a": /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__("861d");
            module1.exports = function(it) {
                if (!isObject(it)) throw TypeError(String(it) + " is not an object");
                return it;
            };
        /***/ },
        /***/ "83ab": /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__("d039");
            // Thank's IE8 for his funny defineProperty
            module1.exports = !fails(function() {
                return Object.defineProperty({}, 1, {
                    get: function() {
                        return 7;
                    }
                })[1] != 7;
            });
        /***/ },
        /***/ "8418": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var toPrimitive = __webpack_require__("c04e");
            var definePropertyModule = __webpack_require__("9bf2");
            var createPropertyDescriptor = __webpack_require__("5c6c");
            module1.exports = function(object, key, value) {
                var propertyKey = toPrimitive(key);
                if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                else object[propertyKey] = value;
            };
        /***/ },
        /***/ "861d": /***/ function(module1, exports) {
            module1.exports = function(it) {
                return typeof it === "object" ? it !== null : typeof it === "function";
            };
        /***/ },
        /***/ "8875": /***/ function(module1, exports, __webpack_require__) {
            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // addapted from the document.currentScript polyfill by Adam Miller
            // MIT license
            // source: https://github.com/amiller-gh/currentScript-polyfill
            // added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505
            (function(root, factory) {
                __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
            })(typeof self !== "undefined" ? self : this, function() {
                function getCurrentScript() {
                    var descriptor = Object.getOwnPropertyDescriptor(document, "currentScript");
                    // for chrome
                    if (!descriptor && "currentScript" in document && document.currentScript) return document.currentScript;
                    // for other browsers with native support for currentScript
                    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) return document.currentScript;
                    // IE 8-10 support script readyState
                    // IE 11+ & Firefox support stack trace
                    try {
                        throw new Error();
                    } catch (err) {
                        // Find the second match for the "at" string to get file src url from stack.
                        var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig, ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig, stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack), scriptLocation = stackDetails && stackDetails[1] || false, line = stackDetails && stackDetails[2] || false, currentLocation = document.location.href.replace(document.location.hash, ""), pageSource, inlineScriptSourceRegExp, inlineScriptSource, scripts = document.getElementsByTagName("script"); // Live NodeList collection
                        if (scriptLocation === currentLocation) {
                            pageSource = document.documentElement.outerHTML;
                            inlineScriptSourceRegExp = new RegExp("(?:[^\\n]+?\\n){0," + (line - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i");
                            inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, "$1").trim();
                        }
                        for(var i = 0; i < scripts.length; i++){
                            // If ready state is interactive, return the script tag
                            if (scripts[i].readyState === "interactive") return scripts[i];
                            // If src matches, return the script tag
                            if (scripts[i].src === scriptLocation) return scripts[i];
                            // If inline source matches, return the script tag
                            if (scriptLocation === currentLocation && scripts[i].innerHTML && scripts[i].innerHTML.trim() === inlineScriptSource) return scripts[i];
                        }
                        // If no match, return null
                        return null;
                    }
                }
                return getCurrentScript;
            });
        /***/ },
        /***/ "8925": /***/ function(module1, exports, __webpack_require__) {
            var store = __webpack_require__("c6cd");
            var functionToString = Function.toString;
            // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
            if (typeof store.inspectSource != "function") store.inspectSource = function(it) {
                return functionToString.call(it);
            };
            module1.exports = store.inspectSource;
        /***/ },
        /***/ "8aa5": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var charAt = __webpack_require__("6547").charAt;
            // `AdvanceStringIndex` abstract operation
            // https://tc39.github.io/ecma262/#sec-advancestringindex
            module1.exports = function(S, index, unicode) {
                return index + (unicode ? charAt(S, index).length : 1);
            };
        /***/ },
        /***/ "8bbf": /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;
        /***/ },
        /***/ "90e3": /***/ function(module1, exports) {
            var id = 0;
            var postfix = Math.random();
            module1.exports = function(key) {
                return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++id + postfix).toString(36);
            };
        /***/ },
        /***/ "9112": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var definePropertyModule = __webpack_require__("9bf2");
            var createPropertyDescriptor = __webpack_require__("5c6c");
            module1.exports = DESCRIPTORS ? function(object, key, value) {
                return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
            } : function(object, key, value) {
                object[key] = value;
                return object;
            };
        /***/ },
        /***/ "9263": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var regexpFlags = __webpack_require__("ad6d");
            var stickyHelpers = __webpack_require__("9f7f");
            var nativeExec = RegExp.prototype.exec;
            // This always refers to the native implementation, because the
            // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
            // which loads this file before patching the method.
            var nativeReplace = String.prototype.replace;
            var patchedExec = nativeExec;
            var UPDATES_LAST_INDEX_WRONG = function() {
                var re1 = /a/;
                var re2 = /b*/g;
                nativeExec.call(re1, "a");
                nativeExec.call(re2, "a");
                return re1.lastIndex !== 0 || re2.lastIndex !== 0;
            }();
            var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;
            // nonparticipating capturing group, copied from es5-shim's String#split patch.
            var NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
            var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;
            if (PATCH) patchedExec = function exec(str) {
                var re = this;
                var lastIndex, reCopy, match, i;
                var sticky = UNSUPPORTED_Y && re.sticky;
                var flags = regexpFlags.call(re);
                var source = re.source;
                var charsAdded = 0;
                var strCopy = str;
                if (sticky) {
                    flags = flags.replace("y", "");
                    if (flags.indexOf("g") === -1) flags += "g";
                    strCopy = String(str).slice(re.lastIndex);
                    // Support anchored sticky behavior.
                    if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== "\n")) {
                        source = "(?: " + source + ")";
                        strCopy = " " + strCopy;
                        charsAdded++;
                    }
                    // ^(? + rx + ) is needed, in combination with some str slicing, to
                    // simulate the 'y' flag.
                    reCopy = new RegExp("^(?:" + source + ")", flags);
                }
                if (NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
                if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
                match = nativeExec.call(sticky ? reCopy : re, strCopy);
                if (sticky) {
                    if (match) {
                        match.input = match.input.slice(charsAdded);
                        match[0] = match[0].slice(charsAdded);
                        match.index = re.lastIndex;
                        re.lastIndex += match[0].length;
                    } else re.lastIndex = 0;
                } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
                if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
                // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
                nativeReplace.call(match[0], reCopy, function() {
                    for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
                });
                return match;
            };
            module1.exports = patchedExec;
        /***/ },
        /***/ "94ca": /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__("d039");
            var replacement = /#|\.prototype\./;
            var isForced = function(feature, detection) {
                var value = data[normalize(feature)];
                return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == "function" ? fails(detection) : !!detection;
            };
            var normalize = isForced.normalize = function(string) {
                return String(string).replace(replacement, ".").toLowerCase();
            };
            var data = isForced.data = {};
            var NATIVE = isForced.NATIVE = "N";
            var POLYFILL = isForced.POLYFILL = "P";
            module1.exports = isForced;
        /***/ },
        /***/ "99af": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var fails = __webpack_require__("d039");
            var isArray = __webpack_require__("e8b5");
            var isObject = __webpack_require__("861d");
            var toObject = __webpack_require__("7b0b");
            var toLength = __webpack_require__("50c4");
            var createProperty = __webpack_require__("8418");
            var arraySpeciesCreate = __webpack_require__("65f0");
            var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
            var wellKnownSymbol = __webpack_require__("b622");
            var V8_VERSION = __webpack_require__("2d00");
            var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
            var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
            var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
            // We can't use this feature detection in V8 since it causes
            // deoptimization and serious performance degradation
            // https://github.com/zloirock/core-js/issues/679
            var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
                var array = [];
                array[IS_CONCAT_SPREADABLE] = false;
                return array.concat()[0] !== array;
            });
            var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");
            var isConcatSpreadable = function(O) {
                if (!isObject(O)) return false;
                var spreadable = O[IS_CONCAT_SPREADABLE];
                return spreadable !== undefined ? !!spreadable : isArray(O);
            };
            var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
            // `Array.prototype.concat` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.concat
            // with adding support of @@isConcatSpreadable and @@species
            $({
                target: "Array",
                proto: true,
                forced: FORCED
            }, {
                concat: function concat(arg) {
                    var O = toObject(this);
                    var A = arraySpeciesCreate(O, 0);
                    var n = 0;
                    var i, k, length, len, E;
                    for(i = -1, length = arguments.length; i < length; i++){
                        E = i === -1 ? O : arguments[i];
                        if (isConcatSpreadable(E)) {
                            len = toLength(E.length);
                            if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                            for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                        } else {
                            if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                            createProperty(A, n++, E);
                        }
                    }
                    A.length = n;
                    return A;
                }
            });
        /***/ },
        /***/ "9bdd": /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__("825a");
            // call something on iterator step with safe closing on error
            module1.exports = function(iterator, fn, value, ENTRIES) {
                try {
                    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                // 7.4.6 IteratorClose(iterator, completion)
                } catch (error) {
                    var returnMethod = iterator["return"];
                    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
                    throw error;
                }
            };
        /***/ },
        /***/ "9bf2": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var IE8_DOM_DEFINE = __webpack_require__("0cfb");
            var anObject = __webpack_require__("825a");
            var toPrimitive = __webpack_require__("c04e");
            var nativeDefineProperty = Object.defineProperty;
            // `Object.defineProperty` method
            // https://tc39.github.io/ecma262/#sec-object.defineproperty
            exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return nativeDefineProperty(O, P, Attributes);
                } catch (error) {}
                if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
                if ("value" in Attributes) O[P] = Attributes.value;
                return O;
            };
        /***/ },
        /***/ "9ed3": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
            var create = __webpack_require__("7c73");
            var createPropertyDescriptor = __webpack_require__("5c6c");
            var setToStringTag = __webpack_require__("d44e");
            var Iterators = __webpack_require__("3f8c");
            var returnThis = function() {
                return this;
            };
            module1.exports = function(IteratorConstructor, NAME, next) {
                var TO_STRING_TAG = NAME + " Iterator";
                IteratorConstructor.prototype = create(IteratorPrototype, {
                    next: createPropertyDescriptor(1, next)
                });
                setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                Iterators[TO_STRING_TAG] = returnThis;
                return IteratorConstructor;
            };
        /***/ },
        /***/ "9f7f": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var fails = __webpack_require__("d039");
            // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
            // so we use an intermediate function.
            function RE(s, f) {
                return RegExp(s, f);
            }
            exports.UNSUPPORTED_Y = fails(function() {
                // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
                var re = RE("a", "y");
                re.lastIndex = 2;
                return re.exec("abcd") != null;
            });
            exports.BROKEN_CARET = fails(function() {
                // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
                var re = RE("^r", "gy");
                re.lastIndex = 2;
                return re.exec("str") != null;
            });
        /***/ },
        /***/ "a2bf": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var isArray = __webpack_require__("e8b5");
            var toLength = __webpack_require__("50c4");
            var bind = __webpack_require__("0366");
            // `FlattenIntoArray` abstract operation
            // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
            var flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
                var targetIndex = start;
                var sourceIndex = 0;
                var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
                var element;
                while(sourceIndex < sourceLen){
                    if (sourceIndex in source) {
                        element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
                        if (depth > 0 && isArray(element)) targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
                        else {
                            if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError("Exceed the acceptable array length");
                            target[targetIndex] = element;
                        }
                        targetIndex++;
                    }
                    sourceIndex++;
                }
                return targetIndex;
            };
            module1.exports = flattenIntoArray;
        /***/ },
        /***/ "a352": /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_a352__;
        /***/ },
        /***/ "a434": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var toAbsoluteIndex = __webpack_require__("23cb");
            var toInteger = __webpack_require__("a691");
            var toLength = __webpack_require__("50c4");
            var toObject = __webpack_require__("7b0b");
            var arraySpeciesCreate = __webpack_require__("65f0");
            var createProperty = __webpack_require__("8418");
            var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("splice");
            var USES_TO_LENGTH = arrayMethodUsesToLength("splice", {
                ACCESSORS: true,
                0: 0,
                1: 2
            });
            var max = Math.max;
            var min = Math.min;
            var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
            var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = "Maximum allowed length exceeded";
            // `Array.prototype.splice` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.splice
            // with adding support of @@species
            $({
                target: "Array",
                proto: true,
                forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
            }, {
                splice: function splice(start, deleteCount /* , ...items */ ) {
                    var O = toObject(this);
                    var len = toLength(O.length);
                    var actualStart = toAbsoluteIndex(start, len);
                    var argumentsLength = arguments.length;
                    var insertCount, actualDeleteCount, A, k, from, to;
                    if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
                    else if (argumentsLength === 1) {
                        insertCount = 0;
                        actualDeleteCount = len - actualStart;
                    } else {
                        insertCount = argumentsLength - 2;
                        actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
                    }
                    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
                    A = arraySpeciesCreate(O, actualDeleteCount);
                    for(k = 0; k < actualDeleteCount; k++){
                        from = actualStart + k;
                        if (from in O) createProperty(A, k, O[from]);
                    }
                    A.length = actualDeleteCount;
                    if (insertCount < actualDeleteCount) {
                        for(k = actualStart; k < len - actualDeleteCount; k++){
                            from = k + actualDeleteCount;
                            to = k + insertCount;
                            if (from in O) O[to] = O[from];
                            else delete O[to];
                        }
                        for(k = len; k > len - actualDeleteCount + insertCount; k--)delete O[k - 1];
                    } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
                        from = k + actualDeleteCount - 1;
                        to = k + insertCount - 1;
                        if (from in O) O[to] = O[from];
                        else delete O[to];
                    }
                    for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
                    O.length = len - actualDeleteCount + insertCount;
                    return A;
                }
            });
        /***/ },
        /***/ "a4d3": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var global = __webpack_require__("da84");
            var getBuiltIn = __webpack_require__("d066");
            var IS_PURE = __webpack_require__("c430");
            var DESCRIPTORS = __webpack_require__("83ab");
            var NATIVE_SYMBOL = __webpack_require__("4930");
            var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
            var fails = __webpack_require__("d039");
            var has = __webpack_require__("5135");
            var isArray = __webpack_require__("e8b5");
            var isObject = __webpack_require__("861d");
            var anObject = __webpack_require__("825a");
            var toObject = __webpack_require__("7b0b");
            var toIndexedObject = __webpack_require__("fc6a");
            var toPrimitive = __webpack_require__("c04e");
            var createPropertyDescriptor = __webpack_require__("5c6c");
            var nativeObjectCreate = __webpack_require__("7c73");
            var objectKeys = __webpack_require__("df75");
            var getOwnPropertyNamesModule = __webpack_require__("241c");
            var getOwnPropertyNamesExternal = __webpack_require__("057f");
            var getOwnPropertySymbolsModule = __webpack_require__("7418");
            var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
            var definePropertyModule = __webpack_require__("9bf2");
            var propertyIsEnumerableModule = __webpack_require__("d1e7");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var redefine = __webpack_require__("6eeb");
            var shared = __webpack_require__("5692");
            var sharedKey = __webpack_require__("f772");
            var hiddenKeys = __webpack_require__("d012");
            var uid = __webpack_require__("90e3");
            var wellKnownSymbol = __webpack_require__("b622");
            var wrappedWellKnownSymbolModule = __webpack_require__("e538");
            var defineWellKnownSymbol = __webpack_require__("746f");
            var setToStringTag = __webpack_require__("d44e");
            var InternalStateModule = __webpack_require__("69f3");
            var $forEach = __webpack_require__("b727").forEach;
            var HIDDEN = sharedKey("hidden");
            var SYMBOL = "Symbol";
            var PROTOTYPE = "prototype";
            var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
            var setInternalState = InternalStateModule.set;
            var getInternalState = InternalStateModule.getterFor(SYMBOL);
            var ObjectPrototype = Object[PROTOTYPE];
            var $Symbol = global.Symbol;
            var $stringify = getBuiltIn("JSON", "stringify");
            var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            var nativeDefineProperty = definePropertyModule.f;
            var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
            var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
            var AllSymbols = shared("symbols");
            var ObjectPrototypeSymbols = shared("op-symbols");
            var StringToSymbolRegistry = shared("string-to-symbol-registry");
            var SymbolToStringRegistry = shared("symbol-to-string-registry");
            var WellKnownSymbolsStore = shared("wks");
            var QObject = global.QObject;
            // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
            var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
            // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
            var setSymbolDescriptor = DESCRIPTORS && fails(function() {
                return nativeObjectCreate(nativeDefineProperty({}, "a", {
                    get: function() {
                        return nativeDefineProperty(this, "a", {
                            value: 7
                        }).a;
                    }
                })).a != 7;
            }) ? function(O, P, Attributes) {
                var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
                if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
                nativeDefineProperty(O, P, Attributes);
                if (ObjectPrototypeDescriptor && O !== ObjectPrototype) nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
            } : nativeDefineProperty;
            var wrap = function(tag, description) {
                var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
                setInternalState(symbol, {
                    type: SYMBOL,
                    tag: tag,
                    description: description
                });
                if (!DESCRIPTORS) symbol.description = description;
                return symbol;
            };
            var isSymbol = USE_SYMBOL_AS_UID ? function(it) {
                return typeof it == "symbol";
            } : function(it) {
                return Object(it) instanceof $Symbol;
            };
            var $defineProperty = function defineProperty(O, P, Attributes) {
                if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
                anObject(O);
                var key = toPrimitive(P, true);
                anObject(Attributes);
                if (has(AllSymbols, key)) {
                    if (!Attributes.enumerable) {
                        if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
                        O[HIDDEN][key] = true;
                    } else {
                        if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                        Attributes = nativeObjectCreate(Attributes, {
                            enumerable: createPropertyDescriptor(0, false)
                        });
                    }
                    return setSymbolDescriptor(O, key, Attributes);
                }
                return nativeDefineProperty(O, key, Attributes);
            };
            var $defineProperties = function defineProperties(O, Properties) {
                anObject(O);
                var properties = toIndexedObject(Properties);
                var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
                $forEach(keys, function(key) {
                    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
                });
                return O;
            };
            var $create = function create(O, Properties) {
                return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
            };
            var $propertyIsEnumerable = function propertyIsEnumerable(V) {
                var P = toPrimitive(V, true);
                var enumerable = nativePropertyIsEnumerable.call(this, P);
                if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
                return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
            };
            var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
                var it = toIndexedObject(O);
                var key = toPrimitive(P, true);
                if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
                var descriptor = nativeGetOwnPropertyDescriptor(it, key);
                if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
                return descriptor;
            };
            var $getOwnPropertyNames = function getOwnPropertyNames(O) {
                var names = nativeGetOwnPropertyNames(toIndexedObject(O));
                var result = [];
                $forEach(names, function(key) {
                    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
                });
                return result;
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
                var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
                var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
                var result = [];
                $forEach(names, function(key) {
                    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) result.push(AllSymbols[key]);
                });
                return result;
            };
            // `Symbol` constructor
            // https://tc39.github.io/ecma262/#sec-symbol-constructor
            if (!NATIVE_SYMBOL) {
                $Symbol = function Symbol1() {
                    if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor");
                    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
                    var tag = uid(description);
                    var setter = function(value) {
                        if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
                        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                        setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
                    };
                    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                        configurable: true,
                        set: setter
                    });
                    return wrap(tag, description);
                };
                redefine($Symbol[PROTOTYPE], "toString", function toString() {
                    return getInternalState(this).tag;
                });
                redefine($Symbol, "withoutSetter", function(description) {
                    return wrap(uid(description), description);
                });
                propertyIsEnumerableModule.f = $propertyIsEnumerable;
                definePropertyModule.f = $defineProperty;
                getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
                getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
                getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
                wrappedWellKnownSymbolModule.f = function(name) {
                    return wrap(wellKnownSymbol(name), name);
                };
                if (DESCRIPTORS) {
                    // https://github.com/tc39/proposal-Symbol-description
                    nativeDefineProperty($Symbol[PROTOTYPE], "description", {
                        configurable: true,
                        get: function description() {
                            return getInternalState(this).description;
                        }
                    });
                    if (!IS_PURE) redefine(ObjectPrototype, "propertyIsEnumerable", $propertyIsEnumerable, {
                        unsafe: true
                    });
                }
            }
            $({
                global: true,
                wrap: true,
                forced: !NATIVE_SYMBOL,
                sham: !NATIVE_SYMBOL
            }, {
                Symbol: $Symbol
            });
            $forEach(objectKeys(WellKnownSymbolsStore), function(name) {
                defineWellKnownSymbol(name);
            });
            $({
                target: SYMBOL,
                stat: true,
                forced: !NATIVE_SYMBOL
            }, {
                // `Symbol.for` method
                // https://tc39.github.io/ecma262/#sec-symbol.for
                "for": function(key) {
                    var string = String(key);
                    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
                    var symbol = $Symbol(string);
                    StringToSymbolRegistry[string] = symbol;
                    SymbolToStringRegistry[symbol] = string;
                    return symbol;
                },
                // `Symbol.keyFor` method
                // https://tc39.github.io/ecma262/#sec-symbol.keyfor
                keyFor: function keyFor(sym) {
                    if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol");
                    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
                },
                useSetter: function() {
                    USE_SETTER = true;
                },
                useSimple: function() {
                    USE_SETTER = false;
                }
            });
            $({
                target: "Object",
                stat: true,
                forced: !NATIVE_SYMBOL,
                sham: !DESCRIPTORS
            }, {
                // `Object.create` method
                // https://tc39.github.io/ecma262/#sec-object.create
                create: $create,
                // `Object.defineProperty` method
                // https://tc39.github.io/ecma262/#sec-object.defineproperty
                defineProperty: $defineProperty,
                // `Object.defineProperties` method
                // https://tc39.github.io/ecma262/#sec-object.defineproperties
                defineProperties: $defineProperties,
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
                getOwnPropertyDescriptor: $getOwnPropertyDescriptor
            });
            $({
                target: "Object",
                stat: true,
                forced: !NATIVE_SYMBOL
            }, {
                // `Object.getOwnPropertyNames` method
                // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
                getOwnPropertyNames: $getOwnPropertyNames,
                // `Object.getOwnPropertySymbols` method
                // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
                getOwnPropertySymbols: $getOwnPropertySymbols
            });
            // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
            // https://bugs.chromium.org/p/v8/issues/detail?id=3443
            $({
                target: "Object",
                stat: true,
                forced: fails(function() {
                    getOwnPropertySymbolsModule.f(1);
                })
            }, {
                getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                    return getOwnPropertySymbolsModule.f(toObject(it));
                }
            });
            // `JSON.stringify` method behavior with symbols
            // https://tc39.github.io/ecma262/#sec-json.stringify
            if ($stringify) {
                var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function() {
                    var symbol = $Symbol();
                    // MS Edge converts symbol values to JSON as {}
                    return $stringify([
                        symbol
                    ]) != "[null]" || $stringify({
                        a: symbol
                    }) != "{}" || $stringify(Object(symbol)) != "{}";
                });
                $({
                    target: "JSON",
                    stat: true,
                    forced: FORCED_JSON_STRINGIFY
                }, {
                    // eslint-disable-next-line no-unused-vars
                    stringify: function stringify(it, replacer, space) {
                        var args = [
                            it
                        ];
                        var index = 1;
                        var $replacer;
                        while(arguments.length > index)args.push(arguments[index++]);
                        $replacer = replacer;
                        if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                        if (!isArray(replacer)) replacer = function(key, value) {
                            if (typeof $replacer == "function") value = $replacer.call(this, key, value);
                            if (!isSymbol(value)) return value;
                        };
                        args[1] = replacer;
                        return $stringify.apply(null, args);
                    }
                });
            }
            // `Symbol.prototype[@@toPrimitive]` method
            // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
            if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
            // `Symbol.prototype[@@toStringTag]` property
            // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
            setToStringTag($Symbol, SYMBOL);
            hiddenKeys[HIDDEN] = true;
        /***/ },
        /***/ "a630": /***/ function(module1, exports, __webpack_require__) {
            var $ = __webpack_require__("23e7");
            var from = __webpack_require__("4df4");
            var checkCorrectnessOfIteration = __webpack_require__("1c7e");
            var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
                Array.from(iterable);
            });
            // `Array.from` method
            // https://tc39.github.io/ecma262/#sec-array.from
            $({
                target: "Array",
                stat: true,
                forced: INCORRECT_ITERATION
            }, {
                from: from
            });
        /***/ },
        /***/ "a640": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var fails = __webpack_require__("d039");
            module1.exports = function(METHOD_NAME, argument) {
                var method = [][METHOD_NAME];
                return !!method && fails(function() {
                    // eslint-disable-next-line no-useless-call,no-throw-literal
                    method.call(null, argument || function() {
                        throw 1;
                    }, 1);
                });
            };
        /***/ },
        /***/ "a691": /***/ function(module1, exports) {
            var ceil = Math.ceil;
            var floor = Math.floor;
            // `ToInteger` abstract operation
            // https://tc39.github.io/ecma262/#sec-tointeger
            module1.exports = function(argument) {
                return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
            };
        /***/ },
        /***/ "ab13": /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__("b622");
            var MATCH = wellKnownSymbol("match");
            module1.exports = function(METHOD_NAME) {
                var regexp = /./;
                try {
                    "/./"[METHOD_NAME](regexp);
                } catch (e) {
                    try {
                        regexp[MATCH] = false;
                        return "/./"[METHOD_NAME](regexp);
                    } catch (f) {}
                }
                return false;
            };
        /***/ },
        /***/ "ac1f": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var exec = __webpack_require__("9263");
            $({
                target: "RegExp",
                proto: true,
                forced: /./.exec !== exec
            }, {
                exec: exec
            });
        /***/ },
        /***/ "ad6d": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var anObject = __webpack_require__("825a");
            // `RegExp.prototype.flags` getter implementation
            // https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
            module1.exports = function() {
                var that = anObject(this);
                var result = "";
                if (that.global) result += "g";
                if (that.ignoreCase) result += "i";
                if (that.multiline) result += "m";
                if (that.dotAll) result += "s";
                if (that.unicode) result += "u";
                if (that.sticky) result += "y";
                return result;
            };
        /***/ },
        /***/ "ae40": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var fails = __webpack_require__("d039");
            var has = __webpack_require__("5135");
            var defineProperty = Object.defineProperty;
            var cache = {};
            var thrower = function(it) {
                throw it;
            };
            module1.exports = function(METHOD_NAME, options) {
                if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
                if (!options) options = {};
                var method = [][METHOD_NAME];
                var ACCESSORS = has(options, "ACCESSORS") ? options.ACCESSORS : false;
                var argument0 = has(options, 0) ? options[0] : thrower;
                var argument1 = has(options, 1) ? options[1] : undefined;
                return cache[METHOD_NAME] = !!method && !fails(function() {
                    if (ACCESSORS && !DESCRIPTORS) return true;
                    var O = {
                        length: -1
                    };
                    if (ACCESSORS) defineProperty(O, 1, {
                        enumerable: true,
                        get: thrower
                    });
                    else O[1] = 1;
                    method.call(O, argument0, argument1);
                });
            };
        /***/ },
        /***/ "ae93": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var getPrototypeOf = __webpack_require__("e163");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var has = __webpack_require__("5135");
            var wellKnownSymbol = __webpack_require__("b622");
            var IS_PURE = __webpack_require__("c430");
            var ITERATOR = wellKnownSymbol("iterator");
            var BUGGY_SAFARI_ITERATORS = false;
            var returnThis = function() {
                return this;
            };
            // `%IteratorPrototype%` object
            // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
            var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
            if ([].keys) {
                arrayIterator = [].keys();
                // Safari 8 has buggy iterators w/o `next`
                if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                else {
                    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                }
            }
            if (IteratorPrototype == undefined) IteratorPrototype = {};
            // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
            module1.exports = {
                IteratorPrototype: IteratorPrototype,
                BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
            };
        /***/ },
        /***/ "b041": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
            var classof = __webpack_require__("f5df");
            // `Object.prototype.toString` method implementation
            // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
            module1.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
                return "[object " + classof(this) + "]";
            };
        /***/ },
        /***/ "b0c0": /***/ function(module1, exports, __webpack_require__) {
            var DESCRIPTORS = __webpack_require__("83ab");
            var defineProperty = __webpack_require__("9bf2").f;
            var FunctionPrototype = Function.prototype;
            var FunctionPrototypeToString = FunctionPrototype.toString;
            var nameRE = /^\s*function ([^ (]*)/;
            var NAME = "name";
            // Function instances `.name` property
            // https://tc39.github.io/ecma262/#sec-function-instances-name
            if (DESCRIPTORS && !(NAME in FunctionPrototype)) defineProperty(FunctionPrototype, NAME, {
                configurable: true,
                get: function() {
                    try {
                        return FunctionPrototypeToString.call(this).match(nameRE)[1];
                    } catch (error) {
                        return "";
                    }
                }
            });
        /***/ },
        /***/ "b622": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var shared = __webpack_require__("5692");
            var has = __webpack_require__("5135");
            var uid = __webpack_require__("90e3");
            var NATIVE_SYMBOL = __webpack_require__("4930");
            var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
            var WellKnownSymbolsStore = shared("wks");
            var Symbol1 = global.Symbol;
            var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
            module1.exports = function(name) {
                if (!has(WellKnownSymbolsStore, name)) {
                    if (NATIVE_SYMBOL && has(Symbol1, name)) WellKnownSymbolsStore[name] = Symbol1[name];
                    else WellKnownSymbolsStore[name] = createWellKnownSymbol("Symbol." + name);
                }
                return WellKnownSymbolsStore[name];
            };
        /***/ },
        /***/ "b64b": /***/ function(module1, exports, __webpack_require__) {
            var $ = __webpack_require__("23e7");
            var toObject = __webpack_require__("7b0b");
            var nativeKeys = __webpack_require__("df75");
            var fails = __webpack_require__("d039");
            var FAILS_ON_PRIMITIVES = fails(function() {
                nativeKeys(1);
            });
            // `Object.keys` method
            // https://tc39.github.io/ecma262/#sec-object.keys
            $({
                target: "Object",
                stat: true,
                forced: FAILS_ON_PRIMITIVES
            }, {
                keys: function keys(it) {
                    return nativeKeys(toObject(it));
                }
            });
        /***/ },
        /***/ "b727": /***/ function(module1, exports, __webpack_require__) {
            var bind = __webpack_require__("0366");
            var IndexedObject = __webpack_require__("44ad");
            var toObject = __webpack_require__("7b0b");
            var toLength = __webpack_require__("50c4");
            var arraySpeciesCreate = __webpack_require__("65f0");
            var push = [].push;
            // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
            var createMethod = function(TYPE) {
                var IS_MAP = TYPE == 1;
                var IS_FILTER = TYPE == 2;
                var IS_SOME = TYPE == 3;
                var IS_EVERY = TYPE == 4;
                var IS_FIND_INDEX = TYPE == 6;
                var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
                return function($this, callbackfn, that, specificCreate) {
                    var O = toObject($this);
                    var self1 = IndexedObject(O);
                    var boundFunction = bind(callbackfn, that, 3);
                    var length = toLength(self1.length);
                    var index = 0;
                    var create = specificCreate || arraySpeciesCreate;
                    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
                    var value, result;
                    for(; length > index; index++)if (NO_HOLES || index in self1) {
                        value = self1[index];
                        result = boundFunction(value, index, O);
                        if (TYPE) {
                            if (IS_MAP) target[index] = result; // map
                            else if (result) switch(TYPE){
                                case 3:
                                    return true; // some
                                case 5:
                                    return value; // find
                                case 6:
                                    return index; // findIndex
                                case 2:
                                    push.call(target, value); // filter
                            }
                            else if (IS_EVERY) return false; // every
                        }
                    }
                    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
                };
            };
            module1.exports = {
                // `Array.prototype.forEach` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
                forEach: createMethod(0),
                // `Array.prototype.map` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.map
                map: createMethod(1),
                // `Array.prototype.filter` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.filter
                filter: createMethod(2),
                // `Array.prototype.some` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.some
                some: createMethod(3),
                // `Array.prototype.every` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.every
                every: createMethod(4),
                // `Array.prototype.find` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.find
                find: createMethod(5),
                // `Array.prototype.findIndex` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
                findIndex: createMethod(6)
            };
        /***/ },
        /***/ "c04e": /***/ function(module1, exports, __webpack_require__) {
            var isObject = __webpack_require__("861d");
            // `ToPrimitive` abstract operation
            // https://tc39.github.io/ecma262/#sec-toprimitive
            // instead of the ES6 spec version, we didn't implement @@toPrimitive case
            // and the second argument - flag - preferred type is a string
            module1.exports = function(input, PREFERRED_STRING) {
                if (!isObject(input)) return input;
                var fn, val;
                if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject(val = fn.call(input))) return val;
                if (typeof (fn = input.valueOf) == "function" && !isObject(val = fn.call(input))) return val;
                if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject(val = fn.call(input))) return val;
                throw TypeError("Can't convert object to primitive value");
            };
        /***/ },
        /***/ "c430": /***/ function(module1, exports) {
            module1.exports = false;
        /***/ },
        /***/ "c6b6": /***/ function(module1, exports) {
            var toString = {}.toString;
            module1.exports = function(it) {
                return toString.call(it).slice(8, -1);
            };
        /***/ },
        /***/ "c6cd": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var setGlobal = __webpack_require__("ce4e");
            var SHARED = "__core-js_shared__";
            var store = global[SHARED] || setGlobal(SHARED, {});
            module1.exports = store;
        /***/ },
        /***/ "c740": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var $findIndex = __webpack_require__("b727").findIndex;
            var addToUnscopables = __webpack_require__("44d2");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var FIND_INDEX = "findIndex";
            var SKIPS_HOLES = true;
            var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);
            // Shouldn't skip holes
            if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
                SKIPS_HOLES = false;
            });
            // `Array.prototype.findIndex` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.findindex
            $({
                target: "Array",
                proto: true,
                forced: SKIPS_HOLES || !USES_TO_LENGTH
            }, {
                findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
                    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
            // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
            addToUnscopables(FIND_INDEX);
        /***/ },
        /***/ "c8ba": /***/ function(module1, exports) {
            var g;
            // This works in non-strict mode
            g = function() {
                return this;
            }();
            try {
                // This works if eval is allowed (see CSP)
                g = g || new Function("return this")();
            } catch (e) {
                // This works if the window reference is available
                if (typeof window === "object") g = window;
            }
            // g can still be undefined, but nothing to do about it...
            // We return undefined, instead of nothing here, so it's
            // easier to handle this case. if(!global) { ...}
            module1.exports = g;
        /***/ },
        /***/ "c975": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var $indexOf = __webpack_require__("4d64").indexOf;
            var arrayMethodIsStrict = __webpack_require__("a640");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var nativeIndexOf = [].indexOf;
            var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [
                1
            ].indexOf(1, -0) < 0;
            var STRICT_METHOD = arrayMethodIsStrict("indexOf");
            var USES_TO_LENGTH = arrayMethodUsesToLength("indexOf", {
                ACCESSORS: true,
                1: 0
            });
            // `Array.prototype.indexOf` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
            $({
                target: "Array",
                proto: true,
                forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH
            }, {
                indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
                    return NEGATIVE_ZERO ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
        /***/ },
        /***/ "ca84": /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__("5135");
            var toIndexedObject = __webpack_require__("fc6a");
            var indexOf = __webpack_require__("4d64").indexOf;
            var hiddenKeys = __webpack_require__("d012");
            module1.exports = function(object, names) {
                var O = toIndexedObject(object);
                var i = 0;
                var result = [];
                var key;
                for(key in O)!has(hiddenKeys, key) && has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while(names.length > i)if (has(O, key = names[i++])) ~indexOf(result, key) || result.push(key);
                return result;
            };
        /***/ },
        /***/ "caad": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var $includes = __webpack_require__("4d64").includes;
            var addToUnscopables = __webpack_require__("44d2");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var USES_TO_LENGTH = arrayMethodUsesToLength("indexOf", {
                ACCESSORS: true,
                1: 0
            });
            // `Array.prototype.includes` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.includes
            $({
                target: "Array",
                proto: true,
                forced: !USES_TO_LENGTH
            }, {
                includes: function includes(el /* , fromIndex = 0 */ ) {
                    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
            // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
            addToUnscopables("includes");
        /***/ },
        /***/ "cc12": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var isObject = __webpack_require__("861d");
            var document1 = global.document;
            // typeof document.createElement is 'object' in old IE
            var EXISTS = isObject(document1) && isObject(document1.createElement);
            module1.exports = function(it) {
                return EXISTS ? document1.createElement(it) : {};
            };
        /***/ },
        /***/ "ce4e": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var createNonEnumerableProperty = __webpack_require__("9112");
            module1.exports = function(key, value) {
                try {
                    createNonEnumerableProperty(global, key, value);
                } catch (error) {
                    global[key] = value;
                }
                return value;
            };
        /***/ },
        /***/ "d012": /***/ function(module1, exports) {
            module1.exports = {};
        /***/ },
        /***/ "d039": /***/ function(module1, exports) {
            module1.exports = function(exec) {
                try {
                    return !!exec();
                } catch (error) {
                    return true;
                }
            };
        /***/ },
        /***/ "d066": /***/ function(module1, exports, __webpack_require__) {
            var path = __webpack_require__("428f");
            var global = __webpack_require__("da84");
            var aFunction = function(variable) {
                return typeof variable == "function" ? variable : undefined;
            };
            module1.exports = function(namespace, method) {
                return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
            };
        /***/ },
        /***/ "d1e7": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
            var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            // Nashorn ~ JDK8 bug
            var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
                1: 2
            }, 1);
            // `Object.prototype.propertyIsEnumerable` method implementation
            // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
            exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                var descriptor = getOwnPropertyDescriptor(this, V);
                return !!descriptor && descriptor.enumerable;
            } : nativePropertyIsEnumerable;
        /***/ },
        /***/ "d28b": /***/ function(module1, exports, __webpack_require__) {
            var defineWellKnownSymbol = __webpack_require__("746f");
            // `Symbol.iterator` well-known symbol
            // https://tc39.github.io/ecma262/#sec-symbol.iterator
            defineWellKnownSymbol("iterator");
        /***/ },
        /***/ "d2bb": /***/ function(module1, exports, __webpack_require__) {
            var anObject = __webpack_require__("825a");
            var aPossiblePrototype = __webpack_require__("3bbe");
            // `Object.setPrototypeOf` method
            // https://tc39.github.io/ecma262/#sec-object.setprototypeof
            // Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */ module1.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                var CORRECT_SETTER = false;
                var test = {};
                var setter;
                try {
                    setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
                    setter.call(test, []);
                    CORRECT_SETTER = test instanceof Array;
                } catch (error) {}
                return function setPrototypeOf(O, proto) {
                    anObject(O);
                    aPossiblePrototype(proto);
                    if (CORRECT_SETTER) setter.call(O, proto);
                    else O.__proto__ = proto;
                    return O;
                };
            }() : undefined);
        /***/ },
        /***/ "d3b7": /***/ function(module1, exports, __webpack_require__) {
            var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
            var redefine = __webpack_require__("6eeb");
            var toString = __webpack_require__("b041");
            // `Object.prototype.toString` method
            // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
            if (!TO_STRING_TAG_SUPPORT) redefine(Object.prototype, "toString", toString, {
                unsafe: true
            });
        /***/ },
        /***/ "d44e": /***/ function(module1, exports, __webpack_require__) {
            var defineProperty = __webpack_require__("9bf2").f;
            var has = __webpack_require__("5135");
            var wellKnownSymbol = __webpack_require__("b622");
            var TO_STRING_TAG = wellKnownSymbol("toStringTag");
            module1.exports = function(it, TAG, STATIC) {
                if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
                    configurable: true,
                    value: TAG
                });
            };
        /***/ },
        /***/ "d58f": /***/ function(module1, exports, __webpack_require__) {
            var aFunction = __webpack_require__("1c0b");
            var toObject = __webpack_require__("7b0b");
            var IndexedObject = __webpack_require__("44ad");
            var toLength = __webpack_require__("50c4");
            // `Array.prototype.{ reduce, reduceRight }` methods implementation
            var createMethod = function(IS_RIGHT) {
                return function(that, callbackfn, argumentsLength, memo) {
                    aFunction(callbackfn);
                    var O = toObject(that);
                    var self1 = IndexedObject(O);
                    var length = toLength(O.length);
                    var index = IS_RIGHT ? length - 1 : 0;
                    var i = IS_RIGHT ? -1 : 1;
                    if (argumentsLength < 2) while(true){
                        if (index in self1) {
                            memo = self1[index];
                            index += i;
                            break;
                        }
                        index += i;
                        if (IS_RIGHT ? index < 0 : length <= index) throw TypeError("Reduce of empty array with no initial value");
                    }
                    for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
                    return memo;
                };
            };
            module1.exports = {
                // `Array.prototype.reduce` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
                left: createMethod(false),
                // `Array.prototype.reduceRight` method
                // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
                right: createMethod(true)
            };
        /***/ },
        /***/ "d784": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // TODO: Remove from `core-js@4` since it's moved to entry points
            __webpack_require__("ac1f");
            var redefine = __webpack_require__("6eeb");
            var fails = __webpack_require__("d039");
            var wellKnownSymbol = __webpack_require__("b622");
            var regexpExec = __webpack_require__("9263");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var SPECIES = wellKnownSymbol("species");
            var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
                // #replace needs built-in support for named groups.
                // #match works fine because it just return the exec results, even if it has
                // a "grops" property.
                var re = /./;
                re.exec = function() {
                    var result = [];
                    result.groups = {
                        a: "7"
                    };
                    return result;
                };
                return "".replace(re, "$<a>") !== "7";
            });
            // IE <= 11 replaces $0 with the whole match, as if it was $&
            // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
            var REPLACE_KEEPS_$0 = function() {
                return "a".replace(/./, "$0") === "$0";
            }();
            var REPLACE = wellKnownSymbol("replace");
            // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
            var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
                if (/./[REPLACE]) return /./[REPLACE]("a", "$0") === "";
                return false;
            }();
            // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
            // Weex JS has frozen built-in prototypes, so use try / catch wrapper
            var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
                var re = /(?:)/;
                var originalExec = re.exec;
                re.exec = function() {
                    return originalExec.apply(this, arguments);
                };
                var result = "ab".split(re);
                return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
            });
            module1.exports = function(KEY, length, exec, sham) {
                var SYMBOL = wellKnownSymbol(KEY);
                var DELEGATES_TO_SYMBOL = !fails(function() {
                    // String methods call symbol-named RegEp methods
                    var O = {};
                    O[SYMBOL] = function() {
                        return 7;
                    };
                    return ""[KEY](O) != 7;
                });
                var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                    // Symbol-named RegExp methods call .exec
                    var execCalled = false;
                    var re = /a/;
                    if (KEY === "split") {
                        // We can't use real regex here since it causes deoptimization
                        // and serious performance degradation in V8
                        // https://github.com/zloirock/core-js/issues/306
                        re = {};
                        // RegExp[@@split] doesn't call the regex's exec method, but first creates
                        // a new one. We need to return the patched regex when creating the new one.
                        re.constructor = {};
                        re.constructor[SPECIES] = function() {
                            return re;
                        };
                        re.flags = "";
                        re[SYMBOL] = /./[SYMBOL];
                    }
                    re.exec = function() {
                        execCalled = true;
                        return null;
                    };
                    re[SYMBOL]("");
                    return !execCalled;
                });
                if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === "replace" && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === "split" && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
                    var nativeRegExpMethod = /./[SYMBOL];
                    var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                        if (regexp.exec === regexpExec) {
                            if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                            // polyfilled function), leasing to infinite recursion.
                            // We avoid it by directly calling the native @@method method.
                            return {
                                done: true,
                                value: nativeRegExpMethod.call(regexp, str, arg2)
                            };
                            return {
                                done: true,
                                value: nativeMethod.call(str, regexp, arg2)
                            };
                        }
                        return {
                            done: false
                        };
                    }, {
                        REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
                        REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
                    });
                    var stringMethod = methods[0];
                    var regexMethod = methods[1];
                    redefine(String.prototype, KEY, stringMethod);
                    redefine(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
                        return regexMethod.call(string, this, arg);
                    } : function(string) {
                        return regexMethod.call(string, this);
                    });
                }
                if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], "sham", true);
            };
        /***/ },
        /***/ "d81d": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var $map = __webpack_require__("b727").map;
            var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
            // FF49- issue
            var USES_TO_LENGTH = arrayMethodUsesToLength("map");
            // `Array.prototype.map` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.map
            // with adding support of @@species
            $({
                target: "Array",
                proto: true,
                forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
            }, {
                map: function map(callbackfn /* , thisArg */ ) {
                    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
        /***/ },
        /***/ "da84": /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(global) {
                var check = function(it) {
                    return it && it.Math == Math && it;
                };
                // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                module1.exports = // eslint-disable-next-line no-undef
                check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || check(typeof global == "object" && global) || // eslint-disable-next-line no-new-func
                Function("return this")();
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__("c8ba"));
        /***/ },
        /***/ "dbb4": /***/ function(module1, exports, __webpack_require__) {
            var $ = __webpack_require__("23e7");
            var DESCRIPTORS = __webpack_require__("83ab");
            var ownKeys = __webpack_require__("56ef");
            var toIndexedObject = __webpack_require__("fc6a");
            var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
            var createProperty = __webpack_require__("8418");
            // `Object.getOwnPropertyDescriptors` method
            // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
            $({
                target: "Object",
                stat: true,
                sham: !DESCRIPTORS
            }, {
                getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                    var O = toIndexedObject(object);
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    var keys = ownKeys(O);
                    var result = {};
                    var index = 0;
                    var key, descriptor;
                    while(keys.length > index){
                        descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                        if (descriptor !== undefined) createProperty(result, key, descriptor);
                    }
                    return result;
                }
            });
        /***/ },
        /***/ "dbf1": /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(global) {
                __webpack_require__.d(__webpack_exports__, "a", function() {
                    return console;
                });
                function getConsole() {
                    if (typeof window !== "undefined") return window.console;
                    return global.console;
                }
                var console = getConsole();
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__("c8ba"));
        /***/ },
        /***/ "ddb0": /***/ function(module1, exports, __webpack_require__) {
            var global = __webpack_require__("da84");
            var DOMIterables = __webpack_require__("fdbc");
            var ArrayIteratorMethods = __webpack_require__("e260");
            var createNonEnumerableProperty = __webpack_require__("9112");
            var wellKnownSymbol = __webpack_require__("b622");
            var ITERATOR = wellKnownSymbol("iterator");
            var TO_STRING_TAG = wellKnownSymbol("toStringTag");
            var ArrayValues = ArrayIteratorMethods.values;
            for(var COLLECTION_NAME in DOMIterables){
                var Collection = global[COLLECTION_NAME];
                var CollectionPrototype = Collection && Collection.prototype;
                if (CollectionPrototype) {
                    // some Chrome versions have non-configurable methods on DOMTokenList
                    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
                        createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
                    } catch (error) {
                        CollectionPrototype[ITERATOR] = ArrayValues;
                    }
                    if (!CollectionPrototype[TO_STRING_TAG]) createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
                    if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
                        // some Chrome versions have non-configurable methods on DOMTokenList
                        if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                            createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                        } catch (error) {
                            CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                        }
                    }
                }
            }
        /***/ },
        /***/ "df75": /***/ function(module1, exports, __webpack_require__) {
            var internalObjectKeys = __webpack_require__("ca84");
            var enumBugKeys = __webpack_require__("7839");
            // `Object.keys` method
            // https://tc39.github.io/ecma262/#sec-object.keys
            module1.exports = Object.keys || function keys(O) {
                return internalObjectKeys(O, enumBugKeys);
            };
        /***/ },
        /***/ "e01a": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // `Symbol.prototype.description` getter
            // https://tc39.github.io/ecma262/#sec-symbol.prototype.description
            var $ = __webpack_require__("23e7");
            var DESCRIPTORS = __webpack_require__("83ab");
            var global = __webpack_require__("da84");
            var has = __webpack_require__("5135");
            var isObject = __webpack_require__("861d");
            var defineProperty = __webpack_require__("9bf2").f;
            var copyConstructorProperties = __webpack_require__("e893");
            var NativeSymbol = global.Symbol;
            if (DESCRIPTORS && typeof NativeSymbol == "function" && (!("description" in NativeSymbol.prototype) || // Safari 12 bug
            NativeSymbol().description !== undefined)) {
                var EmptyStringDescriptionStore = {};
                // wrap Symbol constructor for correct work with undefined description
                var SymbolWrapper = function Symbol1() {
                    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
                    var result = this instanceof SymbolWrapper ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
                    if (description === "") EmptyStringDescriptionStore[result] = true;
                    return result;
                };
                copyConstructorProperties(SymbolWrapper, NativeSymbol);
                var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
                symbolPrototype.constructor = SymbolWrapper;
                var symbolToString = symbolPrototype.toString;
                var native = String(NativeSymbol("test")) == "Symbol(test)";
                var regexp = /^Symbol\((.*)\)[^)]+$/;
                defineProperty(symbolPrototype, "description", {
                    configurable: true,
                    get: function description() {
                        var symbol = isObject(this) ? this.valueOf() : this;
                        var string = symbolToString.call(symbol);
                        if (has(EmptyStringDescriptionStore, symbol)) return "";
                        var desc = native ? string.slice(7, -1) : string.replace(regexp, "$1");
                        return desc === "" ? undefined : desc;
                    }
                });
                $({
                    global: true,
                    forced: true
                }, {
                    Symbol: SymbolWrapper
                });
            }
        /***/ },
        /***/ "e163": /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__("5135");
            var toObject = __webpack_require__("7b0b");
            var sharedKey = __webpack_require__("f772");
            var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");
            var IE_PROTO = sharedKey("IE_PROTO");
            var ObjectPrototype = Object.prototype;
            // `Object.getPrototypeOf` method
            // https://tc39.github.io/ecma262/#sec-object.getprototypeof
            module1.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function(O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
                return O instanceof Object ? ObjectPrototype : null;
            };
        /***/ },
        /***/ "e177": /***/ function(module1, exports, __webpack_require__) {
            var fails = __webpack_require__("d039");
            module1.exports = !fails(function() {
                function F() {}
                F.prototype.constructor = null;
                return Object.getPrototypeOf(new F()) !== F.prototype;
            });
        /***/ },
        /***/ "e260": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var toIndexedObject = __webpack_require__("fc6a");
            var addToUnscopables = __webpack_require__("44d2");
            var Iterators = __webpack_require__("3f8c");
            var InternalStateModule = __webpack_require__("69f3");
            var defineIterator = __webpack_require__("7dd0");
            var ARRAY_ITERATOR = "Array Iterator";
            var setInternalState = InternalStateModule.set;
            var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
            // `Array.prototype.entries` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.entries
            // `Array.prototype.keys` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.keys
            // `Array.prototype.values` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.values
            // `Array.prototype[@@iterator]` method
            // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
            // `CreateArrayIterator` internal method
            // https://tc39.github.io/ecma262/#sec-createarrayiterator
            module1.exports = defineIterator(Array, "Array", function(iterated, kind) {
                setInternalState(this, {
                    type: ARRAY_ITERATOR,
                    target: toIndexedObject(iterated),
                    index: 0,
                    kind: kind // kind
                });
            // `%ArrayIteratorPrototype%.next` method
            // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
            }, function() {
                var state = getInternalState(this);
                var target = state.target;
                var kind = state.kind;
                var index = state.index++;
                if (!target || index >= target.length) {
                    state.target = undefined;
                    return {
                        value: undefined,
                        done: true
                    };
                }
                if (kind == "keys") return {
                    value: index,
                    done: false
                };
                if (kind == "values") return {
                    value: target[index],
                    done: false
                };
                return {
                    value: [
                        index,
                        target[index]
                    ],
                    done: false
                };
            }, "values");
            // argumentsList[@@iterator] is %ArrayProto_values%
            // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
            // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
            Iterators.Arguments = Iterators.Array;
            // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
            addToUnscopables("keys");
            addToUnscopables("values");
            addToUnscopables("entries");
        /***/ },
        /***/ "e439": /***/ function(module1, exports, __webpack_require__) {
            var $ = __webpack_require__("23e7");
            var fails = __webpack_require__("d039");
            var toIndexedObject = __webpack_require__("fc6a");
            var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
            var DESCRIPTORS = __webpack_require__("83ab");
            var FAILS_ON_PRIMITIVES = fails(function() {
                nativeGetOwnPropertyDescriptor(1);
            });
            var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;
            // `Object.getOwnPropertyDescriptor` method
            // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
            $({
                target: "Object",
                stat: true,
                forced: FORCED,
                sham: !DESCRIPTORS
            }, {
                getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
                    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
                }
            });
        /***/ },
        /***/ "e538": /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__("b622");
            exports.f = wellKnownSymbol;
        /***/ },
        /***/ "e893": /***/ function(module1, exports, __webpack_require__) {
            var has = __webpack_require__("5135");
            var ownKeys = __webpack_require__("56ef");
            var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
            var definePropertyModule = __webpack_require__("9bf2");
            module1.exports = function(target, source) {
                var keys = ownKeys(source);
                var defineProperty = definePropertyModule.f;
                var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                for(var i = 0; i < keys.length; i++){
                    var key = keys[i];
                    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                }
            };
        /***/ },
        /***/ "e8b5": /***/ function(module1, exports, __webpack_require__) {
            var classof = __webpack_require__("c6b6");
            // `IsArray` abstract operation
            // https://tc39.github.io/ecma262/#sec-isarray
            module1.exports = Array.isArray || function isArray(arg) {
                return classof(arg) == "Array";
            };
        /***/ },
        /***/ "e95a": /***/ function(module1, exports, __webpack_require__) {
            var wellKnownSymbol = __webpack_require__("b622");
            var Iterators = __webpack_require__("3f8c");
            var ITERATOR = wellKnownSymbol("iterator");
            var ArrayPrototype = Array.prototype;
            // check on default Array iterator
            module1.exports = function(it) {
                return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
            };
        /***/ },
        /***/ "f5df": /***/ function(module1, exports, __webpack_require__) {
            var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
            var classofRaw = __webpack_require__("c6b6");
            var wellKnownSymbol = __webpack_require__("b622");
            var TO_STRING_TAG = wellKnownSymbol("toStringTag");
            // ES3 wrong here
            var CORRECT_ARGUMENTS = classofRaw(function() {
                return arguments;
            }()) == "Arguments";
            // fallback for IE11 Script Access Denied error
            var tryGet = function(it, key) {
                try {
                    return it[key];
                } catch (error) {}
            };
            // getting tag from ES6+ `Object.prototype.toString`
            module1.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                var O, tag, result;
                return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
            };
        /***/ },
        /***/ "f772": /***/ function(module1, exports, __webpack_require__) {
            var shared = __webpack_require__("5692");
            var uid = __webpack_require__("90e3");
            var keys = shared("keys");
            module1.exports = function(key) {
                return keys[key] || (keys[key] = uid(key));
            };
        /***/ },
        /***/ "fb15": /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            // ESM COMPAT FLAG
            __webpack_require__.r(__webpack_exports__);
            // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
            // This file is imported into lib/wc client bundles.
            if (typeof window !== "undefined") {
                var currentScript = window.document.currentScript;
                var getCurrentScript = __webpack_require__("8875");
                currentScript = getCurrentScript();
                // for backward compatibility, because previously we directly included the polyfill
                if (!("currentScript" in document)) Object.defineProperty(document, "currentScript", {
                    get: getCurrentScript
                });
                var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
                if (src) __webpack_require__.p = src[1] // eslint-disable-line
                ;
            }
            // Indicate to webpack that this file can be concatenated
            /* harmony default export */ var setPublicPath = null;
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
            var es_array_concat = __webpack_require__("99af");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
            var es_array_filter = __webpack_require__("4de4");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
            var es_array_for_each = __webpack_require__("4160");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
            var es_array_index_of = __webpack_require__("c975");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
            var es_array_map = __webpack_require__("d81d");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
            var es_array_splice = __webpack_require__("a434");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
            var web_dom_collections_for_each = __webpack_require__("159b");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
            var es_symbol = __webpack_require__("a4d3");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
            var es_object_get_own_property_descriptor = __webpack_require__("e439");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
            var es_object_get_own_property_descriptors = __webpack_require__("dbb4");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
            var es_object_keys = __webpack_require__("b64b");
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    if (enumerableOnly) symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    });
                    keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread2(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                    else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                    else ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
            var es_symbol_description = __webpack_require__("e01a");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
            var es_symbol_iterator = __webpack_require__("d28b");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
            var es_array_iterator = __webpack_require__("e260");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
            var es_object_to_string = __webpack_require__("d3b7");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
            var es_string_iterator = __webpack_require__("3ca3");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
            var web_dom_collections_iterator = __webpack_require__("ddb0");
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
            function _iterableToArrayLimit(arr, i) {
                if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
                var _arr = [];
                var _n = true;
                var _d = false;
                var _e = undefined;
                try {
                    for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                        _arr.push(_s.value);
                        if (i && _arr.length === i) break;
                    }
                } catch (err) {
                    _d = true;
                    _e = err;
                } finally{
                    try {
                        if (!_n && _i["return"] != null) _i["return"]();
                    } finally{
                        if (_d) throw _e;
                    }
                }
                return _arr;
            }
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
            var es_array_from = __webpack_require__("a630");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
            var es_array_slice = __webpack_require__("fb6a");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
            var es_function_name = __webpack_require__("b0c0");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
            var es_regexp_to_string = __webpack_require__("25f0");
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                return arr2;
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            // EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
            var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
            var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/ __webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);
            // CONCATENATED MODULE: ./src/util/htmlHelper.js
            function removeNode(node) {
                if (node.parentElement !== null) node.parentElement.removeChild(node);
            }
            function insertNodeAt(fatherNode, node, position) {
                var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
                fatherNode.insertBefore(node, refNode);
            }
            // EXTERNAL MODULE: ./src/util/console.js
            var console = __webpack_require__("dbf1");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
            var es_array_reduce = __webpack_require__("13d5");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
            var es_object_entries = __webpack_require__("4fad");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
            var es_regexp_exec = __webpack_require__("ac1f");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
            var es_string_replace = __webpack_require__("5319");
            // CONCATENATED MODULE: ./src/util/string.js
            function cached(fn) {
                var cache = Object.create(null);
                return function cachedFn(str) {
                    var hit = cache[str];
                    return hit || (cache[str] = fn(str));
                };
            }
            var regex = /-(\w)/g;
            var camelize = cached(function(str) {
                return str.replace(regex, function(_, c) {
                    return c.toUpperCase();
                });
            });
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat-map.js
            var es_array_flat_map = __webpack_require__("5db7");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
            var es_array_unscopables_flat_map = __webpack_require__("73d9");
            // CONCATENATED MODULE: ./src/core/sortableEvents.js
            var manageAndEmit = [
                "Start",
                "Add",
                "Remove",
                "Update",
                "End"
            ];
            var emit = [
                "Choose",
                "Unchoose",
                "Sort",
                "Filter",
                "Clone"
            ];
            var manage = [
                "Move"
            ];
            var eventHandlerNames = [
                manage,
                manageAndEmit,
                emit
            ].flatMap(function(events) {
                return events;
            }).map(function(evt) {
                return "on".concat(evt);
            });
            var events = {
                manage: manage,
                manageAndEmit: manageAndEmit,
                emit: emit
            };
            function isReadOnly(eventName) {
                return eventHandlerNames.indexOf(eventName) !== -1;
            }
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
            var es_array_includes = __webpack_require__("caad");
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
            var es_string_starts_with = __webpack_require__("2ca0");
            // CONCATENATED MODULE: ./src/util/tags.js
            var tags = [
                "a",
                "abbr",
                "address",
                "area",
                "article",
                "aside",
                "audio",
                "b",
                "base",
                "bdi",
                "bdo",
                "blockquote",
                "body",
                "br",
                "button",
                "canvas",
                "caption",
                "cite",
                "code",
                "col",
                "colgroup",
                "data",
                "datalist",
                "dd",
                "del",
                "details",
                "dfn",
                "dialog",
                "div",
                "dl",
                "dt",
                "em",
                "embed",
                "fieldset",
                "figcaption",
                "figure",
                "footer",
                "form",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "head",
                "header",
                "hgroup",
                "hr",
                "html",
                "i",
                "iframe",
                "img",
                "input",
                "ins",
                "kbd",
                "label",
                "legend",
                "li",
                "link",
                "main",
                "map",
                "mark",
                "math",
                "menu",
                "menuitem",
                "meta",
                "meter",
                "nav",
                "noscript",
                "object",
                "ol",
                "optgroup",
                "option",
                "output",
                "p",
                "param",
                "picture",
                "pre",
                "progress",
                "q",
                "rb",
                "rp",
                "rt",
                "rtc",
                "ruby",
                "s",
                "samp",
                "script",
                "section",
                "select",
                "slot",
                "small",
                "source",
                "span",
                "strong",
                "style",
                "sub",
                "summary",
                "sup",
                "svg",
                "table",
                "tbody",
                "td",
                "template",
                "textarea",
                "tfoot",
                "th",
                "thead",
                "time",
                "title",
                "tr",
                "track",
                "u",
                "ul",
                "var",
                "video",
                "wbr"
            ];
            function isHtmlTag(name) {
                return tags.includes(name);
            }
            function isTransition(name) {
                return [
                    "transition-group",
                    "TransitionGroup"
                ].includes(name);
            }
            function isHtmlAttribute(value) {
                return [
                    "id",
                    "class",
                    "role",
                    "style"
                ].includes(value) || value.startsWith("data-") || value.startsWith("aria-") || value.startsWith("on");
            }
            // CONCATENATED MODULE: ./src/core/componentBuilderHelper.js
            function project(entries) {
                return entries.reduce(function(res, _ref) {
                    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    res[key] = value;
                    return res;
                }, {});
            }
            function getComponentAttributes(_ref3) {
                var $attrs = _ref3.$attrs, _ref3$componentData = _ref3.componentData, componentData = _ref3$componentData === void 0 ? {} : _ref3$componentData;
                var attributes = project(Object.entries($attrs).filter(function(_ref4) {
                    var _ref5 = _slicedToArray(_ref4, 2), key = _ref5[0], _ = _ref5[1];
                    return isHtmlAttribute(key);
                }));
                return _objectSpread2(_objectSpread2({}, attributes), componentData);
            }
            function createSortableOption(_ref6) {
                var $attrs = _ref6.$attrs, callBackBuilder = _ref6.callBackBuilder;
                var options = project(getValidSortableEntries($attrs));
                Object.entries(callBackBuilder).forEach(function(_ref7) {
                    var _ref8 = _slicedToArray(_ref7, 2), eventType = _ref8[0], eventBuilder = _ref8[1];
                    events[eventType].forEach(function(event) {
                        options["on".concat(event)] = eventBuilder(event);
                    });
                });
                var draggable = "[data-draggable]".concat(options.draggable || "");
                return _objectSpread2(_objectSpread2({}, options), {}, {
                    draggable: draggable
                });
            }
            function getValidSortableEntries(value) {
                return Object.entries(value).filter(function(_ref9) {
                    var _ref10 = _slicedToArray(_ref9, 2), key = _ref10[0], _ = _ref10[1];
                    return !isHtmlAttribute(key);
                }).map(function(_ref11) {
                    var _ref12 = _slicedToArray(_ref11, 2), key = _ref12[0], value = _ref12[1];
                    return [
                        camelize(key),
                        value
                    ];
                }).filter(function(_ref13) {
                    var _ref14 = _slicedToArray(_ref13, 2), key = _ref14[0], _ = _ref14[1];
                    return !isReadOnly(key);
                });
            }
            // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
            var es_array_find_index = __webpack_require__("c740");
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            // CONCATENATED MODULE: ./src/core/componentStructure.js
            var getHtmlElementFromNode = function getHtmlElementFromNode(_ref) {
                var el = _ref.el;
                return el;
            };
            var addContext = function addContext(domElement, context) {
                return domElement.__draggable_context = context;
            };
            var getContext = function getContext(domElement) {
                return domElement.__draggable_context;
            };
            var componentStructure_ComponentStructure = /*#__PURE__*/ function() {
                function ComponentStructure(_ref2) {
                    var _ref2$nodes = _ref2.nodes, header = _ref2$nodes.header, defaultNodes = _ref2$nodes.default, footer = _ref2$nodes.footer, root = _ref2.root, realList = _ref2.realList;
                    _classCallCheck(this, ComponentStructure);
                    this.defaultNodes = defaultNodes;
                    this.children = [].concat(_toConsumableArray(header), _toConsumableArray(defaultNodes), _toConsumableArray(footer));
                    this.externalComponent = root.externalComponent;
                    this.rootTransition = root.transition;
                    this.tag = root.tag;
                    this.realList = realList;
                }
                _createClass(ComponentStructure, [
                    {
                        key: "render",
                        value: function render(h, attributes) {
                            var tag = this.tag, children = this.children, _isRootComponent = this._isRootComponent;
                            var option = !_isRootComponent ? children : {
                                default: function _default() {
                                    return children;
                                }
                            };
                            return h(tag, attributes, option);
                        }
                    },
                    {
                        key: "updated",
                        value: function updated() {
                            var defaultNodes = this.defaultNodes, realList = this.realList;
                            defaultNodes.forEach(function(node, index) {
                                addContext(getHtmlElementFromNode(node), {
                                    element: realList[index],
                                    index: index
                                });
                            });
                        }
                    },
                    {
                        key: "getUnderlyingVm",
                        value: function getUnderlyingVm(domElement) {
                            return getContext(domElement);
                        }
                    },
                    {
                        key: "getVmIndexFromDomIndex",
                        value: function getVmIndexFromDomIndex(domIndex, element) {
                            var defaultNodes = this.defaultNodes;
                            var length = defaultNodes.length;
                            var domChildren = element.children;
                            var domElement = domChildren.item(domIndex);
                            if (domElement === null) return length;
                            var context = getContext(domElement);
                            if (context) return context.index;
                            if (length === 0) return 0;
                            var firstDomListElement = getHtmlElementFromNode(defaultNodes[0]);
                            var indexFirstDomListElement = _toConsumableArray(domChildren).findIndex(function(element) {
                                return element === firstDomListElement;
                            });
                            return domIndex < indexFirstDomListElement ? 0 : length;
                        }
                    },
                    {
                        key: "_isRootComponent",
                        get: function get() {
                            return this.externalComponent || this.rootTransition;
                        }
                    }
                ]);
                return ComponentStructure;
            }();
            // EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
            var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
            // CONCATENATED MODULE: ./src/core/renderHelper.js
            function getSlot(slots, key) {
                var slotValue = slots[key];
                return slotValue ? slotValue() : [];
            }
            function computeNodes(_ref) {
                var $slots = _ref.$slots, realList = _ref.realList, getKey = _ref.getKey;
                var normalizedList = realList || [];
                var _map = [
                    "header",
                    "footer"
                ].map(function(name) {
                    return getSlot($slots, name);
                }), _map2 = _slicedToArray(_map, 2), header = _map2[0], footer = _map2[1];
                var item = $slots.item;
                if (!item) throw new Error("draggable element must have an item slot");
                var defaultNodes = normalizedList.flatMap(function(element, index) {
                    return item({
                        element: element,
                        index: index
                    }).map(function(node) {
                        node.key = getKey(element);
                        node.props = _objectSpread2(_objectSpread2({}, node.props || {}), {}, {
                            "data-draggable": true
                        });
                        return node;
                    });
                });
                if (defaultNodes.length !== normalizedList.length) throw new Error("Item slot must have only one child");
                return {
                    header: header,
                    footer: footer,
                    default: defaultNodes
                };
            }
            function getRootInformation(tag) {
                var transition = isTransition(tag);
                var externalComponent = !isHtmlTag(tag) && !transition;
                return {
                    transition: transition,
                    externalComponent: externalComponent,
                    tag: externalComponent ? Object(external_commonjs_vue_commonjs2_vue_root_Vue_["resolveComponent"])(tag) : transition ? external_commonjs_vue_commonjs2_vue_root_Vue_["TransitionGroup"] : tag
                };
            }
            function computeComponentStructure(_ref2) {
                var $slots = _ref2.$slots, tag = _ref2.tag, realList = _ref2.realList, getKey = _ref2.getKey;
                var nodes = computeNodes({
                    $slots: $slots,
                    realList: realList,
                    getKey: getKey
                });
                var root = getRootInformation(tag);
                return new componentStructure_ComponentStructure({
                    nodes: nodes,
                    root: root,
                    realList: realList
                });
            }
            // CONCATENATED MODULE: ./src/vuedraggable.js
            function _emit(evtName, evtData) {
                var _this = this;
                Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])(function() {
                    return _this.$emit(evtName.toLowerCase(), evtData);
                });
            }
            function _manage(evtName) {
                var _this2 = this;
                return function(evtData, originalElement) {
                    if (_this2.realList !== null) return _this2["onDrag".concat(evtName)](evtData, originalElement);
                };
            }
            function _manageAndEmit(evtName) {
                var _this3 = this;
                var delegateCallBack = _manage.call(this, evtName);
                return function(evtData, originalElement) {
                    delegateCallBack.call(_this3, evtData, originalElement);
                    _emit.call(_this3, evtName, evtData);
                };
            }
            var draggingElement = null;
            var props = {
                list: {
                    type: Array,
                    required: false,
                    default: null
                },
                modelValue: {
                    type: Array,
                    required: false,
                    default: null
                },
                itemKey: {
                    type: [
                        String,
                        Function
                    ],
                    required: true
                },
                clone: {
                    type: Function,
                    default: function _default(original) {
                        return original;
                    }
                },
                tag: {
                    type: String,
                    default: "div"
                },
                move: {
                    type: Function,
                    default: null
                },
                componentData: {
                    type: Object,
                    required: false,
                    default: null
                }
            };
            var emits = [
                "update:modelValue",
                "change"
            ].concat(_toConsumableArray([].concat(_toConsumableArray(events.manageAndEmit), _toConsumableArray(events.emit)).map(function(evt) {
                return evt.toLowerCase();
            })));
            var draggableComponent = Object(external_commonjs_vue_commonjs2_vue_root_Vue_["defineComponent"])({
                name: "draggable",
                inheritAttrs: false,
                props: props,
                emits: emits,
                data: function data() {
                    return {
                        error: false
                    };
                },
                render: function render() {
                    try {
                        this.error = false;
                        var $slots = this.$slots, $attrs = this.$attrs, tag = this.tag, componentData = this.componentData, realList = this.realList, getKey = this.getKey;
                        var componentStructure = computeComponentStructure({
                            $slots: $slots,
                            tag: tag,
                            realList: realList,
                            getKey: getKey
                        });
                        this.componentStructure = componentStructure;
                        var attributes = getComponentAttributes({
                            $attrs: $attrs,
                            componentData: componentData
                        });
                        return componentStructure.render(external_commonjs_vue_commonjs2_vue_root_Vue_["h"], attributes);
                    } catch (err) {
                        this.error = true;
                        return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["h"])("pre", {
                            style: {
                                color: "red"
                            }
                        }, err.stack);
                    }
                },
                created: function created() {
                    if (this.list !== null && this.modelValue !== null) console["a" /* console */ ].error("modelValue and list props are mutually exclusive! Please set one or another.");
                },
                mounted: function mounted() {
                    var _this4 = this;
                    if (this.error) return;
                    var $attrs = this.$attrs, $el = this.$el, componentStructure = this.componentStructure;
                    componentStructure.updated();
                    var sortableOptions = createSortableOption({
                        $attrs: $attrs,
                        callBackBuilder: {
                            manageAndEmit: function manageAndEmit(event) {
                                return _manageAndEmit.call(_this4, event);
                            },
                            emit: function emit(event) {
                                return _emit.bind(_this4, event);
                            },
                            manage: function manage(event) {
                                return _manage.call(_this4, event);
                            }
                        }
                    });
                    var targetDomElement = $el.nodeType === 1 ? $el : $el.parentElement;
                    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(targetDomElement, sortableOptions);
                    this.targetDomElement = targetDomElement;
                    targetDomElement.__draggable_component__ = this;
                },
                updated: function updated() {
                    this.componentStructure.updated();
                },
                beforeUnmount: function beforeUnmount() {
                    if (this._sortable !== undefined) this._sortable.destroy();
                },
                computed: {
                    realList: function realList() {
                        var list = this.list;
                        return list ? list : this.modelValue;
                    },
                    getKey: function getKey() {
                        var itemKey = this.itemKey;
                        if (typeof itemKey === "function") return itemKey;
                        return function(element) {
                            return element[itemKey];
                        };
                    }
                },
                watch: {
                    $attrs: {
                        handler: function handler(newOptionValue) {
                            var _sortable = this._sortable;
                            if (!_sortable) return;
                            getValidSortableEntries(newOptionValue).forEach(function(_ref) {
                                var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                                _sortable.option(key, value);
                            });
                        },
                        deep: true
                    }
                },
                methods: {
                    getUnderlyingVm: function getUnderlyingVm(domElement) {
                        return this.componentStructure.getUnderlyingVm(domElement) || null;
                    },
                    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(htmElement) {
                        //TODO check case where you need to see component children
                        return htmElement.__draggable_component__;
                    },
                    emitChanges: function emitChanges(evt) {
                        var _this5 = this;
                        Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])(function() {
                            return _this5.$emit("change", evt);
                        });
                    },
                    alterList: function alterList(onList) {
                        if (this.list) {
                            onList(this.list);
                            return;
                        }
                        var newList = _toConsumableArray(this.modelValue);
                        onList(newList);
                        this.$emit("update:modelValue", newList);
                    },
                    spliceList: function spliceList() {
                        var _arguments = arguments;
                        var spliceList = function spliceList(list) {
                            return list.splice.apply(list, _toConsumableArray(_arguments));
                        };
                        this.alterList(spliceList);
                    },
                    updatePosition: function updatePosition(oldIndex, newIndex) {
                        var updatePosition = function updatePosition(list) {
                            return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
                        };
                        this.alterList(updatePosition);
                    },
                    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref3) {
                        var to = _ref3.to, related = _ref3.related;
                        var component = this.getUnderlyingPotencialDraggableComponent(to);
                        if (!component) return {
                            component: component
                        };
                        var list = component.realList;
                        var context = {
                            list: list,
                            component: component
                        };
                        if (to !== related && list) {
                            var destination = component.getUnderlyingVm(related) || {};
                            return _objectSpread2(_objectSpread2({}, destination), context);
                        }
                        return context;
                    },
                    getVmIndexFromDomIndex: function getVmIndexFromDomIndex(domIndex) {
                        return this.componentStructure.getVmIndexFromDomIndex(domIndex, this.targetDomElement);
                    },
                    onDragStart: function onDragStart(evt) {
                        this.context = this.getUnderlyingVm(evt.item);
                        evt.item._underlying_vm_ = this.clone(this.context.element);
                        draggingElement = evt.item;
                    },
                    onDragAdd: function onDragAdd(evt) {
                        var element = evt.item._underlying_vm_;
                        if (element === undefined) return;
                        removeNode(evt.item);
                        var newIndex = this.getVmIndexFromDomIndex(evt.newIndex);
                        this.spliceList(newIndex, 0, element);
                        var added = {
                            element: element,
                            newIndex: newIndex
                        };
                        this.emitChanges({
                            added: added
                        });
                    },
                    onDragRemove: function onDragRemove(evt) {
                        insertNodeAt(this.$el, evt.item, evt.oldIndex);
                        if (evt.pullMode === "clone") {
                            removeNode(evt.clone);
                            return;
                        }
                        var _this$context = this.context, oldIndex = _this$context.index, element = _this$context.element;
                        this.spliceList(oldIndex, 1);
                        var removed = {
                            element: element,
                            oldIndex: oldIndex
                        };
                        this.emitChanges({
                            removed: removed
                        });
                    },
                    onDragUpdate: function onDragUpdate(evt) {
                        removeNode(evt.item);
                        insertNodeAt(evt.from, evt.item, evt.oldIndex);
                        var oldIndex = this.context.index;
                        var newIndex = this.getVmIndexFromDomIndex(evt.newIndex);
                        this.updatePosition(oldIndex, newIndex);
                        var moved = {
                            element: this.context.element,
                            oldIndex: oldIndex,
                            newIndex: newIndex
                        };
                        this.emitChanges({
                            moved: moved
                        });
                    },
                    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
                        if (!relatedContext.element) return 0;
                        var domChildren = _toConsumableArray(evt.to.children).filter(function(el) {
                            return el.style["display"] !== "none";
                        });
                        var currentDomIndex = domChildren.indexOf(evt.related);
                        var currentIndex = relatedContext.component.getVmIndexFromDomIndex(currentDomIndex);
                        var draggedInList = domChildren.indexOf(draggingElement) !== -1;
                        return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
                    },
                    onDragMove: function onDragMove(evt, originalEvent) {
                        var move = this.move, realList = this.realList;
                        if (!move || !realList) return true;
                        var relatedContext = this.getRelatedContextFromMoveEvent(evt);
                        var futureIndex = this.computeFutureIndex(relatedContext, evt);
                        var draggedContext = _objectSpread2(_objectSpread2({}, this.context), {}, {
                            futureIndex: futureIndex
                        });
                        var sendEvent = _objectSpread2(_objectSpread2({}, evt), {}, {
                            relatedContext: relatedContext,
                            draggedContext: draggedContext
                        });
                        return move(sendEvent, originalEvent);
                    },
                    onDragEnd: function onDragEnd() {
                        draggingElement = null;
                    }
                }
            });
            /* harmony default export */ var vuedraggable = draggableComponent;
            // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
            /* harmony default export */ var entry_lib = __webpack_exports__["default"] = vuedraggable;
        /***/ },
        /***/ "fb6a": /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var $ = __webpack_require__("23e7");
            var isObject = __webpack_require__("861d");
            var isArray = __webpack_require__("e8b5");
            var toAbsoluteIndex = __webpack_require__("23cb");
            var toLength = __webpack_require__("50c4");
            var toIndexedObject = __webpack_require__("fc6a");
            var createProperty = __webpack_require__("8418");
            var wellKnownSymbol = __webpack_require__("b622");
            var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
            var arrayMethodUsesToLength = __webpack_require__("ae40");
            var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice");
            var USES_TO_LENGTH = arrayMethodUsesToLength("slice", {
                ACCESSORS: true,
                0: 0,
                1: 2
            });
            var SPECIES = wellKnownSymbol("species");
            var nativeSlice = [].slice;
            var max = Math.max;
            // `Array.prototype.slice` method
            // https://tc39.github.io/ecma262/#sec-array.prototype.slice
            // fallback for not array-like ES3 strings and DOM objects
            $({
                target: "Array",
                proto: true,
                forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH
            }, {
                slice: function slice(start, end) {
                    var O = toIndexedObject(this);
                    var length = toLength(O.length);
                    var k = toAbsoluteIndex(start, length);
                    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
                    var Constructor, result, n;
                    if (isArray(O)) {
                        Constructor = O.constructor;
                        // cross-realm fallback
                        if (typeof Constructor == "function" && (Constructor === Array || isArray(Constructor.prototype))) Constructor = undefined;
                        else if (isObject(Constructor)) {
                            Constructor = Constructor[SPECIES];
                            if (Constructor === null) Constructor = undefined;
                        }
                        if (Constructor === Array || Constructor === undefined) return nativeSlice.call(O, k, fin);
                    }
                    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
                    for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
                    result.length = n;
                    return result;
                }
            });
        /***/ },
        /***/ "fc6a": /***/ function(module1, exports, __webpack_require__) {
            // toObject with fallback for non-array-like ES3 strings
            var IndexedObject = __webpack_require__("44ad");
            var requireObjectCoercible = __webpack_require__("1d80");
            module1.exports = function(it) {
                return IndexedObject(requireObjectCoercible(it));
            };
        /***/ },
        /***/ "fdbc": /***/ function(module1, exports) {
            // iterable DOM collections
            // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
            module1.exports = {
                CSSRuleList: 0,
                CSSStyleDeclaration: 0,
                CSSValueList: 0,
                ClientRectList: 0,
                DOMRectList: 0,
                DOMStringList: 0,
                DOMTokenList: 1,
                DataTransferItemList: 0,
                FileList: 0,
                HTMLAllCollection: 0,
                HTMLCollection: 0,
                HTMLFormElement: 0,
                HTMLSelectElement: 0,
                MediaList: 0,
                MimeTypeArray: 0,
                NamedNodeMap: 0,
                NodeList: 1,
                PaintRequestList: 0,
                Plugin: 0,
                PluginArray: 0,
                SVGLengthList: 0,
                SVGNumberList: 0,
                SVGPathSegList: 0,
                SVGPointList: 0,
                SVGStringList: 0,
                SVGTransformList: 0,
                SourceBufferList: 0,
                StyleSheetList: 0,
                TextTrackCueList: 0,
                TextTrackList: 0,
                TouchList: 0
            };
        /***/ },
        /***/ "fdbf": /***/ function(module1, exports, __webpack_require__) {
            var NATIVE_SYMBOL = __webpack_require__("4930");
            module1.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
        /***/ }
    })["default"];
});

});
parcelRequire.register("iVGQs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Sortable", () => $dc7ec905e041f51c$export$31b3ca70d8f57423);
$parcel$export(module.exports, "Swap", () => $dc7ec905e041f51c$export$bdb5f0a1b77546f4);
$parcel$export(module.exports, "MultiDrag", () => $dc7ec905e041f51c$export$18e5d2a5d1df842d);
$parcel$export(module.exports, "default", () => $dc7ec905e041f51c$export$2e2bcd8739ae039);
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $dc7ec905e041f51c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc7ec905e041f51c$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc7ec905e041f51c$var$ownKeys(Object(source), true).forEach(function(key) {
            $dc7ec905e041f51c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc7ec905e041f51c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc7ec905e041f51c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dc7ec905e041f51c$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $dc7ec905e041f51c$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dc7ec905e041f51c$var$_typeof(obj);
}
function $dc7ec905e041f51c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc7ec905e041f51c$var$_extends() {
    $dc7ec905e041f51c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc7ec905e041f51c$var$_extends.apply(this, arguments);
}
function $dc7ec905e041f51c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dc7ec905e041f51c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dc7ec905e041f51c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dc7ec905e041f51c$var$_toConsumableArray(arr) {
    return $dc7ec905e041f51c$var$_arrayWithoutHoles(arr) || $dc7ec905e041f51c$var$_iterableToArray(arr) || $dc7ec905e041f51c$var$_unsupportedIterableToArray(arr) || $dc7ec905e041f51c$var$_nonIterableSpread();
}
function $dc7ec905e041f51c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dc7ec905e041f51c$var$_arrayLikeToArray(arr);
}
function $dc7ec905e041f51c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dc7ec905e041f51c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc7ec905e041f51c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc7ec905e041f51c$var$_arrayLikeToArray(o, minLen);
}
function $dc7ec905e041f51c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dc7ec905e041f51c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $dc7ec905e041f51c$var$version = "1.14.0";
function $dc7ec905e041f51c$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $dc7ec905e041f51c$var$IE11OrLess = $dc7ec905e041f51c$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $dc7ec905e041f51c$var$Edge = $dc7ec905e041f51c$var$userAgent(/Edge/i);
var $dc7ec905e041f51c$var$FireFox = $dc7ec905e041f51c$var$userAgent(/firefox/i);
var $dc7ec905e041f51c$var$Safari = $dc7ec905e041f51c$var$userAgent(/safari/i) && !$dc7ec905e041f51c$var$userAgent(/chrome/i) && !$dc7ec905e041f51c$var$userAgent(/android/i);
var $dc7ec905e041f51c$var$IOS = $dc7ec905e041f51c$var$userAgent(/iP(ad|od|hone)/i);
var $dc7ec905e041f51c$var$ChromeForAndroid = $dc7ec905e041f51c$var$userAgent(/chrome/i) && $dc7ec905e041f51c$var$userAgent(/android/i);
var $dc7ec905e041f51c$var$captureMode = {
    capture: false,
    passive: false
};
function $dc7ec905e041f51c$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$dc7ec905e041f51c$var$IE11OrLess && $dc7ec905e041f51c$var$captureMode);
}
function $dc7ec905e041f51c$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$dc7ec905e041f51c$var$IE11OrLess && $dc7ec905e041f51c$var$captureMode);
}
function $dc7ec905e041f51c$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $dc7ec905e041f51c$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $dc7ec905e041f51c$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $dc7ec905e041f51c$var$matches(el, selector) : $dc7ec905e041f51c$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $dc7ec905e041f51c$var$getParentOrHost(el));
    }
    return null;
}
var $dc7ec905e041f51c$var$R_SPACE = /\s+/g;
function $dc7ec905e041f51c$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($dc7ec905e041f51c$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($dc7ec905e041f51c$var$R_SPACE, " ");
        }
    }
}
function $dc7ec905e041f51c$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $dc7ec905e041f51c$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $dc7ec905e041f51c$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $dc7ec905e041f51c$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $dc7ec905e041f51c$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $dc7ec905e041f51c$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $dc7ec905e041f51c$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$dc7ec905e041f51c$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($dc7ec905e041f51c$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $dc7ec905e041f51c$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($dc7ec905e041f51c$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($dc7ec905e041f51c$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $dc7ec905e041f51c$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $dc7ec905e041f51c$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $dc7ec905e041f51c$var$getParentAutoScrollElement(el, true), elSideVal = $dc7ec905e041f51c$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $dc7ec905e041f51c$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $dc7ec905e041f51c$var$getWindowScrollingElement()) break;
        parent = $dc7ec905e041f51c$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $dc7ec905e041f51c$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $dc7ec905e041f51c$export$31b3ca70d8f57423.dragged) && $dc7ec905e041f51c$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $dc7ec905e041f51c$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost || $dc7ec905e041f51c$var$css(last, "display") === "none" || selector && !$dc7ec905e041f51c$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $dc7ec905e041f51c$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $dc7ec905e041f51c$export$31b3ca70d8f57423.clone && (!selector || $dc7ec905e041f51c$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $dc7ec905e041f51c$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $dc7ec905e041f51c$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $dc7ec905e041f51c$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $dc7ec905e041f51c$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $dc7ec905e041f51c$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $dc7ec905e041f51c$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $dc7ec905e041f51c$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $dc7ec905e041f51c$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $dc7ec905e041f51c$var$getWindowScrollingElement();
}
function $dc7ec905e041f51c$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $dc7ec905e041f51c$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $dc7ec905e041f51c$var$_throttleTimeout;
function $dc7ec905e041f51c$var$throttle(callback, ms) {
    return function() {
        if (!$dc7ec905e041f51c$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $dc7ec905e041f51c$var$_throttleTimeout = setTimeout(function() {
                $dc7ec905e041f51c$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $dc7ec905e041f51c$var$cancelThrottle() {
    clearTimeout($dc7ec905e041f51c$var$_throttleTimeout);
    $dc7ec905e041f51c$var$_throttleTimeout = void 0;
}
function $dc7ec905e041f51c$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $dc7ec905e041f51c$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $dc7ec905e041f51c$var$setRect(el, rect) {
    $dc7ec905e041f51c$var$css(el, "position", "absolute");
    $dc7ec905e041f51c$var$css(el, "top", rect.top);
    $dc7ec905e041f51c$var$css(el, "left", rect.left);
    $dc7ec905e041f51c$var$css(el, "width", rect.width);
    $dc7ec905e041f51c$var$css(el, "height", rect.height);
}
function $dc7ec905e041f51c$var$unsetRect(el) {
    $dc7ec905e041f51c$var$css(el, "position", "");
    $dc7ec905e041f51c$var$css(el, "top", "");
    $dc7ec905e041f51c$var$css(el, "left", "");
    $dc7ec905e041f51c$var$css(el, "width", "");
    $dc7ec905e041f51c$var$css(el, "height", "");
}
var $dc7ec905e041f51c$var$expando = "Sortable" + new Date().getTime();
function $dc7ec905e041f51c$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($dc7ec905e041f51c$var$css(child, "display") === "none" || child === $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $dc7ec905e041f51c$var$getRect(child)
                });
                var fromRect = $dc7ec905e041f51c$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $dc7ec905e041f51c$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($dc7ec905e041f51c$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $dc7ec905e041f51c$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $dc7ec905e041f51c$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($dc7ec905e041f51c$var$isRectEqual(prevFromRect, toRect) && !$dc7ec905e041f51c$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $dc7ec905e041f51c$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                } // if fromRect != toRect: animate
                if (!$dc7ec905e041f51c$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $dc7ec905e041f51c$var$css(target, "transition", "");
                $dc7ec905e041f51c$var$css(target, "transform", "");
                var elMatrix = $dc7ec905e041f51c$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $dc7ec905e041f51c$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $dc7ec905e041f51c$var$repaint(target); // repaint
                $dc7ec905e041f51c$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $dc7ec905e041f51c$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $dc7ec905e041f51c$var$css(target, "transition", "");
                    $dc7ec905e041f51c$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $dc7ec905e041f51c$var$repaint(target) {
    return target.offsetWidth;
}
function $dc7ec905e041f51c$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $dc7ec905e041f51c$var$plugins = [];
var $dc7ec905e041f51c$var$defaults = {
    initializeByDefault: true
};
var $dc7ec905e041f51c$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $dc7ec905e041f51c$var$defaults)if ($dc7ec905e041f51c$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $dc7ec905e041f51c$var$defaults[option];
        $dc7ec905e041f51c$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $dc7ec905e041f51c$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($dc7ec905e041f51c$var$_objectSpread2({
                sortable: sortable
            }, evt));
             // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($dc7ec905e041f51c$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized; // Add default options from plugin
            $dc7ec905e041f51c$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $dc7ec905e041f51c$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $dc7ec905e041f51c$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $dc7ec905e041f51c$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$dc7ec905e041f51c$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
    if (window.CustomEvent && !$dc7ec905e041f51c$var$IE11OrLess && !$dc7ec905e041f51c$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $dc7ec905e041f51c$var$_objectSpread2($dc7ec905e041f51c$var$_objectSpread2({}, extraEventProperties), $dc7ec905e041f51c$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $dc7ec905e041f51c$var$_excluded = [
    "evt"
];
var $dc7ec905e041f51c$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $dc7ec905e041f51c$var$_objectWithoutProperties(_ref, $dc7ec905e041f51c$var$_excluded);
    $dc7ec905e041f51c$var$PluginManager.pluginEvent.bind($dc7ec905e041f51c$export$31b3ca70d8f57423)(eventName, sortable, $dc7ec905e041f51c$var$_objectSpread2({
        dragEl: $dc7ec905e041f51c$var$dragEl,
        parentEl: $dc7ec905e041f51c$var$parentEl,
        ghostEl: $dc7ec905e041f51c$var$ghostEl,
        rootEl: $dc7ec905e041f51c$var$rootEl,
        nextEl: $dc7ec905e041f51c$var$nextEl,
        lastDownEl: $dc7ec905e041f51c$var$lastDownEl,
        cloneEl: $dc7ec905e041f51c$var$cloneEl,
        cloneHidden: $dc7ec905e041f51c$var$cloneHidden,
        dragStarted: $dc7ec905e041f51c$var$moved,
        putSortable: $dc7ec905e041f51c$var$putSortable,
        activeSortable: $dc7ec905e041f51c$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $dc7ec905e041f51c$var$oldIndex,
        oldDraggableIndex: $dc7ec905e041f51c$var$oldDraggableIndex,
        newIndex: $dc7ec905e041f51c$var$newIndex,
        newDraggableIndex: $dc7ec905e041f51c$var$newDraggableIndex,
        hideGhostForTarget: $dc7ec905e041f51c$var$_hideGhostForTarget,
        unhideGhostForTarget: $dc7ec905e041f51c$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $dc7ec905e041f51c$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $dc7ec905e041f51c$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $dc7ec905e041f51c$var$_dispatchEvent(info) {
    $dc7ec905e041f51c$var$dispatchEvent($dc7ec905e041f51c$var$_objectSpread2({
        putSortable: $dc7ec905e041f51c$var$putSortable,
        cloneEl: $dc7ec905e041f51c$var$cloneEl,
        targetEl: $dc7ec905e041f51c$var$dragEl,
        rootEl: $dc7ec905e041f51c$var$rootEl,
        oldIndex: $dc7ec905e041f51c$var$oldIndex,
        oldDraggableIndex: $dc7ec905e041f51c$var$oldDraggableIndex,
        newIndex: $dc7ec905e041f51c$var$newIndex,
        newDraggableIndex: $dc7ec905e041f51c$var$newDraggableIndex
    }, info));
}
var $dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$parentEl, $dc7ec905e041f51c$var$ghostEl, $dc7ec905e041f51c$var$rootEl, $dc7ec905e041f51c$var$nextEl, $dc7ec905e041f51c$var$lastDownEl, $dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$cloneHidden, $dc7ec905e041f51c$var$oldIndex, $dc7ec905e041f51c$var$newIndex, $dc7ec905e041f51c$var$oldDraggableIndex, $dc7ec905e041f51c$var$newDraggableIndex, $dc7ec905e041f51c$var$activeGroup, $dc7ec905e041f51c$var$putSortable, $dc7ec905e041f51c$var$awaitingDragStarted = false, $dc7ec905e041f51c$var$ignoreNextClick = false, $dc7ec905e041f51c$var$sortables = [], $dc7ec905e041f51c$var$tapEvt, $dc7ec905e041f51c$var$touchEvt, $dc7ec905e041f51c$var$lastDx, $dc7ec905e041f51c$var$lastDy, $dc7ec905e041f51c$var$tapDistanceLeft, $dc7ec905e041f51c$var$tapDistanceTop, $dc7ec905e041f51c$var$moved, $dc7ec905e041f51c$var$lastTarget, $dc7ec905e041f51c$var$lastDirection, $dc7ec905e041f51c$var$pastFirstInvertThresh = false, $dc7ec905e041f51c$var$isCircumstantialInvert = false, $dc7ec905e041f51c$var$targetMoveDistance, // For positioning ghost absolutely
$dc7ec905e041f51c$var$ghostRelativeParent, $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll = [], // (left, top)
$dc7ec905e041f51c$var$_silent = false, $dc7ec905e041f51c$var$savedInputChecked = [];
/** @const */ var $dc7ec905e041f51c$var$documentExists = typeof document !== "undefined", $dc7ec905e041f51c$var$PositionGhostAbsolutely = $dc7ec905e041f51c$var$IOS, $dc7ec905e041f51c$var$CSSFloatProperty = $dc7ec905e041f51c$var$Edge || $dc7ec905e041f51c$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$dc7ec905e041f51c$var$supportDraggable = $dc7ec905e041f51c$var$documentExists && !$dc7ec905e041f51c$var$ChromeForAndroid && !$dc7ec905e041f51c$var$IOS && "draggable" in document.createElement("div"), $dc7ec905e041f51c$var$supportCssPointerEvents = function() {
    if (!$dc7ec905e041f51c$var$documentExists) return; // false when <= IE11
    if ($dc7ec905e041f51c$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $dc7ec905e041f51c$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $dc7ec905e041f51c$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $dc7ec905e041f51c$var$getChild(el, 0, options), child2 = $dc7ec905e041f51c$var$getChild(el, 1, options), firstChildCSS = child1 && $dc7ec905e041f51c$var$css(child1), secondChildCSS = child2 && $dc7ec905e041f51c$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $dc7ec905e041f51c$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $dc7ec905e041f51c$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$dc7ec905e041f51c$var$CSSFloatProperty] === "none" || child2 && elCSS[$dc7ec905e041f51c$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $dc7ec905e041f51c$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */ $dc7ec905e041f51c$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $dc7ec905e041f51c$var$sortables.some(function(sortable) {
        var threshold = sortable[$dc7ec905e041f51c$var$expando].options.emptyInsertThreshold;
        if (!threshold || $dc7ec905e041f51c$var$lastChild(sortable)) return;
        var rect = $dc7ec905e041f51c$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $dc7ec905e041f51c$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $dc7ec905e041f51c$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $dc7ec905e041f51c$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$dc7ec905e041f51c$var$supportCssPointerEvents && $dc7ec905e041f51c$var$ghostEl) $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "display", "none");
}, $dc7ec905e041f51c$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$dc7ec905e041f51c$var$supportCssPointerEvents && $dc7ec905e041f51c$var$ghostEl) $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "display", "");
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($dc7ec905e041f51c$var$documentExists) document.addEventListener("click", function(evt) {
    if ($dc7ec905e041f51c$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $dc7ec905e041f51c$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($dc7ec905e041f51c$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $dc7ec905e041f51c$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$dc7ec905e041f51c$var$expando]._onDragOver(event);
        }
    }
};
var $dc7ec905e041f51c$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($dc7ec905e041f51c$var$dragEl) $dc7ec905e041f51c$var$dragEl.parentNode[$dc7ec905e041f51c$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $dc7ec905e041f51c$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $dc7ec905e041f51c$var$_extends({}, options); // Export instance
    el[$dc7ec905e041f51c$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $dc7ec905e041f51c$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $dc7ec905e041f51c$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$dc7ec905e041f51c$var$Safari,
        emptyInsertThreshold: 5
    };
    $dc7ec905e041f51c$var$PluginManager.initializePlugins(this, el, defaults); // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $dc7ec905e041f51c$var$_prepareGroup(options); // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
     // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $dc7ec905e041f51c$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
     // Bind events
    if (options.supportPointer) $dc7ec905e041f51c$var$on(el, "pointerdown", this._onTapStart);
    else {
        $dc7ec905e041f51c$var$on(el, "mousedown", this._onTapStart);
        $dc7ec905e041f51c$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $dc7ec905e041f51c$var$on(el, "dragover", this);
        $dc7ec905e041f51c$var$on(el, "dragenter", this);
    }
    $dc7ec905e041f51c$var$sortables.push(this.el); // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
    $dc7ec905e041f51c$var$_extends(this, $dc7ec905e041f51c$var$AnimationStateManager());
}
$dc7ec905e041f51c$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $dc7ec905e041f51c$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $dc7ec905e041f51c$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $dc7ec905e041f51c$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $dc7ec905e041f51c$var$_saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($dc7ec905e041f51c$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
         // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
         // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $dc7ec905e041f51c$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $dc7ec905e041f51c$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($dc7ec905e041f51c$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
         // Get the index of the dragged element within its parent
        $dc7ec905e041f51c$var$oldIndex = $dc7ec905e041f51c$var$index(target);
        $dc7ec905e041f51c$var$oldDraggableIndex = $dc7ec905e041f51c$var$index(target, options.draggable); // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $dc7ec905e041f51c$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $dc7ec905e041f51c$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $dc7ec905e041f51c$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $dc7ec905e041f51c$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $dc7ec905e041f51c$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$dc7ec905e041f51c$var$closest(originalTarget, options.handle, el, false)) return;
         // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$dc7ec905e041f51c$var$dragEl && target.parentNode === el) {
            var dragRect = $dc7ec905e041f51c$var$getRect(target);
            $dc7ec905e041f51c$var$rootEl = el;
            $dc7ec905e041f51c$var$dragEl = target;
            $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$dragEl.parentNode;
            $dc7ec905e041f51c$var$nextEl = $dc7ec905e041f51c$var$dragEl.nextSibling;
            $dc7ec905e041f51c$var$lastDownEl = target;
            $dc7ec905e041f51c$var$activeGroup = options.group;
            $dc7ec905e041f51c$export$31b3ca70d8f57423.dragged = $dc7ec905e041f51c$var$dragEl;
            $dc7ec905e041f51c$var$tapEvt = {
                target: $dc7ec905e041f51c$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $dc7ec905e041f51c$var$tapDistanceLeft = $dc7ec905e041f51c$var$tapEvt.clientX - dragRect.left;
            $dc7ec905e041f51c$var$tapDistanceTop = $dc7ec905e041f51c$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $dc7ec905e041f51c$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $dc7ec905e041f51c$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                } // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$dc7ec905e041f51c$var$FireFox && _this.nativeDraggable) $dc7ec905e041f51c$var$dragEl.draggable = true;
                 // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch); // Drag start event
                $dc7ec905e041f51c$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                }); // Chosen item
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.chosenClass, true);
            }; // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $dc7ec905e041f51c$var$find($dc7ec905e041f51c$var$dragEl, criteria.trim(), $dc7ec905e041f51c$var$_disableDraggable);
            });
            $dc7ec905e041f51c$var$on(ownerDocument, "dragover", $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
            $dc7ec905e041f51c$var$on(ownerDocument, "mousemove", $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
            $dc7ec905e041f51c$var$on(ownerDocument, "touchmove", $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
            $dc7ec905e041f51c$var$on(ownerDocument, "mouseup", _this._onDrop);
            $dc7ec905e041f51c$var$on(ownerDocument, "touchend", _this._onDrop);
            $dc7ec905e041f51c$var$on(ownerDocument, "touchcancel", _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
            if ($dc7ec905e041f51c$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $dc7ec905e041f51c$var$dragEl.draggable = true;
            }
            $dc7ec905e041f51c$var$pluginEvent("delayStart", this, {
                evt: evt
            }); // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($dc7ec905e041f51c$var$Edge || $dc7ec905e041f51c$var$IE11OrLess))) {
                if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                } // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $dc7ec905e041f51c$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $dc7ec905e041f51c$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $dc7ec905e041f51c$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $dc7ec905e041f51c$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $dc7ec905e041f51c$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $dc7ec905e041f51c$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $dc7ec905e041f51c$var$dragEl && $dc7ec905e041f51c$var$_disableDraggable($dc7ec905e041f51c$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $dc7ec905e041f51c$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $dc7ec905e041f51c$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $dc7ec905e041f51c$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $dc7ec905e041f51c$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $dc7ec905e041f51c$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $dc7ec905e041f51c$var$on(document, "touchmove", this._onTouchMove);
            else $dc7ec905e041f51c$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $dc7ec905e041f51c$var$on($dc7ec905e041f51c$var$dragEl, "dragend", this);
            $dc7ec905e041f51c$var$on($dc7ec905e041f51c$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $dc7ec905e041f51c$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $dc7ec905e041f51c$var$awaitingDragStarted = false;
        if ($dc7ec905e041f51c$var$rootEl && $dc7ec905e041f51c$var$dragEl) {
            $dc7ec905e041f51c$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $dc7ec905e041f51c$var$on(document, "dragover", $dc7ec905e041f51c$var$_checkOutsideTargetEl);
            var options = this.options; // Apply effect
            !fallback && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.dragClass, false);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.ghostClass, true);
            $dc7ec905e041f51c$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost(); // Drag start event
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($dc7ec905e041f51c$var$touchEvt) {
            this._lastX = $dc7ec905e041f51c$var$touchEvt.clientX;
            this._lastY = $dc7ec905e041f51c$var$touchEvt.clientY;
            $dc7ec905e041f51c$var$_hideGhostForTarget();
            var target = document.elementFromPoint($dc7ec905e041f51c$var$touchEvt.clientX, $dc7ec905e041f51c$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($dc7ec905e041f51c$var$touchEvt.clientX, $dc7ec905e041f51c$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $dc7ec905e041f51c$var$dragEl.parentNode[$dc7ec905e041f51c$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$dc7ec905e041f51c$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$dc7ec905e041f51c$var$expando]._onDragOver({
                        clientX: $dc7ec905e041f51c$var$touchEvt.clientX,
                        clientY: $dc7ec905e041f51c$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $dc7ec905e041f51c$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($dc7ec905e041f51c$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $dc7ec905e041f51c$var$ghostEl && $dc7ec905e041f51c$var$matrix($dc7ec905e041f51c$var$ghostEl, true), scaleX = $dc7ec905e041f51c$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $dc7ec905e041f51c$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $dc7ec905e041f51c$var$PositionGhostAbsolutely && $dc7ec905e041f51c$var$ghostRelativeParent && $dc7ec905e041f51c$var$getRelativeScrollOffset($dc7ec905e041f51c$var$ghostRelativeParent), dx = (touch.clientX - $dc7ec905e041f51c$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $dc7ec905e041f51c$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
            if (!$dc7ec905e041f51c$export$31b3ca70d8f57423.active && !$dc7ec905e041f51c$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($dc7ec905e041f51c$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($dc7ec905e041f51c$var$lastDx || 0);
                    ghostMatrix.f += dy - ($dc7ec905e041f51c$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "webkitTransform", cssMatrix);
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "mozTransform", cssMatrix);
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "msTransform", cssMatrix);
                $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "transform", cssMatrix);
                $dc7ec905e041f51c$var$lastDx = dx;
                $dc7ec905e041f51c$var$lastDy = dy;
                $dc7ec905e041f51c$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$dc7ec905e041f51c$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $dc7ec905e041f51c$var$rootEl, rect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl, true, $dc7ec905e041f51c$var$PositionGhostAbsolutely, true, container), options = this.options; // Position absolutely
            if ($dc7ec905e041f51c$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $dc7ec905e041f51c$var$ghostRelativeParent = container;
                while($dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostRelativeParent, "position") === "static" && $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostRelativeParent, "transform") === "none" && $dc7ec905e041f51c$var$ghostRelativeParent !== document)$dc7ec905e041f51c$var$ghostRelativeParent = $dc7ec905e041f51c$var$ghostRelativeParent.parentNode;
                if ($dc7ec905e041f51c$var$ghostRelativeParent !== document.body && $dc7ec905e041f51c$var$ghostRelativeParent !== document.documentElement) {
                    if ($dc7ec905e041f51c$var$ghostRelativeParent === document) $dc7ec905e041f51c$var$ghostRelativeParent = $dc7ec905e041f51c$var$getWindowScrollingElement();
                    rect.top += $dc7ec905e041f51c$var$ghostRelativeParent.scrollTop;
                    rect.left += $dc7ec905e041f51c$var$ghostRelativeParent.scrollLeft;
                } else $dc7ec905e041f51c$var$ghostRelativeParent = $dc7ec905e041f51c$var$getWindowScrollingElement();
                $dc7ec905e041f51c$var$ghostRelativeParentInitialScroll = $dc7ec905e041f51c$var$getRelativeScrollOffset($dc7ec905e041f51c$var$ghostRelativeParent);
            }
            $dc7ec905e041f51c$var$ghostEl = $dc7ec905e041f51c$var$dragEl.cloneNode(true);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$ghostEl, options.ghostClass, false);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$ghostEl, options.fallbackClass, true);
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$ghostEl, options.dragClass, true);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "transition", "");
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "transform", "");
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "box-sizing", "border-box");
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "margin", 0);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "top", rect.top);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "left", rect.left);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "width", rect.width);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "height", rect.height);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "opacity", "0.8");
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "position", $dc7ec905e041f51c$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "zIndex", "100000");
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "pointerEvents", "none");
            $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost = $dc7ec905e041f51c$var$ghostEl;
            container.appendChild($dc7ec905e041f51c$var$ghostEl); // Set transform-origin
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$ghostEl, "transform-origin", $dc7ec905e041f51c$var$tapDistanceLeft / parseInt($dc7ec905e041f51c$var$ghostEl.style.width) * 100 + "% " + $dc7ec905e041f51c$var$tapDistanceTop / parseInt($dc7ec905e041f51c$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $dc7ec905e041f51c$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $dc7ec905e041f51c$var$pluginEvent("setupClone", this);
        if (!$dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
            $dc7ec905e041f51c$var$cloneEl = $dc7ec905e041f51c$var$clone($dc7ec905e041f51c$var$dragEl);
            $dc7ec905e041f51c$var$cloneEl.draggable = false;
            $dc7ec905e041f51c$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$cloneEl, this.options.chosenClass, false);
            $dc7ec905e041f51c$export$31b3ca70d8f57423.clone = $dc7ec905e041f51c$var$cloneEl;
        } // #1143: IFrame support workaround
        _this.cloneId = $dc7ec905e041f51c$var$_nextTick(function() {
            $dc7ec905e041f51c$var$pluginEvent("clone", _this);
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$dragEl);
            _this._hideClone();
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.dragClass, true); // Set proper drop events
        if (fallback) {
            $dc7ec905e041f51c$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $dc7ec905e041f51c$var$off(document, "mouseup", _this._onDrop);
            $dc7ec905e041f51c$var$off(document, "touchend", _this._onDrop);
            $dc7ec905e041f51c$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $dc7ec905e041f51c$var$dragEl);
            }
            $dc7ec905e041f51c$var$on(document, "drop", _this); // #1276 fix:
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$dragEl, "transform", "translateZ(0)");
        }
        $dc7ec905e041f51c$var$awaitingDragStarted = true;
        _this._dragStartId = $dc7ec905e041f51c$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $dc7ec905e041f51c$var$on(document, "selectstart", _this);
        $dc7ec905e041f51c$var$moved = true;
        if ($dc7ec905e041f51c$var$Safari) $dc7ec905e041f51c$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $dc7ec905e041f51c$export$31b3ca70d8f57423.active, isOwner = $dc7ec905e041f51c$var$activeGroup === group, canSort = options.sort, fromSortable = $dc7ec905e041f51c$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($dc7ec905e041f51c$var$_silent) return;
        function dragOverEvent(name, extra) {
            $dc7ec905e041f51c$var$pluginEvent(name, _this, $dc7ec905e041f51c$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, $dc7ec905e041f51c$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        } // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        } // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$putSortable ? $dc7ec905e041f51c$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, options.ghostClass, true);
                }
                if ($dc7ec905e041f51c$var$putSortable !== _this && _this !== $dc7ec905e041f51c$export$31b3ca70d8f57423.active) $dc7ec905e041f51c$var$putSortable = _this;
                else if (_this === $dc7ec905e041f51c$export$31b3ca70d8f57423.active && $dc7ec905e041f51c$var$putSortable) $dc7ec905e041f51c$var$putSortable = null;
                 // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            } // Null lastTarget if it is not inside a previously swapped element
            if (target === $dc7ec905e041f51c$var$dragEl && !$dc7ec905e041f51c$var$dragEl.animated || target === el && !target.animated) $dc7ec905e041f51c$var$lastTarget = null;
             // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $dc7ec905e041f51c$var$dragEl.parentNode[$dc7ec905e041f51c$var$expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
                !insertion && $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        } // Call when dragEl has been inserted
        function changed() {
            $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
            $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl, options.draggable);
            $dc7ec905e041f51c$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $dc7ec905e041f51c$var$newIndex,
                newDraggableIndex: $dc7ec905e041f51c$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $dc7ec905e041f51c$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($dc7ec905e041f51c$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $dc7ec905e041f51c$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $dc7ec905e041f51c$var$parentEl !== $dc7ec905e041f51c$var$rootEl // Reverting item into the original list
        ) : $dc7ec905e041f51c$var$putSortable === this || (this.lastPutMode = $dc7ec905e041f51c$var$activeGroup.checkPull(this, activeSortable, $dc7ec905e041f51c$var$dragEl, evt)) && group.checkPut(this, activeSortable, $dc7ec905e041f51c$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
                    if ($dc7ec905e041f51c$var$nextEl) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$nextEl);
                    else $dc7ec905e041f51c$var$rootEl.appendChild($dc7ec905e041f51c$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $dc7ec905e041f51c$var$lastChild(el, options.draggable);
            if (!elLastChild || $dc7ec905e041f51c$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $dc7ec905e041f51c$var$dragEl) return completed(false);
                 // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $dc7ec905e041f51c$var$getRect(target);
                if ($dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    el.appendChild($dc7ec905e041f51c$var$dragEl);
                    $dc7ec905e041f51c$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $dc7ec905e041f51c$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $dc7ec905e041f51c$var$getChild(el, 0, options, true);
                if (firstChild === $dc7ec905e041f51c$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $dc7ec905e041f51c$var$getRect(target);
                if ($dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($dc7ec905e041f51c$var$dragEl, firstChild);
                    $dc7ec905e041f51c$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $dc7ec905e041f51c$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $dc7ec905e041f51c$var$dragEl.parentNode !== el, differentRowCol = !$dc7ec905e041f51c$var$_dragElInRowColumn($dc7ec905e041f51c$var$dragEl.animated && $dc7ec905e041f51c$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $dc7ec905e041f51c$var$isScrolledPast(target, "top", "top") || $dc7ec905e041f51c$var$isScrolledPast($dc7ec905e041f51c$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($dc7ec905e041f51c$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $dc7ec905e041f51c$var$pastFirstInvertThresh = false;
                    $dc7ec905e041f51c$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $dc7ec905e041f51c$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $dc7ec905e041f51c$var$isCircumstantialInvert, $dc7ec905e041f51c$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $dc7ec905e041f51c$var$parentEl.children[dragIndex];
                    }while (sibling && ($dc7ec905e041f51c$var$css(sibling, "display") === "none" || sibling === $dc7ec905e041f51c$var$ghostEl));
                } // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $dc7ec905e041f51c$var$lastTarget = target;
                $dc7ec905e041f51c$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $dc7ec905e041f51c$var$_onMove($dc7ec905e041f51c$var$rootEl, el, $dc7ec905e041f51c$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $dc7ec905e041f51c$var$_silent = true;
                    setTimeout($dc7ec905e041f51c$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($dc7ec905e041f51c$var$dragEl);
                    else target.parentNode.insertBefore($dc7ec905e041f51c$var$dragEl, after ? nextSibling : target);
                     // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $dc7ec905e041f51c$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$dc7ec905e041f51c$var$isCircumstantialInvert) $dc7ec905e041f51c$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $dc7ec905e041f51c$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($dc7ec905e041f51c$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $dc7ec905e041f51c$var$off(document, "mousemove", this._onTouchMove);
        $dc7ec905e041f51c$var$off(document, "touchmove", this._onTouchMove);
        $dc7ec905e041f51c$var$off(document, "pointermove", this._onTouchMove);
        $dc7ec905e041f51c$var$off(document, "dragover", $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
        $dc7ec905e041f51c$var$off(document, "mousemove", $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
        $dc7ec905e041f51c$var$off(document, "touchmove", $dc7ec905e041f51c$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $dc7ec905e041f51c$var$off(ownerDocument, "mouseup", this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, "touchend", this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, "pointerup", this._onDrop);
        $dc7ec905e041f51c$var$off(ownerDocument, "touchcancel", this._onDrop);
        $dc7ec905e041f51c$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options; // Get the index of the dragged element within its parent
        $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
        $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl, options.draggable);
        $dc7ec905e041f51c$var$pluginEvent("drop", this, {
            evt: evt
        });
        $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$dragEl && $dc7ec905e041f51c$var$dragEl.parentNode; // Get again after plugin event
        $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl);
        $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl, options.draggable);
        if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $dc7ec905e041f51c$var$awaitingDragStarted = false;
        $dc7ec905e041f51c$var$isCircumstantialInvert = false;
        $dc7ec905e041f51c$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $dc7ec905e041f51c$var$_cancelNextTick(this.cloneId);
        $dc7ec905e041f51c$var$_cancelNextTick(this._dragStartId); // Unbind events
        if (this.nativeDraggable) {
            $dc7ec905e041f51c$var$off(document, "drop", this);
            $dc7ec905e041f51c$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($dc7ec905e041f51c$var$Safari) $dc7ec905e041f51c$var$css(document.body, "user-select", "");
        $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$dragEl, "transform", "");
        if (evt) {
            if ($dc7ec905e041f51c$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $dc7ec905e041f51c$var$ghostEl && $dc7ec905e041f51c$var$ghostEl.parentNode && $dc7ec905e041f51c$var$ghostEl.parentNode.removeChild($dc7ec905e041f51c$var$ghostEl);
            if ($dc7ec905e041f51c$var$rootEl === $dc7ec905e041f51c$var$parentEl || $dc7ec905e041f51c$var$putSortable && $dc7ec905e041f51c$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $dc7ec905e041f51c$var$cloneEl && $dc7ec905e041f51c$var$cloneEl.parentNode && $dc7ec905e041f51c$var$cloneEl.parentNode.removeChild($dc7ec905e041f51c$var$cloneEl);
            if ($dc7ec905e041f51c$var$dragEl) {
                if (this.nativeDraggable) $dc7ec905e041f51c$var$off($dc7ec905e041f51c$var$dragEl, "dragend", this);
                $dc7ec905e041f51c$var$_disableDraggable($dc7ec905e041f51c$var$dragEl);
                $dc7ec905e041f51c$var$dragEl.style["will-change"] = ""; // Remove classes
                // ghostClass is added in dragStarted
                if ($dc7ec905e041f51c$var$moved && !$dc7ec905e041f51c$var$awaitingDragStarted) $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$putSortable ? $dc7ec905e041f51c$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl, this.options.chosenClass, false); // Drag stop event
                $dc7ec905e041f51c$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $dc7ec905e041f51c$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($dc7ec905e041f51c$var$rootEl !== $dc7ec905e041f51c$var$parentEl) {
                    if ($dc7ec905e041f51c$var$newIndex >= 0) {
                        // Add event
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            rootEl: $dc7ec905e041f51c$var$parentEl,
                            name: "add",
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            fromEl: $dc7ec905e041f51c$var$rootEl,
                            originalEvent: evt
                        }); // Remove event
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            originalEvent: evt
                        }); // drag from one list and drop into another
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            rootEl: $dc7ec905e041f51c$var$parentEl,
                            name: "sort",
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            fromEl: $dc7ec905e041f51c$var$rootEl,
                            originalEvent: evt
                        });
                        $dc7ec905e041f51c$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $dc7ec905e041f51c$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $dc7ec905e041f51c$var$putSortable && $dc7ec905e041f51c$var$putSortable.save();
                } else {
                    if ($dc7ec905e041f51c$var$newIndex !== $dc7ec905e041f51c$var$oldIndex) {
                        if ($dc7ec905e041f51c$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $dc7ec905e041f51c$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $dc7ec905e041f51c$var$parentEl,
                                originalEvent: evt
                            });
                            $dc7ec905e041f51c$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $dc7ec905e041f51c$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($dc7ec905e041f51c$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($dc7ec905e041f51c$var$newIndex == null || $dc7ec905e041f51c$var$newIndex === -1) {
                        $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$oldIndex;
                        $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$oldDraggableIndex;
                    }
                    $dc7ec905e041f51c$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $dc7ec905e041f51c$var$parentEl,
                        originalEvent: evt
                    }); // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $dc7ec905e041f51c$var$pluginEvent("nulling", this);
        $dc7ec905e041f51c$var$rootEl = $dc7ec905e041f51c$var$dragEl = $dc7ec905e041f51c$var$parentEl = $dc7ec905e041f51c$var$ghostEl = $dc7ec905e041f51c$var$nextEl = $dc7ec905e041f51c$var$cloneEl = $dc7ec905e041f51c$var$lastDownEl = $dc7ec905e041f51c$var$cloneHidden = $dc7ec905e041f51c$var$tapEvt = $dc7ec905e041f51c$var$touchEvt = $dc7ec905e041f51c$var$moved = $dc7ec905e041f51c$var$newIndex = $dc7ec905e041f51c$var$newDraggableIndex = $dc7ec905e041f51c$var$oldIndex = $dc7ec905e041f51c$var$oldDraggableIndex = $dc7ec905e041f51c$var$lastTarget = $dc7ec905e041f51c$var$lastDirection = $dc7ec905e041f51c$var$putSortable = $dc7ec905e041f51c$var$activeGroup = $dc7ec905e041f51c$export$31b3ca70d8f57423.dragged = $dc7ec905e041f51c$export$31b3ca70d8f57423.ghost = $dc7ec905e041f51c$export$31b3ca70d8f57423.clone = $dc7ec905e041f51c$export$31b3ca70d8f57423.active = null;
        $dc7ec905e041f51c$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $dc7ec905e041f51c$var$savedInputChecked.length = $dc7ec905e041f51c$var$lastDx = $dc7ec905e041f51c$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($dc7ec905e041f51c$var$dragEl) {
                    this._onDragOver(evt);
                    $dc7ec905e041f51c$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($dc7ec905e041f51c$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $dc7ec905e041f51c$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($dc7ec905e041f51c$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $dc7ec905e041f51c$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $dc7ec905e041f51c$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $dc7ec905e041f51c$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $dc7ec905e041f51c$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$dc7ec905e041f51c$var$expando] = null;
        $dc7ec905e041f51c$var$off(el, "mousedown", this._onTapStart);
        $dc7ec905e041f51c$var$off(el, "touchstart", this._onTapStart);
        $dc7ec905e041f51c$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $dc7ec905e041f51c$var$off(el, "dragover", this);
            $dc7ec905e041f51c$var$off(el, "dragenter", this);
        } // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $dc7ec905e041f51c$var$sortables.splice($dc7ec905e041f51c$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$dc7ec905e041f51c$var$cloneHidden) {
            $dc7ec905e041f51c$var$pluginEvent("hideClone", this);
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return;
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $dc7ec905e041f51c$var$cloneEl.parentNode) $dc7ec905e041f51c$var$cloneEl.parentNode.removeChild($dc7ec905e041f51c$var$cloneEl);
            $dc7ec905e041f51c$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($dc7ec905e041f51c$var$cloneHidden) {
            $dc7ec905e041f51c$var$pluginEvent("showClone", this);
            if ($dc7ec905e041f51c$export$31b3ca70d8f57423.eventCanceled) return; // show clone at dragEl or original position
            if ($dc7ec905e041f51c$var$dragEl.parentNode == $dc7ec905e041f51c$var$rootEl && !this.options.group.revertClone) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$dragEl);
            else if ($dc7ec905e041f51c$var$nextEl) $dc7ec905e041f51c$var$rootEl.insertBefore($dc7ec905e041f51c$var$cloneEl, $dc7ec905e041f51c$var$nextEl);
            else $dc7ec905e041f51c$var$rootEl.appendChild($dc7ec905e041f51c$var$cloneEl);
            if (this.options.group.revertClone) this.animate($dc7ec905e041f51c$var$dragEl, $dc7ec905e041f51c$var$cloneEl);
            $dc7ec905e041f51c$var$css($dc7ec905e041f51c$var$cloneEl, "display", "");
            $dc7ec905e041f51c$var$cloneHidden = false;
        }
    }
};
function $dc7ec905e041f51c$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $dc7ec905e041f51c$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$dc7ec905e041f51c$var$expando], onMoveFn = sortable.options.onMove, retVal; // Support for new CustomEvent feature
    if (window.CustomEvent && !$dc7ec905e041f51c$var$IE11OrLess && !$dc7ec905e041f51c$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $dc7ec905e041f51c$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $dc7ec905e041f51c$var$_disableDraggable(el) {
    el.draggable = false;
}
function $dc7ec905e041f51c$var$_unsilent() {
    $dc7ec905e041f51c$var$_silent = false;
}
function $dc7ec905e041f51c$var$_ghostIsFirst(evt, vertical, sortable) {
    var rect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function $dc7ec905e041f51c$var$_ghostIsLast(evt, vertical, sortable) {
    var rect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function $dc7ec905e041f51c$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $dc7ec905e041f51c$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$dc7ec905e041f51c$var$pastFirstInvertThresh && ($dc7ec905e041f51c$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $dc7ec905e041f51c$var$pastFirstInvertThresh = true;
            if (!$dc7ec905e041f51c$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($dc7ec905e041f51c$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $dc7ec905e041f51c$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $dc7ec905e041f51c$var$targetMoveDistance) return -$dc7ec905e041f51c$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $dc7ec905e041f51c$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $dc7ec905e041f51c$var$_getInsertDirection(target) {
    if ($dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl) < $dc7ec905e041f51c$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $dc7ec905e041f51c$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $dc7ec905e041f51c$var$_saveInputCheckedState(root) {
    $dc7ec905e041f51c$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $dc7ec905e041f51c$var$savedInputChecked.push(el);
    }
}
function $dc7ec905e041f51c$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $dc7ec905e041f51c$var$_cancelNextTick(id) {
    return clearTimeout(id);
} // Fixed #973:
if ($dc7ec905e041f51c$var$documentExists) $dc7ec905e041f51c$var$on(document, "touchmove", function(evt) {
    if (($dc7ec905e041f51c$export$31b3ca70d8f57423.active || $dc7ec905e041f51c$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
 // Export utils
$dc7ec905e041f51c$export$31b3ca70d8f57423.utils = {
    on: $dc7ec905e041f51c$var$on,
    off: $dc7ec905e041f51c$var$off,
    css: $dc7ec905e041f51c$var$css,
    find: $dc7ec905e041f51c$var$find,
    is: function is(el, selector) {
        return !!$dc7ec905e041f51c$var$closest(el, selector, el, false);
    },
    extend: $dc7ec905e041f51c$var$extend,
    throttle: $dc7ec905e041f51c$var$throttle,
    closest: $dc7ec905e041f51c$var$closest,
    toggleClass: $dc7ec905e041f51c$var$toggleClass,
    clone: $dc7ec905e041f51c$var$clone,
    index: $dc7ec905e041f51c$var$index,
    nextTick: $dc7ec905e041f51c$var$_nextTick,
    cancelNextTick: $dc7ec905e041f51c$var$_cancelNextTick,
    detectDirection: $dc7ec905e041f51c$var$_detectDirection,
    getChild: $dc7ec905e041f51c$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $dc7ec905e041f51c$export$31b3ca70d8f57423.get = function(element) {
    return element[$dc7ec905e041f51c$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $dc7ec905e041f51c$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $dc7ec905e041f51c$export$31b3ca70d8f57423.utils = $dc7ec905e041f51c$var$_objectSpread2($dc7ec905e041f51c$var$_objectSpread2({}, $dc7ec905e041f51c$export$31b3ca70d8f57423.utils), plugin.utils);
        $dc7ec905e041f51c$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $dc7ec905e041f51c$export$31b3ca70d8f57423.create = function(el, options) {
    return new $dc7ec905e041f51c$export$31b3ca70d8f57423(el, options);
}; // Export
$dc7ec905e041f51c$export$31b3ca70d8f57423.version = $dc7ec905e041f51c$var$version;
var $dc7ec905e041f51c$var$autoScrolls = [], $dc7ec905e041f51c$var$scrollEl, $dc7ec905e041f51c$var$scrollRootEl, $dc7ec905e041f51c$var$scrolling = false, $dc7ec905e041f51c$var$lastAutoScrollX, $dc7ec905e041f51c$var$lastAutoScrollY, $dc7ec905e041f51c$var$touchEvt$1, $dc7ec905e041f51c$var$pointerElemChangedInterval;
function $dc7ec905e041f51c$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        }; // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $dc7ec905e041f51c$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $dc7ec905e041f51c$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $dc7ec905e041f51c$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $dc7ec905e041f51c$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $dc7ec905e041f51c$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $dc7ec905e041f51c$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $dc7ec905e041f51c$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $dc7ec905e041f51c$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $dc7ec905e041f51c$var$clearPointerElemChangedInterval();
            $dc7ec905e041f51c$var$clearAutoScrolls();
            $dc7ec905e041f51c$var$cancelThrottle();
        },
        nulling: function nulling() {
            $dc7ec905e041f51c$var$touchEvt$1 = $dc7ec905e041f51c$var$scrollRootEl = $dc7ec905e041f51c$var$scrollEl = $dc7ec905e041f51c$var$scrolling = $dc7ec905e041f51c$var$pointerElemChangedInterval = $dc7ec905e041f51c$var$lastAutoScrollX = $dc7ec905e041f51c$var$lastAutoScrollY = null;
            $dc7ec905e041f51c$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $dc7ec905e041f51c$var$touchEvt$1 = evt; // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $dc7ec905e041f51c$var$Edge || $dc7ec905e041f51c$var$IE11OrLess || $dc7ec905e041f51c$var$Safari) {
                $dc7ec905e041f51c$var$autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
                var ogElemScroller = $dc7ec905e041f51c$var$getParentAutoScrollElement(elem, true);
                if ($dc7ec905e041f51c$var$scrolling && (!$dc7ec905e041f51c$var$pointerElemChangedInterval || x !== $dc7ec905e041f51c$var$lastAutoScrollX || y !== $dc7ec905e041f51c$var$lastAutoScrollY)) {
                    $dc7ec905e041f51c$var$pointerElemChangedInterval && $dc7ec905e041f51c$var$clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
                    $dc7ec905e041f51c$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $dc7ec905e041f51c$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $dc7ec905e041f51c$var$clearAutoScrolls();
                        }
                        $dc7ec905e041f51c$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $dc7ec905e041f51c$var$lastAutoScrollX = x;
                    $dc7ec905e041f51c$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $dc7ec905e041f51c$var$getParentAutoScrollElement(elem, true) === $dc7ec905e041f51c$var$getWindowScrollingElement()) {
                    $dc7ec905e041f51c$var$clearAutoScrolls();
                    return;
                }
                $dc7ec905e041f51c$var$autoScroll(evt, this.options, $dc7ec905e041f51c$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $dc7ec905e041f51c$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $dc7ec905e041f51c$var$clearAutoScrolls() {
    $dc7ec905e041f51c$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $dc7ec905e041f51c$var$autoScrolls = [];
}
function $dc7ec905e041f51c$var$clearPointerElemChangedInterval() {
    clearInterval($dc7ec905e041f51c$var$pointerElemChangedInterval);
}
var $dc7ec905e041f51c$var$autoScroll = $dc7ec905e041f51c$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $dc7ec905e041f51c$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn; // New scroll root, set scrollEl
    if ($dc7ec905e041f51c$var$scrollRootEl !== rootEl) {
        $dc7ec905e041f51c$var$scrollRootEl = rootEl;
        $dc7ec905e041f51c$var$clearAutoScrolls();
        $dc7ec905e041f51c$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($dc7ec905e041f51c$var$scrollEl === true) $dc7ec905e041f51c$var$scrollEl = $dc7ec905e041f51c$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $dc7ec905e041f51c$var$scrollEl;
    do {
        var el = currentParent, rect = $dc7ec905e041f51c$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $dc7ec905e041f51c$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$dc7ec905e041f51c$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$dc7ec905e041f51c$var$autoScrolls[i]) $dc7ec905e041f51c$var$autoScrolls[i] = {};
        }
        if ($dc7ec905e041f51c$var$autoScrolls[layersOut].vx != vx || $dc7ec905e041f51c$var$autoScrolls[layersOut].vy != vy || $dc7ec905e041f51c$var$autoScrolls[layersOut].el !== el) {
            $dc7ec905e041f51c$var$autoScrolls[layersOut].el = el;
            $dc7ec905e041f51c$var$autoScrolls[layersOut].vx = vx;
            $dc7ec905e041f51c$var$autoScrolls[layersOut].vy = vy;
            clearInterval($dc7ec905e041f51c$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $dc7ec905e041f51c$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $dc7ec905e041f51c$export$31b3ca70d8f57423.active._onTouchMove($dc7ec905e041f51c$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $dc7ec905e041f51c$var$autoScrolls[this.layer].vy ? $dc7ec905e041f51c$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $dc7ec905e041f51c$var$autoScrolls[this.layer].vx ? $dc7ec905e041f51c$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($dc7ec905e041f51c$export$31b3ca70d8f57423.dragged.parentNode[$dc7ec905e041f51c$var$expando], scrollOffsetX, scrollOffsetY, evt, $dc7ec905e041f51c$var$touchEvt$1, $dc7ec905e041f51c$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $dc7ec905e041f51c$var$scrollBy($dc7ec905e041f51c$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $dc7ec905e041f51c$var$getParentAutoScrollElement(currentParent, false)));
    $dc7ec905e041f51c$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $dc7ec905e041f51c$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $dc7ec905e041f51c$var$Revert() {}
$dc7ec905e041f51c$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $dc7ec905e041f51c$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $dc7ec905e041f51c$var$drop
};
$dc7ec905e041f51c$var$_extends($dc7ec905e041f51c$var$Revert, {
    pluginName: "revertOnSpill"
});
function $dc7ec905e041f51c$var$Remove() {}
$dc7ec905e041f51c$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $dc7ec905e041f51c$var$drop
};
$dc7ec905e041f51c$var$_extends($dc7ec905e041f51c$var$Remove, {
    pluginName: "removeOnSpill"
});
var $dc7ec905e041f51c$var$lastSwapEl;
function $dc7ec905e041f51c$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $dc7ec905e041f51c$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $dc7ec905e041f51c$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $dc7ec905e041f51c$var$toggleClass(target, options.swapClass, true);
                    $dc7ec905e041f51c$var$lastSwapEl = target;
                } else $dc7ec905e041f51c$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $dc7ec905e041f51c$var$lastSwapEl) $dc7ec905e041f51c$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $dc7ec905e041f51c$var$lastSwapEl && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$lastSwapEl, options.swapClass, false);
            if ($dc7ec905e041f51c$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $dc7ec905e041f51c$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $dc7ec905e041f51c$var$swapNodes(dragEl, $dc7ec905e041f51c$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $dc7ec905e041f51c$var$lastSwapEl = null;
        }
    };
    return $dc7ec905e041f51c$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $dc7ec905e041f51c$var$lastSwapEl
            };
        }
    });
}
function $dc7ec905e041f51c$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $dc7ec905e041f51c$var$index(n1);
    i2 = $dc7ec905e041f51c$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $dc7ec905e041f51c$var$multiDragElements = [], $dc7ec905e041f51c$var$multiDragClones = [], $dc7ec905e041f51c$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$dc7ec905e041f51c$var$multiDragSortable, $dc7ec905e041f51c$var$initialFolding = false, // Initial multi-drag fold when drag started
$dc7ec905e041f51c$var$folding = false, // Folding any other time
$dc7ec905e041f51c$var$dragStarted = false, $dc7ec905e041f51c$var$dragEl$1, $dc7ec905e041f51c$var$clonesFromRect, $dc7ec905e041f51c$var$clonesHidden;
function $dc7ec905e041f51c$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (sortable.options.supportPointer) $dc7ec905e041f51c$var$on(document, "pointerup", this._deselectMultiDrag);
        else {
            $dc7ec905e041f51c$var$on(document, "mouseup", this._deselectMultiDrag);
            $dc7ec905e041f51c$var$on(document, "touchend", this._deselectMultiDrag);
        }
        $dc7ec905e041f51c$var$on(document, "keydown", this._checkKeyDown);
        $dc7ec905e041f51c$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($dc7ec905e041f51c$var$multiDragElements.length && $dc7ec905e041f51c$var$multiDragSortable === sortable) $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $dc7ec905e041f51c$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $dc7ec905e041f51c$var$multiDragElements.length; i++){
                $dc7ec905e041f51c$var$multiDragClones.push($dc7ec905e041f51c$var$clone($dc7ec905e041f51c$var$multiDragElements[i]));
                $dc7ec905e041f51c$var$multiDragClones[i].sortableIndex = $dc7ec905e041f51c$var$multiDragElements[i].sortableIndex;
                $dc7ec905e041f51c$var$multiDragClones[i].draggable = false;
                $dc7ec905e041f51c$var$multiDragClones[i].style["will-change"] = "";
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$multiDragClones[i], this.options.selectedClass, false);
                $dc7ec905e041f51c$var$multiDragElements[i] === $dc7ec905e041f51c$var$dragEl$1 && $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($dc7ec905e041f51c$var$multiDragElements.length && $dc7ec905e041f51c$var$multiDragSortable === sortable) {
                    $dc7ec905e041f51c$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $dc7ec905e041f51c$var$insertMultiDragClones(false, rootEl);
            $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                $dc7ec905e041f51c$var$css(clone, "display", "");
            });
            cloneNowShown();
            $dc7ec905e041f51c$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                $dc7ec905e041f51c$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $dc7ec905e041f51c$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $dc7ec905e041f51c$var$multiDragSortable) $dc7ec905e041f51c$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $dc7ec905e041f51c$var$index(multiDragElement);
            }); // Sort multi-drag elements
            $dc7ec905e041f51c$var$multiDragElements = $dc7ec905e041f51c$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $dc7ec905e041f51c$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
                        $dc7ec905e041f51c$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl$1, false, true, true);
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
                        $dc7ec905e041f51c$var$setRect(multiDragElement, dragRect);
                    });
                    $dc7ec905e041f51c$var$folding = true;
                    $dc7ec905e041f51c$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $dc7ec905e041f51c$var$folding = false;
                $dc7ec905e041f51c$var$initialFolding = false;
                if (_this2.options.animation) $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                    $dc7ec905e041f51c$var$unsetRect(multiDragElement);
                });
                 // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $dc7ec905e041f51c$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($dc7ec905e041f51c$var$folding && ~$dc7ec905e041f51c$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($dc7ec905e041f51c$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $dc7ec905e041f51c$var$folding ? $dc7ec905e041f51c$var$getRect(multiDragElement) : dragRect
                    });
                    $dc7ec905e041f51c$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $dc7ec905e041f51c$var$folding = false;
                $dc7ec905e041f51c$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $dc7ec905e041f51c$var$initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $dc7ec905e041f51c$var$multiDragElements.length > 1 && ($dc7ec905e041f51c$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl$1, false, true, true);
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
                        $dc7ec905e041f51c$var$setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $dc7ec905e041f51c$var$folding = true;
                } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$dc7ec905e041f51c$var$folding) $dc7ec905e041f51c$var$removeMultiDragElements();
                    if ($dc7ec905e041f51c$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $dc7ec905e041f51c$var$clonesHidden;
                        activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$dc7ec905e041f51c$var$clonesHidden && clonesHiddenBefore) $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $dc7ec905e041f51c$var$clonesFromRect
                            });
                            clone.fromRect = $dc7ec905e041f51c$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $dc7ec905e041f51c$var$clonesFromRect = $dc7ec905e041f51c$var$_extends({}, dragRect);
                var dragMatrix = $dc7ec905e041f51c$var$matrix($dc7ec905e041f51c$var$dragEl$1, true);
                $dc7ec905e041f51c$var$clonesFromRect.top -= dragMatrix.f;
                $dc7ec905e041f51c$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($dc7ec905e041f51c$var$folding) {
                $dc7ec905e041f51c$var$folding = false;
                $dc7ec905e041f51c$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children; // Multi-drag selection
            if (!$dc7ec905e041f51c$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $dc7ec905e041f51c$var$toggleClass($dc7ec905e041f51c$var$dragEl$1, options.selectedClass, !~$dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1));
                if (!~$dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1)) {
                    $dc7ec905e041f51c$var$multiDragElements.push($dc7ec905e041f51c$var$dragEl$1);
                    $dc7ec905e041f51c$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $dc7ec905e041f51c$var$dragEl$1,
                        originalEvt: evt
                    }); // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $dc7ec905e041f51c$var$lastMultiDragSelect && sortable.el.contains($dc7ec905e041f51c$var$lastMultiDragSelect)) {
                        var lastIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$lastMultiDragSelect), currentIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$dc7ec905e041f51c$var$multiDragElements.indexOf(children[i])) continue;
                                $dc7ec905e041f51c$var$toggleClass(children[i], options.selectedClass, true);
                                $dc7ec905e041f51c$var$multiDragElements.push(children[i]);
                                $dc7ec905e041f51c$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvt: evt
                                });
                            }
                        }
                    } else $dc7ec905e041f51c$var$lastMultiDragSelect = $dc7ec905e041f51c$var$dragEl$1;
                    $dc7ec905e041f51c$var$multiDragSortable = toSortable;
                } else {
                    $dc7ec905e041f51c$var$multiDragElements.splice($dc7ec905e041f51c$var$multiDragElements.indexOf($dc7ec905e041f51c$var$dragEl$1), 1);
                    $dc7ec905e041f51c$var$lastMultiDragSelect = null;
                    $dc7ec905e041f51c$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $dc7ec905e041f51c$var$dragEl$1,
                        originalEvt: evt
                    });
                }
            } // Multi-drag drop
            if ($dc7ec905e041f51c$var$dragStarted && this.isMultiDrag) {
                $dc7ec905e041f51c$var$folding = false; // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$dc7ec905e041f51c$var$expando].options.sort || parentEl !== rootEl) && $dc7ec905e041f51c$var$multiDragElements.length > 1) {
                    var dragRect = $dc7ec905e041f51c$var$getRect($dc7ec905e041f51c$var$dragEl$1), multiDragIndex = $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$dc7ec905e041f51c$var$initialFolding && options.animation) $dc7ec905e041f51c$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$dc7ec905e041f51c$var$initialFolding) {
                        if (options.animation) {
                            $dc7ec905e041f51c$var$dragEl$1.fromRect = dragRect;
                            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $dc7ec905e041f51c$var$dragEl$1) {
                                    var rect = $dc7ec905e041f51c$var$folding ? $dc7ec905e041f51c$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect; // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $dc7ec905e041f51c$var$removeMultiDragElements();
                        $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        }); // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $dc7ec905e041f51c$var$index($dc7ec905e041f51c$var$dragEl$1)) {
                            var update = false;
                            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $dc7ec905e041f51c$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) dispatchSortableEvent("update");
                        }
                    } // Must be done after capturing individual rects (scroll bar)
                    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                        $dc7ec905e041f51c$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $dc7ec905e041f51c$var$multiDragSortable = toSortable;
            } // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $dc7ec905e041f51c$var$dragStarted = false;
            $dc7ec905e041f51c$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $dc7ec905e041f51c$var$off(document, "pointerup", this._deselectMultiDrag);
            $dc7ec905e041f51c$var$off(document, "mouseup", this._deselectMultiDrag);
            $dc7ec905e041f51c$var$off(document, "touchend", this._deselectMultiDrag);
            $dc7ec905e041f51c$var$off(document, "keydown", this._checkKeyDown);
            $dc7ec905e041f51c$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $dc7ec905e041f51c$var$dragStarted !== "undefined" && $dc7ec905e041f51c$var$dragStarted) return; // Only deselect if selection is in this sortable
            if ($dc7ec905e041f51c$var$multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
            if (evt && $dc7ec905e041f51c$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($dc7ec905e041f51c$var$multiDragElements.length){
                var el = $dc7ec905e041f51c$var$multiDragElements[0];
                $dc7ec905e041f51c$var$toggleClass(el, this.options.selectedClass, false);
                $dc7ec905e041f51c$var$multiDragElements.shift();
                $dc7ec905e041f51c$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvt: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $dc7ec905e041f51c$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$dc7ec905e041f51c$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$dc7ec905e041f51c$var$multiDragElements.indexOf(el)) return;
                if ($dc7ec905e041f51c$var$multiDragSortable && $dc7ec905e041f51c$var$multiDragSortable !== sortable) {
                    $dc7ec905e041f51c$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $dc7ec905e041f51c$var$multiDragSortable = sortable;
                }
                $dc7ec905e041f51c$var$toggleClass(el, sortable.options.selectedClass, true);
                $dc7ec905e041f51c$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$dc7ec905e041f51c$var$expando], index = $dc7ec905e041f51c$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $dc7ec905e041f51c$var$toggleClass(el, sortable.options.selectedClass, false);
                $dc7ec905e041f51c$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                }); // multiDragElements will already be sorted if folding
                var newIndex;
                if ($dc7ec905e041f51c$var$folding && multiDragElement !== $dc7ec905e041f51c$var$dragEl$1) newIndex = -1;
                else if ($dc7ec905e041f51c$var$folding) newIndex = $dc7ec905e041f51c$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $dc7ec905e041f51c$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $dc7ec905e041f51c$var$_toConsumableArray($dc7ec905e041f51c$var$multiDragElements),
                clones: [].concat($dc7ec905e041f51c$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $dc7ec905e041f51c$var$insertMultiDragElements(clonesInserted, rootEl) {
    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $dc7ec905e041f51c$var$insertMultiDragClones(elementsInserted, rootEl) {
    $dc7ec905e041f51c$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $dc7ec905e041f51c$var$removeMultiDragElements() {
    $dc7ec905e041f51c$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $dc7ec905e041f51c$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$dc7ec905e041f51c$export$31b3ca70d8f57423.mount(new $dc7ec905e041f51c$var$AutoScrollPlugin());
$dc7ec905e041f51c$export$31b3ca70d8f57423.mount($dc7ec905e041f51c$var$Remove, $dc7ec905e041f51c$var$Revert);
var $dc7ec905e041f51c$export$2e2bcd8739ae039 = $dc7ec905e041f51c$export$31b3ca70d8f57423;

});


parcelRequire.register("i0TKe", function(module, exports) {

$parcel$export(module.exports, "createPinia", () => $52e3354521f75c8c$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $52e3354521f75c8c$export$5061c4f75bbcb4a);
$parcel$export(module.exports, "storeToRefs", () => $52e3354521f75c8c$export$586af8bd019552de);
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("kwQGb");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
var $kwQGb = parcelRequire("kwQGb");

var $j6G8F = parcelRequire("j6G8F");
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $52e3354521f75c8c$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ // @ts-expect-error: cannot constrain the type of the return
const $52e3354521f75c8c$export$89ffb8149ccd46af = (pinia)=>$52e3354521f75c8c$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $52e3354521f75c8c$export$d0cc41ca14a2d060 = ()=>(0, $TusQn.hasInjectionContext)() && (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol) || $52e3354521f75c8c$var$activePinia;
const $52e3354521f75c8c$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $52e3354521f75c8c$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $52e3354521f75c8c$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($52e3354521f75c8c$export$d97371ba8df8c539 || ($52e3354521f75c8c$export$d97371ba8df8c539 = {}));
const $52e3354521f75c8c$var$IS_CLIENT = typeof window !== "undefined";
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */ const $52e3354521f75c8c$var$USE_DEVTOOLS = typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT;
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $52e3354521f75c8c$var$_global = /*#__PURE__*/ (()=>typeof window === "object" && window.window === window ? window : typeof self === "object" && self.self === self ? self : typeof $parcel$global === "object" && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === "object" ? globalThis : {
        HTMLElement: null
    })();
function $52e3354521f75c8c$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $52e3354521f75c8c$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = function() {
        $52e3354521f75c8c$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error("could not download file");
    };
    xhr.send();
}
function $52e3354521f75c8c$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open("HEAD", url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $52e3354521f75c8c$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent("click"));
    } catch (e) {
        const evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const $52e3354521f75c8c$var$_navigator = typeof navigator === "object" ? navigator : {
    userAgent: ""
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $52e3354521f75c8c$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($52e3354521f75c8c$var$_navigator.userAgent) && /AppleWebKit/.test($52e3354521f75c8c$var$_navigator.userAgent) && !/Safari/.test($52e3354521f75c8c$var$_navigator.userAgent))();
const $52e3354521f75c8c$var$saveAs = !$52e3354521f75c8c$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !$52e3354521f75c8c$var$isMacOSWebView ? $52e3354521f75c8c$var$downloadSaveAs : "msSaveOrOpenBlob" in $52e3354521f75c8c$var$_navigator ? $52e3354521f75c8c$var$msSaveAs : $52e3354521f75c8c$var$fileSaverSaveAs;
function $52e3354521f75c8c$var$downloadSaveAs(blob, name = "download", opts) {
    const a = document.createElement("a");
    a.download = name;
    a.rel = "noopener"; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === "string") {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($52e3354521f75c8c$var$corsEnabled(a.href)) $52e3354521f75c8c$var$download(blob, name, opts);
            else {
                a.target = "_blank";
                $52e3354521f75c8c$var$click(a);
            }
        } else $52e3354521f75c8c$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $52e3354521f75c8c$var$click(a);
        }, 0);
    }
}
function $52e3354521f75c8c$var$msSaveAs(blob, name = "download", opts) {
    if (typeof blob === "string") {
        if ($52e3354521f75c8c$var$corsEnabled(blob)) $52e3354521f75c8c$var$download(blob, name, opts);
        else {
            const a = document.createElement("a");
            a.href = blob;
            a.target = "_blank";
            setTimeout(function() {
                $52e3354521f75c8c$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($52e3354521f75c8c$var$bom(blob, opts), name);
}
function $52e3354521f75c8c$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open("", "_blank");
    if (popup) popup.document.title = popup.document.body.innerText = "downloading...";
    if (typeof blob === "string") return $52e3354521f75c8c$var$download(blob, name, opts);
    const force = blob.type === "application/octet-stream";
    const isSafari = /constructor/i.test(String($52e3354521f75c8c$var$_global.HTMLElement)) || "safari" in $52e3354521f75c8c$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $52e3354521f75c8c$var$isMacOSWebView) && typeof FileReader !== "undefined") {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== "string") {
                popup = null;
                throw new Error("Wrong reader.result type");
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $52e3354521f75c8c$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === "function") // No longer available :(
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === "error") console.error(piniaMessage);
    else if (type === "warn") console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $52e3354521f75c8c$var$isPinia(o) {
    return "_a" in o && "install" in o;
}
/**
 * This file contain devtools actions, they are not Pinia actions.
 */ // ---
function $52e3354521f75c8c$var$checkClipboardAccess() {
    if (!("clipboard" in navigator)) {
        $52e3354521f75c8c$var$toastMessage(`Your browser doesn't support the Clipboard API`, "error");
        return true;
    }
}
function $52e3354521f75c8c$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes("document is not focused")) {
        $52e3354521f75c8c$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn");
        return true;
    }
    return false;
}
async function $52e3354521f75c8c$var$actionGlobalCopyState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $52e3354521f75c8c$var$toastMessage("Global state copied to clipboard.");
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalPasteState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $52e3354521f75c8c$var$toastMessage("Global state pasted from clipboard.");
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalSaveState(pinia) {
    try {
        $52e3354521f75c8c$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: "text/plain;charset=utf-8"
        }), "pinia-state.json");
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
let $52e3354521f75c8c$var$fileInput;
function $52e3354521f75c8c$var$getFileOpener() {
    if (!$52e3354521f75c8c$var$fileInput) {
        $52e3354521f75c8c$var$fileInput = document.createElement("input");
        $52e3354521f75c8c$var$fileInput.type = "file";
        $52e3354521f75c8c$var$fileInput.accept = ".json";
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $52e3354521f75c8c$var$fileInput.onchange = async ()=>{
                const files = $52e3354521f75c8c$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $52e3354521f75c8c$var$fileInput.oncancel = ()=>resolve(null);
            $52e3354521f75c8c$var$fileInput.onerror = reject;
            $52e3354521f75c8c$var$fileInput.click();
        });
    }
    return openFile;
}
async function $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = $52e3354521f75c8c$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(text));
        $52e3354521f75c8c$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
function $52e3354521f75c8c$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) Object.assign(storeState, state[key]);
        else // store is not instantiated, set the initial state
        pinia.state.value[key] = state[key];
    }
}
function $52e3354521f75c8c$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $52e3354521f75c8c$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $52e3354521f75c8c$var$PINIA_ROOT_ID = "_root";
function $52e3354521f75c8c$var$formatStoreForInspectorTree(store) {
    return $52e3354521f75c8c$var$isPinia(store) ? {
        id: $52e3354521f75c8c$var$PINIA_ROOT_ID,
        label: $52e3354521f75c8c$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $52e3354521f75c8c$var$formatStoreForInspectorState(store) {
    if ($52e3354521f75c8c$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $52e3354521f75c8c$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $52e3354521f75c8c$var$formatDisplay(events.type),
        key: $52e3354521f75c8c$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $52e3354521f75c8c$var$formatMutationType(type) {
    switch(type){
        case $52e3354521f75c8c$export$d97371ba8df8c539.direct:
            return "mutation";
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction:
            return "$patch";
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchObject:
            return "$patch";
        default:
            return "unknown";
    }
}
// timeline can be paused when directly changing the state
let $52e3354521f75c8c$var$isTimelineActive = true;
const $52e3354521f75c8c$var$componentStateTypes = [];
const $52e3354521f75c8c$var$MUTATIONS_LAYER_ID = "pinia:mutations";
const $52e3354521f75c8c$var$INSPECTOR_ID = "pinia";
const { assign: $52e3354521f75c8c$var$assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $52e3354521f75c8c$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia) {
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $52e3354521f75c8c$var$toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.addTimelineLayer({
            id: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
            label: `Pinia 🍍`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $52e3354521f75c8c$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: "storage",
            treeFilterPlaceholder: "Search stores",
            actions: [
                {
                    icon: "content_copy",
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: "Serialize and copy the state"
                },
                {
                    icon: "content_paste",
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: "Replace the state with the content of your clipboard"
                },
                {
                    icon: "save",
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: "Save the state as a JSON file"
                },
                {
                    icon: "folder_open",
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: "Import the state from a JSON file"
                }
            ],
            nodeActions: [
                {
                    icon: "restore",
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, "warn");
                        else if (typeof store.$reset !== "function") $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, "warn");
                        else {
                            store.$reset();
                            $52e3354521f75c8c$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload, ctx)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: "state",
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $01W3b.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: "restore",
                                        tooltip: "Reset the state of this store",
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: "getters",
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>"$id" in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $52e3354521f75c8c$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($52e3354521f75c8c$var$formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) payload.state = $52e3354521f75c8c$var$formatStoreForInspectorState(inspectedStore);
            }
        });
        api.on.editInspectorState((payload, ctx)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $52e3354521f75c8c$var$toastMessage(`store "${payload.nodeId}" not found`, "error");
                const { path: path } = payload;
                if (!$52e3354521f75c8c$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift("$state");
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift("state");
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, "");
                const store = pinia._s.get(storeId);
                if (!store) return $52e3354521f75c8c$var$toastMessage(`store "${storeId}" not found`, "error");
                const { path: path } = payload;
                if (path[0] !== "state") return $52e3354521f75c8c$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = "$state";
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
    });
}
function $52e3354521f75c8c$var$addStoreToDevtools(app, store) {
    if (!$52e3354521f75c8c$var$componentStateTypes.includes($52e3354521f75c8c$var$getStoreType(store.$id))) $52e3354521f75c8c$var$componentStateTypes.push($52e3354521f75c8c$var$getStoreType(store.$id));
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: "Notify about new/deleted stores",
                type: "boolean",
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === "function" ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $52e3354521f75c8c$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: "start",
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        action: $52e3354521f75c8c$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: "end",
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: "error",
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: "end",
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $TusQn.watch)(()=>(0, $01W3b.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                if ($52e3354521f75c8c$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "Change",
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $52e3354521f75c8c$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            if (!$52e3354521f75c8c$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $52e3354521f75c8c$var$formatMutationType(type),
                data: $52e3354521f75c8c$var$assign$1({
                    store: $52e3354521f75c8c$var$formatDisplay(store.$id)
                }, $52e3354521f75c8c$var$formatEventData(events)),
                groupId: $52e3354521f75c8c$var$activeAction
            };
            if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "⤵️";
            else if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data["rawEvent(s)"] = {
                _custom: {
                    display: "DebuggerEvent",
                    type: "object",
                    tooltip: "raw DebuggerEvent[]",
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: "sync"
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $01W3b.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: "HMR update",
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        info: $52e3354521f75c8c$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`Disposed "${store.$id}" store 🗑`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`"${store.$id}" store installed 🆕`);
    });
}
let $52e3354521f75c8c$var$runningActionId = 0;
let $52e3354521f75c8c$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $52e3354521f75c8c$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $01W3b.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // the running action id is incremented in a before action hook
        const _actionId = $52e3354521f75c8c$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        // For Setup Stores we need https://github.com/tc39/proposal-async-context
        $52e3354521f75c8c$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        // this is safer as async actions in Setup Stores would associate mutations done outside of the action
        $52e3354521f75c8c$var$activeAction = undefined;
        return retValue;
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $52e3354521f75c8c$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith("__hot:")) return;
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
    // Upgrade the HMR to also update the new actions
    const originalHotUpdate = store._hotUpdate;
    (0, $01W3b.toRaw)(store)._hotUpdate = function(newStore) {
        originalHotUpdate.apply(this, arguments);
        $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
    };
    $52e3354521f75c8c$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $52e3354521f75c8c$export$4b9f6a0748623d44() {
    const scope = (0, $01W3b.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $01W3b.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $01W3b.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            if (!(0, $kwQGb.isVue2)) {
                pinia._a = app;
                app.provide($52e3354521f75c8c$var$piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */ if ($52e3354521f75c8c$var$USE_DEVTOOLS) $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia);
                toBeInstalled.forEach((plugin)=>_p.push(plugin));
                toBeInstalled = [];
            }
        },
        use (plugin) {
            if (!this._a && !(0, $kwQGb.isVue2)) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if ($52e3354521f75c8c$var$USE_DEVTOOLS && typeof Proxy !== "undefined") pinia.use($52e3354521f75c8c$var$devtoolsPlugin);
    return pinia;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $52e3354521f75c8c$var$isUseStore = (fn)=>{
    return typeof fn === "function" && typeof fn.$id === "string";
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $52e3354521f75c8c$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) newState[key] = $52e3354521f75c8c$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        if (0, $kwQGb.isVue2) (0, $kwQGb.set)(newState, key, subPatch);
        else newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $52e3354521f75c8c$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $52e3354521f75c8c$var$noop = ()=>{};
function $52e3354521f75c8c$var$addSubscription(subscriptions, callback, detached, onCleanup = $52e3354521f75c8c$var$noop) {
    subscriptions.push(callback);
    const removeSubscription = ()=>{
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && (0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback)=>{
        callback(...args);
    });
}
const $52e3354521f75c8c$var$fallbackRunWithContext = (fn)=>fn();
function $52e3354521f75c8c$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    // Handle Set instances
    if (target instanceof Set && patchToApply instanceof Set) patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $52e3354521f75c8c$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $52e3354521f75c8c$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
const $52e3354521f75c8c$var$skipHydrateMap = /*#__PURE__*/ new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $52e3354521f75c8c$export$dbb88672ab248e88(obj) {
    return (0, $kwQGb.isVue2) ? /* istanbul ignore next */ $52e3354521f75c8c$var$skipHydrateMap.set(obj, 1) && obj : Object.defineProperty(obj, $52e3354521f75c8c$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $52e3354521f75c8c$var$shouldHydrate(obj) {
    return (0, $kwQGb.isVue2) ? /* istanbul ignore next */ !$52e3354521f75c8c$var$skipHydrateMap.has(obj) : !$52e3354521f75c8c$var$isPlainObject(obj) || !obj.hasOwnProperty($52e3354521f75c8c$var$skipHydrateSymbol);
}
const { assign: $52e3354521f75c8c$var$assign } = Object;
function $52e3354521f75c8c$var$isComputed(o) {
    return !!((0, $01W3b.isRef)(o) && o.effect);
}
function $52e3354521f75c8c$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) {
            /* istanbul ignore if */ if (0, $kwQGb.isVue2) (0, $kwQGb.set)(pinia.state.value, id, state ? state() : {});
            else pinia.state.value[id] = state ? state() : {};
        }
        // avoid creating a state in pinia.state.value
        const localState = (0, $01W3b.toRefs)(pinia.state.value[id]);
        return $52e3354521f75c8c$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $01W3b.markRaw)((0, $TusQn.computed)(()=>{
                $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore next */ if ((0, $kwQGb.isVue2) && !store._r) return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $52e3354521f75c8c$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $52e3354521f75c8c$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = [];
    let actionSubscriptions = [];
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) {
        /* istanbul ignore if */ if (0, $kwQGb.isVue2) (0, $kwQGb.set)(pinia.state.value, $id, {});
        else pinia.state.value[$id] = {};
    }
    const hotState = (0, $01W3b.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === "function") {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $52e3354521f75c8c$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $TusQn.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            $52e3354521f75c8c$var$assign($state, newState);
        });
    } : $52e3354521f75c8c$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Wraps an action to handle subscriptions.
     *
     * @param name - name of the action
     * @param action - action to wrap
     * @returns a wrapped action to handle subscriptions
     */ function wrapAction(name, action) {
        return function() {
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            $52e3354521f75c8c$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: name,
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = action.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackList, value);
                return value;
            }).catch((error)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackList, error);
                return Promise.reject(error);
            });
            // trigger after callbacks
            $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
    }
    const _hmrPayload = /*#__PURE__*/ (0, $01W3b.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $52e3354521f75c8c$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $52e3354521f75c8c$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $TusQn.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === "sync" ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $52e3354521f75c8c$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $52e3354521f75c8c$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    /* istanbul ignore if */ if (0, $kwQGb.isVue2) // start as non ready
    partialStore._r = false;
    const store = (0, $01W3b.reactive)($52e3354521f75c8c$var$USE_DEVTOOLS ? $52e3354521f75c8c$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $01W3b.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = pinia._a && pinia._a.runWithContext || $52e3354521f75c8c$var$fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(()=>pinia._e.run(()=>(scope = (0, $01W3b.effectScope)()).run(setup)));
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $01W3b.isRef)(prop) && !$52e3354521f75c8c$var$isComputed(prop) || (0, $01W3b.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $52e3354521f75c8c$var$shouldHydrate(prop)) {
                    if ((0, $01W3b.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $52e3354521f75c8c$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */ if (0, $kwQGb.isVue2) (0, $kwQGb.set)(pinia.state.value[$id], key, prop);
                else pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === "function") {
            // @ts-expect-error: we are overriding the function we avoid wrapping if
            const actionValue = wrapAction(key, prop);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */ if (0, $kwQGb.isVue2) (0, $kwQGb.set)(setupStore, key, actionValue);
            else // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ if (0, $kwQGb.isVue2) Object.keys(setupStore).forEach((key)=>{
        (0, $kwQGb.set)(store, key, setupStore[key]);
    });
    else {
        $52e3354521f75c8c$var$assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        $52e3354521f75c8c$var$assign((0, $01W3b.toRaw)(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, "$state", {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                $52e3354521f75c8c$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if ($52e3354521f75c8c$var$USE_DEVTOOLS) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            "_p",
            "_hmrPayload",
            "_getters",
            "_customProperties"
        ].forEach((p)=>{
            Object.defineProperty(store, p, $52e3354521f75c8c$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    /* istanbul ignore if */ if (0, $kwQGb.isVue2) // mark the store as ready before plugins
    store._r = true;
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if ($52e3354521f75c8c$var$USE_DEVTOOLS) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $52e3354521f75c8c$var$assign(store, extensions);
        } else $52e3354521f75c8c$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
function $52e3354521f75c8c$export$5061c4f75bbcb4a(// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === "function";
    if (typeof idOrOptions === "string") {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    } else {
        options = idOrOptions;
        id = idOrOptions.id;
    }
    function useStore(pinia, hot) {
        const hasContext = (0, $TusQn.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol, null) : null);
        if (pinia) $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
        pinia = $52e3354521f75c8c$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia);
            else $52e3354521f75c8c$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $52e3354521f75c8c$var$mapStoreSuffix = "Store";
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $52e3354521f75c8c$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $52e3354521f75c8c$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $52e3354521f75c8c$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $52e3354521f75c8c$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === "function" ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $52e3354521f75c8c$export$74d9085e6d5a97cb = $52e3354521f75c8c$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-ignore
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                // it's easier to type it here as any
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-ignore
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                // it's easier to type it here as any
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $52e3354521f75c8c$export$586af8bd019552de(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (0, $kwQGb.isVue2) // @ts-expect-error: toRefs include methods and others
    return (0, $01W3b.toRefs)(store);
    else {
        store = (0, $01W3b.toRaw)(store);
        const refs = {};
        for(const key in store){
            const value = store[key];
            if ((0, $01W3b.isRef)(value) || (0, $01W3b.isReactive)(value)) // @ts-expect-error: the key is state or getter
            refs[key] = // ---
            (0, $01W3b.toRef)(store, key);
        }
        return refs;
    }
}
/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */ const $52e3354521f75c8c$export$a99c5571bb37058e = function(_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate () {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */ if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, "_provided", {
                        get: ()=>provideCache,
                        set: (v)=>Object.assign(provideCache, v)
                    });
                }
                this._provided[$52e3354521f75c8c$var$piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */ if (!this.$pinia) this.$pinia = pinia;
                pinia._a = this;
                if ($52e3354521f75c8c$var$IS_CLIENT) // this allows calling useStore() outside of a component setup after
                // installing pinia's plugin
                $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
                if ($52e3354521f75c8c$var$USE_DEVTOOLS) $52e3354521f75c8c$var$registerPiniaDevtools(pinia._a, pinia);
            } else if (!this.$pinia && options.parent && options.parent.$pinia) this.$pinia = options.parent.$pinia;
        },
        destroyed () {
            delete this._pStores;
        }
    });
};

});
parcelRequire.register("kwQGb", function(module, exports) {

$parcel$export(module.exports, "isVue2", () => $b96aa8e01a022d58$export$1da84e343e81ceb9);
$parcel$export(module.exports, "set", () => $b96aa8e01a022d58$export$adaa4cf7ef1b65be);

var $ecd4d = parcelRequire("ecd4d");
var $b96aa8e01a022d58$export$1da84e343e81ceb9 = false;
var $b96aa8e01a022d58$export$34b222e3d4733e48 = true;
var $b96aa8e01a022d58$export$a8cb34872e7d8b79 = undefined;
function $b96aa8e01a022d58$export$4b3e715f166fdd78() {}
function $b96aa8e01a022d58$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $b96aa8e01a022d58$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}
$parcel$exportWildcard(module.exports, $ecd4d);

});


parcelRequire.register("2xmtF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d9019689151a3a9$export$2e2bcd8739ae039);
let $1d9019689151a3a9$var$script;




let $1d9019689151a3a9$var$initialize = ()=>{
    $1d9019689151a3a9$var$script = (parcelRequire("cFyrq"));
    if ($1d9019689151a3a9$var$script.__esModule) $1d9019689151a3a9$var$script = $1d9019689151a3a9$var$script.default;
    $1d9019689151a3a9$var$script.render = (parcelRequire("42Moj")).render;
    $1d9019689151a3a9$var$script.__cssModules = (parcelRequire("hU1qC")).default;
    (parcelRequire("cZJOq")).default($1d9019689151a3a9$var$script);
    $1d9019689151a3a9$var$script.__scopeId = "data-v-1707ab";
    $1d9019689151a3a9$var$script.__file = "AppInfoMessage.vue";
};
$1d9019689151a3a9$var$initialize();
var $1d9019689151a3a9$export$2e2bcd8739ae039 = $1d9019689151a3a9$var$script;

});
parcelRequire.register("cFyrq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0f281a210780ce7f$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $khdnb = parcelRequire("khdnb");
var $0f281a210780ce7f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "AppInfoMessage",
    props: {
        message: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = {
            props: props,
            get QCard () {
                return 0, $khdnb.QCard;
            },
            get QCardSection () {
                return 0, $khdnb.QCardSection;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRequire.register("42Moj", function(module, exports) {

$parcel$export(module.exports, "render", () => $2f1ce2c863e8a797$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
function $2f1ce2c863e8a797$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = (0, $TusQn.resolveComponent)("q-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["QCard"], {
        flat: "",
        bordered: "",
        class: "q-pt-md q-pb-md q-mt-sm q-mb-sm"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)($setup["QCardSection"], {
                    horizontal: "",
                    class: (0, $8POXm.normalizeClass)(_ctx.$style.area)
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_q_icon, {
                                name: "info",
                                size: "48px",
                                color: "blue"
                            }),
                            (0, $TusQn.createVNode)($setup["QCardSection"], null, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($props.message), 1)
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "class"
                ])
            ]),
        _: 1
    });
}

});

parcelRequire.register("hU1qC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d088c6499d89533a$export$2e2bcd8739ae039);
parcelRequire("42Moj");
let $d088c6499d89533a$var$cssModules = {
    "$style": {
        "area": "_area_1mdrh_2"
    }
};
var $d088c6499d89533a$export$2e2bcd8739ae039 = $d088c6499d89533a$var$cssModules;

});

parcelRequire.register("cZJOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $975eb7e99665fdae$export$2e2bcd8739ae039);
let $975eb7e99665fdae$var$NOOP = ()=>{};
var $975eb7e99665fdae$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("cfJHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eba5704f75db261$export$2e2bcd8739ae039);
let $8eba5704f75db261$var$script;



let $8eba5704f75db261$var$initialize = ()=>{
    $8eba5704f75db261$var$script = (parcelRequire("5UjXK"));
    if ($8eba5704f75db261$var$script.__esModule) $8eba5704f75db261$var$script = $8eba5704f75db261$var$script.default;
    $8eba5704f75db261$var$script.render = (parcelRequire("bdbXo")).render;
    (parcelRequire("8n0HU")).default($8eba5704f75db261$var$script);
    $8eba5704f75db261$var$script.__scopeId = "data-v-4fc0d5";
    $8eba5704f75db261$var$script.__file = "QuestionsPageEditor.vue";
};
$8eba5704f75db261$var$initialize();
var $8eba5704f75db261$export$2e2bcd8739ae039 = $8eba5704f75db261$var$script;

});
parcelRequire.register("5UjXK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f9f1013ccf96a604$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $i0TKe = parcelRequire("i0TKe");

var $8qY0g = parcelRequire("8qY0g");

var $cHm2O = parcelRequire("cHm2O");

var $5sKyw = parcelRequire("5sKyw");

var $8htdk = parcelRequire("8htdk");
var $f9f1013ccf96a604$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "QuestionsPageEditor",
    setup (__props, { expose: __expose }) {
        __expose();
        const surveyStore = (0, $8qY0g.useSurveysStore)();
        const { currentPage: currentPage } = (0, $i0TKe.storeToRefs)(surveyStore);
        let lastItemExpanded = null;
        const conditionalOptions = (0, $TusQn.computed)(()=>{
            const options = currentPage.value.data.questions.filter((question)=>question.type === "multichoice").map((question)=>{
                return {
                    label: `[${question.id}] ${question.body}`,
                    value: question.internalID
                };
            });
            return [
                {
                    label: "Aucune",
                    value: null
                }
            ].concat(...options);
        });
        function getAcceptedAnswersOptions(questionID) {
            let questions = currentPage.value.data.questions.filter((question)=>question.internalID === questionID && question.type === "multichoice");
            if (questions.length === 0) return [];
            let question = questions[0];
            return question.answers.map((answer)=>{
                return {
                    label: `[${answer.code}] ${answer.body}`,
                    value: answer.internalID
                };
            });
        }
        function removeAcceptedAnswer(answers, index) {
            answers.splice(index, 1);
        }
        async function addMultiChoiceQuestion() {
            currentPage.value.data.questions.push({
                ...getDefaultBaseQuestion("multichoice"),
                answers: []
            });
            await (0, $TusQn.nextTick)();
        }
        async function addFreeTextQuestion() {
            currentPage.value.data.questions.push({
                ...getDefaultBaseQuestion("string"),
                choice: ""
            });
            await (0, $TusQn.nextTick)();
        }
        async function addNumberQuestion() {
            currentPage.value.data.questions.push({
                ...getDefaultBaseQuestion("number"),
                choice: 0
            });
            await (0, $TusQn.nextTick)();
        }
        function getDefaultBaseQuestion(type) {
            return {
                id: "",
                internalID: (0, $5sKyw.default)(),
                type: type,
                body: "",
                choice: null,
                condition: {
                    questionID: null,
                    answers: []
                }
            };
        }
        function addConditionalAnswer(conditions) {
            conditions.push(null);
        }
        function onShow(event) {
            lastItemExpanded = event.target;
        }
        function afterShow() {
            if (!lastItemExpanded) return;
            lastItemExpanded.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
        const __returned__ = {
            surveyStore: surveyStore,
            currentPage: currentPage,
            get lastItemExpanded () {
                return lastItemExpanded;
            },
            set lastItemExpanded (v){
                lastItemExpanded = v;
            },
            conditionalOptions: conditionalOptions,
            getAcceptedAnswersOptions: getAcceptedAnswersOptions,
            removeAcceptedAnswer: removeAcceptedAnswer,
            addMultiChoiceQuestion: addMultiChoiceQuestion,
            addFreeTextQuestion: addFreeTextQuestion,
            addNumberQuestion: addNumberQuestion,
            getDefaultBaseQuestion: getDefaultBaseQuestion,
            addConditionalAnswer: addConditionalAnswer,
            onShow: onShow,
            afterShow: afterShow,
            get draggable () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($cHm2O));
            },
            get duplicateQuestion () {
                return 0, $8htdk.duplicateQuestion;
            },
            get removeQuestion () {
                return 0, $8htdk.removeQuestion;
            },
            get removeAnswer () {
                return 0, $8htdk.removeAnswer;
            },
            get addAnswer () {
                return 0, $8htdk.addAnswer;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRequire.register("8qY0g", function(module, exports) {

$parcel$export(module.exports, "useSurveysStore", () => $23d2b2325250bd08$export$3aed26cfaf01f2bb);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $i0TKe = parcelRequire("i0TKe");

var $5sKyw = parcelRequire("5sKyw");

var $521sb = parcelRequire("521sb");
const $23d2b2325250bd08$export$3aed26cfaf01f2bb = (0, $i0TKe.defineStore)("surveys", ()=>{
    const survey = (0, $01W3b.ref)(null);
    const currentPage = (0, $01W3b.ref)(null);
    const currentPageIndex = (0, $01W3b.ref)(-1);
    async function loadSurvey(surveyID) {
        await (0, $521sb.sendRequest)({
            uri: `/api/surveys/${surveyID}`
        }).then(async (response)=>{
            survey.value = await response.json();
            survey.value.pages.forEach(patchPage);
        });
    }
    function setCurrentPage(pageIndex) {
        let page = getPageByIndex(pageIndex);
        patchPage(page);
        currentPage.value = page;
        currentPageIndex.value = pageIndex;
    }
    function selectLastPage() {
        if (survey.value === null) throw Error();
        let pageIndex = survey.value.pages.length - 1;
        setCurrentPage(pageIndex);
    }
    function getPageByIndex(index) {
        return survey.value?.pages[index];
    }
    function patchSingleQuestion(question) {
        if (!question.condition) question.condition = {
            questionID: null,
            answers: []
        };
        if (!question.type) question.type = "multichoice";
        if (question.type == "multichoice") question.answers.forEach(patchAnswer);
    }
    function patchQuestion(question) {
        if (!question.internalID) question.internalID = (0, $5sKyw.default)();
    }
    function patchAnswer(answer) {
        if (!answer.internalID) answer.internalID = (0, $5sKyw.default)();
    }
    function patchPage(page) {
        if (!page.id) page.id = (0, $5sKyw.default)();
        if (!page.description) page.description = "";
        page.data.questions.forEach(patchQuestion);
        if (page?.type === "questions") page.data.questions.forEach(patchSingleQuestion);
        else if (page?.type === "table") page.data.answers.forEach(patchAnswer);
    }
    return {
        survey: survey,
        currentPage: currentPage,
        currentPageIndex: currentPageIndex,
        loadSurvey: loadSurvey,
        setCurrentPage: setCurrentPage,
        selectLastPage: selectLastPage
    };
});

});
parcelRequire.register("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRequire.register("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRequire.register("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRequire.register("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRequire.register("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRequire.register("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





parcelRequire.register("8htdk", function(module, exports) {

$parcel$export(module.exports, "duplicateQuestion", () => $5a74f6648133f8f7$export$615875c50e608423);
$parcel$export(module.exports, "addAnswer", () => $5a74f6648133f8f7$export$7a6edd6200baeed7);
$parcel$export(module.exports, "removeAnswer", () => $5a74f6648133f8f7$export$f8ec0448ea3b075b);
$parcel$export(module.exports, "removeQuestion", () => $5a74f6648133f8f7$export$4a751bcd52dbf567);

var $5sKyw = parcelRequire("5sKyw");
function $5a74f6648133f8f7$export$615875c50e608423(page, index) {
    const questions = page.data.questions;
    if (!questions) return;
    let question = questions[index];
    questions.push({
        ...JSON.parse(JSON.stringify(question)),
        internalID: undefined,
        id: ""
    });
}
function $5a74f6648133f8f7$export$7a6edd6200baeed7(parent) {
    parent.answers.push({
        body: "",
        code: "",
        internalID: (0, $5sKyw.default)()
    });
}
function $5a74f6648133f8f7$export$f8ec0448ea3b075b(parent, index) {
    parent.answers.splice(index, 1);
}
function $5a74f6648133f8f7$export$4a751bcd52dbf567(page, index) {
    page.data.questions.splice(index, 1);
}

});


parcelRequire.register("bdbXo", function(module, exports) {

$parcel$export(module.exports, "render", () => $829a2eff0654a288$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $829a2eff0654a288$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_item_label = (0, $TusQn.resolveComponent)("q-item-label");
    const _component_q_btn = (0, $TusQn.resolveComponent)("q-btn");
    const _component_q_card_actions = (0, $TusQn.resolveComponent)("q-card-actions");
    const _component_q_input = (0, $TusQn.resolveComponent)("q-input");
    const _component_q_editor = (0, $TusQn.resolveComponent)("q-editor");
    const _component_q_select = (0, $TusQn.resolveComponent)("q-select");
    const _component_q_tooltip = (0, $TusQn.resolveComponent)("q-tooltip");
    const _component_q_item = (0, $TusQn.resolveComponent)("q-item");
    const _component_q_list = (0, $TusQn.resolveComponent)("q-list");
    const _component_q_card_section = (0, $TusQn.resolveComponent)("q-card-section");
    const _component_q_card = (0, $TusQn.resolveComponent)("q-card");
    const _component_q_expansion_item = (0, $TusQn.resolveComponent)("q-expansion-item");
    const _component_q_separator = (0, $TusQn.resolveComponent)("q-separator");
    return $setup.currentPage && $setup.currentPage.type === "questions" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_list, {
        key: 0,
        bordered: ""
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_q_item_label, {
                    header: ""
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)("Questions")
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)($setup["draggable"], {
                    modelValue: $setup.currentPage.data.questions,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.currentPage.data.questions = $event),
                    handle: ".question.q-expansion-item .q-item",
                    "item-key": "internalID"
                }, {
                    item: (0, $TusQn.withCtx)(({ element: question, index: qIndex })=>[
                            (0, $TusQn.createVNode)(_component_q_expansion_item, {
                                "expand-separator": "",
                                class: "question",
                                icon: "question_mark",
                                label: question.body,
                                caption: question.id,
                                group: "questions",
                                onShow: _cache[0] || (_cache[0] = ($event)=>$setup.onShow($event)),
                                onAfterShow: _cache[1] || (_cache[1] = ($event)=>$setup.afterShow())
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_q_card, null, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_q_card_actions, {
                                                        align: "right"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_btn, {
                                                                    onClick: ($event)=>$setup.removeQuestion($setup.currentPage, qIndex),
                                                                    icon: "remove",
                                                                    label: "Supprimer la question",
                                                                    color: "negative",
                                                                    outline: ""
                                                                }, null, 8, [
                                                                    "onClick"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_btn, {
                                                                    onClick: ($event)=>$setup.duplicateQuestion($setup.currentPage, qIndex),
                                                                    icon: "content_copy",
                                                                    label: "dupliquer la question",
                                                                    color: "primary",
                                                                    outline: ""
                                                                }, null, 8, [
                                                                    "onClick"
                                                                ])
                                                            ]),
                                                        _: 2
                                                    }, 1024),
                                                    (0, $TusQn.createVNode)(_component_q_card_section, null, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_input, {
                                                                    modelValue: question.id,
                                                                    "onUpdate:modelValue": ($event)=>question.id = $event,
                                                                    label: "Identifiant de la question"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_editor, {
                                                                    modelValue: question.body,
                                                                    "onUpdate:modelValue": ($event)=>question.body = $event,
                                                                    "min-height": "5rem"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_select, {
                                                                    options: $setup.conditionalOptions,
                                                                    modelValue: question.condition.questionID,
                                                                    "onUpdate:modelValue": ($event)=>question.condition.questionID = $event,
                                                                    "emit-value": true,
                                                                    "map-options": true,
                                                                    label: "Conditionn\xe9e par la r\xe9ponse \xe0 la question"
                                                                }, null, 8, [
                                                                    "options",
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ]),
                                                                question.condition.questionID ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_list, {
                                                                    key: 0,
                                                                    bordered: ""
                                                                }, {
                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                            (0, $TusQn.createVNode)(_component_q_item_label, {
                                                                                header: ""
                                                                            }, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        (0, $TusQn.createTextVNode)("R\xe9ponses accept\xe9es")
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(question.condition.answers, (acceptedAnswerInternalID, acceptedAnswerIndex)=>{
                                                                                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_item, {
                                                                                    key: acceptedAnswerInternalID
                                                                                }, {
                                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                                            (0, $TusQn.createVNode)(_component_q_select, {
                                                                                                options: $setup.getAcceptedAnswersOptions(question.condition.questionID),
                                                                                                modelValue: question.condition.answers[acceptedAnswerIndex],
                                                                                                "onUpdate:modelValue": ($event)=>question.condition.answers[acceptedAnswerIndex] = $event,
                                                                                                "emit-value": true,
                                                                                                "map-options": true,
                                                                                                label: "R\xe9ponse"
                                                                                            }, null, 8, [
                                                                                                "options",
                                                                                                "modelValue",
                                                                                                "onUpdate:modelValue"
                                                                                            ]),
                                                                                            (0, $TusQn.createVNode)(_component_q_btn, {
                                                                                                class: "gt-xs",
                                                                                                size: "12px",
                                                                                                flat: "",
                                                                                                dense: "",
                                                                                                round: "",
                                                                                                icon: "delete",
                                                                                                onClick: ($event)=>$setup.removeAcceptedAnswer(question.condition.answers, acceptedAnswerIndex)
                                                                                            }, {
                                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                                        (0, $TusQn.createVNode)(_component_q_tooltip, null, {
                                                                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                                                                    (0, $TusQn.createTextVNode)("Supprimer")
                                                                                                                ]),
                                                                                                            _: 1
                                                                                                        })
                                                                                                    ]),
                                                                                                _: 2
                                                                                            }, 1032, [
                                                                                                "onClick"
                                                                                            ])
                                                                                        ]),
                                                                                    _: 2
                                                                                }, 1024);
                                                                            }), 128)),
                                                                            (0, $TusQn.createVNode)(_component_q_item, null, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        (0, $TusQn.createVNode)(_component_q_btn, {
                                                                                            onClick: ($event)=>$setup.addConditionalAnswer(question.condition.answers),
                                                                                            icon: "add",
                                                                                            label: "R\xe9ponse accept\xe9e",
                                                                                            outline: ""
                                                                                        }, null, 8, [
                                                                                            "onClick"
                                                                                        ])
                                                                                    ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                    _: 2
                                                                }, 1024)) : (0, $TusQn.createCommentVNode)("", true)
                                                            ]),
                                                        _: 2
                                                    }, 1024),
                                                    question.type === "multichoice" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_card_section, {
                                                        key: 0
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_list, {
                                                                    bordered: ""
                                                                }, {
                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                            (0, $TusQn.createVNode)(_component_q_item_label, {
                                                                                header: ""
                                                                            }, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        (0, $TusQn.createTextVNode)("R\xe9ponses possibles")
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $TusQn.createVNode)($setup["draggable"], {
                                                                                modelValue: question.answers,
                                                                                "onUpdate:modelValue": ($event)=>question.answers = $event,
                                                                                handle: ".answer.q-expansion-item .q-item",
                                                                                "item-key": "internalID"
                                                                            }, {
                                                                                item: (0, $TusQn.withCtx)(({ element: answer, index: index })=>[
                                                                                        (0, $TusQn.createVNode)(_component_q_expansion_item, {
                                                                                            group: "questions-answers",
                                                                                            "expand-separator": "",
                                                                                            icon: "fact_check",
                                                                                            class: "answer",
                                                                                            label: answer.body,
                                                                                            caption: answer.code
                                                                                        }, {
                                                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                                                    (0, $TusQn.createVNode)(_component_q_card, null, {
                                                                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                                                                (0, $TusQn.createVNode)(_component_q_card_actions, {
                                                                                                                    align: "right"
                                                                                                                }, {
                                                                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                                                                            (0, $TusQn.createVNode)(_component_q_btn, {
                                                                                                                                onClick: ($event)=>$setup.removeAnswer(question, index),
                                                                                                                                icon: "remove",
                                                                                                                                label: "Supprimer la r\xe9ponse",
                                                                                                                                color: "negative",
                                                                                                                                outline: ""
                                                                                                                            }, null, 8, [
                                                                                                                                "onClick"
                                                                                                                            ])
                                                                                                                        ]),
                                                                                                                    _: 2
                                                                                                                }, 1024),
                                                                                                                (0, $TusQn.createVNode)(_component_q_card_section, null, {
                                                                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                                                                            (0, $TusQn.createVNode)(_component_q_input, {
                                                                                                                                modelValue: answer.body,
                                                                                                                                "onUpdate:modelValue": ($event)=>answer.body = $event,
                                                                                                                                label: "R\xe9ponse \xe0 afficher"
                                                                                                                            }, null, 8, [
                                                                                                                                "modelValue",
                                                                                                                                "onUpdate:modelValue"
                                                                                                                            ]),
                                                                                                                            (0, $TusQn.createVNode)(_component_q_input, {
                                                                                                                                modelValue: answer.code,
                                                                                                                                "onUpdate:modelValue": ($event)=>answer.code = $event,
                                                                                                                                label: "Code interne"
                                                                                                                            }, null, 8, [
                                                                                                                                "modelValue",
                                                                                                                                "onUpdate:modelValue"
                                                                                                                            ])
                                                                                                                        ]),
                                                                                                                    _: 2
                                                                                                                }, 1024)
                                                                                                            ]),
                                                                                                        _: 2
                                                                                                    }, 1024)
                                                                                                ]),
                                                                                            _: 2
                                                                                        }, 1032, [
                                                                                            "label",
                                                                                            "caption"
                                                                                        ])
                                                                                    ]),
                                                                                _: 2
                                                                            }, 1032, [
                                                                                "modelValue",
                                                                                "onUpdate:modelValue"
                                                                            ]),
                                                                            (0, $TusQn.createVNode)(_component_q_separator),
                                                                            (0, $TusQn.createVNode)(_component_q_item, null, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        (0, $TusQn.createVNode)(_component_q_btn, {
                                                                                            onClick: ($event)=>$setup.addAnswer(question),
                                                                                            icon: "add",
                                                                                            label: "R\xe9ponse",
                                                                                            outline: ""
                                                                                        }, null, 8, [
                                                                                            "onClick"
                                                                                        ])
                                                                                    ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                    _: 2
                                                                }, 1024)
                                                            ]),
                                                        _: 2
                                                    }, 1024)) : (0, $TusQn.createCommentVNode)("", true)
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                _: 2
                            }, 1032, [
                                "label",
                                "caption"
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "modelValue"
                ]),
                (0, $TusQn.createVNode)(_component_q_item, {
                    class: "justify-around"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_q_btn, {
                                onClick: _cache[3] || (_cache[3] = ($event)=>$setup.addMultiChoiceQuestion()),
                                color: "primary",
                                icon: "add",
                                label: "Question multichoix",
                                size: "l",
                                outline: "",
                                "icon-right": "task_alt"
                            }),
                            (0, $TusQn.createVNode)(_component_q_btn, {
                                onClick: _cache[4] || (_cache[4] = ($event)=>$setup.addFreeTextQuestion()),
                                color: "primary",
                                icon: "add",
                                label: "Question \xe0 r\xe9ponse text libre",
                                size: "l",
                                outline: "",
                                "icon-right": "keyboard"
                            }),
                            (0, $TusQn.createVNode)(_component_q_btn, {
                                onClick: _cache[5] || (_cache[5] = ($event)=>$setup.addNumberQuestion()),
                                color: "primary",
                                icon: "add",
                                label: "Question \xe0 r\xe9ponse num\xe9rique",
                                size: "l",
                                "icon-right": "123",
                                outline: ""
                            })
                        ]),
                    _: 1
                })
            ]),
        _: 1
    })) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRequire.register("8n0HU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61810526788a7257$export$2e2bcd8739ae039);
let $61810526788a7257$var$NOOP = ()=>{};
var $61810526788a7257$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("778Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $52dfff21017c36e0$export$2e2bcd8739ae039);
let $52dfff21017c36e0$var$script;



let $52dfff21017c36e0$var$initialize = ()=>{
    $52dfff21017c36e0$var$script = (parcelRequire("af3C4"));
    if ($52dfff21017c36e0$var$script.__esModule) $52dfff21017c36e0$var$script = $52dfff21017c36e0$var$script.default;
    $52dfff21017c36e0$var$script.render = (parcelRequire("1IZJt")).render;
    (parcelRequire("fqRgi")).default($52dfff21017c36e0$var$script);
    $52dfff21017c36e0$var$script.__scopeId = "data-v-23f739";
    $52dfff21017c36e0$var$script.__file = "TablePageEditor.vue";
};
$52dfff21017c36e0$var$initialize();
var $52dfff21017c36e0$export$2e2bcd8739ae039 = $52dfff21017c36e0$var$script;

});
parcelRequire.register("af3C4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $afe8651323643d2e$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $i0TKe = parcelRequire("i0TKe");

var $5sKyw = parcelRequire("5sKyw");

var $cHm2O = parcelRequire("cHm2O");

var $8qY0g = parcelRequire("8qY0g");

var $8htdk = parcelRequire("8htdk");
var $afe8651323643d2e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "TablePageEditor",
    setup (__props, { expose: __expose }) {
        __expose();
        const surveyStore = (0, $8qY0g.useSurveysStore)();
        const { currentPage: currentPage } = (0, $i0TKe.storeToRefs)(surveyStore);
        let lastItemExpanded = null;
        function addQuestionToTable() {
            currentPage.value.data.questions.push({
                id: "",
                internalID: (0, $5sKyw.default)(),
                body: "",
                reversed: false,
                choice: null
            });
        }
        function onShow(event) {
            lastItemExpanded = event.target;
        }
        function afterShow() {
            if (!lastItemExpanded) return;
            lastItemExpanded.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
        const __returned__ = {
            surveyStore: surveyStore,
            currentPage: currentPage,
            get lastItemExpanded () {
                return lastItemExpanded;
            },
            set lastItemExpanded (v){
                lastItemExpanded = v;
            },
            addQuestionToTable: addQuestionToTable,
            onShow: onShow,
            afterShow: afterShow,
            get draggable () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($cHm2O));
            },
            get duplicateQuestion () {
                return 0, $8htdk.duplicateQuestion;
            },
            get removeAnswer () {
                return 0, $8htdk.removeAnswer;
            },
            get addAnswer () {
                return 0, $8htdk.addAnswer;
            },
            get removeQuestion () {
                return 0, $8htdk.removeQuestion;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRequire.register("1IZJt", function(module, exports) {

$parcel$export(module.exports, "render", () => $1419c945ee052b97$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $1419c945ee052b97$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_item_label = (0, $TusQn.resolveComponent)("q-item-label");
    const _component_q_btn = (0, $TusQn.resolveComponent)("q-btn");
    const _component_q_card_actions = (0, $TusQn.resolveComponent)("q-card-actions");
    const _component_q_input = (0, $TusQn.resolveComponent)("q-input");
    const _component_q_card_section = (0, $TusQn.resolveComponent)("q-card-section");
    const _component_q_card = (0, $TusQn.resolveComponent)("q-card");
    const _component_q_expansion_item = (0, $TusQn.resolveComponent)("q-expansion-item");
    const _component_q_item = (0, $TusQn.resolveComponent)("q-item");
    const _component_q_separator = (0, $TusQn.resolveComponent)("q-separator");
    const _component_q_checkbox = (0, $TusQn.resolveComponent)("q-checkbox");
    const _component_q_list = (0, $TusQn.resolveComponent)("q-list");
    return $setup.currentPage && $setup.currentPage.type === "table" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_list, {
        key: 0,
        bordered: ""
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_q_item_label, {
                    header: ""
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)("R\xe9ponses possibles")
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)($setup["draggable"], {
                    modelValue: $setup.currentPage.data.answers,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.currentPage.data.answers = $event),
                    handle: ".answer.q-expansion-item .q-item",
                    "item-key": "internalID"
                }, {
                    item: (0, $TusQn.withCtx)(({ element: answer, index: index })=>[
                            (0, $TusQn.createVNode)(_component_q_expansion_item, {
                                group: "table-answers",
                                "expand-separator": "",
                                icon: "fact_check",
                                class: "answer",
                                label: answer.body,
                                caption: answer.code,
                                onShow: _cache[0] || (_cache[0] = ($event)=>$setup.onShow($event)),
                                onAfterShow: _cache[1] || (_cache[1] = ($event)=>$setup.afterShow())
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_q_card, null, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_q_card_actions, {
                                                        align: "right"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_btn, {
                                                                    onClick: ($event)=>$setup.removeAnswer($setup.currentPage.data, index),
                                                                    icon: "remove",
                                                                    label: "Supprimer la r\xe9ponse",
                                                                    color: "negative",
                                                                    outline: ""
                                                                }, null, 8, [
                                                                    "onClick"
                                                                ])
                                                            ]),
                                                        _: 2
                                                    }, 1024),
                                                    (0, $TusQn.createVNode)(_component_q_card_section, null, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_input, {
                                                                    modelValue: answer.body,
                                                                    "onUpdate:modelValue": ($event)=>answer.body = $event,
                                                                    label: "R\xe9ponse \xe0 afficher"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_input, {
                                                                    modelValue: answer.code,
                                                                    "onUpdate:modelValue": ($event)=>answer.code = $event,
                                                                    label: "Code interne"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ])
                                                            ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                _: 2
                            }, 1032, [
                                "label",
                                "caption"
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "modelValue"
                ]),
                (0, $TusQn.createVNode)(_component_q_item, null, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_q_btn, {
                                onClick: _cache[3] || (_cache[3] = ($event)=>$setup.addAnswer($setup.currentPage.data)),
                                icon: "add",
                                label: "R\xe9ponse",
                                outline: ""
                            })
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)(_component_q_separator),
                (0, $TusQn.createVNode)(_component_q_item_label, {
                    header: ""
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)("Questions")
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)($setup["draggable"], {
                    modelValue: $setup.currentPage.data.questions,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.currentPage.data.questions = $event),
                    handle: ".question.q-expansion-item .q-item",
                    "item-key": "internalID"
                }, {
                    item: (0, $TusQn.withCtx)(({ element: question, index: qIndex })=>[
                            (0, $TusQn.createVNode)(_component_q_expansion_item, {
                                "expand-separator": "",
                                class: "question",
                                icon: "question_mark",
                                label: question.body,
                                caption: question.id,
                                group: "questions",
                                onShow: _cache[4] || (_cache[4] = ($event)=>$setup.onShow($event)),
                                onAfterShow: _cache[5] || (_cache[5] = ($event)=>$setup.afterShow())
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_q_card, null, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_q_card_actions, {
                                                        align: "right"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_btn, {
                                                                    onClick: ($event)=>$setup.removeQuestion($setup.currentPage, qIndex),
                                                                    icon: "remove",
                                                                    label: "Supprimer la question",
                                                                    color: "negative",
                                                                    outline: ""
                                                                }, null, 8, [
                                                                    "onClick"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_btn, {
                                                                    onClick: ($event)=>$setup.duplicateQuestion($setup.currentPage, qIndex),
                                                                    icon: "content_copy",
                                                                    label: "dupliquer la question",
                                                                    color: "primary",
                                                                    outline: ""
                                                                }, null, 8, [
                                                                    "onClick"
                                                                ])
                                                            ]),
                                                        _: 2
                                                    }, 1024),
                                                    (0, $TusQn.createVNode)(_component_q_card_section, null, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createVNode)(_component_q_input, {
                                                                    modelValue: question.id,
                                                                    "onUpdate:modelValue": ($event)=>question.id = $event,
                                                                    label: "Identifiant de la question"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_input, {
                                                                    modelValue: question.body,
                                                                    "onUpdate:modelValue": ($event)=>question.body = $event,
                                                                    label: "Question \xe0 afficher"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ]),
                                                                (0, $TusQn.createVNode)(_component_q_checkbox, {
                                                                    modelValue: question.reversed,
                                                                    "onUpdate:modelValue": ($event)=>question.reversed = $event,
                                                                    label: "Invers\xe9 le score"
                                                                }, null, 8, [
                                                                    "modelValue",
                                                                    "onUpdate:modelValue"
                                                                ])
                                                            ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                _: 2
                            }, 1032, [
                                "label",
                                "caption"
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "modelValue"
                ]),
                (0, $TusQn.createVNode)(_component_q_item, null, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_q_btn, {
                                onClick: _cache[7] || (_cache[7] = ($event)=>$setup.addQuestionToTable()),
                                color: "primary",
                                icon: "add",
                                label: "Question",
                                size: "l",
                                outline: ""
                            })
                        ]),
                    _: 1
                })
            ]),
        _: 1
    })) : (0, $TusQn.createCommentVNode)("", true);
}

});

parcelRequire.register("fqRgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c29966c5455d4d$export$2e2bcd8739ae039);
let $b3c29966c5455d4d$var$NOOP = ()=>{};
var $b3c29966c5455d4d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("b7twF", function(module, exports) {

$parcel$export(module.exports, "render", () => $818740602bdd9e23$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $818740602bdd9e23$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
    class: "text-h6 q-pa-none q-ma-none"
}, "Modifier un questionnaire", -1);
const $818740602bdd9e23$var$_hoisted_2 = {
    class: "q-pa-sm"
};
const $818740602bdd9e23$var$_hoisted_3 = [
    "onClick",
    "title"
];
const $818740602bdd9e23$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "text-h6"
}, "Nouvelle page", -1);
function $818740602bdd9e23$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = (0, $TusQn.resolveComponent)("q-btn");
    const _component_q_input = (0, $TusQn.resolveComponent)("q-input");
    const _component_q_checkbox = (0, $TusQn.resolveComponent)("q-checkbox");
    const _component_q_item = (0, $TusQn.resolveComponent)("q-item");
    const _component_q_editor = (0, $TusQn.resolveComponent)("q-editor");
    const _component_q_list = (0, $TusQn.resolveComponent)("q-list");
    const _component_q_card_section = (0, $TusQn.resolveComponent)("q-card-section");
    const _component_q_card = (0, $TusQn.resolveComponent)("q-card");
    const _component_q_option_group = (0, $TusQn.resolveComponent)("q-option-group");
    const _component_q_card_actions = (0, $TusQn.resolveComponent)("q-card-actions");
    const _component_q_dialog = (0, $TusQn.resolveComponent)("q-dialog");
    const _directive_close_popup = (0, $TusQn.resolveDirective)("close-popup");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", {
            class: (0, $8POXm.normalizeClass)([
                _ctx.$style.floatingToolbar,
                "q-pa-sm q-ma-none row justify-between items-center content-start"
            ])
        }, [
            $818740602bdd9e23$var$_hoisted_1,
            (0, $TusQn.createVNode)(_component_q_btn, {
                onClick: _cache[0] || (_cache[0] = ($event)=>$setup.save()),
                color: "primary",
                icon: "save",
                label: "Sauvegarder",
                outline: "",
                size: ""
            })
        ], 2),
        $setup.survey ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8POXm.normalizeClass)(_ctx.$style.editor)
        }, [
            (0, $TusQn.createElementVNode)("div", $818740602bdd9e23$var$_hoisted_2, [
                (0, $TusQn.createVNode)(_component_q_input, {
                    modelValue: $setup.survey.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.survey.title = $event),
                    label: "Titre du questionnaire",
                    autofocus: ""
                }, null, 8, [
                    "modelValue"
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("div", {
                    class: (0, $8POXm.normalizeClass)(_ctx.$style.actions)
                }, [
                    (0, $TusQn.createVNode)(_component_q_checkbox, {
                        modelValue: $setup.pagesColumnMode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.pagesColumnMode = $event),
                        label: "Afficher les pages comme liste"
                    }, null, 8, [
                        "modelValue"
                    ]),
                    (0, $TusQn.createVNode)(_component_q_btn, {
                        onClick: _cache[3] || (_cache[3] = ($event)=>$setup.showAddPageDialog = true),
                        color: "primary",
                        icon: "add",
                        label: "Ajouter une page",
                        size: "l",
                        outline: ""
                    })
                ], 2),
                $setup.survey.pages.length === 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AppInfoMessage"], {
                    key: 0,
                    class: (0, $8POXm.normalizeClass)(_ctx.$style.empty),
                    message: "Aucune page \xe0 afficher"
                }, null, 8, [
                    "class"
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createVNode)($setup["draggable"], {
                modelValue: $setup.survey.pages,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.survey.pages = $event),
                class: (0, $8POXm.normalizeClass)({
                    [_ctx.$style.pages]: true,
                    [_ctx.$style.pagesColumn]: $setup.pagesColumnMode
                }),
                onChange: _cache[5] || (_cache[5] = ($event)=>$setup.selectPageByIndex($setup.currentPageIndex)),
                "item-key": "id"
            }, {
                item: (0, $TusQn.withCtx)(({ element: page, index: pageIndex })=>[
                        (0, $TusQn.createElementVNode)("div", {
                            class: (0, $8POXm.normalizeClass)({
                                [_ctx.$style.page]: true,
                                [_ctx.$style.selected]: $setup.currentPageIndex === pageIndex
                            }),
                            onClick: ($event)=>$setup.selectPageByIndex(pageIndex),
                            title: page.title
                        }, (0, $8POXm.toDisplayString)(page.title), 11, $818740602bdd9e23$var$_hoisted_3)
                    ]),
                _: 1
            }, 8, [
                "modelValue",
                "class"
            ]),
            $setup.currentPage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_q_list, {
                key: 0,
                bordered: ""
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_q_item, {
                            class: (0, $8POXm.normalizeClass)(_ctx.$style.pageActions)
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_q_btn, {
                                        onClick: _cache[6] || (_cache[6] = ($event)=>$setup.removePage($setup.currentPageIndex)),
                                        icon: "remove",
                                        label: "Supprimer la page",
                                        color: "negative",
                                        size: "l",
                                        outline: ""
                                    })
                                ]),
                            _: 1
                        }, 8, [
                            "class"
                        ]),
                        (0, $TusQn.createVNode)(_component_q_item, null, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_q_input, {
                                        modelValue: $setup.currentPage.title,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.currentPage.title = $event),
                                        label: "Titre de la page",
                                        class: (0, $8POXm.normalizeClass)(_ctx.$style.pageTitle),
                                        style: {
                                            width: "100%"
                                        }
                                    }, null, 8, [
                                        "modelValue",
                                        "class"
                                    ])
                                ]),
                            _: 1
                        }),
                        (0, $TusQn.createVNode)(_component_q_item, null, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_q_editor, {
                                        modelValue: $setup.currentPage.description,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.currentPage.description = $event),
                                        "min-height": "5rem"
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ]),
                            _: 1
                        })
                    ]),
                _: 1
            })) : (0, $TusQn.createCommentVNode)("", true),
            $setup.currentPage && $setup.currentPage.type === "questions" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AppQuestionsPageEditor"], {
                key: 1,
                page: $setup.currentPage?.id
            }, null, 8, [
                "page"
            ])) : (0, $TusQn.createCommentVNode)("", true),
            $setup.currentPage && $setup.currentPage.type === "table" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["AppTablePageEditor"], {
                key: 2,
                page: $setup.currentPage?.id
            }, null, 8, [
                "page"
            ])) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createVNode)(_component_q_card, {
                flat: ""
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_q_card_section, null, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_q_btn, {
                                        onClick: _cache[9] || (_cache[9] = ($event)=>$setup.save()),
                                        color: "primary",
                                        icon: "save",
                                        label: "Sauvegarder",
                                        outline: ""
                                    })
                                ]),
                            _: 1
                        })
                    ]),
                _: 1
            }),
            (0, $TusQn.createVNode)(_component_q_dialog, {
                modelValue: $setup.showAddPageDialog,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.showAddPageDialog = $event)
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_q_card, null, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createVNode)(_component_q_card_section, null, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                $818740602bdd9e23$var$_hoisted_4
                                            ]),
                                        _: 1
                                    }),
                                    (0, $TusQn.createVNode)(_component_q_card_section, {
                                        class: "q-pt-none"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createVNode)(_component_q_input, {
                                                    modelValue: $setup.newPageTitle,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.newPageTitle = $event),
                                                    label: "Titre de la nouvelle page",
                                                    autofocus: ""
                                                }, null, 8, [
                                                    "modelValue"
                                                ]),
                                                (0, $TusQn.createTextVNode)(" Type de page \xe0 ajouter "),
                                                (0, $TusQn.createVNode)(_component_q_option_group, {
                                                    modelValue: $setup.newPageType,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.newPageType = $event),
                                                    options: $setup.newPageTypeOptions,
                                                    color: "primary"
                                                }, null, 8, [
                                                    "modelValue",
                                                    "options"
                                                ])
                                            ]),
                                        _: 1
                                    }),
                                    (0, $TusQn.createVNode)(_component_q_card_actions, {
                                        align: "right"
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(_component_q_btn, {
                                                    flat: "",
                                                    label: "OK",
                                                    color: "primary",
                                                    onClick: _cache[12] || (_cache[12] = ($event)=>$setup.addPage())
                                                }, null, 512), [
                                                    [
                                                        _directive_close_popup
                                                    ]
                                                ])
                                            ]),
                                        _: 1
                                    })
                                ]),
                            _: 1
                        })
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ])
        ], 2)) : (0, $TusQn.createCommentVNode)("", true)
    ], 64);
}

});

parcelRequire.register("1u0xq", function(module, exports) {

$parcel$export(module.exports, "default", () => $114902a303d282c2$export$2e2bcd8739ae039);
parcelRequire("b7twF");
let $114902a303d282c2$var$cssModules = {
    "$style": {
        "title_1": "_title_1_ykddu_2",
        "title_2": "_title_2_ykddu_6",
        "title_3": "_title_3_ykddu_10",
        "editor": "_editor_ykddu_14",
        "question": "_question_ykddu_19",
        "actions": "_actions_ykddu_28",
        "pages": "_pages_ykddu_35",
        "pagesColumn": "_pagesColumn_ykddu_42",
        "page": "_page_ykddu_35",
        "selected": "_selected_ykddu_66",
        "pageActions": "_pageActions_ykddu_72",
        "pageTitle": "_pageTitle_ykddu_77",
        "floatingToolbar": "_floatingToolbar_ykddu_90"
    }
};
var $114902a303d282c2$export$2e2bcd8739ae039 = $114902a303d282c2$var$cssModules;

});

parcelRequire.register("n5ZIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0456cc7967917f2f$export$2e2bcd8739ae039);
let $0456cc7967917f2f$var$NOOP = ()=>{};
var $0456cc7967917f2f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $i0TKe = parcelRequire("i0TKe");

var $khdnb = parcelRequire("khdnb");

var $73mM4 = parcelRequire("73mM4");


let $8a040672df33d1ed$var$script;



let $8a040672df33d1ed$var$initialize = ()=>{
    $8a040672df33d1ed$var$script = {};
    $8a040672df33d1ed$var$script.render = (parcelRequire("38qZG")).render;
    $8a040672df33d1ed$var$script.__cssModules = (parcelRequire("eQYUT")).default;
    (parcelRequire("6fKCF")).default($8a040672df33d1ed$var$script);
    $8a040672df33d1ed$var$script.__scopeId = "data-v-0c15e9";
    $8a040672df33d1ed$var$script.__file = "App.vue";
};
$8a040672df33d1ed$var$initialize();
var $8a040672df33d1ed$export$2e2bcd8739ae039 = $8a040672df33d1ed$var$script;


let $de0afdc4c4b0cf12$var$script;




let $de0afdc4c4b0cf12$var$initialize = ()=>{
    $de0afdc4c4b0cf12$var$script = (parcelRequire("3gDlC"));
    if ($de0afdc4c4b0cf12$var$script.__esModule) $de0afdc4c4b0cf12$var$script = $de0afdc4c4b0cf12$var$script.default;
    $de0afdc4c4b0cf12$var$script.render = (parcelRequire("4h9pT")).render;
    $de0afdc4c4b0cf12$var$script.__cssModules = (parcelRequire("9VsqV")).default;
    (parcelRequire("2lP7M")).default($de0afdc4c4b0cf12$var$script);
    $de0afdc4c4b0cf12$var$script.__scopeId = "data-v-627459";
    $de0afdc4c4b0cf12$var$script.__file = "SurveyPage.vue";
};
$de0afdc4c4b0cf12$var$initialize();
var $de0afdc4c4b0cf12$export$2e2bcd8739ae039 = $de0afdc4c4b0cf12$var$script;


let $19d893bf53c02068$var$script;




let $19d893bf53c02068$var$initialize = ()=>{
    $19d893bf53c02068$var$script = (parcelRequire("eehUc"));
    if ($19d893bf53c02068$var$script.__esModule) $19d893bf53c02068$var$script = $19d893bf53c02068$var$script.default;
    $19d893bf53c02068$var$script.render = (parcelRequire("9ozJ9")).render;
    $19d893bf53c02068$var$script.__cssModules = (parcelRequire("3xyB7")).default;
    (parcelRequire("9exEj")).default($19d893bf53c02068$var$script);
    $19d893bf53c02068$var$script.__scopeId = "data-v-4280d8";
    $19d893bf53c02068$var$script.__file = "AdminPage.vue";
};
$19d893bf53c02068$var$initialize();
var $19d893bf53c02068$export$2e2bcd8739ae039 = $19d893bf53c02068$var$script;


let $1cc2450c42c60cc3$var$script;




let $1cc2450c42c60cc3$var$initialize = ()=>{
    $1cc2450c42c60cc3$var$script = (parcelRequire("j8u7V"));
    if ($1cc2450c42c60cc3$var$script.__esModule) $1cc2450c42c60cc3$var$script = $1cc2450c42c60cc3$var$script.default;
    $1cc2450c42c60cc3$var$script.render = (parcelRequire("b7twF")).render;
    $1cc2450c42c60cc3$var$script.__cssModules = (parcelRequire("1u0xq")).default;
    (parcelRequire("n5ZIE")).default($1cc2450c42c60cc3$var$script);
    $1cc2450c42c60cc3$var$script.__scopeId = "data-v-f0b503";
    $1cc2450c42c60cc3$var$script.__file = "CreateSurveyPage.vue";
};
$1cc2450c42c60cc3$var$initialize();
var $1cc2450c42c60cc3$export$2e2bcd8739ae039 = $1cc2450c42c60cc3$var$script;


const $de9db17bbab00a4e$var$routes = [
    {
        name: "survey",
        path: "/",
        component: (0, $de0afdc4c4b0cf12$export$2e2bcd8739ae039)
    },
    {
        name: "admin",
        path: "/admin",
        component: (0, $19d893bf53c02068$export$2e2bcd8739ae039)
    },
    {
        name: "edit",
        path: "/edit",
        component: (0, $1cc2450c42c60cc3$export$2e2bcd8739ae039)
    }
];
const $de9db17bbab00a4e$var$router = (0, $73mM4.createRouter)({
    history: (0, $73mM4.createWebHashHistory)(),
    routes: $de9db17bbab00a4e$var$routes
});
const $de9db17bbab00a4e$var$pinia = (0, $i0TKe.createPinia)();
const $de9db17bbab00a4e$var$app = (0, $eeJ70.createApp)((0, $8a040672df33d1ed$export$2e2bcd8739ae039));
$de9db17bbab00a4e$var$app.use($de9db17bbab00a4e$var$pinia);
$de9db17bbab00a4e$var$app.use($de9db17bbab00a4e$var$router);
$de9db17bbab00a4e$var$app.use((0, $khdnb.Quasar), {
    plugins: {
        Notify: $khdnb.Notify,
        Loading: $khdnb.Loading,
        Dialog: $khdnb.Dialog
    }
});
$de9db17bbab00a4e$var$app.mount("#q-app");


//# sourceMappingURL=index.6ec1736f.js.map
